export const defaultStyleDx = () => `
.dx-validationsummary-item {
  cursor: pointer;
}
.dx-invalid-message.dx-overlay {
  position: relative;
}
.dx-invalid-message.dx-overlay-wrapper {
  width: 100%;
  visibility: hidden;
  pointer-events: none;
}
.dx-invalid-message > .dx-overlay-content {
  display: inline-block;
  border-width: 0;
  padding: 10px;
  font-size: .85em;
  line-height: normal;
  word-wrap: break-word;
}
.dx-dropdownbox.dx-dropdowneditor-active .dx-invalid-message-auto,
.dx-invalid-message-visible.dx-invalid .dx-invalid-message-auto,
.dx-invalid-message.dx-invalid-message-always,
.dx-lookup.dx-dropdowneditor-active .dx-invalid-message-auto,
.dx-state-focused.dx-invalid .dx-invalid-message-auto {
  visibility: visible;
}
.dx-validationsummary-item-content {
  border-bottom: 1px dashed;
  display: inline-block;
  line-height: normal;
}
@-webkit-keyframes dx-valid-badge-frames {
  from {
    opacity: 0;
    -webkit-transform: scale(.1);
    transform: scale(.1);
  }
  to {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@keyframes dx-valid-badge-frames {
  from {
    opacity: 0;
    -webkit-transform: scale(.1);
    transform: scale(.1);
  }
  to {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

.dx-theme-material-typography {
  background-color: #fff;
  color: rgba(0,0,0,.87);
  font-weight: 400;
  font-size: 14px;
  font-family: Roboto,RobotoFallback,"Noto Kufi Arabic",Helvetica,Arial,sans-serif;
  line-height: 1.2857;
}
.dx-theme-material-typography input,
.dx-theme-material-typography textarea {
  font-family: Roboto,RobotoFallback,"Noto Kufi Arabic",Helvetica,Arial,sans-serif;
  line-height: 1.2857;
}
.dx-theme-material-typography h1 {
  font-weight: 300;
  font-size: 96px;
  letter-spacing: -1.5px;
}
.dx-theme-material-typography h2 {
  font-weight: 300;
  font-size: 60px;
  letter-spacing: -.5px;
}
.dx-theme-material-typography h3 {
  font-weight: 400;
  font-size: 48px;
}
.dx-theme-material-typography h4 {
  font-weight: 400;
  font-size: 34px;
  letter-spacing: .25px;
}
.dx-theme-material-typography h5 {
  font-weight: 400;
  font-size: 24px;
}
.dx-theme-material-typography h6 {
  font-weight: 500;
  font-size: 20px;
  letter-spacing: .15px;
}
.dx-theme-material-typography .dx-font-xl {
  font-size: 34px;
}
.dx-theme-material-typography .dx-font-l {
  font-size: 28px;
}
.dx-theme-material-typography .dx-font-m {
  font-size: 20px;
}
.dx-theme-material-typography .dx-font-s {
  font-size: 18px;
}
.dx-theme-material-typography .dx-font-xs,
.dx-theme-material-typography small {
  font-size: 12px;
}
.dx-theme-material-typography a {
  color: #009688;
}
.dx-icon-add,
.dx-icon-addcolumnleft,
.dx-icon-addcolumnright,
.dx-icon-addrowabove,
.dx-icon-addrowbelow,
.dx-icon-addtable,
.dx-icon-airplane,
.dx-icon-aligncenter,
.dx-icon-alignjustify,
.dx-icon-alignleft,
.dx-icon-alignright,
.dx-icon-arrowdown,
.dx-icon-arrowleft,
.dx-icon-arrowright,
.dx-icon-arrowup,
.dx-icon-background,
.dx-icon-bell,
.dx-icon-blockquote,
.dx-icon-bold,
.dx-icon-bookmark,
.dx-icon-box,
.dx-icon-bulletlist,
.dx-icon-car,
.dx-icon-card,
.dx-icon-cart,
.dx-icon-cellproperties,
.dx-icon-chart,
.dx-icon-checklist,
.dx-icon-clear,
.dx-icon-clearformat,
.dx-icon-clock,
.dx-icon-close,
.dx-icon-codeblock,
.dx-icon-color,
.dx-icon-columnproperties,
.dx-icon-comment,
.dx-icon-decreaseindent,
.dx-icon-doc,
.dx-icon-download,
.dx-icon-edit,
.dx-icon-email,
.dx-icon-event,
.dx-icon-eventall,
.dx-icon-favorites,
.dx-icon-find,
.dx-icon-folder,
.dx-icon-fontsize,
.dx-icon-food,
.dx-icon-formula,
.dx-icon-gift,
.dx-icon-globe,
.dx-icon-group,
.dx-icon-growfont,
.dx-icon-header,
.dx-icon-help,
.dx-icon-home,
.dx-icon-image,
.dx-icon-increaseindent,
.dx-icon-indent,
.dx-icon-info,
.dx-icon-italic,
.dx-icon-key,
.dx-icon-like,
.dx-icon-link,
.dx-icon-map,
.dx-icon-mention,
.dx-icon-menu,
.dx-icon-mergecells,
.dx-icon-money,
.dx-icon-music,
.dx-icon-orderedlist,
.dx-icon-overflow,
.dx-icon-percent,
.dx-icon-photo,
.dx-icon-plus,
.dx-icon-preferences,
.dx-icon-product,
.dx-icon-redo,
.dx-icon-refresh,
.dx-icon-remove,
.dx-icon-removecolumn,
.dx-icon-removerow,
.dx-icon-removetable,
.dx-icon-rowproperties,
.dx-icon-runner,
.dx-icon-save,
.dx-icon-search,
.dx-icon-shrinkfont,
.dx-icon-splitcells,
.dx-icon-strike,
.dx-icon-subscript,
.dx-icon-superscript,
.dx-icon-tableproperties,
.dx-icon-tags,
.dx-icon-tel,
.dx-icon-tips,
.dx-icon-to,
.dx-icon-todo,
.dx-icon-toolbox,
.dx-icon-underline,
.dx-icon-undo,
.dx-icon-user,
.dx-icon-variable,
.dx-icon-verticalalignbottom,
.dx-icon-verticalaligncenter,
.dx-icon-verticalaligntop,
.dx-icon-video {
  background-position: 0 0;
  background-repeat: no-repeat;
}
.dx-icon {
  background-position: 50% 50%;
  display: inline-block;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.dx-svg-icon svg {
  pointer-events: none;
}
.dx-rtl .dx-icon-spinnext::before {
  content: "\\f04f";
}
.dx-rtl .dx-icon-spinprev::before {
  content: "\\f04e";
}
.dx-rtl .dx-icon-chevronnext::before {
  content: "\\f012";
}
.dx-rtl .dx-icon-back::before,
.dx-rtl .dx-icon-chevronprev::before {
  content: "\\f010";
}
.dx-rtl .dx-icon-undo::before {
  content: "\\f093";
}
.dx-rtl .dx-icon-redo::before {
  content: "\\f04c";
}
.dx-rtl .dx-icon-hidepanel::before {
  content: "\\f11d";
}
.dx-rtl .dx-icon-showpanel::before {
  content: "\\f11c";
}
.dx-icon-add {
  font: 14px/1 DXIcons;
}
.dx-icon-add::before {
  content: "\\f00b";
}
.dx-icon-airplane {
  font: 14px/1 DXIcons;
}
.dx-icon-airplane::before {
  content: "\\f000";
}
.dx-icon-bookmark {
  font: 14px/1 DXIcons;
}
.dx-icon-bookmark::before {
  content: "\\f017";
}
.dx-icon-box {
  font: 14px/1 DXIcons;
}
.dx-icon-box::before {
  content: "\\f018";
}
.dx-icon-car {
  font: 14px/1 DXIcons;
}
.dx-icon-car::before {
  content: "\\f01b";
}
.dx-icon-card {
  font: 14px/1 DXIcons;
}
.dx-icon-card::before {
  content: "\\f019";
}
.dx-icon-cart {
  font: 14px/1 DXIcons;
}
.dx-icon-cart::before {
  content: "\\f01a";
}
.dx-icon-chart {
  font: 14px/1 DXIcons;
}
.dx-icon-chart::before {
  content: "\\f01c";
}
.dx-icon-check {
  font: 14px/1 DXIcons;
}
.dx-icon-check::before {
  content: "\\f005";
}
.dx-icon-clear {
  font: 14px/1 DXIcons;
}
.dx-icon-clear::before {
  content: "\\f008";
}
.dx-icon-clock {
  font: 14px/1 DXIcons;
}
.dx-icon-clock::before {
  content: "\\f01d";
}
.dx-icon-close {
  font: 14px/1 DXIcons;
}
.dx-icon-close::before {
  content: "\\f00a";
}
.dx-icon-coffee {
  font: 14px/1 DXIcons;
}
.dx-icon-coffee::before {
  content: "\\f02a";
}
.dx-icon-comment {
  font: 14px/1 DXIcons;
}
.dx-icon-comment::before {
  content: "\\f01e";
}
.dx-icon-doc {
  font: 14px/1 DXIcons;
}
.dx-icon-doc::before {
  content: "\\f021";
}
.dx-icon-file {
  font: 14px/1 DXIcons;
}
.dx-icon-file::before {
  content: "\\f021";
}
.dx-icon-download {
  font: 14px/1 DXIcons;
}
.dx-icon-download::before {
  content: "\\f022";
}
.dx-icon-dragvertical {
  font: 14px/1 DXIcons;
}
.dx-icon-dragvertical::before {
  content: "\\f038";
}
.dx-icon-edit {
  font: 14px/1 DXIcons;
}
.dx-icon-edit::before {
  content: "\\f023";
}
.dx-icon-email {
  font: 14px/1 DXIcons;
}
.dx-icon-email::before {
  content: "\\f024";
}
.dx-icon-event {
  font: 14px/1 DXIcons;
}
.dx-icon-event::before {
  content: "\\f026";
}
.dx-icon-eventall {
  font: 14px/1 DXIcons;
}
.dx-icon-eventall::before {
  content: "\\f043";
}
.dx-icon-favorites {
  font: 14px/1 DXIcons;
}
.dx-icon-favorites::before {
  content: "\\f025";
}
.dx-icon-find {
  font: 14px/1 DXIcons;
}
.dx-icon-find::before {
  content: "\\f027";
}
.dx-icon-filter {
  font: 14px/1 DXIcons;
}
.dx-icon-filter::before {
  content: "\\f050";
}
.dx-icon-folder {
  font: 14px/1 DXIcons;
}
.dx-icon-folder::before {
  content: "\\f028";
}
.dx-icon-activefolder {
  font: 14px/1 DXIcons;
}
.dx-icon-activefolder::before {
  content: "\\f028";
}
.dx-icon-food {
  font: 14px/1 DXIcons;
}
.dx-icon-food::before {
  content: "\\f029";
}
.dx-icon-gift {
  font: 14px/1 DXIcons;
}
.dx-icon-gift::before {
  content: "\\f02b";
}
.dx-icon-globe {
  font: 14px/1 DXIcons;
}
.dx-icon-globe::before {
  content: "\\f02c";
}
.dx-icon-group {
  font: 14px/1 DXIcons;
}
.dx-icon-group::before {
  content: "\\f02e";
}
.dx-icon-help {
  font: 14px/1 DXIcons;
}
.dx-icon-help::before {
  content: "\\f02f";
}
.dx-icon-home {
  font: 14px/1 DXIcons;
}
.dx-icon-home::before {
  content: "\\f030";
}
.dx-icon-image {
  font: 14px/1 DXIcons;
}
.dx-icon-image::before {
  content: "\\f031";
}
.dx-icon-info {
  font: 14px/1 DXIcons;
}
.dx-icon-info::before {
  content: "\\f032";
}
.dx-icon-key {
  font: 14px/1 DXIcons;
}
.dx-icon-key::before {
  content: "\\f033";
}
.dx-icon-like {
  font: 14px/1 DXIcons;
}
.dx-icon-like::before {
  content: "\\f034";
}
.dx-icon-map {
  font: 14px/1 DXIcons;
}
.dx-icon-map::before {
  content: "\\f035";
}
.dx-icon-menu {
  font: 14px/1 DXIcons;
}
.dx-icon-menu::before {
  content: "\\f00c";
}
.dx-icon-message {
  font: 14px/1 DXIcons;
}
.dx-icon-message::before {
  content: "\\f024";
}
.dx-icon-money {
  font: 14px/1 DXIcons;
}
.dx-icon-money::before {
  content: "\\f036";
}
.dx-icon-music {
  font: 14px/1 DXIcons;
}
.dx-icon-music::before {
  content: "\\f037";
}
.dx-icon-overflow {
  font: 14px/1 DXIcons;
}
.dx-icon-overflow::before {
  content: "\\f00d";
}
.dx-icon-percent {
  font: 14px/1 DXIcons;
}
.dx-icon-percent::before {
  content: "\\f039";
}
.dx-icon-photo {
  font: 14px/1 DXIcons;
}
.dx-icon-photo::before {
  content: "\\f03a";
}
.dx-icon-plus {
  font: 14px/1 DXIcons;
}
.dx-icon-plus::before {
  content: "\\f00b";
}
.dx-icon-minus {
  font: 14px/1 DXIcons;
}
.dx-icon-minus::before {
  content: "\\f074";
}
.dx-icon-preferences {
  font: 14px/1 DXIcons;
}
.dx-icon-preferences::before {
  content: "\\f03b";
}
.dx-icon-product {
  font: 14px/1 DXIcons;
}
.dx-icon-product::before {
  content: "\\f03c";
}
.dx-icon-pulldown {
  font: 14px/1 DXIcons;
}
.dx-icon-pulldown::before {
  content: "\\f062";
}
.dx-icon-refresh {
  font: 14px/1 DXIcons;
}
.dx-icon-refresh::before {
  content: "\\f03d";
}
.dx-icon-remove {
  font: 14px/1 DXIcons;
}
.dx-icon-remove::before {
  content: "\\f00a";
}
.dx-icon-revert {
  font: 14px/1 DXIcons;
}
.dx-icon-revert::before {
  content: "\\f04c";
}
.dx-icon-runner {
  font: 14px/1 DXIcons;
}
.dx-icon-runner::before {
  content: "\\f040";
}
.dx-icon-save {
  font: 14px/1 DXIcons;
}
.dx-icon-save::before {
  content: "\\f041";
}
.dx-icon-search {
  font: 14px/1 DXIcons;
}
.dx-icon-search::before {
  content: "\\f027";
}
.dx-icon-tags {
  font: 14px/1 DXIcons;
}
.dx-icon-tags::before {
  content: "\\f009";
}
.dx-icon-tel {
  font: 14px/1 DXIcons;
}
.dx-icon-tel::before {
  content: "\\f003";
}
.dx-icon-tips {
  font: 14px/1 DXIcons;
}
.dx-icon-tips::before {
  content: "\\f004";
}
.dx-icon-todo {
  font: 14px/1 DXIcons;
}
.dx-icon-todo::before {
  content: "\\f005";
}
.dx-icon-toolbox {
  font: 14px/1 DXIcons;
}
.dx-icon-toolbox::before {
  content: "\\f007";
}
.dx-icon-trash {
  font: 14px/1 DXIcons;
}
.dx-icon-trash::before {
  content: "\\f03e";
}
.dx-icon-user {
  font: 14px/1 DXIcons;
}
.dx-icon-user::before {
  content: "\\f02d";
}
.dx-icon-upload {
  font: 14px/1 DXIcons;
}
.dx-icon-upload::before {
  content: "\\f006";
}
.dx-icon-floppy {
  font: 14px/1 DXIcons;
}
.dx-icon-floppy::before {
  content: "\\f073";
}
.dx-icon-arrowleft {
  font: 14px/1 DXIcons;
}
.dx-icon-arrowleft::before {
  content: "\\f011";
}
.dx-icon-arrowdown {
  font: 14px/1 DXIcons;
}
.dx-icon-arrowdown::before {
  content: "\\f015";
}
.dx-icon-arrowright {
  font: 14px/1 DXIcons;
}
.dx-icon-arrowright::before {
  content: "\\f00e";
}
.dx-icon-arrowup {
  font: 14px/1 DXIcons;
}
.dx-icon-arrowup::before {
  content: "\\f013";
}
.dx-icon-spinleft {
  font: 14px/1 DXIcons;
}
.dx-icon-spinleft::before {
  content: "\\f04f";
}
.dx-icon-spinprev {
  font: 14px/1 DXIcons;
}
.dx-icon-spinprev::before {
  content: "\\f04f";
}
.dx-icon-spinright {
  font: 14px/1 DXIcons;
}
.dx-icon-spinright::before {
  content: "\\f04e";
}
.dx-icon-spinnext {
  font: 14px/1 DXIcons;
}
.dx-icon-spinnext::before {
  content: "\\f04e";
}
.dx-icon-spindown {
  font: 14px/1 DXIcons;
}
.dx-icon-spindown::before {
  content: "\\f001";
}
.dx-icon-spinup {
  font: 14px/1 DXIcons;
}
.dx-icon-spinup::before {
  content: "\\f002";
}
.dx-icon-chevronleft {
  font: 14px/1 DXIcons;
}
.dx-icon-chevronleft::before {
  content: "\\f012";
}
.dx-icon-chevronprev {
  font: 14px/1 DXIcons;
}
.dx-icon-chevronprev::before {
  content: "\\f012";
}
.dx-icon-back {
  font: 14px/1 DXIcons;
}
.dx-icon-back::before {
  content: "\\f012";
}
.dx-icon-chevronright {
  font: 14px/1 DXIcons;
}
.dx-icon-chevronright::before {
  content: "\\f010";
}
.dx-icon-chevronnext {
  font: 14px/1 DXIcons;
}
.dx-icon-chevronnext::before {
  content: "\\f010";
}
.dx-icon-chevrondown {
  font: 14px/1 DXIcons;
}
.dx-icon-chevrondown::before {
  content: "\\f016";
}
.dx-icon-chevronup {
  font: 14px/1 DXIcons;
}
.dx-icon-chevronup::before {
  content: "\\f014";
}
.dx-icon-chevrondoubleleft {
  font: 14px/1 DXIcons;
}
.dx-icon-chevrondoubleleft::before {
  content: "\\f042";
}
.dx-icon-chevrondoubleright {
  font: 14px/1 DXIcons;
}
.dx-icon-chevrondoubleright::before {
  content: "\\f03f";
}
.dx-icon-equal {
  font: 14px/1 DXIcons;
}
.dx-icon-equal::before {
  content: "\\f044";
}
.dx-icon-notequal {
  font: 14px/1 DXIcons;
}
.dx-icon-notequal::before {
  content: "\\f045";
}
.dx-icon-less {
  font: 14px/1 DXIcons;
}
.dx-icon-less::before {
  content: "\\f046";
}
.dx-icon-greater {
  font: 14px/1 DXIcons;
}
.dx-icon-greater::before {
  content: "\\f047";
}
.dx-icon-lessorequal {
  font: 14px/1 DXIcons;
}
.dx-icon-lessorequal::before {
  content: "\\f048";
}
.dx-icon-greaterorequal {
  font: 14px/1 DXIcons;
}
.dx-icon-greaterorequal::before {
  content: "\\f049";
}
.dx-icon-isblank {
  font: 14px/1 DXIcons;
}
.dx-icon-isblank::before {
  content: "\\f075";
}
.dx-icon-isnotblank {
  font: 14px/1 DXIcons;
}
.dx-icon-isnotblank::before {
  content: "\\f076";
}
.dx-icon-sortup {
  font: 14px/1 DXIcons;
}
.dx-icon-sortup::before {
  content: "\\f051";
}
.dx-icon-sortdown {
  font: 14px/1 DXIcons;
}
.dx-icon-sortdown::before {
  content: "\\f052";
}
.dx-icon-sortuptext {
  font: 14px/1 DXIcons;
}
.dx-icon-sortuptext::before {
  content: "\\f053";
}
.dx-icon-sortdowntext {
  font: 14px/1 DXIcons;
}
.dx-icon-sortdowntext::before {
  content: "\\f054";
}
.dx-icon-sorted {
  font: 14px/1 DXIcons;
}
.dx-icon-sorted::before {
  content: "\\f055";
}
.dx-icon-expand {
  font: 14px/1 DXIcons;
}
.dx-icon-expand::before {
  content: "\\f04a";
}
.dx-icon-collapse {
  font: 14px/1 DXIcons;
}
.dx-icon-collapse::before {
  content: "\\f04b";
}
.dx-icon-columnfield {
  font: 14px/1 DXIcons;
}
.dx-icon-columnfield::before {
  content: "\\f057";
}
.dx-icon-rowfield {
  font: 14px/1 DXIcons;
}
.dx-icon-rowfield::before {
  content: "\\f058";
}
.dx-icon-datafield {
  font: 14px/1 DXIcons;
}
.dx-icon-datafield::before {
  content: "\\f101";
}
.dx-icon-fields {
  font: 14px/1 DXIcons;
}
.dx-icon-fields::before {
  content: "\\f059";
}
.dx-icon-fieldchooser {
  font: 14px/1 DXIcons;
}
.dx-icon-fieldchooser::before {
  content: "\\f05a";
}
.dx-icon-columnchooser {
  font: 14px/1 DXIcons;
}
.dx-icon-columnchooser::before {
  content: "\\f04d";
}
.dx-icon-pin {
  font: 14px/1 DXIcons;
}
.dx-icon-pin::before {
  content: "\\f05b";
}
.dx-icon-unpin {
  font: 14px/1 DXIcons;
}
.dx-icon-unpin::before {
  content: "\\f05c";
}
.dx-icon-pinleft {
  font: 14px/1 DXIcons;
}
.dx-icon-pinleft::before {
  content: "\\f05d";
}
.dx-icon-pinright {
  font: 14px/1 DXIcons;
}
.dx-icon-pinright::before {
  content: "\\f05e";
}
.dx-icon-contains {
  font: 14px/1 DXIcons;
}
.dx-icon-contains::before {
  content: "\\f063";
}
.dx-icon-startswith {
  font: 14px/1 DXIcons;
}
.dx-icon-startswith::before {
  content: "\\f064";
}
.dx-icon-endswith {
  font: 14px/1 DXIcons;
}
.dx-icon-endswith::before {
  content: "\\f065";
}
.dx-icon-doesnotcontain {
  font: 14px/1 DXIcons;
}
.dx-icon-doesnotcontain::before {
  content: "\\f066";
}
.dx-icon-range {
  font: 14px/1 DXIcons;
}
.dx-icon-range::before {
  content: "\\f06a";
}
.dx-icon-export {
  font: 14px/1 DXIcons;
}
.dx-icon-export::before {
  content: "\\f05f";
}
.dx-icon-exportxlsx {
  font: 14px/1 DXIcons;
}
.dx-icon-exportxlsx::before {
  content: "\\f060";
}
.dx-icon-exportpdf {
  font: 14px/1 DXIcons;
}
.dx-icon-exportpdf::before {
  content: "\\f061";
}
.dx-icon-exportselected {
  font: 14px/1 DXIcons;
}
.dx-icon-exportselected::before {
  content: "\\f06d";
}
.dx-icon-warning {
  font: 14px/1 DXIcons;
}
.dx-icon-warning::before {
  content: "\\f06b";
}
.dx-icon-more {
  font: 14px/1 DXIcons;
}
.dx-icon-more::before {
  content: "\\f06c";
}
.dx-icon-square {
  font: 14px/1 DXIcons;
}
.dx-icon-square::before {
  content: "\\f067";
}
.dx-icon-clearsquare {
  font: 14px/1 DXIcons;
}
.dx-icon-clearsquare::before {
  content: "\\f068";
}
.dx-icon-repeat {
  font: 14px/1 DXIcons;
}
.dx-icon-repeat::before {
  content: "\\f069";
}
.dx-icon-selectall {
  font: 14px/1 DXIcons;
}
.dx-icon-selectall::before {
  content: "\\f070";
}
.dx-icon-unselectall {
  font: 14px/1 DXIcons;
}
.dx-icon-unselectall::before {
  content: "\\f071";
}
.dx-icon-print {
  font: 14px/1 DXIcons;
}
.dx-icon-print::before {
  content: "\\f072";
}
.dx-icon-bold {
  font: 14px/1 DXIcons;
}
.dx-icon-bold::before {
  content: "\\f077";
}
.dx-icon-italic {
  font: 14px/1 DXIcons;
}
.dx-icon-italic::before {
  content: "\\f078";
}
.dx-icon-underline {
  font: 14px/1 DXIcons;
}
.dx-icon-underline::before {
  content: "\\f079";
}
.dx-icon-strike {
  font: 14px/1 DXIcons;
}
.dx-icon-strike::before {
  content: "\\f07a";
}
.dx-icon-indent {
  font: 14px/1 DXIcons;
}
.dx-icon-indent::before {
  content: "\\f07b";
}
.dx-icon-increaselinespacing {
  font: 14px/1 DXIcons;
}
.dx-icon-increaselinespacing::before {
  content: "\\f07b";
}
.dx-icon-font {
  font: 14px/1 DXIcons;
}
.dx-icon-font::before {
  content: "\\f11b";
}
.dx-icon-fontsize {
  font: 14px/1 DXIcons;
}
.dx-icon-fontsize::before {
  content: "\\f07c";
}
.dx-icon-shrinkfont {
  font: 14px/1 DXIcons;
}
.dx-icon-shrinkfont::before {
  content: "\\f07d";
}
.dx-icon-growfont {
  font: 14px/1 DXIcons;
}
.dx-icon-growfont::before {
  content: "\\f07e";
}
.dx-icon-color {
  font: 14px/1 DXIcons;
}
.dx-icon-color::before {
  content: "\\f07f";
}
.dx-icon-background {
  font: 14px/1 DXIcons;
}
.dx-icon-background::before {
  content: "\\f080";
}
.dx-icon-fill {
  font: 14px/1 DXIcons;
}
.dx-icon-fill::before {
  content: "\\f10d";
}
.dx-icon-palette {
  font: 14px/1 DXIcons;
}
.dx-icon-palette::before {
  content: "\\f120";
}
.dx-icon-superscript {
  font: 14px/1 DXIcons;
}
.dx-icon-superscript::before {
  content: "\\f081";
}
.dx-icon-subscript {
  font: 14px/1 DXIcons;
}
.dx-icon-subscript::before {
  content: "\\f082";
}
.dx-icon-header {
  font: 14px/1 DXIcons;
}
.dx-icon-header::before {
  content: "\\f083";
}
.dx-icon-blockquote {
  font: 14px/1 DXIcons;
}
.dx-icon-blockquote::before {
  content: "\\f084";
}
.dx-icon-formula {
  font: 14px/1 DXIcons;
}
.dx-icon-formula::before {
  content: "\\f056";
}
.dx-icon-codeblock {
  font: 14px/1 DXIcons;
}
.dx-icon-codeblock::before {
  content: "\\f085";
}
.dx-icon-orderedlist {
  font: 14px/1 DXIcons;
}
.dx-icon-orderedlist::before {
  content: "\\f086";
}
.dx-icon-bulletlist {
  font: 14px/1 DXIcons;
}
.dx-icon-bulletlist::before {
  content: "\\f087";
}
.dx-icon-increaseindent {
  font: 14px/1 DXIcons;
}
.dx-icon-increaseindent::before {
  content: "\\f088";
}
.dx-icon-decreaseindent {
  font: 14px/1 DXIcons;
}
.dx-icon-decreaseindent::before {
  content: "\\f089";
}
.dx-icon-decreaselinespacing {
  font: 14px/1 DXIcons;
}
.dx-icon-decreaselinespacing::before {
  content: "\\f106";
}
.dx-icon-alignleft {
  font: 14px/1 DXIcons;
}
.dx-icon-alignleft::before {
  content: "\\f08a";
}
.dx-icon-alignright {
  font: 14px/1 DXIcons;
}
.dx-icon-alignright::before {
  content: "\\f08b";
}
.dx-icon-aligncenter {
  font: 14px/1 DXIcons;
}
.dx-icon-aligncenter::before {
  content: "\\f08c";
}
.dx-icon-alignjustify {
  font: 14px/1 DXIcons;
}
.dx-icon-alignjustify::before {
  content: "\\f08d";
}
.dx-icon-link {
  font: 14px/1 DXIcons;
}
.dx-icon-link::before {
  content: "\\f08e";
}
.dx-icon-video {
  font: 14px/1 DXIcons;
}
.dx-icon-video::before {
  content: "\\f08f";
}
.dx-icon-mention {
  font: 14px/1 DXIcons;
}
.dx-icon-mention::before {
  content: "\\f090";
}
.dx-icon-variable {
  font: 14px/1 DXIcons;
}
.dx-icon-variable::before {
  content: "\\f091";
}
.dx-icon-clearformat {
  font: 14px/1 DXIcons;
}
.dx-icon-clearformat::before {
  content: "\\f092";
}
.dx-icon-fullscreen {
  font: 14px/1 DXIcons;
}
.dx-icon-fullscreen::before {
  content: "\\f11a";
}
.dx-icon-hierarchy {
  font: 14px/1 DXIcons;
}
.dx-icon-hierarchy::before {
  content: "\\f124";
}
.dx-icon-docfile {
  font: 14px/1 DXIcons;
}
.dx-icon-docfile::before {
  content: "\\f111";
}
.dx-icon-docxfile {
  font: 14px/1 DXIcons;
}
.dx-icon-docxfile::before {
  content: "\\f110";
}
.dx-icon-pdffile {
  font: 14px/1 DXIcons;
}
.dx-icon-pdffile::before {
  content: "\\f118";
}
.dx-icon-pptfile {
  font: 14px/1 DXIcons;
}
.dx-icon-pptfile::before {
  content: "\\f114";
}
.dx-icon-pptxfile {
  font: 14px/1 DXIcons;
}
.dx-icon-pptxfile::before {
  content: "\\f115";
}
.dx-icon-rtffile {
  font: 14px/1 DXIcons;
}
.dx-icon-rtffile::before {
  content: "\\f112";
}
.dx-icon-txtfile {
  font: 14px/1 DXIcons;
}
.dx-icon-txtfile::before {
  content: "\\f113";
}
.dx-icon-xlsfile {
  font: 14px/1 DXIcons;
}
.dx-icon-xlsfile::before {
  content: "\\f116";
}
.dx-icon-xlsxfile {
  font: 14px/1 DXIcons;
}
.dx-icon-xlsxfile::before {
  content: "\\f117";
}
.dx-icon-copy {
  font: 14px/1 DXIcons;
}
.dx-icon-copy::before {
  content: "\\f107";
}
.dx-icon-cut {
  font: 14px/1 DXIcons;
}
.dx-icon-cut::before {
  content: "\\f10a";
}
.dx-icon-paste {
  font: 14px/1 DXIcons;
}
.dx-icon-paste::before {
  content: "\\f108";
}
.dx-icon-share {
  font: 14px/1 DXIcons;
}
.dx-icon-share::before {
  content: "\\f11f";
}
.dx-icon-inactivefolder {
  font: 14px/1 DXIcons;
}
.dx-icon-inactivefolder::before {
  content: "\\f105";
}
.dx-icon-newfolder {
  font: 14px/1 DXIcons;
}
.dx-icon-newfolder::before {
  content: "\\f123";
}
.dx-icon-movetofolder {
  font: 14px/1 DXIcons;
}
.dx-icon-movetofolder::before {
  content: "\\f121";
}
.dx-icon-parentfolder {
  font: 14px/1 DXIcons;
}
.dx-icon-parentfolder::before {
  content: "\\f122";
}
.dx-icon-rename {
  font: 14px/1 DXIcons;
}
.dx-icon-rename::before {
  content: "\\f109";
}
.dx-icon-detailslayout {
  font: 14px/1 DXIcons;
}
.dx-icon-detailslayout::before {
  content: "\\f10b";
}
.dx-icon-contentlayout {
  font: 14px/1 DXIcons;
}
.dx-icon-contentlayout::before {
  content: "\\f11e";
}
.dx-icon-smalliconslayout {
  font: 14px/1 DXIcons;
}
.dx-icon-smalliconslayout::before {
  content: "\\f119";
}
.dx-icon-mediumiconslayout {
  font: 14px/1 DXIcons;
}
.dx-icon-mediumiconslayout::before {
  content: "\\f10c";
}
.dx-icon-undo {
  font: 14px/1 DXIcons;
}
.dx-icon-undo::before {
  content: "\\f04c";
}
.dx-icon-redo {
  font: 14px/1 DXIcons;
}
.dx-icon-redo::before {
  content: "\\f093";
}
.dx-icon-hidepanel {
  font: 14px/1 DXIcons;
}
.dx-icon-hidepanel::before {
  content: "\\f11c";
}
.dx-icon-showpanel {
  font: 14px/1 DXIcons;
}
.dx-icon-showpanel::before {
  content: "\\f11d";
}
.dx-icon-checklist {
  font: 14px/1 DXIcons;
}
.dx-icon-checklist::before {
  content: "\\f141";
}
.dx-icon-verticalaligntop {
  font: 14px/1 DXIcons;
}
.dx-icon-verticalaligntop::before {
  content: "\\f14f";
}
.dx-icon-verticalaligncenter {
  font: 14px/1 DXIcons;
}
.dx-icon-verticalaligncenter::before {
  content: "\\f14e";
}
.dx-icon-verticalalignbottom {
  font: 14px/1 DXIcons;
}
.dx-icon-verticalalignbottom::before {
  content: "\\f14d";
}
.dx-icon-rowproperties {
  font: 14px/1 DXIcons;
}
.dx-icon-rowproperties::before {
  content: "\\f14c";
}
.dx-icon-columnproperties {
  font: 14px/1 DXIcons;
}
.dx-icon-columnproperties::before {
  content: "\\f14b";
}
.dx-icon-cellproperties {
  font: 14px/1 DXIcons;
}
.dx-icon-cellproperties::before {
  content: "\\f14a";
}
.dx-icon-tableproperties {
  font: 14px/1 DXIcons;
}
.dx-icon-tableproperties::before {
  content: "\\f140";
}
.dx-icon-splitcells {
  font: 14px/1 DXIcons;
}
.dx-icon-splitcells::before {
  content: "\\f139";
}
.dx-icon-mergecells {
  font: 14px/1 DXIcons;
}
.dx-icon-mergecells::before {
  content: "\\f138";
}
.dx-icon-deleterow {
  font: 14px/1 DXIcons;
}
.dx-icon-deleterow::before {
  content: "\\f137";
}
.dx-icon-deletecolumn {
  font: 14px/1 DXIcons;
}
.dx-icon-deletecolumn::before {
  content: "\\f136";
}
.dx-icon-insertrowabove {
  font: 14px/1 DXIcons;
}
.dx-icon-insertrowabove::before {
  content: "\\f135";
}
.dx-icon-insertrowbelow {
  font: 14px/1 DXIcons;
}
.dx-icon-insertrowbelow::before {
  content: "\\f134";
}
.dx-icon-insertcolumnleft {
  font: 14px/1 DXIcons;
}
.dx-icon-insertcolumnleft::before {
  content: "\\f133";
}
.dx-icon-insertcolumnright {
  font: 14px/1 DXIcons;
}
.dx-icon-insertcolumnright::before {
  content: "\\f132";
}
.dx-icon-inserttable {
  font: 14px/1 DXIcons;
}
.dx-icon-inserttable::before {
  content: "\\f130";
}
.dx-icon-deletetable {
  font: 14px/1 DXIcons;
}
.dx-icon-deletetable::before {
  content: "\\f131";
}
.dx-icon-edittableheader {
  font: 14px/1 DXIcons;
}
.dx-icon-edittableheader::before {
  content: "\\f142";
}
.dx-icon-addtableheader {
  font: 14px/1 DXIcons;
}
.dx-icon-addtableheader::before {
  content: "\\f143";
}
.dx-icon-pasteplaintext {
  font: 14px/1 DXIcons;
}
.dx-icon-pasteplaintext::before {
  content: "\\f144";
}
.dx-icon-importselected {
  font: 14px/1 DXIcons;
}
.dx-icon-importselected::before {
  content: "\\f145";
}
.dx-icon-import {
  font: 14px/1 DXIcons;
}
.dx-icon-import::before {
  content: "\\f146";
}
.dx-icon-textdocument {
  font: 14px/1 DXIcons;
}
.dx-icon-textdocument::before {
  content: "\\f147";
}
.dx-icon-jpgfile {
  font: 14px/1 DXIcons;
}
.dx-icon-jpgfile::before {
  content: "\\f148";
}
.dx-icon-bmpfile {
  font: 14px/1 DXIcons;
}
.dx-icon-bmpfile::before {
  content: "\\f149";
}
.dx-icon-svgfile {
  font: 14px/1 DXIcons;
}
.dx-icon-svgfile::before {
  content: "\\f150";
}
.dx-icon-attach {
  font: 14px/1 DXIcons;
}
.dx-icon-attach::before {
  content: "\\f151";
}
.dx-icon-return {
  font: 14px/1 DXIcons;
}
.dx-icon-return::before {
  content: "\\f152";
}
.dx-icon-indeterminatestate {
  font: 14px/1 DXIcons;
}
.dx-icon-indeterminatestate::before {
  content: "\\f153";
}
.dx-icon-lock {
  font: 14px/1 DXIcons;
}
.dx-icon-lock::before {
  content: "\\f154";
}
.dx-icon-unlock {
  font: 14px/1 DXIcons;
}
.dx-icon-unlock::before {
  content: "\\f155";
}
.dx-icon-imgarlock {
  font: 14px/1 DXIcons;
}
.dx-icon-imgarlock::before {
  content: "\\f156";
}
.dx-icon-imgarunlock {
  font: 14px/1 DXIcons;
}
.dx-icon-imgarunlock::before {
  content: "\\f157";
}
.dx-icon-bell {
  font: 14px/1 DXIcons;
}
.dx-icon-bell::before {
  content: "\\f158";
}
.dx-icon-sun {
  font: 14px/1 DXIcons;
}
.dx-icon-sun::before {
  content: "\\f159";
}
.dx-icon-send {
  font: 14px/1 DXIcons;
}
.dx-icon-send::before {
  content: "\\f160";
}
.dx-icon-pinmap {
  font: 14px/1 DXIcons;
}
.dx-icon-pinmap::before {
  content: "\\f161";
}
.dx-icon-photooutline {
  font: 14px/1 DXIcons;
}
.dx-icon-photooutline::before {
  content: "\\f162";
}
.dx-icon-panelright {
  font: 14px/1 DXIcons;
}
.dx-icon-panelright::before {
  content: "\\f163";
}
.dx-icon-panelleft {
  font: 14px/1 DXIcons;
}
.dx-icon-panelleft::before {
  content: "\\f164";
}
.dx-icon-optionsgear {
  font: 14px/1 DXIcons;
}
.dx-icon-optionsgear::before {
  content: "\\f165";
}
.dx-icon-moon {
  font: 14px/1 DXIcons;
}
.dx-icon-moon::before {
  content: "\\f166";
}
.dx-icon-login {
  font: 14px/1 DXIcons;
}
.dx-icon-login::before {
  content: "\\f167";
}
.dx-icon-eyeopen {
  font: 14px/1 DXIcons;
}
.dx-icon-eyeopen::before {
  content: "\\f168";
}
.dx-icon-eyeclose {
  font: 14px/1 DXIcons;
}
.dx-icon-eyeclose::before {
  content: "\\f169";
}
.dx-icon-expandform {
  font: 14px/1 DXIcons;
}
.dx-icon-expandform::before {
  content: "\\f170";
}
.dx-icon-description {
  font: 14px/1 DXIcons;
}
.dx-icon-description::before {
  content: "\\f171";
}
.dx-icon-belloutline {
  font: 14px/1 DXIcons;
}
.dx-icon-belloutline::before {
  content: "\\f172";
}
.dx-icon-to {
  font: 14px/1 DXIcons;
}
.dx-icon-to::before {
  content: "\\f173";
}
.dx-icon {
  font-size: 24px;
  line-height: 1;
  white-space: nowrap;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: "liga";
  font-feature-settings: "liga";
}
.dx-tab .dx-icon,
.dx-tab.dx-tab-selected .dx-icon {
  background-size: 100% 100%;
  background-position: 50% 50%;
}
.dx-scrollview-pulldown {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAABkCAQAAABebbrxAAABD0lEQVRo3u2XvQ3CMBCFLbmjYYGsAA2wA1X2gAbEAEwB2eIKflagh6zACJAuUihASUic+M5GNH56dT7J8efTPUXKkDkzrS8LpQAEMBygcwAss2UGQADDBmLa+AMvzAAIYNhATBt/YMEMgACGDcS0wbQBEEAAAQQQwD8CEzaiL7sKqOnojTuQrh95SKkX7kqD5j+M6O6Mu1NkupQJZU64B426bjmmXIzLKe7TZiUGLmweyhTa28XWdJKpYn8pXIVub1U4T4+jUKkKbyWeWhR6Vqpwd+w+hb5U4S/ta54qkhZgVihxrxWaznZVZD2lqVDaVkVafOoKGVWRN6nZR6GMxr+qZjHl3aq4db0NLXld7wVjuu7NS9f7yAAAAABJRU5ErkJggg==");
  background-position: 0 0;
  background-repeat: no-repeat;
}
.dx-loadindicator-image-small {
  background-image: url("data:image/gif;base64,R0lGODlhFAAUAKECADI6RTI6Rv///////yH/C05FVFNDQVBFMi4wAwEAAAAh+QQJCQABACwAAAAAFAAUAAACI4yPqZsADM+LcNJlb9Mq8+B8iCeWBqmFJnqpJUu5ojzDplIAACH5BAkJAAEALAAAAAAUABQAAAIhjI+py+3gXmxwrmoRzgZ4fnxgIIIl523o2KmZ+7KdTIMFACH5BAkJAAIALAAAAAAUABQAAAIflI+py+0Po4zAgDptFhXP60ngNmYdyaGBiYXbC8dwAQAh+QQJCQADACwAAAAAFAAUAAACIpyPqcsL3cCDSlJ368xnc+Nx1geG2Uiin3mpIlnC7gnXTAEAIfkECQkAAwAsAAAAABQAFAAAAiKcD6e74AxRivHRenGGc6vuIWEzluaJbuC4eq36XlboxGUBACH5BAkJAAMALAAAAAAUABQAAAIjnA8Jx226nBxp2mpnzG7z5n3iSJbmiaaqFIrt93LYOMP1UQAAIfkECQkAAwAsAAAAABQAFAAAAh2cD6l53eyiA7Iii7PevPsPhuJIluZpUB6ELWxTAAAh+QQJCQADACwAAAAAFAAUAAACHZx/oMit/5p0a9oBrt68+w+G4kiW5rllYbRCLFIAACH5BAkJAAMALAAAAAAUABQAAAIenH+ggO24noRq2molzo3xD4biSJbmSXqpuYlR2ToFACH5BAkJAAMALAAAAAAUABQAAAIhnI+pi+AMzYsQ0HrXzI2n7Q1WSJbMSKIh6Kmty7GtKWUFACH5BAkJAAMALAAAAAAUABQAAAIinI+py+3gXmxwKlAtytpgrmHdIY5DOX6mt56t24Kd/NZMAQAh+QQJCQADACwAAAAAFAAUAAACIZyPqcvtD6OMwIA6w8Czcnl91DVZW3mKkIeqK+ai8kyXBQAh+QQJCQADACwAAAAAFAAUAAACI5yPqcsL3cCDSlJ368xn82F9RiiSn8l5pziqmXuhMUzR7F0AACH5BAkJAAMALAAAAAAUABQAAAIfnI+pB70/HFxyKmBp1rv7D4aMiIXld6KmmW6V+7pKAQAh+QQJCQADACwAAAAAFAAUAAACIZw/oMi9Dc2LEVBqL8y6+w+G4kiWJBein+pNK4sp8CY3BQAh+QQJCQADACwAAAAAFAAUAAACHZw/oIt96iICstqLs968+w+G4kh+VHdukLW06VEAACH5BAkJAAMALAAAAAAUABQAAAIbnI+pCu29InKygoqz3rz7D4biSJbZ9VHpoyIFACH5BAkJAAMALAAAAAAUABQAAAIfnI8AyM26nDxq2hGvy7r7D4biSJYg51WiGkKju8JOAQA7");
  background-position: center center;
  background-repeat: no-repeat;
}
.dx-loadindicator-image-large {
  background-image: url("data:image/gif;base64,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");
  background-position: center center;
  background-repeat: no-repeat;
}
.dx-color-scheme {
  font-family: "#";
}
.dx-widget {
  display: block;
  -ms-content-zooming: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-text-size-adjust: none;
  -webkit-touch-callout: none;
  padding: 0;
  outline: 0;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
  color: rgba(0,0,0,.87);
  font-weight: 400;
  font-size: 14px;
  font-family: Roboto,RobotoFallback,"Noto Kufi Arabic",Helvetica,Arial,sans-serif;
  line-height: 1.2857;
}
.dx-widget,
.dx-widget *,
.dx-widget ::after,
.dx-widget ::before,
.dx-widget::after,
.dx-widget::before {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.dx-item {
  outline: 0;
}
.dx-rtl {
  direction: rtl;
  unicode-bidi: embed;
}
.dx-state-disabled {
  pointer-events: none;
}
.dx-widget input,
.dx-widget textarea {
  font-family: Roboto,RobotoFallback,"Noto Kufi Arabic",Helvetica,Arial,sans-serif;
  line-height: 1.2857;
}
.dx-state-disabled .dx-widget,
.dx-state-disabled.dx-widget {
  opacity: .38;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  cursor: default;
}
.dx-state-disabled .dx-widget .dx-widget,
.dx-state-disabled.dx-widget .dx-widget {
  opacity: 1;
}
.dx-card {
  overflow: hidden;
  -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);
  box-shadow: 0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);
  border-radius: 4px;
  background-color: #fff;
  margin: 2px 2px 3px;
}
.dx-fieldset .dx-field-value {
  margin: 0;
}
.dx-fieldset,
.dx-fieldset * {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.dx-fieldset-header:empty {
  display: none;
}
.dx-field {
  position: relative;
  color: rgba(0,0,0,.87);
  font-weight: 400;
  font-size: 14px;
  font-family: Roboto,RobotoFallback,"Noto Kufi Arabic",Helvetica,Arial,sans-serif;
  line-height: 1.2857;
  padding: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.dx-field::after,
.dx-field::before {
  display: table;
  content: "";
  line-height: 0;
}
.dx-field::after {
  clear: both;
}
.dx-field-label {
  float: left;
  width: 40%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dx-field-value,
.dx-field-value-static {
  float: right;
}
.dx-field-value.dx-datebox {
  min-width: 60%;
}
.dx-field-value:not(.dx-widget) > .dx-datebox {
  min-width: 100%;
}
.dx-field-value .dx-selectbox-tag-container {
  white-space: normal;
}
.dx-field-value:not(.dx-widget) > .dx-selectbox.dx-selectbox-multiselect.dx-widget {
  position: relative;
  width: auto;
  text-align: left;
}
.dx-fieldset.dx-rtl .dx-field-label,
.dx-rtl .dx-fieldset .dx-field-label {
  float: right;
}
.dx-fieldset.dx-rtl .dx-field-value,
.dx-rtl .dx-fieldset .dx-field-value {
  float: left;
}
.dx-field input,
.dx-field textarea {
  font-family: Roboto,RobotoFallback,"Noto Kufi Arabic",Helvetica,Arial,sans-serif;
  line-height: 1.2857;
}
.dx-field-label i {
  font-style: normal;
}
.dx-field-value.dx-attention {
  color: #f44336;
  padding: 21px 10px 20px 32px;
  position: relative;
}
.dx-field-value.dx-attention::before {
  pointer-events: none;
  position: absolute;
  top: 50%;
  margin-top: -11px;
  width: 22px;
  height: 22px;
  text-align: center;
  line-height: 23px;
  font-size: 14px;
  font-weight: 500;
  background-color: #f44336;
  color: #fff;
  content: "!";
  border-radius: 50%;
  left: 0;
}
.dx-field-value-static,
.dx-field-value:not(.dx-switch):not(.dx-checkbox):not(.dx-button) {
  width: 60%;
}
.dx-field-label {
  color: rgba(117,117,117,.87);
  font-size: 12px;
  cursor: default;
  -ms-flex-item-align: center;
  align-self: center;
  padding-right: 15px;
}
.dx-field-value.dx-widget,
.dx-field-value:not(.dx-widget) > .dx-widget {
  margin: 0;
}
.dx-field-value:not(.dx-widget) > .dx-button,
.dx-field-value:not(.dx-widget) > .dx-checkbox,
.dx-field-value:not(.dx-widget) > .dx-switch {
  float: right;
}
.dx-field-value.dx-checkbox,
.dx-field-value:not(.dx-widget) > .dx-checkbox {
  margin: 15px 0;
}
.dx-field-value.dx-switch,
.dx-field-value:not(.dx-widget) > .dx-switch {
  margin: 14px 0;
}
.dx-field-value.dx-slider,
.dx-field-value:not(.dx-widget) > .dx-slider {
  margin: 10px 0;
}
.dx-field-value.dx-radiogroup,
.dx-field-value:not(.dx-widget) > .dx-radiogroup {
  margin: 11px 0;
}
.dx-field-value-static {
  white-space: normal;
  padding: 21px 10px 20px;
}
.dx-fieldset {
  margin: 30px 20px;
  padding: 0;
}
.dx-rtl .dx-fieldset .dx-field-value:not(.dx-widget) > .dx-button,
.dx-rtl .dx-fieldset .dx-field-value:not(.dx-widget) > .dx-checkbox,
.dx-rtl .dx-fieldset .dx-field-value:not(.dx-widget) > .dx-switch,
.dx-rtl.dx-fieldset .dx-field-value:not(.dx-widget) > .dx-button,
.dx-rtl.dx-fieldset .dx-field-value:not(.dx-widget) > .dx-checkbox,
.dx-rtl.dx-fieldset .dx-field-value:not(.dx-widget) > .dx-switch {
  float: left;
}
.dx-fieldset-header {
  margin: 0 0 20px;
  font-size: 18px;
}
.dx-field {
  margin: 0 0 30px;
}
.dx-field:last-of-type {
  margin: 0;
}
.dx-theme-marker {
  font-family: "dx.material.teal.light";
}
.dx-theme-accent-as-text-color {
  color: #009688!important;
}
.dx-theme-text-color {
  color: rgba(0,0,0,.87)!important;
}
.dx-theme-background-color-as-text-color {
  color: #fff!important;
}
.dx-theme-border-color-as-text-color {
  color: #e0e0e0!important;
}
.dx-theme-accent-as-background-color {
  background-color: #009688!important;
  fill: #009688!important;
}
.dx-theme-text-color-as-background-color {
  background-color: rgba(0,0,0,.87)!important;
  fill: rgba(0,0,0,0.87)!important;
}
.dx-theme-background-color {
  background-color: #fff!important;
  fill: #fff!important;
}
.dx-theme-border-color-as-background-color {
  background-color: #e0e0e0!important;
  fill: #e0e0e0!important;
}
.dx-theme-accent-as-border-color {
  border-color: #009688!important;
}
.dx-theme-text-color-as-border-color {
  border-color: rgba(0,0,0,.87)!important;
}
.dx-theme-background-color-as-border-color {
  border-color: #fff!important;
}
.dx-theme-border-color {
  border-color: #e0e0e0!important;
}
.dx-inkripple {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
}
.dx-inkripple-wave {
  position: absolute;
  background-color: rgba(0,0,0,.16);
  border-radius: 50%;
  opacity: 0;
  -webkit-transform: scale(0);
  transform: scale(0);
  pointer-events: none;
}
.dx-inkripple-showing {
  -webkit-transition: -webkit-transform .1s linear;
  transition: transform .1s linear;
  transition: transform .1s linear,-webkit-transform .1s linear;
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}
.dx-inkripple-hiding {
  -webkit-transition: opacity .1s linear,-webkit-transform .1s linear;
  transition: transform .1s linear,opacity .1s linear,-webkit-transform .1s linear;
  -webkit-transform: scale(1.01);
  transform: scale(1.01);
  opacity: 0;
}
.dx-resizable {
  display: block;
  position: relative;
}
.dx-resizable-handle {
  position: absolute;
  z-index: 50;
}
.dx-state-disabled .dx-resizable-handle {
  cursor: default;
}
.dx-resizable-handle-left,
.dx-resizable-handle-right {
  top: 0;
  height: 100%;
  width: 3px;
}
.dx-resizable-handle-left {
  left: 0;
  cursor: e-resize;
}
.dx-resizable-handle-right {
  right: 0;
  cursor: e-resize;
}
.dx-resizable-handle-bottom,
.dx-resizable-handle-top {
  left: 0;
  width: 100%;
  height: 3px;
}
.dx-resizable-handle-top {
  top: 0;
  cursor: s-resize;
}
.dx-resizable-handle-bottom {
  bottom: 0;
  cursor: s-resize;
}
.dx-resizable-handle-corner-bottom-left,
.dx-resizable-handle-corner-bottom-right,
.dx-resizable-handle-corner-top-left,
.dx-resizable-handle-corner-top-right {
  width: 6px;
  height: 6px;
}
.dx-resizable-handle-corner-bottom-right,
.dx-resizable-handle-corner-top-left {
  cursor: se-resize;
}
.dx-resizable-handle-corner-bottom-left,
.dx-resizable-handle-corner-top-right {
  cursor: ne-resize;
}
.dx-resizable-handle-corner-bottom-left,
.dx-resizable-handle-corner-top-left {
  left: 0;
  border-bottom-right-radius: 100%;
}
.dx-resizable-handle-corner-bottom-right,
.dx-resizable-handle-corner-top-right {
  right: 0;
  border-bottom-left-radius: 100%;
}
.dx-resizable-handle-corner-top-left,
.dx-resizable-handle-corner-top-right {
  top: 0;
}
.dx-resizable-handle-corner-bottom-left,
.dx-resizable-handle-corner-bottom-right {
  bottom: 0;
}
.dx-draggable {
  left: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}
.dx-draggable.dx-state-disabled,
.dx-state-disabled .dx-draggable {
  cursor: default;
}
.dx-draggable-clone {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2147483647;
}
.dx-clearfix::after,
.dx-clearfix::before {
  display: table;
  content: "";
  line-height: 0;
}
.dx-clearfix::after {
  clear: both;
}
.dx-translate-disabled {
  -webkit-transform: none!important;
  transform: none!important;
}
.dx-hidden-input {
  position: fixed;
  top: -10px;
  left: -10px;
  width: 0;
  height: 0;
}
.dx-user-select {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
.dx-hidden,
.dx-state-invisible {
  display: none!important;
}
.dx-gesture-cover {
  -webkit-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  opacity: 0;
  z-index: 2147483647;
}
.dx-animating {
  pointer-events: none;
}
.dx-fade-animation.dx-enter,
.dx-fade-animation.dx-leave.dx-leave-active,
.dx-no-direction.dx-enter,
.dx-no-direction.dx-leave.dx-leave-active {
  opacity: 0;
}
.dx-fade-animation.dx-enter.dx-enter-active,
.dx-fade-animation.dx-leave,
.dx-no-direction.dx-enter.dx-enter-active,
.dx-no-direction.dx-leave {
  opacity: 1;
}
.dx-overflow-animation.dx-enter.dx-forward {
  -webkit-transform: translate3d(100%,0,0);
  transform: translate3d(100%,0,0);
  z-index: 2;
}
.dx-overflow-animation.dx-enter.dx-enter-active.dx-forward {
  -webkit-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);
  z-index: 2;
}
.dx-overflow-animation.dx-enter.dx-backward,
.dx-overflow-animation.dx-enter.dx-enter-active.dx-backward,
.dx-overflow-animation.dx-leave.dx-forward,
.dx-overflow-animation.dx-leave.dx-leave-active.dx-forward {
  -webkit-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);
  z-index: 1;
}
.dx-overflow-animation.dx-leave.dx-backward {
  -webkit-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);
  z-index: 2;
}
.dx-overflow-animation.dx-leave.dx-leave-active.dx-backward {
  -webkit-transform: translate3d(100%,0,0);
  transform: translate3d(100%,0,0);
  z-index: 2;
}
.dx-slide-animation.dx-enter.dx-forward {
  -webkit-transform: translate3d(100%,0,0);
  transform: translate3d(100%,0,0);
}
.dx-slide-animation.dx-enter.dx-enter-active.dx-forward {
  -webkit-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);
}
.dx-slide-animation.dx-enter.dx-backward {
  -webkit-transform: translate3d(-100%,0,0);
  transform: translate3d(-100%,0,0);
}
.dx-slide-animation.dx-enter.dx-enter-active.dx-backward,
.dx-slide-animation.dx-leave.dx-forward {
  -webkit-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);
}
.dx-slide-animation.dx-leave.dx-leave-active.dx-forward {
  -webkit-transform: translate3d(-100%,0,0);
  transform: translate3d(-100%,0,0);
}
.dx-slide-animation.dx-leave.dx-backward {
  -webkit-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);
}
.dx-slide-animation.dx-leave.dx-leave-active.dx-backward {
  -webkit-transform: translate3d(100%,0,0);
  transform: translate3d(100%,0,0);
}
.dx-opendoor-animation.dx-enter.dx-forward {
  -webkit-transform: matrix3d(.71,0,.71,.001,0,1,0,0,-.71,0,.71,0,0,0,0,1);
  transform: matrix3d(.71,0,.71,.001,0,1,0,0,-.71,0,.71,0,0,0,0,1);
  -webkit-transform-origin: center left 0;
  transform-origin: center left 0;
  opacity: 0;
}
.dx-opendoor-animation.dx-enter.dx-enter-active.dx-backward,
.dx-opendoor-animation.dx-enter.dx-enter-active.dx-forward {
  -webkit-transform: none;
  transform: none;
  opacity: 1;
}
.dx-opendoor-animation.dx-leave.dx-backward,
.dx-opendoor-animation.dx-leave.dx-forward {
  -webkit-transform: none;
  transform: none;
  -webkit-transform-origin: center left 0;
  transform-origin: center left 0;
  opacity: 1;
}
.dx-opendoor-animation.dx-enter.dx-backward,
.dx-opendoor-animation.dx-leave.dx-leave-active.dx-forward {
  -webkit-transform: matrix3d(.5,0,.87,-.001,0,1,0,0,-.87,0,.5,0,0,0,0,1);
  transform: matrix3d(.5,0,.87,-.001,0,1,0,0,-.87,0,.5,0,0,0,0,1);
  -webkit-transform-origin: center left 0;
  transform-origin: center left 0;
  opacity: 0;
}
.dx-opendoor-animation.dx-leave.dx-leave-active.dx-backward {
  -webkit-transform: matrix3d(.71,0,.71,.001,0,1,0,0,-.71,0,.71,0,0,0,0,1);
  transform: matrix3d(.71,0,.71,.001,0,1,0,0,-.71,0,.71,0,0,0,0,1);
  opacity: 0;
}
.dx-win-pop-animation.dx-enter.dx-forward {
  -webkit-transform: scale(.5);
  transform: scale(.5);
  opacity: 0;
}
.dx-win-pop-animation.dx-enter.dx-enter-active.dx-forward {
  -webkit-transform: scale(1);
  transform: scale(1);
  opacity: 1;
}
.dx-win-pop-animation.dx-enter.dx-backward,
.dx-win-pop-animation.dx-leave.dx-leave-active.dx-forward {
  -webkit-transform: scale(1.5);
  transform: scale(1.5);
  opacity: 0;
}
.dx-win-pop-animation.dx-enter.dx-enter-active.dx-backward {
  -webkit-transform: scale(1);
  transform: scale(1);
  opacity: 1;
}
.dx-win-pop-animation.dx-leave.dx-leave-active.dx-backward {
  -webkit-transform: scale(.5);
  transform: scale(.5);
  opacity: 0;
}
.dx-android-pop-animation.dx-enter.dx-forward,
.dx-android-pop-animation.dx-leave.dx-leave-active.dx-backward {
  -webkit-transform: translate3d(0,150px,0);
  transform: translate3d(0,150px,0);
  opacity: 0;
}
.dx-android-pop-animation.dx-enter.dx-enter-active.dx-forward,
.dx-android-pop-animation.dx-leave.dx-backward {
  -webkit-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);
  opacity: 1;
}
.dx-android-pop-animation.dx-enter.dx-forward,
.dx-android-pop-animation.dx-leave.dx-backward {
  z-index: 1;
}
.dx-ios7-slide-animation.dx-enter.dx-forward {
  z-index: 2;
  -webkit-transform: translate3d(100%,0,0);
  transform: translate3d(100%,0,0);
}
.dx-ios7-slide-animation.dx-enter.dx-enter-active.dx-forward {
  z-index: 2;
  -webkit-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);
}
.dx-ios7-slide-animation.dx-enter.dx-backward {
  -webkit-transform: translate3d(-20%,0,0);
  transform: translate3d(-20%,0,0);
  z-index: 1;
}
.dx-ios7-slide-animation.dx-enter.dx-enter-active.dx-backward {
  -webkit-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);
  z-index: 1;
}
.dx-ios7-slide-animation.dx-leave.dx-forward {
  z-index: 1;
  -webkit-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);
}
.dx-ios7-slide-animation.dx-leave.dx-leave-active.dx-forward {
  -webkit-transform: translate3d(-20%,0,0);
  transform: translate3d(-20%,0,0);
  z-index: 1;
}
.dx-ios7-slide-animation.dx-leave.dx-backward {
  z-index: 2;
}
.dx-ios7-slide-animation.dx-leave.dx-leave-active.dx-backward {
  -webkit-transform: translate3d(100%,0,0);
  transform: translate3d(100%,0,0);
  z-index: 2;
}
.dx-ios7-toolbar-animation.dx-enter.dx-forward {
  -webkit-transform: translate3d(40%,0,0);
  transform: translate3d(40%,0,0);
  opacity: 0;
  z-index: 2;
}
.dx-ios7-toolbar-animation.dx-enter.dx-enter-active.dx-forward {
  -webkit-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);
  opacity: 1;
  z-index: 2;
}
.dx-ios7-toolbar-animation.dx-enter.dx-backward {
  -webkit-transform: translate3d(-40%,0,0);
  transform: translate3d(-40%,0,0);
  opacity: 0;
  z-index: 1;
}
.dx-ios7-toolbar-animation.dx-enter.dx-enter-active.dx-backward,
.dx-ios7-toolbar-animation.dx-leave.dx-forward {
  -webkit-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);
  opacity: 1;
  z-index: 1;
}
.dx-ios7-toolbar-animation.dx-leave.dx-leave-active.dx-forward {
  -webkit-transform: translate3d(-40%,0,0);
  transform: translate3d(-40%,0,0);
  opacity: 0;
  z-index: 1;
}
.dx-ios7-toolbar-animation.dx-leave.dx-backward {
  -webkit-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);
  opacity: 1;
  z-index: 2;
}
.dx-ios7-toolbar-animation.dx-leave.dx-leave-active.dx-backward {
  -webkit-transform: translate3d(40%,0,0);
  transform: translate3d(40%,0,0);
  opacity: 0;
  z-index: 2;
}
.dx-drop-animation.dx-enter,
.dx-drop-animation.dx-leave.dx-leave-active {
  -webkit-transform: translate3d(0,-120%,0);
  transform: translate3d(0,-120%,0);
}
.dx-drop-animation.dx-enter.dx-enter-active,
.dx-drop-animation.dx-leave {
  -webkit-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);
}
.dx-3d-drop-animation.dx-enter,
.dx-3d-drop-animation.dx-leave.dx-leave-active {
  -webkit-transform: rotate3d(1,0,0,10deg) translate3d(0,-10px,0) scale3d(1.1,1.1,1.1);
  transform: rotate3d(1,0,0,10deg) translate3d(0,-10px,0) scale3d(1.1,1.1,1.1);
  opacity: 0;
}
.dx-3d-drop-animation.dx-enter.dx-enter-active,
.dx-3d-drop-animation.dx-leave {
  -webkit-transform: rotate3d(1,0,0,0) translate3d(0,0,0) scale3d(1,1,1);
  transform: rotate3d(1,0,0,0) translate3d(0,0,0) scale3d(1,1,1);
  opacity: 1;
}
.dx-fade-drop-animation.dx-enter,
.dx-fade-drop-animation.dx-leave.dx-leave-active {
  -webkit-transform: translate3d(0,-10px,0) scale3d(1.1,1.1,1.1);
  transform: translate3d(0,-10px,0) scale3d(1.1,1.1,1.1);
  opacity: 0;
}
.dx-fade-drop-animation.dx-enter.dx-enter-active,
.dx-fade-drop-animation.dx-leave {
  -webkit-transform: translate3d(0,0,0) scale3d(1,1,1);
  transform: translate3d(0,0,0) scale3d(1,1,1);
  opacity: 1;
}
.dx-fade-rise-animation.dx-enter,
.dx-fade-rise-animation.dx-leave.dx-leave-active {
  -webkit-transform: translate3d(0,10px,0) scale3d(1.1,1.1,1.1);
  transform: translate3d(0,10px,0) scale3d(1.1,1.1,1.1);
  opacity: 0;
}
.dx-fade-rise-animation.dx-enter.dx-enter-active,
.dx-fade-rise-animation.dx-leave {
  -webkit-transform: translate3d(0,0,0) scale3d(1,1,1);
  transform: translate3d(0,0,0) scale3d(1,1,1);
  opacity: 1;
}
.dx-fade-slide-animation.dx-enter,
.dx-fade-slide-animation.dx-leave.dx-leave-active {
  -webkit-transform: translate3d(40%,0,0);
  transform: translate3d(40%,0,0);
  opacity: 0;
}
.dx-fade-slide-animation.dx-enter.dx-enter-active,
.dx-fade-slide-animation.dx-leave {
  -webkit-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);
  opacity: 1;
}
.dx-fade-zoom-animation.dx-enter,
.dx-fade-zoom-animation.dx-leave.dx-leave-active {
  -webkit-transform: scale3d(.3,.3,.3);
  transform: scale3d(.3,.3,.3);
  opacity: 0;
}
.dx-fade-zoom-animation.dx-enter.dx-enter-active,
.dx-fade-zoom-animation.dx-leave {
  -webkit-transform: scale3d(1,1,1);
  transform: scale3d(1,1,1);
  opacity: 1;
}
.dx-box-item-content {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  max-width: 100%;
  font-size: 14px;
}
.dx-button-disabled {
  cursor: default;
}
.dx-button {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  cursor: pointer;
  text-align: center;
  vertical-align: middle;
  max-width: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-drag: none;
  min-width: 36px;
}
.dx-button .dx-icon {
  -webkit-user-drag: none;
  display: inherit;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  vertical-align: middle;
  width: 18px;
  height: 18px;
  font-size: 18px;
  margin-right: 0;
  margin-left: 0;
  color: rgba(0,0,0,.87);
}
.dx-button a {
  text-decoration: none;
}
.dx-button-back .dx-button-text {
  display: none;
}
.dx-button-content {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  height: 100%;
  max-height: 100%;
  display: inherit;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  vertical-align: middle;
  line-height: 0;
}
.dx-button-has-text .dx-button-content,
.dx-button-has-text .dx-button-content .dx-button-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dx-button-content > .dx-inkripple {
  display: none;
}
.dx-button-link {
  text-decoration: none;
}
.dx-button-submit-input {
  padding: 0;
  margin: 0;
  border: 0;
  height: 0;
  width: 0;
  font-size: 0;
  opacity: 0;
}
.dx-state-disabled .dx-button,
.dx-state-disabled.dx-button {
  cursor: default;
}
.dx-button-text {
  line-height: normal;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: .04em;
}
.dx-button .dx-button-content {
  padding: 0;
  position: relative;
}
.dx-button .dx-icon.dx-icon-right,
.dx-rtl .dx-button .dx-icon,
.dx-rtl.dx-button .dx-icon {
  margin-left: 0;
  margin-right: 0;
}
.dx-rtl .dx-button .dx-icon.dx-icon-right,
.dx-rtl.dx-button .dx-icon.dx-icon-right {
  margin-right: 0;
  margin-left: 0;
}
.dx-button-has-icon {
  min-width: 36px;
}
.dx-button-has-icon .dx-button-content {
  padding: 0;
}
.dx-button-has-icon .dx-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
  margin-right: 0;
  margin-left: 0;
}
.dx-button-has-icon .dx-icon.dx-icon-right,
.dx-rtl .dx-button-has-icon .dx-icon,
.dx-rtl.dx-button-has-icon .dx-icon {
  margin-left: 0;
  margin-right: 0;
}
.dx-rtl .dx-button-has-icon .dx-icon.dx-icon-right,
.dx-rtl.dx-button-has-icon .dx-icon.dx-icon-right {
  margin-right: 0;
  margin-left: 0;
}
.dx-button-has-text {
  min-width: 64px;
}
.dx-button-has-text .dx-button-content {
  padding: 6px 16px;
}
.dx-button-has-text .dx-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
  margin-right: 9px;
  margin-left: 0;
}
.dx-button-has-text .dx-icon.dx-icon-right,
.dx-rtl .dx-button-has-text .dx-icon,
.dx-rtl.dx-button-has-text .dx-icon {
  margin-left: 9px;
  margin-right: 0;
}
.dx-rtl .dx-button-has-text .dx-icon.dx-icon-right,
.dx-rtl.dx-button-has-text .dx-icon.dx-icon-right {
  margin-right: 9px;
  margin-left: 0;
}
.dx-button-has-icon.dx-button-has-text .dx-button-content {
  padding: 6px 16px 6px 12px;
}
.dx-button-has-icon.dx-button-has-text .dx-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
  margin-right: 8px;
  margin-left: 0;
}
.dx-button-has-icon.dx-button-has-text .dx-icon.dx-icon-right,
.dx-rtl .dx-button-has-icon.dx-button-has-text .dx-icon,
.dx-rtl.dx-button-has-icon.dx-button-has-text .dx-icon {
  margin-left: 8px;
  margin-right: 0;
}
.dx-rtl .dx-button-has-icon.dx-button-has-text .dx-icon.dx-icon-right,
.dx-rtl.dx-button-has-icon.dx-button-has-text .dx-icon.dx-icon-right {
  margin-right: 8px;
  margin-left: 0;
}
.dx-rtl .dx-button-has-icon.dx-button-has-text .dx-button-content {
  padding-left: 16px;
  padding-right: 12px;
}
.dx-button.dx-button-has-icon:not(.dx-button-has-text):not(.dx-shape-standard) {
  border-radius: 50%;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button {
  height: 36px;
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  background-color: #fff;
  color: rgba(0,0,0,.87);
  -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.24);
  box-shadow: 0 1px 3px rgba(0,0,0,.24);
}
.dx-button .dx-button-content .dx-inkripple {
  overflow: hidden;
  display: block;
}
.dx-button.dx-state-hover {
  background-color: #ebebeb;
  -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.24);
  box-shadow: 0 1px 3px rgba(0,0,0,.24);
}
.dx-button.dx-state-focused {
  background-color: #ebebeb;
  -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.32);
  box-shadow: 0 1px 3px rgba(0,0,0,.32);
}
.dx-button.dx-state-active {
  background-color: #b3b3b3;
  -webkit-box-shadow: 0 4px 6px rgba(0,0,0,.32);
  box-shadow: 0 4px 6px rgba(0,0,0,.32);
}
.dx-button.dx-state-disabled {
  background: rgba(0,0,0,.1);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-button.dx-state-disabled .dx-button-text,
.dx-button.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-button .dx-inkripple-wave {
  background-color: rgba(0,0,0,.2);
}
.dx-button.dx-button-default {
  border-radius: 4px;
  background-color: #009688;
  color: #fff;
  -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.24);
  box-shadow: 0 1px 3px rgba(0,0,0,.24);
}
.dx-button.dx-button-default .dx-icon {
  color: #fff;
}
.dx-button.dx-button-default.dx-state-hover {
  background-color: #006b61;
  -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.24);
  box-shadow: 0 1px 3px rgba(0,0,0,.24);
}
.dx-button.dx-button-default.dx-state-focused {
  background-color: #006b61;
  -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.32);
  box-shadow: 0 1px 3px rgba(0,0,0,.32);
}
.dx-button.dx-button-default.dx-state-active {
  background-color: #00332e;
  -webkit-box-shadow: 0 4px 6px rgba(0,0,0,.32);
  box-shadow: 0 4px 6px rgba(0,0,0,.32);
}
.dx-button.dx-button-default.dx-state-disabled {
  background: rgba(0,0,0,.1);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button.dx-button-default.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-button.dx-button-default.dx-state-disabled .dx-button-text,
.dx-button.dx-button-default.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-button.dx-button-default .dx-inkripple-wave {
  background-color: rgba(255,255,255,.2);
}
.dx-button.dx-button-danger {
  border-radius: 4px;
  background-color: #f44336;
  color: #fff;
  -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.24);
  box-shadow: 0 1px 3px rgba(0,0,0,.24);
}
.dx-button.dx-button-danger .dx-icon {
  color: #fff;
}
.dx-button.dx-button-danger.dx-state-hover {
  background-color: #f11d0d;
  -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.24);
  box-shadow: 0 1px 3px rgba(0,0,0,.24);
}
.dx-button.dx-button-danger.dx-state-focused {
  background-color: #f11d0d;
  -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.32);
  box-shadow: 0 1px 3px rgba(0,0,0,.32);
}
.dx-button.dx-button-danger.dx-state-active {
  background-color: #bc160a;
  -webkit-box-shadow: 0 4px 6px rgba(0,0,0,.32);
  box-shadow: 0 4px 6px rgba(0,0,0,.32);
}
.dx-button.dx-button-danger.dx-state-disabled {
  background: rgba(0,0,0,.1);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button.dx-button-danger.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-button.dx-button-danger.dx-state-disabled .dx-button-text,
.dx-button.dx-button-danger.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-button.dx-button-danger .dx-inkripple-wave {
  background-color: rgba(255,255,255,.2);
}
.dx-button.dx-button-success {
  border-radius: 4px;
  background-color: #8bc34a;
  color: #fff;
  -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.24);
  box-shadow: 0 1px 3px rgba(0,0,0,.24);
}
.dx-button.dx-button-success .dx-icon {
  color: #fff;
}
.dx-button.dx-button-success.dx-state-hover {
  background-color: #75a938;
  -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.24);
  box-shadow: 0 1px 3px rgba(0,0,0,.24);
}
.dx-button.dx-button-success.dx-state-focused {
  background-color: #75a938;
  -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.32);
  box-shadow: 0 1px 3px rgba(0,0,0,.32);
}
.dx-button.dx-button-success.dx-state-active {
  background-color: #587f2a;
  -webkit-box-shadow: 0 4px 6px rgba(0,0,0,.32);
  box-shadow: 0 4px 6px rgba(0,0,0,.32);
}
.dx-button.dx-button-success.dx-state-disabled {
  background: rgba(0,0,0,.1);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button.dx-button-success.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-button.dx-button-success.dx-state-disabled .dx-button-text,
.dx-button.dx-button-success.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-button.dx-button-success .dx-inkripple-wave {
  background-color: rgba(255,255,255,.2);
}
.dx-button.dx-button-back {
  background-color: transparent;
  color: rgba(0,0,0,.87);
  -webkit-box-shadow: none;
  box-shadow: none;
  border-radius: 50%;
  min-width: 36px;
}
.dx-button.dx-button-back .dx-icon {
  color: rgba(0,0,0,.87);
  width: 18px;
  height: 18px;
  font-size: 18px;
  margin-right: 0;
  margin-left: 0;
}
.dx-button.dx-button-back.dx-state-focused,
.dx-button.dx-button-back.dx-state-hover {
  background-color: rgba(0,0,0,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button.dx-button-back.dx-state-active {
  background-color: rgba(0,0,0,.3);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button.dx-button-back.dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button.dx-button-back.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-button.dx-button-back.dx-state-disabled .dx-button-text,
.dx-button.dx-button-back.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-button.dx-button-back .dx-inkripple-wave {
  background-color: rgba(0,0,0,.2);
}
.dx-button.dx-button-back .dx-button-content {
  padding: 0;
}
.dx-button.dx-button-back .dx-icon.dx-icon-right,
.dx-rtl .dx-button.dx-button-back .dx-icon,
.dx-rtl.dx-button.dx-button-back .dx-icon {
  margin-left: 0;
  margin-right: 0;
}
.dx-rtl .dx-button.dx-button-back .dx-icon.dx-icon-right,
.dx-rtl.dx-button.dx-button-back .dx-icon.dx-icon-right {
  margin-right: 0;
  margin-left: 0;
}
.dx-button-mode-text {
  background-color: transparent;
  color: rgba(0,0,0,.87);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-text .dx-icon {
  color: rgba(0,0,0,.87);
}
.dx-button-mode-text.dx-state-focused,
.dx-button-mode-text.dx-state-hover {
  background-color: rgba(0,0,0,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-text.dx-state-active {
  background-color: rgba(0,0,0,.3);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-text.dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-text.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-button-mode-text.dx-state-disabled .dx-button-text,
.dx-button-mode-text.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-button-mode-text .dx-inkripple-wave {
  background-color: rgba(0,0,0,.2);
}
.dx-button-mode-text.dx-button-default {
  background-color: transparent;
  color: #009688;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-text.dx-button-default .dx-icon {
  color: #009688;
}
.dx-button-mode-text.dx-button-default.dx-state-focused,
.dx-button-mode-text.dx-button-default.dx-state-hover {
  background-color: rgba(0,150,136,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-text.dx-button-default.dx-state-active {
  background-color: rgba(0,150,136,.36);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-text.dx-button-default.dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-text.dx-button-default.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-button-mode-text.dx-button-default.dx-state-disabled .dx-button-text,
.dx-button-mode-text.dx-button-default.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-button-mode-text.dx-button-default .dx-inkripple-wave {
  background-color: rgba(0,150,136,.2);
}
.dx-button-mode-text.dx-button-danger {
  background-color: transparent;
  color: #f44336;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-text.dx-button-danger .dx-icon {
  color: #f44336;
}
.dx-button-mode-text.dx-button-danger.dx-state-focused,
.dx-button-mode-text.dx-button-danger.dx-state-hover {
  background-color: rgba(244,67,54,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-text.dx-button-danger.dx-state-active {
  background-color: rgba(244,67,54,.36);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-text.dx-button-danger.dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-text.dx-button-danger.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-button-mode-text.dx-button-danger.dx-state-disabled .dx-button-text,
.dx-button-mode-text.dx-button-danger.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-button-mode-text.dx-button-danger .dx-inkripple-wave {
  background-color: rgba(244,67,54,.2);
}
.dx-button-mode-text.dx-button-success {
  background-color: transparent;
  color: #8bc34a;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-text.dx-button-success .dx-icon {
  color: #8bc34a;
}
.dx-button-mode-text.dx-button-success.dx-state-focused,
.dx-button-mode-text.dx-button-success.dx-state-hover {
  background-color: rgba(139,195,74,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-text.dx-button-success.dx-state-active {
  background-color: rgba(139,195,74,.36);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-text.dx-button-success.dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-text.dx-button-success.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-button-mode-text.dx-button-success.dx-state-disabled .dx-button-text,
.dx-button-mode-text.dx-button-success.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-button-mode-text.dx-button-success .dx-inkripple-wave {
  background-color: rgba(139,195,74,.2);
}
.dx-button-mode-outlined {
  background-color: transparent;
  color: rgba(0,0,0,.87);
  -webkit-box-shadow: none;
  box-shadow: none;
  border: 1px solid rgba(0,0,0,.24);
}
.dx-button-mode-outlined .dx-icon {
  color: rgba(0,0,0,.87);
}
.dx-button-mode-outlined.dx-state-focused,
.dx-button-mode-outlined.dx-state-hover {
  background-color: rgba(0,0,0,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-outlined.dx-state-active {
  background-color: rgba(0,0,0,.3);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-outlined.dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-outlined.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-button-mode-outlined.dx-state-disabled .dx-button-text,
.dx-button-mode-outlined.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-button-mode-outlined .dx-inkripple-wave {
  background-color: rgba(0,0,0,.2);
}
.dx-button-mode-outlined.dx-button-default {
  background-color: transparent;
  color: #009688;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: 1px solid #009688;
}
.dx-button-mode-outlined.dx-button-default .dx-icon {
  color: #009688;
}
.dx-button-mode-outlined.dx-button-default.dx-state-focused,
.dx-button-mode-outlined.dx-button-default.dx-state-hover {
  background-color: rgba(0,150,136,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-outlined.dx-button-default.dx-state-active {
  background-color: rgba(0,150,136,.36);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-outlined.dx-button-default.dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-outlined.dx-button-default.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-button-mode-outlined.dx-button-default.dx-state-disabled .dx-button-text,
.dx-button-mode-outlined.dx-button-default.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-button-mode-outlined.dx-button-default .dx-inkripple-wave {
  background-color: rgba(0,150,136,.2);
}
.dx-button-mode-outlined.dx-button-danger {
  background-color: transparent;
  color: #f44336;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: 1px solid #f44336;
}
.dx-button-mode-outlined.dx-button-danger .dx-icon {
  color: #f44336;
}
.dx-button-mode-outlined.dx-button-danger.dx-state-focused,
.dx-button-mode-outlined.dx-button-danger.dx-state-hover {
  background-color: rgba(244,67,54,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-outlined.dx-button-danger.dx-state-active {
  background-color: rgba(244,67,54,.36);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-outlined.dx-button-danger.dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-outlined.dx-button-danger.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-button-mode-outlined.dx-button-danger.dx-state-disabled .dx-button-text,
.dx-button-mode-outlined.dx-button-danger.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-button-mode-outlined.dx-button-danger .dx-inkripple-wave {
  background-color: rgba(244,67,54,.2);
}
.dx-button-mode-outlined.dx-button-success {
  background-color: transparent;
  color: #8bc34a;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: 1px solid #8bc34a;
}
.dx-button-mode-outlined.dx-button-success .dx-icon {
  color: #8bc34a;
}
.dx-button-mode-outlined.dx-button-success.dx-state-focused,
.dx-button-mode-outlined.dx-button-success.dx-state-hover {
  background-color: rgba(139,195,74,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-outlined.dx-button-success.dx-state-active {
  background-color: rgba(139,195,74,.36);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-outlined.dx-button-success.dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button-mode-outlined.dx-button-success.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-button-mode-outlined.dx-button-success.dx-state-disabled .dx-button-text,
.dx-button-mode-outlined.dx-button-success.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-button-mode-outlined.dx-button-success .dx-inkripple-wave {
  background-color: rgba(139,195,74,.2);
}
.dx-buttongroup {
  display: inline-block;
}
.dx-buttongroup-wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  height: 100%;
  width: 100%;
}
.dx-buttongroup-item {
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
}
.dx-buttongroup-item.dx-button-mode-contained,
.dx-buttongroup-item.dx-button-mode-outlined {
  border-left-width: 0;
}
.dx-buttongroup-item.dx-button-mode-contained.dx-button,
.dx-buttongroup-item.dx-button-mode-outlined.dx-button {
  border-radius: 0;
}
.dx-buttongroup-item.dx-button-mode-text {
  margin-left: 1px;
}
.dx-buttongroup-item-has-width {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.dx-button-mode-contained.dx-buttongroup-item {
  padding-right: 1px;
}
.dx-button-mode-contained.dx-buttongroup-last-item {
  padding-right: 0;
}
.dx-button-mode-outlined.dx-buttongroup-item {
  border-left-width: 0;
}
.dx-button-mode-outlined.dx-buttongroup-first-item {
  border-left-width: 1px;
}
.dx-button-mode-text.dx-button.dx-buttongroup-item {
  border-radius: 4px;
}
.dx-button-mode-text.dx-buttongroup-first-item {
  margin-left: 0;
}
.dx-button-mode-contained.dx-button.dx-buttongroup-first-item,
.dx-button-mode-outlined.dx-button.dx-buttongroup-first-item {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.dx-button-mode-contained.dx-button.dx-buttongroup-last-item,
.dx-button-mode-outlined.dx-button.dx-buttongroup-last-item {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.dx-buttongroup-item.dx-button.dx-button-mode-contained.dx-state-disabled,
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-state-disabled {
  opacity: 1;
}
.dx-buttongroup-item.dx-button.dx-button-mode-contained.dx-state-disabled .dx-button-content,
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-state-disabled .dx-button-content {
  opacity: .6;
}
.dx-buttongroup-item.dx-button.dx-button-mode-contained.dx-button-normal {
  background-color: #fff;
}
.dx-buttongroup-item.dx-button.dx-button-mode-contained.dx-button-normal.dx-state-focused,
.dx-buttongroup-item.dx-button.dx-button-mode-contained.dx-button-normal.dx-state-hover {
  background-color: #ebebeb;
}
.dx-buttongroup-item.dx-button.dx-button-mode-contained.dx-button-normal.dx-item-selected {
  background-color: #d1d1d1;
}
.dx-buttongroup-item.dx-button.dx-button-mode-contained.dx-button-normal.dx-item-selected.dx-state-focused,
.dx-buttongroup-item.dx-button.dx-button-mode-contained.dx-button-normal.dx-item-selected.dx-state-hover {
  background-color: #e0e0e0;
}
.dx-buttongroup-item.dx-button.dx-button-mode-contained.dx-button-normal.dx-item-selected,
.dx-buttongroup-item.dx-button.dx-button-mode-contained.dx-button-normal.dx-item-selected .dx-icon {
  color: rgba(0,0,0,.87);
}
.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected) {
  background-color: #fff;
}
.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-success.dx-state-focused,
.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-success.dx-state-hover {
  background-color: #f6faf1;
}
.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-success,
.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-success .dx-icon {
  color: #8bc34a;
}
.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-default.dx-state-focused,
.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-default.dx-state-hover {
  background-color: #75fff2;
}
.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-default,
.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-default .dx-icon {
  color: #009688;
}
.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-danger.dx-state-focused,
.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-danger.dx-state-hover {
  background-color: #fef0ef;
}
.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-danger,
.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-danger .dx-icon {
  color: #f44336;
}
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-state-focused,
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-state-hover {
  background-color: rgba(0,0,0,.08);
}
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-button-success.dx-state-focused,
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-button-success.dx-state-hover {
  background-color: rgba(139,195,74,.08);
}
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-button-default.dx-state-focused,
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-button-default.dx-state-hover {
  background-color: rgba(0,150,136,.08);
}
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-button-danger.dx-state-focused,
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-button-danger.dx-state-hover {
  background-color: rgba(244,67,54,.08);
}
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-state-focused,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-state-hover {
  background-color: rgba(0,0,0,.08);
}
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-button-success.dx-state-focused,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-button-success.dx-state-hover {
  background-color: rgba(139,195,74,.08);
}
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-button-default.dx-state-focused,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-button-default.dx-state-hover {
  background-color: rgba(0,150,136,.08);
}
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-button-danger.dx-state-focused,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-button-danger.dx-state-hover {
  background-color: rgba(244,67,54,.08);
}
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-item-selected.dx-button-normal,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-item-selected.dx-button-normal {
  background-color: rgba(0,0,0,.18);
}
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-item-selected.dx-button-normal.dx-state-focused,
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-item-selected.dx-button-normal.dx-state-hover,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-item-selected.dx-button-normal.dx-state-focused,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-item-selected.dx-button-normal.dx-state-hover {
  background-color: rgba(0,0,0,.12);
}
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-item-selected.dx-button-normal,
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-item-selected.dx-button-normal .dx-icon,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-item-selected.dx-button-normal,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-item-selected.dx-button-normal .dx-icon {
  color: rgba(0,0,0,.87);
}
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-item-selected.dx-button-success,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-item-selected.dx-button-success {
  background-color: rgba(139,195,74,.22);
}
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-item-selected.dx-button-success.dx-state-focused,
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-item-selected.dx-button-success.dx-state-hover,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-item-selected.dx-button-success.dx-state-focused,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-item-selected.dx-button-success.dx-state-hover {
  background-color: rgba(139,195,74,.14);
}
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-item-selected.dx-button-success,
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-item-selected.dx-button-success .dx-icon,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-item-selected.dx-button-success,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-item-selected.dx-button-success .dx-icon {
  color: #8bc34a;
}
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-item-selected.dx-button-default,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-item-selected.dx-button-default {
  background-color: rgba(0,150,136,.22);
}
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-item-selected.dx-button-default.dx-state-focused,
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-item-selected.dx-button-default.dx-state-hover,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-item-selected.dx-button-default.dx-state-focused,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-item-selected.dx-button-default.dx-state-hover {
  background-color: rgba(0,150,136,.14);
}
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-item-selected.dx-button-default,
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-item-selected.dx-button-default .dx-icon,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-item-selected.dx-button-default,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-item-selected.dx-button-default .dx-icon {
  color: #009688;
}
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-item-selected.dx-button-danger,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-item-selected.dx-button-danger {
  background-color: rgba(244,67,54,.22);
}
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-item-selected.dx-button-danger.dx-state-focused,
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-item-selected.dx-button-danger.dx-state-hover,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-item-selected.dx-button-danger.dx-state-focused,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-item-selected.dx-button-danger.dx-state-hover {
  background-color: rgba(244,67,54,.14);
}
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-item-selected.dx-button-danger,
.dx-buttongroup-item.dx-button.dx-button-mode-outlined.dx-item-selected.dx-button-danger .dx-icon,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-item-selected.dx-button-danger,
.dx-buttongroup-item.dx-button.dx-button-mode-text.dx-item-selected.dx-button-danger .dx-icon {
  color: #f44336;
}
.dx-rtl.dx-button-mode-contained.dx-button.dx-buttongroup-first-item,
.dx-rtl.dx-button-mode-outlined.dx-button.dx-buttongroup-first-item {
  border-radius: 0 4px 4px 0;
}
.dx-rtl.dx-button-mode-contained.dx-button.dx-buttongroup-last-item,
.dx-rtl.dx-button-mode-outlined.dx-button.dx-buttongroup-last-item {
  border-radius: 4px 0 0 4px;
}
.dx-rtl.dx-button-mode-contained.dx-button.dx-buttongroup-first-item.dx-buttongroup-last-item,
.dx-rtl.dx-button-mode-outlined.dx-button.dx-buttongroup-first-item.dx-buttongroup-last-item {
  border-radius: 4px;
}
.dx-rtl.dx-button-mode-text.dx-buttongroup-first-item {
  margin-left: 1px;
}
.dx-rtl.dx-button-mode-text.dx-buttongroup-last-item {
  margin-left: 0;
}
.dx-rtl.dx-button-mode-outlined.dx-buttongroup-first-item {
  border-left-width: 0;
}
.dx-rtl.dx-button-mode-outlined.dx-buttongroup-last-item {
  border-left-width: 1px;
}
.dx-scrollable-scrollbar-simulated {
  position: relative;
}
.dx-scrollable {
  display: block;
  height: 100%;
  min-height: 0;
}
.dx-scrollable:focus {
  outline: 0;
}
.dx-scrollable-native {
  -ms-overflow-style: -ms-autohiding-scrollbar;
  -ms-scroll-snap-type: proximity;
}
.dx-scrollable-native.dx-scrollable-wrapper > .dx-scrollable-container > .dx-scrollable-scrollbar {
  display: none;
}
.dx-scrollable-native.dx-scrollable-scrollbar-simulated .dx-scrollable-scrollbar {
  display: block;
}
.dx-scrollable-native > div.dx-scrollable-wrapper > .dx-scrollable-container,
.dx-scrollable-native.dx-scrollable-wrapper > .dx-scrollable-container {
  -webkit-overflow-scrolling: touch;
  position: relative;
  height: 100%;
}
.dx-scrollable-native.dx-scrollable-vertical,
.dx-scrollable-native.dx-scrollable-vertical > .dx-scrollable-wrapper > .dx-scrollable-container {
  -ms-touch-action: pan-y;
  touch-action: pan-y;
  overflow-x: hidden;
  overflow-y: auto;
}
.dx-scrollable-native.dx-scrollable-horizontal,
.dx-scrollable-native.dx-scrollable-horizontal > .dx-scrollable-wrapper > .dx-scrollable-container {
  -ms-touch-action: pan-x;
  touch-action: pan-x;
  float: none;
  overflow-x: auto;
  overflow-y: hidden;
}
.dx-scrollable-native.dx-scrollable-both,
.dx-scrollable-native.dx-scrollable-both > .dx-scrollable-wrapper > .dx-scrollable-container {
  -ms-touch-action: pan-y pan-x;
  touch-action: pan-y pan-x;
  float: none;
  overflow-x: auto;
  overflow-y: auto;
}
.dx-scrollable-native.dx-scrollable-disabled,
.dx-scrollable-native.dx-scrollable-disabled .dx-scrollable-container {
  -ms-touch-action: auto;
  touch-action: auto;
}
.dx-scrollable-native.dx-scrollable-scrollbars-hidden > .dx-scrollable-wrapper > .dx-scrollable-container {
  overflow: hidden;
}
.dx-scrollable-native.dx-scrollable-native-ios .dx-scrollable-content {
  min-height: 101%;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
.dx-scrollable-native.dx-scrollable-native-ios.dx-scrollable-horizontal .dx-scrollable-content {
  min-height: 0;
  padding: 0;
}
.dx-scrollable-native.dx-scrollable-native-generic {
  -ms-overflow-style: auto;
  overflow: hidden;
}
.dx-scrollable-native.dx-scrollable-native-generic .dx-scrollable-content {
  height: auto;
}
.dx-scrollable-native.dx-scrollable-native-android .dx-scrollable-content {
  -webkit-transform: none;
  transform: none;
  z-index: 0;
}
.dx-scrollable-scrollbar-simulated,
.dx-scrollable-scrollbar-simulated .dx-scrollable-container {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.dx-scrollable-scrollbar-simulated .dx-scrollable-container ::-webkit-scrollbar,
.dx-scrollable-scrollbar-simulated ::-webkit-scrollbar {
  display: none;
}
.dx-scrollable-container {
  -webkit-tap-highlight-color: transparent;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.dx-scrollable-container:focus {
  outline: 0;
}
.dx-scrollable-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}
.dx-scrollable-content {
  position: relative;
  min-height: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.dx-scrollable-content::after {
  display: block;
  content: "";
  clear: both;
}
.dx-scrollable-both .dx-scrollable-content,
.dx-scrollable-horizontal .dx-scrollable-content {
  display: block;
  float: left;
  min-width: 100%;
}
.dx-scrollable-scrollbar {
  position: absolute;
  pointer-events: auto;
}
.dx-scrollbar-vertical {
  top: 0;
  right: 0;
  height: 100%;
}
.dx-scrollbar-horizontal {
  bottom: 0;
  left: 0;
  width: 100%;
}
.dx-scrollable-scroll {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-transform: translate(0,0);
  padding: 2px 0 2px 2px;
  background-color: transparent;
  opacity: 1;
  overflow: hidden;
  -webkit-transition: opacity linear;
  transition: opacity linear;
}
.dx-scrollable-scroll.dx-state-invisible {
  display: block!important;
  background-color: rgba(0,0,0,0);
  opacity: 0;
  -webkit-transition: opacity .5s linear 1s;
  transition: opacity .5s linear 1s;
}
.dx-rtl .dx-scrollable,
.dx-rtl .dx-scrollable .dx-scrollable-container,
.dx-rtl .dx-scrollable .dx-scrollable-content,
.dx-rtl.dx-scrollable,
.dx-rtl.dx-scrollable .dx-scrollable-container,
.dx-rtl.dx-scrollable .dx-scrollable-content {
  direction: ltr;
}
.dx-scrollable-native.dx-rtl .dx-scrollable .dx-scrollable-container,
.dx-scrollable-native.dx-rtl .dx-scrollable .dx-scrollable-content,
.dx-scrollable-native.dx-rtl.dx-scrollable .dx-scrollable-container,
.dx-scrollable-native.dx-rtl.dx-scrollable .dx-scrollable-content {
  direction: rtl;
}
.dx-scrollable-native.dx-rtl .dx-scrollable .dx-scrollable-content,
.dx-scrollable-native.dx-rtl.dx-scrollable .dx-scrollable-content {
  float: right;
}
.dx-rtl .dx-scrollable .dx-scrollable-content > *,
.dx-rtl.dx-scrollable .dx-scrollable-content > * {
  direction: rtl;
}
.dx-rtl .dx-scrollable .dx-scrollable-scrollbar.dx-scrollbar-vertical,
.dx-rtl.dx-scrollable .dx-scrollable-scrollbar.dx-scrollbar-vertical {
  right: auto;
  left: 0;
}
.dx-rtl .dx-scrollable .dx-scrollable-scrollbar.dx-scrollbar-horizontal,
.dx-rtl.dx-scrollable .dx-scrollable-scrollbar.dx-scrollbar-horizontal {
  direction: ltr;
}
.dx-scrollable-simulated .dx-scrollable-content {
  overflow-anchor: none;
}
.dx-scrollable-simulated.dx-scrollable-disabled .dx-scrollable-scrollbar {
  pointer-events: none;
}
.dx-scrollable-content {
  -webkit-transform: none;
}
.dx-rtl .dx-scrollable-scroll {
  padding-left: 0;
  padding-right: 2px;
}
.dx-scrollable-scroll-content {
  width: 100%;
  height: 100%;
  background-color: rgba(191,191,191,.7);
  -webkit-box-shadow: 0 0 0 1px transparent;
  box-shadow: 0 0 0 1px transparent;
}
.dx-scrollbar-hoverable {
  background-color: transparent;
}
.dx-scrollbar-hoverable .dx-scrollable-scroll.dx-state-invisible {
  opacity: 1;
}
.dx-scrollbar-hoverable .dx-scrollable-scroll.dx-state-invisible .dx-scrollable-scroll-content {
  background-color: rgba(0,0,0,0);
  -webkit-box-shadow: 0 0 0 1px transparent;
  box-shadow: 0 0 0 1px transparent;
}
.dx-scrollbar-vertical .dx-scrollable-scroll {
  float: right;
  width: 6px;
}
.dx-scrollbar-vertical.dx-scrollbar-hoverable {
  width: 6px;
  -webkit-transition: width .2s linear .15s,background-color .2s linear .15s;
  transition: width .2s linear .15s,background-color .2s linear .15s;
}
.dx-scrollbar-vertical.dx-scrollbar-hoverable .dx-scrollable-scroll {
  -webkit-transition: background-color .5s linear 1s,width .2s linear 150ms;
  transition: background-color .5s linear 1s,width .2s linear 150ms;
}
.dx-scrollbar-vertical.dx-scrollbar-hoverable .dx-scrollable-scroll .dx-scrollable-scroll-content {
  -webkit-transition: background-color .15s linear .15s,-webkit-box-shadow .15s linear .15s;
  transition: box-shadow .15s linear .15s,background-color .15s linear .15s,-webkit-box-shadow .15s linear .15s;
}
.dx-scrollbar-vertical.dx-scrollbar-hoverable .dx-scrollable-scroll.dx-state-invisible {
  -webkit-transition: background-color .5s linear 1s,width .2s linear .15s;
  transition: background-color .5s linear 1s,width .2s linear .15s;
}
.dx-scrollbar-vertical.dx-scrollbar-hoverable .dx-scrollable-scroll.dx-state-invisible .dx-scrollable-scroll-content {
  -webkit-transition: background-color .5s linear 1s,-webkit-box-shadow .5s linear 1s;
  transition: box-shadow .5s linear 1s,background-color .5s linear 1s,-webkit-box-shadow .5s linear 1s;
}
.dx-scrollbar-vertical.dx-scrollbar-hoverable.dx-scrollable-scrollbar-active,
.dx-scrollbar-vertical.dx-scrollbar-hoverable.dx-scrollable-scrollbar-active .dx-scrollable-scroll,
.dx-scrollbar-vertical.dx-scrollbar-hoverable.dx-state-hover,
.dx-scrollbar-vertical.dx-scrollbar-hoverable.dx-state-hover .dx-scrollable-scroll {
  width: 13px;
}
.dx-scrollbar-horizontal .dx-scrollable-scroll {
  height: 6px;
}
.dx-rtl .dx-scrollbar-horizontal .dx-scrollable-scroll,
.dx-scrollbar-horizontal .dx-scrollable-scroll {
  padding-left: 2px;
  padding-right: 2px;
  padding-bottom: 0;
}
.dx-scrollbar-horizontal.dx-scrollbar-hoverable {
  height: 6px;
  -webkit-transition: height .2s linear .15s,background-color .2s linear .15s;
  transition: height .2s linear .15s,background-color .2s linear .15s;
}
.dx-scrollbar-horizontal.dx-scrollbar-hoverable .dx-scrollable-scroll {
  -webkit-transition: background-color .5s linear 1s,height .2s linear .15s;
  transition: background-color .5s linear 1s,height .2s linear .15s;
}
.dx-scrollbar-horizontal.dx-scrollbar-hoverable .dx-scrollable-scroll .dx-scrollable-scroll-content {
  -webkit-transition: background-color .15s linear .15s,-webkit-box-shadow .15s linear .15s;
  transition: box-shadow .15s linear .15s,background-color .15s linear .15s,-webkit-box-shadow .15s linear .15s;
}
.dx-scrollbar-horizontal.dx-scrollbar-hoverable .dx-scrollable-scroll.dx-state-invisible {
  -webkit-transition: background-color .5s linear 1s,height .2s linear .15s;
  transition: background-color .5s linear 1s,height .2s linear .15s;
}
.dx-scrollbar-horizontal.dx-scrollbar-hoverable .dx-scrollable-scroll.dx-state-invisible .dx-scrollable-scroll-content {
  -webkit-transition: background-color .5s linear 1s,-webkit-box-shadow .5s linear 1s;
  transition: box-shadow .5s linear 1s,background-color .5s linear 1s,-webkit-box-shadow .5s linear 1s;
}
.dx-scrollbar-horizontal.dx-scrollbar-hoverable.dx-scrollable-scrollbar-active,
.dx-scrollbar-horizontal.dx-scrollbar-hoverable.dx-scrollable-scrollbar-active .dx-scrollable-scroll,
.dx-scrollbar-horizontal.dx-scrollbar-hoverable.dx-state-hover,
.dx-scrollbar-horizontal.dx-scrollbar-hoverable.dx-state-hover .dx-scrollable-scroll {
  height: 13px;
}
.dx-scrollable-scrollbars-alwaysvisible.dx-scrollable-both > .dx-scrollable-wrapper > .dx-scrollable-container > .dx-scrollable-content,
.dx-scrollable-scrollbars-alwaysvisible.dx-scrollable-vertical > .dx-scrollable-wrapper > .dx-scrollable-container > .dx-scrollable-content {
  padding-right: 6px;
}
.dx-rtl .dx-scrollable-scrollbars-alwaysvisible.dx-scrollable-both > .dx-scrollable-wrapper > .dx-scrollable-container > .dx-scrollable-content,
.dx-rtl .dx-scrollable-scrollbars-alwaysvisible.dx-scrollable-vertical > .dx-scrollable-wrapper > .dx-scrollable-container > .dx-scrollable-content,
.dx-scrollable-scrollbars-alwaysvisible.dx-scrollable-both.dx-rtl > .dx-scrollable-wrapper > .dx-scrollable-container > .dx-scrollable-content,
.dx-scrollable-scrollbars-alwaysvisible.dx-scrollable-vertical.dx-rtl > .dx-scrollable-wrapper > .dx-scrollable-container > .dx-scrollable-content {
  padding-right: 0;
  padding-left: 6px;
}
.dx-scrollable-scrollbars-alwaysvisible.dx-scrollable-both > .dx-scrollable-wrapper > .dx-scrollable-container > .dx-scrollable-content,
.dx-scrollable-scrollbars-alwaysvisible.dx-scrollable-horizontal > .dx-scrollable-wrapper > .dx-scrollable-container > .dx-scrollable-content {
  padding-bottom: 6px;
}
.dx-scrollview-pull-down-text,
.dx-scrollview-scrollbottom-text {
  margin-left: 10px;
  top: 18px;
}
.dx-rtl .dx-scrollview-pull-down-text,
.dx-rtl .dx-scrollview-scrollbottom-text {
  margin-left: 0;
  margin-right: 10px;
}
.dx-rtl .dx-scrollable .dx-scrollable-scroll,
.dx-rtl.dx-scrollable .dx-scrollable-scroll {
  float: left;
}
.dx-scrollable-native.dx-scrollable-native-generic .dx-scrollview-top-pocket {
  position: absolute;
  display: none;
}
.dx-scrollable-native.dx-scrollable-native-android .dx-scrollview-top-pocket {
  width: 40px;
  height: 40px;
  left: 50%;
  position: absolute;
  z-index: 1;
}
.dx-scrollable-native.dx-scrollable-native-android .dx-scrollview-pull-down {
  background-image: none;
  position: static;
  height: 100%;
  width: 100%;
  left: -50%;
  margin-left: -20px;
  padding: 0;
  border-radius: 50%;
  background-color: #fff;
  -webkit-box-shadow: 0 1px 4px 0 rgba(0,0,0,.37);
  box-shadow: 0 1px 4px 0 rgba(0,0,0,.37);
}
.dx-scrollable-native.dx-scrollable-native-android .dx-scrollview-pull-down.dx-scrollview-pull-down-loading {
  -webkit-transition: -webkit-transform .1s linear;
  transition: transform .1s linear;
  transition: transform .1s linear,-webkit-transform .1s linear;
}
.dx-scrollable-native.dx-scrollable-native-android .dx-scrollview-pull-down .dx-scrollview-pull-down-indicator {
  position: relative;
  top: 0;
  padding: 4px;
  margin: 0;
  height: 100%;
  width: 100%;
  float: left;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.dx-scrollable-native.dx-scrollable-native-android .dx-scrollview-pull-down .dx-scrollview-pull-down-indicator .dx-loadindicator {
  float: left;
}
.dx-scrollable-native.dx-scrollable-native-android .dx-icon-pulldown {
  width: 100%;
  height: 100%;
  padding: 8px;
  font-size: 24px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-transition: opacity .2s;
  transition: opacity .2s;
}
.dx-scrollable-native.dx-scrollable-native-android .dx-scrollview-pull-down-loading.dx-scrollview-pull-down {
  -webkit-transition: top .2s ease-out;
  transition: top .2s ease-out;
}
.dx-scrollable-native.dx-scrollable-native-android .dx-scrollview-pull-down-image {
  position: absolute;
  margin: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-size: contain;
  -webkit-transition: opacity .2s;
  transition: opacity .2s;
}
.dx-scrollable-native.dx-scrollable-native-android .dx-scrollview-pull-down-loading .dx-icon-pulldown {
  display: none;
}
.dx-scrollable-native.dx-scrollable-native-ios .dx-scrollview-top-pocket {
  position: absolute;
  left: 0;
  width: 100%;
  overflow-y: auto;
  -webkit-transition: -webkit-transform .4s;
  transition: transform .4s;
  transition: transform .4s,-webkit-transform .4s;
  -webkit-transform: translate(0,0);
  transform: translate(0,0);
}
.dx-scrollable-native.dx-scrollable-native-ios .dx-scrollview-content {
  -webkit-transition: -webkit-transform .4s;
  transition: transform .4s;
  transition: transform .4s,-webkit-transform .4s;
  -webkit-transform: none;
  transform: none;
}
.dx-scrollable-native.dx-scrollable-native-win8.dx-scrollable-disabled {
  overflow-y: auto;
}
.dx-scrollable-native.dx-scrollable-native-win8.dx-scrollable-disabled .dx-scrollable-container {
  overflow-y: auto;
  overflow-x: hidden;
}
.dx-scrollable-native.dx-scrollable-native-win8.dx-scrollable-disabled .dx-scrollable-content,
.dx-scrollable-native.dx-scrollable-native-win8.dx-scrollable-disabled .dx-scrollview-content {
  overflow-y: hidden;
}
.dx-scrollable-native.dx-scrollable-native-win8 .dx-scrollable-container {
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
.dx-scrollable-native.dx-scrollable-native-win8 .dx-scrollview-bottom-pocket {
  width: 100%;
  text-align: center;
}
.dx-device-android-4 .dx-scrollable-native.dx-scrollable-native-android .dx-scrollview-pull-down-loading .dx-icon-pulldown {
  display: block;
}
.dx-scrollview-content {
  position: static;
}
.dx-scrollview-content::after,
.dx-scrollview-content::before {
  display: table;
  content: "";
  line-height: 0;
}
.dx-scrollview-content::after {
  clear: both;
}
.dx-scrollview-pull-down {
  text-align: center;
  width: 100%;
  height: 50px;
  padding: 15px 0;
  top: -80px;
  overflow: hidden;
  -webkit-transform: translate(0,0);
  transform: translate(0,0);
  -webkit-user-drag: none;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
.dx-scrollview-pull-down-container {
  display: inline-block;
  width: 49%;
  text-align: right;
}
.dx-scrollview-pull-down-indicator {
  opacity: 0;
  left: 0;
  top: 50%;
  display: inline-block;
  margin: -15px 20px 0 15px;
  -webkit-user-drag: none;
}
.dx-scrollview-pull-down-image {
  display: inline-block;
  vertical-align: middle;
  margin: 0 20px;
  width: 20px;
  height: 50px;
  background-size: contain;
  -webkit-user-drag: none;
  -webkit-transform: translate(0,0) rotate(0);
  transform: translate(0,0) rotate(0);
  -webkit-transition: -webkit-transform .2s linear;
  transition: transform .2s linear,-webkit-transform .2s linear;
}
.dx-scrollview-pull-down-text {
  display: inline;
  vertical-align: middle;
  position: relative;
  overflow: visible;
  -webkit-user-drag: none;
}
.dx-scrollview-pull-down-text div {
  position: absolute;
  left: 0;
  top: 0;
  white-space: nowrap;
  overflow: visible;
  opacity: 0;
}
.dx-scrollview-pull-down-text div.dx-scrollview-pull-down-text-visible {
  opacity: 1;
}
.dx-scrollview-pull-down-ready .dx-scrollview-pull-down-image {
  -webkit-transform: translate(0,0) rotate(-180deg);
  transform: translate(0,0) rotate(-180deg);
}
.dx-scrollview-pull-down-loading .dx-scrollview-pull-down-image {
  opacity: 0;
}
.dx-scrollview-pull-down-loading .dx-scrollview-pull-down-indicator {
  opacity: 1;
}
.dx-scrollview-scrollbottom {
  width: 100%;
  padding: 10px 0;
  overflow: hidden;
  text-align: center;
  -webkit-transform: translate(0,0);
  transform: translate(0,0);
}
.dx-scrollview-scrollbottom::before {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}
.dx-scrollview-scrollbottom-indicator {
  display: inline-block;
  margin: 0 10px 0 0;
  -webkit-user-drag: none;
}
.dx-scrollview-scrollbottom-text {
  display: inline-block;
  margin-top: -20px;
  vertical-align: middle;
  -webkit-user-drag: none;
}
.dx-scrollview-scrollbottom-end {
  opacity: 0;
}
.dx-rtl .dx-scrollable-native.dx-scrollable-native-ios .dx-scrollview-top-pocket,
.dx-scrollable-native.dx-rtl.dx-scrollable-native-ios .dx-scrollview-top-pocket {
  left: auto;
  right: 0;
}
.dx-rtl .dx-scrollview-pull-down-container {
  text-align: left;
}
.dx-rtl .dx-scrollview-pull-down-indicator,
.dx-rtl .dx-scrollview-pull-down-text div {
  left: auto;
  right: 0;
}
.dx-rtl .dx-scrollview-scrollbottom-indicator {
  margin: 0 0 0 10px;
}
.dx-scrollview-scrollbottom-loading .dx-scrollview-scrollbottom-image {
  width: 24px;
  height: 24px;
}
.dx-scrollview-pull-down-indicator,
.dx-scrollview-scrollbottom-indicator {
  margin-right: 0;
  height: 42px;
  width: 42px;
  border-radius: 21px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-shadow: 0 1px 3px 1px rgba(0,0,0,.37);
  box-shadow: 0 1px 3px 1px rgba(0,0,0,.37);
  opacity: 1;
}
.dx-scrollview-pull-down-indicator > .dx-loadindicator,
.dx-scrollview-scrollbottom-indicator > .dx-loadindicator {
  height: 24px;
  width: 24px;
}
.dx-scrollview-pull-down-indicator > .dx-loadindicator > .dx-loadindicator-wrapper,
.dx-scrollview-scrollbottom-indicator > .dx-loadindicator > .dx-loadindicator-wrapper {
  font-size: 24px;
}
.dx-scrollview-pull-down-indicator {
  position: relative;
  margin-left: 0;
  margin-top: -21px;
}
.dx-scrollview-pull-down-text > div {
  display: none;
}
.dx-scrollview-pull-down-text > div.dx-scrollview-pull-down-text-visible {
  display: block;
}
.dx-checkbox {
  display: inline-block;
  cursor: pointer;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}
.dx-checkbox.dx-state-readonly {
  cursor: default;
}
.dx-checkbox-icon {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  position: relative;
  background-position: 0 0;
  background-size: cover;
  background-repeat: no-repeat;
}
.dx-checkbox-container {
  overflow: hidden;
  white-space: nowrap;
  height: 100%;
  width: 100%;
  vertical-align: middle;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  text-overflow: clip;
}
.dx-checkbox-text {
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
  line-height: normal;
  padding-left: 5px;
}
.dx-rtl .dx-checkbox-text,
.dx-rtl.dx-checkbox-text {
  margin: 0;
  padding: 0 5px 0 0;
  text-align: right;
}
.dx-state-disabled .dx-checkbox,
.dx-state-disabled.dx-checkbox {
  cursor: default;
}
.dx-checkbox {
  line-height: 0;
}
.dx-checkbox .dx-checkbox-container {
  overflow: visible;
}
.dx-checkbox.dx-state-disabled,
.dx-checkbox.dx-state-readonly {
  border-color: rgba(0,0,0,.26);
}
.dx-checkbox.dx-state-active .dx-checkbox-icon::after,
.dx-checkbox.dx-state-focused .dx-checkbox-icon::after {
  background-color: rgba(0,0,0,.1);
  -webkit-transform: scale(1);
  transform: scale(1);
}
.dx-checkbox.dx-checkbox-checked.dx-state-active .dx-checkbox-icon::after,
.dx-checkbox.dx-checkbox-checked.dx-state-focused .dx-checkbox-icon::after,
.dx-checkbox.dx-checkbox-indeterminate.dx-state-active .dx-checkbox-icon::after,
.dx-checkbox.dx-checkbox-indeterminate.dx-state-focused .dx-checkbox-icon::after {
  background-color: rgba(0,150,136,.1);
  -webkit-transform: scale(1);
  transform: scale(1);
}
.dx-checkbox.dx-checkbox-checked.dx-state-disabled .dx-checkbox-icon,
.dx-checkbox.dx-checkbox-checked.dx-state-readonly .dx-checkbox-icon,
.dx-checkbox.dx-checkbox-indeterminate.dx-state-disabled .dx-checkbox-icon,
.dx-checkbox.dx-checkbox-indeterminate.dx-state-readonly .dx-checkbox-icon {
  background-color: rgba(0,0,0,.26);
}
.dx-checkbox-checked.dx-state-readonly.dx-state-focused .dx-checkbox-icon::after,
.dx-checkbox-indeterminate.dx-state-readonly.dx-state-focused .dx-checkbox-icon::after,
.dx-checkbox.dx-state-readonly.dx-state-focused .dx-checkbox-icon::after {
  background-color: rgba(0,0,0,.1);
  -webkit-transform: scale(1);
  transform: scale(1);
}
.dx-checkbox-icon {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(0,0,0,.54);
  border-radius: 2px;
}
.dx-checkbox-icon::after {
  content: "";
  width: 2.5em;
  height: 2.5em;
  top: 50%;
  left: 50%;
  margin-top: -1.25em;
  margin-left: -1.25em;
  border-radius: 50%;
  display: block;
  position: absolute;
  z-index: 1;
  -webkit-transform: scale(.5);
  transform: scale(.5);
  -webkit-transition: .4s cubic-bezier(.23, 1, .32, 1);
  transition: .4s cubic-bezier(.23, 1, .32, 1);
}
.dx-checkbox-icon::before {
  z-index: 2;
}
.dx-checkbox-checked .dx-checkbox-icon {
  color: #fff;
  background-color: #009688;
  border: none;
  font: 16px/1em DXIcons;
  text-align: center;
}
.dx-checkbox-checked .dx-checkbox-icon::before {
  content: "\\f005";
  position: relative;
  display: block;
  width: 1em;
  top: 50%;
  margin-top: -.5em;
  left: 50%;
  margin-left: -.5em;
}
.dx-rtl .dx-checkbox-checked .dx-checkbox-icon::before,
.dx-rtl.dx-checkbox-checked .dx-checkbox-icon::before {
  left: 0;
  margin-left: 0;
  right: 50%;
  margin-right: -.5em;
}
.dx-checkbox-indeterminate .dx-checkbox-icon {
  background-color: #009688;
  color: #fff;
  border: none;
  font: 20px/1em DXIcons;
  text-align: center;
}
.dx-checkbox-indeterminate .dx-checkbox-icon::before {
  content: "\\f074";
  position: relative;
  display: block;
  width: 1em;
  top: 50%;
  margin-top: -.5em;
  left: 50%;
  margin-left: -.5em;
}
.dx-rtl .dx-checkbox-indeterminate .dx-checkbox-icon::before,
.dx-rtl.dx-checkbox-indeterminate .dx-checkbox-icon::before {
  left: 0;
  margin-left: 0;
  right: 50%;
  margin-right: -.5em;
}
.dx-invalid .dx-checkbox-icon {
  border: 2px solid #f44336;
}
.dx-invalid.dx-state-focused .dx-checkbox-icon::after {
  background-color: rgba(244,67,54,.1);
  -webkit-transform: scale(1);
  transform: scale(1);
}
.dx-switch {
  display: inline-block;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-drag: none;
}
.dx-switch .dx-switch-wrapper {
  display: inline-block;
  text-align: left;
  height: 100%;
  width: 100%;
  position: relative;
  padding: 10px;
  left: -10px;
  top: -10px;
  overflow: hidden;
  vertical-align: middle;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
.dx-switch .dx-switch-wrapper::before {
  display: inline-block;
  height: 100%;
  content: "";
  vertical-align: middle;
}
.dx-switch-inner {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}
.dx-switch-container {
  display: inline-block;
  width: 100%;
  vertical-align: middle;
  height: 20px;
  overflow: visible;
  position: relative;
}
.dx-state-disabled .dx-switch,
.dx-state-disabled.dx-switch {
  cursor: default;
}
.dx-switch-handle,
.dx-switch-on-value .dx-switch-inner {
  -webkit-transform: translateX(0);
  transform: translateX(0);
}
.dx-switch-on-value .dx-switch-handle {
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
}
.dx-rtl .dx-switch-wrapper,
.dx-rtl.dx-switch-wrapper {
  text-align: right;
}
.dx-rtl .dx-switch-inner {
  -webkit-transform: translateX(50%);
  transform: translateX(50%);
}
.dx-rtl .dx-switch-handle {
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
}
.dx-rtl.dx-switch-on-value .dx-switch-handle {
  -webkit-transform: translateX(0);
  transform: translateX(0);
}
.dx-switch {
  width: 36px;
  height: 20px;
}
.dx-switch.dx-state-disabled .dx-switch-handle::before,
.dx-switch.dx-state-readonly .dx-switch-handle::before {
  background-color: #bdbdbd;
}
.dx-switch.dx-state-disabled .dx-switch-container::before,
.dx-switch.dx-state-readonly .dx-switch-container::before {
  background-color: rgba(0,0,0,.2);
}
.dx-switch-on-value.dx-state-readonly.dx-state-focused .dx-switch-handle::before,
.dx-switch.dx-state-active .dx-switch-handle::before,
.dx-switch.dx-state-focused .dx-switch-handle::before,
.dx-switch.dx-state-readonly.dx-state-focused .dx-switch-handle::before {
  -webkit-box-shadow: 0 0 0 10px rgba(0,0,0,.1);
  box-shadow: 0 0 0 10px rgba(0,0,0,.1);
  border-radius: 50%;
}
.dx-switch-container::before {
  position: absolute;
  content: "";
  width: 100%;
  height: 14px;
  border-radius: 500px;
  background-color: #9e9e9e;
  margin: 3px 0;
}
.dx-switch-inner {
  width: 200%;
  height: 100%;
}
.dx-switch-off,
.dx-switch-on {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  float: left;
  padding: 4px 0;
  width: 50%;
  height: 20px;
  color: transparent;
  text-align: center;
  line-height: 100%;
}
.dx-switch-on {
  background: 0 0;
}
.dx-switch-off {
  display: none;
  padding-bottom: 10px;
  background-color: transparent;
}
.dx-switch-handle {
  -ms-flex-preferred-size: 20px;
  flex-basis: 20px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  position: relative;
  float: left;
  width: 20px;
  height: 20px;
  background-color: #fafafa;
  -webkit-box-shadow: 0 1px 4px 0 rgba(0,0,0,.2);
  box-shadow: 0 1px 4px 0 rgba(0,0,0,.2);
  border-radius: 50%;
}
.dx-switch-handle::before {
  display: block;
  content: " ";
  width: 100%;
  height: 100%;
  background-color: #fafafa;
  border-radius: 50%;
  -webkit-transition: .4s cubic-bezier(.23, 1, .32, 1);
  transition: .4s cubic-bezier(.23, 1, .32, 1);
}
.dx-switch-on-value .dx-switch-container::before {
  background-color: rgba(0,150,136,.5);
}
.dx-switch-on-value .dx-switch-handle::before {
  background-color: #009688;
}
.dx-switch-on-value.dx-state-active .dx-switch-handle::before,
.dx-switch-on-value.dx-state-focused .dx-switch-handle::before {
  -webkit-box-shadow: 0 0 0 10px rgba(0,150,136,.1);
  box-shadow: 0 0 0 10px rgba(0,150,136,.1);
  border-radius: 50%;
}
.dx-rtl .dx-switch .dx-switch-off,
.dx-rtl .dx-switch .dx-switch-on,
.dx-switch.dx-rtl .dx-switch-off,
.dx-switch.dx-rtl .dx-switch-on {
  float: right;
  padding-left: 16px;
  padding-right: 2px;
}
.dx-rtl .dx-switch .dx-switch-off,
.dx-switch.dx-rtl .dx-switch-off {
  margin-left: 0;
}
.dx-rtl .dx-switch .dx-switch-handle,
.dx-switch.dx-rtl .dx-switch-handle {
  float: right;
  margin-left: 0;
  margin-right: -20px;
}
.dx-rtl .dx-switch .dx-switch-wrapper,
.dx-switch.dx-rtl .dx-switch-wrapper {
  left: 10px;
}
.dx-rtl .dx-switch .dx-switch-container,
.dx-switch.dx-rtl .dx-switch-container {
  margin: 0 0 0 -6px;
}
.dx-invalid.dx-switch .dx-switch-container::before {
  background-color: rgba(244,67,54,.5);
}
.dx-invalid.dx-switch-on-value:not(.dx-state-readonly):not(.dx-state-disabled) .dx-switch-container .dx-switch-handle::before {
  background-color: #f44336;
}
.dx-invalid.dx-switch-on-value:not(.dx-state-readonly):not(.dx-state-disabled).dx-state-active .dx-switch-container .dx-switch-handle::before,
.dx-invalid.dx-switch-on-value:not(.dx-state-readonly):not(.dx-state-disabled).dx-state-focused .dx-switch-container .dx-switch-handle::before {
  -webkit-box-shadow: 0 0 0 10px rgba(244,67,54,.1);
  box-shadow: 0 0 0 10px rgba(244,67,54,.1);
}
.dx-tabs {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  display: inline-block;
  width: 100%;
  text-align: center;
  table-layout: fixed;
}
.dx-tabs.dx-tabs-stretched {
  table-layout: auto;
}
.dx-tabs.dx-overflow-hidden {
  overflow: hidden;
}
.dx-tabs-wrapper {
  display: table-row;
}
.dx-tabs-scrollable .dx-tabs-wrapper {
  display: block;
  white-space: nowrap;
  height: 100%;
}
.dx-tabs-scrollable .dx-tab {
  height: 100%;
  display: inline-block;
}
.dx-tabs-scrollable .dx-tab::before {
  content: "";
  height: 100%;
  display: inline-block;
  vertical-align: middle;
}
.dx-tabs-scrollable .dx-scrollable-content {
  height: 100%;
}
.dx-tabs-nav-button {
  width: 25px;
  padding: 0;
  top: 0;
}
.dx-tabs-nav-button-left {
  left: 0;
}
.dx-tabs-nav-button-right {
  right: 0;
}
.dx-tabs-expanded {
  display: table;
}
.dx-tab {
  position: relative;
  display: table-cell;
  vertical-align: middle;
  cursor: pointer;
  white-space: nowrap;
}
.dx-tab a {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  color: #fff;
  text-decoration: none;
  opacity: .001;
}
.dx-tab-content {
  display: inline-block;
  max-width: 100%;
}
.dx-tab-text {
  display: inline-block;
  margin: 0 auto;
  text-align: center;
  max-width: 100%;
  -webkit-user-drag: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dx-tabs-item-badge {
  display: inline-block;
  vertical-align: top;
}
.dx-badge {
  padding: 3px 9px;
  border-radius: 14px;
  background-color: #009688;
  color: #fff;
  font-size: 12px;
  margin-left: 4px;
  line-height: normal;
  margin-top: 1px;
}
.dx-rtl .dx-badge {
  margin-left: 0;
  margin-right: 4px;
}
.dx-tabs {
  padding: 0;
  background-color: #fff;
  position: relative;
}
.dx-tabs .dx-inkripple {
  overflow: hidden;
}
.dx-tabs-nav-buttons .dx-tabs-scrollable {
  margin-right: 36px;
  margin-left: 36px;
}
.dx-tabs-nav-button {
  border: none;
  background-color: #fff;
  position: absolute;
  height: 48px;
  border-radius: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-tabs-nav-button.dx-button.dx-tabs-nav-button.dx-button-has-icon:not(.dx-button-has-text) {
  background-color: transparent;
  color: rgba(0,0,0,.54);
  -webkit-box-shadow: none;
  box-shadow: none;
  border-radius: 0;
}
.dx-tabs-nav-button.dx-button.dx-tabs-nav-button.dx-button-has-icon:not(.dx-button-has-text) .dx-icon {
  color: rgba(0,0,0,.54);
}
.dx-tabs-nav-button.dx-button.dx-tabs-nav-button.dx-button-has-icon:not(.dx-button-has-text).dx-state-active,
.dx-tabs-nav-button.dx-button.dx-tabs-nav-button.dx-button-has-icon:not(.dx-button-has-text).dx-state-focused,
.dx-tabs-nav-button.dx-button.dx-tabs-nav-button.dx-button-has-icon:not(.dx-button-has-text).dx-state-hover {
  background-color: rgba(0,107,97,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-tabs-nav-button.dx-button.dx-tabs-nav-button.dx-button-has-icon:not(.dx-button-has-text).dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-tabs-nav-button.dx-button.dx-tabs-nav-button.dx-button-has-icon:not(.dx-button-has-text).dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-tabs-nav-button.dx-button.dx-tabs-nav-button.dx-button-has-icon:not(.dx-button-has-text).dx-state-disabled .dx-button-text,
.dx-tabs-nav-button.dx-button.dx-tabs-nav-button.dx-button-has-icon:not(.dx-button-has-text).dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-tabs-nav-button.dx-button.dx-tabs-nav-button.dx-button-has-icon:not(.dx-button-has-text) .dx-inkripple-wave {
  background-color: rgba(0,107,97,.08);
}
.dx-tabs-nav-button .dx-button-content {
  padding: 0;
}
.dx-tabs-nav-button.dx-state-active {
  border: none;
}
.dx-tabs-nav-button.dx-state-disabled {
  opacity: 1;
  background-color: #fff;
}
.dx-tabs-nav-button.dx-state-disabled .dx-button-content {
  opacity: 0;
}
.dx-tab {
  padding: 12px 16px;
  min-width: 90px;
  background-color: #fff;
  color: rgba(0,0,0,.54);
}
.dx-tab.dx-state-hover {
  background-color: rgba(0,150,136,.08);
}
.dx-tab .dx-icon {
  display: block;
  -webkit-user-drag: none;
  color: rgba(0,0,0,.54);
  vertical-align: middle;
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  font-size: 24px;
  text-align: center;
  line-height: 24px;
  margin: 0 auto;
}
.dx-tab.dx-tab-selected,
.dx-tab.dx-tab-selected .dx-icon {
  color: #009688;
}
.dx-tab.dx-tab-selected::before {
  content: "";
  position: absolute;
  bottom: 0;
  height: 2px;
  left: 0;
  right: 0;
  background-color: #009688;
}
.dx-tab.dx-state-focused {
  background-color: rgba(0,150,136,.12);
}
.dx-tab.dx-state-disabled,
.dx-tab.dx-state-disabled .dx-icon {
  color: rgba(0,0,0,.13);
}
.dx-tab.dx-state-disabled.dx-tab-selected::before {
  content: "";
  position: absolute;
  bottom: 0;
  height: 2px;
  left: 0;
  right: 0;
  background-color: rgba(0,0,0,.13);
}
.dx-tab.dx-state-active,
.dx-tab.dx-state-active .dx-inkripple-wave {
  background-color: rgba(0,150,136,.16);
}
.dx-tab-content,
.dx-tab-text {
  vertical-align: middle;
  text-transform: uppercase;
  line-height: 24px;
  font-weight: 500;
}
.dx-overlay-wrapper {
  top: 0;
  pointer-events: none;
  width: 100%;
  height: 100%;
  left: 0;
  z-index: 1000;
  color: rgba(0,0,0,.87);
  font-weight: 400;
  font-size: 14px;
  font-family: Roboto,RobotoFallback,"Noto Kufi Arabic",Helvetica,Arial,sans-serif;
  line-height: 1.2857;
}
.dx-overlay-wrapper,
.dx-overlay-wrapper *,
.dx-overlay-wrapper ::after,
.dx-overlay-wrapper ::before,
.dx-overlay-wrapper::after,
.dx-overlay-wrapper::before {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.dx-overlay-shader {
  pointer-events: auto;
  background-color: rgba(0,0,0,.32);
}
.dx-overlay-content {
  position: absolute;
  pointer-events: auto;
  z-index: 1000;
  outline: 0;
  overflow: hidden;
}
.dx-overlay-content > .dx-template-wrapper {
  height: 100%;
  width: 100%;
}
.dx-device-android .dx-overlay-content {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.dx-device-android .dx-scrollable-native .dx-overlay-content {
  -webkit-backface-visibility: visible;
  backface-visibility: visible;
}
.dx-overlay-wrapper input,
.dx-overlay-wrapper textarea {
  font-family: Roboto,RobotoFallback,"Noto Kufi Arabic",Helvetica,Arial,sans-serif;
  line-height: 1.2857;
}
.dx-validationsummary-item {
  color: #f44336;
}
.dx-invalid-message > .dx-overlay-content {
  background-color: transparent;
  color: #f44336;
}
.dx-editor-filled .dx-invalid-message-bottom .dx-invalid-message > .dx-overlay-content,
.dx-editor-filled .dx-invalid-message-top .dx-invalid-message > .dx-overlay-content,
.dx-invalid-message-bottom .dx-invalid-message > .dx-overlay-content .dx-editor-outlined,
.dx-invalid-message-top .dx-invalid-message > .dx-overlay-content .dx-editor-outlined {
  padding-left: 16px;
  padding-right: 16px;
}
.dx-invalid-message-top .dx-invalid-message > .dx-overlay-content {
  padding: 0 0 6px;
}
.dx-invalid-message-right .dx-invalid-message > .dx-overlay-content {
  padding: 0 0 0 6px;
}
.dx-invalid-message-bottom .dx-invalid-message > .dx-overlay-content {
  padding: 6px 0 0;
}
.dx-invalid-message-left .dx-invalid-message > .dx-overlay-content {
  padding: 0 6px 0 0;
}
.dx-validationsummary > .dx-validationsummary-item:not(:last-child) {
  margin-bottom: 10px;
}
.dx-form-validation-summary {
  margin-top: 20px;
}
.dx-searchbox .dx-icon-search {
  display: block;
  position: relative;
  pointer-events: none;
}
.dx-searchbox .dx-icon-search::before {
  display: inline-block;
  overflow: hidden;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  position: static;
  text-indent: 0;
}
.dx-texteditor {
  display: block;
}
.dx-texteditor input::-ms-clear {
  display: none;
}
.dx-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  max-width: 100%;
  width: auto;
  height: 100%;
  text-align: left;
  cursor: text;
  pointer-events: none;
  color: rgba(148,148,148,.87);
  font-size: 16px;
}
.dx-placeholder::before {
  display: inline-block;
  vertical-align: middle;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  content: attr(DATA-DX_PLACEHOLDER);
  pointer-events: none;
  white-space: nowrap;
}
.dx-placeholder::after {
  content: " ";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}
.dx-texteditor-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.dx-texteditor-buttons-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: auto;
  -webkit-box-flex: 0;
  -ms-flex-positive: 0;
  flex-grow: 0;
  -ms-flex-preferred-size: content;
  flex-basis: content;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.dx-texteditor-input-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  position: relative;
  -webkit-box-align: baseline;
  -ms-flex-align: baseline;
  align-items: baseline;
}
.dx-texteditor-input {
  -webkit-appearance: none;
  width: 100%;
  height: 100%;
  outline: 0;
  border: 0;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
  margin: 0;
  background-color: transparent;
  color: rgba(0,0,0,.87);
  font-size: 16px;
}
.dx-texteditor-input:-webkit-autofill + .dx-placeholder {
  display: none!important;
}
.dx-texteditor-input:autofill + .dx-placeholder {
  display: none!important;
}
.dx-texteditor-input:-moz-ui-invalid {
  box-shadow: none;
}
.dx-show-clear-button {
  position: relative;
}
.dx-clear-button-area {
  height: 100%;
  width: 34px;
  position: relative;
  cursor: pointer;
  text-align: justify;
}
.dx-clear-button-area .dx-icon-clear {
  position: absolute;
  display: inline-block;
  background-size: contain;
}
.dx-texteditor-empty .dx-clear-button-area {
  display: none;
}
.dx-state-disabled .dx-placeholder {
  cursor: auto;
}
.dx-state-disabled .dx-clear-button-area {
  display: none;
}
.dx-state-disabled .dx-texteditor-input {
  opacity: 1;
}
.dx-rtl .dx-texteditor .dx-placeholder,
.dx-rtl.dx-texteditor .dx-placeholder {
  text-align: right;
  left: auto;
  right: 0;
}
.dx-device-android .dx-texteditor-input {
  -webkit-user-modify: read-write-plaintext-only;
}
.dx-texteditor {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  position: relative;
}
.dx-texteditor::before {
  left: 0;
  right: 0;
  bottom: 0;
  height: 0;
  width: 100%;
  content: "";
  position: absolute;
  z-index: 2;
  -webkit-transform: scale(0);
  transform: scale(0);
}
.dx-texteditor::after {
  left: 0;
  right: 0;
  bottom: 0;
  height: 0;
  width: 100%;
  content: "";
  position: absolute;
}
.dx-texteditor.dx-state-focused .dx-texteditor-label,
.dx-texteditor.dx-state-focused.dx-state-hover .dx-texteditor-label {
  color: #009688;
  font-size: 12px;
}
.dx-texteditor.dx-state-focused.dx-invalid .dx-texteditor-label,
.dx-texteditor.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label {
  color: #f44336;
}
.dx-texteditor.dx-state-active,
.dx-texteditor.dx-state-focused {
  background-color: rgba(0,0,0,.04);
}
.dx-texteditor.dx-state-active::before,
.dx-texteditor.dx-state-focused::before {
  border-bottom: 2px solid #009688;
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: -webkit-transform .6s cubic-bezier(.4, 0, .02, 1);
  transition: transform .6s cubic-bezier(.4, 0, .02, 1);
  transition: transform .6s cubic-bezier(.4, 0, .02, 1),-webkit-transform .6s cubic-bezier(.4, 0, .02, 1);
}
.dx-texteditor.dx-invalid.dx-editor-underlined .dx-texteditor-input,
.dx-texteditor.dx-valid.dx-editor-underlined .dx-texteditor-input {
  padding-right: 46px;
}
.dx-texteditor.dx-invalid.dx-editor-underlined.dx-rtl .dx-texteditor-input,
.dx-texteditor.dx-valid.dx-editor-underlined.dx-rtl .dx-texteditor-input {
  padding-left: 46px;
  padding-right: 0;
}
.dx-texteditor.dx-invalid.dx-editor-filled .dx-texteditor-input,
.dx-texteditor.dx-invalid.dx-editor-outlined .dx-texteditor-input,
.dx-texteditor.dx-valid.dx-editor-filled .dx-texteditor-input,
.dx-texteditor.dx-valid.dx-editor-outlined .dx-texteditor-input {
  padding-right: 62px;
}
.dx-texteditor.dx-invalid.dx-editor-filled.dx-rtl .dx-texteditor-input,
.dx-texteditor.dx-invalid.dx-editor-outlined.dx-rtl .dx-texteditor-input,
.dx-texteditor.dx-valid.dx-editor-filled.dx-rtl .dx-texteditor-input,
.dx-texteditor.dx-valid.dx-editor-outlined.dx-rtl .dx-texteditor-input {
  padding: 15px 16px 14px 62px;
}
.dx-texteditor.dx-invalid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-texteditor.dx-invalid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-texteditor.dx-valid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-texteditor.dx-valid.dx-editor-outlined .dx-texteditor-input-container::after {
  right: 12px;
}
.dx-rtl .dx-texteditor.dx-invalid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl .dx-texteditor.dx-invalid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-rtl .dx-texteditor.dx-valid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl .dx-texteditor.dx-valid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-rtl.dx-texteditor.dx-invalid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl.dx-texteditor.dx-invalid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-rtl.dx-texteditor.dx-valid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl.dx-texteditor.dx-valid.dx-editor-outlined .dx-texteditor-input-container::after {
  left: 12px;
  right: auto;
}
.dx-texteditor.dx-invalid .dx-texteditor-input-container::after,
.dx-texteditor.dx-valid .dx-texteditor-input-container::after {
  right: 6px;
}
.dx-rtl .dx-texteditor.dx-invalid .dx-texteditor-input-container::after,
.dx-rtl .dx-texteditor.dx-valid .dx-texteditor-input-container::after,
.dx-rtl.dx-texteditor.dx-invalid .dx-texteditor-input-container::after,
.dx-rtl.dx-texteditor.dx-valid .dx-texteditor-input-container::after {
  left: 6px;
  right: auto;
}
.dx-texteditor.dx-validation-pending.dx-editor-underlined .dx-texteditor-input {
  padding-right: 46px;
}
.dx-texteditor.dx-validation-pending.dx-editor-underlined.dx-rtl .dx-texteditor-input {
  padding-left: 46px;
  padding-right: 0;
}
.dx-texteditor.dx-validation-pending.dx-editor-filled .dx-texteditor-input,
.dx-texteditor.dx-validation-pending.dx-editor-outlined .dx-texteditor-input {
  padding-right: 62px;
}
.dx-texteditor.dx-validation-pending.dx-editor-filled.dx-rtl .dx-texteditor-input,
.dx-texteditor.dx-validation-pending.dx-editor-outlined.dx-rtl .dx-texteditor-input {
  padding: 15px 16px 14px 62px;
}
.dx-texteditor.dx-validation-pending.dx-editor-filled .dx-texteditor-input-container .dx-pending-indicator,
.dx-texteditor.dx-validation-pending.dx-editor-outlined .dx-texteditor-input-container .dx-pending-indicator {
  right: 12px;
}
.dx-rtl .dx-texteditor.dx-validation-pending.dx-editor-filled .dx-texteditor-input-container .dx-pending-indicator,
.dx-rtl .dx-texteditor.dx-validation-pending.dx-editor-outlined .dx-texteditor-input-container .dx-pending-indicator,
.dx-rtl.dx-texteditor.dx-validation-pending.dx-editor-filled .dx-texteditor-input-container .dx-pending-indicator,
.dx-rtl.dx-texteditor.dx-validation-pending.dx-editor-outlined .dx-texteditor-input-container .dx-pending-indicator {
  left: 12px;
  right: auto;
}
.dx-texteditor.dx-validation-pending .dx-texteditor-input-container .dx-pending-indicator {
  right: 6px;
}
.dx-rtl .dx-texteditor.dx-validation-pending .dx-texteditor-input-container .dx-pending-indicator,
.dx-rtl.dx-texteditor.dx-validation-pending .dx-texteditor-input-container .dx-pending-indicator {
  left: 6px;
  right: auto;
}
.dx-texteditor.dx-editor-filled .dx-placeholder::before,
.dx-texteditor.dx-editor-filled .dx-texteditor-input,
.dx-texteditor.dx-editor-outlined .dx-placeholder::before,
.dx-texteditor.dx-editor-outlined .dx-texteditor-input {
  padding: 15px 16px 14px;
}
.dx-texteditor.dx-editor-filled {
  background-color: rgba(0,0,0,.04);
}
.dx-texteditor.dx-editor-filled::after {
  border-bottom: 1px solid rgba(0,0,0,.42);
}
.dx-texteditor.dx-editor-filled.dx-state-hover {
  background-color: rgba(0,0,0,.07);
}
.dx-texteditor.dx-editor-filled.dx-state-hover::after {
  border-bottom-color: rgba(0,0,0,.87);
}
.dx-texteditor.dx-editor-filled.dx-state-disabled,
.dx-texteditor.dx-editor-filled.dx-state-readonly,
.dx-texteditor.dx-editor-filled.dx-state-readonly.dx-state-hover {
  background-color: rgba(0,0,0,.12);
}
.dx-texteditor.dx-editor-filled.dx-state-disabled .dx-texteditor-input,
.dx-texteditor.dx-editor-filled.dx-state-readonly .dx-texteditor-input,
.dx-texteditor.dx-editor-filled.dx-state-readonly.dx-state-hover .dx-texteditor-input {
  color: rgba(0,0,0,.5);
}
.dx-texteditor.dx-editor-underlined {
  background-color: transparent;
}
.dx-texteditor.dx-editor-underlined::after {
  border-bottom: 1px solid rgba(0,0,0,.42);
}
.dx-texteditor.dx-editor-underlined.dx-state-hover::after {
  border-bottom: 2px solid rgba(0,0,0,.87);
}
.dx-texteditor.dx-editor-underlined .dx-placeholder::before,
.dx-texteditor.dx-editor-underlined .dx-texteditor-input {
  padding: 7px 0 6px;
}
.dx-texteditor.dx-editor-underlined.dx-state-disabled::after,
.dx-texteditor.dx-editor-underlined.dx-state-readonly.dx-state-hover::after,
.dx-texteditor.dx-editor-underlined.dx-state-readonly::after {
  border-bottom-style: dotted;
  border-bottom-width: 1px;
}
.dx-texteditor.dx-editor-underlined.dx-invalid::after {
  border-bottom-color: rgba(244,67,54,.4);
}
.dx-texteditor.dx-editor-outlined {
  background-color: transparent;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 0 0 1px rgba(0,0,0,.42);
  box-shadow: inset 0 0 0 1px rgba(0,0,0,.42);
}
.dx-texteditor.dx-editor-outlined::before {
  display: none;
}
.dx-texteditor.dx-editor-outlined.dx-state-hover {
  -webkit-box-shadow: inset 0 0 0 1px rgba(0,0,0,.87);
  box-shadow: inset 0 0 0 1px rgba(0,0,0,.87);
}
.dx-texteditor.dx-editor-outlined.dx-state-disabled,
.dx-texteditor.dx-editor-outlined.dx-state-readonly {
  -webkit-box-shadow: inset 0 0 0 1px rgba(0,0,0,.5);
  box-shadow: inset 0 0 0 1px rgba(0,0,0,.5);
}
.dx-texteditor.dx-editor-outlined.dx-state-disabled .dx-texteditor-input,
.dx-texteditor.dx-editor-outlined.dx-state-readonly .dx-texteditor-input {
  color: rgba(0,0,0,.5);
}
.dx-texteditor.dx-editor-outlined.dx-state-focused {
  -webkit-box-shadow: inset 0 0 0 2px #009688;
  box-shadow: inset 0 0 0 2px #009688;
}
.dx-texteditor.dx-editor-outlined.dx-state-focused.dx-invalid {
  -webkit-box-shadow: inset 0 0 0 2px #f44336;
  box-shadow: inset 0 0 0 2px #f44336;
}
.dx-texteditor.dx-editor-outlined.dx-invalid {
  -webkit-box-shadow: inset 0 0 0 1px rgba(244,67,54,.4);
  box-shadow: inset 0 0 0 1px rgba(244,67,54,.4);
}
.dx-show-clear-button .dx-clear-button-area {
  width: 22px;
  min-width: 22px;
  right: 0;
}
.dx-show-clear-button .dx-icon-clear {
  color: rgba(117,117,117,.87);
  background-color: rgba(194,194,194,.87);
  border-radius: 50%;
  position: absolute;
  top: 50%;
  margin-top: -11px;
  width: 22px;
  height: 22px;
  background-position: 0 0;
  background-size: 22px 22px;
  padding: 0;
  font-size: 12px;
  text-align: center;
  line-height: 12px;
}
.dx-show-clear-button .dx-icon-clear::before {
  position: absolute;
  display: block;
  width: 12px;
  top: 50%;
  margin-top: -6px;
  left: 50%;
  margin-left: -6px;
}
.dx-show-clear-button:not(.dx-texteditor-empty).dx-invalid.dx-editor-underlined .dx-texteditor-input,
.dx-show-clear-button:not(.dx-texteditor-empty).dx-valid.dx-editor-underlined .dx-texteditor-input {
  padding-right: 46px;
}
.dx-show-clear-button:not(.dx-texteditor-empty).dx-invalid.dx-editor-underlined.dx-rtl .dx-texteditor-input,
.dx-show-clear-button:not(.dx-texteditor-empty).dx-valid.dx-editor-underlined.dx-rtl .dx-texteditor-input {
  padding-left: 46px;
  padding-right: 0;
}
.dx-show-clear-button:not(.dx-texteditor-empty).dx-invalid.dx-editor-filled .dx-texteditor-input,
.dx-show-clear-button:not(.dx-texteditor-empty).dx-invalid.dx-editor-outlined .dx-texteditor-input,
.dx-show-clear-button:not(.dx-texteditor-empty).dx-valid.dx-editor-filled .dx-texteditor-input,
.dx-show-clear-button:not(.dx-texteditor-empty).dx-valid.dx-editor-outlined .dx-texteditor-input {
  padding-right: 62px;
}
.dx-show-clear-button:not(.dx-texteditor-empty).dx-invalid.dx-editor-filled.dx-rtl .dx-texteditor-input,
.dx-show-clear-button:not(.dx-texteditor-empty).dx-invalid.dx-editor-outlined.dx-rtl .dx-texteditor-input,
.dx-show-clear-button:not(.dx-texteditor-empty).dx-valid.dx-editor-filled.dx-rtl .dx-texteditor-input,
.dx-show-clear-button:not(.dx-texteditor-empty).dx-valid.dx-editor-outlined.dx-rtl .dx-texteditor-input {
  padding: 15px 16px 14px 62px;
}
.dx-show-clear-button:not(.dx-texteditor-empty).dx-invalid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-show-clear-button:not(.dx-texteditor-empty).dx-invalid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-show-clear-button:not(.dx-texteditor-empty).dx-valid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-show-clear-button:not(.dx-texteditor-empty).dx-valid.dx-editor-outlined .dx-texteditor-input-container::after {
  right: 12px;
}
.dx-rtl .dx-show-clear-button:not(.dx-texteditor-empty).dx-invalid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl .dx-show-clear-button:not(.dx-texteditor-empty).dx-invalid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-rtl .dx-show-clear-button:not(.dx-texteditor-empty).dx-valid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl .dx-show-clear-button:not(.dx-texteditor-empty).dx-valid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-rtl.dx-show-clear-button:not(.dx-texteditor-empty).dx-invalid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl.dx-show-clear-button:not(.dx-texteditor-empty).dx-invalid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-rtl.dx-show-clear-button:not(.dx-texteditor-empty).dx-valid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl.dx-show-clear-button:not(.dx-texteditor-empty).dx-valid.dx-editor-outlined .dx-texteditor-input-container::after {
  left: 12px;
  right: auto;
}
.dx-show-clear-button:not(.dx-texteditor-empty).dx-invalid .dx-texteditor-input-container::after,
.dx-show-clear-button:not(.dx-texteditor-empty).dx-valid .dx-texteditor-input-container::after {
  right: 6px;
}
.dx-rtl .dx-show-clear-button:not(.dx-texteditor-empty).dx-invalid .dx-texteditor-input-container::after,
.dx-rtl .dx-show-clear-button:not(.dx-texteditor-empty).dx-valid .dx-texteditor-input-container::after,
.dx-rtl.dx-show-clear-button:not(.dx-texteditor-empty).dx-invalid .dx-texteditor-input-container::after,
.dx-rtl.dx-show-clear-button:not(.dx-texteditor-empty).dx-valid .dx-texteditor-input-container::after {
  left: 6px;
  right: auto;
}
.dx-show-clear-button:not(.dx-texteditor-empty).dx-validation-pending.dx-editor-underlined .dx-texteditor-input {
  padding-right: 46px;
}
.dx-show-clear-button:not(.dx-texteditor-empty).dx-validation-pending.dx-editor-underlined.dx-rtl .dx-texteditor-input {
  padding-left: 46px;
  padding-right: 0;
}
.dx-show-clear-button:not(.dx-texteditor-empty).dx-validation-pending.dx-editor-filled .dx-texteditor-input,
.dx-show-clear-button:not(.dx-texteditor-empty).dx-validation-pending.dx-editor-outlined .dx-texteditor-input {
  padding-right: 62px;
}
.dx-show-clear-button:not(.dx-texteditor-empty).dx-validation-pending.dx-editor-filled.dx-rtl .dx-texteditor-input,
.dx-show-clear-button:not(.dx-texteditor-empty).dx-validation-pending.dx-editor-outlined.dx-rtl .dx-texteditor-input {
  padding: 15px 16px 14px 62px;
}
.dx-show-clear-button:not(.dx-texteditor-empty).dx-validation-pending.dx-editor-filled .dx-texteditor-input-container .dx-pending-indicator,
.dx-show-clear-button:not(.dx-texteditor-empty).dx-validation-pending.dx-editor-outlined .dx-texteditor-input-container .dx-pending-indicator {
  right: 12px;
}
.dx-rtl .dx-show-clear-button:not(.dx-texteditor-empty).dx-validation-pending.dx-editor-filled .dx-texteditor-input-container .dx-pending-indicator,
.dx-rtl .dx-show-clear-button:not(.dx-texteditor-empty).dx-validation-pending.dx-editor-outlined .dx-texteditor-input-container .dx-pending-indicator,
.dx-rtl.dx-show-clear-button:not(.dx-texteditor-empty).dx-validation-pending.dx-editor-filled .dx-texteditor-input-container .dx-pending-indicator,
.dx-rtl.dx-show-clear-button:not(.dx-texteditor-empty).dx-validation-pending.dx-editor-outlined .dx-texteditor-input-container .dx-pending-indicator {
  left: 12px;
  right: auto;
}
.dx-show-clear-button:not(.dx-texteditor-empty).dx-validation-pending .dx-texteditor-input-container .dx-pending-indicator {
  right: 6px;
}
.dx-rtl .dx-show-clear-button:not(.dx-texteditor-empty).dx-validation-pending .dx-texteditor-input-container .dx-pending-indicator,
.dx-rtl.dx-show-clear-button:not(.dx-texteditor-empty).dx-validation-pending .dx-texteditor-input-container .dx-pending-indicator {
  left: 6px;
  right: auto;
}
.dx-invalid.dx-texteditor.dx-state-hover::after {
  border-bottom-color: rgba(244,67,54,.4);
}
.dx-invalid.dx-texteditor.dx-state-active::before,
.dx-invalid.dx-texteditor.dx-state-focused::before {
  border-bottom: 2px solid #f44336;
}
.dx-invalid.dx-texteditor.dx-show-invalid-badge .dx-texteditor-input-container::after {
  pointer-events: none;
  position: absolute;
  top: 50%;
  margin-top: -11px;
  width: 22px;
  height: 22px;
  text-align: center;
  line-height: 23px;
  font-size: 14px;
  font-weight: 500;
  background-color: #f44336;
  color: #fff;
  content: "!";
  border-radius: 50%;
}
.dx-editor-filled .dx-texteditor-buttons-container > .dx-button,
.dx-editor-filled .dx-texteditor-buttons-container > .dx-clear-button-area,
.dx-editor-outlined .dx-texteditor-buttons-container > .dx-button,
.dx-editor-outlined .dx-texteditor-buttons-container > .dx-clear-button-area,
.dx-editor-underlined .dx-texteditor-buttons-container > .dx-button,
.dx-editor-underlined .dx-texteditor-buttons-container > .dx-clear-button-area {
  margin-left: 5px;
  margin-right: 5px;
}
.dx-editor-filled .dx-texteditor-buttons-container:first-child > .dx-button:first-child,
.dx-editor-filled .dx-texteditor-buttons-container:first-child > .dx-clear-button-area:first-child,
.dx-editor-outlined .dx-texteditor-buttons-container:first-child > .dx-button:first-child,
.dx-editor-outlined .dx-texteditor-buttons-container:first-child > .dx-clear-button-area:first-child,
.dx-editor-underlined .dx-texteditor-buttons-container:first-child > .dx-button:first-child,
.dx-editor-underlined .dx-texteditor-buttons-container:first-child > .dx-clear-button-area:first-child {
  margin-left: 10px;
}
.dx-editor-filled .dx-texteditor-buttons-container:first-child > .dx-button:last-child,
.dx-editor-filled .dx-texteditor-buttons-container:first-child > .dx-clear-button-area:last-child,
.dx-editor-outlined .dx-texteditor-buttons-container:first-child > .dx-button:last-child,
.dx-editor-outlined .dx-texteditor-buttons-container:first-child > .dx-clear-button-area:last-child,
.dx-editor-underlined .dx-texteditor-buttons-container:first-child > .dx-button:last-child,
.dx-editor-underlined .dx-texteditor-buttons-container:first-child > .dx-clear-button-area:last-child {
  margin-right: 0;
}
.dx-editor-filled .dx-texteditor-buttons-container:last-child > .dx-button:first-child,
.dx-editor-filled .dx-texteditor-buttons-container:last-child > .dx-clear-button-area:first-child,
.dx-editor-outlined .dx-texteditor-buttons-container:last-child > .dx-button:first-child,
.dx-editor-outlined .dx-texteditor-buttons-container:last-child > .dx-clear-button-area:first-child,
.dx-editor-underlined .dx-texteditor-buttons-container:last-child > .dx-button:first-child,
.dx-editor-underlined .dx-texteditor-buttons-container:last-child > .dx-clear-button-area:first-child {
  margin-left: 0;
}
.dx-editor-filled .dx-texteditor-buttons-container:last-child > .dx-button:last-child,
.dx-editor-filled .dx-texteditor-buttons-container:last-child > .dx-clear-button-area:last-child,
.dx-editor-outlined .dx-texteditor-buttons-container:last-child > .dx-button:last-child,
.dx-editor-outlined .dx-texteditor-buttons-container:last-child > .dx-clear-button-area:last-child,
.dx-editor-underlined .dx-texteditor-buttons-container:last-child > .dx-button:last-child,
.dx-editor-underlined .dx-texteditor-buttons-container:last-child > .dx-clear-button-area:last-child {
  margin-right: 10px;
}
.dx-editor-filled .dx-texteditor-buttons-container:last-child > .dx-dropdowneditor-button:last-child,
.dx-editor-filled .dx-texteditor-buttons-container:last-child > .dx-numberbox-spin-container:last-child,
.dx-editor-outlined .dx-texteditor-buttons-container:last-child > .dx-dropdowneditor-button:last-child,
.dx-editor-outlined .dx-texteditor-buttons-container:last-child > .dx-numberbox-spin-container:last-child,
.dx-editor-underlined .dx-texteditor-buttons-container:last-child > .dx-dropdowneditor-button:last-child,
.dx-editor-underlined .dx-texteditor-buttons-container:last-child > .dx-numberbox-spin-container:last-child {
  margin-right: 8px;
}
.dx-editor-filled .dx-texteditor-buttons-container:last-child > .dx-clear-button-area + div:empty:last-child,
.dx-editor-filled .dx-texteditor-buttons-container:last-child > .dx-clear-button-area:last-child,
.dx-editor-outlined .dx-texteditor-buttons-container:last-child > .dx-clear-button-area + div:empty:last-child,
.dx-editor-outlined .dx-texteditor-buttons-container:last-child > .dx-clear-button-area:last-child,
.dx-editor-underlined .dx-texteditor-buttons-container:last-child > .dx-clear-button-area + div:empty:last-child,
.dx-editor-underlined .dx-texteditor-buttons-container:last-child > .dx-clear-button-area:last-child {
  margin-right: 12px;
}
.dx-rtl.dx-editor-filled .dx-texteditor-buttons-container:first-child > .dx-button:first-child,
.dx-rtl.dx-editor-filled .dx-texteditor-buttons-container:first-child > .dx-clear-button-area:first-child,
.dx-rtl.dx-editor-outlined .dx-texteditor-buttons-container:first-child > .dx-button:first-child,
.dx-rtl.dx-editor-outlined .dx-texteditor-buttons-container:first-child > .dx-clear-button-area:first-child,
.dx-rtl.dx-editor-underlined .dx-texteditor-buttons-container:first-child > .dx-button:first-child,
.dx-rtl.dx-editor-underlined .dx-texteditor-buttons-container:first-child > .dx-clear-button-area:first-child {
  margin-left: 5px;
  margin-right: 10px;
}
.dx-rtl.dx-editor-filled .dx-texteditor-buttons-container:first-child > .dx-button:last-child,
.dx-rtl.dx-editor-filled .dx-texteditor-buttons-container:first-child > .dx-clear-button-area:last-child,
.dx-rtl.dx-editor-outlined .dx-texteditor-buttons-container:first-child > .dx-button:last-child,
.dx-rtl.dx-editor-outlined .dx-texteditor-buttons-container:first-child > .dx-clear-button-area:last-child,
.dx-rtl.dx-editor-underlined .dx-texteditor-buttons-container:first-child > .dx-button:last-child,
.dx-rtl.dx-editor-underlined .dx-texteditor-buttons-container:first-child > .dx-clear-button-area:last-child {
  margin-left: 0;
  margin-right: 5px;
}
.dx-rtl.dx-editor-filled .dx-texteditor-buttons-container:first-child > .dx-button:first-child:last-child,
.dx-rtl.dx-editor-filled .dx-texteditor-buttons-container:first-child > .dx-clear-button-area:first-child:last-child,
.dx-rtl.dx-editor-outlined .dx-texteditor-buttons-container:first-child > .dx-button:first-child:last-child,
.dx-rtl.dx-editor-outlined .dx-texteditor-buttons-container:first-child > .dx-clear-button-area:first-child:last-child,
.dx-rtl.dx-editor-underlined .dx-texteditor-buttons-container:first-child > .dx-button:first-child:last-child,
.dx-rtl.dx-editor-underlined .dx-texteditor-buttons-container:first-child > .dx-clear-button-area:first-child:last-child {
  margin-left: 0;
  margin-right: 10px;
}
.dx-rtl.dx-editor-filled .dx-texteditor-buttons-container:last-child > .dx-button:first-child,
.dx-rtl.dx-editor-filled .dx-texteditor-buttons-container:last-child > .dx-clear-button-area:first-child,
.dx-rtl.dx-editor-outlined .dx-texteditor-buttons-container:last-child > .dx-button:first-child,
.dx-rtl.dx-editor-outlined .dx-texteditor-buttons-container:last-child > .dx-clear-button-area:first-child,
.dx-rtl.dx-editor-underlined .dx-texteditor-buttons-container:last-child > .dx-button:first-child,
.dx-rtl.dx-editor-underlined .dx-texteditor-buttons-container:last-child > .dx-clear-button-area:first-child {
  margin-left: 5px;
  margin-right: 0;
}
.dx-rtl.dx-editor-filled .dx-texteditor-buttons-container:last-child > .dx-button:last-child,
.dx-rtl.dx-editor-filled .dx-texteditor-buttons-container:last-child > .dx-clear-button-area:last-child,
.dx-rtl.dx-editor-outlined .dx-texteditor-buttons-container:last-child > .dx-button:last-child,
.dx-rtl.dx-editor-outlined .dx-texteditor-buttons-container:last-child > .dx-clear-button-area:last-child,
.dx-rtl.dx-editor-underlined .dx-texteditor-buttons-container:last-child > .dx-button:last-child,
.dx-rtl.dx-editor-underlined .dx-texteditor-buttons-container:last-child > .dx-clear-button-area:last-child {
  margin-left: 10px;
  margin-right: 5px;
}
.dx-rtl.dx-editor-filled .dx-texteditor-buttons-container:last-child > .dx-dropdowneditor-button:last-child,
.dx-rtl.dx-editor-filled .dx-texteditor-buttons-container:last-child > .dx-numberbox-spin-container:last-child,
.dx-rtl.dx-editor-outlined .dx-texteditor-buttons-container:last-child > .dx-dropdowneditor-button:last-child,
.dx-rtl.dx-editor-outlined .dx-texteditor-buttons-container:last-child > .dx-numberbox-spin-container:last-child,
.dx-rtl.dx-editor-underlined .dx-texteditor-buttons-container:last-child > .dx-dropdowneditor-button:last-child,
.dx-rtl.dx-editor-underlined .dx-texteditor-buttons-container:last-child > .dx-numberbox-spin-container:last-child {
  margin-left: 8px;
  margin-right: 0;
}
.dx-rtl.dx-editor-filled .dx-texteditor-buttons-container:last-child > .dx-clear-button-area + div:empty:last-child,
.dx-rtl.dx-editor-filled .dx-texteditor-buttons-container:last-child > .dx-clear-button-area:last-child,
.dx-rtl.dx-editor-outlined .dx-texteditor-buttons-container:last-child > .dx-clear-button-area + div:empty:last-child,
.dx-rtl.dx-editor-outlined .dx-texteditor-buttons-container:last-child > .dx-clear-button-area:last-child,
.dx-rtl.dx-editor-underlined .dx-texteditor-buttons-container:last-child > .dx-clear-button-area + div:empty:last-child,
.dx-rtl.dx-editor-underlined .dx-texteditor-buttons-container:last-child > .dx-clear-button-area:last-child {
  margin-left: 12px;
  margin-right: 0;
}
.dx-texteditor-label {
  position: absolute;
  font-size: 12px;
  color: rgba(148,148,148,.87);
  white-space: nowrap;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  pointer-events: none;
  cursor: text;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  top: 0;
  left: 0;
}
.dx-texteditor-label .dx-label {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.dx-texteditor-label .dx-label span {
  overflow: hidden;
  text-overflow: ellipsis;
  width: auto;
  max-width: 100%;
  display: block;
  margin-bottom: -1px;
}
.dx-invalid .dx-texteditor-label {
  color: #f44336;
}
.dx-rtl .dx-texteditor-label {
  left: auto;
  right: 0;
}
.dx-editor-filled .dx-texteditor-label .dx-label-after,
.dx-editor-filled .dx-texteditor-label .dx-label-before {
  display: block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  min-width: 16px;
}
.dx-editor-filled.dx-texteditor-with-floating-label,
.dx-editor-filled.dx-texteditor-with-label {
  position: relative;
}
.dx-editor-filled.dx-texteditor-with-floating-label .dx-texteditor-input,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-lookup .dx-lookup-field,
.dx-editor-filled.dx-texteditor-with-label .dx-texteditor-input,
.dx-editor-filled.dx-texteditor-with-label.dx-lookup .dx-lookup-field {
  padding-top: 21px;
  padding-bottom: 8px;
}
.dx-editor-filled.dx-texteditor-with-floating-label.dx-textarea .dx-texteditor-container,
.dx-editor-filled.dx-texteditor-with-label.dx-textarea .dx-texteditor-container {
  padding-top: 21px;
}
.dx-editor-filled.dx-texteditor-with-floating-label.dx-textarea .dx-placeholder::before,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-textarea .dx-texteditor-input,
.dx-editor-filled.dx-texteditor-with-label.dx-textarea .dx-placeholder::before,
.dx-editor-filled.dx-texteditor-with-label.dx-textarea .dx-texteditor-input {
  padding-top: 0;
}
.dx-editor-filled.dx-texteditor-with-floating-label.dx-textarea .dx-texteditor-label,
.dx-editor-filled.dx-texteditor-with-label.dx-textarea .dx-texteditor-label {
  top: 7px;
}
.dx-editor-filled.dx-texteditor-with-floating-label .dx-texteditor-label,
.dx-editor-filled.dx-texteditor-with-label .dx-texteditor-label {
  font-size: 12px;
  height: 12px;
  line-height: 12px;
  top: 7px;
  margin-top: 0;
}
.dx-editor-filled.dx-texteditor-with-floating-label .dx-placeholder::before,
.dx-editor-filled.dx-texteditor-with-label .dx-placeholder::before {
  padding-top: 21px;
}
.dx-editor-filled.dx-texteditor-with-floating-label.dx-lookup-empty .dx-placeholder,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly .dx-placeholder,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-texteditor-empty .dx-placeholder,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly .dx-placeholder {
  display: none;
}
.dx-editor-filled.dx-texteditor-with-floating-label.dx-lookup-empty .dx-lookup-field,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly .dx-lookup-field,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-texteditor-empty .dx-lookup-field,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly .dx-lookup-field {
  font-size: 0;
}
.dx-editor-filled.dx-texteditor-with-floating-label.dx-lookup-empty .dx-texteditor-label,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly .dx-texteditor-label,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-texteditor-empty .dx-texteditor-label,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly .dx-texteditor-label {
  -webkit-transition: font-size .2s cubic-bezier(0, 0, .2, 1),top .2s cubic-bezier(0, 0, .2, 1),-webkit-transform .2s cubic-bezier(0, 0, .2, 1);
  transition: transform .2s cubic-bezier(0, 0, .2, 1),font-size .2s cubic-bezier(0, 0, .2, 1),top .2s cubic-bezier(0, 0, .2, 1),-webkit-transform .2s cubic-bezier(0, 0, .2, 1);
  font-size: 16px;
  top: 50%;
  margin-top: -8px;
  height: 16px;
  line-height: 16px;
}
.dx-editor-filled.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea .dx-texteditor-label,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-lookup-empty.dx-textarea .dx-texteditor-label,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea .dx-texteditor-label,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-textarea .dx-texteditor-label {
  top: 21px;
  margin-top: 0;
  font-size: 16px;
  line-height: 16px;
  height: 16px;
}
.dx-editor-filled.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea .dx-placeholder,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-lookup-empty.dx-textarea .dx-placeholder,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea .dx-placeholder,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-textarea .dx-placeholder {
  display: none;
}
.dx-editor-filled.dx-texteditor-with-floating-label.dx-dropdowneditor-active .dx-placeholder,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-state-focused .dx-placeholder,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused .dx-placeholder {
  display: block;
}
.dx-editor-filled.dx-texteditor-with-floating-label.dx-dropdowneditor-active .dx-lookup-field,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-state-focused .dx-lookup-field,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused .dx-lookup-field {
  font-size: 16px;
}
.dx-editor-filled.dx-texteditor-with-floating-label.dx-dropdowneditor-active .dx-texteditor-label,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-state-focused .dx-texteditor-label,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused .dx-texteditor-label {
  font-size: 12px;
  height: 12px;
  line-height: 12px;
  top: 7px;
  margin-top: 0;
}
.dx-editor-filled.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-textarea .dx-texteditor-label,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-state-focused.dx-textarea .dx-texteditor-label,
.dx-editor-filled.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-textarea .dx-texteditor-label {
  top: 7px;
}
.dx-editor-outlined .dx-texteditor-label {
  top: 0;
  left: 0;
  right: 0;
}
.dx-editor-outlined .dx-texteditor-label .dx-label {
  padding: 0;
}
.dx-editor-outlined .dx-texteditor-label .dx-label span {
  position: relative;
  font-size: 16px;
  top: 0;
  margin-top: 0;
}
.dx-editor-outlined .dx-texteditor-label .dx-label-after,
.dx-editor-outlined .dx-texteditor-label .dx-label-before {
  display: block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.dx-editor-outlined .dx-texteditor-label .dx-label-before {
  border-radius: 4px 0 0 4px;
  min-width: 16px;
}
.dx-editor-outlined .dx-texteditor-label .dx-label-after {
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  min-width: 16px;
  border-radius: 0 4px 4px 0;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty .dx-texteditor-label {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty .dx-texteditor-label .dx-label {
  padding: 0 2px;
  height: 100%;
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset 1px 0 transparent,inset -1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset 1px 0 transparent,inset -1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty .dx-texteditor-label .dx-label span {
  -webkit-transition: font-size .2s cubic-bezier(0, 0, .2, 1),top .2s cubic-bezier(0, 0, .2, 1),-webkit-transform .2s cubic-bezier(0, 0, .2, 1);
  transition: transform .2s cubic-bezier(0, 0, .2, 1),font-size .2s cubic-bezier(0, 0, .2, 1),top .2s cubic-bezier(0, 0, .2, 1),-webkit-transform .2s cubic-bezier(0, 0, .2, 1);
  -webkit-transform: translate(0,0);
  transform: translate(0,0);
  font-size: 16px;
  top: 50%;
  margin-top: -8px;
  height: 16px;
  line-height: 16px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.42);
  box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.42);
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 rgba(0,0,0,.42),inset 1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 rgba(0,0,0,.42),inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-textarea .dx-texteditor-label .dx-label span {
  top: 15px;
  margin-top: 0;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty .dx-placeholder {
  display: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty .dx-lookup-field {
  font-size: 0;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 rgba(0,0,0,.42),inset 1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 rgba(0,0,0,.42),inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.42);
  box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.42);
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-invalid {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-invalid .dx-texteditor-label {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-invalid .dx-texteditor-label .dx-label {
  padding: 0 2px;
  height: 100%;
  -webkit-box-shadow: inset 0 -1px rgba(244,67,54,.4),inset 0 1px rgba(244,67,54,.4),inset 1px 0 transparent,inset -1px 0 transparent;
  box-shadow: inset 0 -1px rgba(244,67,54,.4),inset 0 1px rgba(244,67,54,.4),inset 1px 0 transparent,inset -1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-invalid .dx-texteditor-label .dx-label span {
  -webkit-transition: font-size .2s cubic-bezier(0, 0, .2, 1),top .2s cubic-bezier(0, 0, .2, 1),-webkit-transform .2s cubic-bezier(0, 0, .2, 1);
  transition: transform .2s cubic-bezier(0, 0, .2, 1),font-size .2s cubic-bezier(0, 0, .2, 1),top .2s cubic-bezier(0, 0, .2, 1),-webkit-transform .2s cubic-bezier(0, 0, .2, 1);
  -webkit-transform: translate(0,0);
  transform: translate(0,0);
  font-size: 16px;
  top: 50%;
  margin-top: -8px;
  height: 16px;
  line-height: 16px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-invalid .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px rgba(244,67,54,.4),inset 0 1px rgba(244,67,54,.4),inset -1px 0 transparent,inset 1px 0 rgba(244,67,54,.4);
  box-shadow: inset 0 -1px rgba(244,67,54,.4),inset 0 1px rgba(244,67,54,.4),inset -1px 0 transparent,inset 1px 0 rgba(244,67,54,.4);
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-invalid .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px rgba(244,67,54,.4),inset 0 1px rgba(244,67,54,.4),inset -1px 0 rgba(244,67,54,.4),inset 1px 0 transparent;
  box-shadow: inset 0 -1px rgba(244,67,54,.4),inset 0 1px rgba(244,67,54,.4),inset -1px 0 rgba(244,67,54,.4),inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-invalid.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-invalid.dx-textarea .dx-texteditor-label .dx-label span {
  top: 15px;
  margin-top: 0;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-invalid .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-invalid .dx-placeholder {
  display: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-invalid .dx-lookup-field {
  font-size: 0;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-invalid .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px rgba(244,67,54,.4),inset 0 1px rgba(244,67,54,.4),inset -1px 0 rgba(244,67,54,.4),inset 1px 0 transparent;
  box-shadow: inset 0 -1px rgba(244,67,54,.4),inset 0 1px rgba(244,67,54,.4),inset -1px 0 rgba(244,67,54,.4),inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-invalid .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px rgba(244,67,54,.4),inset 0 1px rgba(244,67,54,.4),inset -1px 0 transparent,inset 1px 0 rgba(244,67,54,.4);
  box-shadow: inset 0 -1px rgba(244,67,54,.4),inset 0 1px rgba(244,67,54,.4),inset -1px 0 transparent,inset 1px 0 rgba(244,67,54,.4);
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover .dx-texteditor-label {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label {
  padding: 0 2px;
  height: 100%;
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.5),inset 0 1px rgba(0,0,0,.5),inset 1px 0 transparent,inset -1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.5),inset 0 1px rgba(0,0,0,.5),inset 1px 0 transparent,inset -1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label span {
  -webkit-transition: font-size .2s cubic-bezier(0, 0, .2, 1),top .2s cubic-bezier(0, 0, .2, 1),-webkit-transform .2s cubic-bezier(0, 0, .2, 1);
  transition: transform .2s cubic-bezier(0, 0, .2, 1),font-size .2s cubic-bezier(0, 0, .2, 1),top .2s cubic-bezier(0, 0, .2, 1),-webkit-transform .2s cubic-bezier(0, 0, .2, 1);
  -webkit-transform: translate(0,0);
  transform: translate(0,0);
  font-size: 16px;
  top: 50%;
  margin-top: -8px;
  height: 16px;
  line-height: 16px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.5),inset 0 1px rgba(0,0,0,.5),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.5);
  box-shadow: inset 0 -1px rgba(0,0,0,.5),inset 0 1px rgba(0,0,0,.5),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.5);
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.5),inset 0 1px rgba(0,0,0,.5),inset -1px 0 rgba(0,0,0,.5),inset 1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.5),inset 0 1px rgba(0,0,0,.5),inset -1px 0 rgba(0,0,0,.5),inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea .dx-texteditor-label .dx-label span {
  top: 15px;
  margin-top: 0;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover .dx-placeholder {
  display: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover .dx-lookup-field {
  font-size: 0;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.5),inset 0 1px rgba(0,0,0,.5),inset -1px 0 rgba(0,0,0,.5),inset 1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.5),inset 0 1px rgba(0,0,0,.5),inset -1px 0 rgba(0,0,0,.5),inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.5),inset 0 1px rgba(0,0,0,.5),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.5);
  box-shadow: inset 0 -1px rgba(0,0,0,.5),inset 0 1px rgba(0,0,0,.5),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.5);
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused .dx-texteditor-label {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label {
  padding: 0 2px;
  height: 100%;
  -webkit-box-shadow: inset 0 -2px #009688,inset 0 2px #009688,inset 2px 0 transparent,inset -2px 0 transparent;
  box-shadow: inset 0 -2px #009688,inset 0 2px #009688,inset 2px 0 transparent,inset -2px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label span {
  -webkit-transition: font-size .2s cubic-bezier(0, 0, .2, 1),top .2s cubic-bezier(0, 0, .2, 1),-webkit-transform .2s cubic-bezier(0, 0, .2, 1);
  transition: transform .2s cubic-bezier(0, 0, .2, 1),font-size .2s cubic-bezier(0, 0, .2, 1),top .2s cubic-bezier(0, 0, .2, 1),-webkit-transform .2s cubic-bezier(0, 0, .2, 1);
  -webkit-transform: translate(0,0);
  transform: translate(0,0);
  font-size: 16px;
  top: 50%;
  margin-top: -8px;
  height: 16px;
  line-height: 16px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -2px #009688,inset 0 2px #009688,inset -2px 0 transparent,inset 2px 0 #009688;
  box-shadow: inset 0 -2px #009688,inset 0 2px #009688,inset -2px 0 transparent,inset 2px 0 #009688;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -2px #009688,inset 0 2px #009688,inset -2px 0 #009688,inset 2px 0 transparent;
  box-shadow: inset 0 -2px #009688,inset 0 2px #009688,inset -2px 0 #009688,inset 2px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-textarea .dx-texteditor-label .dx-label span {
  top: 15px;
  margin-top: 0;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused .dx-placeholder {
  display: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused .dx-lookup-field {
  font-size: 0;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -2px #009688,inset 0 2px #009688,inset -2px 0 #009688,inset 2px 0 transparent;
  box-shadow: inset 0 -2px #009688,inset 0 2px #009688,inset -2px 0 #009688,inset 2px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -2px #009688,inset 0 2px #009688,inset -2px 0 transparent,inset 2px 0 #009688;
  box-shadow: inset 0 -2px #009688,inset 0 2px #009688,inset -2px 0 transparent,inset 2px 0 #009688;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label {
  padding: 0 2px;
  height: 100%;
  -webkit-box-shadow: inset 0 -2px #f44336,inset 0 2px #f44336,inset 2px 0 transparent,inset -2px 0 transparent;
  box-shadow: inset 0 -2px #f44336,inset 0 2px #f44336,inset 2px 0 transparent,inset -2px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label span {
  -webkit-transition: font-size .2s cubic-bezier(0, 0, .2, 1),top .2s cubic-bezier(0, 0, .2, 1),-webkit-transform .2s cubic-bezier(0, 0, .2, 1);
  transition: transform .2s cubic-bezier(0, 0, .2, 1),font-size .2s cubic-bezier(0, 0, .2, 1),top .2s cubic-bezier(0, 0, .2, 1),-webkit-transform .2s cubic-bezier(0, 0, .2, 1);
  -webkit-transform: translate(0,0);
  transform: translate(0,0);
  font-size: 16px;
  top: 50%;
  margin-top: -8px;
  height: 16px;
  line-height: 16px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -2px #f44336,inset 0 2px #f44336,inset -2px 0 transparent,inset 2px 0 #f44336;
  box-shadow: inset 0 -2px #f44336,inset 0 2px #f44336,inset -2px 0 transparent,inset 2px 0 #f44336;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -2px #f44336,inset 0 2px #f44336,inset -2px 0 #f44336,inset 2px 0 transparent;
  box-shadow: inset 0 -2px #f44336,inset 0 2px #f44336,inset -2px 0 #f44336,inset 2px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused.dx-invalid.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused.dx-invalid.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused.dx-invalid.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused.dx-invalid.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid.dx-textarea .dx-texteditor-label .dx-label span {
  top: 15px;
  margin-top: 0;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused.dx-invalid .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused.dx-invalid .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused.dx-invalid .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused.dx-invalid .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid .dx-placeholder {
  display: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid .dx-lookup-field {
  font-size: 0;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -2px #f44336,inset 0 2px #f44336,inset -2px 0 #f44336,inset 2px 0 transparent;
  box-shadow: inset 0 -2px #f44336,inset 0 2px #f44336,inset -2px 0 #f44336,inset 2px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-disabled.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-state-hover.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -2px #f44336,inset 0 2px #f44336,inset -2px 0 transparent,inset 2px 0 #f44336;
  box-shadow: inset 0 -2px #f44336,inset 0 2px #f44336,inset -2px 0 transparent,inset 2px 0 #f44336;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover .dx-texteditor-label {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover .dx-texteditor-label .dx-label {
  padding: 0 2px;
  height: 100%;
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset 1px 0 transparent,inset -1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset 1px 0 transparent,inset -1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover .dx-texteditor-label .dx-label span {
  -webkit-transition: font-size .2s cubic-bezier(0, 0, .2, 1),top .2s cubic-bezier(0, 0, .2, 1),-webkit-transform .2s cubic-bezier(0, 0, .2, 1);
  transition: transform .2s cubic-bezier(0, 0, .2, 1),font-size .2s cubic-bezier(0, 0, .2, 1),top .2s cubic-bezier(0, 0, .2, 1),-webkit-transform .2s cubic-bezier(0, 0, .2, 1);
  -webkit-transform: translate(0,0);
  transform: translate(0,0);
  font-size: 16px;
  top: 50%;
  margin-top: -8px;
  height: 16px;
  line-height: 16px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.87);
  box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.87);
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 rgba(0,0,0,.87),inset 1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 rgba(0,0,0,.87),inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-textarea .dx-texteditor-label .dx-label span {
  top: 15px;
  margin-top: 0;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover .dx-placeholder {
  display: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover .dx-lookup-field {
  font-size: 0;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 rgba(0,0,0,.87),inset 1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 rgba(0,0,0,.87),inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.87);
  box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.87);
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-dropdowneditor-active,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-dropdowneditor-active {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-dropdowneditor-active .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-dropdowneditor-active .dx-texteditor-label {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-dropdowneditor-active .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-dropdowneditor-active .dx-texteditor-label .dx-label {
  height: 100%;
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px transparent,inset 1px 0 transparent,inset -1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px transparent,inset 1px 0 transparent,inset -1px 0 transparent;
  padding: 0 4px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-dropdowneditor-active .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-dropdowneditor-active .dx-texteditor-label .dx-label span {
  -webkit-transform: translate(0,-6px);
  transform: translate(0,-6px);
  font-size: 12px;
  margin-top: 0;
  top: 0;
  height: 13px;
  line-height: 12px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-dropdowneditor-active .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-dropdowneditor-active .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.87);
  box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.87);
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-dropdowneditor-active .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-dropdowneditor-active .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 rgba(0,0,0,.87),inset 1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 rgba(0,0,0,.87),inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-dropdowneditor-active .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-dropdowneditor-active .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-dropdowneditor-active .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-dropdowneditor-active .dx-texteditor-label .dx-label-before {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-dropdowneditor-active .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-dropdowneditor-active .dx-lookup-field {
  font-size: 16px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-dropdowneditor-active.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-dropdowneditor-active.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-dropdowneditor-active .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-dropdowneditor-active .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 rgba(0,0,0,.87),inset 1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 rgba(0,0,0,.87),inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-dropdowneditor-active.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-dropdowneditor-active.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-dropdowneditor-active .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-dropdowneditor-active .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.87);
  box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.87);
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-invalid {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-invalid .dx-texteditor-label {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label {
  padding: 0 2px;
  height: 100%;
  -webkit-box-shadow: inset 0 -1px #f44336,inset 0 1px #f44336,inset 1px 0 transparent,inset -1px 0 transparent;
  box-shadow: inset 0 -1px #f44336,inset 0 1px #f44336,inset 1px 0 transparent,inset -1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label span {
  -webkit-transition: font-size .2s cubic-bezier(0, 0, .2, 1),top .2s cubic-bezier(0, 0, .2, 1),-webkit-transform .2s cubic-bezier(0, 0, .2, 1);
  transition: transform .2s cubic-bezier(0, 0, .2, 1),font-size .2s cubic-bezier(0, 0, .2, 1),top .2s cubic-bezier(0, 0, .2, 1),-webkit-transform .2s cubic-bezier(0, 0, .2, 1);
  -webkit-transform: translate(0,0);
  transform: translate(0,0);
  font-size: 16px;
  top: 50%;
  margin-top: -8px;
  height: 16px;
  line-height: 16px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px #f44336,inset 0 1px #f44336,inset -1px 0 transparent,inset 1px 0 #f44336;
  box-shadow: inset 0 -1px #f44336,inset 0 1px #f44336,inset -1px 0 transparent,inset 1px 0 #f44336;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px #f44336,inset 0 1px #f44336,inset -1px 0 #f44336,inset 1px 0 transparent;
  box-shadow: inset 0 -1px #f44336,inset 0 1px #f44336,inset -1px 0 #f44336,inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-invalid.dx-textarea .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-invalid.dx-textarea .dx-texteditor-label .dx-label span {
  top: 15px;
  margin-top: 0;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-invalid .dx-placeholder,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-invalid .dx-placeholder {
  display: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-invalid .dx-lookup-field {
  font-size: 0;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px #f44336,inset 0 1px #f44336,inset -1px 0 #f44336,inset 1px 0 transparent;
  box-shadow: inset 0 -1px #f44336,inset 0 1px #f44336,inset -1px 0 #f44336,inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px #f44336,inset 0 1px #f44336,inset -1px 0 transparent,inset 1px 0 #f44336;
  box-shadow: inset 0 -1px #f44336,inset 0 1px #f44336,inset -1px 0 transparent,inset 1px 0 #f44336;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-dropdowneditor-active,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-dropdowneditor-active {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-dropdowneditor-active .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-dropdowneditor-active .dx-texteditor-label {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-dropdowneditor-active .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-dropdowneditor-active .dx-texteditor-label .dx-label {
  height: 100%;
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px transparent,inset 1px 0 transparent,inset -1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px transparent,inset 1px 0 transparent,inset -1px 0 transparent;
  padding: 0 4px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-dropdowneditor-active .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-dropdowneditor-active .dx-texteditor-label .dx-label span {
  -webkit-transform: translate(0,-6px);
  transform: translate(0,-6px);
  font-size: 12px;
  margin-top: 0;
  top: 0;
  height: 13px;
  line-height: 12px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-dropdowneditor-active .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-dropdowneditor-active .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.42);
  box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.42);
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-dropdowneditor-active .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-dropdowneditor-active .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 rgba(0,0,0,.42),inset 1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 rgba(0,0,0,.42),inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-dropdowneditor-active .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-dropdowneditor-active .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-dropdowneditor-active .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-dropdowneditor-active .dx-texteditor-label .dx-label-before {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-dropdowneditor-active .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-dropdowneditor-active .dx-lookup-field {
  font-size: 16px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-dropdowneditor-active.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-dropdowneditor-active.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-dropdowneditor-active .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-dropdowneditor-active .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 rgba(0,0,0,.42),inset 1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 rgba(0,0,0,.42),inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-dropdowneditor-active.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-dropdowneditor-active.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-dropdowneditor-active .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-dropdowneditor-active .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.42);
  box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.42);
}
.dx-editor-outlined.dx-texteditor-with-floating-label,
.dx-editor-outlined.dx-texteditor-with-label {
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: 0;
  position: relative;
  margin-top: 6px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea .dx-texteditor-input-container,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea .dx-texteditor-input-container {
  padding-top: 15px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea .dx-texteditor-input-container .dx-texteditor-input,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea .dx-texteditor-input-container .dx-texteditor-input {
  padding-top: 0;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-disabled,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly.dx-state-hover,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-disabled,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly.dx-state-hover {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-disabled .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly.dx-state-hover .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-disabled .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly.dx-state-hover .dx-texteditor-label {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-disabled .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-disabled .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label {
  height: 100%;
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.5),inset 0 1px transparent,inset 1px 0 transparent,inset -1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.5),inset 0 1px transparent,inset 1px 0 transparent,inset -1px 0 transparent;
  padding: 0 4px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-disabled .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-disabled .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label span {
  -webkit-transform: translate(0,-6px);
  transform: translate(0,-6px);
  font-size: 12px;
  margin-top: 0;
  top: 0;
  height: 13px;
  line-height: 12px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-disabled .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-disabled .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.5),inset 0 1px rgba(0,0,0,.5),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.5);
  box-shadow: inset 0 -1px rgba(0,0,0,.5),inset 0 1px rgba(0,0,0,.5),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.5);
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-disabled .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-disabled .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.5),inset 0 1px rgba(0,0,0,.5),inset -1px 0 rgba(0,0,0,.5),inset 1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.5),inset 0 1px rgba(0,0,0,.5),inset -1px 0 rgba(0,0,0,.5),inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-disabled .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-disabled .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-disabled .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-disabled .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label-before {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-disabled .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly.dx-state-hover .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-disabled .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly.dx-state-hover .dx-lookup-field {
  font-size: 16px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-disabled.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-disabled.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-disabled .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-state-disabled .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.5),inset 0 1px rgba(0,0,0,.5),inset -1px 0 rgba(0,0,0,.5),inset 1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.5),inset 0 1px rgba(0,0,0,.5),inset -1px 0 rgba(0,0,0,.5),inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-disabled.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-disabled.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-disabled .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-state-disabled .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-state-readonly.dx-state-hover .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.5),inset 0 1px rgba(0,0,0,.5),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.5);
  box-shadow: inset 0 -1px rgba(0,0,0,.5),inset 0 1px rgba(0,0,0,.5),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.5);
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-label.dx-invalid {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-invalid .dx-texteditor-label {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-invalid .dx-texteditor-label .dx-label {
  height: 100%;
  -webkit-box-shadow: inset 0 -1px rgba(244,67,54,.4),inset 0 1px transparent,inset 1px 0 transparent,inset -1px 0 transparent;
  box-shadow: inset 0 -1px rgba(244,67,54,.4),inset 0 1px transparent,inset 1px 0 transparent,inset -1px 0 transparent;
  padding: 0 4px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-label.dx-invalid .dx-texteditor-label .dx-label span {
  -webkit-transform: translate(0,-6px);
  transform: translate(0,-6px);
  font-size: 12px;
  margin-top: 0;
  top: 0;
  height: 13px;
  line-height: 12px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-invalid .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px rgba(244,67,54,.4),inset 0 1px rgba(244,67,54,.4),inset -1px 0 transparent,inset 1px 0 rgba(244,67,54,.4);
  box-shadow: inset 0 -1px rgba(244,67,54,.4),inset 0 1px rgba(244,67,54,.4),inset -1px 0 transparent,inset 1px 0 rgba(244,67,54,.4);
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-invalid .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px rgba(244,67,54,.4),inset 0 1px rgba(244,67,54,.4),inset -1px 0 rgba(244,67,54,.4),inset 1px 0 transparent;
  box-shadow: inset 0 -1px rgba(244,67,54,.4),inset 0 1px rgba(244,67,54,.4),inset -1px 0 rgba(244,67,54,.4),inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-invalid .dx-texteditor-label .dx-label-before {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-label.dx-invalid .dx-lookup-field {
  font-size: 16px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-invalid .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px rgba(244,67,54,.4),inset 0 1px rgba(244,67,54,.4),inset -1px 0 rgba(244,67,54,.4),inset 1px 0 transparent;
  box-shadow: inset 0 -1px rgba(244,67,54,.4),inset 0 1px rgba(244,67,54,.4),inset -1px 0 rgba(244,67,54,.4),inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-invalid .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px rgba(244,67,54,.4),inset 0 1px rgba(244,67,54,.4),inset -1px 0 transparent,inset 1px 0 rgba(244,67,54,.4);
  box-shadow: inset 0 -1px rgba(244,67,54,.4),inset 0 1px rgba(244,67,54,.4),inset -1px 0 transparent,inset 1px 0 rgba(244,67,54,.4);
}
.dx-editor-outlined.dx-texteditor-with-floating-label .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-label .dx-texteditor-label {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-label .dx-texteditor-label .dx-label {
  padding: 0 4px;
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px transparent,inset 1px 0 transparent,inset -1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px transparent,inset 1px 0 transparent,inset -1px 0 transparent;
  margin-left: -2px;
  margin-right: -2px;
  border-radius: 1px;
  -webkit-clip-path: inset(-12px 1px -1px 1px);
  clip-path: inset(-12px 1px -1px 1px);
}
.dx-editor-outlined.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-label .dx-texteditor-label .dx-label span {
  -webkit-transform: translate(0,-6px);
  transform: translate(0,-6px);
  font-size: 12px;
  top: 0;
  margin-top: 0;
  height: 13px;
  line-height: 12px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.42);
  box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.42);
  -webkit-clip-path: inset(-1px 1px -1px -1px);
  clip-path: inset(-1px 1px -1px -1px);
}
.dx-editor-outlined.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 rgba(0,0,0,.42),inset 1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 rgba(0,0,0,.42),inset 1px 0 transparent;
  -webkit-clip-path: inset(-1px -1px -1px 1px);
  clip-path: inset(-1px -1px -1px 1px);
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label .dx-texteditor-label .dx-label-before {
  border-radius: 0 4px 4px 0;
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 rgba(0,0,0,.42),inset 1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 rgba(0,0,0,.42),inset 1px 0 transparent;
  -webkit-clip-path: inset(-1px -1px -1px 1px);
  clip-path: inset(-1px -1px -1px 1px);
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label .dx-texteditor-label .dx-label-after {
  border-radius: 4px 0 0 4px;
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.42);
  box-shadow: inset 0 -1px rgba(0,0,0,.42),inset 0 1px rgba(0,0,0,.42),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.42);
  -webkit-clip-path: inset(-1px 1px -1px -1px);
  clip-path: inset(-1px 1px -1px -1px);
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover .dx-texteditor-label {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover .dx-texteditor-label .dx-label {
  height: 100%;
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px transparent,inset 1px 0 transparent,inset -1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px transparent,inset 1px 0 transparent,inset -1px 0 transparent;
  padding: 0 4px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover .dx-texteditor-label .dx-label span {
  -webkit-transform: translate(0,-6px);
  transform: translate(0,-6px);
  font-size: 12px;
  margin-top: 0;
  top: 0;
  height: 13px;
  line-height: 12px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.87);
  box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.87);
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 rgba(0,0,0,.87),inset 1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 rgba(0,0,0,.87),inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover .dx-texteditor-label .dx-label-before {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover .dx-lookup-field {
  font-size: 16px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-state-hover .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 rgba(0,0,0,.87),inset 1px 0 transparent;
  box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 rgba(0,0,0,.87),inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-state-hover .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.87);
  box-shadow: inset 0 -1px rgba(0,0,0,.87),inset 0 1px rgba(0,0,0,.87),inset -1px 0 transparent,inset 1px 0 rgba(0,0,0,.87);
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover.dx-invalid {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover.dx-invalid .dx-texteditor-label {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label {
  height: 100%;
  -webkit-box-shadow: inset 0 -1px #f44336,inset 0 1px transparent,inset 1px 0 transparent,inset -1px 0 transparent;
  box-shadow: inset 0 -1px #f44336,inset 0 1px transparent,inset 1px 0 transparent,inset -1px 0 transparent;
  padding: 0 4px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label span {
  -webkit-transform: translate(0,-6px);
  transform: translate(0,-6px);
  font-size: 12px;
  margin-top: 0;
  top: 0;
  height: 13px;
  line-height: 12px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px #f44336,inset 0 1px #f44336,inset -1px 0 transparent,inset 1px 0 #f44336;
  box-shadow: inset 0 -1px #f44336,inset 0 1px #f44336,inset -1px 0 transparent,inset 1px 0 #f44336;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px #f44336,inset 0 1px #f44336,inset -1px 0 #f44336,inset 1px 0 transparent;
  box-shadow: inset 0 -1px #f44336,inset 0 1px #f44336,inset -1px 0 #f44336,inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover.dx-invalid .dx-lookup-field {
  font-size: 16px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -1px #f44336,inset 0 1px #f44336,inset -1px 0 #f44336,inset 1px 0 transparent;
  box-shadow: inset 0 -1px #f44336,inset 0 1px #f44336,inset -1px 0 #f44336,inset 1px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-hover.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -1px #f44336,inset 0 1px #f44336,inset -1px 0 transparent,inset 1px 0 #f44336;
  box-shadow: inset 0 -1px #f44336,inset 0 1px #f44336,inset -1px 0 transparent,inset 1px 0 #f44336;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover .dx-texteditor-label {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label {
  height: 100%;
  -webkit-box-shadow: inset 0 -2px #009688,inset 0 2px transparent,inset 2px 0 transparent,inset -2px 0 transparent;
  box-shadow: inset 0 -2px #009688,inset 0 2px transparent,inset 2px 0 transparent,inset -2px 0 transparent;
  padding: 0 4px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label span {
  -webkit-transform: translate(0,-6px);
  transform: translate(0,-6px);
  font-size: 12px;
  margin-top: 0;
  top: 0;
  height: 13px;
  line-height: 12px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -2px #009688,inset 0 2px #009688,inset -2px 0 transparent,inset 2px 0 #009688;
  box-shadow: inset 0 -2px #009688,inset 0 2px #009688,inset -2px 0 transparent,inset 2px 0 #009688;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -2px #009688,inset 0 2px #009688,inset -2px 0 #009688,inset 2px 0 transparent;
  box-shadow: inset 0 -2px #009688,inset 0 2px #009688,inset -2px 0 #009688,inset 2px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-before {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover .dx-lookup-field {
  font-size: 16px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -2px #009688,inset 0 2px #009688,inset -2px 0 #009688,inset 2px 0 transparent;
  box-shadow: inset 0 -2px #009688,inset 0 2px #009688,inset -2px 0 #009688,inset 2px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -2px #009688,inset 0 2px #009688,inset -2px 0 transparent,inset 2px 0 #009688;
  box-shadow: inset 0 -2px #009688,inset 0 2px #009688,inset -2px 0 transparent,inset 2px 0 #009688;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-invalid,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label {
  height: 100%;
  -webkit-box-shadow: inset 0 -2px #f44336,inset 0 2px transparent,inset 2px 0 transparent,inset -2px 0 transparent;
  box-shadow: inset 0 -2px #f44336,inset 0 2px transparent,inset 2px 0 transparent,inset -2px 0 transparent;
  padding: 0 4px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label span,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label span {
  -webkit-transform: translate(0,-6px);
  transform: translate(0,-6px);
  font-size: 12px;
  margin-top: 0;
  top: 0;
  height: 13px;
  line-height: 12px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -2px #f44336,inset 0 2px #f44336,inset -2px 0 transparent,inset 2px 0 #f44336;
  box-shadow: inset 0 -2px #f44336,inset 0 2px #f44336,inset -2px 0 transparent,inset 2px 0 #f44336;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -2px #f44336,inset 0 2px #f44336,inset -2px 0 #f44336,inset 2px 0 transparent;
  box-shadow: inset 0 -2px #f44336,inset 0 2px #f44336,inset -2px 0 #f44336,inset 2px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before {
  height: 100%;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-invalid .dx-lookup-field,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid .dx-lookup-field {
  font-size: 16px;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-before,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-before {
  -webkit-box-shadow: inset 0 -2px #f44336,inset 0 2px #f44336,inset -2px 0 #f44336,inset 2px 0 transparent;
  box-shadow: inset 0 -2px #f44336,inset 0 2px #f44336,inset -2px 0 #f44336,inset 2px 0 transparent;
}
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid.dx-rtl .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-dropdowneditor-active.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-invalid .dx-texteditor-label .dx-label-after,
.dx-rtl .dx-editor-outlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-state-hover.dx-invalid .dx-texteditor-label .dx-label-after {
  -webkit-box-shadow: inset 0 -2px #f44336,inset 0 2px #f44336,inset -2px 0 transparent,inset 2px 0 #f44336;
  box-shadow: inset 0 -2px #f44336,inset 0 2px #f44336,inset -2px 0 transparent,inset 2px 0 #f44336;
}
.dx-editor-underlined.dx-texteditor-with-floating-label .dx-texteditor-label,
.dx-editor-underlined.dx-texteditor-with-label .dx-texteditor-label {
  -webkit-transform: translate(0,0);
  transform: translate(0,0);
  top: 0;
  margin-top: 0;
  height: 12px;
  line-height: 12px;
}
.dx-editor-underlined.dx-texteditor-with-floating-label .dx-placeholder::before,
.dx-editor-underlined.dx-texteditor-with-label .dx-placeholder::before {
  padding-top: 16px;
}
.dx-editor-underlined.dx-texteditor-with-floating-label .dx-texteditor-input,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-lookup .dx-lookup-field,
.dx-editor-underlined.dx-texteditor-with-label .dx-texteditor-input,
.dx-editor-underlined.dx-texteditor-with-label.dx-lookup .dx-lookup-field {
  padding-top: 16px;
  padding-bottom: 7px;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-textarea .dx-texteditor-container,
.dx-editor-underlined.dx-texteditor-with-label.dx-textarea .dx-texteditor-container {
  padding-top: 16px;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-textarea .dx-placeholder::before,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-textarea .dx-texteditor-input,
.dx-editor-underlined.dx-texteditor-with-label.dx-textarea .dx-placeholder::before,
.dx-editor-underlined.dx-texteditor-with-label.dx-textarea .dx-texteditor-input {
  padding-top: 0;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-textarea .dx-texteditor-label,
.dx-editor-underlined.dx-texteditor-with-label.dx-textarea .dx-texteditor-label {
  top: 0;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-state-focused .dx-placeholder,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused .dx-placeholder,
.dx-editor-underlined.dx-texteditor-with-label.dx-state-focused .dx-placeholder,
.dx-editor-underlined.dx-texteditor-with-label.dx-textarea.dx-state-focused .dx-placeholder {
  display: block;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-state-focused .dx-lookup-field,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused .dx-lookup-field,
.dx-editor-underlined.dx-texteditor-with-label.dx-state-focused .dx-lookup-field,
.dx-editor-underlined.dx-texteditor-with-label.dx-textarea.dx-state-focused .dx-lookup-field {
  font-size: 16px;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-state-focused .dx-texteditor-label,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused .dx-texteditor-label,
.dx-editor-underlined.dx-texteditor-with-label.dx-state-focused .dx-texteditor-label,
.dx-editor-underlined.dx-texteditor-with-label.dx-textarea.dx-state-focused .dx-texteditor-label {
  -webkit-transform: translate(0,0);
  transform: translate(0,0);
  font-size: 12px;
  height: 12px;
  line-height: 12px;
  top: 0;
  margin-top: 0;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-state-focused.dx-textarea .dx-texteditor-label,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-textarea .dx-texteditor-label,
.dx-editor-underlined.dx-texteditor-with-label.dx-state-focused.dx-textarea .dx-texteditor-label,
.dx-editor-underlined.dx-texteditor-with-label.dx-textarea.dx-state-focused.dx-textarea .dx-texteditor-label {
  top: 0;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container > .dx-button.dx-button-mode-text,
.dx-editor-underlined.dx-texteditor-with-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container > .dx-button.dx-button-mode-text {
  height: 28px;
  margin: 1px 5px 3px;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container > .dx-button.dx-button-mode-text .dx-button-content,
.dx-editor-underlined.dx-texteditor-with-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container > .dx-button.dx-button-mode-text .dx-button-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-top: 5px;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container > .dx-button.dx-button-mode-text .dx-button-content .dx-icon,
.dx-editor-underlined.dx-texteditor-with-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container > .dx-button.dx-button-mode-text .dx-button-content .dx-icon {
  -ms-flex-item-align: center;
  align-self: center;
  margin-top: 1px;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container > .dx-button.dx-button-mode-text.dx-button-has-text .dx-button-content .dx-icon,
.dx-editor-underlined.dx-texteditor-with-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container > .dx-button.dx-button-mode-text.dx-button-has-text .dx-button-content .dx-icon {
  margin-top: 3px;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container > .dx-button.dx-button-mode-text:not(.dx-button-has-text),
.dx-editor-underlined.dx-texteditor-with-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container > .dx-button.dx-button-mode-text:not(.dx-button-has-text) {
  min-width: 28px;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container > .dx-button.dx-button-mode-text:not(.dx-button-has-text) .dx-button-content,
.dx-editor-underlined.dx-texteditor-with-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container > .dx-button.dx-button-mode-text:not(.dx-button-has-text) .dx-button-content {
  padding: 2px;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container:first-child > .dx-button:first-child,
.dx-editor-underlined.dx-texteditor-with-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container:first-child > .dx-button:first-child {
  margin-left: 0;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container:last-child > .dx-button:last-child,
.dx-editor-underlined.dx-texteditor-with-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container:last-child > .dx-button:last-child {
  margin-right: 0;
}
.dx-rtl.dx-editor-underlined.dx-texteditor-with-floating-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container:first-child > .dx-button:first-child,
.dx-rtl.dx-editor-underlined.dx-texteditor-with-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container:first-child > .dx-button:first-child {
  margin-left: 5px;
  margin-right: 0;
}
.dx-rtl.dx-editor-underlined.dx-texteditor-with-floating-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container:last-child > .dx-button:first-child,
.dx-rtl.dx-editor-underlined.dx-texteditor-with-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container:last-child > .dx-button:first-child {
  margin-left: 5px;
  margin-right: 5px;
}
.dx-rtl.dx-editor-underlined.dx-texteditor-with-floating-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container:last-child > .dx-button:last-child,
.dx-rtl.dx-editor-underlined.dx-texteditor-with-label.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container:last-child > .dx-button:last-child {
  margin-left: 0;
  margin-right: 5px;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-lookup-empty .dx-placeholder,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly .dx-placeholder,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-texteditor-empty .dx-placeholder,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly .dx-placeholder {
  display: none;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-lookup-empty .dx-lookup-field,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly .dx-lookup-field,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-texteditor-empty .dx-lookup-field,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly .dx-lookup-field {
  font-size: 0;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-lookup-empty .dx-texteditor-label,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly .dx-texteditor-label,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-texteditor-empty .dx-texteditor-label,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly .dx-texteditor-label {
  -webkit-transition: font-size .2s cubic-bezier(0, 0, .2, 1),top .2s cubic-bezier(0, 0, .2, 1),-webkit-transform .2s cubic-bezier(0, 0, .2, 1);
  transition: transform .2s cubic-bezier(0, 0, .2, 1),font-size .2s cubic-bezier(0, 0, .2, 1),top .2s cubic-bezier(0, 0, .2, 1),-webkit-transform .2s cubic-bezier(0, 0, .2, 1);
  -webkit-transform: translate(0,0);
  transform: translate(0,0);
  font-size: 16px;
  top: 50%;
  height: 16px;
  margin-top: -8px;
  line-height: 16px;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea .dx-texteditor-label,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-textarea .dx-texteditor-label,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea .dx-texteditor-label,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-textarea .dx-texteditor-label {
  top: 16px;
  margin-top: 0;
  -webkit-transform: translate(0,0);
  transform: translate(0,0);
  font-size: 16px;
  line-height: 16px;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-state-readonly.dx-textarea .dx-placeholder,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-lookup-empty.dx-textarea .dx-placeholder,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-state-readonly.dx-textarea .dx-placeholder,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-texteditor-empty.dx-textarea .dx-placeholder {
  display: none;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active .dx-placeholder,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-state-focused .dx-placeholder,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused .dx-placeholder {
  display: block;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active .dx-texteditor-label,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-state-focused .dx-texteditor-label,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused .dx-texteditor-label {
  -webkit-transform: translate(0,0);
  transform: translate(0,0);
  font-size: 12px;
  top: 0;
  margin-top: 0;
  height: 12px;
  line-height: 12px;
}
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-dropdowneditor-active.dx-textarea .dx-texteditor-label,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-state-focused.dx-textarea .dx-texteditor-label,
.dx-editor-underlined.dx-texteditor-with-floating-label.dx-textarea.dx-state-focused.dx-textarea .dx-texteditor-label {
  top: 0;
}
.dx-editor-underlined.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container > .dx-button.dx-button-mode-text {
  height: 28px;
  margin: 1px 5px 3px;
}
.dx-editor-underlined.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container > .dx-button.dx-button-mode-text .dx-button-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-top: 5px;
}
.dx-editor-underlined.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container > .dx-button.dx-button-mode-text .dx-button-content .dx-icon {
  -ms-flex-item-align: center;
  align-self: center;
  margin-top: 1px;
}
.dx-editor-underlined.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container > .dx-button.dx-button-mode-text.dx-button-has-text .dx-button-content .dx-icon {
  margin-top: 3px;
}
.dx-editor-underlined.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container > .dx-button.dx-button-mode-text:not(.dx-button-has-text) {
  min-width: 28px;
}
.dx-editor-underlined.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container > .dx-button.dx-button-mode-text:not(.dx-button-has-text) .dx-button-content {
  padding: 2px;
}
.dx-editor-underlined.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container:first-child > .dx-button:first-child {
  margin-left: 0;
}
.dx-editor-underlined.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container:last-child > .dx-button:last-child {
  margin-right: 0;
}
.dx-rtl.dx-editor-underlined.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container:first-child > .dx-button:first-child {
  margin-left: 5px;
  margin-right: 0;
}
.dx-rtl.dx-editor-underlined.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container:last-child > .dx-button:first-child {
  margin-left: 5px;
  margin-right: 5px;
}
.dx-rtl.dx-editor-underlined.dx-texteditor-with-before-buttons .dx-texteditor-buttons-container:last-child > .dx-button:last-child {
  margin-left: 0;
  margin-right: 5px;
}
.dx-valid.dx-texteditor .dx-texteditor-input-container::after {
  pointer-events: none;
  position: absolute;
  top: 50%;
  margin-top: -11px;
  width: 22px;
  height: 22px;
  text-align: center;
  line-height: 23px;
  font-size: 20px;
  font-weight: 700;
  font-family: DXIcons,sans-serif;
  color: #8bc34a;
  content: "\\f005";
  opacity: 0;
  -webkit-transform: scale(0);
  transform: scale(0);
  -webkit-animation: .3s cubic-bezier(1,.008,.565,1.65) .1s forwards dx-valid-badge-frames;
  animation: .3s cubic-bezier(1,.008,.565,1.65) .1s forwards dx-valid-badge-frames;
}
.dx-validation-pending.dx-texteditor .dx-texteditor-input-container .dx-pending-indicator {
  pointer-events: none;
  position: absolute;
  top: 50%;
  margin-top: -11px;
  width: 22px;
  height: 22px;
}
.dx-rtl .dx-placeholder,
.dx-rtl .dx-placeholder::before {
  right: 0;
  left: auto;
}
.dx-searchbox .dx-icon-search {
  font: 14px/1 DXIcons;
  color: rgba(148,148,148,.87);
}
.dx-searchbox .dx-icon-search::before {
  content: "\\f027";
  color: rgba(0,0,0,.54);
}
.dx-searchbox.dx-editor-underlined .dx-icon-search {
  position: absolute;
  top: 50%;
  margin-top: -15px;
  width: 30px;
  height: 30px;
  background-position: 4px 4px;
  background-size: 22px 22px;
  padding: 4px 8px 4px 0;
  font-size: 22px;
  text-align: center;
  line-height: 22px;
}
.dx-rtl .dx-searchbox.dx-editor-underlined .dx-icon-search,
.dx-rtl.dx-searchbox.dx-editor-underlined .dx-icon-search {
  padding-right: 0;
  padding-left: 8px;
}
.dx-searchbox.dx-editor-underlined .dx-placeholder::before,
.dx-searchbox.dx-editor-underlined .dx-texteditor-input {
  padding-left: 30px;
}
.dx-rtl .dx-searchbox.dx-editor-underlined .dx-placeholder::before,
.dx-rtl .dx-searchbox.dx-editor-underlined .dx-texteditor-input,
.dx-rtl.dx-searchbox.dx-editor-underlined .dx-placeholder::before,
.dx-rtl.dx-searchbox.dx-editor-underlined .dx-texteditor-input {
  padding-left: 0;
  padding-right: 30px;
}
.dx-searchbox.dx-editor-filled .dx-icon-search,
.dx-searchbox.dx-editor-outlined .dx-icon-search {
  position: absolute;
  top: 50%;
  margin-top: -23px;
  width: 46px;
  height: 46px;
  background-position: 12px 12px;
  background-size: 22px 22px;
  padding: 12px 8px 12px 16px;
  font-size: 22px;
  text-align: center;
  line-height: 22px;
}
.dx-rtl .dx-searchbox.dx-editor-filled .dx-icon-search,
.dx-rtl .dx-searchbox.dx-editor-outlined .dx-icon-search,
.dx-rtl.dx-searchbox.dx-editor-filled .dx-icon-search,
.dx-rtl.dx-searchbox.dx-editor-outlined .dx-icon-search {
  padding-right: 16px;
  padding-left: 8px;
}
.dx-searchbox.dx-editor-filled .dx-placeholder::before,
.dx-searchbox.dx-editor-filled .dx-texteditor-input,
.dx-searchbox.dx-editor-outlined .dx-placeholder::before,
.dx-searchbox.dx-editor-outlined .dx-texteditor-input {
  padding-left: 46px;
}
.dx-rtl .dx-searchbox.dx-editor-filled .dx-placeholder::before,
.dx-rtl .dx-searchbox.dx-editor-filled .dx-texteditor-input,
.dx-rtl .dx-searchbox.dx-editor-outlined .dx-placeholder::before,
.dx-rtl .dx-searchbox.dx-editor-outlined .dx-texteditor-input,
.dx-rtl.dx-searchbox.dx-editor-filled .dx-placeholder::before,
.dx-rtl.dx-searchbox.dx-editor-filled .dx-texteditor-input,
.dx-rtl.dx-searchbox.dx-editor-outlined .dx-placeholder::before,
.dx-rtl.dx-searchbox.dx-editor-outlined .dx-texteditor-input {
  padding-left: 16px;
  padding-right: 46px;
}
.dx-searchbar {
  padding-bottom: 5px;
}
.dx-searchbar .dx-texteditor {
  margin: 0;
}
.dx-dropdowneditor {
  position: relative;
}
.dx-dropdowneditor.dx-dropdowneditor-field-clickable,
.dx-dropdowneditor.dx-dropdowneditor-field-clickable .dx-texteditor-input {
  cursor: pointer;
}
.dx-dropdowneditor.dx-dropdowneditor-field-clickable .dx-texteditor-buttons-container .dx-state-disabled .dx-button,
.dx-dropdowneditor.dx-dropdowneditor-field-clickable .dx-texteditor-buttons-container .dx-state-disabled.dx-button {
  pointer-events: auto;
}
.dx-dropdowneditor-input-wrapper {
  -webkit-tap-highlight-color: transparent;
  overflow: hidden;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.dx-dropdowneditor-input-wrapper .dx-texteditor {
  border: none;
  margin: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
}
.dx-dropdowneditor-input-wrapper .dx-texteditor-input {
  text-overflow: ellipsis;
}
.dx-dropdowneditor-input-wrapper .dx-texteditor-input::-ms-clear {
  width: 0;
  height: 0;
}
.dx-dropdowneditor-field-template-wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  position: relative;
  -webkit-box-align: baseline;
  -ms-flex-align: baseline;
  align-items: baseline;
}
.dx-dropdowneditor-field-template-wrapper > * {
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
}
.dx-dropdowneditor-active .dx-dropdowneditor-icon {
  opacity: .35;
}
.dx-dropdowneditor-button {
  position: relative;
  float: right;
  height: 100%;
  cursor: pointer;
  width: 24px;
  min-width: 24px;
}
.dx-dropdowneditor-button .dx-button-content {
  text-align: center;
  white-space: nowrap;
}
.dx-rtl .dx-dropdowneditor-button,
.dx-rtl.dx-dropdowneditor-button {
  float: left;
}
.dx-dropdowneditor-button.dx-dropdowneditor-readonly {
  cursor: default;
}
.dx-dropdowneditor-icon {
  background-position: center;
  background-repeat: no-repeat;
  color: rgba(0,0,0,.54);
  font: 24px/24px DXIcons;
  width: 24px;
  height: 100%;
  text-align: center;
}
.dx-state-disabled .dx-dropdowneditor,
.dx-state-disabled.dx-dropdowneditor {
  cursor: default;
}
.dx-state-disabled .dx-dropdowneditor-button {
  cursor: inherit;
}
.dx-state-disabled .dx-dropdowneditor-icon {
  opacity: .2;
}
.dx-state-disabled .dx-dropdowneditor-button .dx-dropdowneditor-icon,
.dx-state-readonly .dx-dropdowneditor-button .dx-dropdowneditor-icon {
  opacity: 1;
}
.dx-dropdowneditor-icon::before {
  content: "\\f001";
  position: absolute;
  display: block;
  width: 24px;
  top: 50%;
  margin-top: -12px;
  left: 50%;
  margin-left: -12px;
}
.dx-dropdowneditor-input-wrapper .dx-texteditor::after,
.dx-dropdowneditor-input-wrapper .dx-texteditor::before {
  content: none;
}
.dx-dropdowneditor-input-wrapper .dx-texteditor,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-active .dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-disabled,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-active .dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-disabled.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-active .dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-disabled.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label-after,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-active .dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-disabled.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label-before,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-active .dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-disabled.dx-texteditor-with-label .dx-texteditor-label .dx-label,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-active .dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-disabled.dx-texteditor-with-label .dx-texteditor-label .dx-label-after,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-active .dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-disabled.dx-texteditor-with-label .dx-texteditor-label .dx-label-before,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-focused,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-focused.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-focused.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label-after,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-focused.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label-before,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-focused.dx-texteditor-with-label .dx-texteditor-label .dx-label,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-focused.dx-texteditor-with-label .dx-texteditor-label .dx-label-after,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-focused.dx-texteditor-with-label .dx-texteditor-label .dx-label-before,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-hover,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-hover.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-hover.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label-after,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-hover.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label-before,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-hover.dx-texteditor-with-label .dx-texteditor-label .dx-label,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-hover.dx-texteditor-with-label .dx-texteditor-label .dx-label-after,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-hover.dx-texteditor-with-label .dx-texteditor-label .dx-label-before,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-readonly,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-readonly.dx-state-hover,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-readonly.dx-state-hover.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-readonly.dx-state-hover.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label-after,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-readonly.dx-state-hover.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label-before,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-readonly.dx-state-hover.dx-texteditor-with-label .dx-texteditor-label .dx-label,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-readonly.dx-state-hover.dx-texteditor-with-label .dx-texteditor-label .dx-label-after,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-readonly.dx-state-hover.dx-texteditor-with-label .dx-texteditor-label .dx-label-before,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-readonly.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-readonly.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label-after,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-readonly.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label-before,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-readonly.dx-texteditor-with-label .dx-texteditor-label .dx-label,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-readonly.dx-texteditor-with-label .dx-texteditor-label .dx-label-after,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-state-readonly.dx-texteditor-with-label .dx-texteditor-label .dx-label-before,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label-after,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label-before,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-texteditor-with-label .dx-texteditor-label .dx-label,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-texteditor-with-label .dx-texteditor-label .dx-label-after,
.dx-dropdowneditor-input-wrapper .dx-texteditor.dx-texteditor-with-label .dx-texteditor-label .dx-label-before {
  background-color: transparent;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-invalid.dx-dropdowneditor-button-visible.dx-editor-underlined .dx-texteditor-input,
.dx-valid.dx-dropdowneditor-button-visible.dx-editor-underlined .dx-texteditor-input,
.dx-validation-pending.dx-dropdowneditor-button-visible.dx-editor-underlined .dx-texteditor-input {
  padding-right: 34px;
}
.dx-invalid.dx-dropdowneditor-button-visible.dx-editor-underlined.dx-rtl .dx-texteditor-input,
.dx-valid.dx-dropdowneditor-button-visible.dx-editor-underlined.dx-rtl .dx-texteditor-input,
.dx-validation-pending.dx-dropdowneditor-button-visible.dx-editor-underlined.dx-rtl .dx-texteditor-input {
  padding-right: 0;
  padding-left: 34px;
}
.dx-invalid.dx-dropdowneditor-button-visible.dx-editor-filled .dx-texteditor-input,
.dx-invalid.dx-dropdowneditor-button-visible.dx-editor-outlined .dx-texteditor-input,
.dx-valid.dx-dropdowneditor-button-visible.dx-editor-filled .dx-texteditor-input,
.dx-valid.dx-dropdowneditor-button-visible.dx-editor-outlined .dx-texteditor-input,
.dx-validation-pending.dx-dropdowneditor-button-visible.dx-editor-filled .dx-texteditor-input,
.dx-validation-pending.dx-dropdowneditor-button-visible.dx-editor-outlined .dx-texteditor-input {
  padding-right: 50px;
}
.dx-invalid.dx-dropdowneditor-button-visible.dx-editor-filled.dx-rtl .dx-texteditor-input,
.dx-invalid.dx-dropdowneditor-button-visible.dx-editor-outlined.dx-rtl .dx-texteditor-input,
.dx-valid.dx-dropdowneditor-button-visible.dx-editor-filled.dx-rtl .dx-texteditor-input,
.dx-valid.dx-dropdowneditor-button-visible.dx-editor-outlined.dx-rtl .dx-texteditor-input,
.dx-validation-pending.dx-dropdowneditor-button-visible.dx-editor-filled.dx-rtl .dx-texteditor-input,
.dx-validation-pending.dx-dropdowneditor-button-visible.dx-editor-outlined.dx-rtl .dx-texteditor-input {
  padding-right: 16px;
  padding-left: 50px;
}
.dx-dropdowneditor-button.dx-state-active .dx-dropdowneditor-icon,
.dx-dropdowneditor.dx-dropdowneditor-active .dx-dropdowneditor-icon {
  color: rgba(0,0,0,.54);
  opacity: 1;
  font: 24px/24px DXIcons;
  width: 24px;
  height: 100%;
  text-align: center;
}
.dx-dropdowneditor-button.dx-state-active .dx-dropdowneditor-icon::before,
.dx-dropdowneditor.dx-dropdowneditor-active .dx-dropdowneditor-icon::before {
  content: "\\f002";
  position: absolute;
  display: block;
  width: 24px;
  top: 50%;
  margin-top: -12px;
  left: 50%;
  margin-left: -12px;
}
.dx-invalid.dx-dropdowneditor .dx-texteditor-buttons-container::after,
.dx-valid.dx-dropdowneditor .dx-texteditor-buttons-container::after {
  right: 30px;
}
.dx-rtl .dx-invalid.dx-dropdowneditor .dx-texteditor-buttons-container::after,
.dx-rtl .dx-valid.dx-dropdowneditor .dx-texteditor-buttons-container::after,
.dx-rtl.dx-invalid.dx-dropdowneditor .dx-texteditor-buttons-container::after,
.dx-rtl.dx-valid.dx-dropdowneditor .dx-texteditor-buttons-container::after {
  right: auto;
  left: 30px;
}
.dx-invalid.dx-dropdowneditor.dx-show-clear-button:not(.dx-texteditor-empty) .dx-texteditor-buttons-container::after,
.dx-valid.dx-dropdowneditor.dx-show-clear-button:not(.dx-texteditor-empty) .dx-texteditor-buttons-container::after {
  right: 54px;
}
.dx-rtl .dx-invalid.dx-dropdowneditor.dx-show-clear-button:not(.dx-texteditor-empty) .dx-texteditor-buttons-container::after,
.dx-rtl .dx-valid.dx-dropdowneditor.dx-show-clear-button:not(.dx-texteditor-empty) .dx-texteditor-buttons-container::after,
.dx-rtl.dx-invalid.dx-dropdowneditor.dx-show-clear-button:not(.dx-texteditor-empty) .dx-texteditor-buttons-container::after,
.dx-rtl.dx-valid.dx-dropdowneditor.dx-show-clear-button:not(.dx-texteditor-empty) .dx-texteditor-buttons-container::after {
  right: auto;
  left: 54px;
}
.dx-dropdowneditor-overlay.dx-popup-wrapper .dx-overlay-content {
  -webkit-box-shadow: 0 2px 7px rgba(0,0,0,.2);
  box-shadow: 0 2px 7px rgba(0,0,0,.2);
  overflow: hidden;
}
.dx-dropdowneditor-overlay .dx-list-group-header,
.dx-dropdowneditor-overlay .dx-list-item-content {
  font-size: 14px;
  line-height: 20px;
}
.dx-list {
  margin: 0;
  min-height: 3em;
}
.dx-list .dx-scrollview-content:focus {
  outline: 0;
}
.dx-wrap-item-text > .dx-list-group > .dx-list-group-body > .dx-list-item > .dx-list-item-content,
.dx-wrap-item-text > .dx-list-item > .dx-list-item-content {
  white-space: normal;
}
.dx-empty-collection .dx-list-select-all {
  display: none;
}
.dx-list-group-header::before {
  width: 0;
  height: 0;
  display: block;
  float: right;
  margin-top: 6px;
  border-style: solid;
  border-color: transparent;
  border-width: 5px 5px 0;
}
.dx-list-collapsible-groups .dx-list-group-header {
  cursor: pointer;
}
.dx-list-collapsible-groups .dx-list-group-header::before {
  content: " ";
  content: none;
}
.dx-list-group-collapsed .dx-list-group-header::before {
  border-width: 0 5px 5px;
}
.dx-list-group-body {
  overflow: hidden;
}
.dx-list-item {
  cursor: pointer;
  display: table;
  width: 100%;
  table-layout: fixed;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dx-list-item-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: table-cell;
  width: 100%;
}
.dx-list-item-content::before {
  content: "_";
  color: transparent;
  display: inline-block;
  width: 0;
  float: left;
}
.dx-list .dx-empty-message {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-height: 3em;
}
.dx-list-item-badge-container {
  display: table-cell;
  width: 20px;
  text-align: right;
  vertical-align: middle;
}
.dx-list-item-badge {
  float: right;
  position: relative;
}
.dx-list-item-chevron-container {
  display: table-cell;
  vertical-align: middle;
}
.dx-list-item-icon-container {
  display: inline-block;
}
.dx-list-item-chevron {
  border-width: 2px 0 0 2px;
  opacity: .3;
}
.dx-list-item-response-wait {
  opacity: .5;
  -webkit-transition: opacity .2s linear;
  transition: opacity .2s linear;
}
.dx-list-slide-menu-content {
  display: table;
  width: 100%;
  table-layout: fixed;
}
.dx-list-item-after-bag,
.dx-list-item-before-bag {
  display: table-cell;
  width: 0;
  height: 100%;
  vertical-align: middle;
}
.dx-list-item-before-bag .dx-list-toggle-delete-switch {
  display: block;
  float: left;
  padding: 3px 0;
}
.dx-list-item-before-bag .dx-icon-toggle-delete {
  -webkit-transition: .1s linear;
  transition: .1s linear;
}
.dx-list-item-before-bag .dx-list-select-checkbox {
  float: left;
  -webkit-transition: .1s linear;
  transition: .1s linear;
}
.dx-list-select-all-label {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dx-list-item-after-bag .dx-list-reorder-handle {
  cursor: move;
  background-repeat: no-repeat;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
}
.dx-state-disabled .dx-list-item-after-bag .dx-list-reorder-handle {
  cursor: default;
}
.dx-list-switchable-menu-shield-positioning {
  position: relative;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}
.dx-list-switchable-delete-bottom-shield,
.dx-list-switchable-delete-top-shield {
  position: absolute;
  right: 0;
  left: 0;
  cursor: pointer;
}
.dx-list-switchable-delete-top-shield {
  top: 0;
}
.dx-list-switchable-delete-bottom-shield {
  bottom: 0;
}
.dx-list-switchable-delete-item-content-shield {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.dx-list-switchable-delete-button-container {
  position: absolute;
  top: 0;
  bottom: 0;
  overflow: hidden;
}
.dx-list-switchable-delete-button-wrapper {
  display: table;
  height: 100%;
}
.dx-list-switchable-delete-button-inner-wrapper {
  display: table-cell;
  padding-left: 1px;
  height: 100%;
  vertical-align: middle;
}
.dx-list-switchable-menu-item-shield-positioning,
.dx-list-switchable-menu-item-shield-positioning .dx-list-item-content,
.dx-list-switchable-menu-item-shield-positioning .dx-list-slide-menu-content {
  position: relative;
}
.dx-list-switchable-delete-ready .dx-icon-toggle-delete {
  -webkit-transform: rotate(-90deg);
  transform: rotate(-90deg);
}
.dx-list-slide-menu-buttons-container {
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
}
.dx-device-ios .dx-list-slide-menu-buttons-container {
  -webkit-mask-image: -webkit-radial-gradient(white,black);
}
.dx-list-slide-menu-buttons {
  position: relative;
  top: 0;
  left: 0;
  bottom: 0;
  display: table;
  height: 100%;
}
.dx-list-slide-menu-button {
  display: table-cell;
  padding: 0 10px;
  vertical-align: middle;
  bottom: 1px;
}
.dx-list-static-delete-button .dx-button-content {
  overflow: visible;
}
.dx-list-next-button {
  padding: 5px;
  text-align: center;
}
.dx-state-disabled .dx-list-item,
.dx-state-disabled .dx-list-switchable-delete-button,
.dx-state-disabled .dx-list-toggle-delete-switch,
.dx-state-disabled.dx-list-item {
  cursor: default;
}
.dx-list-context-menuitem {
  cursor: pointer;
}
.dx-rtl .dx-list .dx-list-item-badge-container,
.dx-rtl.dx-list .dx-list-item-badge-container {
  padding-left: 10px;
  padding-right: 0;
}
.dx-rtl .dx-list .dx-list-item-badge,
.dx-rtl.dx-list .dx-list-item-badge {
  float: left;
}
.dx-rtl .dx-list .dx-list-item-before-bag .dx-list-select-checkbox,
.dx-rtl .dx-list .dx-list-item-before-bag .dx-list-toggle-delete-switch,
.dx-rtl.dx-list .dx-list-item-before-bag .dx-list-select-checkbox,
.dx-rtl.dx-list .dx-list-item-before-bag .dx-list-toggle-delete-switch {
  float: right;
}
.dx-rtl .dx-list .dx-list-slide-item-delete-button-container,
.dx-rtl.dx-list .dx-list-slide-item-delete-button-container {
  right: 100%;
  left: 0;
}
.dx-rtl .dx-list .dx-list-slide-item-delete-button,
.dx-rtl.dx-list .dx-list-slide-item-delete-button {
  right: auto;
  left: 0;
}
.dx-rtl .dx-list .dx-list-group-header::before,
.dx-rtl.dx-list .dx-list-group-header::before {
  float: left;
}
.dx-list-item-chevron {
  -webkit-transform: rotate(0);
  transform: rotate(0);
  border: none;
  opacity: 1;
  font: 24px/24px DXIcons;
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  text-align: center;
  margin-left: -5px;
  color: rgba(0,0,0,.54);
}
.dx-rtl .dx-list-item-chevron {
  margin-left: auto;
  margin-right: -6px;
  -webkit-transform: rotate(0);
  transform: rotate(0);
}
.dx-list-item-chevron::before {
  content: "\\f010";
}
.dx-list-item-icon-container {
  width: 40px;
  height: 24px;
  vertical-align: bottom;
}
.dx-list-item-icon {
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  font-size: 24px;
  text-align: center;
  line-height: 24px;
}
.dx-list-search {
  margin-bottom: 5px;
  padding-top: 4px;
}
.dx-list-search.dx-searchbox .dx-placeholder::before {
  font-size: 16px;
}
.dx-list-search.dx-searchbox .dx-clear-button-area {
  width: 23px;
}
.dx-list-group-header,
.dx-list-item,
.dx-list-select-all {
  position: relative;
}
.dx-list-group-header .dx-inkripple,
.dx-list-item .dx-inkripple,
.dx-list-select-all .dx-inkripple {
  overflow: hidden;
}
.dx-list {
  border: none;
}
.dx-list.dx-list-with-search .dx-scrollable-wrapper {
  height: calc(100% - 57px);
}
.dx-list.dx-list-select-decorator-enabled .dx-list-item.dx-state-hover .dx-radiobutton-icon,
.dx-list.dx-list-select-decorator-enabled .dx-list-select-all.dx-state-hover .dx-radiobutton-icon {
  border-color: #005951;
}
.dx-list.dx-list-select-decorator-enabled .dx-list-item.dx-state-focused .dx-radiobutton .dx-radiobutton-icon::after,
.dx-list.dx-list-select-decorator-enabled .dx-list-select-all.dx-state-focused .dx-radiobutton .dx-radiobutton-icon::after {
  background-color: rgba(0,0,0,.1);
  -webkit-transform: scale(1);
  transform: scale(1);
}
.dx-list.dx-list-select-decorator-enabled .dx-list-item.dx-state-focused .dx-radiobutton.dx-radiobutton-checked .dx-radiobutton-icon::after,
.dx-list.dx-list-select-decorator-enabled .dx-list-select-all.dx-state-focused .dx-radiobutton.dx-radiobutton-checked .dx-radiobutton-icon::after {
  background-color: rgba(0,150,136,.1);
  -webkit-transform: scale(1);
  transform: scale(1);
}
.dx-list.dx-list-select-decorator-enabled .dx-list-item.dx-state-focused .dx-checkbox .dx-checkbox-icon::after,
.dx-list.dx-list-select-decorator-enabled .dx-list-select-all.dx-state-focused .dx-checkbox .dx-checkbox-icon::after {
  background-color: rgba(0,0,0,.1);
  -webkit-transform: scale(1);
  transform: scale(1);
}
.dx-list.dx-list-select-decorator-enabled .dx-list-item.dx-state-focused .dx-checkbox.dx-checkbox-checked .dx-checkbox-icon::after,
.dx-list.dx-list-select-decorator-enabled .dx-list-item.dx-state-focused .dx-checkbox.dx-checkbox-indeterminate .dx-checkbox-icon::after,
.dx-list.dx-list-select-decorator-enabled .dx-list-select-all.dx-state-focused .dx-checkbox.dx-checkbox-checked .dx-checkbox-icon::after,
.dx-list.dx-list-select-decorator-enabled .dx-list-select-all.dx-state-focused .dx-checkbox.dx-checkbox-indeterminate .dx-checkbox-icon::after {
  background-color: rgba(0,150,136,.1);
  -webkit-transform: scale(1);
  transform: scale(1);
}
.dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-list-item-selected {
  background-color: rgba(0,0,0,.12);
  color: #000;
}
.dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-list-item-selected.dx-state-hover:not(.dx-state-focused) {
  background-color: rgba(0,0,0,.14);
  color: #000;
}
.dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-state-focused {
  background-color: rgba(0,0,0,.04);
  color: rgba(0,0,0,.87);
}
.dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-state-focused.dx-list-item-selected {
  background-color: rgba(0,0,0,.18);
  color: #000;
}
.dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-state-active,
.dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-state-active .dx-list-slide-item-content {
  background-color: #ccc;
}
.dx-list-group:not(.dx-list-group-collapsed):not(:last-child) {
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
}
.dx-list-group:not(.dx-list-group-collapsed) + .dx-list-group:not(.dx-list-group-collapsed) .dx-list-group-header {
  border-top-color: transparent;
}
.dx-list-collapsible-groups .dx-list-group.dx-list-group-collapsed .dx-list-group-header-indicator {
  font: 24px/1 DXIcons;
}
.dx-list-collapsible-groups .dx-list-group.dx-list-group-collapsed .dx-list-group-header-indicator::before {
  content: "\\f016";
}
.dx-list-group.dx-list-group-collapsed .dx-list-group-header {
  color: rgba(0,0,0,.87);
}
.dx-list-group .dx-list-item:first-of-type {
  margin-top: 0;
}
.dx-list-group .dx-list-item:last-of-type {
  margin-bottom: 0;
}
.dx-list-group-header {
  font-weight: 400;
  padding: 14px 16px;
  background: rgba(255,255,255,0);
  color: #009688;
  border-top: 1px solid transparent;
  font-size: 16px;
}
.dx-list-group-header .dx-list-group-header-indicator {
  color: rgba(0,0,0,.54);
}
.dx-list-collapsible-groups .dx-list-group-header .dx-list-group-header-indicator {
  font: 24px/1 DXIcons;
  float: right;
  margin-top: -2px;
}
.dx-list-collapsible-groups .dx-list-group-header .dx-list-group-header-indicator::before {
  content: "\\f014";
}
.dx-list-group-header .dx-inkripple {
  height: auto;
  top: -1px;
  bottom: 0;
}
.dx-list-group-header::before {
  content: none;
}
.dx-list-item .dx-icon-toggle-delete {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C!--%20Generator%3A%20Adobe%20Illustrator%2024.0.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200)%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22dx_l_3%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20style%3D%22enable-background%3Anew%200%200%2024%2024%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cpath%20style%3D%22fill%3Argba%280,%200,%200,%200.54%29%3B%22%20d%3D%22M12%2C2C6.5%2C2%2C2%2C6.5%2C2%2C12c0%2C5.5%2C4.5%2C10%2C10%2C10s10-4.5%2C10-10C22%2C6.5%2C17.5%2C2%2C12%2C2z%20M18%2C13H6v-2h12V13z%22%2F%3E%0A%3C%2Fsvg%3E%0A");
  background-size: 100%;
}
.dx-list-item.dx-state-active,
.dx-list-item.dx-state-hover {
  background-color: rgba(0,0,0,.04);
  color: rgba(0,0,0,.87);
}
.dx-list-item.dx-state-active .dx-list-switchable-delete-button-inner-wrapper,
.dx-list-item.dx-state-hover .dx-list-switchable-delete-button-inner-wrapper {
  background-color: rgba(0,0,0,.04);
}
.dx-list-item:first-of-type {
  border-top: none;
  margin-top: 8px;
}
.dx-list-item:last-of-type {
  border-bottom: none;
  margin-bottom: 8px;
}
.dx-list-item .dx-icon {
  color: rgba(0,0,0,.54);
}
.dx-list-item.dx-list-item-ghost-reordering.dx-state-focused.dx-state-hover {
  color: rgba(98,98,98,.87);
  background: #fff;
  border-top: 1px solid rgba(0,150,136,.5);
  border-bottom: 1px solid rgba(0,150,136,.5);
  -webkit-box-shadow: 0 0 1px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.2);
  box-shadow: 0 0 1px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.2);
}
.dx-list .dx-empty-message,
.dx-list-item {
  color: rgba(0,0,0,.87);
}
.dx-list-item-separator-hidden .dx-list .dx-empty-message,
.dx-list-item-separator-hidden .dx-list-item {
  border-top: none;
  border-bottom: none;
}
.dx-list-item-content {
  font-size: 16px;
  padding: 14px 16px 13px;
}
.dx-list .dx-empty-message {
  text-align: left;
  padding: 8px 16px 7px;
  color: rgba(0,0,0,.54);
  font-size: 12px;
}
.dx-list-next-button .dx-button {
  margin-top: 20px;
  padding: 0;
}
.dx-list-next-button .dx-button .dx-button-content {
  padding: 6px 58px;
}
.dx-list-next-button .dx-button .dx-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
  margin-right: 9px;
  margin-left: 0;
}
.dx-list-next-button .dx-button .dx-icon.dx-icon-right,
.dx-rtl .dx-list-next-button .dx-button .dx-icon,
.dx-rtl.dx-list-next-button .dx-button .dx-icon {
  margin-left: 9px;
  margin-right: 0;
}
.dx-rtl .dx-list-next-button .dx-button .dx-icon.dx-icon-right,
.dx-rtl.dx-list-next-button .dx-button .dx-icon.dx-icon-right {
  margin-right: 9px;
  margin-left: 0;
}
.dx-list-item-chevron-container {
  width: 27px;
  padding-top: 7px;
}
.dx-list-border-visible {
  border: 1px solid #e0e0e0;
}
.dx-list-item-before-bag.dx-list-toggle-delete-switch-container {
  width: 46px;
}
.dx-list-item-before-bag.dx-list-select-checkbox-container,
.dx-list-item-before-bag.dx-list-select-radiobutton-container {
  width: 56px;
}
.dx-list-item-before-bag .dx-button.dx-list-toggle-delete-switch {
  border: none;
  background: 0 0;
  padding: 0;
  height: 24px;
  width: 24px;
  margin-left: 15px;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-list-item-before-bag .dx-button.dx-list-toggle-delete-switch .dx-button-content {
  padding: 0;
}
.dx-list-item-before-bag .dx-button.dx-list-toggle-delete-switch .dx-button-content .dx-inkripple-wave {
  display: none;
}
.dx-list-item-before-bag .dx-icon-toggle-delete {
  width: 23px;
  height: 23px;
}
.dx-list-item-before-bag .dx-list-select-checkbox,
.dx-list-item-before-bag .dx-list-select-radiobutton {
  margin-top: -1px;
  margin-bottom: -3px;
  margin-left: 16px;
}
.dx-list-toggle-delete-switch-container + .dx-list-item-content {
  padding-left: 34px;
}
.dx-list-select-all {
  white-space: nowrap;
  padding: 13px 0;
  font-size: 16px;
  position: relative;
}
.dx-list-select-all::after {
  content: "";
  position: absolute;
  bottom: 1px;
  left: 16px;
  right: 16px;
  height: 1px;
  background-color: #e0e0e0;
}
.dx-list-select-all-checkbox {
  float: left;
  margin: -1px 0 -3px 16px;
}
.dx-list-select-all-label {
  line-height: 17px;
  padding: 0 35px;
  margin-top: 2px;
}
.dx-list-item-after-bag.dx-list-static-delete-button-container {
  width: 37px;
}
.dx-list-item-after-bag.dx-list-reorder-handle-container {
  width: 44.8px;
}
.dx-list-item-after-bag .dx-list-reorder-handle {
  font: 24px/24px DXIcons;
  color: rgba(0,0,0,.27);
  width: 38.4px;
  height: 38.4px;
  background-position: 7px 7px;
  background-size: 24px 24px;
  padding: 7px;
  text-align: center;
}
.dx-list-item-after-bag .dx-list-reorder-handle::before {
  content: "\\f038";
}
.dx-list-slide-menu-button-delete {
  font: 24px/1 DXIcons;
  color: #fff;
  border: 1px solid rgba(0,0,0,.24);
  border-right-color: transparent;
  background-color: #f44336;
  display: table-cell;
  vertical-align: middle;
  padding: 0 16px;
  width: 56px;
  -webkit-box-shadow: inset 3px 0 5px -3px rgba(0,0,0,.24),inset 0 3px 5px -3px rgba(0,0,0,.24),inset 0 -3px 5px -3px rgba(0,0,0,.24);
  box-shadow: inset 3px 0 5px -3px rgba(0,0,0,.24),inset 0 3px 5px -3px rgba(0,0,0,.24),inset 0 -3px 5px -3px rgba(0,0,0,.24);
}
.dx-list-slide-menu-button-delete::before {
  content: "\\f03e";
}
.dx-list-slide-menu-button-menu {
  border: 1px solid transparent;
  color: #fff;
  background-color: #009688;
}
.dx-list-static-delete-button {
  margin-right: 16px;
  padding: 0;
  border-radius: 50%;
  height: 34px;
  margin-top: -2px;
}
.dx-list-static-delete-button.dx-button {
  -webkit-box-shadow: none;
  box-shadow: none;
  background-color: transparent;
}
.dx-list-static-delete-button.dx-button .dx-button-content {
  z-index: 1;
}
.dx-list-switchable-delete-button-inner-wrapper {
  padding-right: 6px;
  background-color: #fff;
}
.dx-button.dx-list-switchable-delete-button {
  background-color: transparent;
  color: #f44336;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button.dx-list-switchable-delete-button .dx-icon {
  color: #f44336;
}
.dx-button.dx-list-switchable-delete-button.dx-state-focused,
.dx-button.dx-list-switchable-delete-button.dx-state-hover {
  background-color: rgba(244,67,54,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button.dx-list-switchable-delete-button.dx-state-active {
  background-color: rgba(244,67,54,.36);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button.dx-list-switchable-delete-button.dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-button.dx-list-switchable-delete-button.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-button.dx-list-switchable-delete-button.dx-state-disabled .dx-button-text,
.dx-button.dx-list-switchable-delete-button.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-button.dx-list-switchable-delete-button .dx-inkripple-wave {
  background-color: rgba(244,67,54,.2);
}
.dx-list-context-menucontent {
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 0;
  -webkit-box-shadow: 0 3px 10px rgba(0,0,0,.1);
  box-shadow: 0 3px 10px rgba(0,0,0,.1);
}
.dx-state-disabled .dx-list-item,
.dx-state-disabled.dx-list-item {
  background-color: transparent;
  opacity: .6;
}
.dx-rtl .dx-list .dx-empty-message,
.dx-rtl.dx-list .dx-empty-message {
  text-align: right;
}
.dx-rtl .dx-list .dx-list-item-before-bag .dx-button.dx-list-toggle-delete-switch,
.dx-rtl.dx-list .dx-list-item-before-bag .dx-button.dx-list-toggle-delete-switch {
  margin-right: 15px;
  margin-left: 0;
}
.dx-rtl .dx-list .dx-list-item-before-bag .dx-list-select-checkbox,
.dx-rtl .dx-list .dx-list-item-before-bag .dx-list-select-radiobutton,
.dx-rtl.dx-list .dx-list-item-before-bag .dx-list-select-checkbox,
.dx-rtl.dx-list .dx-list-item-before-bag .dx-list-select-radiobutton {
  margin-right: 16px;
  margin-left: 1px;
}
.dx-rtl .dx-list .dx-list-select-all-checkbox,
.dx-rtl.dx-list .dx-list-select-all-checkbox {
  float: right;
  margin-right: 16px;
  margin-left: 1px;
}
.dx-rtl .dx-list .dx-list-switchable-delete-button,
.dx-rtl.dx-list .dx-list-switchable-delete-button {
  margin-right: 0;
}
.dx-rtl .dx-list .dx-list-switchable-delete-button-inner-wrapper,
.dx-rtl.dx-list .dx-list-switchable-delete-button-inner-wrapper {
  padding-left: 6px;
  padding-right: 0;
}
.dx-list-item-badge-container {
  padding-right: 16px;
}
.dx-textarea .dx-texteditor-input {
  resize: none;
  font-family: inherit;
  display: block;
  overflow: auto;
  white-space: pre-wrap;
  margin: 0;
  padding: 10px;
  line-height: 24px;
}
.dx-textarea .dx-texteditor-input-auto-resize {
  overflow-y: hidden;
}
.dx-textarea .dx-placeholder {
  height: auto;
}
.dx-textarea .dx-placeholder::before {
  white-space: normal;
  padding: 13px 10px;
}
.dx-textarea {
  height: auto;
}
.dx-textarea .dx-texteditor-input-container {
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  margin: 2px;
}
.dx-textarea .dx-icon-clear {
  top: 0;
  margin-top: 0;
}
.dx-textarea.dx-invalid .dx-texteditor-container::after {
  top: 14px;
  margin-top: 0;
}
.dx-numberbox {
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}
.dx-numberbox input[type=number] {
  -moz-appearance: textfield;
}
.dx-numberbox input[type=number]::-webkit-inner-spin-button,
.dx-numberbox input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.dx-numberbox-spin-container {
  height: 100%;
}
.dx-numberbox-spin-down,
.dx-numberbox-spin-up {
  position: relative;
  width: 100%;
  height: 50%;
  cursor: pointer;
}
.dx-numberbox-spin-touch-friendly .dx-numberbox-spin-down,
.dx-numberbox-spin-touch-friendly .dx-numberbox-spin-up {
  width: 50%;
  height: 100%;
  display: inline-block;
}
.dx-numberbox-spin-down-icon,
.dx-numberbox-spin-up-icon {
  width: 100%;
  height: 100%;
}
.dx-state-disabled .dx-numberbox-spin-container {
  opacity: .2;
  opacity: 1;
}
.dx-numberbox-spin-container {
  overflow: hidden;
  width: 24px;
}
.dx-numberbox-spin-up-icon {
  font: 14px/1 DXIcons;
  color: rgba(0,0,0,.54);
}
.dx-numberbox-spin-up-icon::before {
  content: "\\f002";
}
.dx-numberbox-spin-down-icon {
  font: 14px/1 DXIcons;
  color: rgba(0,0,0,.54);
}
.dx-numberbox-spin-down-icon::before {
  content: "\\f001";
}
.dx-numberbox-spin-down-icon,
.dx-numberbox-spin-up-icon {
  font-size: 24px;
  text-align: center;
  line-height: 24px;
}
.dx-numberbox-spin-down-icon::before,
.dx-numberbox-spin-up-icon::before {
  position: absolute;
  display: block;
  width: 24px;
  top: 50%;
  margin-top: -12px;
  left: 50%;
  margin-left: -12px;
}
.dx-numberbox-spin-button {
  padding: 1px;
  height: 50%;
}
.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined .dx-texteditor-input {
  padding-right: 0;
}
.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-invalid.dx-editor-underlined .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-valid.dx-editor-underlined .dx-texteditor-input {
  padding-right: 46px;
}
.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-invalid.dx-editor-underlined.dx-rtl .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-valid.dx-editor-underlined.dx-rtl .dx-texteditor-input {
  padding-left: 46px;
  padding-right: 0;
}
.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-invalid.dx-editor-filled .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-invalid.dx-editor-outlined .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-valid.dx-editor-filled .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-valid.dx-editor-outlined .dx-texteditor-input {
  padding-right: 62px;
}
.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-invalid.dx-editor-filled.dx-rtl .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-invalid.dx-editor-outlined.dx-rtl .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-valid.dx-editor-filled.dx-rtl .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-valid.dx-editor-outlined.dx-rtl .dx-texteditor-input {
  padding: 15px 16px 14px 62px;
}
.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-invalid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-invalid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-valid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-valid.dx-editor-outlined .dx-texteditor-input-container::after {
  right: 12px;
}
.dx-rtl .dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-invalid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl .dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-invalid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-rtl .dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-valid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl .dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-valid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-invalid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-invalid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-valid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-valid.dx-editor-outlined .dx-texteditor-input-container::after {
  left: 12px;
  right: auto;
}
.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-invalid .dx-texteditor-input-container::after,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-valid .dx-texteditor-input-container::after {
  right: 6px;
}
.dx-rtl .dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-invalid .dx-texteditor-input-container::after,
.dx-rtl .dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-valid .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-invalid .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin.dx-numberbox-box.dx-editor-underlined.dx-valid .dx-texteditor-input-container::after {
  left: 6px;
  right: auto;
}
.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined .dx-texteditor-input {
  padding-right: 16px;
}
.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-invalid.dx-editor-underlined .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-valid.dx-editor-underlined .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-invalid.dx-editor-underlined .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-valid.dx-editor-underlined .dx-texteditor-input {
  padding-right: 46px;
}
.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-invalid.dx-editor-underlined.dx-rtl .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-valid.dx-editor-underlined.dx-rtl .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-invalid.dx-editor-underlined.dx-rtl .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-valid.dx-editor-underlined.dx-rtl .dx-texteditor-input {
  padding-left: 46px;
  padding-right: 0;
}
.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-invalid.dx-editor-filled .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-invalid.dx-editor-outlined .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-valid.dx-editor-filled .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-valid.dx-editor-outlined .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-invalid.dx-editor-filled .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-invalid.dx-editor-outlined .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-valid.dx-editor-filled .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-valid.dx-editor-outlined .dx-texteditor-input {
  padding-right: 62px;
}
.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-invalid.dx-editor-filled.dx-rtl .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-invalid.dx-editor-outlined.dx-rtl .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-valid.dx-editor-filled.dx-rtl .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-valid.dx-editor-outlined.dx-rtl .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-invalid.dx-editor-filled.dx-rtl .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-invalid.dx-editor-outlined.dx-rtl .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-valid.dx-editor-filled.dx-rtl .dx-texteditor-input,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-valid.dx-editor-outlined.dx-rtl .dx-texteditor-input {
  padding: 15px 16px 14px 62px;
}
.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-invalid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-invalid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-valid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-valid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-invalid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-invalid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-valid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-valid.dx-editor-outlined .dx-texteditor-input-container::after {
  right: 12px;
}
.dx-rtl .dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-invalid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl .dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-invalid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-rtl .dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-valid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl .dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-valid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-rtl .dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-invalid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl .dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-invalid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-rtl .dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-valid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl .dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-valid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-invalid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-invalid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-valid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-valid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-invalid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-invalid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-valid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-valid.dx-editor-outlined .dx-texteditor-input-container::after {
  left: 12px;
  right: auto;
}
.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-invalid .dx-texteditor-input-container::after,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-valid .dx-texteditor-input-container::after,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-invalid .dx-texteditor-input-container::after,
.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-valid .dx-texteditor-input-container::after {
  right: 6px;
}
.dx-rtl .dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-invalid .dx-texteditor-input-container::after,
.dx-rtl .dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-valid .dx-texteditor-input-container::after,
.dx-rtl .dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-invalid .dx-texteditor-input-container::after,
.dx-rtl .dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-valid .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-invalid .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin.dx-numberbox-box.dx-editor-filled.dx-valid .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-invalid .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin.dx-numberbox-box.dx-editor-outlined.dx-valid .dx-texteditor-input-container::after {
  left: 6px;
  right: auto;
}
.dx-numberbox-spin-touch-friendly.dx-invalid.dx-editor-underlined .dx-texteditor-input,
.dx-numberbox-spin-touch-friendly.dx-valid.dx-editor-underlined .dx-texteditor-input {
  padding-right: 46px;
}
.dx-numberbox-spin-touch-friendly.dx-invalid.dx-editor-underlined.dx-rtl .dx-texteditor-input,
.dx-numberbox-spin-touch-friendly.dx-valid.dx-editor-underlined.dx-rtl .dx-texteditor-input {
  padding-left: 46px;
  padding-right: 0;
}
.dx-numberbox-spin-touch-friendly.dx-invalid.dx-editor-filled .dx-texteditor-input,
.dx-numberbox-spin-touch-friendly.dx-invalid.dx-editor-outlined .dx-texteditor-input,
.dx-numberbox-spin-touch-friendly.dx-valid.dx-editor-filled .dx-texteditor-input,
.dx-numberbox-spin-touch-friendly.dx-valid.dx-editor-outlined .dx-texteditor-input {
  padding-right: 62px;
}
.dx-numberbox-spin-touch-friendly.dx-invalid.dx-editor-filled.dx-rtl .dx-texteditor-input,
.dx-numberbox-spin-touch-friendly.dx-invalid.dx-editor-outlined.dx-rtl .dx-texteditor-input,
.dx-numberbox-spin-touch-friendly.dx-valid.dx-editor-filled.dx-rtl .dx-texteditor-input,
.dx-numberbox-spin-touch-friendly.dx-valid.dx-editor-outlined.dx-rtl .dx-texteditor-input {
  padding: 15px 16px 14px 62px;
}
.dx-numberbox-spin-touch-friendly.dx-invalid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-numberbox-spin-touch-friendly.dx-invalid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-numberbox-spin-touch-friendly.dx-valid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-numberbox-spin-touch-friendly.dx-valid.dx-editor-outlined .dx-texteditor-input-container::after {
  right: 12px;
}
.dx-rtl .dx-numberbox-spin-touch-friendly.dx-invalid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl .dx-numberbox-spin-touch-friendly.dx-invalid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-rtl .dx-numberbox-spin-touch-friendly.dx-valid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl .dx-numberbox-spin-touch-friendly.dx-valid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin-touch-friendly.dx-invalid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin-touch-friendly.dx-invalid.dx-editor-outlined .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin-touch-friendly.dx-valid.dx-editor-filled .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin-touch-friendly.dx-valid.dx-editor-outlined .dx-texteditor-input-container::after {
  left: 12px;
  right: auto;
}
.dx-numberbox-spin-touch-friendly.dx-invalid .dx-texteditor-input-container::after,
.dx-numberbox-spin-touch-friendly.dx-valid .dx-texteditor-input-container::after {
  right: 6px;
}
.dx-rtl .dx-numberbox-spin-touch-friendly.dx-invalid .dx-texteditor-input-container::after,
.dx-rtl .dx-numberbox-spin-touch-friendly.dx-valid .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin-touch-friendly.dx-invalid .dx-texteditor-input-container::after,
.dx-rtl.dx-numberbox-spin-touch-friendly.dx-valid .dx-texteditor-input-container::after {
  left: 6px;
  right: auto;
}
.dx-numberbox-spin-touch-friendly .dx-numberbox-spin-container {
  width: 74px;
  border-left: none;
}
.dx-numberbox-spin-touch-friendly .dx-numberbox-spin-down-icon,
.dx-numberbox-spin-touch-friendly .dx-numberbox-spin-up-icon {
  background-position: center;
}
.dx-numberbox-spin-touch-friendly.dx-editor-underlined.dx-show-clear-button .dx-texteditor-input {
  padding-right: 0;
}
.dx-numberbox-spin-touch-friendly.dx-editor-filled.dx-show-clear-button .dx-texteditor-input,
.dx-numberbox-spin-touch-friendly.dx-editor-outlined.dx-show-clear-button .dx-texteditor-input {
  padding-right: 16px;
}
.dx-numberbox.dx-rtl.dx-numberbox-spin-touch-friendly .dx-numberbox-spin-container,
.dx-rtl .dx-numberbox.dx-numberbox-spin-touch-friendly .dx-numberbox-spin-container {
  border-right: none;
}
.dx-numberbox.dx-rtl.dx-numberbox-spin-touch-friendly.dx-show-clear-button .dx-texteditor-input,
.dx-numberbox.dx-rtl.dx-numberbox-spin.dx-show-clear-button .dx-texteditor-input,
.dx-rtl .dx-numberbox.dx-numberbox-spin-touch-friendly.dx-show-clear-button .dx-texteditor-input,
.dx-rtl .dx-numberbox.dx-numberbox-spin.dx-show-clear-button .dx-texteditor-input {
  padding-left: 24px;
}
.dx-numberbox.dx-rtl.dx-numberbox-spin.dx-editor-underlined .dx-texteditor-input,
.dx-rtl .dx-numberbox.dx-numberbox-spin.dx-editor-underlined .dx-texteditor-input {
  padding-left: 0;
}
.dx-numberbox.dx-rtl.dx-numberbox-spin.dx-editor-filled .dx-texteditor-input,
.dx-numberbox.dx-rtl.dx-numberbox-spin.dx-editor-outlined .dx-texteditor-input,
.dx-rtl .dx-numberbox.dx-numberbox-spin.dx-editor-filled .dx-texteditor-input,
.dx-rtl .dx-numberbox.dx-numberbox-spin.dx-editor-outlined .dx-texteditor-input {
  padding-left: 16px;
}
.dx-calendar {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  direction: ltr;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border: 1px solid transparent;
  width: 272px;
  height: 264px;
  background-color: #fff;
  gap: 8px;
}
.dx-calendar.dx-rtl {
  direction: rtl;
}
.dx-calendar-views-wrapper {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: auto;
  flex: auto;
}
.dx-calendar-navigator {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.dx-calendar-navigator .dx-calendar-caption-button {
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  overflow: hidden;
}
.dx-calendar-navigator .dx-button .dx-button-text {
  text-transform: none;
}
.dx-calendar-navigator .dx-button.dx-state-disabled {
  opacity: 1;
}
.dx-calendar-navigator .dx-button.dx-state-disabled .dx-button-content {
  opacity: .5;
}
.dx-calendar-navigator .dx-button.dx-state-active,
.dx-calendar-navigator .dx-button.dx-state-hover {
  z-index: 1;
}
.dx-calendar-body {
  overflow: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.dx-calendar-body .dx-widget {
  position: absolute;
  width: 100%;
  height: 100%;
}
.dx-calendar-body table {
  width: 100%;
  height: 100%;
  table-layout: fixed;
  border-spacing: 0;
  line-height: normal;
}
.dx-calendar-body td,
.dx-calendar-body th {
  padding: 0;
}
.dx-calendar-body thead th {
  font-weight: 500;
  font-size: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: rgba(0,0,0,.87);
}
.dx-calendar-week-number-cell {
  position: relative;
  color: rgba(0,0,0,.56);
  width: 2em;
}
.dx-calendar-week-number-cell span {
  position: absolute;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  text-align: center;
  width: 2em;
  inset: 0;
  background-color: rgba(224,224,224,.4);
  inset-inline-start: 0;
}
.dx-calendar-cell {
  cursor: pointer;
  position: relative;
  text-align: center;
  font-size: 14px;
  color: rgba(0,0,0,.87);
}
.dx-calendar-cell span {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: relative;
  z-index: 2;
  border-radius: 50%;
  width: 2em;
  height: 2em;
}
.dx-calendar-footer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.dx-calendar-multiview .dx-calendar-caption-button .dx-button-content {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.dx-calendar-multiview .dx-calendar-body .dx-widget,
.dx-calendar-multiview .dx-calendar-caption-button .dx-button-text {
  width: 50%;
}
.dx-calendar-multiview .dx-calendar-body table {
  padding: 0 10px;
}
.dx-calendar.dx-calendar-with-footer {
  height: 308px;
}
.dx-calendar.dx-calendar-multiview {
  width: 544px;
}
.dx-calendar.dx-invalid {
  border-color: rgba(244,67,54,.4);
}
.dx-calendar.dx-invalid.dx-state-focused {
  border-color: #f44336;
}
.dx-calendar-navigator-next-view.dx-button .dx-icon,
.dx-calendar-navigator-previous-view.dx-button .dx-icon {
  width: 24px;
  height: 24px;
  font-size: 24px;
}
.dx-calendar-body thead tr {
  height: 2em;
}
.dx-calendar-body tbody tr:first-of-type .dx-calendar-week-number-cell span {
  border-start-start-radius: 4px;
  border-start-end-radius: 4px;
}
.dx-calendar-body tbody tr:last-of-type .dx-calendar-week-number-cell span {
  border-end-start-radius: 4px;
  border-end-end-radius: 4px;
}
.dx-calendar-body .dx-week-number-header {
  font-size: 14px;
  width: 2.5em;
}
.dx-calendar-view-century .dx-calendar-cell span,
.dx-calendar-view-decade .dx-calendar-cell span,
.dx-calendar-view-year .dx-calendar-cell span {
  width: 4em;
  height: 4em;
  border-radius: 4px;
  word-spacing: 4em;
  line-height: 1em;
}
.dx-calendar-cell.dx-calendar-today span {
  border: 2px solid #009688;
}
.dx-calendar-cell.dx-state-hover span {
  background-color: rgba(0,150,136,.24);
  color: rgba(0,0,0,.87);
}
.dx-calendar-cell.dx-state-active span {
  background-color: rgba(0,150,136,.4);
}
.dx-calendar-cell.dx-calendar-selected-date span {
  color: #fff;
  background-color: #009688;
}
.dx-calendar-cell.dx-calendar-contoured-date span {
  -webkit-box-shadow: 0 0 0 2px rgba(0,150,136,.5);
  box-shadow: 0 0 0 2px rgba(0,150,136,.5);
}
.dx-calendar-cell.dx-calendar-empty-cell,
.dx-calendar-cell.dx-calendar-empty-cell.dx-state-active span,
.dx-calendar-cell.dx-calendar-empty-cell.dx-state-hover span,
.dx-calendar-cell.dx-calendar-other-view,
.dx-calendar-cell.dx-calendar-other-view.dx-state-active span,
.dx-calendar-cell.dx-calendar-other-view.dx-state-hover span {
  color: rgba(0,0,0,.38);
}
.dx-calendar-cell.dx-calendar-empty-cell.dx-calendar-selected-date span,
.dx-calendar-cell.dx-calendar-other-view.dx-calendar-selected-date span {
  color: #fff;
}
.dx-calendar-cell.dx-calendar-other-view::after,
.dx-calendar-cell.dx-calendar-other-view::before {
  content: none;
}
.dx-calendar-cell.dx-calendar-other-view.dx-calendar-cell-in-range.dx-state-active span,
.dx-calendar-cell.dx-calendar-other-view.dx-calendar-cell-in-range.dx-state-hover span,
.dx-calendar-cell.dx-calendar-other-view.dx-calendar-cell-range-hover.dx-state-active span,
.dx-calendar-cell.dx-calendar-other-view.dx-calendar-cell-range-hover.dx-state-hover span,
.dx-calendar-cell.dx-calendar-other-view.dx-calendar-range-end-date.dx-state-active span,
.dx-calendar-cell.dx-calendar-other-view.dx-calendar-range-end-date.dx-state-hover span,
.dx-calendar-cell.dx-calendar-other-view.dx-calendar-range-start-date.dx-state-active span,
.dx-calendar-cell.dx-calendar-other-view.dx-calendar-range-start-date.dx-state-hover span {
  color: rgba(0,0,0,.38);
}
.dx-calendar-cell.dx-calendar-other-view.dx-calendar-cell-in-range.dx-state-hover span,
.dx-calendar-cell.dx-calendar-other-view.dx-calendar-cell-range-hover.dx-state-hover span,
.dx-calendar-cell.dx-calendar-other-view.dx-calendar-range-end-date.dx-state-hover span,
.dx-calendar-cell.dx-calendar-other-view.dx-calendar-range-start-date.dx-state-hover span {
  background-color: rgba(0,150,136,.24);
}
.dx-calendar-cell.dx-calendar-other-view.dx-calendar-cell-in-range.dx-state-active span,
.dx-calendar-cell.dx-calendar-other-view.dx-calendar-cell-range-hover.dx-state-active span,
.dx-calendar-cell.dx-calendar-other-view.dx-calendar-range-end-date.dx-state-active span,
.dx-calendar-cell.dx-calendar-other-view.dx-calendar-range-start-date.dx-state-active span {
  background-color: rgba(0,150,136,.4);
}
.dx-calendar-cell.dx-calendar-other-view.dx-calendar-cell-in-range span,
.dx-calendar-cell.dx-calendar-other-view.dx-calendar-cell-range-hover span,
.dx-calendar-cell.dx-calendar-other-view.dx-calendar-range-end-date span,
.dx-calendar-cell.dx-calendar-other-view.dx-calendar-range-start-date span {
  color: rgba(0,0,0,.38);
  background-color: transparent;
}
.dx-calendar-cell.dx-calendar-empty-cell {
  cursor: default;
  color: rgba(0,0,0,.24);
}
.dx-calendar-cell.dx-calendar-empty-cell.dx-state-active span,
.dx-calendar-cell.dx-calendar-empty-cell.dx-state-hover span {
  background-color: transparent;
}
.dx-calendar-cell.dx-calendar-empty-cell.dx-state-active.dx-calendar-selected-date span,
.dx-calendar-cell.dx-calendar-empty-cell.dx-state-hover.dx-calendar-selected-date span {
  background-color: #009688;
}
.dx-calendar-cell-in-range::before {
  content: "";
  position: absolute;
  z-index: 1;
  height: 2em;
  inset-inline-start: 0;
  inset-inline-end: 0;
  width: 100%;
  background-color: rgba(0,150,136,.24);
  border-width: 0;
  border-style: dashed;
  border-color: rgba(0,150,136,.6) transparent;
}
.dx-calendar-cell-in-range.dx-calendar-cell-end-in-row::before,
.dx-calendar-cell-in-range.dx-calendar-cell-end::before,
.dx-calendar-cell-in-range.dx-calendar-cell-start-in-row::before,
.dx-calendar-cell-in-range.dx-calendar-cell-start::before,
.dx-calendar-cell-in-range.dx-calendar-range-end-date::before,
.dx-calendar-cell-in-range.dx-calendar-range-start-date::before {
  width: calc(50% + 1em);
}
.dx-calendar-cell-in-range.dx-calendar-range-start-date::before {
  inset-inline-start: auto;
  border-start-start-radius: 999em;
  border-end-start-radius: 999em;
  border-inline-start-color: rgba(0,150,136,0.6);
}
.dx-calendar-cell-in-range.dx-calendar-range-start-date.dx-calendar-range-end-date::before {
  content: none;
}
.dx-calendar-cell-in-range.dx-calendar-range-end-date::before {
  border-start-end-radius: 999em;
  border-end-end-radius: 999em;
  border-inline-end-color: rgba(0,150,136,0.6);
}
.dx-calendar-cell-in-range.dx-calendar-cell-start-in-row::before {
  inset-inline-start: auto;
  border-start-start-radius: 999em;
  border-end-start-radius: 999em;
  border-inline-start-color: rgba(0,150,136,0.6);
}
.dx-calendar-cell-in-range.dx-calendar-cell-start-in-row.dx-calendar-cell-end::before,
.dx-calendar-cell-in-range.dx-calendar-cell-start-in-row.dx-calendar-range-end-date::before {
  width: 2em;
  inset-inline-start: calc(50% - 1em);
  inset-inline-end: auto;
}
.dx-calendar-cell-in-range.dx-calendar-cell-end-in-row::before {
  border-start-end-radius: 999em;
  border-end-end-radius: 999em;
  border-inline-end-color: rgba(0,150,136,0.6);
}
.dx-calendar-cell-in-range.dx-calendar-cell-end-in-row.dx-calendar-range-start-date::before {
  width: 2em;
  inset-inline-start: calc(50% - 1em);
  inset-inline-end: auto;
}
.dx-calendar-cell-in-range.dx-calendar-cell-start::before {
  inset-inline-start: auto;
  border-start-start-radius: 999em;
  border-end-start-radius: 999em;
  border-inline-start-color: rgba(0,150,136,0.6);
}
.dx-calendar-cell-in-range.dx-calendar-cell-start.dx-calendar-range-end-date::before {
  width: 2em;
  inset-inline-start: calc(50% - 1em);
  inset-inline-end: auto;
  border-start-end-radius: 999em;
  border-end-end-radius: 999em;
  border-inline-end-color: rgba(0,150,136,0.6);
}
.dx-calendar-cell-in-range.dx-calendar-cell-start.dx-calendar-cell-end-in-row::before {
  width: 2em;
  inset-inline-start: calc(50% - 1em);
  inset-inline-end: auto;
}
.dx-calendar-cell-in-range.dx-calendar-cell-end::before {
  border-start-end-radius: 999em;
  border-end-end-radius: 999em;
  border-inline-end-color: rgba(0,150,136,0.6);
}
.dx-calendar-cell-in-range.dx-calendar-cell-end.dx-calendar-range-start-date::before {
  width: 2em;
  inset-inline-start: calc(50% - 1em);
  inset-inline-end: auto;
}
.dx-calendar-cell-range-hover::after {
  content: "";
  position: absolute;
  z-index: 1;
  height: 2em;
  inset-inline-start: 0;
  inset-inline-end: 0;
  width: 100%;
  background-color: inherit;
  border-width: 1px;
  border-style: dashed;
  border-color: rgba(0,150,136,.6) transparent;
}
.dx-calendar-cell-range-hover.dx-calendar-cell-end-in-row::after,
.dx-calendar-cell-range-hover.dx-calendar-cell-end::after,
.dx-calendar-cell-range-hover.dx-calendar-cell-range-hover-end::after,
.dx-calendar-cell-range-hover.dx-calendar-cell-range-hover-start::after,
.dx-calendar-cell-range-hover.dx-calendar-cell-start-in-row::after,
.dx-calendar-cell-range-hover.dx-calendar-cell-start::after {
  width: calc(50% + 1em);
}
.dx-calendar-cell-range-hover.dx-calendar-cell-range-hover-start::after {
  inset-inline-start: auto;
  border-start-start-radius: 999em;
  border-end-start-radius: 999em;
  border-inline-start-color: rgba(0,150,136,0.6);
}
.dx-calendar-cell-range-hover.dx-calendar-cell-range-hover-start.dx-calendar-cell-range-hover-end::after {
  content: none;
}
.dx-calendar-cell-range-hover.dx-calendar-cell-range-hover-end::after {
  border-start-end-radius: 999em;
  border-end-end-radius: 999em;
  border-inline-end-color: rgba(0,150,136,0.6);
}
.dx-calendar-cell-range-hover.dx-calendar-cell-start-in-row::after {
  inset-inline-start: auto;
  border-start-start-radius: 999em;
  border-end-start-radius: 999em;
  border-inline-start-color: rgba(0,150,136,0.6);
}
.dx-calendar-cell-range-hover.dx-calendar-cell-start-in-row.dx-calendar-cell-end::after,
.dx-calendar-cell-range-hover.dx-calendar-cell-start-in-row.dx-calendar-cell-range-hover-end::after {
  width: 2em;
  inset-inline-start: calc(50% - 1em);
  inset-inline-end: auto;
}
.dx-calendar-cell-range-hover.dx-calendar-cell-end-in-row::after {
  border-start-end-radius: 999em;
  border-end-end-radius: 999em;
  border-inline-end-color: rgba(0,150,136,0.6);
}
.dx-calendar-cell-range-hover.dx-calendar-cell-end-in-row.dx-calendar-cell-range-hover-start::after {
  width: 2em;
  inset-inline-start: calc(50% - 1em);
  inset-inline-end: auto;
}
.dx-calendar-cell-range-hover.dx-calendar-cell-start::after {
  inset-inline-start: auto;
  border-start-start-radius: 999em;
  border-end-start-radius: 999em;
  border-inline-start-color: rgba(0,150,136,0.6);
}
.dx-calendar-cell-range-hover.dx-calendar-cell-start.dx-calendar-cell-range-hover-end::after {
  width: 2em;
  inset-inline-start: calc(50% - 1em);
  inset-inline-end: auto;
  border-start-end-radius: 999em;
  border-end-end-radius: 999em;
  border-inline-end-color: rgba(0,150,136,0.6);
}
.dx-calendar-cell-range-hover.dx-calendar-cell-start.dx-calendar-cell-end-in-row::after {
  width: 2em;
  inset-inline-start: calc(50% - 1em);
  inset-inline-end: auto;
}
.dx-calendar-cell-range-hover.dx-calendar-cell-end::after {
  border-start-end-radius: 999em;
  border-end-end-radius: 999em;
  border-inline-end-color: rgba(0,150,136,0.6);
}
.dx-calendar-cell-range-hover.dx-calendar-cell-end.dx-calendar-cell-range-hover-start::after {
  width: 2em;
  inset-inline-start: calc(50% - 1em);
  inset-inline-end: auto;
}
.dx-texteditor input[type=date]::-webkit-inner-spin-button {
  height: 20px;
}
.dx-datebox-native.dx-state-focused.dx-texteditor-empty .dx-placeholder {
  display: none;
}
.dx-datebox {
  max-width: 100%;
}
.dx-datebox .dx-texteditor-input::-webkit-datetime-edit {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dx-datebox.dx-texteditor-empty input::-webkit-datetime-edit {
  color: transparent;
}
.dx-datebox.dx-texteditor-empty.dx-state-focused input::-webkit-datetime-edit {
  color: inherit;
}
.dx-datebox-wrapper .dx-popup-content {
  padding-top: 20px;
  padding-bottom: 20px;
}
.dx-rtl .dx-texteditor-input {
  text-align: right;
}
.dx-datebox-button-cell .dx-button {
  min-width: 90px;
}
.dx-datebox-button-cell .dx-button.dx-datebox-apply-button {
  margin-right: 10px;
  margin-left: 0;
}
.dx-datebox-button-cell .dx-button.dx-datebox-cancel-button {
  margin-right: 0;
  margin-left: 0;
}
.dx-datebox-buttons-container {
  text-align: right;
  width: 100%;
}
.dx-timeview .dx-state-disabled .dx-widget,
.dx-timeview .dx-state-disabled.dx-widget,
.dx-timeview.dx-state-disabled .dx-widget,
.dx-timeview.dx-state-disabled.dx-widget {
  opacity: 1;
}
.dx-timeview-clock {
  position: relative;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22182%22%20height%3D%22182%22%20viewBox%3D%220%200%20182%20182%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20filter%3D%22url(%23filter0_d)%22%3E%0A%3Ccircle%20cx%3D%2291%22%20cy%3D%2291%22%20r%3D%2285%22%20fill%3D%22%23fff%22%2F%3E%0A%3Cpath%20d%3D%22M88.835%2015.4421V23.2701H87.153V17.3431C87.0605%2017.4249%2086.9501%2017.5033%2086.8219%2017.578C86.6974%2017.6492%2086.5639%2017.7151%2086.4215%2017.7756C86.2791%2017.8325%2086.1313%2017.8824%2085.9783%2017.9251C85.8252%2017.9642%2085.6739%2017.9927%2085.5244%2018.0105V16.5902C85.9623%2016.462%2086.3752%2016.2983%2086.7632%2016.0989C87.1512%2015.8996%2087.5019%2015.6806%2087.8151%2015.4421H88.835Z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%20%2F%3E%0A%3Cpath%20d%3D%22M92.9733%2021.8711H96.2198V23.2701H91.1257V22.6934C91.1257%2022.3019%2091.1916%2021.9512%2091.3233%2021.6415C91.455%2021.3282%2091.6205%2021.0488%2091.8199%2020.8032C92.0192%2020.554%2092.2364%2020.3351%2092.4713%2020.1464C92.7098%2019.9542%2092.9359%2019.7815%2093.1495%2019.6285C93.3737%2019.4683%2093.5695%2019.3152%2093.7368%2019.1692C93.9077%2019.0233%2094.0501%2018.8791%2094.164%2018.7367C94.2815%2018.5908%2094.3687%2018.4448%2094.4257%2018.2989C94.4826%2018.1494%2094.5111%2017.9909%2094.5111%2017.8236C94.5111%2017.4961%2094.4185%2017.2487%2094.2334%2017.0814C94.0483%2016.9141%2093.7653%2016.8305%2093.3844%2016.8305C92.7259%2016.8305%2092.0958%2017.0921%2091.4942%2017.6154V16.131C92.1599%2015.7002%2092.911%2015.4849%2093.7475%2015.4849C94.1355%2015.4849%2094.4826%2015.5365%2094.7888%2015.6397C95.0985%2015.7394%2095.3601%2015.8836%2095.5737%2016.0722C95.7873%2016.2609%2095.9492%2016.4905%2096.0596%2016.761C96.1735%2017.028%2096.2305%2017.327%2096.2305%2017.6581C96.2305%2018.0105%2096.1753%2018.3238%2096.0649%2018.5979C95.9581%2018.872%2095.814%2019.1212%2095.6324%2019.3454C95.4544%2019.5697%2095.248%2019.7762%2095.013%2019.9649C94.7781%2020.15%2094.5342%2020.3297%2094.2815%2020.5042C94.1106%2020.6252%2093.9451%2020.7462%2093.7849%2020.8673C93.6283%2020.9847%2093.4894%2021.1022%2093.3684%2021.2197C93.2474%2021.3336%2093.1513%2021.4457%2093.0801%2021.5561C93.0089%2021.6664%2092.9733%2021.7714%2092.9733%2021.8711Z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%20%2F%3E%0A%3Cpath%20d%3D%22M93.3369%20165.802C93.3369%20166.179%2093.2711%20166.531%2093.1394%20166.859C93.0076%20167.186%2092.8243%20167.471%2092.5894%20167.713C92.3544%20167.952%2092.075%20168.14%2091.751%20168.279C91.4271%20168.415%2091.0729%20168.482%2090.6884%20168.482C90.2577%20168.482%2089.8715%20168.402%2089.5297%20168.242C89.1915%20168.082%2088.905%20167.85%2088.67%20167.548C88.4351%20167.242%2088.2553%20166.868%2088.1307%20166.426C88.0061%20165.985%2087.9438%20165.485%2087.9438%20164.926C87.9438%20164.267%2088.0239%20163.671%2088.1841%20163.137C88.3479%20162.6%2088.5793%20162.14%2088.8783%20161.759C89.1809%20161.379%2089.5457%20161.085%2089.9729%20160.878C90.4001%20160.668%2090.8807%20160.563%2091.4146%20160.563C92.0056%20160.563%2092.4648%20160.633%2092.7923%20160.772V162.181C92.4043%20161.961%2091.9806%20161.85%2091.5214%20161.85C91.2366%20161.85%2090.9786%20161.905%2090.7472%20162.016C90.5158%20162.126%2090.3164%20162.283%2090.1491%20162.486C89.9854%20162.689%2089.8554%20162.934%2089.7593%20163.223C89.6668%20163.507%2089.6169%20163.826%2089.6098%20164.178H89.6419C90.005%20163.676%2090.5407%20163.425%2091.2491%20163.425C91.5659%20163.425%2091.8525%20163.482%2092.1088%20163.596C92.3651%20163.71%2092.584%20163.872%2092.7656%20164.082C92.9471%20164.289%2093.0877%20164.538%2093.1874%20164.83C93.2871%20165.122%2093.3369%20165.446%2093.3369%20165.802ZM91.687%20165.908C91.687%20165.086%2091.3506%20164.675%2090.6778%20164.675C90.5247%20164.675%2090.3859%20164.703%2090.2613%20164.76C90.1367%20164.817%2090.0299%20164.897%2089.9409%20165.001C89.8519%20165.104%2089.7825%20165.227%2089.7326%20165.369C89.6864%20165.508%2089.6632%20165.663%2089.6632%20165.834C89.6632%20166.022%2089.6881%20166.199%2089.738%20166.362C89.7878%20166.526%2089.8572%20166.67%2089.9462%20166.795C90.0388%20166.916%2090.1474%20167.012%2090.2719%20167.083C90.3965%20167.154%2090.5354%20167.19%2090.6884%20167.19C90.8415%20167.19%2090.9786%20167.16%2091.0996%20167.099C91.2242%20167.035%2091.3292%20166.948%2091.4146%20166.838C91.5036%20166.724%2091.5713%20166.588%2091.6175%20166.432C91.6638%20166.272%2091.687%20166.097%2091.687%20165.908Z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%20%2F%3E%0A%3Cpath%20d%3D%22M125.714%20155.329C125.714%20155.703%20125.649%20156.041%20125.521%20156.344C125.393%20156.646%20125.21%20156.906%20124.971%20157.123C124.736%20157.341%20124.452%20157.508%20124.117%20157.625C123.782%20157.743%20123.41%20157.802%20123.001%20157.802C122.289%20157.802%20121.76%20157.695%20121.415%20157.481V156.552C121.935%20156.887%20122.467%20157.054%20123.012%20157.054C123.289%20157.054%20123.539%20157.013%20123.759%20156.931C123.983%20156.849%20124.174%20156.735%20124.331%20156.589C124.487%20156.443%20124.606%20156.267%20124.688%20156.061C124.774%20155.854%20124.816%20155.628%20124.816%20155.383C124.816%20154.884%20124.649%20154.494%20124.315%20154.213C123.98%20153.928%20123.494%20153.786%20122.857%20153.786C122.754%20153.786%20122.645%20153.788%20122.531%20153.791C122.417%20153.795%20122.303%20153.8%20122.189%20153.807C122.075%20153.811%20121.963%20153.816%20121.853%20153.823C121.746%20153.831%20121.648%20153.839%20121.559%20153.85L121.821%20150.011H125.361V150.801H122.579L122.424%20153.049C122.538%20153.042%20122.659%20153.037%20122.787%20153.033C122.916%20153.026%20123.029%20153.022%20123.129%20153.022C123.535%20153.022%20123.898%20153.076%20124.218%20153.183C124.539%20153.289%20124.809%20153.443%20125.03%20153.642C125.254%20153.838%20125.423%20154.08%20125.537%20154.368C125.655%20154.653%20125.714%20154.973%20125.714%20155.329Z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%20%2F%3E%0A%3Cpath%20d%3D%22M124.405%2033.9508H123.53V27.3349C123.462%2027.4025%20123.362%2027.4808%20123.231%2027.5698C123.102%2027.6553%20122.956%2027.7407%20122.793%2027.8261C122.633%2027.9116%20122.462%2027.9917%20122.28%2028.0664C122.102%2028.1412%20121.928%2028.1999%20121.757%2028.2426V27.3562C121.949%2027.3029%20122.152%2027.2317%20122.366%2027.1427C122.583%2027.0501%20122.795%2026.9487%20123.001%2026.8383C123.211%2026.7244%20123.409%2026.6069%20123.594%2026.4859C123.779%2026.3613%20123.939%2026.2403%20124.074%2026.1228H124.405V33.9508Z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%20%2F%3E%0A%3Cpath%20d%3D%22M152.67%20123.309V128.366H153.652V129.167H152.67V130.966H151.805V129.167H148.206V128.409C148.54%20128.031%20148.879%20127.629%20149.22%20127.202C149.562%20126.771%20149.888%20126.335%20150.198%20125.894C150.511%20125.452%20150.799%20125.013%20151.063%20124.575C151.33%20124.133%20151.554%20123.712%20151.735%20123.309H152.67ZM149.194%20128.366H151.805V124.618C151.538%20125.084%20151.285%20125.5%20151.047%20125.867C150.808%20126.234%20150.58%20126.567%20150.363%20126.866C150.149%20127.165%20149.945%20127.435%20149.749%20127.677C149.553%20127.919%20149.368%20128.149%20149.194%20128.366Z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%20%2F%3E%0A%3Cpath%20d%3D%22M152.253%2052.3328C152.253%2052.0979%20152.216%2051.8932%20152.141%2051.7187C152.07%2051.5443%20151.97%2051.4001%20151.842%2051.2862C151.718%2051.1687%20151.57%2051.0815%20151.399%2051.0246C151.228%2050.9676%20151.043%2050.9391%20150.844%2050.9391C150.673%2050.9391%20150.505%2050.9623%20150.342%2051.0086C150.178%2051.0548%20150.018%2051.1189%20149.861%2051.2008C149.708%2051.2827%20149.559%2051.3806%20149.413%2051.4945C149.27%2051.6084%20149.137%2051.7348%20149.012%2051.8736V50.9338C149.258%2050.6953%20149.532%2050.5137%20149.834%2050.3892C150.141%2050.261%20150.513%2050.1969%20150.95%2050.1969C151.264%2050.1969%20151.554%2050.2432%20151.821%2050.3358C152.088%2050.4248%20152.319%2050.5565%20152.515%2050.7309C152.711%2050.9053%20152.864%2051.1207%20152.974%2051.377C153.088%2051.6333%20153.145%2051.927%20153.145%2052.258C153.145%2052.5606%20153.109%2052.8347%20153.038%2053.0804C152.971%2053.326%20152.866%2053.5574%20152.723%2053.7745C152.584%2053.9917%20152.408%2054.1999%20152.195%2054.3993C151.981%2054.5986%20151.73%2054.8015%20151.442%2055.008C151.082%2055.2643%20150.785%2055.4832%20150.55%2055.6648C150.319%2055.8463%20150.133%2056.0172%20149.995%2056.1774C149.859%2056.334%20149.763%2056.4924%20149.706%2056.6526C149.653%2056.8092%20149.626%2056.9908%20149.626%2057.1973H153.439V57.9822H148.713V57.6031C148.713%2057.2756%20148.749%2056.9872%20148.82%2056.738C148.891%2056.4889%20149.009%2056.2521%20149.172%2056.0279C149.336%2055.8036%20149.55%2055.5793%20149.813%2055.3551C150.08%2055.1308%20150.406%2054.878%20150.79%2054.5968C151.068%2054.3975%20151.299%2054.207%20151.484%2054.0255C151.673%2053.8439%20151.824%2053.6624%20151.938%2053.4808C152.052%2053.2993%20152.132%2053.116%20152.179%2052.9308C152.228%2052.7422%20152.253%2052.5428%20152.253%2052.3328Z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%20%2F%3E%0A%3Cpath%20d%3D%22M162.324%2096.0035V94.535C162.837%2094.9088%20163.435%2095.0957%20164.118%2095.0957C164.549%2095.0957%20164.884%2095.0032%20165.122%2094.8181C165.364%2094.6329%20165.485%2094.3749%20165.485%2094.0438C165.485%2093.7021%20165.336%2093.4386%20165.037%2093.2535C164.741%2093.0684%20164.334%2092.9759%20163.814%2092.9759H163.104V91.6837H163.761C164.757%2091.6837%20165.256%2091.3526%20165.256%2090.6905C165.256%2090.0675%20164.873%2089.756%20164.108%2089.756C163.595%2089.756%20163.097%2089.9216%20162.612%2090.2526V88.875C163.15%2088.6044%20163.777%2088.4692%20164.492%2088.4692C165.275%2088.4692%20165.884%2088.6454%20166.318%2088.9978C166.756%2089.3502%20166.975%2089.8076%20166.975%2090.3701C166.975%2091.3704%20166.468%2091.9969%20165.453%2092.2497V92.2764C165.994%2092.344%20166.421%2092.5416%20166.735%2092.8691C167.048%2093.193%20167.205%2093.5917%20167.205%2094.0652C167.205%2094.7807%20166.943%2095.3467%20166.42%2095.7632C165.896%2096.1797%20165.174%2096.3879%20164.252%2096.3879C163.461%2096.3879%20162.819%2096.2598%20162.324%2096.0035Z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%20%2F%3E%0A%3Cpath%20d%3D%22M19.8147%2092.0574C19.8147%2092.7374%2019.74%2093.3461%2019.5905%2093.8836C19.441%2094.4176%2019.222%2094.8697%2018.9337%2095.2399C18.6489%2095.6101%2018.3001%2095.8949%2017.8871%2096.0942C17.4742%2096.29%2017.0061%2096.3879%2016.4828%2096.3879C15.8563%2096.3879%2015.3169%2096.2882%2014.8649%2096.0889V94.7006C15.2671%2094.964%2015.7512%2095.0957%2016.3172%2095.0957C16.8975%2095.0957%2017.3514%2094.8981%2017.6789%2094.503C18.0064%2094.1079%2018.1719%2093.5365%2018.1755%2092.789L18.1434%2092.7783C17.8052%2093.2802%2017.2909%2093.5312%2016.6003%2093.5312C16.287%2093.5312%2015.9969%2093.4725%2015.7299%2093.355C15.4665%2093.2375%2015.2369%2093.0755%2015.0411%2092.8691C14.8488%2092.659%2014.6975%2092.4099%2014.5872%2092.1215C14.4804%2091.8332%2014.427%2091.5163%2014.427%2091.171C14.427%2090.7688%2014.4929%2090.4021%2014.6246%2090.0711C14.7563%2089.74%2014.9396%2089.4552%2015.1746%2089.2167C15.4131%2088.9782%2015.6978%2088.7949%2016.0289%2088.6667C16.36%2088.535%2016.7266%2088.4692%2017.1289%2088.4692C17.5454%2088.4692%2017.9192%2088.551%2018.2502%2088.7148C18.5813%2088.875%2018.8625%2089.1082%2019.0939%2089.4143C19.3288%2089.7204%2019.5068%2090.096%2019.6279%2090.541C19.7524%2090.9859%2019.8147%2091.4914%2019.8147%2092.0574ZM18.1114%2091.1604C18.1114%2090.9646%2018.0865%2090.7813%2018.0366%2090.6104C17.9868%2090.436%2017.9174%2090.2864%2017.8284%2090.1618C17.7394%2090.0373%2017.6308%2089.9394%2017.5027%2089.8682C17.3745%2089.7934%2017.2339%2089.756%2017.0808%2089.756C16.9349%2089.756%2016.7996%2089.7881%2016.675%2089.8521C16.554%2089.9162%2016.449%2090.0052%2016.36%2090.1191C16.271%2090.2295%2016.2016%2090.363%2016.1517%2090.5196C16.1019%2090.6762%2016.077%2090.8453%2016.077%2091.0269C16.077%2091.2262%2016.1019%2091.4042%2016.1517%2091.5608C16.2016%2091.7139%2016.271%2091.8438%2016.36%2091.9506C16.4525%2092.0574%2016.5629%2092.1393%2016.691%2092.1963C16.8192%2092.2497%2016.9616%2092.2764%2017.1182%2092.2764C17.2677%2092.2764%2017.403%2092.2479%2017.524%2092.1909C17.6451%2092.1304%2017.7483%2092.0503%2017.8337%2091.9506C17.9227%2091.851%2017.9904%2091.7335%2018.0366%2091.5982C18.0865%2091.463%2018.1114%2091.317%2018.1114%2091.1604Z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%20%2F%3E%0A%3Cpath%20d%3D%22M26.0617%20127.941C26.0617%20127.738%2026.0937%20127.535%2026.1578%20127.332C26.2219%20127.125%2026.3127%20126.933%2026.4301%20126.755C26.5512%20126.577%2026.6989%20126.415%2026.8733%20126.269C27.0513%20126.123%2027.2524%20126.008%2027.4767%20125.922C27.1456%20125.737%2026.8822%20125.5%2026.6864%20125.212C26.4906%20124.92%2026.3927%20124.598%2026.3927%20124.245C26.3927%20123.964%2026.4461%20123.704%2026.5529%20123.466C26.6633%20123.227%2026.8146%20123.021%2027.0068%20122.846C27.199%20122.672%2027.4269%20122.537%2027.6903%20122.441C27.9537%20122.341%2028.2385%20122.291%2028.5446%20122.291C28.8543%20122.291%2029.1409%20122.341%2029.4043%20122.441C29.6678%20122.54%2029.8956%20122.677%2030.0878%20122.852C30.28%20123.026%2030.4295%20123.233%2030.5363%20123.471C30.6431%20123.71%2030.6965%20123.968%2030.6965%20124.245C30.6965%20124.598%2030.5986%20124.92%2030.4028%20125.212C30.2071%20125.5%2029.9472%20125.737%2029.6233%20125.922C29.844%20126.008%2030.0415%20126.123%2030.216%20126.269C30.3904%20126.415%2030.5363%20126.577%2030.6538%20126.755C30.7748%20126.933%2030.8674%20127.125%2030.9315%20127.332C30.9956%20127.535%2031.0276%20127.738%2031.0276%20127.941C31.0276%20128.275%2030.9671%20128.581%2030.846%20128.859C30.725%20129.137%2030.5541%20129.375%2030.3334%20129.574C30.1163%20129.77%2029.8546%20129.923%2029.5485%20130.034C29.2459%20130.144%2028.9113%20130.199%2028.5446%20130.199C28.1815%20130.199%2027.8487%20130.144%2027.5461%20130.034C27.2435%20129.923%2026.9819%20129.77%2026.7612%20129.574C26.5405%20129.375%2026.3678%20129.137%2026.2432%20128.859C26.1222%20128.581%2026.0617%20128.275%2026.0617%20127.941ZM27.0122%20127.866C27.0122%20128.104%2027.0477%20128.32%2027.1189%20128.512C27.1937%20128.704%2027.2969%20128.868%2027.4286%20129.003C27.5639%20129.138%2027.7259%20129.243%2027.9146%20129.318C28.1068%20129.389%2028.3186%20129.425%2028.55%20129.425C28.7742%20129.425%2028.9807%20129.388%2029.1694%20129.313C29.3581%20129.238%2029.52%20129.133%2029.6553%20128.998C29.7941%20128.863%2029.9009%20128.699%2029.9757%20128.507C30.054%20128.314%2030.0931%20128.101%2030.0931%20127.866C30.0931%20127.652%2030.0558%20127.453%2029.981%20127.268C29.9098%20127.079%2029.8066%20126.914%2029.6713%20126.771C29.536%20126.629%2029.3741%20126.517%2029.1854%20126.435C28.9967%20126.353%2028.7849%20126.312%2028.55%20126.312C28.3293%20126.312%2028.1246%20126.351%2027.9359%20126.429C27.7508%20126.504%2027.5888%20126.611%2027.45%20126.75C27.3147%20126.885%2027.2079%20127.049%2027.1296%20127.241C27.0513%20127.43%2027.0122%20127.638%2027.0122%20127.866ZM27.2845%20124.315C27.2845%20124.496%2027.3165%20124.666%2027.3806%20124.822C27.4482%20124.975%2027.539%20125.111%2027.6529%20125.228C27.7704%20125.342%2027.9057%20125.433%2028.0587%20125.5C28.2118%20125.564%2028.3756%20125.596%2028.55%20125.596C28.7244%20125.596%2028.8882%20125.563%2029.0412%20125.495C29.1979%20125.427%2029.3331%20125.337%2029.447%20125.223C29.561%20125.105%2029.6517%20124.97%2029.7194%20124.817C29.787%20124.66%2029.8208%20124.493%2029.8208%20124.315C29.8208%20124.13%2029.787%20123.959%2029.7194%20123.802C29.6553%20123.646%2029.5663%20123.51%2029.4524%20123.396C29.3385%20123.283%2029.2032%20123.194%2029.0466%20123.129C28.8935%20123.062%2028.728%20123.028%2028.55%20123.028C28.3613%20123.028%2028.1887%20123.062%2028.032%20123.129C27.879%20123.197%2027.7455%20123.29%2027.6316%20123.407C27.5212%20123.521%2027.4358%20123.656%2027.3752%20123.813C27.3147%20123.97%2027.2845%20124.137%2027.2845%20124.315Z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%20%2F%3E%0A%3Cpath%20d%3D%22M56.7857%20152.298C56.6683%20152.501%2056.5259%20152.754%2056.3586%20153.057C56.1948%20153.359%2056.0204%20153.699%2055.8353%20154.076C55.6502%20154.454%2055.4615%20154.86%2055.2693%20155.294C55.077%20155.728%2054.8973%20156.177%2054.73%20156.64C54.5627%20157.102%2054.4149%20157.572%2054.2868%20158.049C54.1622%20158.523%2054.0714%20158.989%2054.0144%20159.448H53.0747C53.1387%20158.993%2053.2366%20158.528%2053.3683%20158.055C53.5036%20157.578%2053.6549%20157.111%2053.8222%20156.656C53.9931%20156.196%2054.1729%20155.755%2054.3615%20155.331C54.5502%20154.908%2054.7335%20154.518%2054.9115%20154.162C55.0895%20153.806%2055.2515%20153.493%2055.3974%20153.222C55.5469%20152.948%2055.6662%20152.734%2055.7552%20152.581H51.9159V151.791H56.7857V152.298Z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%20%2F%3E%0A%3Cpath%20d%3D%22M29.447%2060.6523H28.5713V54.0365C28.5037%2054.1041%2028.404%2054.1824%2028.2723%2054.2714C28.1442%2054.3568%2027.9982%2054.4423%2027.8345%2054.5277C27.6743%2054.6131%2027.5034%2054.6932%2027.3219%2054.768C27.1439%2054.8428%2026.9694%2054.9015%2026.7986%2054.9442V54.0578C26.9908%2054.0044%2027.1937%2053.9332%2027.4073%2053.8442C27.6244%2053.7517%2027.8362%2053.6502%2028.0427%2053.5399C28.2527%2053.426%2028.4503%2053.3085%2028.6354%2053.1875C28.8205%2053.0629%2028.9807%2052.9418%2029.116%2052.8244H29.447V60.6523Z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%20%2F%3E%0A%3Cpath%20d%3D%22M36.9226%2056.7917C36.9226%2057.4325%2036.8639%2058.0003%2036.7464%2058.4951C36.6325%2058.9899%2036.4652%2059.4082%2036.2445%2059.7499C36.0273%2060.0881%2035.7586%2060.3462%2035.4382%2060.5242C35.1214%2060.6986%2034.76%2060.7858%2034.3542%2060.7858C33.9698%2060.7858%2033.6262%2060.7022%2033.3237%2060.5349C33.0246%2060.364%2032.7719%2060.1166%2032.5654%2059.7926C32.359%2059.4687%2032.2023%2059.0718%2032.0955%2058.6019C31.9887%2058.1284%2031.9353%2057.5874%2031.9353%2056.9786C31.9353%2056.3094%2031.9905%2055.7185%2032.1009%2055.2059C32.2148%2054.6932%2032.3803%2054.2643%2032.5975%2053.919C32.8146%2053.5701%2033.0834%2053.3085%2033.4038%2053.1341C33.7277%2052.9561%2034.0979%2052.8671%2034.5144%2052.8671C36.1199%2052.8671%2036.9226%2054.1753%2036.9226%2056.7917ZM36.0255%2056.8772C36.0255%2054.6986%2035.5076%2053.6093%2034.4717%2053.6093C33.3788%2053.6093%2032.8324%2054.7182%2032.8324%2056.9359C32.8324%2059.0041%2033.3682%2060.0383%2034.4397%2060.0383C35.4969%2060.0383%2036.0255%2058.9846%2036.0255%2056.8772Z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%20%2F%3E%0A%3Cpath%20d%3D%22M57.0387%2033.9508H56.163V27.3349C56.0954%2027.4025%2055.9957%2027.4808%2055.864%2027.5698C55.7358%2027.6553%2055.5899%2027.7407%2055.4261%2027.8261C55.2659%2027.9116%2055.0951%2027.9917%2054.9135%2028.0664C54.7355%2028.1412%2054.5611%2028.1999%2054.3902%2028.2426V27.3562C54.5825%2027.3029%2054.7854%2027.2317%2054.9989%2027.1427C55.2161%2027.0501%2055.4279%2026.9487%2055.6344%2026.8383C55.8444%2026.7244%2056.042%2026.6069%2056.2271%2026.4859C56.4122%2026.3613%2056.5724%2026.2403%2056.7076%2026.1228H57.0387V33.9508Z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%20%2F%3E%0A%3Cpath%20d%3D%22M62.9337%2033.9508H62.058V27.3349C61.9904%2027.4025%2061.8907%2027.4808%2061.759%2027.5698C61.6308%2027.6553%2061.4849%2027.7407%2061.3211%2027.8261C61.1609%2027.9116%2060.9901%2027.9917%2060.8085%2028.0664C60.6305%2028.1412%2060.4561%2028.1999%2060.2852%2028.2426V27.3562C60.4775%2027.3029%2060.6804%2027.2317%2060.894%2027.1427C61.1111%2027.0501%2061.3229%2026.9487%2061.5294%2026.8383C61.7394%2026.7244%2061.937%2026.6069%2062.1221%2026.4859C62.3072%2026.3613%2062.4674%2026.2403%2062.6027%2026.1228H62.9337V33.9508Z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%20%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22filter0_d%22%20x%3D%222%22%20y%3D%224%22%20width%3D%22178%22%20height%3D%22178%22%20filterUnits%3D%22userSpaceOnUse%22%20color-interpolation-filters%3D%22sRGB%22%3E%0A%3CfeFlood%20flood-opacity%3D%220%22%20result%3D%22BackgroundImageFix%22%2F%3E%0A%3CfeColorMatrix%20in%3D%22SourceAlpha%22%20type%3D%22matrix%22%20values%3D%220%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200%22%20result%3D%22hardAlpha%22%2F%3E%0A%3CfeOffset%20dy%3D%222%22%2F%3E%0A%3CfeGaussianBlur%20stdDeviation%3D%222%22%2F%3E%0A%3CfeComposite%20in2%3D%22hardAlpha%22%20operator%3D%22out%22%2F%3E%0A%3CfeColorMatrix%20type%3D%22matrix%22%20values%3D%220%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.05%200%22%2F%3E%0A%3CfeBlend%20mode%3D%22normal%22%20in2%3D%22BackgroundImageFix%22%20result%3D%22effect1_dropShadow%22%2F%3E%0A%3CfeBlend%20mode%3D%22normal%22%20in%3D%22SourceGraphic%22%20in2%3D%22effect1_dropShadow%22%20result%3D%22shape%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E%0A");
  min-width: 182px;
  min-height: 182px;
  max-height: 182px;
  background-size: 182px;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  margin-bottom: 10px;
}
.dx-timeview-hourarrow,
.dx-timeview-minutearrow {
  position: absolute;
  left: 50%;
  width: 10px;
  margin-left: -5px;
  height: 50%;
  background-position: bottom;
  background-repeat: no-repeat;
  -webkit-transform-origin: 50% 100%;
  transform-origin: 50% 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.dx-timeview-hourarrow {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%226%22%20height%3D%2248%22%20viewBox%3D%220%200%206%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Crect%20width%3D%226%22%20height%3D%2244%22%20rx%3D%223%22%20fill%3D%22%23009688%22%2F%3E%0A%3C%2Fsvg%3E%0A");
}
.dx-timeview-minutearrow {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2210%22%20height%3D%2266%22%20viewBox%3D%220%200%2010%2066%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Crect%20x%3D%223%22%20width%3D%224%22%20height%3D%2264%22%20rx%3D%222%22%20fill%3D%22%23009688%22%2F%3E%0A%3Ccircle%20cx%3D%225%22%20cy%3D%2261%22%20r%3D%223.5%22%20fill%3D%22%23fff%22%20stroke%3D%22%23009688%22%20stroke-width%3D%223%22%2F%3E%0A%3C%2Fsvg%3E%0A");
}
.dx-timeview {
  height: auto;
  width: auto;
}
.dx-timeview .dx-texteditor .dx-texteditor-container .dx-texteditor-input {
  padding-right: 0;
  padding-left: 12px;
}
.dx-rtl .dx-timeview .dx-texteditor .dx-texteditor-container .dx-texteditor-input {
  padding-left: 0;
  padding-right: 12px;
}
.dx-timeview .dx-texteditor .dx-texteditor-container .dx-texteditor-buttons-container .dx-dropdowneditor-button {
  margin-right: 0;
}
.dx-rtl .dx-timeview .dx-texteditor .dx-texteditor-container .dx-texteditor-buttons-container .dx-dropdowneditor-button,
.dx-timeview .dx-texteditor .dx-texteditor-container .dx-texteditor-buttons-container .dx-dropdowneditor-button.dx-rtl {
  margin-left: 0;
}
.dx-timeview-format12 {
  width: 64px;
  margin-left: 5px;
  margin-right: auto;
}
.dx-rtl .dx-timeview-format12,
.dx-timeview-format12.dx-rtl {
  margin-left: auto;
  margin-right: 5px;
}
.dx-timeview-time-separator {
  margin: 0 5px;
}
.dx-timeview-field {
  min-height: 35px;
}
.dx-timeview-field .dx-numberbox {
  width: 64px;
}
.dx-timeview-field .dx-numberbox.dx-numberbox-spin-touch-friendly {
  width: 110px;
}
.dx-dateview-item {
  margin: 0;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 1.3em;
  color: rgba(0,0,0,.87);
}
.dx-dateview-rollers {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
}
.dx-dateview-item-selected-border,
.dx-dateviewroller-day .dx-dateview-name-formatter,
.dx-dateviewroller-month .dx-dateview-value-formatter {
  display: none;
}
.dx-dateview-rollers {
  width: auto;
  text-align: center;
  display: block;
}
.dx-dateviewroller-current .dx-dateview-item {
  -webkit-transition: font-size .2s ease-out;
  transition: font-size .2s ease-out;
}
.dx-dateviewroller {
  position: relative;
  vertical-align: top;
  cursor: pointer;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  min-width: 4em;
  text-align: center;
  display: inline-block;
}
.dx-dateviewroller .dx-button {
  display: none;
}
.dx-dateviewroller .dx-scrollable-content::after,
.dx-dateviewroller .dx-scrollable-content::before {
  content: "";
  height: 71px;
  display: block;
}
.dx-dateviewroller .dx-scrollable-container {
  height: 182px;
}
.dx-dateviewroller.dx-dateviewroller-year {
  min-width: 4.85em;
}
.dx-dateviewroller.dx-state-active .dx-button {
  display: none;
}
.dx-dateviewroller-month {
  min-width: 12em;
}
.dx-dateviewroller-hours::after {
  content: ":";
  font-size: 2.2em;
  position: absolute;
  right: -9%;
  font-weight: 700;
  top: 37%;
  color: rgba(0,0,0,.87);
}
.dx-dateviewroller-hours .dx-dateview-item-selected-frame {
  padding-left: 20%;
}
.dx-dateviewroller-minutes .dx-dateview-item-selected-frame {
  width: 80%;
}
.dx-dateview-item-selected {
  font-size: 1.8em;
  color: #009688;
}
.dx-rtl.dx-dateviewroller-hours::after {
  left: -9%;
  right: auto;
}
.dx-dateview-item-selected-frame {
  position: absolute;
  top: 71px;
  width: 100%;
}
.dx-dateview-item-selected-frame::after,
.dx-dateview-item-selected-frame::before {
  pointer-events: none;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  content: "";
  display: block;
  width: 100%;
  position: absolute;
  height: 71px;
}
.dx-dateview-item-selected-frame::before {
  top: -71px;
  background-repeat: no-repeat;
  background-image: -webkit-gradient(linear,left bottom,left top,from(rgba(255,255,255,0)),color-stop(60%,rgba(255,255,255,.8)));
  background-image: linear-gradient(0deg,rgba(255,255,255,0) 0,rgba(255,255,255,.8) 60%);
}
.dx-dateview-item-selected-frame::after {
  top: 40px;
  background-repeat: no-repeat;
  background-image: -webkit-gradient(linear,left top,left bottom,from(rgba(255,255,255,0)),color-stop(60%,rgba(255,255,255,.8)));
  background-image: linear-gradient(180deg,rgba(255,255,255,0) 0,rgba(255,255,255,.8) 60%);
}
.dx-device-phone .dx-dateview-rollers,
.dx-device-tablet .dx-dateview-rollers {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
}
.dx-device-phone .dx-dateviewroller-month,
.dx-device-tablet .dx-dateviewroller-month {
  min-width: 4em;
}
.dx-device-phone .dx-dateview-item,
.dx-device-tablet .dx-dateview-item {
  font-size: 1.1em;
}
.dx-device-phone .dx-dateview-item-selected,
.dx-device-tablet .dx-dateview-item-selected {
  font-size: 1.4em;
}
.dx-datebox-wrapper .dx-popup-title {
  min-height: 10px;
  border-bottom: none;
  background: 0 0;
}
.dx-datebox-wrapper .dx-item {
  border: none;
}
.dx-datebox-wrapper .dx-popup-bottom .dx-button {
  width: auto;
}
.dx-datebox-datetime-time-side {
  background-color: rgba(221,221,221,.2);
}
.dx-datebox-wrapper-rollers.dx-datebox-wrapper-time .dx-popup-content {
  margin: 0 34px;
}
.dx-datebox-wrapper-list .dx-overlay-content {
  border-top: none;
}
.dx-device-phone .dx-datebox-wrapper-rollers .dx-popup-content {
  padding: 10px;
}
.dx-datebox-time .dx-dropdowneditor-icon {
  font: 24px/24px DXIcons;
  width: 24px;
  height: 100%;
  text-align: center;
}
.dx-datebox-time .dx-dropdowneditor-icon::before {
  content: "\\f01d";
  position: absolute;
  display: block;
  width: 24px;
  top: 50%;
  margin-top: -12px;
  left: 50%;
  margin-left: -12px;
}
.dx-datebox-time.dx-dropdowneditor-active .dx-dropdowneditor-icon {
  font: 24px/24px DXIcons;
  width: 24px;
  height: 100%;
  text-align: center;
}
.dx-datebox-time.dx-dropdowneditor-active .dx-dropdowneditor-icon::before {
  content: "\\f01d";
  position: absolute;
  display: block;
  width: 24px;
  top: 50%;
  margin-top: -12px;
  left: 50%;
  margin-left: -12px;
}
.dx-datebox-date .dx-dropdowneditor-icon {
  font: 24px/24px DXIcons;
  width: 24px;
  height: 100%;
  text-align: center;
}
.dx-datebox-date .dx-dropdowneditor-icon::before {
  content: "\\f026";
  position: absolute;
  display: block;
  width: 24px;
  top: 50%;
  margin-top: -12px;
  left: 50%;
  margin-left: -12px;
}
.dx-datebox-date.dx-dropdowneditor-active .dx-dropdowneditor-icon {
  font: 24px/24px DXIcons;
  width: 24px;
  height: 100%;
  text-align: center;
}
.dx-datebox-date.dx-dropdowneditor-active .dx-dropdowneditor-icon::before {
  content: "\\f026";
  position: absolute;
  display: block;
  width: 24px;
  top: 50%;
  margin-top: -12px;
  left: 50%;
  margin-left: -12px;
}
.dx-datebox-datetime .dx-dropdowneditor-icon {
  font: 24px/24px DXIcons;
  width: 24px;
  height: 100%;
  text-align: center;
}
.dx-datebox-datetime .dx-dropdowneditor-icon::before {
  content: "\\f043";
  position: absolute;
  display: block;
  width: 24px;
  top: 50%;
  margin-top: -12px;
  left: 50%;
  margin-left: -12px;
}
.dx-datebox-datetime.dx-dropdowneditor-active .dx-dropdowneditor-icon {
  font: 24px/24px DXIcons;
  width: 24px;
  height: 100%;
  text-align: center;
}
.dx-datebox-datetime.dx-dropdowneditor-active .dx-dropdowneditor-icon::before {
  content: "\\f043";
  position: absolute;
  display: block;
  width: 24px;
  top: 50%;
  margin-top: -12px;
  left: 50%;
  margin-left: -12px;
}
.dx-datebox-calendar.dx-dropdowneditor-active.dx-editor-filled {
  background: rgba(0,0,0,.07);
}
.dx-datebox-calendar.dx-rtl.dx-dropdowneditor-active .dx-dropdowneditor-button .dx-dropdowneditor-icon {
  opacity: 1;
}
.dx-datebox-wrapper-calendar .dx-popup-content {
  padding: 0;
}
.dx-datebox-wrapper-calendar .dx-calendar {
  border: none;
  margin: 16px;
}
.dx-datebox-wrapper-calendar .dx-datebox-container-cell {
  margin-right: 16px;
  margin-bottom: 16px;
}
.dx-datebox-wrapper-calendar.dx-datebox-wrapper-datetime .dx-timeview {
  padding: 16px;
}
.dx-datebox-wrapper-calendar.dx-datebox-wrapper-datetime .dx-datebox-container-cell {
  margin-top: -1px;
  margin-right: 16px;
}
@media (max-width:320px) {
  .dx-datebox-wrapper-calendar .dx-calendar {
    margin: 18px;
  }
}
.dx-rtl .dx-datebox-wrapper .dx-popup-bottom .dx-toolbar-button + .dx-toolbar-button .dx-button {
  margin-right: 5px;
  margin-left: 0;
}
.dx-datebox-wrapper-list .dx-popup-content {
  padding: 0;
}
.dx-datebox input[type=date] {
  line-height: normal;
}
.dx-datebox.dx-auto-width.dx-dropdowneditor-button-visible.dx-editor-underlined .dx-texteditor-input,
.dx-datebox:not(.dx-texteditor-empty).dx-auto-width.dx-dropdowneditor-button-visible.dx-editor-underlined .dx-texteditor-input {
  padding-right: 34px;
}
.dx-datebox.dx-auto-width.dx-dropdowneditor-button-visible.dx-editor-underlined.dx-rtl .dx-texteditor-input,
.dx-datebox:not(.dx-texteditor-empty).dx-auto-width.dx-dropdowneditor-button-visible.dx-editor-underlined.dx-rtl .dx-texteditor-input {
  padding-right: 0;
  padding-left: 34px;
}
.dx-datebox.dx-auto-width.dx-dropdowneditor-button-visible.dx-editor-filled .dx-texteditor-input,
.dx-datebox.dx-auto-width.dx-dropdowneditor-button-visible.dx-editor-outlined .dx-texteditor-input,
.dx-datebox:not(.dx-texteditor-empty).dx-auto-width.dx-dropdowneditor-button-visible.dx-editor-filled .dx-texteditor-input,
.dx-datebox:not(.dx-texteditor-empty).dx-auto-width.dx-dropdowneditor-button-visible.dx-editor-outlined .dx-texteditor-input {
  padding-right: 50px;
}
.dx-datebox.dx-auto-width.dx-dropdowneditor-button-visible.dx-editor-filled.dx-rtl .dx-texteditor-input,
.dx-datebox.dx-auto-width.dx-dropdowneditor-button-visible.dx-editor-outlined.dx-rtl .dx-texteditor-input,
.dx-datebox:not(.dx-texteditor-empty).dx-auto-width.dx-dropdowneditor-button-visible.dx-editor-filled.dx-rtl .dx-texteditor-input,
.dx-datebox:not(.dx-texteditor-empty).dx-auto-width.dx-dropdowneditor-button-visible.dx-editor-outlined.dx-rtl .dx-texteditor-input {
  padding-right: 16px;
  padding-left: 50px;
}
.dx-device-ios .dx-datebox.dx-texteditor-empty .dx-texteditor-input {
  min-height: 33px;
}
.dx-editor-filled.dx-datebox-native .dx-texteditor-input,
.dx-editor-outlined.dx-datebox-native .dx-texteditor-input,
.dx-editor-underlined.dx-datebox-native .dx-texteditor-input {
  padding-right: 8px;
}
.dx-daterangebox {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.dx-daterangebox .dx-texteditor-with-floating-label,
.dx-daterangebox .dx-texteditor-with-label {
  margin-top: 0;
}
.dx-daterangebox.dx-editor-outlined .dx-datebox.dx-end-datebox.dx-editor-outlined,
.dx-daterangebox.dx-editor-outlined .dx-datebox.dx-start-datebox.dx-editor-outlined {
  border: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-daterangebox.dx-editor-outlined .dx-datebox.dx-end-datebox.dx-editor-outlined.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label,
.dx-daterangebox.dx-editor-outlined .dx-datebox.dx-end-datebox.dx-editor-outlined.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label-after,
.dx-daterangebox.dx-editor-outlined .dx-datebox.dx-end-datebox.dx-editor-outlined.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label-before,
.dx-daterangebox.dx-editor-outlined .dx-datebox.dx-end-datebox.dx-editor-outlined.dx-texteditor-with-label .dx-texteditor-label .dx-label,
.dx-daterangebox.dx-editor-outlined .dx-datebox.dx-end-datebox.dx-editor-outlined.dx-texteditor-with-label .dx-texteditor-label .dx-label-after,
.dx-daterangebox.dx-editor-outlined .dx-datebox.dx-end-datebox.dx-editor-outlined.dx-texteditor-with-label .dx-texteditor-label .dx-label-before,
.dx-daterangebox.dx-editor-outlined .dx-datebox.dx-start-datebox.dx-editor-outlined.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label,
.dx-daterangebox.dx-editor-outlined .dx-datebox.dx-start-datebox.dx-editor-outlined.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label-after,
.dx-daterangebox.dx-editor-outlined .dx-datebox.dx-start-datebox.dx-editor-outlined.dx-texteditor-with-floating-label .dx-texteditor-label .dx-label-before,
.dx-daterangebox.dx-editor-outlined .dx-datebox.dx-start-datebox.dx-editor-outlined.dx-texteditor-with-label .dx-texteditor-label .dx-label,
.dx-daterangebox.dx-editor-outlined .dx-datebox.dx-start-datebox.dx-editor-outlined.dx-texteditor-with-label .dx-texteditor-label .dx-label-after,
.dx-daterangebox.dx-editor-outlined .dx-datebox.dx-start-datebox.dx-editor-outlined.dx-texteditor-with-label .dx-texteditor-label .dx-label-before {
  margin: 0;
  border: 0;
  -webkit-clip-path: none;
  clip-path: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-daterangebox .dx-datebox {
  width: 100%;
}
.dx-daterangebox .dx-datebox.dx-editor-underlined {
  border-bottom: 0;
}
.dx-daterangebox .dx-datebox.dx-editor-underlined::before {
  margin-left: 0;
}
.dx-daterangebox .dx-datebox.dx-editor-underlined.dx-rtl .dx-texteditor-container .dx-texteditor-input {
  padding-right: 0;
}
.dx-daterangebox .dx-datebox.dx-editor-filled {
  background-color: transparent;
  border: 0;
}
.dx-daterangebox .dx-datebox.dx-editor-filled.dx-state-readonly,
.dx-daterangebox .dx-datebox.dx-editor-filled.dx-state-readonly.dx-state-hover {
  background-color: transparent;
}
.dx-daterangebox.dx-texteditor-empty .dx-clear-button-area {
  display: block;
  visibility: hidden;
}
.dx-daterangebox-separator {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding-left: 16px;
  color: rgba(148,148,148,.87);
}
.dx-rtl .dx-daterangebox-separator {
  -webkit-transform: scale(-1,1);
  transform: scale(-1,1);
}
.dx-daterangebox-with-floating-label.dx-editor-outlined,
.dx-daterangebox-with-label.dx-editor-outlined {
  margin-top: 6px;
}
.dx-daterangebox-with-floating-label.dx-editor-outlined .dx-texteditor-label .dx-label,
.dx-daterangebox-with-label.dx-editor-outlined .dx-texteditor-label .dx-label {
  position: relative;
}
.dx-daterangebox-with-floating-label.dx-editor-outlined .dx-texteditor-label .dx-label::before,
.dx-daterangebox-with-label.dx-editor-outlined .dx-texteditor-label .dx-label::before {
  content: "";
  background-color: #fff;
  width: 100%;
  position: absolute;
  height: 2.5px;
  top: 0;
  margin-left: -4px;
  margin-right: -4px;
}
.dx-daterangebox.dx-daterangebox-with-floating-label.dx-editor-outlined.dx-dropdowneditor-active .dx-datebox.dx-editor-outlined .dx-texteditor-label .dx-label,
.dx-daterangebox.dx-daterangebox-with-floating-label.dx-editor-outlined.dx-invalid .dx-datebox.dx-editor-outlined .dx-texteditor-label .dx-label,
.dx-daterangebox.dx-daterangebox-with-floating-label.dx-editor-outlined.dx-state-focused .dx-datebox.dx-editor-outlined .dx-texteditor-label .dx-label {
  padding: 0 4px;
}
.dx-daterangebox.dx-daterangebox-with-floating-label.dx-editor-outlined.dx-dropdowneditor-active .dx-datebox.dx-editor-outlined .dx-texteditor-label .dx-label::before,
.dx-daterangebox.dx-daterangebox-with-floating-label.dx-editor-outlined.dx-invalid .dx-datebox.dx-editor-outlined .dx-texteditor-label .dx-label::before,
.dx-daterangebox.dx-daterangebox-with-floating-label.dx-editor-outlined.dx-state-focused .dx-datebox.dx-editor-outlined .dx-texteditor-label .dx-label::before {
  background-color: #fff;
}
.dx-daterangebox.dx-daterangebox-with-floating-label.dx-editor-outlined.dx-dropdowneditor-active .dx-datebox.dx-editor-outlined .dx-texteditor-label .dx-label span,
.dx-daterangebox.dx-daterangebox-with-floating-label.dx-editor-outlined.dx-invalid .dx-datebox.dx-editor-outlined .dx-texteditor-label .dx-label span,
.dx-daterangebox.dx-daterangebox-with-floating-label.dx-editor-outlined.dx-state-focused .dx-datebox.dx-editor-outlined .dx-texteditor-label .dx-label span {
  -webkit-transform: translate(0,-6px);
  transform: translate(0,-6px);
  font-size: 12px;
  margin-top: 0;
  top: 0;
  height: 13px;
  line-height: 12px;
}
.dx-daterangebox.dx-daterangebox-with-floating-label.dx-editor-outlined .dx-datebox.dx-texteditor-empty .dx-texteditor-label .dx-label::before {
  background-color: transparent;
}
.dx-daterangebox-with-floating-label.dx-editor-underlined .dx-texteditor-label {
  height: 12px;
  line-height: 12px;
}
.dx-daterangebox-with-floating-label.dx-editor-underlined.dx-dropdowneditor-active .dx-datebox .dx-texteditor-label,
.dx-daterangebox-with-floating-label.dx-editor-underlined.dx-invalid .dx-datebox .dx-texteditor-label,
.dx-daterangebox-with-floating-label.dx-editor-underlined.dx-state-focused .dx-datebox .dx-texteditor-label {
  -webkit-transform: translate(0,0);
  transform: translate(0,0);
  font-size: 12px;
  height: 12px;
  line-height: 12px;
  top: 0;
  margin-top: 0;
}
.dx-daterangebox-with-floating-label.dx-editor-filled .dx-texteditor-label {
  height: 12px;
  line-height: 12px;
}
.dx-daterangebox-with-floating-label.dx-editor-filled.dx-dropdowneditor-active .dx-datebox .dx-texteditor-label,
.dx-daterangebox-with-floating-label.dx-editor-filled.dx-invalid .dx-datebox .dx-texteditor-label,
.dx-daterangebox-with-floating-label.dx-editor-filled.dx-state-focused .dx-datebox .dx-texteditor-label {
  font-size: 12px;
  height: 12px;
  line-height: 12px;
  top: 7px;
  margin-top: 0;
}
.dx-daterangebox .dx-dropdowneditor-icon {
  font: 24px/24px DXIcons;
  width: 24px;
  height: 100%;
  text-align: center;
}
.dx-daterangebox .dx-dropdowneditor-icon::before {
  content: "\\f043";
  position: absolute;
  display: block;
  width: 24px;
  top: 50%;
  margin-top: -12px;
  left: 50%;
  margin-left: -12px;
}
.dx-daterangebox.dx-dropdowneditor-active .dx-dropdowneditor-icon {
  font: 24px/24px DXIcons;
  width: 24px;
  height: 100%;
  text-align: center;
}
.dx-daterangebox.dx-dropdowneditor-active .dx-dropdowneditor-icon::before {
  content: "\\f043";
  position: absolute;
  display: block;
  width: 24px;
  top: 50%;
  margin-top: -12px;
  left: 50%;
  margin-left: -12px;
}
.dx-daterangebox .dx-editor-outlined::before {
  display: block;
  bottom: 1px;
}
.dx-daterangebox .dx-editor-filled::before,
.dx-daterangebox .dx-editor-outlined::before {
  width: calc(100% - 30px);
  margin: 0 15px;
}
.dx-daterangebox.dx-editor-filled.dx-state-focused.dx-invalid::before,
.dx-daterangebox.dx-editor-filled.dx-state-hover::after,
.dx-daterangebox.dx-editor-filled::before,
.dx-daterangebox.dx-editor-underlined.dx-state-focused.dx-invalid::before,
.dx-daterangebox.dx-editor-underlined.dx-state-hover::after,
.dx-daterangebox.dx-editor-underlined::before {
  border-bottom-width: 1px;
  -webkit-transition: none;
  transition: none;
}
.dx-daterangebox.dx-editor-filled .dx-datebox::before,
.dx-daterangebox.dx-editor-underlined .dx-datebox::before {
  bottom: 1px;
}
.dx-daterangebox.dx-editor-filled .dx-datebox::after,
.dx-daterangebox.dx-editor-underlined .dx-datebox::after {
  border-color: transparent;
  bottom: 1px;
}
.dx-daterangebox.dx-editor-underlined .dx-daterangebox-separator {
  padding-right: 16px;
}
.dx-daterangebox.dx-editor-filled > .dx-texteditor-buttons-container > .dx-button,
.dx-daterangebox.dx-editor-filled > .dx-texteditor-buttons-container > .dx-clear-button-area,
.dx-daterangebox.dx-editor-outlined > .dx-texteditor-buttons-container > .dx-button,
.dx-daterangebox.dx-editor-outlined > .dx-texteditor-buttons-container > .dx-clear-button-area,
.dx-daterangebox.dx-editor-underlined > .dx-texteditor-buttons-container > .dx-button,
.dx-daterangebox.dx-editor-underlined > .dx-texteditor-buttons-container > .dx-clear-button-area {
  margin-left: 5px;
  margin-right: 5px;
}
.dx-daterangebox.dx-editor-filled > .dx-texteditor-buttons-container > .dx-button:first-child,
.dx-daterangebox.dx-editor-filled > .dx-texteditor-buttons-container > .dx-clear-button-area:first-child,
.dx-daterangebox.dx-editor-outlined > .dx-texteditor-buttons-container > .dx-button:first-child,
.dx-daterangebox.dx-editor-outlined > .dx-texteditor-buttons-container > .dx-clear-button-area:first-child,
.dx-daterangebox.dx-editor-underlined > .dx-texteditor-buttons-container > .dx-button:first-child,
.dx-daterangebox.dx-editor-underlined > .dx-texteditor-buttons-container > .dx-clear-button-area:first-child {
  margin-left: 0;
}
.dx-daterangebox.dx-editor-filled > .dx-texteditor-buttons-container > .dx-button:last-child,
.dx-daterangebox.dx-editor-filled > .dx-texteditor-buttons-container > .dx-clear-button-area:last-child,
.dx-daterangebox.dx-editor-outlined > .dx-texteditor-buttons-container > .dx-button:last-child,
.dx-daterangebox.dx-editor-outlined > .dx-texteditor-buttons-container > .dx-clear-button-area:last-child,
.dx-daterangebox.dx-editor-underlined > .dx-texteditor-buttons-container > .dx-button:last-child,
.dx-daterangebox.dx-editor-underlined > .dx-texteditor-buttons-container > .dx-clear-button-area:last-child {
  margin-right: 10px;
}
.dx-daterangebox.dx-editor-filled > .dx-texteditor-buttons-container > .dx-dropdowneditor-button:last-child,
.dx-daterangebox.dx-editor-outlined > .dx-texteditor-buttons-container > .dx-dropdowneditor-button:last-child,
.dx-daterangebox.dx-editor-underlined > .dx-texteditor-buttons-container > .dx-dropdowneditor-button:last-child {
  margin-right: 8px;
}
.dx-daterangebox.dx-editor-filled > .dx-texteditor-buttons-container > .dx-clear-button-area + div:empty:last-child,
.dx-daterangebox.dx-editor-filled > .dx-texteditor-buttons-container > .dx-clear-button-area:last-child,
.dx-daterangebox.dx-editor-outlined > .dx-texteditor-buttons-container > .dx-clear-button-area + div:empty:last-child,
.dx-daterangebox.dx-editor-outlined > .dx-texteditor-buttons-container > .dx-clear-button-area:last-child,
.dx-daterangebox.dx-editor-underlined > .dx-texteditor-buttons-container > .dx-clear-button-area + div:empty:last-child,
.dx-daterangebox.dx-editor-underlined > .dx-texteditor-buttons-container > .dx-clear-button-area:last-child {
  margin-right: 12px;
}
.dx-daterangebox.dx-editor-filled.dx-rtl > .dx-texteditor-buttons-container > .dx-button:first-child,
.dx-daterangebox.dx-editor-filled.dx-rtl > .dx-texteditor-buttons-container > .dx-clear-button-area:first-child,
.dx-daterangebox.dx-editor-outlined.dx-rtl > .dx-texteditor-buttons-container > .dx-button:first-child,
.dx-daterangebox.dx-editor-outlined.dx-rtl > .dx-texteditor-buttons-container > .dx-clear-button-area:first-child,
.dx-daterangebox.dx-editor-underlined.dx-rtl > .dx-texteditor-buttons-container > .dx-button:first-child,
.dx-daterangebox.dx-editor-underlined.dx-rtl > .dx-texteditor-buttons-container > .dx-clear-button-area:first-child {
  margin-left: 5px;
  margin-right: 0;
}
.dx-daterangebox.dx-editor-filled.dx-rtl > .dx-texteditor-buttons-container > .dx-button:last-child,
.dx-daterangebox.dx-editor-filled.dx-rtl > .dx-texteditor-buttons-container > .dx-clear-button-area:last-child,
.dx-daterangebox.dx-editor-outlined.dx-rtl > .dx-texteditor-buttons-container > .dx-button:last-child,
.dx-daterangebox.dx-editor-outlined.dx-rtl > .dx-texteditor-buttons-container > .dx-clear-button-area:last-child,
.dx-daterangebox.dx-editor-underlined.dx-rtl > .dx-texteditor-buttons-container > .dx-button:last-child,
.dx-daterangebox.dx-editor-underlined.dx-rtl > .dx-texteditor-buttons-container > .dx-clear-button-area:last-child {
  margin-left: 10px;
  margin-right: 5px;
}
.dx-daterangebox.dx-editor-filled.dx-rtl > .dx-texteditor-buttons-container > .dx-dropdowneditor-button:last-child,
.dx-daterangebox.dx-editor-outlined.dx-rtl > .dx-texteditor-buttons-container > .dx-dropdowneditor-button:last-child,
.dx-daterangebox.dx-editor-underlined.dx-rtl > .dx-texteditor-buttons-container > .dx-dropdowneditor-button:last-child {
  margin-left: 8px;
  margin-right: 0;
}
.dx-daterangebox.dx-editor-filled.dx-rtl > .dx-texteditor-buttons-container > .dx-clear-button-area:last-child,
.dx-daterangebox.dx-editor-outlined.dx-rtl > .dx-texteditor-buttons-container > .dx-clear-button-area:last-child,
.dx-daterangebox.dx-editor-underlined.dx-rtl > .dx-texteditor-buttons-container > .dx-clear-button-area:last-child {
  margin-left: 12px;
  margin-right: 0;
}
.dx-daterangebox .dx-datebox.dx-start-datebox.dx-editor-filled .dx-texteditor-input,
.dx-daterangebox .dx-datebox.dx-start-datebox.dx-editor-outlined .dx-texteditor-input,
.dx-daterangebox .dx-datebox.dx-start-datebox.dx-editor-underlined .dx-texteditor-input {
  padding-right: 16px;
}
.dx-daterangebox .dx-datebox.dx-start-datebox.dx-editor-filled.dx-rtl .dx-texteditor-input,
.dx-daterangebox .dx-datebox.dx-start-datebox.dx-editor-outlined.dx-rtl .dx-texteditor-input,
.dx-daterangebox .dx-datebox.dx-start-datebox.dx-editor-underlined.dx-rtl .dx-texteditor-input {
  padding-left: 16px;
}
.dx-daterangebox .dx-datebox.dx-end-datebox.dx-editor-filled.dx-invalid .dx-texteditor-input,
.dx-daterangebox .dx-datebox.dx-end-datebox.dx-editor-outlined.dx-invalid .dx-texteditor-input,
.dx-daterangebox .dx-datebox.dx-end-datebox.dx-editor-underlined.dx-invalid .dx-texteditor-input {
  padding-right: 46px;
}
.dx-daterangebox .dx-datebox.dx-end-datebox.dx-editor-filled.dx-invalid.dx-rtl .dx-texteditor-input,
.dx-daterangebox .dx-datebox.dx-end-datebox.dx-editor-outlined.dx-invalid.dx-rtl .dx-texteditor-input,
.dx-daterangebox .dx-datebox.dx-end-datebox.dx-editor-underlined.dx-invalid.dx-rtl .dx-texteditor-input {
  padding-right: 16px;
  padding-left: 46px;
}
.dx-daterangebox .dx-datebox.dx-end-datebox.dx-editor-underlined.dx-invalid.dx-rtl .dx-texteditor-input {
  padding-right: 0;
}
.dx-daterangebox-separator .dx-icon {
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  font-size: 24px;
  text-align: center;
  line-height: 24px;
}
.dx-dropdownlist-popup-wrapper .dx-list .dx-scrollable-content {
  margin: 0;
}
.dx-dropdownlist-popup-wrapper {
  height: 100%;
}
.dx-dropdownlist-popup-wrapper.dx-popup-wrapper .dx-overlay-content {
  -webkit-box-shadow: 0 2px 7px rgba(0,0,0,.2);
  box-shadow: 0 2px 7px rgba(0,0,0,.2);
  border-top-width: 0;
  border-bottom-width: 1px;
}
.dx-dropdownlist-popup-wrapper.dx-popup-wrapper .dx-overlay-content.dx-dropdowneditor-overlay-flipped {
  border-top-width: 1px;
  border-bottom-width: 0;
}
.dx-dropdownlist-popup-wrapper .dx-popup-content {
  height: 100%;
  padding: 1px;
}
.dx-dropdownlist-popup-wrapper .dx-list {
  height: 100%;
  min-height: 48px;
}
.dx-dropdownlist-popup-wrapper .dx-list-select-all {
  padding: 16px 0 12px;
}
.dx-dropdownlist-popup-wrapper .dx-empty-message,
.dx-dropdownlist-popup-wrapper .dx-list-item {
  border-top: 0;
}
.dx-dropdownlist-popup-wrapper .dx-empty-message:last-of-type,
.dx-dropdownlist-popup-wrapper .dx-list-item:last-of-type {
  border-bottom: none;
}
.dx-autocomplete.dx-invalid .dx-texteditor-buttons-container::after,
.dx-autocomplete.dx-valid .dx-texteditor-buttons-container::after {
  right: 12px;
}
.dx-rtl .dx-autocomplete.dx-invalid .dx-texteditor-buttons-container::after,
.dx-rtl .dx-autocomplete.dx-valid .dx-texteditor-buttons-container::after,
.dx-rtl.dx-autocomplete.dx-invalid .dx-texteditor-buttons-container::after,
.dx-rtl.dx-autocomplete.dx-valid .dx-texteditor-buttons-container::after {
  left: 12px;
}
.dx-autocomplete.dx-validation-pending .dx-texteditor-buttons-container .dx-pending-indicator {
  right: 12px;
}
.dx-rtl .dx-autocomplete.dx-validation-pending .dx-texteditor-buttons-container .dx-pending-indicator,
.dx-rtl.dx-autocomplete.dx-validation-pending .dx-texteditor-buttons-container .dx-pending-indicator {
  left: 12px;
}
.dx-loadindicator {
  width: 32px;
  height: 32px;
  display: inline-block;
  overflow: hidden;
  border: none;
  background-color: transparent;
  line-height: 100%;
}
.dx-loadindicator-wrapper {
  width: 100%;
  height: 100%;
  font-size: 32px;
  margin: auto;
}
.dx-loadindicator-image {
  background-size: contain;
  -webkit-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  background-position: 50%;
  background-repeat: no-repeat;
  background-image: url("data:image/gif;base64,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");
}
.dx-loadindicator-icon-custom {
  position: relative;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  -webkit-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-animation: 1.5s linear infinite dx-loadindicator-icon-custom-rotate;
  animation: 1.5s linear infinite dx-loadindicator-icon-custom-rotate;
}
@-webkit-keyframes dx-loadindicator-icon-custom-rotate {
  from {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes dx-loadindicator-icon-custom-rotate {
  from {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.dx-loadindicator-container > .dx-loadindicator {
  top: 50%;
  left: 50%;
  position: absolute;
  margin-top: -16px;
  margin-left: -16px;
}
.dx-loadindicator-container > .dx-loadindicator.dx-loadindicator {
  margin-top: -16px;
  margin-left: -16px;
}
.dx-loadindicator-content {
  position: relative;
  height: 100%;
  width: 100%;
  -webkit-animation: 1568ms linear infinite dx-content-rotation;
  animation: 1568ms linear infinite dx-content-rotation;
}
.dx-loadindicator-image .dx-loadindicator-content {
  -webkit-animation: none;
  animation: none;
}
.dx-loadindicator-icon {
  direction: ltr;
  position: absolute;
  height: 100%;
  width: 100%;
  -webkit-animation: 5332ms cubic-bezier(.4,0,.2,1) infinite both dx-icon-rotation;
  animation: 5332ms cubic-bezier(.4,0,.2,1) infinite both dx-icon-rotation;
}
.dx-loadindicator-segment {
  height: 100%;
  width: 100%;
  position: absolute;
}
.dx-loadindicator-segment-inner {
  position: relative;
  height: 100%;
  border-color: #009688 #009688 transparent;
  border-width: .12em;
  border-style: solid;
  -webkit-animation: none;
  animation: none;
  border-radius: 50%;
}
.dx-loadindicator-segment0,
.dx-loadindicator-segment2 {
  width: 50%;
  height: 100%;
  overflow: hidden;
}
.dx-loadindicator-segment0 .dx-loadindicator-segment-inner,
.dx-loadindicator-segment2 .dx-loadindicator-segment-inner {
  width: 200%;
}
.dx-loadindicator-segment2 {
  left: 0;
}
.dx-loadindicator-segment2 .dx-loadindicator-segment-inner {
  border-right-color: transparent;
  -webkit-transform: rotate(-129deg);
  transform: rotate(-129deg);
  -webkit-animation: 1333ms cubic-bezier(.4,0,.2,1) infinite both dx-left-segment-rotation;
  animation: 1333ms cubic-bezier(.4,0,.2,1) infinite both dx-left-segment-rotation;
}
.dx-loadindicator-segment0 {
  right: 0;
}
.dx-loadindicator-segment0 .dx-loadindicator-segment-inner {
  left: -100%;
  border-left-color: transparent;
  -webkit-transform: rotate(129deg);
  transform: rotate(129deg);
  -webkit-animation: 1333ms cubic-bezier(.4,0,.2,1) infinite both dx-right-segment-rotation;
  animation: 1333ms cubic-bezier(.4,0,.2,1) infinite both dx-right-segment-rotation;
}
.dx-loadindicator-segment1 {
  position: absolute;
  top: 0;
  left: 45%;
  width: 10%;
  height: 100%;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.dx-loadindicator-segment1 .dx-loadindicator-segment-inner {
  width: 1000%;
  left: -450%;
}
@-webkit-keyframes dx-content-rotation {
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes dx-content-rotation {
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-webkit-keyframes dx-icon-rotation {
  12.5% {
    -webkit-transform: rotate(135deg);
    transform: rotate(135deg);
  }
  25% {
    -webkit-transform: rotate(270deg);
    transform: rotate(270deg);
  }
  37.5% {
    -webkit-transform: rotate(405deg);
    transform: rotate(405deg);
  }
  50% {
    -webkit-transform: rotate(540deg);
    transform: rotate(540deg);
  }
  62.5% {
    -webkit-transform: rotate(675deg);
    transform: rotate(675deg);
  }
  75% {
    -webkit-transform: rotate(810deg);
    transform: rotate(810deg);
  }
  87.5% {
    -webkit-transform: rotate(945deg);
    transform: rotate(945deg);
  }
  to {
    -webkit-transform: rotate(1080deg);
    transform: rotate(1080deg);
  }
}
@keyframes dx-icon-rotation {
  12.5% {
    -webkit-transform: rotate(135deg);
    transform: rotate(135deg);
  }
  25% {
    -webkit-transform: rotate(270deg);
    transform: rotate(270deg);
  }
  37.5% {
    -webkit-transform: rotate(405deg);
    transform: rotate(405deg);
  }
  50% {
    -webkit-transform: rotate(540deg);
    transform: rotate(540deg);
  }
  62.5% {
    -webkit-transform: rotate(675deg);
    transform: rotate(675deg);
  }
  75% {
    -webkit-transform: rotate(810deg);
    transform: rotate(810deg);
  }
  87.5% {
    -webkit-transform: rotate(945deg);
    transform: rotate(945deg);
  }
  to {
    -webkit-transform: rotate(1080deg);
    transform: rotate(1080deg);
  }
}
@-webkit-keyframes dx-left-segment-rotation {
  from,
  to {
    -webkit-transform: rotate(130deg);
    transform: rotate(130deg);
  }
  50% {
    -webkit-transform: rotate(-5deg);
    transform: rotate(-5deg);
  }
}
@keyframes dx-left-segment-rotation {
  from,
  to {
    -webkit-transform: rotate(130deg);
    transform: rotate(130deg);
  }
  50% {
    -webkit-transform: rotate(-5deg);
    transform: rotate(-5deg);
  }
}
@-webkit-keyframes dx-right-segment-rotation {
  from,
  to {
    -webkit-transform: rotate(-130deg);
    transform: rotate(-130deg);
  }
  50% {
    -webkit-transform: rotate(5deg);
    transform: rotate(5deg);
  }
}
@keyframes dx-right-segment-rotation {
  from,
  to {
    -webkit-transform: rotate(-130deg);
    transform: rotate(-130deg);
  }
  50% {
    -webkit-transform: rotate(5deg);
    transform: rotate(5deg);
  }
}
.dx-treeview-loadindicator-wrapper {
  text-align: center;
}
.dx-treeview-node-loadindicator {
  position: absolute;
}
.dx-treeview {
  height: 100%;
}
.dx-treeview .dx-scrollable:focus,
.dx-treeview :focus {
  outline: 0;
}
.dx-treeview .dx-empty-message {
  line-height: normal;
}
.dx-checkbox + .dx-treeview-node-container,
.dx-treeview-node-container:first-child {
  margin: 0;
  display: block;
}
.dx-treeview-select-all-item {
  width: 100%;
}
.dx-treeview-node-container {
  list-style-position: inside;
  padding: 0;
  margin: 0;
  display: none;
  overflow: hidden;
}
.dx-treeview-node-container.dx-treeview-node-container-opened {
  display: block;
}
.dx-treeview-node {
  list-style-type: none;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-drag: none;
}
.dx-treeview-node a {
  text-decoration: none;
}
.dx-treeview-node .dx-checkbox {
  position: absolute;
  margin: 0;
}
.dx-treeview-item .dx-treeview-item-content span {
  vertical-align: middle;
}
.dx-treeview-item.dx-state-disabled {
  opacity: .5;
}
.dx-treeview-custom-collapse-icon,
.dx-treeview-custom-expand-icon,
.dx-treeview-toggle-item-visibility {
  position: absolute;
  cursor: pointer;
}
.dx-treeview-custom-collapse-icon.dx-state-disabled,
.dx-treeview-custom-expand-icon.dx-state-disabled,
.dx-treeview-toggle-item-visibility.dx-state-disabled {
  cursor: default;
}
.dx-rtl .dx-treeview-node-container .dx-treeview-node,
.dx-rtl .dx-treeview-node-container .dx-treeview-node.dx-treeview-item-with-checkbox .dx-treeview-item,
.dx-rtl .dx-treeview-node-container:first-child>.dx-treeview-node {
  padding-left: 0;
}
.dx-rtl .dx-treeview-node-container .dx-treeview-node .dx-treeview-item .dx-treeview-item-content > .dx-icon {
  margin-right: 0;
}
.dx-rtl .dx-treeview-custom-collapse-icon,
.dx-rtl .dx-treeview-custom-expand-icon,
.dx-rtl .dx-treeview-toggle-item-visibility {
  left: auto;
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  right: 0;
}
.dx-treeview-custom-collapse-icon,
.dx-treeview-custom-expand-icon {
  position: absolute;
  left: 0;
  cursor: pointer;
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  font-size: 24px;
  text-align: center;
  line-height: 24px;
  top: 14px;
}
.dx-rtl .dx-treeview-node .dx-checkbox {
  left: auto;
}
.dx-treeview-node-loadindicator {
  right: 0;
  top: 13px;
  left: 2px;
  width: 20px;
  height: 20px;
}
.dx-rtl.dx-treeview-border-visible .dx-treeview-select-all-item {
  padding-left: 0;
  padding-right: 26px;
}
.dx-rtl.dx-treeview-border-visible .dx-scrollable-content > .dx-treeview-node-container {
  padding-left: 1px;
  padding-right: 8px;
}
.dx-rtl .dx-treeview-node {
  padding-right: 24px;
}
.dx-rtl .dx-treeview-item .dx-treeview-item-content > .dx-icon {
  margin-left: 5px;
}
.dx-rtl .dx-treeview-item-with-checkbox .dx-treeview-item {
  padding-right: 40px;
}
.dx-rtl .dx-treeview-item-with-checkbox .dx-checkbox {
  right: 35px;
  overflow: visible;
}
.dx-rtl .dx-treeview-select-all-item {
  padding-left: 0;
  padding-right: 35px;
}
.dx-rtl .dx-treeview-select-all-item .dx-checkbox-text {
  padding-left: 0;
  padding-right: 31px;
}
.dx-treeview-search {
  margin-bottom: 8px;
}
.dx-treeview-with-search > .dx-scrollable {
  height: calc(100% - 56px);
}
.dx-treeview-border-visible {
  border: 1px solid #e0e0e0;
}
.dx-treeview-border-visible .dx-treeview-select-all-item {
  padding-left: 26px;
}
.dx-treeview-border-visible .dx-scrollable-content > .dx-treeview-node-container {
  padding: 1px 1px 1px 8px;
}
.dx-treeview-select-all-item {
  border-bottom: 1px solid #e0e0e0;
  padding: 15px 0 15px 35px;
}
.dx-treeview-select-all-item .dx-checkbox-text {
  padding-left: 31px;
}
.dx-treeview-node {
  padding-left: 24px;
}
.dx-state-selected > .dx-treeview-item {
  color: rgba(0,0,0,.87);
}
.dx-treeview-item-with-checkbox.dx-treeview-item-with-custom-expander-icon > .dx-checkbox {
  top: 17px;
}
.dx-treeview-item-with-checkbox .dx-treeview-item {
  color: rgba(0,0,0,.87);
  padding-left: 40px;
}
.dx-treeview-item-with-checkbox .dx-checkbox {
  top: 14px;
  left: 35px;
}
.dx-treeview-item-without-checkbox.dx-treeview-item-with-custom-expander-icon > .dx-treeview-item {
  padding-left: 8px;
}
.dx-treeview-item-without-checkbox.dx-state-selected > .dx-treeview-item {
  color: rgba(0,0,0,.87);
  background-color: rgba(0,0,0,.12);
}
.dx-treeview-item-without-checkbox.dx-state-selected > .dx-treeview-item.dx-state-hover:not(.dx-state-focused) {
  background-color: rgba(0,0,0,.14);
}
.dx-treeview-item-without-checkbox.dx-state-focused > .dx-treeview-item {
  background-color: rgba(0,0,0,.04);
  color: rgba(0,0,0,.87);
}
.dx-treeview-item {
  display: block;
  cursor: pointer;
  padding: 13px 8px;
  min-height: 48px;
  line-height: 22px;
}
.dx-treeview-item .dx-treeview-item-content > .dx-icon {
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  font-size: 24px;
  text-align: center;
  line-height: 24px;
}
.dx-treeview-item.dx-state-hover {
  background-color: rgba(0,0,0,.04);
  color: rgba(0,0,0,.87);
}
.dx-treeview-toggle-item-visibility {
  font: 24px/24px DXIcons;
  text-align: center;
  color: rgba(0,0,0,.54);
  width: 24px;
  height: 48px;
  top: 0;
  left: 0;
}
.dx-treeview-toggle-item-visibility::before {
  content: "\\f010";
  position: absolute;
  display: block;
  width: 24px;
  top: 50%;
  margin-top: -12px;
  left: 50%;
  margin-left: -12px;
}
.dx-treeview-toggle-item-visibility.dx-treeview-toggle-item-visibility-opened {
  font: 24px/24px DXIcons;
  text-align: center;
}
.dx-treeview-toggle-item-visibility.dx-treeview-toggle-item-visibility-opened::before {
  content: "\\f016";
  position: absolute;
  display: block;
  width: 24px;
  top: 50%;
  margin-top: -12px;
  left: 50%;
  margin-left: -12px;
}
.dx-menu-base .dx-menu-item-wrapper,
.dx-menu-base .dx-menu-items-container {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
}
.dx-menu-base .dx-menu-items-container {
  list-style-type: none;
  display: inline-block;
  white-space: nowrap;
  cursor: pointer;
}
.dx-menu-base .dx-state-disabled,
.dx-menu-base.dx-state-disabled .dx-menu-items-container {
  cursor: default;
}
.dx-menu-base .dx-menu-item {
  display: inline-block;
  position: relative;
  height: 100%;
  width: 100%;
}
.dx-menu-base .dx-menu-item.dx-state-disabled {
  opacity: .5;
}
.dx-menu-base .dx-menu-item .dx-menu-item-content {
  white-space: nowrap;
  height: 100%;
  width: 100%;
  line-height: 24px;
}
.dx-menu-base .dx-menu-item .dx-menu-item-content .dx-icon {
  display: inline-block;
  vertical-align: middle;
  border: 0;
}
.dx-menu-base .dx-menu-item .dx-menu-item-content .dx-menu-item-text {
  display: inline;
  vertical-align: middle;
  overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dx-menu-base .dx-menu-item .dx-menu-item-content .dx-menu-item-text-with-url {
  vertical-align: baseline;
}
.dx-menu-base .dx-menu-item .dx-menu-item-content .dx-icon-with-url {
  vertical-align: top;
}
.dx-menu-base .dx-menu-item .dx-menu-item-content .dx-item-url {
  vertical-align: middle;
}
.dx-menu-base .dx-menu-item .dx-menu-item-content .dx-menu-item-popout-container {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 2em;
}
.dx-menu-base .dx-menu-item .dx-menu-item-content .dx-menu-item-popout-container .dx-menu-item-popout {
  height: 100%;
}
.dx-menu-base.dx-rtl {
  text-align: right;
}
.dx-menu-base.dx-rtl .dx-menu-item-popout-container {
  left: 0;
  right: auto;
}
.dx-menu-item {
  color: rgba(117,117,117,.87);
}
.dx-menu-item a {
  color: #009688;
}
.dx-menu-item.dx-state-focused,
.dx-menu-item.dx-state-hover {
  background-color: rgba(0,0,0,.04);
}
.dx-menu-item-selected {
  background-color: rgba(224,224,224,.87);
  color: rgba(0,0,0,.87);
}
.dx-menu-item-selected.dx-state-focused {
  background-color: rgba(0,0,0,.7);
}
.dx-menu-item-expanded,
.dx-menu-item-expanded.dx-state-focused,
.dx-menu-item-expanded.dx-state-hover {
  color: rgba(117,117,117,.87);
  background-color: rgba(224,224,224,.87);
}
.dx-menu-base {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
  text-align: left;
  color: rgba(0,0,0,.87);
  font-weight: 400;
  font-size: 14px;
  font-family: Roboto,RobotoFallback,"Noto Kufi Arabic",Helvetica,Arial,sans-serif;
  line-height: 1.2857;
}
.dx-menu-base input,
.dx-menu-base textarea {
  font-family: Roboto,RobotoFallback,"Noto Kufi Arabic",Helvetica,Arial,sans-serif;
  line-height: 1.2857;
}
.dx-menu-base.dx-state-focused {
  outline: 0;
}
.dx-menu-base .dx-icon {
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  font-size: 24px;
  text-align: center;
  line-height: 24px;
}
.dx-menu-base .dx-menu-item .dx-menu-item-content .dx-menu-item-popout {
  min-width: 7px;
  min-height: 7px;
}
.dx-menu-base.dx-rtl .dx-menu-item-content .dx-icon {
  margin-left: auto;
  margin-right: auto;
}
.dx-menu-base.dx-rtl .dx-menu-item-content .dx-menu-item-popout-container {
  margin-left: 0;
  margin-right: auto;
}
.dx-menu-base.dx-rtl .dx-menu-item-content .dx-menu-item-popout-container .dx-menu-item-popout {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
.dx-menu {
  position: relative;
  color: rgba(117,117,117,.87);
}
.dx-menu-horizontal {
  height: 100%;
}
.dx-menu-horizontal::after {
  height: 100%;
  display: inline-block;
  content: "";
  vertical-align: middle;
}
.dx-menu-horizontal .dx-menu-item-wrapper {
  display: inline-block;
}
.dx-menu-horizontal .dx-menu-separator {
  display: inline-block;
  margin: 0 15px 0 0;
}
.dx-menu-vertical {
  height: 100%;
}
.dx-menu-vertical::after {
  height: 100%;
  display: inline-block;
  content: "";
  vertical-align: middle;
}
.dx-menu-vertical .dx-menu-item-wrapper {
  display: block;
}
.dx-menu-vertical .dx-menu-separator {
  margin: 0 0 15px;
}
.dx-rtl.dx-menu {
  text-align: right;
}
.dx-context-menu-container-border {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: absolute;
}
.dx-context-menu-content-delimiter {
  position: absolute;
  display: none;
  z-index: 2000;
  cursor: pointer;
}
.dx-rtl .dx-menu-adaptive-mode .dx-treeview-toggle-item-visibility,
.dx-rtl.dx-menu-adaptive-mode .dx-treeview-toggle-item-visibility {
  left: 0;
  right: auto;
}
.dx-menu-adaptive-mode .dx-treeview-item {
  cursor: pointer;
}
.dx-menu-adaptive-mode .dx-treeview-node-container:first-child > .dx-treeview-node {
  padding: 1px;
  border-bottom: 1px solid #e0e0e0;
}
.dx-menu-adaptive-mode .dx-treeview-node-container:first-child > .dx-treeview-node .dx-item-content {
  padding-left: 15px;
}
.dx-rtl .dx-menu-adaptive-mode .dx-treeview-node-container:first-child > .dx-treeview-node .dx-item-content,
.dx-rtl.dx-menu-adaptive-mode .dx-treeview-node-container:first-child > .dx-treeview-node .dx-item-content {
  padding-right: 15px;
}
.dx-menu-adaptive-mode .dx-treeview-node-container:first-child > .dx-treeview-node:last-child {
  border-bottom: none;
}
.dx-menu-adaptive-mode-overlay-wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row wrap;
  flex-flow: row wrap;
}
.dx-menu-adaptive-mode-overlay-wrapper .dx-overlay-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.dx-menu-adaptive-mode-overlay-wrapper .dx-overlay-content .dx-treeview {
  height: auto;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.dx-context-menu-container-border,
.dx-context-menu-content-delimiter {
  background-color: transparent;
}
.dx-menu .dx-menu-item {
  font-size: 14px;
  border-radius: 4px;
}
.dx-menu .dx-menu-item .dx-menu-item-content {
  padding: 12px 16px;
}
.dx-menu .dx-menu-item .dx-menu-item-content .dx-menu-item-popout-container {
  width: 0;
}
.dx-menu .dx-menu-item.dx-menu-item-has-text.dx-menu-item-has-icon .dx-icon {
  margin-right: 16px;
}
.dx-menu.dx-rtl .dx-menu-item.dx-menu-item-has-text.dx-menu-item-has-icon .dx-icon {
  margin-left: 24px;
  margin-right: 0;
}
.dx-menu-adaptive-mode {
  background-color: #fff;
}
.dx-menu-adaptive-mode .dx-treeview {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.dx-menu-adaptive-mode .dx-treeview,
.dx-menu-adaptive-mode .dx-treeview.dx-state-focused {
  -webkit-box-shadow: 0 3px 10px rgba(0,0,0,.1);
  box-shadow: 0 3px 10px rgba(0,0,0,.1);
}
.dx-menu-adaptive-mode .dx-treeview-toggle-item-visibility {
  left: auto;
  right: 0;
  font-size: 18px;
}
.dx-menu-adaptive-mode .dx-treeview-node.dx-state-focused .dx-treeview-node .dx-treeview-toggle-item-visibility {
  color: inherit;
}
.dx-menu-adaptive-mode .dx-treeview-node.dx-state-focused .dx-treeview-toggle-item-visibility {
  color: #fff;
}
.dx-selectbox {
  cursor: pointer;
}
.dx-selectbox .dx-texteditor-input {
  max-width: 100%;
}
.dx-selectbox .dx-texteditor-input:-moz-read-only {
  cursor: pointer;
}
.dx-selectbox .dx-texteditor-input:read-only {
  cursor: pointer;
}
.dx-selectbox-container {
  position: relative;
}
.dx-state-disabled .dx-selectbox .dx-texteditor-input,
.dx-state-disabled.dx-selectbox .dx-texteditor-input {
  cursor: default;
}
.dx-selectbox-popup-wrapper .dx-overlay-content {
  -webkit-box-shadow: 0 2px 7px rgba(0,0,0,.2);
  box-shadow: 0 2px 7px rgba(0,0,0,.2);
}
.dx-selectbox-popup-wrapper .dx-popup-content {
  padding: 0;
}
.dx-selectbox-popup-wrapper .dx-list {
  background-color: #fff;
}
.dx-toolbar.dx-toolbar-multiline .dx-toolbar-items-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  height: 100%;
}
.dx-toolbar.dx-toolbar-multiline .dx-toolbar-items-container .dx-toolbar-before {
  position: relative;
}
.dx-toolbar.dx-toolbar-multiline .dx-toolbar-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  height: 56px;
}
.dx-toolbar .dx-button .dx-icon {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
.dx-toolbar-items-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.dx-toolbar-item {
  padding: 0 5px;
  display: table-cell;
  vertical-align: middle;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
.dx-toolbar-item .dx-tabs {
  table-layout: auto;
}
.dx-toolbar-item img {
  display: block;
}
.dx-toolbar-menu-container {
  display: table-cell;
  vertical-align: middle;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
.dx-toolbar-menu-container .dx-tabs {
  table-layout: auto;
}
.dx-toolbar-menu-container img {
  display: block;
}
.dx-toolbar-group {
  float: left;
  margin: 0 10px;
}
.dx-toolbar-after,
.dx-toolbar-before {
  position: absolute;
}
.dx-toolbar-center:empty {
  display: none;
}
.dx-toolbar-before {
  left: 0;
}
.dx-toolbar-after {
  right: 0;
}
.dx-toolbar-label {
  white-space: nowrap;
  -webkit-user-drag: none;
}
.dx-toolbar-label .dx-toolbar-item-content > div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dx-toolbar-label > div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 -5px;
  padding: 0 5px;
}
.dx-toolbar-center {
  margin: 0 auto;
  text-align: center;
}
.dx-toolbar-after,
.dx-toolbar-before,
.dx-toolbar-center {
  top: 0;
  display: table;
  height: 100%;
}
.dx-rtl .dx-toolbar-before {
  right: 0;
  left: auto;
}
.dx-rtl .dx-toolbar-after {
  right: auto;
  left: 0;
}
.dx-toolbar-menu-section:empty {
  display: none;
}
.dx-dropdownmenu-popup-wrapper .dx-toolbar-menu-custom>.dx-list-item-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-list-item-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-auto-hide,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-list-item-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-auto-hide,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-content {
  padding: 0;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-list-item-content > .dx-button,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-list-item-content.dx-button,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-auto-hide > .dx-button,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-auto-hide.dx-button,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-content > .dx-button,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-content.dx-button,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-list-item-content > .dx-button,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-list-item-content.dx-button,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-auto-hide > .dx-button,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-auto-hide.dx-button,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-content > .dx-button,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-content.dx-button {
  padding: 0;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-list-item-content > .dx-button .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-list-item-content > .dx-buttongroup .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-list-item-content.dx-button .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-list-item-content.dx-buttongroup .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-auto-hide > .dx-button .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-auto-hide > .dx-buttongroup .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-auto-hide.dx-button .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-auto-hide.dx-buttongroup .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-content > .dx-button .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-content > .dx-buttongroup .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-content.dx-button .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-content.dx-buttongroup .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-list-item-content > .dx-button .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-list-item-content > .dx-buttongroup .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-list-item-content.dx-button .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-list-item-content.dx-buttongroup .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-auto-hide > .dx-button .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-auto-hide > .dx-buttongroup .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-auto-hide.dx-button .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-auto-hide.dx-buttongroup .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-content > .dx-button .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-content > .dx-buttongroup .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-content.dx-button .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-content.dx-buttongroup .dx-button-content {
  -webkit-box-pack: left;
  -ms-flex-pack: left;
  justify-content: left;
}
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-list-item-content > .dx-button .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-list-item-content > .dx-buttongroup .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-list-item-content.dx-button .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-list-item-content.dx-buttongroup .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-auto-hide > .dx-button .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-auto-hide > .dx-buttongroup .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-auto-hide.dx-button .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-auto-hide.dx-buttongroup .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-content > .dx-button .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-content > .dx-buttongroup .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-content.dx-button .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-content.dx-buttongroup .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-list-item-content > .dx-button .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-list-item-content > .dx-buttongroup .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-list-item-content.dx-button .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-list-item-content.dx-buttongroup .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-auto-hide > .dx-button .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-auto-hide > .dx-buttongroup .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-auto-hide.dx-button .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-auto-hide.dx-buttongroup .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-content > .dx-button .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-content > .dx-buttongroup .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-content.dx-button .dx-button-content,
.dx-rtl .dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-content.dx-buttongroup .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-list-item-content > .dx-button .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-list-item-content > .dx-buttongroup .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-list-item-content.dx-button .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-list-item-content.dx-buttongroup .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-auto-hide > .dx-button .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-auto-hide > .dx-buttongroup .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-auto-hide.dx-button .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-auto-hide.dx-buttongroup .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-content > .dx-button .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-content > .dx-buttongroup .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-content.dx-button .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-content.dx-buttongroup .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-list-item-content > .dx-button .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-list-item-content > .dx-buttongroup .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-list-item-content.dx-button .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-list-item-content.dx-buttongroup .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-auto-hide > .dx-button .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-auto-hide > .dx-buttongroup .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-auto-hide.dx-button .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-auto-hide.dx-buttongroup .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-content > .dx-button .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-content > .dx-buttongroup .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-content.dx-button .dx-button-content,
.dx-rtl.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-content.dx-buttongroup .dx-button-content {
  -webkit-box-pack: right;
  -ms-flex-pack: right;
  justify-content: right;
}
.dx-toolbar-menu-section.dx-toolbar-menu-last-section {
  border-bottom: none;
}
.dx-toolbar-menu-section .dx-list-item-content::before {
  content: none;
}
.dx-toolbar-menu-section .dx-list-item-content,
.dx-toolbar-menu-section .dx-list-item-content.dx-list,
.dx-toolbar-menu-section .dx-list-item-content>.dx-list,
.dx-toolbar-menu-section .dx-toolbar-item-auto-hide,
.dx-toolbar-menu-section .dx-toolbar-item-auto-hide.dx-list,
.dx-toolbar-menu-section .dx-toolbar-item-auto-hide>.dx-list,
.dx-toolbar-menu-section .dx-toolbar-item-content,
.dx-toolbar-menu-section .dx-toolbar-item-content.dx-list,
.dx-toolbar-menu-section .dx-toolbar-item-content>.dx-list {
  padding: 0;
}
.dx-toolbar-menu-section .dx-list-item-content > .dx-button,
.dx-toolbar-menu-section .dx-list-item-content.dx-button,
.dx-toolbar-menu-section .dx-toolbar-item-auto-hide > .dx-button,
.dx-toolbar-menu-section .dx-toolbar-item-auto-hide.dx-button,
.dx-toolbar-menu-section .dx-toolbar-item-content > .dx-button,
.dx-toolbar-menu-section .dx-toolbar-item-content.dx-button {
  width: 100%;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button {
  width: 100%;
  border: none;
  margin: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-buttongroup {
  width: 100%;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-buttongroup .dx-buttongroup-wrapper {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-buttongroup .dx-buttongroup-wrapper .dx-buttongroup-item {
  border: none;
}
.dx-toolbar-text-auto-hide .dx-button .dx-button-text {
  display: none;
}
.dx-list-item-content > .dx-texteditor,
.dx-list-item-content.dx-texteditor,
.dx-toolbar-item-content > .dx-texteditor,
.dx-toolbar-item-content.dx-texteditor {
  width: 150px;
}
.dx-toolbar-item-invisible {
  display: none;
}
.dx-dropdownmenu-popup-wrapper .dx-dropdownmenu-list {
  min-height: 0;
  min-width: 100px;
  border-radius: 8px;
}
.dx-dropdownmenu-popup-wrapper .dx-dropdownmenu-list .dx-list-item {
  display: block;
}
.dx-dropdownmenu-popup-wrapper .dx-dropdownmenu-list .dx-list-item:last-of-type {
  border-bottom: none;
}
.dx-dropdownmenu-popup-wrapper .dx-dropdownmenu-list .dx-list-item-content {
  display: block;
}
.dx-dropdownmenu-popup-wrapper .dx-overlay-content .dx-popup-content {
  padding: 1px;
}
.dx-dropdownmenu-popup-wrapper .dx-list-item {
  display: block;
  border-top: 0;
}
.dx-dropdownmenu-popup-wrapper .dx-overlay-content {
  -webkit-box-shadow: 0 2px 7px rgba(0,0,0,.2);
  box-shadow: 0 2px 7px rgba(0,0,0,.2);
}
.dx-toolbar {
  width: 100%;
  background-color: #fff;
  color: rgba(0,0,0,.87);
  padding: 0;
  overflow: visible;
}
.dx-toolbar .dx-toolbar-before {
  padding-right: 15px;
}
.dx-rtl.dx-toolbar .dx-toolbar-before {
  padding-right: 0;
  padding-left: 15px;
}
.dx-toolbar .dx-toolbar-after {
  padding-left: 15px;
}
.dx-rtl.dx-toolbar .dx-toolbar-after {
  padding-left: 0;
  padding-right: 15px;
}
.dx-toolbar .dx-toolbar-after:empty,
.dx-toolbar .dx-toolbar-before:empty {
  padding: 0;
}
.dx-toolbar .dx-toolbar-items-container {
  height: 56px;
  overflow: visible;
}
.dx-toolbar .dx-toolbar-menu-container {
  padding: 0 0 0 5px;
}
.dx-rtl.dx-toolbar .dx-toolbar-menu-container,
.dx-toolbar .dx-toolbar-item {
  padding: 0 5px 0 0;
}
.dx-toolbar .dx-toolbar-item.dx-toolbar-first-in-group {
  padding-left: 20px;
}
.dx-toolbar .dx-toolbar-item:last-child {
  padding: 0;
}
.dx-rtl.dx-toolbar .dx-toolbar-item {
  padding: 0 0 0 5px;
}
.dx-rtl.dx-toolbar .dx-toolbar-item:last-child {
  padding: 0;
}
.dx-toolbar .dx-toolbar-label {
  font-size: 20px;
  font-weight: 500;
}
.dx-toolbar.dx-state-disabled {
  opacity: 1;
}
.dx-toolbar-after .dx-toolbar-item,
.dx-toolbar-after .dx-toolbar-item:last-child {
  padding: 0 0 0 5px;
}
.dx-toolbar-after .dx-toolbar-item:first-child {
  padding: 0;
}
.dx-rtl .dx-toolbar-after .dx-toolbar-item:first-child {
  padding-left: 5px;
}
.dx-toolbar-background {
  background-color: #fff;
}
.dx-toolbar-menu-section {
  border-bottom: 1px solid #e0e0e0;
}
.dx-toolbar-menu-section .dx-list-item-content,
.dx-toolbar-menu-section .dx-toolbar-item-auto-hide {
  padding: 14px 16px 13px;
}
.dx-toolbar-menu-section .dx-list-item-content {
  font-size: 14px;
  vertical-align: middle;
}
.dx-toolbar-menu-section .dx-list-item-content .dx-list-item-icon-container {
  height: 18px;
  width: 18px;
  margin-right: 9px;
  margin-left: 0;
}
.dx-rtl .dx-toolbar-menu-section .dx-list-item-content .dx-list-item-icon-container,
.dx-rtl.dx-toolbar-menu-section .dx-list-item-content .dx-list-item-icon-container,
.dx-toolbar-menu-section .dx-list-item-content .dx-list-item-icon-container.dx-icon-right {
  margin-left: 9px;
  margin-right: 0;
}
.dx-rtl .dx-toolbar-menu-section .dx-list-item-content .dx-list-item-icon-container.dx-icon-right,
.dx-rtl.dx-toolbar-menu-section .dx-list-item-content .dx-list-item-icon-container.dx-icon-right {
  margin-right: 9px;
  margin-left: 0;
}
.dx-toolbar-menu-section .dx-list-item-content .dx-list-item-icon-container .dx-icon {
  width: 18px;
  height: 18px;
  background-position: 0 0;
  background-size: 18px 18px;
  padding: 0;
  font-size: 18px;
  text-align: center;
  line-height: 18px;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-toolbar-item-auto-hide,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-toolbar-item-auto-hide {
  padding: 0;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text {
  border: none;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button.dx-button-back,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button.dx-button-back,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button.dx-button-back,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button.dx-button-back,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button.dx-button-back,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button.dx-button-back {
  border-radius: 0;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-back,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-normal,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-back,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-normal,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-back,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-normal,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-back,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-normal,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-back,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-normal,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-back,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-normal {
  background-color: transparent;
  color: rgba(0,0,0,.87);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-back .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-normal .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-back .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-normal .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-back .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-normal .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-back .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-normal .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-back .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-normal .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-back .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-normal .dx-icon {
  color: rgba(0,0,0,.87);
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-back.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-back.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-normal.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-normal.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-back.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-back.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-normal.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-normal.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-back.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-back.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-normal.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-normal.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-back.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-back.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-normal.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-normal.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-back.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-back.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-normal.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-normal.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-back.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-back.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-normal.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-normal.dx-state-hover {
  background-color: rgba(0,0,0,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-back.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-normal.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-back.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-normal.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-back.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-normal.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-back.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-normal.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-back.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-normal.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-back.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-normal.dx-state-active {
  background-color: rgba(0,0,0,.3);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-back.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-normal.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-back.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-normal.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-back.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-normal.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-back.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-normal.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-back.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-normal.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-back.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-normal.dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-back.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-normal.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-back.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-normal.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-back.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-normal.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-back.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-normal.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-back.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-normal.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-back.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-normal.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-back.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-back.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-normal.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-normal.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-back.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-back.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-normal.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-normal.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-back.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-back.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-normal.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-normal.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-back.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-back.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-normal.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-normal.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-back.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-back.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-normal.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-normal.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-back.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-back.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-normal.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-normal.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-back .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-normal .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-back .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-normal .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-back .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-normal .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-back .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-normal .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-back .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-normal .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-back .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-normal .dx-inkripple-wave {
  background-color: rgba(0,0,0,.2);
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-default,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-default,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-default,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-default,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-default,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-default {
  background-color: transparent;
  color: #009688;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-default .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-default .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-default .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-default .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-default .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-default .dx-icon {
  color: #009688;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-default.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-default.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-default.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-default.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-default.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-default.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-default.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-default.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-default.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-default.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-default.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-default.dx-state-hover {
  background-color: rgba(0,150,136,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-default.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-default.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-default.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-default.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-default.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-default.dx-state-active {
  background-color: rgba(0,150,136,.36);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-default.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-default.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-default.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-default.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-default.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-default.dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-default.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-default.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-default.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-default.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-default.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-default.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-default.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-default.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-default.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-default.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-default.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-default.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-default.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-default.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-default.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-default.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-default.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-default.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-default .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-default .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-default .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-default .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-default .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-default .dx-inkripple-wave {
  background-color: rgba(0,150,136,.2);
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-danger,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-danger,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-danger,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-danger,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-danger,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-danger {
  background-color: transparent;
  color: #f44336;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-danger .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-danger .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-danger .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-danger .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-danger .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-danger .dx-icon {
  color: #f44336;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-danger.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-danger.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-danger.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-danger.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-danger.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-danger.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-danger.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-danger.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-danger.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-danger.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-danger.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-danger.dx-state-hover {
  background-color: rgba(244,67,54,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-danger.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-danger.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-danger.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-danger.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-danger.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-danger.dx-state-active {
  background-color: rgba(244,67,54,.36);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-danger.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-danger.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-danger.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-danger.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-danger.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-danger.dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-danger.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-danger.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-danger.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-danger.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-danger.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-danger.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-danger.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-danger.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-danger.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-danger.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-danger.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-danger.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-danger.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-danger.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-danger.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-danger.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-danger.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-danger.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-danger .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-danger .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-danger .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-danger .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-danger .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-danger .dx-inkripple-wave {
  background-color: rgba(244,67,54,.2);
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-success,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-success,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-success,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-success,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-success,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-success {
  background-color: transparent;
  color: #8bc34a;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-success .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-success .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-success .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-success .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-success .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-success .dx-icon {
  color: #8bc34a;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-success.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-success.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-success.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-success.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-success.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-success.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-success.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-success.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-success.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-success.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-success.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-success.dx-state-hover {
  background-color: rgba(139,195,74,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-success.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-success.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-success.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-success.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-success.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-success.dx-state-active {
  background-color: rgba(139,195,74,.36);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-success.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-success.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-success.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-success.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-success.dx-state-disabled,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-success.dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-success.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-success.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-success.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-success.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-success.dx-state-disabled .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-success.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-success.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-success.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-success.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-success.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-success.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-success.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-success.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-success.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-success.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-success.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-success.dx-state-disabled .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-success.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-success .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-success .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-success .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-success .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-success .dx-inkripple-wave,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-success .dx-inkripple-wave {
  background-color: rgba(139,195,74,.2);
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button {
  height: 48px;
  padding: 0;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button .dx-button-text,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button .dx-button-text {
  text-transform: none;
  font-weight: 400;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button .dx-button-content,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button .dx-button-content {
  padding: 0 16px;
}
.dx-toolbar-menu-section .dx-button.dx-button-back:not(.dx-buttongroup-item) {
  border-radius: 4px;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group {
  margin-top: 0;
  margin-bottom: 0;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group:first-of-type {
  margin-top: 8px;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group:last-of-type {
  margin-bottom: 8px;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-buttongroup-wrapper .dx-buttongroup-item.dx-button {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-buttongroup-wrapper .dx-buttongroup-item.dx-button .dx-button-content {
  padding: 0 16px;
}
.dx-toolbar-button.dx-toolbar-text-auto-hide .dx-button {
  min-width: 36px;
}
.dx-toolbar-button.dx-toolbar-text-auto-hide .dx-button .dx-button-content {
  padding: 0;
}
.dx-toolbar-button.dx-toolbar-text-auto-hide .dx-button .dx-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
  margin-right: 0;
  margin-left: 0;
}
.dx-rtl .dx-toolbar-button.dx-toolbar-text-auto-hide .dx-button .dx-icon,
.dx-rtl.dx-toolbar-button.dx-toolbar-text-auto-hide .dx-button .dx-icon,
.dx-toolbar-button.dx-toolbar-text-auto-hide .dx-button .dx-icon.dx-icon-right {
  margin-left: 0;
  margin-right: 0;
}
.dx-rtl .dx-toolbar-button.dx-toolbar-text-auto-hide .dx-button .dx-icon.dx-icon-right,
.dx-rtl.dx-toolbar-button.dx-toolbar-text-auto-hide .dx-button .dx-icon.dx-icon-right {
  margin-right: 0;
  margin-left: 0;
}
.dx-toolbar-button.dx-toolbar-text-auto-hide .dx-button.dx-button-has-icon.dx-button-has-text {
  border-radius: 50%;
}
.dx-toolbar-button .dx-menu .dx-menu-item {
  color: rgba(0,0,0,.87);
  font-size: 14px;
  font-weight: 500;
  height: 36px;
}
.dx-toolbar-button .dx-menu .dx-menu-item .dx-menu-item-content {
  padding-top: 7px;
  padding-bottom: 7px;
}
.dx-toolbar-button .dx-menu .dx-menu-item.dx-menu-item-has-text.dx-menu-item-has-icon .dx-icon {
  margin-right: 6px;
  margin-left: 0;
}
.dx-rtl .dx-toolbar-button .dx-menu .dx-menu-item.dx-menu-item-has-text.dx-menu-item-has-icon .dx-icon,
.dx-rtl.dx-toolbar-button .dx-menu .dx-menu-item.dx-menu-item-has-text.dx-menu-item-has-icon .dx-icon,
.dx-toolbar-button .dx-menu .dx-menu-item.dx-menu-item-has-text.dx-menu-item-has-icon .dx-icon.dx-icon-right {
  margin-left: 6px;
  margin-right: 0;
}
.dx-rtl .dx-toolbar-button .dx-menu .dx-menu-item.dx-menu-item-has-text.dx-menu-item-has-icon .dx-icon.dx-icon-right,
.dx-rtl.dx-toolbar-button .dx-menu .dx-menu-item.dx-menu-item-has-text.dx-menu-item-has-icon .dx-icon.dx-icon-right {
  margin-right: 6px;
  margin-left: 0;
}
.dx-toolbar-button .dx-menu .dx-menu-item.dx-state-active,
.dx-toolbar-button .dx-menu .dx-menu-item.dx-state-focused,
.dx-toolbar-button .dx-menu .dx-menu-item.dx-state-hover {
  background-color: #ebebeb;
}
.dx-toolbar .dx-tab {
  padding: 4px;
}
.dx-popup-draggable .dx-popup-title {
  cursor: move;
  -ms-touch-action: pinch-zoom;
  touch-action: pinch-zoom;
}
.dx-overlay-content > .dx-template-wrapper.dx-popup-title {
  height: auto;
  width: auto;
}
.dx-overlay-content .dx-popup-content > .dx-template-wrapper {
  height: 100%;
  width: 100%;
}
.dx-overlay-content .dx-popup-content {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
.dx-popup-flex-height {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.dx-overlay-wrapper .dx-overlay-content.dx-popup-flex-height > .dx-popup-bottom,
.dx-overlay-wrapper .dx-overlay-content.dx-popup-flex-height > .dx-popup-title {
  width: 100%;
}
.dx-popup-flex-height .dx-popup-content {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: auto;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  max-width: 100%;
  -ms-flex-preferred-size: 100%;
  flex-basis: 100%;
}
.dx-popup-inherit-height .dx-popup-content>.dx-scrollable,
.dx-popup-inherit-height .dx-popup-content>.dx-scrollable>.dx-scrollable-wrapper,
.dx-popup-inherit-height .dx-popup-content>.dx-scrollable>.dx-scrollable-wrapper>.dx-scrollable-container,
.dx-popup-inherit-height .dx-popup-content>.dx-treeview>.dx-scrollable,
.dx-popup-inherit-height .dx-popup-content>.dx-treeview>.dx-scrollable>.dx-scrollable-wrapper,
.dx-popup-inherit-height .dx-popup-content>.dx-treeview>.dx-scrollable>.dx-scrollable-wrapper>.dx-scrollable-container {
  max-height: inherit;
  min-height: inherit;
}
.dx-popup-inherit-height .dx-popup-content > .dx-widget {
  max-height: inherit;
}
.dx-popup-inherit-height .dx-popup-content>.dx-template-wrapper,
.dx-popup-inherit-height .dx-popup-content>.dx-template-wrapper>.dx-scrollable,
.dx-popup-inherit-height .dx-popup-content>.dx-template-wrapper>.dx-scrollable>.dx-scrollable-wrapper,
.dx-popup-inherit-height .dx-popup-content>.dx-template-wrapper>.dx-scrollable>.dx-scrollable-wrapper>.dx-scrollable-container,
.dx-popup-inherit-height .dx-popup-content>.dx-template-wrapper>.dx-treeview>.dx-scrollable,
.dx-popup-inherit-height .dx-popup-content>.dx-template-wrapper>.dx-treeview>.dx-scrollable>.dx-scrollable-wrapper,
.dx-popup-inherit-height .dx-popup-content>.dx-template-wrapper>.dx-treeview>.dx-scrollable>.dx-scrollable-wrapper>.dx-scrollable-container {
  max-height: inherit;
  min-height: inherit;
}
.dx-popup-inherit-height .dx-popup-content > .dx-template-wrapper > .dx-widget {
  max-height: inherit;
}
.dx-popup-content-scrollable {
  overflow: auto;
  -ms-scroll-chaining: none;
  overscroll-behavior: contain;
}
.dx-dialog-root .dx-overlay-shader {
  background-color: #444;
}
.dx-prevent-safari-scrolling {
  position: fixed;
  margin: 0;
  left: 0;
  right: 0;
  top: 0;
}
.dx-popup-wrapper > .dx-overlay-content {
  background: #fff;
  -webkit-box-shadow: 0 11px 15px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12);
  box-shadow: 0 11px 15px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12);
  border-radius: 4px;
}
.dx-popup-wrapper > .dx-popup-fullscreen {
  border-radius: 0;
}
.dx-popup-title {
  padding: 10px;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  white-space: normal;
  position: relative;
  min-height: 28px;
  border-bottom: 1px solid #e0e0e0;
  background: 0 0;
  color: rgba(0,0,0,.87);
}
.dx-popup-title.dx-toolbar {
  padding: 0 24px;
  overflow: visible;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-popup-title.dx-toolbar .dx-toolbar-before {
  padding-right: 15px;
}
.dx-rtl.dx-popup-title.dx-toolbar .dx-toolbar-before {
  padding-right: 0;
  padding-left: 15px;
}
.dx-popup-title.dx-toolbar .dx-toolbar-after {
  padding-left: 15px;
}
.dx-rtl.dx-popup-title.dx-toolbar .dx-toolbar-after {
  padding-left: 0;
  padding-right: 15px;
}
.dx-popup-title.dx-toolbar .dx-toolbar-after:empty,
.dx-popup-title.dx-toolbar .dx-toolbar-before:empty {
  padding: 0;
}
.dx-popup-title.dx-toolbar .dx-toolbar-items-container {
  height: 64px;
  overflow: visible;
}
.dx-popup-title.dx-toolbar .dx-toolbar-menu-container {
  padding: 0 0 0 8px;
}
.dx-popup-title.dx-toolbar .dx-toolbar-item,
.dx-rtl.dx-popup-title.dx-toolbar .dx-toolbar-menu-container {
  padding: 0 8px 0 0;
}
.dx-popup-title.dx-toolbar .dx-toolbar-item.dx-toolbar-first-in-group {
  padding-left: 20px;
}
.dx-popup-title.dx-toolbar .dx-toolbar-item:last-child {
  padding: 0;
}
.dx-rtl.dx-popup-title.dx-toolbar .dx-toolbar-item {
  padding: 0 0 0 8px;
}
.dx-rtl.dx-popup-title.dx-toolbar .dx-toolbar-item:last-child {
  padding: 0;
}
.dx-popup-title.dx-toolbar .dx-toolbar-label {
  font-size: 20px;
  font-weight: 500;
}
.dx-popup-content {
  -webkit-user-drag: none;
  padding: 24px;
}
.dx-popup-content > .dx-button {
  margin: 0 8px;
}
.dx-popup-bottom {
  background: 0 0;
  color: rgba(0,0,0,.87);
}
.dx-popup-bottom.dx-toolbar {
  padding: 0 20px;
  overflow: visible;
}
.dx-popup-bottom.dx-toolbar .dx-toolbar-before {
  padding-right: 15px;
}
.dx-rtl.dx-popup-bottom.dx-toolbar .dx-toolbar-before {
  padding-right: 0;
  padding-left: 15px;
}
.dx-popup-bottom.dx-toolbar .dx-toolbar-after {
  padding-left: 15px;
}
.dx-rtl.dx-popup-bottom.dx-toolbar .dx-toolbar-after {
  padding-left: 0;
  padding-right: 15px;
}
.dx-popup-bottom.dx-toolbar .dx-toolbar-after:empty,
.dx-popup-bottom.dx-toolbar .dx-toolbar-before:empty {
  padding: 0;
}
.dx-popup-bottom.dx-toolbar .dx-toolbar-items-container {
  height: 52px;
  overflow: visible;
}
.dx-popup-bottom.dx-toolbar .dx-toolbar-menu-container {
  padding: 0 0 0 8px;
}
.dx-popup-bottom.dx-toolbar .dx-toolbar-item,
.dx-rtl.dx-popup-bottom.dx-toolbar .dx-toolbar-menu-container {
  padding: 0 8px 0 0;
}
.dx-popup-bottom.dx-toolbar .dx-toolbar-item.dx-toolbar-first-in-group {
  padding-left: 20px;
}
.dx-popup-bottom.dx-toolbar .dx-toolbar-item:last-child {
  padding: 0;
}
.dx-rtl.dx-popup-bottom.dx-toolbar .dx-toolbar-item {
  padding: 0 0 0 8px;
}
.dx-rtl.dx-popup-bottom.dx-toolbar .dx-toolbar-item:last-child {
  padding: 0;
}
.dx-popup-bottom.dx-toolbar .dx-toolbar-label {
  font-size: 20px;
  font-weight: 500;
}
.dx-popup-content.dx-dialog-content {
  min-width: 172px;
  padding: 24px;
}
.dx-dialog-message {
  padding: 0;
}
.dx-dropdownbutton {
  display: inline-block;
}
.dx-dropdownbutton-content.dx-popup-content {
  padding: 0;
}
.dx-dropdownbutton-content .dx-list .dx-empty-message,
.dx-dropdownbutton-content .dx-list .dx-list-item {
  border: none;
}
.dx-dropdownbutton-toggle {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  min-width: 0;
  height: 100%;
}
.dx-dropdownbutton-toggle.dx-button .dx-button-content {
  padding-left: 0;
  padding-right: 0;
}
.dx-rtl .dx-dropdownbutton-toggle {
  border-right-width: 0;
}
.dx-dropdownbutton:not(.dx-dropdownbutton-has-arrow) .dx-button-has-icon:not(.dx-button-has-text) .dx-button-content {
  padding-left: 8px;
  padding-right: 8px;
}
.dx-dropdownbutton:not(.dx-dropdownbutton-has-arrow) .dx-button-has-text.dx-button .dx-button-content {
  padding-left: 16px;
  padding-right: 16px;
}
.dx-dropdownbutton-action:not(.dx-buttongroup-last-item).dx-button {
  border-right-width: 0;
  border-left-width: 1px;
}
.dx-rtl .dx-dropdownbutton-action:not(.dx-buttongroup-last-item).dx-button {
  border-right-width: 1px;
  border-left-width: 0;
}
.dx-rtl .dx-dropdownbutton-toggle.dx-button {
  border-right-width: 0;
}
.dx-dropdownbutton-toggle .dx-button-content {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 24px;
  flex: 0 0 24px;
}
.dx-dropdownbutton-action {
  min-width: 0;
  height: 100%;
}
.dx-dropdownbutton {
  height: 36px;
}
.dx-dropdownbutton.dx-dropdownbutton-has-arrow .dx-button-has-icon.dx-button-has-text.dx-buttongroup-last-item .dx-button-content,
.dx-dropdownbutton.dx-dropdownbutton-has-arrow .dx-button-has-icon.dx-buttongroup-last-item .dx-button-content,
.dx-dropdownbutton.dx-dropdownbutton-has-arrow .dx-button-has-text.dx-buttongroup-last-item .dx-button-content {
  padding-right: 0;
}
.dx-dropdownbutton.dx-dropdownbutton-has-arrow .dx-button-has-icon.dx-button-has-text.dx-buttongroup-last-item .dx-button-content .dx-icon-spindown,
.dx-dropdownbutton.dx-dropdownbutton-has-arrow .dx-button-has-icon.dx-buttongroup-last-item .dx-button-content .dx-icon-spindown,
.dx-dropdownbutton.dx-dropdownbutton-has-arrow .dx-button-has-text.dx-buttongroup-last-item .dx-button-content .dx-icon-spindown {
  height: 18px;
  background-position: 0 0;
  background-size: 18px 18px;
  padding: 0;
  font-size: 18px;
  text-align: center;
  line-height: 18px;
  width: 26px;
}
.dx-dropdownbutton.dx-dropdownbutton-has-arrow .dx-button-has-icon.dx-button-has-text.dx-buttongroup-last-item .dx-button-content .dx-icon-spindown.dx-icon-right,
.dx-dropdownbutton.dx-dropdownbutton-has-arrow .dx-button-has-icon.dx-buttongroup-last-item .dx-button-content .dx-icon-spindown.dx-icon-right,
.dx-dropdownbutton.dx-dropdownbutton-has-arrow .dx-button-has-text.dx-buttongroup-last-item .dx-button-content .dx-icon-spindown.dx-icon-right {
  margin-left: 4px;
}
.dx-dropdownbutton .dx-button-has-icon,
.dx-dropdownbutton .dx-button-has-icon.dx-button-has-text,
.dx-dropdownbutton .dx-button-has-text {
  min-width: 0;
}
.dx-dropdownbutton .dx-button-has-icon .dx-button-content,
.dx-dropdownbutton .dx-button-has-icon.dx-button-has-text .dx-button-content,
.dx-dropdownbutton .dx-button-has-text .dx-button-content {
  padding-right: 8px;
}
.dx-dropdownbutton .dx-buttongroup .dx-button {
  border-radius: 0;
}
.dx-dropdownbutton .dx-buttongroup .dx-buttongroup-item {
  margin-left: 0;
}
.dx-dropdownbutton .dx-buttongroup .dx-buttongroup-last-item {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.dx-dropdownbutton .dx-buttongroup .dx-buttongroup-first-item {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.dx-rtl .dx-dropdownbutton .dx-button-has-icon.dx-button-has-text.dx-buttongroup-last-item .dx-button-content,
.dx-rtl .dx-dropdownbutton .dx-button-has-icon.dx-buttongroup-last-item .dx-button-content,
.dx-rtl .dx-dropdownbutton .dx-button-has-text.dx-buttongroup-last-item .dx-button-content,
.dx-rtl.dx-dropdownbutton .dx-button-has-icon.dx-button-has-text.dx-buttongroup-last-item .dx-button-content,
.dx-rtl.dx-dropdownbutton .dx-button-has-icon.dx-buttongroup-last-item .dx-button-content,
.dx-rtl.dx-dropdownbutton .dx-button-has-text.dx-buttongroup-last-item .dx-button-content {
  padding-left: 0;
}
.dx-rtl .dx-dropdownbutton .dx-button-has-icon.dx-button-has-text.dx-buttongroup-last-item .dx-button-content .dx-icon-spindown.dx-icon-right,
.dx-rtl .dx-dropdownbutton .dx-button-has-icon.dx-buttongroup-last-item .dx-button-content .dx-icon-spindown.dx-icon-right,
.dx-rtl .dx-dropdownbutton .dx-button-has-text.dx-buttongroup-last-item .dx-button-content .dx-icon-spindown.dx-icon-right,
.dx-rtl.dx-dropdownbutton .dx-button-has-icon.dx-button-has-text.dx-buttongroup-last-item .dx-button-content .dx-icon-spindown.dx-icon-right,
.dx-rtl.dx-dropdownbutton .dx-button-has-icon.dx-buttongroup-last-item .dx-button-content .dx-icon-spindown.dx-icon-right,
.dx-rtl.dx-dropdownbutton .dx-button-has-text.dx-buttongroup-last-item .dx-button-content .dx-icon-spindown.dx-icon-right {
  margin-left: 0;
  margin-right: 4px;
}
.dx-rtl .dx-dropdownbutton .dx-button-has-icon .dx-button-content,
.dx-rtl .dx-dropdownbutton .dx-button-has-icon.dx-button-has-text .dx-button-content,
.dx-rtl .dx-dropdownbutton .dx-button-has-text .dx-button-content,
.dx-rtl.dx-dropdownbutton .dx-button-has-icon .dx-button-content,
.dx-rtl.dx-dropdownbutton .dx-button-has-icon.dx-button-has-text .dx-button-content,
.dx-rtl.dx-dropdownbutton .dx-button-has-text .dx-button-content {
  padding-left: 8px;
}
.dx-rtl .dx-dropdownbutton .dx-buttongroup-last-item,
.dx-rtl.dx-dropdownbutton .dx-buttongroup-last-item {
  border-radius: 4px 0 0 4px;
  border-left-width: 1px;
}
.dx-rtl .dx-dropdownbutton .dx-buttongroup-first-item,
.dx-rtl.dx-dropdownbutton .dx-buttongroup-first-item {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.dx-rtl .dx-dropdownbutton .dx-buttongroup-first-item:not(.dx-buttongroup-last-item),
.dx-rtl.dx-dropdownbutton .dx-buttongroup-first-item:not(.dx-buttongroup-last-item) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.dx-rtl .dx-dropdownbutton .dx-button-has-text:not(.dx-button-mode-text) .dx-button-content,
.dx-rtl.dx-dropdownbutton .dx-button-has-text:not(.dx-button-mode-text) .dx-button-content {
  padding-right: 16px;
}
.dx-rtl .dx-dropdownbutton .dx-button-has-icon.dx-button-has-text:not(.dx-button-mode-text) .dx-button-content,
.dx-rtl.dx-dropdownbutton .dx-button-has-icon.dx-button-has-text:not(.dx-button-mode-text) .dx-button-content {
  padding-right: 12px;
}
.dx-rtl .dx-dropdownbutton .dx-button-mode-text.dx-buttongroup-first-item .dx-button-content,
.dx-rtl.dx-dropdownbutton .dx-button-mode-text.dx-buttongroup-first-item .dx-button-content {
  padding-right: 8px;
}
.dx-dropdownbutton-popup-wrapper {
  height: 100%;
}
.dx-dropdownbutton-popup-wrapper.dx-popup-wrapper .dx-overlay-content {
  -webkit-box-shadow: 0 2px 7px rgba(0,0,0,.2);
  box-shadow: 0 2px 7px rgba(0,0,0,.2);
  border-top-width: 0;
  border-bottom-width: 1px;
}
.dx-dropdownbutton-popup-wrapper.dx-popup-wrapper .dx-overlay-content.dx-dropdowneditor-overlay-flipped {
  border-top-width: 1px;
  border-bottom-width: 0;
}
.dx-dropdownbutton-popup-wrapper .dx-popup-content {
  height: 100%;
  padding: 1px;
}
.dx-dropdownbutton-popup-wrapper .dx-list {
  height: 100%;
  min-height: 48px;
}
.dx-dropdownbutton-popup-wrapper .dx-list-select-all {
  padding: 16px 0 12px;
}
.dx-dropdownbutton-popup-wrapper .dx-empty-message,
.dx-dropdownbutton-popup-wrapper .dx-list-item {
  border-top: 0;
}
.dx-dropdownbutton-popup-wrapper .dx-empty-message:last-of-type,
.dx-dropdownbutton-popup-wrapper .dx-list-item:last-of-type {
  border-bottom: none;
}
.dx-actionsheet-popup-wrapper .dx-overlay-content {
  padding-top: 0;
  padding-bottom: 0;
  -webkit-user-drag: none;
}
.dx-actionsheet-popover-wrapper .dx-popup-content .dx-button,
.dx-actionsheet-popup-wrapper .dx-popup-content .dx-button {
  width: 100%;
  margin-right: 0;
  margin-left: 0;
}
.dx-actionsheet-cancel,
.dx-actionsheet-item {
  width: 100%;
}
.dx-state-disabled .dx-actionsheet-container .dx-button {
  cursor: default;
}
.dx-actionsheet-popover-wrapper .dx-popup-title,
.dx-actionsheet-popup-wrapper .dx-popup-title {
  word-wrap: break-word;
}
.dx-actionsheet-container .dx-actionsheet-item:not(:last-child) {
  margin: 0 0 20px;
}
.dx-actionsheet-container .dx-button {
  margin: 0;
}
.dx-button.dx-actionsheet-cancel {
  margin: 20px 0 0;
}
.dx-tileview div.dx-scrollable-container {
  overflow-y: hidden;
}
.dx-tile {
  position: absolute;
  color: rgba(0,0,0,.87);
  background-color: #fff;
  border: 1px solid rgba(224,224,224,.6);
  text-align: left;
}
.dx-tile-content {
  padding: 0;
  width: 100%;
  height: 100%;
}
.dx-tileview-wrapper {
  position: relative;
  height: 1px;
}
.dx-device-ios-6 .dx-tile {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.dx-tile.dx-state-focused,
.dx-tile.dx-state-hover {
  background-color: #fff;
  border-color: rgba(0,150,136,.4);
}
.dx-tile.dx-state-active {
  -webkit-transform: scale(.96);
  transform: scale(.96);
  -webkit-transition: -webkit-transform .1s linear;
  transition: transform .1s linear,-webkit-transform .1s linear;
  background-color: rgba(96,96,96,.2);
  color: rgba(0,0,0,.87);
  border-color: transparent;
}
.dx-toast-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.dx-toast-message {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}
.dx-rtl .dx-toast-icon {
  margin-left: 10px;
  margin-right: 0;
}
.dx-toast-stack {
  position: fixed;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  overflow: hidden;
  gap: 3px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  z-index: 9500;
}
.dx-toast-stack .dx-toast-wrapper {
  -webkit-transform: translate(0)!important;
  transform: translate(0)!important;
  position: static!important;
  height: auto!important;
  width: auto!important;
}
.dx-toast-stack .dx-toast-wrapper .dx-toast-content {
  -webkit-transform: translate(0)!important;
  transform: translate(0)!important;
  position: static!important;
}
.dx-toast-stack-down-push-direction {
  -webkit-box-orient: vertical;
  -webkit-box-direction: reverse;
  -ms-flex-direction: column-reverse;
  flex-direction: column-reverse;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}
.dx-toast-stack-up-push-direction {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}
.dx-toast-stack-left-push-direction {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}
.dx-toast-stack-right-push-direction {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  -ms-flex-direction: row-reverse;
  flex-direction: row-reverse;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}
.dx-toast-stack-down-stack-direction {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}
.dx-toast-stack-up-stack-direction {
  -webkit-box-orient: vertical;
  -webkit-box-direction: reverse;
  -ms-flex-direction: column-reverse;
  flex-direction: column-reverse;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}
.dx-toast-stack-left-stack-direction {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  -ms-flex-direction: row-reverse;
  flex-direction: row-reverse;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}
.dx-toast-stack-right-stack-direction {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}
.dx-toast-content {
  color: rgba(255,255,255,.87);
  font-size: 14px;
  font-weight: 400;
  padding: 0 16px;
  border-radius: 4px;
  -webkit-box-shadow: 0 2px 3px rgba(0,0,0,.25);
  box-shadow: 0 2px 3px rgba(0,0,0,.25);
  min-height: 48px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.dx-toast-icon {
  background-size: contain;
  width: 35px;
  height: 35px;
  background-position: left center;
  background-repeat: no-repeat;
  margin-right: 10px;
  display: none;
}
.dx-toast-message {
  padding: 0;
}
.dx-toast-info {
  background-color: rgba(0,0,0,.87);
}
.dx-toast-warning {
  background-color: #ffc107;
}
.dx-toast-error {
  background-color: #f44336;
}
.dx-toast-success {
  background-color: #8bc34a;
}
.dx-popover-wrapper .dx-popover-arrow::after {
  width: 14.1422712488px;
  height: 14.1422712488px;
}
.dx-popover-wrapper.dx-position-bottom .dx-popover-arrow,
.dx-popover-wrapper.dx-position-top .dx-popover-arrow {
  width: 20px;
  height: 10px;
}
.dx-popover-wrapper.dx-position-left .dx-popover-arrow,
.dx-popover-wrapper.dx-position-right .dx-popover-arrow {
  width: 10px;
  height: 20px;
}
.dx-popover-arrow {
  position: absolute;
  z-index: 2000;
  overflow: hidden;
}
.dx-popover-arrow::after {
  position: absolute;
  display: block;
  overflow: hidden;
  content: " ";
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
.dx-popover-wrapper.dx-position-top .dx-popover-arrow::after {
  top: 0;
  left: 0;
  -webkit-transform-origin: top left;
  transform-origin: top left;
}
.dx-popover-wrapper.dx-position-bottom .dx-popover-arrow::after {
  right: 0;
  bottom: 0;
  -webkit-transform-origin: bottom right;
  transform-origin: bottom right;
}
.dx-popover-wrapper.dx-position-left .dx-popover-arrow::after {
  bottom: 0;
  left: 0;
  -webkit-transform-origin: bottom left;
  transform-origin: bottom left;
}
.dx-popover-wrapper.dx-position-right .dx-popover-arrow::after {
  top: 0;
  right: 0;
  -webkit-transform-origin: top right;
  transform-origin: top right;
}
.dx-popover-wrapper .dx-overlay-content {
  overflow: visible;
}
.dx-popover-wrapper .dx-popup-content {
  overflow: hidden;
}
.dx-popover-wrapper .dx-popup-content-scrollable {
  overflow: auto;
}
.dx-device-ios .dx-popover-arrow::after {
  -webkit-transform: rotate(-45deg) translateZ(0);
}
.dx-popover-wrapper .dx-popup-title {
  margin: 0;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.dx-popover-wrapper .dx-popover-arrow {
  display: none;
}
.dx-progressbar .dx-position-left .dx-progressbar-range-container,
.dx-progressbar .dx-position-left .dx-progressbar-status,
.dx-progressbar .dx-position-right .dx-progressbar-range-container,
.dx-progressbar .dx-position-right .dx-progressbar-status {
  display: table-cell;
  vertical-align: middle;
}
.dx-progressbar .dx-position-bottom-left .dx-progressbar-range-container,
.dx-progressbar .dx-position-bottom-left .dx-progressbar-status,
.dx-progressbar .dx-position-top-left .dx-progressbar-range-container,
.dx-progressbar .dx-position-top-left .dx-progressbar-status {
  float: left;
}
.dx-progressbar .dx-position-bottom-right .dx-progressbar-range-container,
.dx-progressbar .dx-position-bottom-right .dx-progressbar-status,
.dx-progressbar .dx-position-top-right .dx-progressbar-range-container,
.dx-progressbar .dx-position-top-right .dx-progressbar-status {
  float: right;
}
.dx-progressbar .dx-position-bottom-center .dx-progressbar-status,
.dx-progressbar .dx-position-top-center .dx-progressbar-status {
  text-align: center;
}
.dx-progressbar .dx-position-left .dx-progressbar-status {
  padding-right: 8px;
}
.dx-progressbar .dx-position-right .dx-progressbar-status {
  padding-left: 8px;
  padding-top: 0;
}
.dx-progressbar::before {
  display: inline-block;
  height: 100%;
  content: "";
  vertical-align: middle;
}
.dx-progressbar-range-container {
  width: 100%;
}
.dx-progressbar-container {
  position: relative;
  width: 100%;
}
.dx-progressbar-wrapper {
  display: inline-block;
  width: 100%;
  vertical-align: middle;
  direction: ltr;
}
.dx-progressbar-range {
  height: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-drag: none;
}
.dx-progressbar-status {
  position: relative;
  top: 0;
  left: 0;
  width: auto;
  height: 20px;
  font-size: 12px;
  padding-top: 8px;
  color: #009688;
}
.dx-progressbar-animating-segment {
  display: none;
}
.dx-rtl .dx-progressbar .dx-progressbar-wrapper,
.dx-rtl.dx-progressbar .dx-progressbar-wrapper {
  direction: rtl;
}
.dx-progressbar-container {
  height: 4px;
  background-color: rgba(0,150,136,.3);
}
.dx-progressbar-range {
  position: relative;
  background-color: #009688;
  margin-top: -1px;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
.dx-progressbar-animating-container {
  width: 100%;
  height: 4px;
  background-color: rgba(0,150,136,.3);
  background-size: 90% 5px;
  -webkit-animation: 2s linear infinite dx-loader;
  animation: 2s linear infinite dx-loader;
  background-image: -webkit-gradient(linear,right top,left top,color-stop(5%,transparent),color-stop(#009688),color-stop(95%,transparent));
  background-image: linear-gradient(-90deg,transparent 5%,#009688,transparent 95%);
  background-repeat: repeat;
}
.dx-state-disabled .dx-progressbar-range {
  background-color: rgba(0,150,136,.6);
}
.dx-state-disabled .dx-progressbar-animating-container {
  -webkit-animation: none;
  animation: none;
  background-position-x: 45%;
}
.dx-rtl .dx-progressbar .dx-progressbar-animating-container,
.dx-rtl.dx-progressbar .dx-progressbar-animating-container {
  -webkit-animation: 2s linear infinite dx-loader-rtl;
  animation: 2s linear infinite dx-loader-rtl;
  background-image: -webkit-gradient(linear,right top,left top,color-stop(5%,transparent),color-stop(#009688),color-stop(95%,transparent));
  background-image: linear-gradient(-90deg,transparent 5%,#009688,transparent 95%);
  background-repeat: repeat;
}
@-webkit-keyframes dx-loader {
  0% {
    background-position-x: 0;
  }
  100% {
    background-position-x: 900%;
  }
}
@keyframes dx-loader {
  0% {
    background-position-x: 0;
  }
  100% {
    background-position-x: 900%;
  }
}
@-webkit-keyframes dx-loader-rtl {
  0% {
    background-position-x: 0;
  }
  100% {
    background-position-x: -900%;
  }
}
@keyframes dx-loader-rtl {
  0% {
    background-position-x: 0;
  }
  100% {
    background-position-x: -900%;
  }
}
.dx-tooltip-wrapper .dx-overlay-content {
  min-width: 34px;
  text-align: center;
  line-height: 0;
  background-color: #616161;
  color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
  border-radius: 4px;
  min-height: auto;
}
.dx-tooltip-wrapper .dx-overlay-content::before {
  display: inline-block;
  height: 100%;
  content: "";
  vertical-align: middle;
}
.dx-tooltip-wrapper .dx-overlay-content .dx-popup-content {
  display: inline-block;
  line-height: normal;
  white-space: nowrap;
  padding: 6px 8px;
  font-size: 12px;
}
.dx-tooltip-wrapper.dx-popover-wrapper .dx-popover-arrow {
  display: none;
}
.dx-slider-label {
  position: absolute;
  font-size: .85em;
}
.dx-slider-label:last-child {
  right: 0;
  left: auto;
}
.dx-rtl .dx-slider-label:last-child {
  left: 0;
  right: auto;
}
.dx-slider-label-position-bottom {
  padding-bottom: 14px;
}
.dx-slider-label-position-top {
  padding-top: 14px;
}
.dx-slider {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}
.dx-slider::before {
  display: inline-block;
  height: 100%;
  content: "";
  vertical-align: middle;
}
.dx-slider .dx-overlay-content {
  height: 28px;
}
.dx-slider .dx-overlay-content::before {
  display: none;
}
.dx-slider .dx-popover-wrapper .dx-popover-arrow::after {
  width: 9.8995898741px;
  height: 9.8995898741px;
}
.dx-slider .dx-popover-wrapper.dx-position-bottom .dx-popover-arrow,
.dx-slider .dx-popover-wrapper.dx-position-top .dx-popover-arrow {
  width: 14px;
  height: 7px;
}
.dx-slider .dx-popover-wrapper.dx-position-left .dx-popover-arrow,
.dx-slider .dx-popover-wrapper.dx-position-right .dx-popover-arrow {
  width: 7px;
  height: 14px;
}
.dx-slider-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
  vertical-align: middle;
  cursor: pointer;
  height: 32px;
}
.dx-slider-bar {
  position: relative;
  margin-right: 18px;
  margin-left: 18px;
  background: rgba(0,150,136,.24);
}
.dx-slider-range {
  position: absolute;
  pointer-events: none;
  -webkit-user-drag: none;
}
.dx-slider-handle {
  position: absolute;
  top: 0;
  right: 0;
  pointer-events: auto;
  -webkit-user-drag: none;
}
.dx-slider-handle .dx-tooltip-wrapper .dx-popup-content {
  line-height: 0;
}
.dx-state-disabled .dx-slider-wrapper {
  cursor: default;
}
.dx-rtl .dx-slider-handle {
  right: auto;
  left: 0;
}
.dx-slider-tooltip-visible-on-hover .dx-tooltip {
  visibility: hidden;
}
.dx-slider-tooltip-visible-on-hover.dx-state-active .dx-tooltip,
.dx-slider-tooltip-visible-on-hover.dx-state-hover .dx-tooltip {
  visibility: visible;
}
.dx-slider-bar,
.dx-slider-range {
  margin-top: 15px;
  height: 2px;
}
.dx-slider-range {
  top: -15px;
}
.dx-slider-range.dx-slider-range-visible {
  background: #009688;
}
.dx-slider-handle {
  margin-top: -15px;
  margin-right: -16px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.dx-slider-handle::after {
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  margin-top: -6px;
  margin-left: -6px;
  width: 12px;
  height: 12px;
  background: #009688;
  content: "";
  border-radius: 50%;
}
.dx-slider-handle .dx-tooltip-wrapper .dx-overlay-content {
  background-color: transparent;
  min-width: 34px;
}
.dx-slider-handle .dx-tooltip-wrapper .dx-overlay-content::before {
  content: "";
  position: absolute;
  width: 34px;
  height: 34px;
  border-radius: 0 50% 50%;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  display: block;
  background-color: #009688;
  top: 0;
}
.dx-slider-tooltip-position-top .dx-slider-handle .dx-tooltip-wrapper .dx-overlay-content::before {
  -webkit-transform: rotate(-135deg);
  transform: rotate(-135deg);
  bottom: 0;
  margin-top: -5px;
}
.dx-slider-handle .dx-tooltip-wrapper .dx-overlay-content .dx-popup-content {
  line-height: normal;
  font-size: 10px;
  max-width: 28px;
  min-width: 28px;
  width: 28px;
  text-overflow: ellipsis;
  padding: 11px 3px 5px;
  color: #fff;
  position: relative;
}
.dx-slider-tooltip-position-top .dx-slider-handle .dx-tooltip-wrapper .dx-overlay-content .dx-popup-content {
  padding-top: 6px;
}
.dx-slider-handle .dx-tooltip-wrapper .dx-overlay-content.dx-state-disabled::before {
  margin-top: 5px;
}
.dx-slider-tooltip-position-top .dx-slider-handle .dx-tooltip-wrapper .dx-overlay-content.dx-state-disabled::before {
  margin-top: -5px;
}
.dx-slider-handle .dx-tooltip-wrapper .dx-overlay-content.dx-state-disabled .dx-popup-content {
  padding-top: 17px;
}
.dx-slider-tooltip-position-top .dx-slider-handle .dx-tooltip-wrapper .dx-overlay-content.dx-state-disabled .dx-popup-content {
  padding-top: 6px;
  padding-bottom: 17px;
}
.dx-slider-handle .dx-inkripple-wave {
  background-color: rgba(0,150,136,.24);
}
.dx-slider-tooltip-position-top {
  padding-top: 40px;
}
.dx-slider-tooltip-position-bottom {
  padding-bottom: 40px;
}
.dx-slider-label-position-bottom .dx-slider-label {
  bottom: -18px;
}
.dx-slider-label-position-top .dx-slider-label {
  top: -15px;
}
.dx-state-disabled .dx-slider,
.dx-state-disabled .dx-slider .dx-slider-handle,
.dx-state-disabled.dx-slider,
.dx-state-disabled.dx-slider .dx-slider-handle {
  opacity: 1;
}
.dx-state-disabled .dx-slider-bar,
.dx-state-disabled .dx-slider-range.dx-slider-range-visible {
  background: rgba(0,0,0,.24);
}
.dx-state-disabled .dx-slider-handle {
  width: 12px;
  height: 12px;
  margin-top: -5px;
  margin-right: -5px;
  border-radius: 50%;
  border: 2px solid #fff;
}
.dx-state-disabled .dx-slider-handle::after {
  margin-top: -4px;
  margin-left: -4px;
  width: 8px;
  height: 8px;
  background: grey;
}
.dx-state-disabled .dx-slider-handle .dx-overlay-content {
  margin-top: -12px;
}
.dx-invalid .dx-slider-handle::after {
  background-color: #f44336;
}
.dx-invalid .dx-slider-range-visible {
  background-color: #f44336;
  border-color: #f44336;
}
.dx-invalid .dx-slider-bar {
  background-color: rgba(244,67,54,.4);
}
.dx-rtl .dx-slider-handle {
  margin-left: -16px;
}
.dx-rtl.dx-state-disabled .dx-slider-handle {
  margin-left: -5px;
  margin-right: 0;
}
.dx-rtl.dx-state-disabled .dx-overlay-content {
  margin-left: -13px;
}
.dx-rangeslider-start-handle {
  top: 0;
  right: auto;
  left: 0;
  margin-left: -14px;
}
.dx-rtl .dx-rangeslider-start-handle {
  right: 0;
  left: auto;
  margin-right: -14px;
}
.dx-state-disabled .dx-rangeslider-start-handle {
  margin-left: -5px;
}
.dx-rtl.dx-state-disabled .dx-rangeslider-start-handle {
  margin-right: -5px;
}
.dx-gallery {
  width: 100%;
  height: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -ms-touch-action: pinch-zoom pan-y;
  touch-action: pinch-zoom pan-y;
}
.dx-gallery-wrapper {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  white-space: nowrap;
}
.dx-gallery-wrapper > .dx-empty-message {
  text-align: center;
  position: absolute;
  width: 100%;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.dx-gallery-container {
  position: relative;
  height: 100%;
}
.dx-gallery-item {
  display: inline-block;
  overflow: hidden;
  width: 100%;
  height: 100%;
  text-align: center;
}
.dx-gallery-item-image {
  max-width: 100%;
  -ms-flex-item-align: start;
  align-self: flex-start;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  height: auto;
  margin: auto;
}
.dx-gallery-item-content {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.dx-gallery .dx-gallery-item-loop {
  display: none;
}
.dx-gallery-loop .dx-gallery-item-loop {
  display: inline-block;
  position: absolute;
}
.dx-gallery-item-invisible {
  visibility: hidden;
}
.dx-gallery-nav-button-next,
.dx-gallery-nav-button-prev {
  position: absolute;
  top: 50%;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  background-size: 100% 100%;
}
.dx-gallery-nav-button-prev {
  left: 0;
}
.dx-gallery-nav-button-next {
  right: 0;
}
.dx-gallery-indicator {
  position: absolute;
  bottom: 10px;
  width: 100%;
  height: 10px;
  font-size: 0;
  pointer-events: none;
  text-align: center;
}
.dx-state-disabled .dx-gallery-indicator-item,
.dx-state-disabled .dx-gallery-nav-button-next,
.dx-state-disabled .dx-gallery-nav-button-prev {
  cursor: default;
}
.dx-rtl .dx-gallery-nav-button-prev {
  right: 0;
  left: auto;
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
.dx-rtl .dx-gallery-nav-button-next {
  right: auto;
  left: 0;
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
.dx-device-android .dx-scrollable-native .dx-gallery-indicator,
.dx-device-android .dx-scrollable-native .dx-gallery-item,
.dx-device-android .dx-scrollable-native .dx-gallery-nav-button-next,
.dx-device-android .dx-scrollable-native .dx-gallery-nav-button-prev {
  -webkit-backface-visibility: visible;
  backface-visibility: visible;
}
.dx-device-android .dx-gallery-item,
.dx-device-android .dx-scrollable-native .dx-gallery-active .dx-gallery-indicator,
.dx-device-android .dx-scrollable-native .dx-gallery-active .dx-gallery-item,
.dx-device-android .dx-scrollable-native .dx-gallery-active .dx-gallery-nav-button-next,
.dx-device-android .dx-scrollable-native .dx-gallery-active .dx-gallery-nav-button-prev,
.dx-device-ios-6 .dx-gallery,
.dx-device-ios-6 .dx-gallery-indicator,
.dx-device-ios-6 .dx-gallery-item,
.dx-device-ios-6 .dx-gallery-nav-button-next,
.dx-device-ios-6 .dx-gallery-nav-button-prev {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.dx-gallery .dx-gallery-nav-button-next,
.dx-gallery .dx-gallery-nav-button-prev {
  position: absolute;
  top: 0;
  width: 34%;
  height: 100%;
  background: 0 0;
  cursor: pointer;
  text-align: center;
}
.dx-gallery .dx-gallery-nav-button-next.dx-state-active::after,
.dx-gallery .dx-gallery-nav-button-next.dx-state-hover::after,
.dx-gallery .dx-gallery-nav-button-prev.dx-state-active::after,
.dx-gallery .dx-gallery-nav-button-prev.dx-state-hover::after {
  background-color: #009688;
}
.dx-gallery .dx-gallery-nav-button-next::before,
.dx-gallery .dx-gallery-nav-button-prev::before {
  display: block;
  width: 32px;
  top: 50%;
  margin-top: -16px;
  left: 50%;
  margin-left: -16px;
  position: absolute;
  z-index: 10;
  clear: both;
  font-size: 32px;
  color: #fff;
}
.dx-gallery .dx-gallery-nav-button-next::after,
.dx-gallery .dx-gallery-nav-button-prev::after {
  content: "";
  position: absolute;
  width: 32px;
  height: 32px;
  background: rgba(0,0,0,.54);
  border-radius: 50%;
  top: 50%;
  margin-top: -16px;
}
.dx-gallery .dx-gallery-nav-button-prev {
  font: 14px/1 DXIcons;
}
.dx-gallery .dx-gallery-nav-button-prev::after {
  left: 8px;
}
.dx-gallery .dx-gallery-nav-button-prev::before {
  content: "\\f012";
  left: 7px;
  right: auto;
  margin-left: 0;
}
.dx-gallery .dx-gallery-nav-button-next {
  font: 14px/1 DXIcons;
}
.dx-gallery .dx-gallery-nav-button-next::after {
  right: 8px;
}
.dx-gallery .dx-gallery-nav-button-next::before {
  content: "\\f010";
  right: 7px;
  left: auto;
}
.dx-gallery-indicator-item {
  display: inline-block;
  cursor: pointer;
  border-radius: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid rgba(0,0,0,.2);
  pointer-events: auto;
  margin: 1px 6px;
  width: 8px;
  height: 8px;
  background: #fff;
}
.dx-gallery-indicator-item-active,
.dx-gallery-indicator-item-selected {
  width: 12px;
  height: 12px;
  background: #009688;
  border: 2px solid rgba(255,255,255,.8);
  margin: -1px 6px;
}
.dx-state-focused.dx-gallery .dx-gallery-indicator-item-selected {
  background: #009688;
}
.dx-lookup {
  margin: 0;
  height: 19px;
}
.dx-lookup .dx-popup-content .dx-scrollable {
  height: calc(100% - 45px);
}
.dx-lookup .dx-lookup-field-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}
.dx-lookup .dx-rtl .dx-lookup-field-wrapper::after,
.dx-lookup:not(.dx-rtl) .dx-lookup-field-wrapper::before {
  display: inline-block;
  height: 100%;
  content: "";
  vertical-align: middle;
}
.dx-lookup-field {
  outline: 0;
  position: relative;
  width: 100%;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
}
.dx-lookup-field::before {
  content: ".";
  color: transparent;
  display: inline-block;
  width: 0;
  float: left;
}
.dx-rtl .dx-lookup-arrow {
  right: auto;
  left: 0;
}
.dx-state-disabled .dx-lookup-field {
  cursor: default;
}
.dx-lookup-popup-wrapper .dx-list-item {
  cursor: pointer;
  border-top: none;
}
.dx-lookup-popup-search .dx-list {
  height: 90%;
}
.dx-lookup-search-wrapper {
  width: 100%;
  padding: 20px 20px 14px;
}
.dx-lookup.dx-editor-filled,
.dx-lookup.dx-editor-outlined {
  height: 48px;
}
.dx-lookup.dx-editor-filled .dx-lookup-field,
.dx-lookup.dx-editor-outlined .dx-lookup-field {
  padding: 15px 40px 14px 16px;
}
.dx-lookup.dx-editor-filled .dx-lookup-arrow,
.dx-lookup.dx-editor-outlined .dx-lookup-arrow {
  right: 12px;
}
.dx-lookup.dx-editor-filled.dx-invalid .dx-lookup-field,
.dx-lookup.dx-editor-outlined.dx-invalid .dx-lookup-field {
  padding-right: 64px;
}
.dx-lookup.dx-editor-filled.dx-invalid.dx-rtl .dx-lookup-field,
.dx-lookup.dx-editor-outlined.dx-invalid.dx-rtl .dx-lookup-field {
  padding-left: 64px;
  padding-right: 16px;
}
.dx-lookup.dx-editor-filled.dx-rtl .dx-lookup-arrow,
.dx-lookup.dx-editor-outlined.dx-rtl .dx-lookup-arrow,
.dx-rtl .dx-lookup.dx-editor-filled .dx-lookup-arrow,
.dx-rtl .dx-lookup.dx-editor-outlined .dx-lookup-arrow {
  left: 12px;
  right: auto;
}
.dx-lookup.dx-editor-filled.dx-rtl .dx-lookup-field,
.dx-lookup.dx-editor-outlined.dx-rtl .dx-lookup-field,
.dx-rtl .dx-lookup.dx-editor-filled .dx-lookup-field,
.dx-rtl .dx-lookup.dx-editor-outlined .dx-lookup-field {
  padding-left: 40px;
  padding-right: 16px;
}
.dx-lookup.dx-editor-underlined {
  height: 32px;
}
.dx-lookup.dx-editor-underlined.dx-texteditor-with-floating-label,
.dx-lookup.dx-editor-underlined.dx-texteditor-with-label {
  height: 42px;
}
.dx-lookup.dx-editor-underlined .dx-lookup-field {
  padding: 7px 24px 6px 0;
}
.dx-lookup.dx-editor-underlined.dx-invalid .dx-lookup-field {
  padding-right: 48px;
}
.dx-lookup.dx-editor-underlined.dx-invalid.dx-rtl .dx-lookup-field {
  padding-left: 48px;
  padding-right: 0;
}
.dx-lookup.dx-editor-underlined.dx-rtl .dx-lookup-field,
.dx-rtl .dx-lookup.dx-editor-underlined .dx-lookup-field {
  padding-left: 24px;
  padding-right: 0;
}
.dx-lookup.dx-invalid {
  border-bottom-color: rgba(244,67,54,.4);
}
.dx-lookup.dx-invalid .dx-lookup-arrow::after {
  pointer-events: none;
  position: absolute;
  top: 50%;
  margin-top: -11px;
  width: 22px;
  height: 22px;
  text-align: center;
  line-height: 23px;
  font-size: 14px;
  font-weight: 500;
  background-color: #f44336;
  color: #fff;
  content: "!";
  border-radius: 50%;
  right: 24px;
}
.dx-lookup.dx-invalid.dx-rtl .dx-lookup-arrow::after,
.dx-rtl .dx-lookup.dx-invalid .dx-lookup-arrow::after {
  left: 24px;
  right: auto;
}
.dx-lookup.dx-valid .dx-lookup-arrow::after {
  pointer-events: none;
  position: absolute;
  top: 50%;
  margin-top: -11px;
  width: 22px;
  height: 22px;
  text-align: center;
  line-height: 23px;
  font-size: 20px;
  font-weight: 700;
  font-family: DXIcons,sans-serif;
  color: #8bc34a;
  content: "\\f005";
  opacity: 0;
  -webkit-transform: scale(0);
  transform: scale(0);
  -webkit-animation: .3s cubic-bezier(1,.008,.565,1.65) .1s forwards dx-valid-badge-frames;
  animation: .3s cubic-bezier(1,.008,.565,1.65) .1s forwards dx-valid-badge-frames;
  right: 24px;
}
.dx-lookup.dx-valid.dx-rtl .dx-lookup-arrow::after,
.dx-rtl .dx-lookup.dx-valid .dx-lookup-arrow::after {
  left: 24px;
  right: auto;
}
.dx-lookup.dx-validation-pending .dx-lookup-field-wrapper .dx-pending-indicator {
  pointer-events: none;
  position: absolute;
  top: 50%;
  margin-top: -11px;
  width: 22px;
  height: 22px;
  right: 24px;
}
.dx-lookup.dx-validation-pending.dx-rtl .dx-lookup-field-wrapper .dx-pending-indicator,
.dx-rtl .dx-lookup.dx-validation-pending .dx-lookup-field-wrapper .dx-pending-indicator {
  left: 24px;
  right: auto;
}
.dx-lookup-field .dx-texteditor {
  border: none;
}
.dx-lookup-field .dx-texteditor::after,
.dx-lookup-field .dx-texteditor::before {
  content: none;
}
.dx-lookup-field .dx-texteditor,
.dx-lookup-field .dx-texteditor.dx-state-active,
.dx-lookup-field .dx-texteditor.dx-state-disabled,
.dx-lookup-field .dx-texteditor.dx-state-focused,
.dx-lookup-field .dx-texteditor.dx-state-hover,
.dx-lookup-field .dx-texteditor.dx-state-readonly,
.dx-lookup-field .dx-texteditor.dx-state-readonly.dx-state-hover {
  background-color: transparent;
}
.dx-lookup-arrow {
  pointer-events: none;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: auto;
  height: 100%;
  font: 24px/24px DXIcons;
  width: 24px;
  color: rgba(0,0,0,.54);
  text-align: center;
}
.dx-lookup-arrow::before {
  content: "\\f001";
  position: absolute;
  display: block;
  width: 24px;
  top: 50%;
  margin-top: -12px;
  left: 50%;
  margin-left: -12px;
}
.dx-state-readonly .dx-lookup-field::before {
  opacity: .5;
}
.dx-lookup-popup-wrapper .dx-list-item:last-of-type {
  border-bottom: none;
}
.dx-lookup-popup-wrapper .dx-popup-content {
  top: 0;
  padding: 0;
}
.dx-lookup-popup-wrapper .dx-popup-title + .dx-popup-content {
  top: 49px;
}
.dx-lookup-empty .dx-lookup-field {
  color: rgba(148,148,148,.87);
}
.dx-lookup-popup-search .dx-list {
  height: calc(100% - 66px);
}
.dx-loadpanel-content::before {
  display: inline-block;
  height: 100%;
  content: "";
  vertical-align: middle;
}
.dx-loadpanel-content-wrapper {
  display: inline-block;
  width: 100%;
  vertical-align: middle;
}
.dx-loadpanel-message {
  text-align: center;
  display: none;
}
.dx-loadpanel-content.dx-loadpanel-pane-hidden {
  -webkit-box-shadow: none;
  box-shadow: none;
  border: none;
  background: 0 0;
}
@-webkit-keyframes dx-loadpanel-opacity {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes dx-loadpanel-opacity {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.dx-loadpanel-content {
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-drag: none;
  border: 1px solid #e0e0e0;
  background: #fff;
  padding: 13px;
  border-radius: 50%;
  -webkit-box-shadow: 0 6px 12px rgba(0,0,0,.25);
  box-shadow: 0 6px 12px rgba(0,0,0,.25);
}
.dx-tagbox.dx-tagbox-default-template.dx-tagbox-only-select .dx-texteditor-input {
  border: none;
  color: transparent;
  text-shadow: 0 0 0 gray;
  min-width: 0;
  width: .1px;
  padding-left: 0;
  padding-right: 0;
  margin-left: 0;
  margin-right: 0;
}
.dx-tagbox.dx-tagbox-default-template.dx-tagbox-only-select .dx-texteditor-input:focus {
  outline: 0;
}
.dx-tagbox.dx-state-disabled .dx-texteditor-input {
  background: 0 0;
}
.dx-tagbox.dx-state-disabled .dx-tag-content {
  cursor: default;
  background-color: #adadad;
}
.dx-tagbox:not(.dx-tagbox-single-line) .dx-texteditor-input-container {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
}
.dx-tag-container.dx-texteditor-input-container {
  padding: 0 4px 0 0;
  outline: 0;
}
.dx-tagbox-single-line .dx-tag-container.dx-texteditor-input-container {
  overflow: hidden;
  white-space: nowrap;
}
.dx-texteditor-container.dx-tag-container {
  white-space: normal;
}
.dx-tag-content {
  position: relative;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  margin: 0;
  padding: 8px 32px 7px 12px;
  min-width: 40px;
  background-color: #e0e0e0;
  color: rgba(0,0,0,.6);
  border-radius: 16px;
}
.dx-tag-remove-button {
  position: absolute;
  top: 0;
  width: 24px;
  height: 100%;
  right: 4px;
  font: 10px/1 DXIcons;
}
.dx-tag-remove-button::after,
.dx-tag-remove-button::before {
  position: absolute;
  top: 50%;
  content: "";
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}
.dx-rtl .dx-tagbox .dx-tag-content,
.dx-tagbox.dx-rtl .dx-tag-content {
  margin-left: 0;
  margin-right: 4px;
}
.dx-rtl .dx-tagbox .dx-tag-remove-button,
.dx-tagbox.dx-rtl .dx-tag-remove-button {
  right: auto;
  left: 0;
}
.dx-rtl .dx-tagbox .dx-tag-container,
.dx-tagbox.dx-rtl .dx-tag-container {
  padding-left: 4px;
  padding-right: 0;
}
.dx-tagbox .dx-texteditor-input-container {
  height: 100%;
}
.dx-tagbox .dx-texteditor-input {
  width: auto;
  height: 32px;
}
.dx-tagbox.dx-editor-filled .dx-texteditor-input,
.dx-tagbox.dx-editor-outlined .dx-texteditor-input {
  padding: 0;
  margin-top: 8px;
}
.dx-tagbox.dx-editor-filled .dx-tag-container,
.dx-tagbox.dx-editor-outlined .dx-tag-container {
  padding: 0 12px 8px 16px;
  min-height: 48px;
}
.dx-tagbox.dx-state-disabled .dx-tag-content .dx-tag-remove-button::before {
  color: #adadad;
}
.dx-tagbox.dx-texteditor-with-floating-label.dx-editor-outlined .dx-tag-container.dx-texteditor-input-container,
.dx-tagbox.dx-texteditor-with-label.dx-editor-outlined .dx-tag-container.dx-texteditor-input-container {
  padding-top: 0;
}
.dx-tagbox.dx-texteditor-with-floating-label.dx-editor-filled .dx-tag-container.dx-texteditor-input-container,
.dx-tagbox.dx-texteditor-with-floating-label.dx-editor-underlined .dx-tag-container.dx-texteditor-input-container,
.dx-tagbox.dx-texteditor-with-label.dx-editor-filled .dx-tag-container.dx-texteditor-input-container,
.dx-tagbox.dx-texteditor-with-label.dx-editor-underlined .dx-tag-container.dx-texteditor-input-container {
  padding-top: 12px;
  padding-bottom: 8px;
}
.dx-tagbox.dx-texteditor-with-floating-label.dx-editor-underlined.dx-tagbox:not(.dx-texteditor-empty):not(.dx-editor-filled):not(.dx-editor-outlined) .dx-tag-container,
.dx-tagbox.dx-texteditor-with-label.dx-editor-underlined.dx-tagbox:not(.dx-texteditor-empty):not(.dx-editor-filled):not(.dx-editor-outlined) .dx-tag-container {
  margin-top: 0;
}
.dx-tagbox:not(.dx-texteditor-empty):not(.dx-editor-filled):not(.dx-editor-outlined) .dx-tag-container {
  margin-top: -8px;
}
.dx-tagbox:not(.dx-texteditor-empty):not(.dx-editor-filled):not(.dx-editor-outlined) .dx-tag-container::after {
  margin-top: -7px;
}
.dx-tagbox:not(.dx-texteditor-empty):not(.dx-editor-filled):not(.dx-editor-outlined) .dx-texteditor-input {
  padding-left: 0;
  margin-top: 8px;
}
.dx-rtl .dx-tagbox:not(.dx-texteditor-empty):not(.dx-editor-filled):not(.dx-editor-outlined) .dx-texteditor-input,
.dx-rtl.dx-tagbox:not(.dx-texteditor-empty):not(.dx-editor-filled):not(.dx-editor-outlined) .dx-texteditor-input {
  padding-right: 0;
  padding-left: 0;
  margin-right: 0;
  margin-left: 0;
}
.dx-tagbox:not(.dx-texteditor-empty):not(.dx-editor-filled):not(.dx-editor-outlined).dx-state-active::before,
.dx-tagbox:not(.dx-texteditor-empty):not(.dx-editor-filled):not(.dx-editor-outlined).dx-state-focused::before {
  border-top: 0;
  border-bottom: 0;
}
.dx-tagbox:not(.dx-texteditor-empty):not(.dx-editor-filled):not(.dx-editor-outlined).dx-state-hover::after,
.dx-tagbox:not(.dx-texteditor-empty):not(.dx-editor-filled):not(.dx-editor-outlined)::after {
  border-bottom: 0;
}
.dx-tagbox-single-line .dx-tag-container {
  padding-right: 0;
}
.dx-tag-remove-button::before {
  content: "\\f008";
  display: block;
  position: absolute;
  top: 51%;
  left: 50%;
  width: 16px;
  height: 16px;
  margin-left: -8px;
  margin-top: -8px;
  line-height: 16px;
  color: #e0e0e0;
  background-color: rgba(0,0,0,.36);
  border-radius: 50%;
  -webkit-transform: none;
  transform: none;
}
.dx-tag {
  max-width: calc(100% - 1px);
  display: inline-block;
  -ms-flex-item-align: start;
  align-self: flex-start;
  margin: 8px 8px 0 0;
}
.dx-tag:hover .dx-tag-content {
  background-color: #d9d9d9;
  color: rgba(0,0,0,.87);
}
.dx-tag.dx-state-focused .dx-tag-content {
  background-color: #adadad;
  color: rgba(0,0,0,.87);
}
.dx-tagbox.dx-invalid .dx-texteditor-container::after,
.dx-tagbox.dx-valid .dx-texteditor-container::after {
  right: 12px;
}
.dx-rtl .dx-tagbox.dx-invalid .dx-texteditor-container::after,
.dx-rtl .dx-tagbox.dx-valid .dx-texteditor-container::after,
.dx-rtl.dx-tagbox.dx-invalid .dx-texteditor-container::after,
.dx-rtl.dx-tagbox.dx-valid .dx-texteditor-container::after {
  left: 12px;
}
.dx-tagbox.dx-validation-pending .dx-texteditor-container .dx-pending-indicator {
  right: 12px;
}
.dx-rtl .dx-tagbox.dx-validation-pending .dx-texteditor-container .dx-pending-indicator,
.dx-rtl.dx-tagbox.dx-validation-pending .dx-texteditor-container .dx-pending-indicator {
  left: 12px;
}
.dx-tagbox-popup-wrapper .dx-list-select-all {
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 12px;
  margin-bottom: 3px;
}
.dx-tagbox-popup-wrapper .dx-list-select-all::after {
  background-color: transparent;
}
.dx-rtl .dx-tag-content {
  padding-right: 12px;
  padding-left: 32px;
}
.dx-rtl .dx-tag-remove-button {
  left: 4px!important;
}
.dx-radio-value-container {
  -webkit-padding-end: 10px;
  padding-inline-end: 10px;
}
.dx-radiogroup-horizontal .dx-collection {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-column-gap: 17px;
  -moz-column-gap: 17px;
  column-gap: 17px;
}
.dx-radiobutton {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
}
.dx-radiobutton.dx-state-disabled {
  cursor: default;
  opacity: .38;
}
.dx-state-disabled .dx-radiobutton.dx-state-disabled {
  opacity: 1;
}
.dx-radiobutton-icon {
  position: relative;
  width: 20px;
  height: 20px;
  border: 2px solid rgba(0,0,0,.54);
  background-color: #fff;
  border-radius: 50%;
  -webkit-transition: border-color .2s cubic-bezier(.4, 0, .2, 1);
  transition: border-color .2s cubic-bezier(.4, 0, .2, 1);
}
.dx-radiobutton-icon .dx-radiobutton-icon-dot {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 0 solid #fff;
  -webkit-transform: scale(0);
  transform: scale(0);
  -webkit-transition: -webkit-transform 150ms cubic-bezier(0, 0, .2, 1);
  transition: transform 150ms cubic-bezier(0, 0, .2, 1);
  transition: transform 150ms cubic-bezier(0, 0, .2, 1),-webkit-transform 150ms cubic-bezier(0, 0, .2, 1);
}
.dx-radiobutton-icon::after {
  content: "";
  position: absolute;
  width: 40px;
  height: 40px;
  top: 50%;
  left: 50%;
  margin-top: -20px;
  margin-left: -20px;
  border-radius: 50%;
  z-index: 1;
  -webkit-transform: scale(.5);
  transform: scale(.5);
  -webkit-transition: .4s cubic-bezier(.23, 1, .32, 1);
  transition: .4s cubic-bezier(.23, 1, .32, 1);
}
.dx-radiobutton-icon-checked {
  border-color: #009688;
}
.dx-radiobutton-icon-checked .dx-radiobutton-icon-dot {
  background-color: #009688;
  border-width: 3px;
  -webkit-transform: scale(1);
  transform: scale(1);
}
.dx-radiobutton.dx-state-active .dx-radiobutton-icon::after,
.dx-radiobutton.dx-state-focused .dx-radiobutton-icon::after {
  background-color: rgba(0,0,0,.1);
  -webkit-transform: scale(1);
  transform: scale(1);
}
.dx-radiobutton.dx-state-active .dx-radiobutton-icon-checked::after,
.dx-radiobutton.dx-state-focused .dx-radiobutton-icon-checked::after {
  background-color: rgba(0,150,136,.1);
  -webkit-transform: scale(1);
  transform: scale(1);
}
.dx-invalid .dx-radiobutton-icon {
  border-color: rgba(244,67,54,.4);
}
.dx-invalid .dx-radiobutton-icon-dot {
  background-color: rgba(244,67,54,.4);
}
.dx-invalid .dx-state-active.dx-radiobutton .dx-radiobutton-icon,
.dx-invalid .dx-state-focused.dx-radiobutton .dx-radiobutton-icon {
  border-color: #f44336;
}
.dx-invalid .dx-state-active.dx-radiobutton .dx-radiobutton-icon-dot,
.dx-invalid .dx-state-focused.dx-radiobutton .dx-radiobutton-icon-dot {
  background-color: #f44336;
}
.dx-invalid .dx-state-active.dx-radiobutton .dx-radiobutton-icon::after,
.dx-invalid .dx-state-focused.dx-radiobutton .dx-radiobutton-icon::after {
  background-color: rgba(244,67,54,.1);
  -webkit-transform: scale(1);
  transform: scale(1);
}
.dx-state-disabled .dx-radiobutton-icon,
.dx-state-readonly .dx-radiobutton-icon {
  border-color: rgba(0,0,0,.54);
}
.dx-state-disabled .dx-radiobutton-icon-dot,
.dx-state-readonly .dx-radiobutton-icon-dot {
  background-color: rgba(0,0,0,.54);
}
.dx-radiogroup .dx-radiobutton {
  margin-top: 12px;
  margin-bottom: 12px;
}
.dx-radiogroup .dx-radiobutton-icon {
  margin-top: 0;
  margin-bottom: 0;
}
.dx-accordion-item-title {
  font-size: 18px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  height: 48px;
  position: relative;
  padding: 12px 16px;
  background-color: #fff;
}
.dx-accordion-item-body {
  overflow: hidden;
  padding: 16px;
  font-size: 12px;
}
.dx-accordion-item-closed .dx-accordion-item-body {
  visibility: hidden;
}
.dx-accordion-item {
  overflow: hidden;
  background-color: #fff;
  -webkit-box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);
  -webkit-transition: margin .2s cubic-bezier(.4, 0, .2, 1);
  transition: margin .2s cubic-bezier(.4, 0, .2, 1);
  will-change: margin,height;
  border-top: 1px solid #e0e0e0;
}
.dx-accordion-item-opened .dx-accordion-item-body {
  visibility: visible;
}
.dx-state-disabled .dx-accordion-item-title {
  cursor: default;
}
.dx-accordion {
  background-color: #fff;
  color: rgba(0,0,0,.87);
  margin: 3px 3px 5px;
}
.dx-accordion-item:first-child {
  border-top: none;
}
.dx-accordion-item.dx-state-active > .dx-accordion-item-title,
.dx-accordion-item.dx-state-focused > .dx-accordion-item-title {
  color: rgba(0,0,0,.87);
  background-color: rgba(0,0,0,.04);
}
.dx-accordion-item.dx-state-active:not(.dx-accordion-item-opened) .dx-icon,
.dx-accordion-item.dx-state-focused:not(.dx-accordion-item-opened) .dx-icon {
  color: rgba(0,0,0,.87);
}
.dx-accordion-item.dx-state-hover > .dx-accordion-item-title {
  background-color: rgba(0,0,0,.04);
}
.dx-accordion-item.dx-state-hover + .dx-accordion-item-closed {
  border-top-color: #d1d1d1;
}
.dx-accordion-item-opened {
  margin: 16px 0;
  border-top: none;
}
.dx-accordion-item-opened:first-child {
  margin-top: 0;
}
.dx-accordion-item-opened > .dx-accordion-item-title::before {
  content: "\\f014";
}
.dx-accordion-item-opened + .dx-accordion-item {
  border-top: none;
}
.dx-accordion-item-title .dx-accordion-item-title-caption,
.dx-accordion-item-title::before {
  position: absolute;
}
.dx-accordion-item-title .dx-accordion-item-title-caption {
  color: rgba(0,0,0,.87);
  font-size: 16px;
  font-weight: 500;
  top: 16px;
  left: 16px;
  right: 56px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.dx-accordion-item-title::before {
  background-position: center;
  float: right;
  top: 10px;
  right: 16px;
  font-weight: 400;
  color: rgba(0,0,0,.38);
  content: "\\f016";
  font-family: DXIcons;
  font-size: 24px;
  height: 24px;
  width: 24px;
}
.dx-accordion-item-title .dx-icon {
  display: inline-block;
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  font-size: 24px;
  text-align: center;
  line-height: 24px;
}
.dx-accordion-item-title .dx-accordion-item-title-caption .dx-icon {
  margin-right: 8px;
  margin-left: 0;
  position: relative;
  top: 4px;
}
.dx-accordion-item-title .dx-accordion-item-title-caption .dx-icon.dx-icon-right,
.dx-rtl .dx-accordion-item-title .dx-accordion-item-title-caption .dx-icon,
.dx-rtl.dx-accordion-item-title .dx-accordion-item-title-caption .dx-icon {
  margin-left: 8px;
  margin-right: 0;
}
.dx-rtl .dx-accordion-item-title .dx-accordion-item-title-caption .dx-icon.dx-icon-right,
.dx-rtl.dx-accordion-item-title .dx-accordion-item-title-caption .dx-icon.dx-icon-right {
  margin-right: 8px;
  margin-left: 0;
}
.dx-state-disabled.dx-accordion-item {
  opacity: .5;
}
.dx-rtl .dx-accordion-item-title .dx-accordion-item-title-caption {
  right: 16px;
  left: 56px;
}
.dx-rtl .dx-accordion-item-title::before {
  float: left;
  left: 16px;
  right: auto;
}
.dx-colorbox-input-container.dx-colorbox-color-is-not-defined .dx-colorbox-color-result-preview {
  border: none;
}
.dx-colorbox-input-container .dx-placeholder {
  max-width: calc(100% - 25px);
}
.dx-colorbox .dx-texteditor-input-container::before {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  z-index: 1;
  width: 15px;
  height: 15px;
  margin-top: -7.5px;
  left: 14px;
}
.dx-colorbox .dx-colorbox-color-is-not-defined .dx-texteditor-input-container::before {
  background: 0 0;
}
.dx-colorbox.dx-editor-filled .dx-texteditor-label .dx-label-before,
.dx-colorbox.dx-editor-outlined .dx-texteditor-label .dx-label-before,
.dx-colorbox.dx-editor-underlined .dx-texteditor-label .dx-label-before {
  min-width: 40px;
}
.dx-colorbox-color-result-preview {
  position: absolute;
  top: 50%;
  z-index: 2;
  width: 17px;
  height: 17px;
  margin-top: -8.5px;
  border: 1px solid;
}
.dx-colorbox-input-container .dx-colorbox-input.dx-texteditor-input {
  -webkit-appearance: none;
  padding-left: 40px;
}
.dx-colorbox-overlay .dx-popup-content {
  overflow: hidden;
  padding: 20px;
}
.dx-colorbox-overlay .dx-popup-bottom .dx-toolbar-item:first-child {
  padding-right: 10px;
}
.dx-colorbox-overlay .dx-colorview-buttons-container .dx-button {
  margin: 0;
}
.dx-rtl .dx-colorbox .dx-placeholder,
.dx-rtl.dx-colorbox .dx-placeholder {
  right: 32px;
}
.dx-rtl .dx-colorbox.dx-dropdowneditor .dx-colorbox-input.dx-texteditor-input,
.dx-rtl.dx-colorbox.dx-dropdowneditor .dx-colorbox-input.dx-texteditor-input {
  direction: ltr;
  text-align: end;
  padding-right: 40px;
}
.dx-rtl .dx-colorbox.dx-dropdowneditor .dx-colorbox-color-result-preview,
.dx-rtl.dx-colorbox.dx-dropdowneditor .dx-colorbox-color-result-preview {
  left: auto;
  right: 13px;
}
.dx-rtl .dx-colorbox.dx-dropdowneditor .dx-colorbox-input-container::before,
.dx-rtl.dx-colorbox.dx-dropdowneditor .dx-colorbox-input-container::before {
  left: auto;
  right: 14px;
}
.dx-colorview-container label {
  overflow: hidden;
  font-weight: 400;
  margin: 0 0 10px;
  white-space: normal;
  line-height: normal;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: rgba(0,0,0,.87);
}
.dx-colorview-container .dx-button {
  margin-top: 0;
  margin-bottom: 0;
}
.dx-colorview-container .dx-button.dx-colorview-apply-button {
  margin-right: 10px;
  margin-left: 0;
}
.dx-colorview-container .dx-button.dx-colorview-cancel-button {
  margin-right: 0;
  margin-left: 0;
}
.dx-colorview-container-row {
  overflow: hidden;
  padding-top: 1px;
}
.dx-colorview-container-row:first-child {
  margin-top: 0;
}
.dx-colorview-container-cell {
  float: left;
}
.dx-colorview-palette-handle {
  width: 28px;
  height: 28px;
  top: 0;
  left: 0;
  cursor: crosshair;
  border-radius: 100%;
  z-index: 5;
  position: absolute;
}
.dx-colorview-alpha-channel-handle,
.dx-colorview-hue-scale-handle {
  position: absolute;
  cursor: pointer;
}
.dx-colorview-hue-scale-handle {
  width: 36px;
  height: 17px;
  top: 0;
  left: -7px;
}
.dx-colorview-alpha-channel-handle {
  width: 17px;
  height: 36px;
  top: -6px;
  left: 0;
}
.dx-colorview-hue-scale {
  position: relative;
  background-repeat: no-repeat;
  background-image: -webkit-gradient(linear,left bottom,left top,from(red),color-stop(17%,#ff0),color-stop(33%,#0f0),color-stop(50%,#0ff),color-stop(67%,#00f),color-stop(83%,#f0f),to(red));
  background-image: linear-gradient(0deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red 100%);
}
.dx-colorbox-input-container::after,
.dx-colorview-alpha-channel-wrapper,
.dx-colorview-color-preview-container-inner {
  background-image: linear-gradient(45deg,#ccc 25%,transparent 25%,transparent 74%,#ccc 75%,#ccc),linear-gradient(45deg,#ccc 25%,transparent 25%,transparent 74%,#ccc 75%,#ccc);
  background-size: 16px 16px;
  background-position: 0 0,8px 8px;
}
.dx-colorview-alpha-channel-wrapper {
  background-position: 0 6px,8px 14px;
}
.dx-colorbox-input-container {
  height: 100%;
}
.dx-colorview-palette-gradient-white {
  background-repeat: no-repeat;
  background-image: -webkit-gradient(linear,right top,left top,from(rgba(255,255,255,0)),to(#fff));
  background-image: linear-gradient(270deg,rgba(255,255,255,0),#fff);
}
.dx-colorview-palette-gradient-black {
  background-repeat: no-repeat;
  background-image: -webkit-gradient(linear,left top,left bottom,from(rgba(0,0,0,0)),to(#000));
  background-image: linear-gradient(180deg,rgba(0,0,0,0),#000);
}
.dx-colorview-palette {
  position: relative;
  overflow: hidden;
  cursor: crosshair;
}
.dx-colorview-palette-gradient {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.dx-colorview-alpha-channel-scale {
  height: 20px;
  position: relative;
}
.dx-colorview-alpha-channel-cell {
  margin: 6px 0;
  position: relative;
}
.dx-colorview-alpha-channel-cell .dx-button {
  width: 90px;
}
.dx-rtl .dx-colorview-container-row .dx-colorview-container-cell {
  float: right;
}
.dx-rtl .dx-colorview-container label .dx-texteditor {
  float: left;
}
.dx-rtl .dx-colorview-alpha-channel-scale {
  direction: ltr;
}
.dx-colorview-palette-handle {
  background: radial-gradient(transparent 5px,rgba(0,0,0,.2) 6px,#fff 7px,#fff 12px,rgba(0,0,0,.2) 13px);
  -webkit-box-shadow: 0 1px 1px 0 rgba(0,0,0,.2);
  box-shadow: 0 1px 1px 0 rgba(0,0,0,.2);
}
.dx-colorview-hue-scale-handle {
  border: 1px solid rgba(0,0,0,.2);
  -webkit-box-shadow: inset -5px 0 0 3px #fff,inset 5px 0 0 3px #fff,inset -6px 0 1px 4px rgba(0,0,0,.2),inset 6px 0 1px 4px rgba(0,0,0,.2);
  box-shadow: inset -5px 0 0 3px #fff,inset 5px 0 0 3px #fff,inset -6px 0 1px 4px rgba(0,0,0,.2),inset 6px 0 1px 4px rgba(0,0,0,.2);
}
.dx-colorview-alpha-channel-handle {
  border: 1px solid rgba(0,0,0,.2);
  -webkit-box-shadow: inset 0 -5px 0 3px #fff,inset 0 5px 0 3px #fff,inset 0 -6px 1px 4px rgba(0,0,0,.2),inset 0 6px 1px 4px rgba(0,0,0,.2);
  box-shadow: inset 0 -5px 0 3px #fff,inset 0 5px 0 3px #fff,inset 0 -6px 1px 4px rgba(0,0,0,.2),inset 0 6px 1px 4px rgba(0,0,0,.2);
}
.dx-colorview-container {
  overflow: hidden;
  width: 450px;
}
.dx-colorview-container label.dx-colorview-label-hex {
  margin: 20px 0 0;
}
.dx-colorview-container label.dx-colorview-alpha-channel-label {
  margin: 0 0 0 43px;
  width: 115px;
}
.dx-colorview-container label .dx-texteditor {
  float: right;
  width: 69px;
  margin: 0 0 0 10px;
}
.dx-colorview-hue-scale-cell {
  position: relative;
  margin-left: 19px;
}
.dx-colorview-palette {
  width: 288px;
  height: 299px;
}
.dx-colorview-alpha-channel-scale {
  width: 288px;
}
.dx-colorview-container-row.dx-colorview-alpha-channel-row {
  margin-top: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.dx-colorview-hue-scale {
  width: 18px;
  height: 299px;
}
.dx-colorview-alpha-channel-cell {
  width: 292px;
}
.dx-colorview-hue-scale-wrapper {
  height: 301px;
}
.dx-colorview-color-preview {
  width: 100%;
  height: 40px;
}
.dx-colorview-controls-container {
  position: relative;
  width: 90px;
  margin-left: 27px;
}
.dx-colorview-alpha-channel-border,
.dx-colorview-color-preview-container,
.dx-colorview-hue-scale-wrapper,
.dx-colorview-palette-cell {
  padding: 1px;
  margin: 0 1px 1px;
  background-color: #fff;
  -webkit-box-shadow: 0 0 0 1px #e0e0e0;
  box-shadow: 0 0 0 1px #e0e0e0;
}
.dx-colorview-color-preview-container {
  margin-bottom: 34px;
}
.dx-rtl .dx-colorview-controls-container {
  margin-left: 0;
  margin-right: 27px;
}
.dx-rtl .dx-colorview-hue-scale-cell {
  margin-left: 0;
  margin-right: 19px;
}
.dx-rtl .dx-colorview-container label.dx-colorview-alpha-channel-label {
  margin-left: 0;
  margin-right: 43px;
}
.dx-colorbox .dx-colorbox-input-container .dx-dropdowneditor-input-wrapper .dx-colorbox-input {
  padding-left: 40px;
}
.dx-colorbox .dx-colorbox-input-container.dx-colorbox-color-is-not-defined .dx-colorbox-color-result-preview {
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAQAAACRZI9xAAAAdElEQVQoU4XR0Q3AIAgFQCarie7UrToMc3QIiyIFFGNe5INcgETAegpQefFCCFPwYZI2qFA/M4EQMQAhKxJgiEcKHFFkwUQY3Q4sBAhUerYzkbaiTUk7Ije0dYoMyeYGi35igUeDzMCiTiKgaPx0BAR1csgHXJxUKOJqsbEAAAAASUVORK5CYII=") no-repeat;
}
.dx-colorbox .dx-colorbox-input-container::after {
  left: 14px;
}
.dx-colorbox .dx-placeholder {
  left: 32px;
}
.dx-colorbox-color-result-preview {
  border-color: #e0e0e0;
  left: 13px;
}
.dx-colorbox-overlay {
  padding: 0;
}
.dx-colorbox-overlay.dx-overlay-content {
  background-color: #fff;
}
.dx-rtl .dx-colorbox.dx-state-focused .dx-colorbox-input,
.dx-rtl.dx-colorbox.dx-state-focused .dx-colorbox-input {
  padding-right: 40px;
}
.dx-rtl .dx-colorbox-overlay .dx-toolbar-item:first-child {
  padding-left: 10px;
  padding-right: 0;
}
.dx-pager {
  overflow: hidden;
  width: 100%;
  line-height: normal;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  padding: 13px 16px;
}
.dx-pager .dx-pages {
  white-space: nowrap;
  float: right;
}
.dx-pager .dx-pages .dx-page-indexes {
  display: inline-block;
}
.dx-pager .dx-pages .dx-page {
  display: inline-block;
  cursor: pointer;
  margin-left: 5px;
  margin-right: 1px;
}
.dx-pager .dx-pages .dx-separator {
  display: inline-block;
}
.dx-pager .dx-pages .dx-info {
  display: inline-block;
  margin-right: 9px;
  opacity: .6;
}
.dx-pager .dx-pages .dx-navigate-button {
  cursor: pointer;
  display: inline-block;
  vertical-align: top;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
.dx-pager .dx-pages .dx-navigate-button.dx-button-disable {
  opacity: .3;
  cursor: inherit;
}
.dx-pager .dx-page-sizes {
  float: left;
}
.dx-pager .dx-page-sizes .dx-page-size {
  display: inline-block;
  cursor: pointer;
  margin-left: 4px;
  margin-right: 1px;
}
.dx-pager .dx-page-sizes .dx-selection,
.dx-pager .dx-pages .dx-selection {
  cursor: inherit;
  text-shadow: none;
}
.dx-pager .dx-light-pages {
  display: inline-block;
}
.dx-pager .dx-light-pages .dx-page-index {
  width: 40px;
}
.dx-pager .dx-light-pages .dx-pages-count {
  cursor: pointer;
}
.dx-pager .dx-light-pages .dx-info-text,
.dx-pager .dx-light-pages .dx-pages-count {
  padding-left: 6px;
}
.dx-pager .dx-light-pages .dx-info-text,
.dx-pager .dx-light-pages .dx-page-index,
.dx-pager .dx-light-pages .dx-pages-count {
  display: table-cell;
}
.dx-pager.dx-rtl .dx-pages,
.dx-rtl .dx-pager .dx-pages {
  float: left;
  direction: ltr;
}
.dx-pager.dx-rtl .dx-pages .dx-page,
.dx-rtl .dx-pager .dx-pages .dx-page {
  direction: ltr;
}
.dx-pager.dx-rtl .dx-pages .dx-page:first-child,
.dx-rtl .dx-pager .dx-pages .dx-page:first-child {
  margin-left: 1px;
}
.dx-pager.dx-rtl .dx-pages .dx-info,
.dx-rtl .dx-pager .dx-pages .dx-info {
  direction: rtl;
  margin-left: 9px;
  margin-right: 0;
}
.dx-pager.dx-rtl .dx-page-sizes,
.dx-rtl .dx-pager .dx-page-sizes {
  float: right;
}
.dx-pager.dx-light-mode .dx-page-sizes {
  min-width: 62px;
}
.dx-pager.dx-light-mode .dx-page-index {
  min-width: 32px;
}
.dx-pager.dx-light-mode .dx-pages .dx-light-pages,
.dx-pager.dx-light-mode .dx-pages .dx-navigate-button,
.dx-pager.dx-light-mode .dx-pages .dx-page-indexes {
  vertical-align: middle;
}
.dx-pager .dx-pages .dx-page {
  padding: 9px 12px;
  line-height: 12px;
}
.dx-pager .dx-pages .dx-separator {
  padding-left: 8px;
  padding-right: 8px;
}
.dx-pager .dx-pages .dx-navigate-button {
  width: 9px;
  height: 12px;
  padding: 9px 12px;
}
.dx-pager .dx-pages .dx-prev-button {
  font: 14px/1 DXIcons;
}
.dx-pager .dx-pages .dx-prev-button::before {
  content: "\\f012";
}
.dx-pager .dx-pages .dx-next-button {
  font: 14px/1 DXIcons;
}
.dx-pager .dx-pages .dx-next-button::before {
  content: "\\f010";
}
.dx-pager .dx-pages .dx-next-button,
.dx-pager .dx-pages .dx-prev-button {
  position: relative;
  font-size: 21px;
  text-align: center;
  line-height: 21px;
}
.dx-pager .dx-pages .dx-next-button::before,
.dx-pager .dx-pages .dx-prev-button::before {
  position: absolute;
  display: block;
  width: 21px;
  top: 50%;
  margin-top: -10.5px;
  left: 50%;
  margin-left: -10.5px;
}
.dx-pager .dx-page,
.dx-pager .dx-page-size {
  font-size: 12px;
  border-radius: 20px;
}
.dx-pager .dx-page-size:hover,
.dx-pager .dx-page:hover {
  background-color: rgba(0,0,0,.04);
}
.dx-pager .dx-page-sizes .dx-page-size {
  padding: 9px 12px;
  line-height: 12px;
}
.dx-pager .dx-page-sizes .dx-page-size.dx-first-child,
.dx-pager .dx-page-sizes .dx-page-size:first-child {
  margin-left: 0;
}
.dx-pager .dx-page-sizes .dx-selection,
.dx-pager .dx-pages .dx-selection {
  font-weight: 500;
  background-color: #009688;
  color: #fff;
}
.dx-gridbase-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 100%;
  min-height: inherit;
  max-height: inherit;
}
.dx-gridbase-container > * {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
}
.dx-datagrid-checkbox-size {
  vertical-align: middle;
}
.dx-datagrid-important-margin {
  margin-right: 5px!important;
}
.dx-datagrid-table {
  background-color: transparent;
}
.dx-datagrid-borders > .dx-datagrid-total-footer {
  border-top: 0;
}
.dx-datagrid-borders > .dx-datagrid-pager {
  margin-top: -1px;
}
.dx-datagrid-borders > .dx-datagrid-header-panel {
  border-bottom: 0;
}
.dx-datagrid-borders > .dx-datagrid-rowsview.dx-last-row-border tbody:last-child > .dx-data-row:nth-last-child(2) > td {
  border-bottom-width: 0;
}
.dx-datagrid .dx-datagrid-content-fixed {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 2;
  pointer-events: none;
  overflow: hidden;
}
.dx-datagrid .dx-datagrid-content-fixed .dx-datagrid-table {
  position: relative;
}
.dx-datagrid .dx-datagrid-content-fixed .dx-datagrid-table td {
  pointer-events: auto;
}
.dx-datagrid .dx-datagrid-content-fixed .dx-datagrid-table .dx-row td.dx-pointer-events-none {
  visibility: hidden;
  background-color: transparent;
  pointer-events: none;
  border-top-color: transparent;
  border-bottom-color: transparent;
}
.dx-datagrid .dx-datagrid-content-fixed .dx-datagrid-table .dx-header-row td.dx-pointer-events-none {
  border-bottom-color: transparent;
}
.dx-datagrid .dx-datagrid-content-fixed .dx-datagrid-table.dx-datagrid-table-fixed .dx-row td.dx-pointer-events-none {
  width: auto;
}
.dx-datagrid .dx-menu-subitem ul li {
  padding-top: 0;
}
.dx-datagrid .dx-menu-subitem ul li:first-child {
  padding-top: 1px;
}
.dx-datagrid .dx-menu-subitem .dx-menu-item {
  padding: 7px 30px 7px 5px;
}
.dx-datagrid .dx-menu-subitem .dx-menu-item .dx-menu-image {
  background-position-x: left;
}
.dx-datagrid .dx-column-indicators {
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
}
.dx-datagrid .dx-column-indicators.dx-visibility-hidden {
  visibility: hidden;
}
.dx-datagrid .dx-column-indicators .dx-sort-index-icon {
  width: 15px;
}
.dx-datagrid .dx-column-indicators .dx-header-filter.dx-header-filter,
.dx-datagrid .dx-column-indicators .dx-header-filter.dx-sort,
.dx-datagrid .dx-column-indicators .dx-sort.dx-header-filter,
.dx-datagrid .dx-column-indicators .dx-sort.dx-sort {
  display: inline-block;
}
.dx-datagrid .dx-column-indicators .dx-header-filter.dx-header-filter::after,
.dx-datagrid .dx-column-indicators .dx-sort.dx-header-filter::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: -7px;
}
.dx-datagrid .dx-row > td,
.dx-datagrid .dx-row > tr > td {
  padding: 7px;
}
.dx-datagrid .dx-error-row {
  -webkit-user-select: initial;
  -moz-user-select: initial;
  -ms-user-select: initial;
  user-select: initial;
}
.dx-datagrid .dx-error-row .dx-error-message {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
.dx-datagrid .dx-error-row .dx-error-message a {
  color: inherit;
}
.dx-datagrid .dx-datagrid-rowsview .dx-data-row .dx-command-drag {
  cursor: move;
  vertical-align: middle;
  padding: 0;
}
.dx-sortable-dragging .dx-datagrid-rowsview .dx-data-row .dx-command-drag {
  cursor: pointer;
  cursor: -webkit-grabbing;
  cursor: grabbing;
}
.dx-datagrid-column-chooser .dx-overlay-content .dx-popup-title {
  font-size: 16px;
}
.dx-datagrid-column-chooser .dx-overlay-content .dx-popup-content {
  padding: 0 20px 20px;
}
.dx-datagrid-column-chooser .dx-overlay-content .dx-popup-content .dx-column-chooser-item {
  opacity: .5;
  -webkit-box-shadow: 0 1px 3px -1px rgba(0,0,0,.2);
  box-shadow: 0 1px 3px -1px rgba(0,0,0,.2);
}
.dx-datagrid-column-chooser .dx-overlay-content .dx-popup-content .dx-column-chooser-item.dx-datagrid-drag-action {
  opacity: 1;
  cursor: pointer;
  -ms-touch-action: pinch-zoom;
  touch-action: pinch-zoom;
}
.dx-datagrid-column-chooser.dx-datagrid-column-chooser-mode-drag .dx-treeview-node-container:first-child > .dx-treeview-node-is-leaf {
  padding: 0;
}
.dx-datagrid-column-chooser.dx-datagrid-column-chooser-mode-select .dx-datagrid-column-chooser-plain .dx-treeview-select-all-item {
  padding-left: 4px;
}
.dx-datagrid-column-chooser.dx-datagrid-column-chooser-mode-select .dx-datagrid-column-chooser-plain .dx-treeview-node {
  padding-left: 0;
}
.dx-datagrid-column-chooser.dx-datagrid-column-chooser-mode-select .dx-datagrid-column-chooser-plain .dx-treeview-node .dx-checkbox {
  left: 4px;
}
.dx-datagrid-nowrap,
.dx-datagrid-nowrap .dx-header-row>td>.dx-datagrid-text-content {
  white-space: nowrap;
}
.dx-datagrid-drag-header {
  position: absolute;
  vertical-align: middle;
  cursor: pointer;
  z-index: 10000;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
.dx-datagrid-drag-header.dx-drag-command-cell {
  padding: 0;
}
.dx-datagrid-columns-separator {
  position: absolute;
  z-index: 3;
  width: 3px;
}
.dx-datagrid-columns-separator-transparent {
  border-left: 0;
  border-right: 0;
}
.dx-datagrid-tracker {
  width: 100%;
  position: absolute;
  top: 0;
  z-index: 3;
  cursor: col-resize;
}
.dx-datagrid-table-content {
  position: absolute;
  top: 0;
}
.dx-datagrid-focus-overlay {
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  visibility: hidden;
}
.dx-datagrid-action,
.dx-datagrid-drag-action {
  cursor: pointer;
}
.dx-datagrid-content {
  position: relative;
}
.dx-datagrid-content .dx-overlay-wrapper.dx-invalid-message.dx-datagrid-invalid-message {
  visibility: visible;
}
.dx-datagrid-content .dx-overlay-wrapper.dx-invalid-message.dx-datagrid-invalid-message .dx-overlay-content,
.dx-datagrid-text-content {
  overflow: hidden;
  text-overflow: ellipsis;
}
.dx-datagrid-table-fixed {
  table-layout: fixed;
  width: 100%;
}
.dx-datagrid-content .dx-datagrid-table {
  border-collapse: collapse;
  border-spacing: 0;
  margin: 0;
  max-width: 10px;
}
.dx-datagrid-content .dx-datagrid-table.dx-datagrid-table-fixed {
  max-width: none;
}
.dx-datagrid-content .dx-datagrid-table.dx-datagrid-table-fixed .dx-column-indicators .dx-sort.dx-sort-none {
  display: none;
}
.dx-datagrid-content .dx-datagrid-table.dx-datagrid-table-fixed .dx-column-indicators .dx-sort.dx-sort-index {
  width: 26px;
}
.dx-datagrid-content .dx-datagrid-table .dx-datagrid-best-fit {
  max-width: none!important;
}
.dx-datagrid-content .dx-datagrid-table .dx-datagrid-best-fit .dx-column-indicators {
  float: none!important;
}
.dx-datagrid-content .dx-datagrid-table .dx-datagrid-best-fit .dx-column-indicators > span {
  width: 14px;
}
.dx-datagrid-content .dx-datagrid-table .dx-datagrid-best-fit .dx-column-indicators .dx-sort.dx-sort-none {
  display: inline-block;
}
.dx-datagrid-content .dx-datagrid-table .dx-datagrid-best-fit .dx-header-row .dx-datagrid-text-content {
  max-width: none;
}
.dx-datagrid-content .dx-datagrid-table .dx-datagrid-best-fit .dx-text-content-alignment-left {
  margin-right: 3px;
}
.dx-datagrid-content .dx-datagrid-table .dx-datagrid-best-fit .dx-text-content-alignment-right {
  margin-left: 3px;
}
.dx-datagrid-content .dx-datagrid-table:not(.dx-datagrid-table-fixed) .dx-column-indicators {
  float: none!important;
}
.dx-datagrid-content .dx-datagrid-table:not(.dx-datagrid-table-fixed) .dx-column-indicators > span {
  width: 14px;
}
.dx-datagrid-content .dx-datagrid-table:not(.dx-datagrid-table-fixed) .dx-text-content-alignment-left {
  margin-right: 3px;
}
.dx-datagrid-content .dx-datagrid-table:not(.dx-datagrid-table-fixed) .dx-text-content-alignment-right {
  margin-left: 3px;
}
.dx-datagrid-content .dx-datagrid-table:not(.dx-datagrid-table-fixed) .dx-master-detail-cell {
  max-width: 0;
}
.dx-datagrid-content .dx-datagrid-table [class*=column] + [class*=column]:last-child {
  float: none;
}
.dx-datagrid-content .dx-datagrid-table .dx-row > td,
.dx-datagrid-content .dx-datagrid-table .dx-row > tr > td {
  vertical-align: top;
}
.dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-first-child,
.dx-datagrid-content .dx-datagrid-table .dx-row > td:first-child,
.dx-datagrid-content .dx-datagrid-table .dx-row > tr > td.dx-first-child,
.dx-datagrid-content .dx-datagrid-table .dx-row > tr > td:first-child {
  border-left: 0;
}
.dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-last-child,
.dx-datagrid-content .dx-datagrid-table .dx-row > tr > td.dx-last-child {
  border-right: 0;
}
.dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-datagrid-group-space,
.dx-datagrid-content .dx-datagrid-table .dx-row > tr > td.dx-datagrid-group-space {
  border-right: none;
  vertical-align: top;
}
.dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-datagrid-group-space + td,
.dx-datagrid-content .dx-datagrid-table .dx-row > tr > td.dx-datagrid-group-space + td {
  border-left: none;
}
.dx-datagrid-content .dx-datagrid-table .dx-row .dx-editor-container {
  overflow: hidden;
}
.dx-datagrid-content .dx-datagrid-table .dx-row .dx-datagrid-invalid .dx-invalid-message.dx-overlay {
  position: static;
}
.dx-datagrid-content .dx-datagrid-table .dx-row .dx-editor-cell {
  max-width: 0;
  padding: 0;
  vertical-align: middle;
}
.dx-datagrid-content .dx-datagrid-table .dx-row .dx-editor-cell .dx-texteditor,
.dx-datagrid-content .dx-datagrid-table .dx-row .dx-editor-cell .dx-texteditor-container {
  border: 0;
  margin: 0;
}
.dx-datagrid-content .dx-datagrid-table .dx-row .dx-command-select {
  padding: 0;
  width: 70px;
  min-width: 70px;
  max-width: 70px;
}
.dx-datagrid-content .dx-datagrid-table .dx-row .dx-command-edit {
  text-overflow: clip;
  width: 100px;
  min-width: 100px;
  white-space: nowrap;
}
.dx-datagrid-content .dx-datagrid-table .dx-row .dx-command-edit.dx-command-edit-with-icons {
  width: 80px;
  min-width: 80px;
}
.dx-datagrid-content .dx-datagrid-table .dx-row .dx-command-edit.dx-command-edit-with-icons .dx-link {
  text-decoration: none;
}
.dx-datagrid-content .dx-datagrid-table .dx-row .dx-command-edit .dx-link {
  display: inline-block;
}
.dx-datagrid-content .dx-datagrid-table .dx-row .dx-command-expand {
  padding: 0;
  width: 30px;
  min-width: 30px;
  max-width: 30px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}
.dx-datagrid-content .dx-datagrid-table .dx-row .dx-command-adaptive {
  padding: 0;
  vertical-align: middle;
}
.dx-datagrid-content .dx-datagrid-table .dx-data-row .dx-command-edit-with-icons {
  line-height: 1;
  white-space: nowrap;
}
.dx-datagrid-content .dx-datagrid-table .dx-filter-range-content {
  padding: 7px 7px 7px 32px;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.dx-datagrid-content .dx-datagrid-table .dx-row > .dx-last-data-cell {
  border-right: none;
}
.dx-datagrid-content .dx-datagrid-table .dx-row > .dx-command-adaptive-hidden {
  border-left: none;
}
.dx-cell-modified,
.dx-datagrid-invalid,
.dx-highlight-outline {
  position: relative;
  padding: 7px;
}
.dx-cell-modified::after,
.dx-datagrid-invalid::after,
.dx-highlight-outline::after {
  content: "";
  position: absolute;
  border: 2px solid transparent;
  top: 0;
  left: 1px;
  bottom: 0;
  right: 0;
  pointer-events: none;
}
.dx-cell-modified.dx-hidden,
.dx-datagrid-invalid.dx-hidden,
.dx-highlight-outline.dx-hidden {
  display: block!important;
}
.dx-cell-modified.dx-hidden::after,
.dx-datagrid-invalid.dx-hidden::after,
.dx-highlight-outline.dx-hidden::after {
  display: none;
}
.dx-editor-cell .dx-highlight-outline,
.dx-editor-cell.dx-cell-modified,
.dx-editor-cell.dx-datagrid-invalid {
  padding: 0;
}
.dx-column-lines .dx-cell-modified::after,
.dx-column-lines .dx-datagrid-invalid::after,
.dx-column-lines .dx-highlight-outline::after {
  left: 0;
}
.dx-datagrid-headers {
  position: relative;
  outline: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}
.dx-header-row > td > .dx-datagrid-text-content {
  display: inline-block;
  white-space: normal;
  vertical-align: top;
}
.dx-header-row > td > .dx-datagrid-text-content:not(.dx-sort-indicator):not(.dx-header-filter-indicator) {
  max-width: 100%;
}
.dx-datagrid-filter-range-overlay .dx-editor-container .dx-texteditor {
  border-width: 0;
}
.dx-datagrid-filter-range-overlay .dx-editor-container .dx-texteditor.dx-state-focused::after {
  content: " ";
  position: absolute;
  top: -1px;
  bottom: -1px;
  left: -1px;
  right: -1px;
  z-index: 1;
  pointer-events: none;
}
.dx-datagrid-filter-range-overlay .dx-datagrid-filter-range-end {
  border-top: 1px solid transparent;
}
.dx-datagrid-filter-range-overlay .dx-editor-container.dx-cell-modified,
.dx-datagrid-filter-range-overlay .dx-editor-container.dx-datagrid-invalid {
  padding: 0;
}
.dx-datagrid-filter-row .dx-editor-cell .dx-menu {
  display: none;
}
.dx-datagrid-filter-row .dx-editor-cell .dx-editor-with-menu {
  position: relative;
}
.dx-datagrid-filter-row .dx-editor-cell .dx-editor-with-menu .dx-menu {
  display: block;
}
.dx-datagrid-filter-row .dx-editor-cell .dx-editor-with-menu .dx-placeholder::before,
.dx-datagrid-filter-row .dx-editor-cell .dx-editor-with-menu .dx-texteditor-input {
  padding-left: 32px;
}
.dx-datagrid-filter-row .dx-cell-modified::after,
.dx-datagrid-filter-row .dx-datagrid-invalid::after {
  pointer-events: none;
}
.dx-datagrid-filter-row .dx-focused .dx-highlight-outline::after,
.dx-datagrid-filter-row .dx-focused.dx-cell-modified::after,
.dx-datagrid-filter-row .dx-focused.dx-datagrid-invalid::after {
  border-color: transparent;
}
.dx-datagrid-filter-row .dx-menu {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  margin-top: -2px;
  height: 100%;
  overflow: visible;
}
.dx-datagrid-filter-row .dx-menu .dx-menu-horizontal {
  height: 100%;
}
.dx-datagrid-filter-row .dx-menu .dx-menu-horizontal .dx-menu-item-popout,
.dx-datagrid-filter-row .dx-menu .dx-menu-horizontal .dx-menu-item-text {
  display: none;
}
.dx-datagrid-filter-row .dx-menu-item.dx-state-focused::after {
  position: absolute;
  left: 2px;
  top: 2px;
  width: 100%;
  height: 102%;
  content: "";
}
.dx-datagrid-filter-row > .dx-first-cell .dx-menu,
.dx-datagrid-filter-row > td:first-child .dx-menu {
  margin-left: 0;
}
.dx-datagrid-filter-row .dx-menu-horizontal .dx-overlay-content ul .dx-menu-item {
  padding: 5px 30px 5px 5px;
}
.dx-datagrid-filter-row .dx-menu ul.dx-menu-horizontal > li > .dx-menu-item {
  padding: 8px 5px 7px;
}
.dx-datagrid-filter-row .dx-menu ul.dx-menu-horizontal > li > .dx-menu-item.dx-state-disabled:hover {
  padding: 9px 6px 8px;
}
.dx-datagrid-filter-row .dx-menu-caption {
  padding-left: 6px;
}
.dx-datagrid-filter-row .dx-menu ul .dx-menu-item .dx-menu-chouser-down {
  display: none;
}
.dx-datagrid-filter-row .dx-menu-item-highlight {
  font-weight: 400;
}
.dx-datagrid-scroll-container {
  overflow: hidden;
  width: 100%;
}
.dx-datagrid-header-panel {
  text-align: left;
}
.dx-datagrid-header-panel .dx-toolbar-menu-container .dx-button {
  margin-left: 10px;
}
.dx-datagrid-search-panel {
  margin: 0 0 0 15px;
}
.dx-gridbase-container > .dx-datagrid-rowsview {
  -webkit-box-flex: 1;
  -ms-flex: auto;
  flex: auto;
  height: auto;
}
.dx-gridbase-container > .dx-datagrid-rowsview.dx-scrollable {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.dx-gridbase-container > .dx-datagrid-rowsview.dx-scrollable > .dx-scrollable-wrapper {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: auto;
  min-width: 0;
  min-height: 0;
}
.dx-datagrid-rowsview {
  position: relative;
  overflow: hidden;
}
.dx-datagrid-rowsview.dx-empty {
  height: 100px;
}
.dx-datagrid-rowsview.dx-empty .dx-scrollable-content {
  height: 100%;
}
.dx-datagrid-rowsview.dx-fixed-columns.dx-scrollable .dx-scrollable-content {
  z-index: 2;
}
.dx-datagrid-rowsview.dx-fixed-columns .dx-scrollable-scrollbar {
  z-index: 3;
}
.dx-datagrid-rowsview .dx-datagrid-content {
  overflow-anchor: none;
}
.dx-datagrid-rowsview .dx-datagrid-content:not(.dx-datagrid-content-fixed) {
  min-height: 100%;
}
.dx-datagrid-rowsview .dx-datagrid-content.dx-scrollable-container {
  width: auto;
}
.dx-datagrid-rowsview .dx-datagrid-content.dx-datagrid-content-fixed.dx-scrollable-container {
  height: auto;
}
.dx-datagrid-rowsview:focus {
  outline: 0;
}
.dx-datagrid-rowsview .dx-row > td,
.dx-datagrid-rowsview .dx-row > tr > td {
  overflow: hidden;
  text-overflow: ellipsis;
}
.dx-datagrid-rowsview .dx-row.dx-row-lines:first-child,
.dx-datagrid-rowsview .dx-row.dx-row-lines:first-child>td,
.dx-datagrid-rowsview .dx-row.dx-row-lines:first-child>tr>td {
  border-top: none;
}
.dx-datagrid-rowsview .dx-data-row > td:focus {
  outline: 0;
}
.dx-datagrid-rowsview .dx-selection > td .dx-link,
.dx-datagrid-rowsview .dx-selection > tr > td .dx-link,
.dx-datagrid-rowsview .dx-selection.dx-row:hover > td .dx-link,
.dx-datagrid-rowsview .dx-selection.dx-row:hover > tr > td .dx-link {
  color: inherit;
}
.dx-datagrid-rowsview .dx-datagrid-table .dx-row.dx-freespace-row,
.dx-datagrid-rowsview .dx-datagrid-table .dx-row.dx-virtual-row {
  border-top: 0;
  border-bottom: 0;
}
.dx-datagrid-rowsview .dx-datagrid-table .dx-row.dx-freespace-row > td,
.dx-datagrid-rowsview .dx-datagrid-table .dx-row.dx-virtual-row > td {
  padding-top: 0;
  padding-bottom: 0;
}
.dx-datagrid-rowsview .dx-select-checkboxes-hidden > tbody > tr > td > .dx-select-checkbox {
  display: none;
}
.dx-datagrid-rowsview .dx-select-checkboxes-hidden>tbody>tr.dx-selection>td>.dx-select-checkbox,
.dx-datagrid-rowsview .dx-select-checkboxes-hidden>tbody>tr>td:hover>.dx-select-checkbox {
  display: inline-block;
}
.dx-datagrid-rowsview .dx-row > .dx-master-detail-cell:focus {
  outline: 0;
}
.dx-datagrid-rowsview .dx-data-row.dx-edit-row .dx-cell-modified::after {
  border-color: transparent;
}
.dx-datagrid-nodata {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  text-align: center;
  -webkit-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
}
.dx-datagrid-bottom-load-panel {
  text-align: center;
  padding: 10px;
}
.dx-datagrid-hidden-column {
  white-space: nowrap;
}
.dx-datagrid .dx-row .dx-datagrid-hidden-column {
  border-right-width: 0;
  border-left-width: 0;
}
.dx-datagrid-hidden-column > * {
  display: none!important;
}
.dx-datagrid-summary-item {
  font-weight: 700;
}
.dx-datagrid-export-menu .dx-dropdownbutton-content .dx-list-item {
  display: block;
}
.dx-datagrid-revert-tooltip.dx-popover-wrapper .dx-overlay-content {
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-datagrid-revert-tooltip.dx-popover-wrapper .dx-overlay-content .dx-popup-content {
  padding: 0;
}
.dx-datagrid-revert-tooltip.dx-popover-wrapper .dx-popover-arrow {
  width: 0;
  height: 0;
}
.dx-datagrid-notouch-action {
  -ms-touch-action: none;
  touch-action: none;
  -ms-content-zooming: none;
  -ms-overflow-style: none;
}
.dx-datagrid-column-chooser-list.dx-treeview .dx-empty-message,
.dx-datagrid-column-chooser-list.dx-treeview .dx-treeview-item {
  border: none;
}
.dx-datagrid-column-chooser-list.dx-treeview .dx-empty-message {
  text-align: center;
  left: 0;
  right: 0;
  bottom: 50%;
  position: absolute;
}
.dx-datagrid.dx-rtl .dx-menu-subitem .dx-menu-item,
.dx-rtl .dx-datagrid .dx-menu-subitem .dx-menu-item {
  padding: 7px 5px 7px 30px;
}
.dx-datagrid.dx-rtl .dx-menu-subitem .dx-menu-item .dx-menu-image,
.dx-rtl .dx-datagrid .dx-menu-subitem .dx-menu-item .dx-menu-image {
  background-position-x: right;
}
.dx-datagrid.dx-rtl .dx-texteditor-buttons-container,
.dx-rtl .dx-datagrid .dx-texteditor-buttons-container {
  text-align: start;
}
.dx-rtl .dx-datagrid-content .dx-datagrid-table {
  direction: rtl;
}
.dx-rtl .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-datagrid-group-space {
  border-left: none;
}
.dx-rtl .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-datagrid-group-space + td {
  border-right: none;
}
.dx-rtl .dx-datagrid-content .dx-datagrid-table .dx-row .dx-editor-container .dx-editor-cell .dx-checkbox.dx-checkbox-checked .dx-checkbox-icon {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
.dx-rtl .dx-datagrid-content .dx-datagrid-table .dx-row .dx-filter-range-content {
  padding: 7px 32px 7px 7px;
}
.dx-rtl .dx-datagrid-headers .dx-datagrid-scrollable-simulated,
.dx-rtl .dx-datagrid-total-footer .dx-datagrid-scrollable-simulated {
  direction: ltr;
}
.dx-rtl .dx-datagrid-headers .dx-datagrid-scrollable-simulated .dx-datagrid-table,
.dx-rtl .dx-datagrid-total-footer .dx-datagrid-scrollable-simulated .dx-datagrid-table {
  direction: rtl;
}
.dx-rtl .dx-datagrid-filter-row .dx-editor-cell .dx-editor-with-menu .dx-texteditor .dx-placeholder::before,
.dx-rtl .dx-datagrid-filter-row .dx-editor-cell .dx-editor-with-menu .dx-texteditor .dx-texteditor-input {
  padding-right: 32px;
}
.dx-rtl .dx-datagrid-filter-row .dx-menu {
  right: 0;
  left: auto;
  margin-left: 0;
  margin-right: -2px;
}
.dx-rtl .dx-datagrid-filter-row > td:first-child .dx-menu {
  margin-left: 0;
}
.dx-rtl .dx-datagrid-filter-row .dx-menu-horizontal .dx-overlay-content ul .dx-menu-item {
  padding: 5px 5px 5px 30px;
}
.dx-rtl .dx-datagrid-filter-row .dx-menu-caption {
  padding-right: 6px;
}
.dx-rtl .dx-datagrid-header-panel {
  text-align: right;
}
.dx-rtl .dx-datagrid-header-panel .dx-datagrid-column-chooser-button {
  margin-left: 0;
}
.dx-rtl .dx-datagrid-header-panel .dx-toolbar-menu-container .dx-button {
  margin-left: 0;
  margin-right: 10px;
}
.dx-rtl .dx-datagrid-search-panel {
  margin: 0 15px 0 0;
}
.dx-datagrid-filter-panel,
.dx-datagrid-filter-panel-left {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  min-width: 0;
}
.dx-datagrid-filter-panel .dx-datagrid-filter-panel-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dx-datagrid-filter-panel .dx-datagrid-filter-panel-clear-filter:hover,
.dx-datagrid-filter-panel .dx-datagrid-filter-panel-text:hover {
  text-decoration: underline;
  cursor: pointer;
}
.dx-datagrid-filter-panel .dx-datagrid-filter-panel-checkbox {
  padding-right: 10px;
}
.dx-datagrid-filter-panel .dx-icon-filter {
  margin: auto 7px auto auto;
  cursor: pointer;
}
.dx-datagrid {
  position: relative;
  cursor: default;
  white-space: normal;
  line-height: normal;
}
.dx-hidden.dx-group-cell {
  display: table-cell!important;
  font-size: 0!important;
}
.dx-datagrid-group-panel {
  display: inline-block;
  white-space: nowrap;
  width: 100%;
  -ms-touch-action: pinch-zoom;
  touch-action: pinch-zoom;
}
.dx-datagrid-group-panel .dx-group-panel-message {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dx-datagrid-group-panel .dx-group-panel-item {
  display: inline-block;
  min-width: 30px;
  white-space: nowrap;
}
.dx-datagrid-group-panel .dx-group-panel-item .dx-sort {
  margin-left: 6px;
}
.dx-datagrid-group-panel .dx-block-separator {
  display: inline-block;
  white-space: nowrap;
  position: relative;
  min-width: 0;
}
.dx-datagrid-group-panel .dx-block-separator .dx-sort {
  margin-left: 6px;
}
.dx-datagrid-rowsview .dx-row.dx-group-row td {
  border-top: 1px solid;
  border-bottom: 1px solid;
}
.dx-datagrid-rowsview .dx-row.dx-group-row:first-child td {
  border-top: none;
}
.dx-datagrid-rowsview .dx-group-row:focus {
  outline: 0;
}
.dx-datagrid-rowsview .dx-group-row.dx-row > td {
  border-left-color: transparent;
  border-right-color: transparent;
}
.dx-datagrid-rowsview .dx-adaptive-detail-row .dx-field-item-content:focus {
  outline: 0;
}
.dx-datagrid-group-closed,
.dx-datagrid-group-opened {
  cursor: pointer;
  position: relative;
}
.dx-datagrid-group-closed::before,
.dx-datagrid-group-opened::before {
  position: absolute;
  display: block;
  right: 0;
  left: 0;
}
.dx-rtl .dx-datagrid-group-closed {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
.dx-rtl .dx-datagrid-content .dx-datagrid-table .dx-group-row.dx-row.dx-column-lines > td {
  border-left: none;
  border-right: none;
}
.dx-rtl .dx-datagrid-group-panel .dx-block-separator,
.dx-rtl .dx-datagrid-group-panel .dx-group-panel-item {
  margin-right: 0;
}
.dx-rtl .dx-datagrid-group-panel .dx-sort {
  margin-left: 0;
  margin-right: 6px;
}
.dx-datagrid-borders > .dx-datagrid-headers,
.dx-datagrid-borders > .dx-datagrid-rowsview,
.dx-datagrid-borders > .dx-datagrid-total-footer {
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
}
.dx-datagrid-borders > .dx-datagrid-rowsview,
.dx-datagrid-borders > .dx-datagrid-total-footer {
  border-bottom: 1px solid #e0e0e0;
}
.dx-datagrid-borders > .dx-datagrid-filter-panel,
.dx-datagrid-borders > .dx-datagrid-headers {
  border-top: 1px solid #e0e0e0;
}
.dx-datagrid-borders > .dx-datagrid-filter-panel {
  border-top-width: 0;
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
}
.dx-sortable-dragging > div > .dx-gridbase-container > .dx-datagrid-rowsview {
  border-color: rgba(0,150,136,.5);
}
.dx-datagrid .dx-sort-up {
  font: 14px/1 DXIcons;
}
.dx-datagrid .dx-sort-up::before {
  content: "\\f051";
}
.dx-datagrid .dx-sort-down {
  font: 14px/1 DXIcons;
}
.dx-datagrid .dx-sort-down::before {
  content: "\\f052";
}
.dx-datagrid .dx-sort-down,
.dx-datagrid .dx-sort-up {
  font-family: inherit;
}
.dx-datagrid .dx-sort-down::before,
.dx-datagrid .dx-sort-up::before {
  font-family: DXIcons,sans-serif;
}
.dx-datagrid .dx-datagrid-header-panel .dx-group-panel-item,
.dx-datagrid .dx-datagrid-header-panel .dx-header-filter {
  outline: 0;
}
.dx-datagrid .dx-datagrid-header-panel.dx-state-focused .dx-datagrid-group-panel .dx-group-panel-item:focus,
.dx-datagrid .dx-datagrid-header-panel.dx-state-focused .dx-datagrid-group-panel .dx-header-filter:focus {
  outline: #33aba0 solid 2px;
  outline-offset: -2px;
}
.dx-datagrid .dx-datagrid-header-panel.dx-state-focused .dx-datagrid-group-panel .dx-header-filter:focus {
  outline-offset: 2px;
}
.dx-datagrid .dx-datagrid-headers .dx-header-filter,
.dx-datagrid .dx-datagrid-headers .dx-header-row > td {
  outline: 0;
}
.dx-datagrid .dx-datagrid-headers.dx-state-focused .dx-header-row td .dx-header-filter:focus,
.dx-datagrid .dx-datagrid-headers.dx-state-focused .dx-header-row td:focus {
  outline: #33aba0 solid 2px;
  outline-offset: 2px;
}
.dx-datagrid .dx-datagrid-headers.dx-state-focused .dx-header-row td:focus {
  outline-offset: -2px;
}
.dx-datagrid .dx-header-filter {
  position: relative;
  color: rgba(0,0,0,.54);
  font: 14px/1 DXIcons;
}
.dx-datagrid .dx-header-filter::before {
  content: "\\f050";
}
.dx-datagrid .dx-header-filter-empty {
  color: rgba(0,0,0,.38);
}
.dx-datagrid .dx-datagrid-content-fixed .dx-datagrid-table .dx-col-fixed {
  background-color: #fff;
}
.dx-datagrid .dx-datagrid-headers .dx-row td.dx-pointer-events-none,
.dx-datagrid .dx-datagrid-rowsview .dx-data-row td.dx-pointer-events-none,
.dx-datagrid .dx-datagrid-rowsview .dx-freespace-row td.dx-pointer-events-none,
.dx-datagrid .dx-datagrid-rowsview .dx-header-row td.dx-pointer-events-none,
.dx-datagrid .dx-datagrid-rowsview .dx-virtual-row td.dx-pointer-events-none {
  border-left: 2px solid #e0e0e0;
  border-right: 2px solid #e0e0e0;
}
.dx-datagrid .dx-datagrid-headers .dx-row td.dx-pointer-events-none.dx-first-cell,
.dx-datagrid .dx-datagrid-rowsview .dx-data-row td.dx-pointer-events-none.dx-first-cell,
.dx-datagrid .dx-datagrid-rowsview .dx-freespace-row td.dx-pointer-events-none.dx-first-cell,
.dx-datagrid .dx-datagrid-rowsview .dx-header-row td.dx-pointer-events-none.dx-first-cell,
.dx-datagrid .dx-datagrid-rowsview .dx-virtual-row td.dx-pointer-events-none.dx-first-cell {
  border-left: none;
}
.dx-datagrid .dx-datagrid-headers .dx-row td.dx-pointer-events-none.dx-last-cell,
.dx-datagrid .dx-datagrid-rowsview .dx-data-row td.dx-pointer-events-none.dx-last-cell,
.dx-datagrid .dx-datagrid-rowsview .dx-freespace-row td.dx-pointer-events-none.dx-last-cell,
.dx-datagrid .dx-datagrid-rowsview .dx-header-row td.dx-pointer-events-none.dx-last-cell,
.dx-datagrid .dx-datagrid-rowsview .dx-virtual-row td.dx-pointer-events-none.dx-last-cell {
  border-right: none;
}
.dx-datagrid .dx-datagrid-rowsview.dx-state-focused .dx-data-row > td.dx-command-edit > a.dx-link:focus {
  outline: #33aba0 solid 2px;
  outline-offset: 2px;
}
.dx-datagrid .dx-datagrid-rowsview.dx-state-focused .dx-data-row.dx-row-focused > td.dx-command-edit > a.dx-link:focus {
  outline-color: #fff;
  outline-offset: 0;
}
.dx-datagrid .dx-datagrid-rowsview .dx-datagrid-edit-form {
  background-color: #fff;
}
.dx-datagrid .dx-datagrid-rowsview .dx-virtual-row > td {
  position: relative;
}
.dx-datagrid .dx-datagrid-rowsview .dx-virtual-row > td:not(.dx-datagrid-group-space)::before {
  display: block;
  height: 100%;
  content: "";
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAADzCAYAAABwgbOvAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpBRjExRDRGQTNENjQxMUU4QUZEMEE1N0M1QzIyNEE4QyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpBRjExRDRGQjNENjQxMUU4QUZEMEE1N0M1QzIyNEE4QyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkFGMTFENEY4M0Q2NDExRThBRkQwQTU3QzVDMjI0QThDIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkFGMTFENEY5M0Q2NDExRThBRkQwQTU3QzVDMjI0QThDIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+57ApqAAAAUNJREFUeNrs3LENwzAMRUEzi2T/sTSJgowQRAI+pbvehf0KFiZYc84nUVU9AAAAAAAAAHf5/id9+wxLjX8efvl+WQQRBEEEQRBBEEQQBBEEQQAAAAAAAAAAflRuLmaxdSIIggiCIIIgiCAIIgiCIAgAyyUfMBs3BjHUBUEQQRBEEAQRBEEEQRAE6cKyNQAAAAAAAADQQuySw9aXDl6gsAYkCIIIgiCCIIggCCIIgiAIcILkA2Y7xR5HM0MEQRBBEEQQBBEEQQRBEAQBAAAAAAAAAHq78l5WMlsngiCIIAgiCIIIgiCCIAiCALDcrQfMDHUEEQRBBEEQQRAEQQRBEEEAAAAAAAAAALZoecCsqo4NYutEEAQRBEEEQRBBEEQQBEEQAJbresBsGOoIIgiCIIggCCIIggiCIIIAAAAAAAAc5iPAAIcKFwANDofzAAAAAElFTkSuQmCC");
  background-repeat: no-repeat repeat;
}
.dx-datagrid .dx-datagrid-rowsview .dx-virtual-row > td[style*="text-align: right"]::before {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
.dx-datagrid .dx-datagrid-filter-row .dx-filter-range-content {
  color: rgba(0,0,0,.87);
}
.dx-datagrid .dx-error-row td {
  color: #fff;
  padding: 0;
}
.dx-datagrid .dx-column-lines > td:first-child {
  border-left: none;
}
.dx-datagrid .dx-column-lines > td:last-child {
  border-right: none;
}
.dx-datagrid .dx-command-drag .dx-datagrid-drag-icon {
  font: 14px/1 DXIcons;
}
.dx-datagrid .dx-command-drag .dx-datagrid-drag-icon::before {
  content: "\\f038";
}
.dx-datagrid-filter-panel {
  color: rgba(0,0,0,.87);
  border-top: 1px solid #e0e0e0;
}
.dx-datagrid-filter-panel .dx-datagrid-filter-panel-clear-filter,
.dx-datagrid-filter-panel .dx-datagrid-filter-panel-text,
.dx-datagrid-filter-panel .dx-icon-filter {
  outline: 0;
}
.dx-datagrid-filter-panel.dx-state-focused .dx-datagrid-filter-panel-clear-filter:focus,
.dx-datagrid-filter-panel.dx-state-focused .dx-datagrid-filter-panel-text:focus,
.dx-datagrid-filter-panel.dx-state-focused .dx-icon-filter:focus {
  outline: #33aba0 solid 2px;
  outline-offset: 3px;
}
.dx-datagrid-form-buttons-container {
  float: right;
}
.dx-datagrid-form-buttons-container .dx-button {
  margin-left: 10px;
  margin-top: 10px;
}
.dx-datagrid-adaptive-more {
  cursor: pointer;
  font: 21px/21px DXIcons;
}
.dx-datagrid-adaptive-more::before {
  content: "\\f06c";
}
.dx-datagrid-edit-popup .dx-error-message {
  background-color: #f88e86;
  white-space: normal;
  word-wrap: break-word;
  color: #fff;
  margin-bottom: 20px;
}
.dx-rtl .dx-datagrid .dx-datagrid-headers .dx-row td.dx-pointer-events-none,
.dx-rtl .dx-datagrid .dx-datagrid-rowsview .dx-data-row td.dx-pointer-events-none,
.dx-rtl .dx-datagrid .dx-datagrid-rowsview .dx-freespace-row td.dx-pointer-events-none,
.dx-rtl .dx-datagrid .dx-datagrid-rowsview .dx-header-row td.dx-pointer-events-none,
.dx-rtl .dx-datagrid .dx-datagrid-rowsview .dx-virtual-row td.dx-pointer-events-none {
  border-left: 2px solid #e0e0e0;
  border-right: 2px solid #e0e0e0;
}
.dx-rtl .dx-datagrid .dx-datagrid-headers .dx-row td.dx-pointer-events-none.dx-first-cell,
.dx-rtl .dx-datagrid .dx-datagrid-rowsview .dx-data-row td.dx-pointer-events-none.dx-first-cell,
.dx-rtl .dx-datagrid .dx-datagrid-rowsview .dx-freespace-row td.dx-pointer-events-none.dx-first-cell,
.dx-rtl .dx-datagrid .dx-datagrid-rowsview .dx-header-row td.dx-pointer-events-none.dx-first-cell,
.dx-rtl .dx-datagrid .dx-datagrid-rowsview .dx-virtual-row td.dx-pointer-events-none.dx-first-cell {
  border-right: none;
}
.dx-rtl .dx-datagrid .dx-datagrid-headers .dx-row td.dx-pointer-events-none.dx-last-cell,
.dx-rtl .dx-datagrid .dx-datagrid-rowsview .dx-data-row td.dx-pointer-events-none.dx-last-cell,
.dx-rtl .dx-datagrid .dx-datagrid-rowsview .dx-freespace-row td.dx-pointer-events-none.dx-last-cell,
.dx-rtl .dx-datagrid .dx-datagrid-rowsview .dx-header-row td.dx-pointer-events-none.dx-last-cell,
.dx-rtl .dx-datagrid .dx-datagrid-rowsview .dx-virtual-row td.dx-pointer-events-none.dx-last-cell {
  border-left: none;
}
.dx-rtl .dx-datagrid .dx-datagrid-rowsview .dx-virtual-row > td::before {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
.dx-rtl .dx-datagrid .dx-datagrid-rowsview .dx-virtual-row > td[style*="text-align: left"]::before {
  -webkit-transform: scale(1);
  transform: scale(1);
}
.dx-rtl .dx-datagrid .dx-column-lines > td:first-child {
  border-right: none;
  border-left: 1px solid #e0e0e0;
}
.dx-rtl .dx-datagrid .dx-column-lines > td:last-child {
  border-left: none;
  border-right: 1px solid #e0e0e0;
}
.dx-rtl .dx-datagrid-form-buttons-container {
  float: left;
}
.dx-rtl .dx-datagrid-form-buttons-container .dx-button {
  margin-left: 0;
  margin-right: 10px;
}
.dx-datagrid-cell-updated-animation {
  -webkit-animation: 1s dx-datagrid-highlight-change;
  animation: 1s dx-datagrid-highlight-change;
}
@-webkit-keyframes dx-datagrid-highlight-change {
  50%,
  from {
    background-color: rgba(0,0,0,.08);
  }
}
@keyframes dx-datagrid-highlight-change {
  50%,
  from {
    background-color: rgba(0,0,0,.08);
  }
}
.dx-datagrid .dx-menu,
.dx-datagrid-container .dx-menu {
  background-color: transparent;
  height: 100%;
}
.dx-datagrid .dx-menu .dx-menu-item .dx-menu-item-content,
.dx-datagrid-container .dx-menu .dx-menu-item .dx-menu-item-content {
  padding: 11px 4px;
}
.dx-datagrid .dx-menu .dx-menu-item .dx-menu-item-content .dx-icon,
.dx-datagrid-container .dx-menu .dx-menu-item .dx-menu-item-content .dx-icon {
  width: 22px;
  height: 22px;
  background-position: 0 0;
  background-size: 22px 22px;
  padding: 0;
  font-size: 22px;
  text-align: center;
  line-height: 22px;
  margin: 0 3px;
}
.dx-datagrid-container.dx-filter-menu .dx-menu-item-content .dx-icon,
.dx-datagrid.dx-filter-menu .dx-menu-item-content .dx-icon {
  color: rgba(86,86,86,.54);
  width: 18px;
  height: 18px;
  background-position: 0 0;
  background-size: 18px 18px;
  padding: 0;
  font-size: 18px;
  text-align: center;
  line-height: 18px;
}
.dx-datagrid-container.dx-filter-menu .dx-menu-item-content .dx-icon.dx-icon-filter-operation-default,
.dx-datagrid.dx-filter-menu .dx-menu-item-content .dx-icon.dx-icon-filter-operation-default {
  margin-top: 2px;
}
.dx-datagrid .dx-editor-with-menu .dx-menu-item-content,
.dx-datagrid-container .dx-editor-with-menu .dx-menu-item-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.dx-datagrid .dx-editor-with-menu .dx-menu-item-content .dx-icon,
.dx-datagrid-container .dx-editor-with-menu .dx-menu-item-content .dx-icon {
  width: 18px;
  height: 18px;
  background-position: 0 0;
  background-size: 18px 18px;
  padding: 0;
  font-size: 18px;
  text-align: center;
  line-height: 18px;
}
.dx-datagrid .dx-editor-with-menu .dx-menu-item-content .dx-icon.dx-icon-filter-operation-default,
.dx-datagrid-container .dx-editor-with-menu .dx-menu-item-content .dx-icon.dx-icon-filter-operation-default {
  margin-top: 2px;
}
.dx-datagrid .dx-editor-with-menu .dx-texteditor .dx-placeholder::before,
.dx-datagrid .dx-editor-with-menu .dx-texteditor .dx-texteditor-input,
.dx-datagrid-container .dx-editor-with-menu .dx-texteditor .dx-placeholder::before,
.dx-datagrid-container .dx-editor-with-menu .dx-texteditor .dx-texteditor-input {
  padding-left: 40px;
}
.dx-datagrid-container.dx-context-menu .dx-menu-items-container .dx-icon-context-menu-sort-asc,
.dx-datagrid.dx-context-menu .dx-menu-items-container .dx-icon-context-menu-sort-asc {
  font: 18px/18px DXIcons;
  width: 18px;
  height: 18px;
  background-position: 0 0;
  background-size: 18px 18px;
  padding: 0;
  text-align: center;
}
.dx-datagrid-container.dx-context-menu .dx-menu-items-container .dx-icon-context-menu-sort-asc::before,
.dx-datagrid.dx-context-menu .dx-menu-items-container .dx-icon-context-menu-sort-asc::before {
  content: "\\f053";
}
.dx-datagrid-container.dx-context-menu .dx-menu-items-container .dx-icon-context-menu-sort-desc,
.dx-datagrid.dx-context-menu .dx-menu-items-container .dx-icon-context-menu-sort-desc {
  font: 18px/18px DXIcons;
  width: 18px;
  height: 18px;
  background-position: 0 0;
  background-size: 18px 18px;
  padding: 0;
  text-align: center;
}
.dx-datagrid-container.dx-context-menu .dx-menu-items-container .dx-icon-context-menu-sort-desc::before,
.dx-datagrid.dx-context-menu .dx-menu-items-container .dx-icon-context-menu-sort-desc::before {
  content: "\\f054";
}
.dx-datagrid-container.dx-context-menu .dx-menu-items-container .dx-icon-context-menu-sort-none,
.dx-datagrid.dx-context-menu .dx-menu-items-container .dx-icon-context-menu-sort-none {
  width: 18px;
  height: 18px;
  background-position: 0 0;
  background-size: 18px 18px;
  padding: 0;
  font-size: 18px;
  text-align: center;
  line-height: 18px;
}
.dx-datagrid .dx-header-filter,
.dx-datagrid .dx-sort-down,
.dx-datagrid .dx-sort-up,
.dx-datagrid-container .dx-header-filter,
.dx-datagrid-container .dx-sort-down,
.dx-datagrid-container .dx-sort-up {
  width: 15px;
  height: 15px;
  background-position: 0 0;
  background-size: 15px 15px;
  padding: 0;
  font-size: 15px;
  text-align: center;
  line-height: 15px;
}
.dx-datagrid .dx-header-filter:not(.dx-header-filter-empty),
.dx-datagrid-container .dx-header-filter:not(.dx-header-filter-empty) {
  color: #009688;
}
.dx-datagrid .dx-icon-filter-operation-equals,
.dx-datagrid-container .dx-icon-filter-operation-equals {
  font: 14px/1 DXIcons;
}
.dx-datagrid .dx-icon-filter-operation-equals::before,
.dx-datagrid-container .dx-icon-filter-operation-equals::before {
  content: "\\f044";
}
.dx-datagrid .dx-icon-filter-operation-default,
.dx-datagrid-container .dx-icon-filter-operation-default {
  font: 14px/1 DXIcons;
}
.dx-datagrid .dx-icon-filter-operation-default::before,
.dx-datagrid-container .dx-icon-filter-operation-default::before {
  content: "\\f027";
}
.dx-datagrid .dx-icon-filter-operation-not-equals,
.dx-datagrid-container .dx-icon-filter-operation-not-equals {
  font: 14px/1 DXIcons;
}
.dx-datagrid .dx-icon-filter-operation-not-equals::before,
.dx-datagrid-container .dx-icon-filter-operation-not-equals::before {
  content: "\\f045";
}
.dx-datagrid .dx-icon-filter-operation-less,
.dx-datagrid-container .dx-icon-filter-operation-less {
  font: 14px/1 DXIcons;
}
.dx-datagrid .dx-icon-filter-operation-less::before,
.dx-datagrid-container .dx-icon-filter-operation-less::before {
  content: "\\f046";
}
.dx-datagrid .dx-icon-filter-operation-less-equal,
.dx-datagrid-container .dx-icon-filter-operation-less-equal {
  font: 14px/1 DXIcons;
}
.dx-datagrid .dx-icon-filter-operation-less-equal::before,
.dx-datagrid-container .dx-icon-filter-operation-less-equal::before {
  content: "\\f048";
}
.dx-datagrid .dx-icon-filter-operation-greater,
.dx-datagrid-container .dx-icon-filter-operation-greater {
  font: 14px/1 DXIcons;
}
.dx-datagrid .dx-icon-filter-operation-greater::before,
.dx-datagrid-container .dx-icon-filter-operation-greater::before {
  content: "\\f047";
}
.dx-datagrid .dx-icon-filter-operation-greater-equal,
.dx-datagrid-container .dx-icon-filter-operation-greater-equal {
  font: 14px/1 DXIcons;
}
.dx-datagrid .dx-icon-filter-operation-greater-equal::before,
.dx-datagrid-container .dx-icon-filter-operation-greater-equal::before {
  content: "\\f049";
}
.dx-datagrid .dx-icon-filter-operation-contains,
.dx-datagrid-container .dx-icon-filter-operation-contains {
  font: 14px/1 DXIcons;
}
.dx-datagrid .dx-icon-filter-operation-contains::before,
.dx-datagrid-container .dx-icon-filter-operation-contains::before {
  content: "\\f063";
}
.dx-datagrid .dx-icon-filter-operation-not-contains,
.dx-datagrid-container .dx-icon-filter-operation-not-contains {
  font: 14px/1 DXIcons;
}
.dx-datagrid .dx-icon-filter-operation-not-contains::before,
.dx-datagrid-container .dx-icon-filter-operation-not-contains::before {
  content: "\\f066";
}
.dx-datagrid .dx-icon-filter-operation-starts-with,
.dx-datagrid-container .dx-icon-filter-operation-starts-with {
  font: 14px/1 DXIcons;
}
.dx-datagrid .dx-icon-filter-operation-starts-with::before,
.dx-datagrid-container .dx-icon-filter-operation-starts-with::before {
  content: "\\f064";
}
.dx-datagrid .dx-icon-filter-operation-ends-with,
.dx-datagrid-container .dx-icon-filter-operation-ends-with {
  font: 14px/1 DXIcons;
}
.dx-datagrid .dx-icon-filter-operation-ends-with::before,
.dx-datagrid-container .dx-icon-filter-operation-ends-with::before {
  content: "\\f065";
}
.dx-datagrid .dx-icon-filter-operation-between,
.dx-datagrid-container .dx-icon-filter-operation-between {
  font: 14px/1 DXIcons;
}
.dx-datagrid .dx-icon-filter-operation-between::before,
.dx-datagrid-container .dx-icon-filter-operation-between::before {
  content: "\\f06a";
}
.dx-datagrid .dx-column-indicators,
.dx-datagrid-container .dx-column-indicators {
  height: 16px;
}
.dx-datagrid .dx-column-indicators .dx-sort-index-icon,
.dx-datagrid-container .dx-column-indicators .dx-sort-index-icon {
  padding-right: 4px;
  margin-left: -1px;
  font-size: 13px;
  position: relative;
  bottom: 1px;
}
.dx-datagrid .dx-column-indicators > div,
.dx-datagrid-container .dx-column-indicators > div {
  width: 15px;
  height: 15px;
  background-position: 0 0;
  background-size: 15px 15px;
  padding: 0;
  font-size: 15px;
  text-align: center;
  line-height: 15px;
}
.dx-datagrid .dx-placeholder::before,
.dx-datagrid-container .dx-placeholder::before {
  font-size: 14px;
}
.dx-datagrid {
  color: rgba(0,0,0,.87);
  background-color: #fff;
  line-height: inherit;
}
.dx-datagrid .dx-row-alt {
  border-top: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;
}
.dx-datagrid .dx-row-alt > td {
  background-color: #f5f5f5;
}
.dx-datagrid .dx-row-alt.dx-row:not(.dx-row-removed) {
  border-bottom-color: transparent;
}
.dx-datagrid .dx-link {
  text-decoration: underline;
  cursor: pointer;
  color: #009688;
}
.dx-datagrid .dx-row-lines > td {
  border-bottom: 1px solid #e0e0e0;
}
.dx-datagrid .dx-column-lines > td {
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
}
.dx-datagrid .dx-error-row .dx-closebutton {
  float: right;
  margin: 16px;
  font: 14px/14px DXIcons;
  width: 14px;
  height: 14px;
  background-position: 0 0;
  background-size: 14px 14px;
  padding: 0;
  text-align: center;
}
.dx-datagrid .dx-error-row .dx-closebutton::before {
  content: "\\f00a";
}
.dx-datagrid .dx-error-row .dx-error-message {
  background-color: #f88e86;
  white-space: normal;
  word-wrap: break-word;
  padding: 14px 35px 14px 14px;
}
.dx-datagrid .dx-row > td {
  padding: 14px 16px;
  font-size: 14px;
  line-height: 20px;
}
.dx-datagrid .dx-datagrid-table .dx-header-row > td {
  padding-top: 20px;
  padding-bottom: 20px;
}
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending),
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-datagrid-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-datagrid-select-all),
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td:not(.dx-validation-pending):not(.dx-datagrid-select-all) {
  vertical-align: middle;
}
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending).dx-command-select,
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-datagrid-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-datagrid-select-all).dx-command-select,
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td:not(.dx-validation-pending):not(.dx-datagrid-select-all).dx-command-select {
  overflow: visible;
  width: 50px;
  min-width: 50px;
  line-height: 1;
}
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending).dx-command-edit,
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-datagrid-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-datagrid-select-all).dx-command-edit,
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td:not(.dx-validation-pending):not(.dx-datagrid-select-all).dx-command-edit {
  width: 115px;
  min-width: 115px;
}
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending).dx-command-edit.dx-command-edit-with-icons,
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-datagrid-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-datagrid-select-all).dx-command-edit.dx-command-edit-with-icons,
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td:not(.dx-validation-pending):not(.dx-datagrid-select-all).dx-command-edit.dx-command-edit-with-icons {
  width: 93px;
  min-width: 93px;
}
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending).dx-command-edit.dx-command-edit-with-icons .dx-link,
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-datagrid-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-datagrid-select-all).dx-command-edit.dx-command-edit-with-icons .dx-link,
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td:not(.dx-validation-pending):not(.dx-datagrid-select-all).dx-command-edit.dx-command-edit-with-icons .dx-link {
  width: 18px;
  height: 18px;
  background-position: 0 0;
  background-size: 18px 18px;
  padding: 0;
  font-size: 18px;
  text-align: center;
  line-height: 18px;
  margin: 0 2px;
  vertical-align: middle;
}
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending).dx-command-edit.dx-command-edit-with-icons .dx-link:not(.dx-link-icon),
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-datagrid-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-datagrid-select-all).dx-command-edit.dx-command-edit-with-icons .dx-link:not(.dx-link-icon),
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td:not(.dx-validation-pending):not(.dx-datagrid-select-all).dx-command-edit.dx-command-edit-with-icons .dx-link:not(.dx-link-icon) {
  width: auto;
}
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending).dx-command-edit .dx-link.dx-state-disabled,
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-datagrid-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-datagrid-select-all).dx-command-edit .dx-link.dx-state-disabled,
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td:not(.dx-validation-pending):not(.dx-datagrid-select-all).dx-command-edit .dx-link.dx-state-disabled {
  opacity: .38;
}
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending).dx-command-edit .dx-link.dx-state-disabled.dx-link-icon,
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-datagrid-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-datagrid-select-all).dx-command-edit .dx-link.dx-state-disabled.dx-link-icon,
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td:not(.dx-validation-pending):not(.dx-datagrid-select-all).dx-command-edit .dx-link.dx-state-disabled.dx-link-icon {
  opacity: .6;
}
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending) .dx-datagrid-group-space,
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending).dx-command-expand,
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-datagrid-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-datagrid-select-all) .dx-datagrid-group-space,
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-datagrid-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-datagrid-select-all).dx-command-expand,
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td:not(.dx-validation-pending):not(.dx-datagrid-select-all) .dx-datagrid-group-space,
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td:not(.dx-validation-pending):not(.dx-datagrid-select-all).dx-command-expand {
  padding: 0 4px 0 8px;
  line-height: 0;
}
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending).dx-editor-cell:not(.dx-command-select),
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-datagrid-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-datagrid-select-all).dx-editor-cell:not(.dx-command-select),
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td:not(.dx-validation-pending):not(.dx-datagrid-select-all).dx-editor-cell:not(.dx-command-select) {
  padding-right: 0;
  padding-left: 0;
}
.dx-datagrid .dx-datagrid-rowsview .dx-virtual-row > td[style*="text-align: right"]:before {
  background-position-y: 49px;
}
.dx-datagrid .dx-command-drag {
  width: 56px;
  min-width: 56px;
}
.dx-datagrid .dx-command-drag .dx-datagrid-drag-icon {
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  font-size: 24px;
  text-align: center;
  line-height: 24px;
}
.dx-datagrid-edit-popup .dx-popup-content {
  padding: 0;
}
.dx-datagrid-edit-popup .dx-error-message {
  padding: 14px 16px;
}
.dx-datagrid-edit-popup-form {
  padding: 24px;
}
.dx-datagrid-headers .dx-texteditor-input,
.dx-datagrid-rowsview .dx-texteditor-input {
  min-height: 16px;
}
.dx-datagrid-headers .dx-lookup,
.dx-datagrid-rowsview .dx-lookup {
  height: auto;
}
.dx-datagrid-headers .dx-lookup .dx-lookup-field,
.dx-datagrid-rowsview .dx-lookup .dx-lookup-field {
  padding-left: 16px;
  padding-top: 14px;
  padding-bottom: 14px;
  font-size: 14px;
}
.dx-datagrid-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-invalid .dx-texteditor-input,
.dx-datagrid-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-valid .dx-texteditor-input,
.dx-datagrid-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-validation-pending .dx-texteditor-input,
.dx-datagrid-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-invalid .dx-texteditor-input,
.dx-datagrid-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-valid .dx-texteditor-input,
.dx-datagrid-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-validation-pending .dx-texteditor-input {
  padding-right: 34px;
}
.dx-datagrid-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-invalid.dx-rtl .dx-texteditor-input,
.dx-datagrid-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-valid.dx-rtl .dx-texteditor-input,
.dx-datagrid-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-validation-pending.dx-rtl .dx-texteditor-input,
.dx-datagrid-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-invalid.dx-rtl .dx-texteditor-input,
.dx-datagrid-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-valid.dx-rtl .dx-texteditor-input,
.dx-datagrid-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-validation-pending.dx-rtl .dx-texteditor-input {
  padding-right: 0;
  padding-left: 34px;
}
.dx-datagrid-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-invalid .dx-texteditor-input,
.dx-datagrid-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-valid .dx-texteditor-input,
.dx-datagrid-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-validation-pending .dx-texteditor-input,
.dx-datagrid-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-invalid .dx-texteditor-input,
.dx-datagrid-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-valid .dx-texteditor-input,
.dx-datagrid-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-validation-pending .dx-texteditor-input {
  padding-right: 34px;
}
.dx-datagrid-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-invalid.dx-rtl .dx-texteditor-input,
.dx-datagrid-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-valid.dx-rtl .dx-texteditor-input,
.dx-datagrid-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-validation-pending.dx-rtl .dx-texteditor-input,
.dx-datagrid-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-invalid.dx-rtl .dx-texteditor-input,
.dx-datagrid-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-valid.dx-rtl .dx-texteditor-input,
.dx-datagrid-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-validation-pending.dx-rtl .dx-texteditor-input {
  padding-right: 0;
  padding-left: 34px;
}
.dx-datagrid-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-rtl .dx-texteditor-input,
.dx-datagrid-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-rtl .dx-texteditor-input {
  padding-right: 0;
}
.dx-datagrid-column-chooser-list .dx-empty-message {
  color: rgba(102,102,102,.87);
  padding: 0 24px;
}
.dx-datagrid-column-chooser {
  color: rgba(0,0,0,.87);
  font-weight: 400;
  font-size: 14px;
  font-family: Roboto,RobotoFallback,"Noto Kufi Arabic",Helvetica,Arial,sans-serif;
  line-height: 1.2857;
}
.dx-datagrid-column-chooser input,
.dx-datagrid-column-chooser textarea {
  font-family: Roboto,RobotoFallback,"Noto Kufi Arabic",Helvetica,Arial,sans-serif;
  line-height: 1.2857;
}
.dx-datagrid-column-chooser.dx-datagrid-column-chooser-mode-drag .dx-popup-content {
  padding: 16px 24px 9px;
}
.dx-datagrid-column-chooser.dx-datagrid-column-chooser-mode-drag .dx-popup-content .dx-treeview-search {
  margin-bottom: 10px;
}
.dx-datagrid-column-chooser.dx-datagrid-column-chooser-mode-drag .dx-popup-content .dx-treeview-node {
  padding-left: 20px;
}
.dx-datagrid-column-chooser.dx-datagrid-column-chooser-mode-select .dx-popup-content {
  padding: 16px 24px 9px;
}
.dx-datagrid-column-chooser .dx-overlay-content {
  background-color: #fff;
}
.dx-datagrid-column-chooser .dx-overlay-content .dx-popup-title {
  background-color: transparent;
  border-bottom: 1px solid #e0e0e0;
}
.dx-datagrid-column-chooser .dx-overlay-content .dx-popup-title .dx-toolbar-label {
  font-size: 20px;
}
.dx-datagrid-column-chooser .dx-overlay-content .dx-popup-content .dx-column-chooser-item {
  margin: 2px 2px 8px;
  background-color: #fff;
  color: rgba(0,0,0,.54);
  font-weight: 500;
  font-size: 14px;
  padding: 14px;
  line-height: 16px;
  -webkit-box-shadow: 0 0 1px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.2);
  box-shadow: 0 0 1px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.2);
}
.dx-datagrid-drag-header {
  border-color: rgba(0,150,136,.5);
  -webkit-box-shadow: 0 0 1px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.2);
  box-shadow: 0 0 1px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.2);
  color: rgba(0,0,0,.54);
  font-weight: 500;
  padding: 20px;
  background-color: #fff;
  line-height: 16px;
  font-size: 14px;
}
.dx-datagrid-columns-separator {
  background-color: rgba(0,150,136,.5);
}
.dx-datagrid-columns-separator-transparent {
  background-color: transparent;
}
.dx-datagrid-drop-highlight > td {
  background-color: #009688;
  color: #fff;
}
.dx-datagrid-drop-highlight > td .dx-header-filter {
  color: #fff;
}
.dx-datagrid-drop-highlight > td .dx-checkbox .dx-checkbox-icon {
  background-color: #fff;
  color: #009688;
}
.dx-datagrid-focus-overlay:after {
  content: "";
  position: absolute;
  bottom: 0;
  height: 2px;
  background-color: #33aba0;
  left: 0;
  right: 1px;
}
.dx-data-row.dx-state-hover:not(.dx-selection):not(.dx-row-inserted):not(.dx-row-removed):not(.dx-edit-row):not(.dx-row-focused) > .dx-datagrid-readonly .dx-texteditor .dx-texteditor-input {
  background-color: rgba(0,0,0,.04);
  color: rgba(0,0,0,.87);
}
.dx-datagrid-headers {
  color: rgba(0,0,0,.54);
  -ms-touch-action: pinch-zoom;
  touch-action: pinch-zoom;
  border-bottom: 1px solid #e0e0e0;
}
.dx-datagrid-headers .dx-datagrid-content {
  margin-bottom: -1px;
}
.dx-datagrid-borders .dx-datagrid-headers .dx-datagrid-table {
  border-bottom-width: 1px;
}
.dx-datagrid-headers .dx-datagrid-table .dx-row > td {
  border-bottom: 1px solid #e0e0e0;
  line-height: 16px;
  font-weight: 500;
  font-size: 14px;
}
.dx-datagrid-headers .dx-datagrid-table .dx-row>td .dx-sort,
.dx-datagrid-headers .dx-datagrid-table .dx-row>td .dx-sort-indicator,
.dx-datagrid-headers .dx-datagrid-table .dx-row>td:hover .dx-datagrid-text-content {
  color: rgba(0,0,0,.87);
}
.dx-datagrid-headers .dx-datagrid-table .dx-row > td:hover .dx-sort {
  color: rgba(0,0,0,.38);
}
.dx-datagrid-headers .dx-datagrid-table .dx-row > td:hover:not(.dx-command-select):not(.dx-command-expand):not(.dx-editor-cell):not(.dx-command-edit):not(.dx-datagrid-group-space) {
  background-color: rgba(0,0,0,.04);
}
.dx-datagrid-headers.dx-header-multi-row .dx-datagrid-content .dx-datagrid-table .dx-row.dx-header-row .dx-command-select {
  padding-bottom: 19px;
}
.dx-datagrid-headers.dx-header-multi-row .dx-datagrid-content .dx-datagrid-table .dx-row.dx-header-row > td {
  padding-top: 12px;
  padding-bottom: 12px;
  vertical-align: bottom;
  border-right: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
}
.dx-datagrid-headers.dx-header-multi-row .dx-datagrid-content .dx-datagrid-table .dx-row.dx-header-row > td:first-child {
  border-left: none;
}
.dx-datagrid-headers.dx-header-multi-row .dx-datagrid-content .dx-datagrid-table .dx-row.dx-header-row > td:last-child {
  border-right: none;
}
.dx-datagrid-filter-row {
  background-color: #fafafa;
}
.dx-datagrid-filter-row .dx-menu {
  margin-left: 0;
}
.dx-datagrid-filter-row .dx-menu .dx-menu-horizontal .dx-menu-items-container {
  height: 100%;
  top: 2px;
  position: absolute;
}
.dx-datagrid-filter-row .dx-menu .dx-menu-horizontal .dx-menu-items-container .dx-menu-item-wrapper {
  height: 100%;
}
.dx-datagrid-filter-row .dx-menu .dx-overlay-content {
  color: rgba(117,117,117,.87);
}
.dx-datagrid-filter-row .dx-filter-modified {
  background-color: rgba(139,195,74,.32);
}
.dx-datagrid-filter-row td .dx-editor-container .dx-filter-range-content {
  padding: 14px 16px 14px 40px;
}
.dx-datagrid .dx-datagrid-table .dx-datagrid-filter-row > td {
  padding-top: 0;
  padding-bottom: 0;
}
.dx-datagrid-filter-range-overlay .dx-overlay-content {
  overflow: inherit;
  background-color: #fafafa;
  -webkit-box-shadow: 0 0 1px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.2);
  box-shadow: 0 0 1px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.2);
}
.dx-datagrid-filter-range-overlay .dx-overlay-content .dx-texteditor.dx-state-focused::after,
.dx-datagrid-filter-range-overlay .dx-overlay-content .dx-texteditor.dx-state-hover::after {
  top: auto;
  bottom: 0;
}
.dx-datagrid-filter-range-overlay .dx-overlay-content .dx-texteditor .dx-texteditor-input {
  font-size: 14px;
  height: 49px;
  padding-right: 12px;
  padding-left: 12px;
}
.dx-datagrid-filter-range-overlay .dx-overlay-content .dx-texteditor .dx-placeholder::before {
  padding-left: 12px;
}
.dx-datagrid-filter-range-overlay .dx-overlay-content .dx-invalid-message.dx-overlay-wrapper {
  display: none;
}
.dx-cell-modified,
.dx-datagrid-invalid {
  padding: 14px 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dx-datagrid-header-panel {
  border-bottom: 1px solid #e0e0e0;
  padding: 0 16px;
  background-color: #fff;
}
.dx-datagrid-header-panel .dx-apply-button {
  background-color: transparent;
  color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-datagrid-header-panel .dx-apply-button .dx-icon {
  color: #fff;
}
.dx-datagrid-header-panel .dx-apply-button.dx-state-focused,
.dx-datagrid-header-panel .dx-apply-button.dx-state-hover {
  background-color: rgba(139,195,74,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-datagrid-header-panel .dx-apply-button.dx-state-active {
  background-color: rgba(139,195,74,.36);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-datagrid-header-panel .dx-apply-button.dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-datagrid-header-panel .dx-apply-button.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-datagrid-header-panel .dx-apply-button.dx-state-disabled .dx-button-text,
.dx-datagrid-header-panel .dx-apply-button.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-datagrid-header-panel .dx-apply-button .dx-inkripple-wave {
  background-color: rgba(255,255,255,.2);
}
.dx-datagrid-header-panel .dx-toolbar-text-auto-hide .dx-button.dx-button-has-icon {
  border-radius: 50%;
}
.dx-datagrid-header-panel .dx-datagrid-toolbar-button .dx-icon {
  color: rgba(0,0,0,.87);
}
.dx-datagrid-addrow-button .dx-icon-edit-button-addrow {
  font: 24px/24px DXIcons;
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  text-align: center;
}
.dx-datagrid-addrow-button .dx-icon-edit-button-addrow::before {
  content: "\\f00b";
}
.dx-datagrid-cancel-button .dx-icon-edit-button-cancel {
  font: 24px/24px DXIcons;
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  text-align: center;
}
.dx-datagrid-cancel-button .dx-icon-edit-button-cancel::before {
  content: "\\f04c";
}
.dx-datagrid-save-button .dx-icon-edit-button-save {
  font: 24px/24px DXIcons;
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  text-align: center;
}
.dx-datagrid-save-button .dx-icon-edit-button-save::before {
  content: "\\f041";
}
.dx-datagrid-adaptive-more {
  vertical-align: middle;
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  font-size: 24px;
  text-align: center;
  line-height: 24px;
  color: rgba(0,0,0,.54);
}
.dx-row.dx-row-focused .dx-datagrid-adaptive-more {
  color: inherit;
}
.dx-datagrid-rowsview {
  border-top: 1px solid #e0e0e0;
}
.dx-datagrid-headers + .dx-datagrid-rowsview,
.dx-datagrid-rowsview.dx-datagrid-after-headers {
  border-top: none;
}
.dx-datagrid-rowsview .dx-row {
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
}
.dx-datagrid-rowsview .dx-row:focus {
  outline: 0;
}
.dx-datagrid-rowsview .dx-row.dx-edit-row:first-child > td {
  border-top-width: 0;
  border-bottom: 1px solid #e0e0e0;
}
.dx-datagrid-rowsview .dx-row.dx-edit-row > td {
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
}
.dx-datagrid-rowsview .dx-master-detail-row > .dx-master-detail-cell {
  padding: 16px;
}
.dx-datagrid-rowsview .dx-master-detail-row .dx-master-detail-cell,
.dx-datagrid-rowsview .dx-master-detail-row > .dx-datagrid-group-space {
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
}
.dx-datagrid-rowsview .dx-master-detail-row:not(.dx-datagrid-edit-form) .dx-master-detail-cell,
.dx-datagrid-rowsview .dx-master-detail-row:not(.dx-datagrid-edit-form) > .dx-datagrid-group-space {
  background-color: #fafafa;
}
.dx-datagrid-rowsview .dx-adaptive-detail-row.dx-selection:hover:not(.dx-edit-row) .dx-cell-modified,
.dx-datagrid-rowsview .dx-adaptive-detail-row.dx-selection:not(.dx-edit-row) .dx-cell-modified,
.dx-datagrid-rowsview .dx-adaptive-detail-row:not(.dx-edit-row) .dx-cell-modified,
.dx-datagrid-rowsview .dx-data-row.dx-selection:hover:not(.dx-edit-row) .dx-cell-modified,
.dx-datagrid-rowsview .dx-data-row.dx-selection:not(.dx-edit-row) .dx-cell-modified,
.dx-datagrid-rowsview .dx-data-row:not(.dx-edit-row) .dx-cell-modified {
  background-color: rgba(139,195,74,.32);
}
.dx-datagrid-rowsview .dx-adaptive-detail-row .dx-validator.dx-datagrid-invalid,
.dx-datagrid-rowsview .dx-adaptive-detail-row .dx-validator.dx-invalid,
.dx-datagrid-rowsview .dx-adaptive-detail-row.dx-selection .dx-validator.dx-datagrid-invalid,
.dx-datagrid-rowsview .dx-adaptive-detail-row.dx-selection .dx-validator.dx-invalid,
.dx-datagrid-rowsview .dx-adaptive-detail-row.dx-selection:hover .dx-validator.dx-datagrid-invalid,
.dx-datagrid-rowsview .dx-adaptive-detail-row.dx-selection:hover .dx-validator.dx-invalid,
.dx-datagrid-rowsview .dx-data-row .dx-validator.dx-datagrid-invalid,
.dx-datagrid-rowsview .dx-data-row .dx-validator.dx-invalid,
.dx-datagrid-rowsview .dx-data-row.dx-selection .dx-validator.dx-datagrid-invalid,
.dx-datagrid-rowsview .dx-data-row.dx-selection .dx-validator.dx-invalid,
.dx-datagrid-rowsview .dx-data-row.dx-selection:hover .dx-validator.dx-datagrid-invalid,
.dx-datagrid-rowsview .dx-data-row.dx-selection:hover .dx-validator.dx-invalid {
  background-color: rgba(244,67,54,.32);
}
.dx-datagrid-rowsview .dx-overlay-wrapper.dx-invalid-message .dx-overlay-content {
  padding: 9px 17px;
  background-color: #f44336;
  color: #fff;
}
.dx-datagrid-rowsview .dx-row-removed > td {
  background-color: #e0e0e0;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  color: rgba(0,0,0,.54);
}
.dx-datagrid-rowsview .dx-adaptive-detail-row .dx-field-item-label {
  padding-top: 0;
}
.dx-datagrid-rowsview .dx-adaptive-detail-row .dx-field-item-content {
  line-height: 40px;
  min-height: 40px;
  font-size: 14px;
}
.dx-datagrid-rowsview .dx-adaptive-detail-row .dx-field-item-content.dx-focused {
  padding: 0;
}
.dx-datagrid-rowsview .dx-adaptive-detail-row .dx-texteditor-input {
  font-size: 14px;
  height: 40px;
  line-height: 40px;
}
.dx-datagrid-rowsview .dx-adaptive-detail-row .dx-texteditor::after,
.dx-datagrid-rowsview .dx-adaptive-detail-row .dx-texteditor::before {
  content: none;
}
.dx-datagrid-rowsview .dx-adaptive-detail-row .dx-texteditor.dx-editor-outlined {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-datagrid-rowsview .dx-item-modified {
  background-color: rgba(139,195,74,.32);
}
.dx-datagrid-rowsview .dx-row-focused.dx-data-row .dx-command-edit .dx-link,
.dx-datagrid-rowsview .dx-row-focused.dx-data-row > td:not(.dx-focused):not(.dx-cell-modified) {
  background-color: #33aba0;
  color: #fff;
}
.dx-datagrid-rowsview .dx-row-focused.dx-data-row .dx-command-edit .dx-link .dx-datagrid-group-closed,
.dx-datagrid-rowsview .dx-row-focused.dx-data-row .dx-command-edit .dx-link .dx-datagrid-group-opened,
.dx-datagrid-rowsview .dx-row-focused.dx-data-row > td:not(.dx-focused):not(.dx-cell-modified) .dx-datagrid-group-closed,
.dx-datagrid-rowsview .dx-row-focused.dx-data-row > td:not(.dx-focused):not(.dx-cell-modified) .dx-datagrid-group-opened {
  color: #fff;
}
.dx-datagrid-rowsview .dx-row-focused.dx-data-row .dx-command-edit .dx-link:focus {
  background-color: #fff;
  color: #009688;
}
.dx-datagrid-rowsview .dx-row-focused.dx-data-row > td,
.dx-datagrid-rowsview .dx-row-focused.dx-data-row > tr:last-child > td {
  border-bottom: 2px solid #33aba0;
}
.dx-datagrid-rowsview .dx-row-focused.dx-data-row:not(.dx-row-lines) > td,
.dx-datagrid-rowsview .dx-row-focused.dx-data-row:not(.dx-row-lines) > tr:first-child > td {
  border-top: 1px solid #33aba0;
  border-bottom: 1px solid #33aba0;
}
.dx-datagrid-rowsview .dx-row-focused.dx-data-row.dx-edit-row > td.dx-editor-cell:not(.dx-command-select),
.dx-datagrid-rowsview .dx-row-focused.dx-data-row.dx-edit-row > tr > td.dx-editor-cell:not(.dx-command-select) {
  background-color: #fff;
  color: rgba(0,0,0,.87);
}
.dx-datagrid-rowsview .dx-row-focused.dx-group-row {
  background-color: #33aba0;
  color: #fff;
}
.dx-datagrid-rowsview .dx-row-focused.dx-group-row .dx-datagrid-group-closed,
.dx-datagrid-rowsview .dx-row-focused.dx-group-row .dx-datagrid-group-opened {
  color: #fff;
}
.dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused) > td,
.dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused) > tr > td,
.dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover > td,
.dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover > tr > td {
  background-color: rgba(0,150,136,.04);
  color: rgba(0,0,0,.87);
}
.dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused) > td.dx-datagrid-group-space,
.dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused) > tr > td.dx-datagrid-group-space,
.dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover > td.dx-datagrid-group-space,
.dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover > tr > td.dx-datagrid-group-space {
  border-right-color: rgba(0,150,136,.04);
}
.dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused) > td.dx-pointer-events-none,
.dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused) > tr > td.dx-pointer-events-none,
.dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover > td.dx-pointer-events-none,
.dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover > tr > td.dx-pointer-events-none {
  border-left-color: #e0e0e0;
  border-right-color: #e0e0e0;
}
.dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover:not(.dx-row-lines) > td,
.dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused):not(.dx-row-lines) > td {
  border-bottom: 1px solid rgba(0,150,136,.04);
  border-top: 1px solid rgba(0,150,136,.04);
}
.dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused).dx-row-lines > td,
.dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover.dx-row-lines > td {
  border-bottom-color: #e0e0e0;
}
.dx-datagrid-rowsview.dx-scrollable-scrollbars-alwaysvisible.dx-scrollable-both .dx-scrollable-wrapper .dx-scrollable-container .dx-scrollable-content {
  padding-right: 0;
}
.dx-datagrid-rowsview td.dx-validation-pending {
  position: relative;
  padding: 0;
}
.dx-datagrid-rowsview td.dx-validation-pending .dx-datagrid-invalid,
.dx-datagrid-rowsview td.dx-validation-pending.dx-cell-modified {
  padding: 14px 46px 14px 16px;
}
.dx-rtl .dx-datagrid-rowsview td.dx-validation-pending .dx-datagrid-invalid,
.dx-rtl .dx-datagrid-rowsview td.dx-validation-pending.dx-cell-modified,
.dx-rtl.dx-datagrid-rowsview td.dx-validation-pending .dx-datagrid-invalid,
.dx-rtl.dx-datagrid-rowsview td.dx-validation-pending.dx-cell-modified {
  padding-left: 46px;
  padding-right: 16px;
}
.dx-datagrid-rowsview td.dx-validation-pending > .dx-pending-indicator {
  pointer-events: none;
  position: absolute;
  top: 50%;
  margin-top: -11px;
  width: 22px;
  height: 22px;
  right: 22px;
  background-color: transparent;
}
.dx-rtl .dx-datagrid-rowsview td.dx-validation-pending > .dx-pending-indicator,
.dx-rtl.dx-datagrid-rowsview td.dx-validation-pending > .dx-pending-indicator {
  right: auto;
  left: 22px;
}
.dx-datagrid-search-text {
  color: #fff;
  background-color: #009688;
}
.dx-datagrid-nodata {
  color: rgba(102,102,102,.87);
  font-size: 17px;
}
.dx-datagrid-bottom-load-panel {
  border-top: 1px solid #e0e0e0;
  background-color: #fff;
}
.dx-datagrid-summary-item {
  color: rgba(0,0,0,.7);
}
.dx-datagrid-total-footer {
  position: relative;
  border-bottom: 1px solid #e0e0e0;
  border-top: 1px solid #e0e0e0;
}
.dx-datagrid-total-footer > .dx-datagrid-content {
  padding: 0;
}
.dx-datagrid-revert-tooltip .dx-overlay-content {
  background-color: transparent;
  min-width: inherit;
}
.dx-datagrid-revert-tooltip .dx-revert-button {
  border-radius: 4px;
  background-color: #f44336;
  color: #fff;
  -webkit-box-shadow: none;
  margin: 0 0 0 1px;
  height: 48px;
  box-shadow: none;
  min-width: inherit;
}
.dx-datagrid-revert-tooltip .dx-revert-button .dx-button-content {
  padding: 2px;
}
.dx-datagrid-revert-tooltip .dx-revert-button .dx-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
  margin-right: 0;
  margin-left: 0;
  color: #fff;
}
.dx-datagrid-revert-tooltip .dx-revert-button .dx-icon.dx-icon-right,
.dx-rtl .dx-datagrid-revert-tooltip .dx-revert-button .dx-icon,
.dx-rtl.dx-datagrid-revert-tooltip .dx-revert-button .dx-icon {
  margin-left: 0;
  margin-right: 0;
}
.dx-rtl .dx-datagrid-revert-tooltip .dx-revert-button .dx-icon.dx-icon-right,
.dx-rtl.dx-datagrid-revert-tooltip .dx-revert-button .dx-icon.dx-icon-right {
  margin-right: 0;
  margin-left: 0;
}
.dx-datagrid-revert-tooltip .dx-revert-button.dx-state-active,
.dx-datagrid-revert-tooltip .dx-revert-button.dx-state-focused,
.dx-datagrid-revert-tooltip .dx-revert-button.dx-state-hover {
  background-color: #f44336;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-datagrid-revert-tooltip .dx-revert-button.dx-state-disabled {
  background: rgba(0,0,0,.1);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-datagrid-revert-tooltip .dx-revert-button.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-datagrid-revert-tooltip .dx-revert-button.dx-state-disabled .dx-button-text,
.dx-datagrid-revert-tooltip .dx-revert-button.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-datagrid-revert-tooltip .dx-revert-button .dx-inkripple-wave {
  background-color: rgba(255,255,255,.2);
}
.dx-datagrid-revert-tooltip .dx-revert-button.dx-button-has-icon:not(.dx-button-has-text) {
  border-radius: 2px;
}
.dx-datagrid-revert-tooltip .dx-revert-button.dx-state-hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-rtl .dx-data-row.dx-state-hover:not(.dx-selection):not(.dx-row-inserted):not(.dx-row-removed):not(.dx-edit-row):not(.dx-row-focused) > td:not(.dx-focused).dx-datagrid-group-space {
  border-left-color: rgba(0,0,0,.04);
  border-right-color: transparent;
}
.dx-rtl .dx-datagrid .dx-menu .dx-menu-item-has-submenu.dx-menu-item-has-icon .dx-icon,
.dx-rtl .dx-datagrid-container .dx-menu .dx-menu-item-has-submenu.dx-menu-item-has-icon .dx-icon {
  margin: 0 3px;
}
.dx-rtl .dx-datagrid-rowsview .dx-selection.dx-row > td,
.dx-rtl .dx-datagrid-rowsview .dx-selection.dx-row > tr > td,
.dx-rtl .dx-datagrid-rowsview .dx-selection.dx-row:hover > td,
.dx-rtl .dx-datagrid-rowsview .dx-selection.dx-row:hover > tr > td {
  border-right-color: #e0e0e0;
}
.dx-rtl .dx-datagrid-rowsview .dx-selection.dx-row > td:not(.dx-focused).dx-datagrid-group-space,
.dx-rtl .dx-datagrid-rowsview .dx-selection.dx-row > tr > td:not(.dx-focused).dx-datagrid-group-space,
.dx-rtl .dx-datagrid-rowsview .dx-selection.dx-row:hover > td:not(.dx-focused).dx-datagrid-group-space,
.dx-rtl .dx-datagrid-rowsview .dx-selection.dx-row:hover > tr > td:not(.dx-focused).dx-datagrid-group-space {
  border-left-color: rgba(0,150,136,.04);
}
.dx-rtl .dx-datagrid-rowsview .dx-selection.dx-row > td.dx-pointer-events-none,
.dx-rtl .dx-datagrid-rowsview .dx-selection.dx-row > tr > td.dx-pointer-events-none,
.dx-rtl .dx-datagrid-rowsview .dx-selection.dx-row:hover > td.dx-pointer-events-none,
.dx-rtl .dx-datagrid-rowsview .dx-selection.dx-row:hover > tr > td.dx-pointer-events-none {
  border-left-color: #e0e0e0;
}
.dx-rtl .dx-datagrid-rowsview.dx-scrollable-scrollbars-alwaysvisible.dx-scrollable-both .dx-scrollable-wrapper .dx-scrollable-container .dx-scrollable-content {
  padding-left: 0;
}
.dx-datagrid-form-buttons-container .dx-button {
  background-color: transparent;
  color: #009688;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-datagrid-form-buttons-container .dx-button .dx-icon {
  color: #009688;
}
.dx-datagrid-form-buttons-container .dx-button.dx-state-focused,
.dx-datagrid-form-buttons-container .dx-button.dx-state-hover {
  background-color: rgba(0,150,136,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-datagrid-form-buttons-container .dx-button.dx-state-active {
  background-color: rgba(0,150,136,.36);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-datagrid-form-buttons-container .dx-button.dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-datagrid-form-buttons-container .dx-button.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-datagrid-form-buttons-container .dx-button.dx-state-disabled .dx-button-text,
.dx-datagrid-form-buttons-container .dx-button.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-datagrid-form-buttons-container .dx-button .dx-inkripple-wave {
  background-color: rgba(0,150,136,.2);
}
.dx-datagrid-filter-panel {
  padding: 18px 16px;
}
.dx-datagrid-filter-panel .dx-datagrid-filter-panel-clear-filter,
.dx-datagrid-filter-panel .dx-datagrid-filter-panel-text {
  color: #009688;
  font-size: 14px;
  line-height: 18px;
}
.dx-datagrid-filter-panel .dx-icon-filter {
  color: #009688;
}
.dx-adaptive-item-text.dx-cell-modified,
.dx-adaptive-item-text.dx-datagrid-invalid {
  padding-top: 0;
  padding-bottom: 0;
}
.dx-datagrid-group-panel {
  font-size: 14px;
  -ms-touch-action: pinch-zoom;
  touch-action: pinch-zoom;
}
.dx-datagrid-group-panel .dx-group-panel-message {
  color: rgba(0,0,0,.54);
  font-weight: 500;
  padding: 7px 0;
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
}
.dx-datagrid-group-panel .dx-group-panel-item {
  margin-right: 10px;
  color: rgba(0,0,0,.54);
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  background: #e0e0e0;
  border-radius: 16px;
  padding: 8px 10px;
}
.dx-datagrid-group-panel .dx-block-separator {
  margin-right: 10px;
  color: rgba(0,0,0,.54);
  font-weight: 500;
  padding: 7px;
  background-color: #e0e0e0;
}
.dx-datagrid-group-panel .dx-sort {
  color: rgba(86,86,86,.54);
}
.dx-datagrid-rowsview .dx-row.dx-group-row:first-child {
  border-top: none;
}
.dx-datagrid-rowsview .dx-row.dx-group-row {
  font-size: 14px;
  font-weight: 700;
}
.dx-datagrid-rowsview .dx-row.dx-group-row:not(.dx-row-focused) {
  color: rgba(0,0,0,.54);
  background-color: #fff;
}
.dx-datagrid-rowsview .dx-row.dx-group-row td {
  border-top-color: #e0e0e0;
  border-bottom-color: #e0e0e0;
}
.dx-datagrid-group-opened {
  font: 24px/24px DXIcons;
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  text-align: center;
  color: rgba(98,98,98,.54);
}
.dx-datagrid-group-opened::before {
  content: "\\f016";
}
.dx-datagrid-group-closed {
  font: 24px/24px DXIcons;
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  text-align: center;
  color: rgba(98,98,98,.54);
}
.dx-datagrid-group-closed::before {
  content: "\\f010";
}
.dx-row.dx-datagrid-group-footer.dx-column-lines {
  border-bottom: 1px solid #e0e0e0;
}
.dx-row.dx-datagrid-group-footer > td {
  background-color: #fff;
  border-top: 1px solid #e0e0e0;
  border-left-width: 0;
  border-right-width: 0;
}
.dx-rtl .dx-datagrid-group-panel .dx-block-separator,
.dx-rtl .dx-datagrid-group-panel .dx-group-panel-item {
  margin-left: 10px;
}
.dx-treelist-important-margin {
  margin-right: 5px!important;
}
.dx-treelist-table {
  background-color: transparent;
}
.dx-treelist-borders > .dx-treelist-total-footer {
  border-top: 0;
}
.dx-treelist-borders > .dx-treelist-pager {
  margin-top: -1px;
}
.dx-treelist-borders > .dx-treelist-header-panel {
  border-bottom: 0;
}
.dx-treelist-borders > .dx-treelist-rowsview.dx-last-row-border tbody:last-child > .dx-data-row:nth-last-child(2) > td {
  border-bottom-width: 0;
}
.dx-treelist .dx-treelist-content-fixed {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 2;
  pointer-events: none;
  overflow: hidden;
}
.dx-treelist .dx-treelist-content-fixed .dx-treelist-table {
  position: relative;
}
.dx-treelist .dx-treelist-content-fixed .dx-treelist-table td {
  pointer-events: auto;
}
.dx-treelist .dx-treelist-content-fixed .dx-treelist-table .dx-row td.dx-pointer-events-none {
  visibility: hidden;
  background-color: transparent;
  pointer-events: none;
  border-top-color: transparent;
  border-bottom-color: transparent;
}
.dx-treelist .dx-treelist-content-fixed .dx-treelist-table .dx-header-row td.dx-pointer-events-none {
  border-bottom-color: transparent;
}
.dx-treelist .dx-treelist-content-fixed .dx-treelist-table.dx-treelist-table-fixed .dx-row td.dx-pointer-events-none {
  width: auto;
}
.dx-treelist .dx-menu-subitem ul li {
  padding-top: 0;
}
.dx-treelist .dx-menu-subitem ul li:first-child {
  padding-top: 1px;
}
.dx-treelist .dx-menu-subitem .dx-menu-item {
  padding: 7px 30px 7px 5px;
}
.dx-treelist .dx-menu-subitem .dx-menu-item .dx-menu-image {
  background-position-x: left;
}
.dx-treelist .dx-link {
  text-decoration: underline;
  cursor: pointer;
}
.dx-treelist .dx-column-indicators {
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
}
.dx-treelist .dx-column-indicators.dx-visibility-hidden {
  visibility: hidden;
}
.dx-treelist .dx-column-indicators .dx-sort-index-icon {
  width: 15px;
}
.dx-treelist .dx-column-indicators .dx-header-filter.dx-header-filter,
.dx-treelist .dx-column-indicators .dx-header-filter.dx-sort,
.dx-treelist .dx-column-indicators .dx-sort.dx-header-filter,
.dx-treelist .dx-column-indicators .dx-sort.dx-sort {
  display: inline-block;
}
.dx-treelist .dx-column-indicators .dx-header-filter.dx-header-filter::after,
.dx-treelist .dx-column-indicators .dx-sort.dx-header-filter::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: -7px;
}
.dx-treelist .dx-row > td,
.dx-treelist .dx-row > tr > td {
  padding: 7px;
}
.dx-treelist .dx-error-row {
  -webkit-user-select: initial;
  -moz-user-select: initial;
  -ms-user-select: initial;
  user-select: initial;
}
.dx-treelist .dx-error-row .dx-error-message {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
.dx-treelist .dx-error-row .dx-error-message a {
  color: inherit;
}
.dx-treelist .dx-treelist-rowsview .dx-data-row .dx-command-drag {
  cursor: move;
  vertical-align: middle;
  padding: 0;
}
.dx-sortable-dragging .dx-treelist-rowsview .dx-data-row .dx-command-drag {
  cursor: pointer;
  cursor: -webkit-grabbing;
  cursor: grabbing;
}
.dx-sortable-without-handle .dx-data-row {
  cursor: pointer;
}
.dx-treelist-column-chooser .dx-overlay-content .dx-popup-title {
  font-size: 16px;
}
.dx-treelist-column-chooser .dx-overlay-content .dx-popup-content {
  padding: 0 20px 20px;
}
.dx-treelist-column-chooser .dx-overlay-content .dx-popup-content .dx-column-chooser-item {
  opacity: .5;
  -webkit-box-shadow: 0 1px 3px -1px rgba(0,0,0,.2);
  box-shadow: 0 1px 3px -1px rgba(0,0,0,.2);
}
.dx-treelist-column-chooser .dx-overlay-content .dx-popup-content .dx-column-chooser-item.dx-treelist-drag-action {
  opacity: 1;
  cursor: pointer;
  -ms-touch-action: pinch-zoom;
  touch-action: pinch-zoom;
}
.dx-treelist-column-chooser.dx-treelist-column-chooser-mode-drag .dx-treeview-node-container:first-child > .dx-treeview-node-is-leaf {
  padding: 0;
}
.dx-treelist-column-chooser.dx-treelist-column-chooser-mode-select .dx-treelist-column-chooser-plain .dx-treeview-select-all-item {
  padding-left: 4px;
}
.dx-treelist-column-chooser.dx-treelist-column-chooser-mode-select .dx-treelist-column-chooser-plain .dx-treeview-node {
  padding-left: 0;
}
.dx-treelist-column-chooser.dx-treelist-column-chooser-mode-select .dx-treelist-column-chooser-plain .dx-treeview-node .dx-checkbox {
  left: 4px;
}
.dx-treelist-nowrap,
.dx-treelist-nowrap .dx-header-row>td>.dx-treelist-text-content {
  white-space: nowrap;
}
.dx-treelist-drag-header {
  position: absolute;
  vertical-align: middle;
  cursor: pointer;
  z-index: 10000;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
.dx-treelist-drag-header.dx-drag-command-cell {
  padding: 0;
}
.dx-treelist-columns-separator {
  position: absolute;
  z-index: 3;
  width: 3px;
}
.dx-treelist-columns-separator-transparent {
  border-left: 0;
  border-right: 0;
}
.dx-treelist-tracker {
  width: 100%;
  position: absolute;
  top: 0;
  z-index: 3;
  cursor: col-resize;
}
.dx-treelist-table-content {
  position: absolute;
  top: 0;
}
.dx-treelist-focus-overlay {
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  visibility: hidden;
}
.dx-treelist-action,
.dx-treelist-drag-action {
  cursor: pointer;
}
.dx-data-row.dx-state-hover:not(.dx-selection):not(.dx-row-modified):not(.dx-row-inserted):not(.dx-row-removed):not(.dx-edit-row) > td:not(.dx-focused) .dx-link {
  color: inherit;
}
.dx-treelist-content {
  position: relative;
}
.dx-treelist-content .dx-overlay-wrapper.dx-invalid-message.dx-treelist-invalid-message {
  visibility: visible;
}
.dx-treelist-content .dx-overlay-wrapper.dx-invalid-message.dx-treelist-invalid-message .dx-overlay-content,
.dx-treelist-text-content {
  overflow: hidden;
  text-overflow: ellipsis;
}
.dx-treelist-table-fixed {
  table-layout: fixed;
  width: 100%;
}
input.dx-hidden {
  display: inline-block!important;
  width: 0!important;
}
.dx-hidden-cell {
  visibility: hidden;
}
.dx-row > td,
.dx-row > tr > td {
  border: none;
}
.dx-treelist-content .dx-treelist-table {
  border-collapse: collapse;
  border-spacing: 0;
  margin: 0;
  max-width: 10px;
}
.dx-treelist-content .dx-treelist-table.dx-treelist-table-fixed {
  max-width: none;
}
.dx-treelist-content .dx-treelist-table.dx-treelist-table-fixed .dx-column-indicators .dx-sort.dx-sort-none {
  display: none;
}
.dx-treelist-content .dx-treelist-table.dx-treelist-table-fixed .dx-column-indicators .dx-sort.dx-sort-index {
  width: 26px;
}
.dx-treelist-content .dx-treelist-table .dx-treelist-best-fit {
  max-width: none!important;
}
.dx-treelist-content .dx-treelist-table .dx-treelist-best-fit .dx-column-indicators {
  float: none!important;
}
.dx-treelist-content .dx-treelist-table .dx-treelist-best-fit .dx-column-indicators > span {
  width: 14px;
}
.dx-treelist-content .dx-treelist-table .dx-treelist-best-fit .dx-column-indicators .dx-sort.dx-sort-none {
  display: inline-block;
}
.dx-treelist-content .dx-treelist-table .dx-treelist-best-fit .dx-header-row .dx-treelist-text-content {
  max-width: none;
}
.dx-treelist-content .dx-treelist-table .dx-treelist-best-fit .dx-text-content-alignment-left {
  margin-right: 3px;
}
.dx-treelist-content .dx-treelist-table .dx-treelist-best-fit .dx-text-content-alignment-right {
  margin-left: 3px;
}
.dx-treelist-content .dx-treelist-table:not(.dx-treelist-table-fixed) .dx-column-indicators {
  float: none!important;
}
.dx-treelist-content .dx-treelist-table:not(.dx-treelist-table-fixed) .dx-column-indicators > span {
  width: 14px;
}
.dx-treelist-content .dx-treelist-table:not(.dx-treelist-table-fixed) .dx-text-content-alignment-left {
  margin-right: 3px;
}
.dx-treelist-content .dx-treelist-table:not(.dx-treelist-table-fixed) .dx-text-content-alignment-right {
  margin-left: 3px;
}
.dx-treelist-content .dx-treelist-table:not(.dx-treelist-table-fixed) .dx-master-detail-cell {
  max-width: 0;
}
.dx-treelist-content .dx-treelist-table [class*=column] + [class*=column]:last-child {
  float: none;
}
.dx-treelist-content .dx-treelist-table .dx-row > td,
.dx-treelist-content .dx-treelist-table .dx-row > tr > td {
  vertical-align: top;
}
.dx-treelist-content .dx-treelist-table .dx-row > td.dx-first-child,
.dx-treelist-content .dx-treelist-table .dx-row > td:first-child,
.dx-treelist-content .dx-treelist-table .dx-row > tr > td.dx-first-child,
.dx-treelist-content .dx-treelist-table .dx-row > tr > td:first-child {
  border-left: 0;
}
.dx-treelist-content .dx-treelist-table .dx-row > td.dx-last-child,
.dx-treelist-content .dx-treelist-table .dx-row > tr > td.dx-last-child {
  border-right: 0;
}
.dx-treelist-content .dx-treelist-table .dx-row > td.dx-treelist-group-space,
.dx-treelist-content .dx-treelist-table .dx-row > tr > td.dx-treelist-group-space {
  border-right: none;
  vertical-align: top;
}
.dx-treelist-content .dx-treelist-table .dx-row > td.dx-treelist-group-space + td,
.dx-treelist-content .dx-treelist-table .dx-row > tr > td.dx-treelist-group-space + td {
  border-left: none;
}
.dx-treelist-content .dx-treelist-table .dx-row .dx-editor-container {
  overflow: hidden;
}
.dx-treelist-content .dx-treelist-table .dx-row .dx-treelist-invalid .dx-invalid-message.dx-overlay {
  position: static;
}
.dx-treelist-content .dx-treelist-table .dx-row .dx-editor-cell {
  max-width: 0;
  padding: 0;
  vertical-align: middle;
}
.dx-treelist-content .dx-treelist-table .dx-row .dx-editor-cell .dx-texteditor,
.dx-treelist-content .dx-treelist-table .dx-row .dx-editor-cell .dx-texteditor-container {
  border: 0;
  margin: 0;
}
.dx-treelist-content .dx-treelist-table .dx-row .dx-command-select {
  padding: 0;
  width: 70px;
  min-width: 70px;
  max-width: 70px;
}
.dx-treelist-content .dx-treelist-table .dx-row .dx-command-edit {
  text-overflow: clip;
  width: 100px;
  min-width: 100px;
  white-space: nowrap;
}
.dx-treelist-content .dx-treelist-table .dx-row .dx-command-edit.dx-command-edit-with-icons {
  width: 80px;
  min-width: 80px;
}
.dx-treelist-content .dx-treelist-table .dx-row .dx-command-edit.dx-command-edit-with-icons .dx-link {
  text-decoration: none;
}
.dx-treelist-content .dx-treelist-table .dx-row .dx-command-edit .dx-link {
  display: inline-block;
}
.dx-treelist-content .dx-treelist-table .dx-row .dx-command-expand {
  padding: 0;
  width: 30px;
  min-width: 30px;
  max-width: 30px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}
.dx-treelist-content .dx-treelist-table .dx-row .dx-command-adaptive {
  padding: 0;
  vertical-align: middle;
}
.dx-treelist-content .dx-treelist-table .dx-data-row .dx-command-edit-with-icons {
  line-height: 1;
  white-space: nowrap;
}
.dx-treelist-content .dx-treelist-table .dx-filter-range-content {
  padding: 7px 7px 7px 32px;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.dx-treelist-content .dx-treelist-table .dx-row > .dx-last-data-cell {
  border-right: none;
}
.dx-treelist-content .dx-treelist-table .dx-row > .dx-command-adaptive-hidden {
  border-left: none;
}
.dx-cell-modified,
.dx-highlight-outline,
.dx-treelist-invalid {
  position: relative;
  padding: 7px;
}
.dx-cell-modified::after,
.dx-highlight-outline::after,
.dx-treelist-invalid::after {
  content: "";
  position: absolute;
  border: 2px solid transparent;
  top: 0;
  left: 1px;
  bottom: 0;
  right: 0;
  pointer-events: none;
}
.dx-cell-modified.dx-hidden,
.dx-highlight-outline.dx-hidden,
.dx-treelist-invalid.dx-hidden {
  display: block!important;
}
.dx-cell-modified.dx-hidden::after,
.dx-highlight-outline.dx-hidden::after,
.dx-treelist-invalid.dx-hidden::after {
  display: none;
}
.dx-editor-cell .dx-texteditor-input {
  margin: 0;
}
.dx-editor-cell .dx-highlight-outline,
.dx-editor-cell.dx-cell-modified,
.dx-editor-cell.dx-treelist-invalid {
  padding: 0;
}
.dx-editor-cell.dx-editor-inline-block:not(.dx-command-select)::before {
  display: inline-block;
  content: "​";
  vertical-align: middle;
}
.dx-column-lines .dx-cell-modified::after,
.dx-column-lines .dx-highlight-outline::after,
.dx-column-lines .dx-treelist-invalid::after {
  left: 0;
}
.dx-treelist-headers {
  position: relative;
  outline: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}
.dx-header-row .dx-editor-cell .dx-select-checkbox {
  display: inline-block;
}
.dx-header-row > td {
  white-space: nowrap;
  overflow: hidden;
}
.dx-header-row > td > .dx-treelist-text-content {
  display: inline-block;
  white-space: normal;
  vertical-align: top;
}
.dx-header-row .dx-text-content-alignment-left,
.dx-header-row .dx-text-content-alignment-right,
.dx-header-row>td>.dx-treelist-text-content:not(.dx-sort-indicator):not(.dx-header-filter-indicator) {
  max-width: 100%;
}
.dx-header-row .dx-header-filter-indicator,
.dx-header-row .dx-sort-indicator {
  max-width: calc(100% - 17px);
}
.dx-header-row .dx-header-filter-indicator.dx-text-content-alignment-left,
.dx-header-row .dx-sort-indicator.dx-text-content-alignment-left {
  margin-right: 3px;
}
.dx-header-row .dx-header-filter-indicator.dx-text-content-alignment-right,
.dx-header-row .dx-sort-indicator.dx-text-content-alignment-right {
  margin-left: 3px;
}
.dx-header-row .dx-header-filter-indicator.dx-text-content-alignment-left.dx-text-content-alignment-right,
.dx-header-row .dx-sort-indicator.dx-text-content-alignment-left.dx-text-content-alignment-right {
  max-width: calc(100% - 34px);
}
.dx-header-row .dx-sort-indicator.dx-header-filter-indicator {
  max-width: calc(100% - 31px);
}
.dx-header-row .dx-sort-indicator.dx-header-filter-indicator.dx-text-content-alignment-left.dx-text-content-alignment-right {
  max-width: calc(100% - 62px);
}
.dx-header-row .dx-sort-indicator.dx-sort-index-indicator {
  max-width: calc(100% - 29px);
}
.dx-header-row .dx-sort-indicator.dx-sort-index-indicator.dx-header-filter-indicator {
  max-width: calc(100% - 43px);
}
.dx-header-row .dx-sort-indicator.dx-sort-index-indicator.dx-text-content-alignment-left.dx-text-content-alignment-right {
  max-width: calc(100% - 46px);
}
.dx-header-row .dx-sort-indicator.dx-sort-index-indicator.dx-header-filter-indicator.dx-text-content-alignment-left.dx-text-content-alignment-right {
  max-width: calc(100% - 74px);
}
.dx-treelist-filter-range-overlay .dx-editor-container .dx-texteditor {
  border-width: 0;
}
.dx-treelist-filter-range-overlay .dx-editor-container .dx-texteditor.dx-state-focused::after {
  content: " ";
  position: absolute;
  top: -1px;
  bottom: -1px;
  left: -1px;
  right: -1px;
  z-index: 1;
  pointer-events: none;
}
.dx-treelist-filter-range-overlay .dx-treelist-filter-range-end {
  border-top: 1px solid transparent;
}
.dx-treelist-filter-range-overlay .dx-editor-container.dx-cell-modified,
.dx-treelist-filter-range-overlay .dx-editor-container.dx-treelist-invalid {
  padding: 0;
}
.dx-treelist-filter-row .dx-editor-cell .dx-menu {
  display: none;
}
.dx-treelist-filter-row .dx-editor-cell .dx-editor-with-menu {
  position: relative;
}
.dx-treelist-filter-row .dx-editor-cell .dx-editor-with-menu .dx-menu {
  display: block;
}
.dx-treelist-filter-row .dx-editor-cell .dx-editor-with-menu .dx-placeholder::before,
.dx-treelist-filter-row .dx-editor-cell .dx-editor-with-menu .dx-texteditor-input {
  padding-left: 32px;
}
.dx-treelist-filter-row .dx-cell-modified::after,
.dx-treelist-filter-row .dx-treelist-invalid::after {
  pointer-events: none;
}
.dx-treelist-filter-row .dx-focused .dx-highlight-outline::after,
.dx-treelist-filter-row .dx-focused.dx-cell-modified::after,
.dx-treelist-filter-row .dx-focused.dx-treelist-invalid::after {
  border-color: transparent;
}
.dx-treelist-filter-row .dx-menu {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  margin-top: -2px;
  height: 100%;
  overflow: visible;
}
.dx-treelist-filter-row .dx-menu .dx-menu-horizontal {
  height: 100%;
}
.dx-treelist-filter-row .dx-menu .dx-menu-horizontal .dx-menu-item-popout,
.dx-treelist-filter-row .dx-menu .dx-menu-horizontal .dx-menu-item-text {
  display: none;
}
.dx-treelist-filter-row .dx-menu-item.dx-state-focused::after {
  position: absolute;
  left: 2px;
  top: 2px;
  width: 100%;
  height: 102%;
  content: "";
}
.dx-treelist-filter-row > .dx-first-cell .dx-menu,
.dx-treelist-filter-row > td:first-child .dx-menu {
  margin-left: 0;
}
.dx-treelist-filter-row .dx-menu-horizontal .dx-overlay-content ul .dx-menu-item {
  padding: 5px 30px 5px 5px;
}
.dx-treelist-filter-row .dx-menu ul.dx-menu-horizontal > li > .dx-menu-item {
  padding: 8px 5px 7px;
}
.dx-treelist-filter-row .dx-menu ul.dx-menu-horizontal > li > .dx-menu-item.dx-state-disabled:hover {
  padding: 9px 6px 8px;
}
.dx-treelist-filter-row .dx-menu-caption {
  padding-left: 6px;
}
.dx-treelist-filter-row .dx-menu ul .dx-menu-item .dx-menu-chouser-down {
  display: none;
}
.dx-treelist-filter-row .dx-menu-item-highlight {
  font-weight: 400;
}
.dx-treelist-scroll-container {
  overflow: hidden;
  width: 100%;
}
.dx-treelist-header-panel {
  text-align: left;
}
.dx-treelist-header-panel .dx-toolbar-menu-container .dx-button {
  margin-left: 10px;
}
.dx-state-disabled {
  cursor: pointer;
}
.dx-state-disabled .dx-menu-item {
  cursor: default;
}
.dx-treelist-search-panel {
  margin: 0 0 0 15px;
}
.dx-gridbase-container > .dx-treelist-rowsview {
  -webkit-box-flex: 1;
  -ms-flex: auto;
  flex: auto;
  height: auto;
}
.dx-gridbase-container > .dx-treelist-rowsview.dx-scrollable {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.dx-gridbase-container > .dx-treelist-rowsview.dx-scrollable > .dx-scrollable-wrapper {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: auto;
  min-width: 0;
  min-height: 0;
}
.dx-treelist-rowsview {
  position: relative;
  overflow: hidden;
}
.dx-treelist-rowsview.dx-empty {
  height: 100px;
}
.dx-treelist-rowsview.dx-empty .dx-scrollable-content {
  height: 100%;
}
.dx-treelist-rowsview.dx-fixed-columns.dx-scrollable .dx-scrollable-content {
  z-index: 2;
}
.dx-treelist-rowsview.dx-fixed-columns .dx-scrollable-scrollbar {
  z-index: 3;
}
.dx-treelist-rowsview .dx-treelist-content {
  overflow-anchor: none;
}
.dx-treelist-rowsview .dx-treelist-content:not(.dx-treelist-content-fixed) {
  min-height: 100%;
}
.dx-treelist-rowsview .dx-treelist-content.dx-scrollable-container {
  width: auto;
}
.dx-treelist-rowsview .dx-treelist-content.dx-treelist-content-fixed.dx-scrollable-container {
  height: auto;
}
.dx-treelist-rowsview:focus {
  outline: 0;
}
.dx-treelist-rowsview .dx-row > td,
.dx-treelist-rowsview .dx-row > tr > td {
  overflow: hidden;
  text-overflow: ellipsis;
}
.dx-treelist-rowsview .dx-row.dx-row-lines:first-child,
.dx-treelist-rowsview .dx-row.dx-row-lines:first-child>td,
.dx-treelist-rowsview .dx-row.dx-row-lines:first-child>tr>td {
  border-top: none;
}
.dx-treelist-rowsview .dx-data-row > td:focus {
  outline: 0;
}
.dx-treelist-rowsview .dx-selection > td .dx-link,
.dx-treelist-rowsview .dx-selection > tr > td .dx-link,
.dx-treelist-rowsview .dx-selection.dx-row:hover > td .dx-link,
.dx-treelist-rowsview .dx-selection.dx-row:hover > tr > td .dx-link {
  color: inherit;
}
.dx-treelist-rowsview .dx-treelist-table .dx-row.dx-freespace-row,
.dx-treelist-rowsview .dx-treelist-table .dx-row.dx-virtual-row {
  border-top: 0;
  border-bottom: 0;
}
.dx-treelist-rowsview .dx-treelist-table .dx-row.dx-freespace-row > td,
.dx-treelist-rowsview .dx-treelist-table .dx-row.dx-virtual-row > td {
  padding-top: 0;
  padding-bottom: 0;
}
.dx-treelist-rowsview .dx-select-checkboxes-hidden > tbody > tr > td > .dx-select-checkbox {
  display: none;
}
.dx-treelist-rowsview .dx-select-checkboxes-hidden>tbody>tr.dx-selection>td>.dx-select-checkbox,
.dx-treelist-rowsview .dx-select-checkboxes-hidden>tbody>tr>td:hover>.dx-select-checkbox {
  display: inline-block;
}
.dx-treelist-rowsview .dx-row > .dx-master-detail-cell:focus {
  outline: 0;
}
.dx-treelist-rowsview .dx-data-row.dx-edit-row .dx-cell-modified::after {
  border-color: transparent;
}
.dx-treelist-nodata {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  text-align: center;
  -webkit-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
}
.dx-treelist-bottom-load-panel {
  text-align: center;
  padding: 10px;
}
.dx-treelist-hidden-column {
  white-space: nowrap;
}
.dx-treelist .dx-row .dx-treelist-hidden-column {
  border-right-width: 0;
  border-left-width: 0;
}
.dx-treelist-hidden-column > * {
  display: none!important;
}
.dx-treelist-summary-item {
  font-weight: 700;
}
.dx-treelist-export-menu .dx-dropdownbutton-content .dx-list-item {
  display: block;
}
.dx-treelist-revert-tooltip.dx-popover-wrapper .dx-overlay-content {
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-treelist-revert-tooltip.dx-popover-wrapper .dx-overlay-content .dx-popup-content {
  padding: 0;
}
.dx-treelist-revert-tooltip.dx-popover-wrapper .dx-popover-arrow {
  width: 0;
  height: 0;
}
.dx-treelist-notouch-action {
  -ms-touch-action: none;
  touch-action: none;
  -ms-content-zooming: none;
  -ms-overflow-style: none;
}
.dx-treelist-column-chooser-list.dx-treeview .dx-empty-message,
.dx-treelist-column-chooser-list.dx-treeview .dx-treeview-item {
  border: none;
}
.dx-treelist-column-chooser-list.dx-treeview .dx-empty-message {
  text-align: center;
  left: 0;
  right: 0;
  bottom: 50%;
  position: absolute;
}
.dx-rtl .dx-treelist .dx-menu-subitem .dx-menu-item,
.dx-treelist.dx-rtl .dx-menu-subitem .dx-menu-item {
  padding: 7px 5px 7px 30px;
}
.dx-rtl .dx-treelist .dx-menu-subitem .dx-menu-item .dx-menu-image,
.dx-treelist.dx-rtl .dx-menu-subitem .dx-menu-item .dx-menu-image {
  background-position-x: right;
}
.dx-rtl .dx-treelist .dx-texteditor-buttons-container,
.dx-treelist.dx-rtl .dx-texteditor-buttons-container {
  text-align: start;
}
.dx-rtl .dx-treelist-content .dx-treelist-table {
  direction: rtl;
}
.dx-rtl .dx-treelist-content .dx-treelist-table .dx-row > td.dx-treelist-group-space {
  border-left: none;
}
.dx-rtl .dx-treelist-content .dx-treelist-table .dx-row > td.dx-treelist-group-space + td {
  border-right: none;
}
.dx-rtl .dx-treelist-content .dx-treelist-table .dx-row .dx-editor-container .dx-editor-cell .dx-checkbox.dx-checkbox-checked .dx-checkbox-icon {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
.dx-rtl .dx-treelist-content .dx-treelist-table .dx-row .dx-filter-range-content {
  padding: 7px 32px 7px 7px;
}
.dx-rtl .dx-treelist-headers .dx-treelist-scrollable-simulated,
.dx-rtl .dx-treelist-total-footer .dx-treelist-scrollable-simulated {
  direction: ltr;
}
.dx-rtl .dx-treelist-headers .dx-treelist-scrollable-simulated .dx-treelist-table,
.dx-rtl .dx-treelist-total-footer .dx-treelist-scrollable-simulated .dx-treelist-table {
  direction: rtl;
}
.dx-rtl .dx-treelist-filter-row .dx-editor-cell .dx-editor-with-menu .dx-texteditor .dx-placeholder::before,
.dx-rtl .dx-treelist-filter-row .dx-editor-cell .dx-editor-with-menu .dx-texteditor .dx-texteditor-input {
  padding-right: 32px;
}
.dx-rtl .dx-treelist-filter-row .dx-menu {
  right: 0;
  left: auto;
  margin-left: 0;
  margin-right: -2px;
}
.dx-rtl .dx-treelist-filter-row > td:first-child .dx-menu {
  margin-left: 0;
}
.dx-rtl .dx-treelist-filter-row .dx-menu-horizontal .dx-overlay-content ul .dx-menu-item {
  padding: 5px 5px 5px 30px;
}
.dx-rtl .dx-treelist-filter-row .dx-menu-caption {
  padding-right: 6px;
}
.dx-rtl .dx-treelist-header-panel {
  text-align: right;
}
.dx-rtl .dx-treelist-header-panel .dx-treelist-column-chooser-button {
  margin-left: 0;
}
.dx-rtl .dx-treelist-header-panel .dx-toolbar-menu-container .dx-button {
  margin-left: 0;
  margin-right: 10px;
}
.dx-rtl .dx-treelist-search-panel {
  margin: 0 15px 0 0;
}
.dx-treelist-filter-panel,
.dx-treelist-filter-panel-left {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  min-width: 0;
}
.dx-treelist-filter-panel .dx-treelist-filter-panel-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dx-treelist-filter-panel .dx-treelist-filter-panel-clear-filter:hover,
.dx-treelist-filter-panel .dx-treelist-filter-panel-text:hover {
  text-decoration: underline;
  cursor: pointer;
}
.dx-treelist-filter-panel .dx-treelist-filter-panel-checkbox {
  padding-right: 10px;
}
.dx-treelist-filter-panel .dx-icon-filter {
  margin: auto 7px auto auto;
  cursor: pointer;
}
.dx-treelist-container {
  position: relative;
  cursor: default;
  white-space: normal;
  line-height: normal;
  color: rgba(0,0,0,.87);
  background-color: #fff;
}
.dx-treelist-rowsview .dx-treelist-best-fit.dx-treelist-cell-expandable,
.dx-treelist-rowsview .dx-treelist-table:not(.dx-treelist-table-fixed) .dx-treelist-cell-expandable {
  white-space: nowrap;
}
.dx-treelist-rowsview .dx-treelist-best-fit.dx-treelist-cell-expandable .dx-treelist-text-content,
.dx-treelist-rowsview .dx-treelist-table:not(.dx-treelist-table-fixed) .dx-treelist-cell-expandable .dx-treelist-text-content {
  display: inline;
  white-space: normal;
}
.dx-treelist-rowsview .dx-treelist-best-fit.dx-treelist-cell-expandable .dx-treelist-icon-container,
.dx-treelist-rowsview .dx-treelist-table:not(.dx-treelist-table-fixed) .dx-treelist-cell-expandable .dx-treelist-icon-container {
  float: none;
}
.dx-treelist-rowsview .dx-treelist-icon-container {
  display: inline-block;
  white-space: nowrap;
  vertical-align: top;
  line-height: 1;
}
.dx-treelist-rowsview .dx-treelist-table-fixed .dx-treelist-icon-container {
  float: left;
}
.dx-treelist-borders > .dx-treelist-headers,
.dx-treelist-borders > .dx-treelist-rowsview,
.dx-treelist-borders > .dx-treelist-total-footer {
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
}
.dx-treelist-borders > .dx-treelist-rowsview,
.dx-treelist-borders > .dx-treelist-total-footer {
  border-bottom: 1px solid #e0e0e0;
}
.dx-treelist-borders > .dx-treelist-filter-panel,
.dx-treelist-borders > .dx-treelist-headers {
  border-top: 1px solid #e0e0e0;
}
.dx-treelist-borders > .dx-treelist-filter-panel {
  border-top-width: 0;
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
}
.dx-sortable-dragging > div > .dx-gridbase-container > .dx-treelist-rowsview {
  border-color: rgba(0,150,136,.5);
}
.dx-treelist .dx-column-lines > td:first-child {
  border-left: none;
}
.dx-treelist .dx-column-lines > td:last-child {
  border-right: none;
}
.dx-treelist .dx-command-drag .dx-treelist-drag-icon {
  font: 14px/1 DXIcons;
}
.dx-treelist .dx-command-drag .dx-treelist-drag-icon::before {
  content: "\\f038";
}
.dx-treelist-container .dx-sort-up {
  font: 14px/1 DXIcons;
}
.dx-treelist-container .dx-sort-up::before {
  content: "\\f051";
}
.dx-treelist-container .dx-sort-down {
  font: 14px/1 DXIcons;
}
.dx-treelist-container .dx-sort-down::before {
  content: "\\f052";
}
.dx-treelist-container .dx-sort-down,
.dx-treelist-container .dx-sort-up {
  font-family: inherit;
}
.dx-treelist-container .dx-sort-down::before,
.dx-treelist-container .dx-sort-up::before {
  font-family: DXIcons,sans-serif;
}
.dx-treelist-container .dx-treelist-headers .dx-header-filter,
.dx-treelist-container .dx-treelist-headers .dx-header-row > td {
  outline: 0;
}
.dx-treelist-container .dx-treelist-headers.dx-state-focused .dx-header-row td .dx-header-filter:focus,
.dx-treelist-container .dx-treelist-headers.dx-state-focused .dx-header-row td:focus {
  outline: #33aba0 solid 2px;
}
.dx-treelist-container .dx-treelist-headers.dx-state-focused .dx-header-row td:focus {
  outline-offset: -2px;
}
.dx-treelist-container .dx-treelist-headers.dx-state-focused .dx-header-row td .dx-header-filter:focus {
  outline-offset: 2px;
}
.dx-treelist-container .dx-header-filter {
  position: relative;
  color: rgba(0,0,0,.54);
  font: 14px/1 DXIcons;
}
.dx-treelist-container .dx-header-filter::before {
  content: "\\f050";
}
.dx-treelist-container .dx-header-filter-empty {
  color: rgba(0,0,0,.38);
}
.dx-treelist-container .dx-treelist-content-fixed .dx-treelist-table .dx-col-fixed {
  background-color: #fff;
}
.dx-treelist-container .dx-datagrid-rowsview .dx-header-row td.dx-pointer-events-none,
.dx-treelist-container .dx-datagrid-rowsview .dx-virtual-row td.dx-pointer-events-none,
.dx-treelist-container .dx-treelist-headers .dx-row td.dx-pointer-events-none,
.dx-treelist-container .dx-treelist-rowsview .dx-data-row td.dx-pointer-events-none,
.dx-treelist-container .dx-treelist-rowsview .dx-freespace-row td.dx-pointer-events-none {
  border-left: 2px solid #e0e0e0;
  border-right: 2px solid #e0e0e0;
}
.dx-treelist-container .dx-datagrid-rowsview .dx-header-row td.dx-pointer-events-none.dx-first-cell,
.dx-treelist-container .dx-datagrid-rowsview .dx-virtual-row td.dx-pointer-events-none.dx-first-cell,
.dx-treelist-container .dx-treelist-headers .dx-row td.dx-pointer-events-none.dx-first-cell,
.dx-treelist-container .dx-treelist-rowsview .dx-data-row td.dx-pointer-events-none.dx-first-cell,
.dx-treelist-container .dx-treelist-rowsview .dx-freespace-row td.dx-pointer-events-none.dx-first-cell {
  border-left: none;
}
.dx-treelist-container .dx-datagrid-rowsview .dx-header-row td.dx-pointer-events-none.dx-last-cell,
.dx-treelist-container .dx-datagrid-rowsview .dx-virtual-row td.dx-pointer-events-none.dx-last-cell,
.dx-treelist-container .dx-treelist-headers .dx-row td.dx-pointer-events-none.dx-last-cell,
.dx-treelist-container .dx-treelist-rowsview .dx-data-row td.dx-pointer-events-none.dx-last-cell,
.dx-treelist-container .dx-treelist-rowsview .dx-freespace-row td.dx-pointer-events-none.dx-last-cell {
  border-right: none;
}
.dx-treelist-container .dx-treelist-rowsview.dx-state-focused .dx-data-row > td.dx-command-edit > a.dx-link:focus {
  outline: #33aba0 solid 2px;
  outline-offset: 2px;
}
.dx-treelist-container .dx-treelist-rowsview.dx-state-focused .dx-data-row.dx-row-focused > td.dx-command-edit > a.dx-link:focus {
  outline-color: #fff;
  outline-offset: 0;
}
.dx-treelist-container .dx-treelist-rowsview .dx-treelist-edit-form {
  background-color: #fff;
}
.dx-treelist-container .dx-treelist-rowsview .dx-virtual-row > td {
  position: relative;
}
.dx-treelist-container .dx-treelist-rowsview .dx-virtual-row > td::before {
  display: block;
  height: 100%;
  content: "";
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAADzCAYAAABwgbOvAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpBRjExRDRGQTNENjQxMUU4QUZEMEE1N0M1QzIyNEE4QyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpBRjExRDRGQjNENjQxMUU4QUZEMEE1N0M1QzIyNEE4QyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkFGMTFENEY4M0Q2NDExRThBRkQwQTU3QzVDMjI0QThDIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkFGMTFENEY5M0Q2NDExRThBRkQwQTU3QzVDMjI0QThDIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+57ApqAAAAUNJREFUeNrs3LENwzAMRUEzi2T/sTSJgowQRAI+pbvehf0KFiZYc84nUVU9AAAAAAAAAHf5/id9+wxLjX8efvl+WQQRBEEEQRBBEEQQBBEEQQAAAAAAAAAAflRuLmaxdSIIggiCIIIgiCAIIgiCIAgAyyUfMBs3BjHUBUEQQRBEEAQRBEEEQRAE6cKyNQAAAAAAAADQQuySw9aXDl6gsAYkCIIIgiCCIIggCCIIgiAIcILkA2Y7xR5HM0MEQRBBEEQQBBEEQQRBEAQBAAAAAAAAAHq78l5WMlsngiCIIAgiCIIIgiCCIAiCALDcrQfMDHUEEQRBBEEQQRAEQQRBEEEAAAAAAAAAALZoecCsqo4NYutEEAQRBEEEQRBBEEQQBEEQAJbresBsGOoIIgiCIIggCCIIggiCIIIAAAAAAAAc5iPAAIcKFwANDofzAAAAAElFTkSuQmCC");
  background-repeat: no-repeat repeat;
}
.dx-treelist-container .dx-treelist-rowsview .dx-virtual-row > td[style*="text-align: right"]::before {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
.dx-treelist-container .dx-treelist-filter-row .dx-filter-range-content {
  color: rgba(0,0,0,.87);
}
.dx-treelist-container .dx-error-row td {
  color: #fff;
  padding: 0;
}
.dx-treelist-container .dx-error-row .dx-error-message {
  background-color: #f88e86;
  white-space: normal;
  word-wrap: break-word;
}
.dx-treelist-filter-panel {
  color: rgba(0,0,0,.87);
  border-top: 1px solid #e0e0e0;
}
.dx-treelist-filter-panel .dx-icon-filter,
.dx-treelist-filter-panel .dx-treelist-filter-panel-clear-filter,
.dx-treelist-filter-panel .dx-treelist-filter-panel-text {
  outline: 0;
}
.dx-treelist-filter-panel.dx-state-focused .dx-icon-filter:focus,
.dx-treelist-filter-panel.dx-state-focused .dx-treelist-filter-panel-clear-filter:focus,
.dx-treelist-filter-panel.dx-state-focused .dx-treelist-filter-panel-text:focus {
  outline: #33aba0 solid 2px;
}
.dx-treelist-form-buttons-container {
  float: right;
}
.dx-treelist-form-buttons-container .dx-button {
  margin-left: 10px;
  margin-top: 10px;
}
.dx-treelist-export-menu .dx-menu-item .dx-icon-exportxlsx {
  width: 16px;
  height: 16px;
  background-position: 0 0;
  background-size: 16px 16px;
  padding: 0;
  font-size: 16px;
  text-align: center;
  line-height: 16px;
}
.dx-treelist-adaptive-more {
  cursor: pointer;
  font: 21px/21px DXIcons;
}
.dx-treelist-adaptive-more::before {
  content: "\\f06c";
}
.dx-treelist-edit-popup .dx-error-message {
  background-color: #f88e86;
  white-space: normal;
  word-wrap: break-word;
  color: #fff;
  margin-bottom: 20px;
}
.dx-rtl.dx-treelist .dx-column-lines > td:first-child {
  border-right: none;
  border-left: 1px solid #e0e0e0;
}
.dx-rtl.dx-treelist .dx-column-lines > td:last-child {
  border-left: none;
  border-right: 1px solid #e0e0e0;
}
.dx-rtl .dx-treelist-container .dx-datagrid-rowsview .dx-header-row td.dx-pointer-events-none,
.dx-rtl .dx-treelist-container .dx-datagrid-rowsview .dx-virtual-row td.dx-pointer-events-none,
.dx-rtl .dx-treelist-container .dx-treelist-headers .dx-row td.dx-pointer-events-none,
.dx-rtl .dx-treelist-container .dx-treelist-rowsview .dx-data-row td.dx-pointer-events-none,
.dx-rtl .dx-treelist-container .dx-treelist-rowsview .dx-freespace-row td.dx-pointer-events-none {
  border-left: 2px solid #e0e0e0;
  border-right: 2px solid #e0e0e0;
}
.dx-rtl .dx-treelist-container .dx-datagrid-rowsview .dx-header-row td.dx-pointer-events-none.dx-first-cell,
.dx-rtl .dx-treelist-container .dx-datagrid-rowsview .dx-virtual-row td.dx-pointer-events-none.dx-first-cell,
.dx-rtl .dx-treelist-container .dx-treelist-headers .dx-row td.dx-pointer-events-none.dx-first-cell,
.dx-rtl .dx-treelist-container .dx-treelist-rowsview .dx-data-row td.dx-pointer-events-none.dx-first-cell,
.dx-rtl .dx-treelist-container .dx-treelist-rowsview .dx-freespace-row td.dx-pointer-events-none.dx-first-cell {
  border-right: none;
}
.dx-rtl .dx-treelist-container .dx-datagrid-rowsview .dx-header-row td.dx-pointer-events-none.dx-last-cell,
.dx-rtl .dx-treelist-container .dx-datagrid-rowsview .dx-virtual-row td.dx-pointer-events-none.dx-last-cell,
.dx-rtl .dx-treelist-container .dx-treelist-headers .dx-row td.dx-pointer-events-none.dx-last-cell,
.dx-rtl .dx-treelist-container .dx-treelist-rowsview .dx-data-row td.dx-pointer-events-none.dx-last-cell,
.dx-rtl .dx-treelist-container .dx-treelist-rowsview .dx-freespace-row td.dx-pointer-events-none.dx-last-cell {
  border-left: none;
}
.dx-rtl .dx-treelist-container .dx-treelist-rowsview .dx-virtual-row > td::before {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
.dx-rtl .dx-treelist-container .dx-treelist-rowsview .dx-virtual-row > td[style*="text-align: left"]::before {
  -webkit-transform: scale(1);
  transform: scale(1);
}
.dx-rtl .dx-treelist-form-buttons-container {
  float: left;
}
.dx-rtl .dx-treelist-form-buttons-container .dx-button {
  margin-left: 0;
  margin-right: 10px;
}
.dx-treelist-cell-updated-animation {
  -webkit-animation: 1s dx-treelist-highlight-change;
  animation: 1s dx-treelist-highlight-change;
}
@-webkit-keyframes dx-treelist-highlight-change {
  50%,
  from {
    background-color: rgba(0,0,0,.08);
  }
}
@keyframes dx-treelist-highlight-change {
  50%,
  from {
    background-color: rgba(0,0,0,.08);
  }
}
.dx-treelist .dx-menu,
.dx-treelist-container .dx-menu {
  background-color: transparent;
  height: 100%;
}
.dx-treelist .dx-menu .dx-menu-item .dx-menu-item-content,
.dx-treelist-container .dx-menu .dx-menu-item .dx-menu-item-content {
  padding: 11px 4px;
}
.dx-treelist .dx-menu .dx-menu-item .dx-menu-item-content .dx-icon,
.dx-treelist-container .dx-menu .dx-menu-item .dx-menu-item-content .dx-icon {
  width: 22px;
  height: 22px;
  background-position: 0 0;
  background-size: 22px 22px;
  padding: 0;
  font-size: 22px;
  text-align: center;
  line-height: 22px;
  margin: 0 3px;
}
.dx-treelist-container.dx-filter-menu .dx-menu-item-content .dx-icon,
.dx-treelist.dx-filter-menu .dx-menu-item-content .dx-icon {
  color: rgba(86,86,86,.54);
  width: 18px;
  height: 18px;
  background-position: 0 0;
  background-size: 18px 18px;
  padding: 0;
  font-size: 18px;
  text-align: center;
  line-height: 18px;
}
.dx-treelist-container.dx-filter-menu .dx-menu-item-content .dx-icon.dx-icon-filter-operation-default,
.dx-treelist.dx-filter-menu .dx-menu-item-content .dx-icon.dx-icon-filter-operation-default {
  margin-top: 2px;
}
.dx-treelist .dx-editor-with-menu .dx-menu-item-content,
.dx-treelist-container .dx-editor-with-menu .dx-menu-item-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.dx-treelist .dx-editor-with-menu .dx-menu-item-content .dx-icon,
.dx-treelist-container .dx-editor-with-menu .dx-menu-item-content .dx-icon {
  width: 18px;
  height: 18px;
  background-position: 0 0;
  background-size: 18px 18px;
  padding: 0;
  font-size: 18px;
  text-align: center;
  line-height: 18px;
}
.dx-treelist .dx-editor-with-menu .dx-menu-item-content .dx-icon.dx-icon-filter-operation-default,
.dx-treelist-container .dx-editor-with-menu .dx-menu-item-content .dx-icon.dx-icon-filter-operation-default {
  margin-top: 2px;
}
.dx-treelist .dx-editor-with-menu .dx-texteditor .dx-placeholder::before,
.dx-treelist .dx-editor-with-menu .dx-texteditor .dx-texteditor-input,
.dx-treelist-container .dx-editor-with-menu .dx-texteditor .dx-placeholder::before,
.dx-treelist-container .dx-editor-with-menu .dx-texteditor .dx-texteditor-input {
  padding-left: 40px;
}
.dx-treelist-container.dx-context-menu .dx-menu-items-container .dx-icon-context-menu-sort-asc,
.dx-treelist.dx-context-menu .dx-menu-items-container .dx-icon-context-menu-sort-asc {
  font: 18px/18px DXIcons;
  width: 18px;
  height: 18px;
  background-position: 0 0;
  background-size: 18px 18px;
  padding: 0;
  text-align: center;
}
.dx-treelist-container.dx-context-menu .dx-menu-items-container .dx-icon-context-menu-sort-asc::before,
.dx-treelist.dx-context-menu .dx-menu-items-container .dx-icon-context-menu-sort-asc::before {
  content: "\\f053";
}
.dx-treelist-container.dx-context-menu .dx-menu-items-container .dx-icon-context-menu-sort-desc,
.dx-treelist.dx-context-menu .dx-menu-items-container .dx-icon-context-menu-sort-desc {
  font: 18px/18px DXIcons;
  width: 18px;
  height: 18px;
  background-position: 0 0;
  background-size: 18px 18px;
  padding: 0;
  text-align: center;
}
.dx-treelist-container.dx-context-menu .dx-menu-items-container .dx-icon-context-menu-sort-desc::before,
.dx-treelist.dx-context-menu .dx-menu-items-container .dx-icon-context-menu-sort-desc::before {
  content: "\\f054";
}
.dx-treelist-container.dx-context-menu .dx-menu-items-container .dx-icon-context-menu-sort-none,
.dx-treelist.dx-context-menu .dx-menu-items-container .dx-icon-context-menu-sort-none {
  width: 18px;
  height: 18px;
  background-position: 0 0;
  background-size: 18px 18px;
  padding: 0;
  font-size: 18px;
  text-align: center;
  line-height: 18px;
}
.dx-treelist .dx-header-filter,
.dx-treelist .dx-sort-down,
.dx-treelist .dx-sort-up,
.dx-treelist-container .dx-header-filter,
.dx-treelist-container .dx-sort-down,
.dx-treelist-container .dx-sort-up {
  width: 15px;
  height: 15px;
  background-position: 0 0;
  background-size: 15px 15px;
  padding: 0;
  font-size: 15px;
  text-align: center;
  line-height: 15px;
}
.dx-treelist .dx-header-filter:not(.dx-header-filter-empty),
.dx-treelist-container .dx-header-filter:not(.dx-header-filter-empty) {
  color: #009688;
}
.dx-treelist .dx-icon-filter-operation-equals,
.dx-treelist-container .dx-icon-filter-operation-equals {
  font: 14px/1 DXIcons;
}
.dx-treelist .dx-icon-filter-operation-equals::before,
.dx-treelist-container .dx-icon-filter-operation-equals::before {
  content: "\\f044";
}
.dx-treelist .dx-icon-filter-operation-default,
.dx-treelist-container .dx-icon-filter-operation-default {
  font: 14px/1 DXIcons;
}
.dx-treelist .dx-icon-filter-operation-default::before,
.dx-treelist-container .dx-icon-filter-operation-default::before {
  content: "\\f027";
}
.dx-treelist .dx-icon-filter-operation-not-equals,
.dx-treelist-container .dx-icon-filter-operation-not-equals {
  font: 14px/1 DXIcons;
}
.dx-treelist .dx-icon-filter-operation-not-equals::before,
.dx-treelist-container .dx-icon-filter-operation-not-equals::before {
  content: "\\f045";
}
.dx-treelist .dx-icon-filter-operation-less,
.dx-treelist-container .dx-icon-filter-operation-less {
  font: 14px/1 DXIcons;
}
.dx-treelist .dx-icon-filter-operation-less::before,
.dx-treelist-container .dx-icon-filter-operation-less::before {
  content: "\\f046";
}
.dx-treelist .dx-icon-filter-operation-less-equal,
.dx-treelist-container .dx-icon-filter-operation-less-equal {
  font: 14px/1 DXIcons;
}
.dx-treelist .dx-icon-filter-operation-less-equal::before,
.dx-treelist-container .dx-icon-filter-operation-less-equal::before {
  content: "\\f048";
}
.dx-treelist .dx-icon-filter-operation-greater,
.dx-treelist-container .dx-icon-filter-operation-greater {
  font: 14px/1 DXIcons;
}
.dx-treelist .dx-icon-filter-operation-greater::before,
.dx-treelist-container .dx-icon-filter-operation-greater::before {
  content: "\\f047";
}
.dx-treelist .dx-icon-filter-operation-greater-equal,
.dx-treelist-container .dx-icon-filter-operation-greater-equal {
  font: 14px/1 DXIcons;
}
.dx-treelist .dx-icon-filter-operation-greater-equal::before,
.dx-treelist-container .dx-icon-filter-operation-greater-equal::before {
  content: "\\f049";
}
.dx-treelist .dx-icon-filter-operation-contains,
.dx-treelist-container .dx-icon-filter-operation-contains {
  font: 14px/1 DXIcons;
}
.dx-treelist .dx-icon-filter-operation-contains::before,
.dx-treelist-container .dx-icon-filter-operation-contains::before {
  content: "\\f063";
}
.dx-treelist .dx-icon-filter-operation-not-contains,
.dx-treelist-container .dx-icon-filter-operation-not-contains {
  font: 14px/1 DXIcons;
}
.dx-treelist .dx-icon-filter-operation-not-contains::before,
.dx-treelist-container .dx-icon-filter-operation-not-contains::before {
  content: "\\f066";
}
.dx-treelist .dx-icon-filter-operation-starts-with,
.dx-treelist-container .dx-icon-filter-operation-starts-with {
  font: 14px/1 DXIcons;
}
.dx-treelist .dx-icon-filter-operation-starts-with::before,
.dx-treelist-container .dx-icon-filter-operation-starts-with::before {
  content: "\\f064";
}
.dx-treelist .dx-icon-filter-operation-ends-with,
.dx-treelist-container .dx-icon-filter-operation-ends-with {
  font: 14px/1 DXIcons;
}
.dx-treelist .dx-icon-filter-operation-ends-with::before,
.dx-treelist-container .dx-icon-filter-operation-ends-with::before {
  content: "\\f065";
}
.dx-treelist .dx-icon-filter-operation-between,
.dx-treelist-container .dx-icon-filter-operation-between {
  font: 14px/1 DXIcons;
}
.dx-treelist .dx-icon-filter-operation-between::before,
.dx-treelist-container .dx-icon-filter-operation-between::before {
  content: "\\f06a";
}
.dx-treelist .dx-column-indicators,
.dx-treelist-container .dx-column-indicators {
  height: 16px;
}
.dx-treelist .dx-column-indicators .dx-sort-index-icon,
.dx-treelist-container .dx-column-indicators .dx-sort-index-icon {
  padding-right: 4px;
  margin-left: -1px;
  font-size: 13px;
  position: relative;
  bottom: 1px;
}
.dx-treelist .dx-column-indicators > div,
.dx-treelist-container .dx-column-indicators > div {
  width: 15px;
  height: 15px;
  background-position: 0 0;
  background-size: 15px 15px;
  padding: 0;
  font-size: 15px;
  text-align: center;
  line-height: 15px;
}
.dx-treelist .dx-placeholder::before,
.dx-treelist-container .dx-placeholder::before {
  font-size: 14px;
}
.dx-treelist {
  line-height: inherit;
}
.dx-treelist .dx-row-alt {
  border-top: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;
}
.dx-treelist .dx-row-alt > td {
  background-color: #f5f5f5;
}
.dx-treelist .dx-row-alt.dx-row:not(.dx-row-removed) {
  border-bottom-color: transparent;
}
.dx-treelist .dx-link {
  color: #009688;
}
.dx-treelist .dx-row-lines > td {
  border-bottom: 1px solid #e0e0e0;
}
.dx-treelist .dx-column-lines > td {
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
}
.dx-treelist .dx-error-row .dx-closebutton {
  float: right;
  margin: 16px;
  font: 14px/14px DXIcons;
  width: 14px;
  height: 14px;
  background-position: 0 0;
  background-size: 14px 14px;
  padding: 0;
  text-align: center;
}
.dx-treelist .dx-error-row .dx-closebutton::before {
  content: "\\f00a";
}
.dx-treelist .dx-error-row .dx-error-message {
  padding: 14px 35px 14px 14px;
}
.dx-treelist .dx-row > td {
  padding: 14px 16px;
  font-size: 14px;
  line-height: 20px;
}
.dx-treelist .dx-treelist-table .dx-header-row > td {
  padding-top: 20px;
  padding-bottom: 20px;
}
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending),
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-treelist-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-treelist-select-all),
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td:not(.dx-validation-pending):not(.dx-treelist-select-all) {
  vertical-align: middle;
}
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending).dx-command-select,
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-treelist-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-treelist-select-all).dx-command-select,
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td:not(.dx-validation-pending):not(.dx-treelist-select-all).dx-command-select {
  overflow: visible;
  width: 50px;
  min-width: 50px;
  line-height: 1;
}
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending).dx-command-edit,
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-treelist-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-treelist-select-all).dx-command-edit,
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td:not(.dx-validation-pending):not(.dx-treelist-select-all).dx-command-edit {
  width: 115px;
  min-width: 115px;
}
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending).dx-command-edit.dx-command-edit-with-icons,
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-treelist-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-treelist-select-all).dx-command-edit.dx-command-edit-with-icons,
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td:not(.dx-validation-pending):not(.dx-treelist-select-all).dx-command-edit.dx-command-edit-with-icons {
  width: 93px;
  min-width: 93px;
}
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending).dx-command-edit.dx-command-edit-with-icons .dx-link,
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-treelist-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-treelist-select-all).dx-command-edit.dx-command-edit-with-icons .dx-link,
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td:not(.dx-validation-pending):not(.dx-treelist-select-all).dx-command-edit.dx-command-edit-with-icons .dx-link {
  width: 18px;
  height: 18px;
  background-position: 0 0;
  background-size: 18px 18px;
  padding: 0;
  font-size: 18px;
  text-align: center;
  line-height: 18px;
  margin: 0 2px;
  vertical-align: middle;
}
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending).dx-command-edit.dx-command-edit-with-icons .dx-link:not(.dx-link-icon),
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-treelist-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-treelist-select-all).dx-command-edit.dx-command-edit-with-icons .dx-link:not(.dx-link-icon),
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td:not(.dx-validation-pending):not(.dx-treelist-select-all).dx-command-edit.dx-command-edit-with-icons .dx-link:not(.dx-link-icon) {
  width: auto;
}
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending).dx-command-edit .dx-link.dx-state-disabled,
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-treelist-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-treelist-select-all).dx-command-edit .dx-link.dx-state-disabled,
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td:not(.dx-validation-pending):not(.dx-treelist-select-all).dx-command-edit .dx-link.dx-state-disabled {
  opacity: .38;
}
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending).dx-command-edit .dx-link.dx-state-disabled.dx-link-icon,
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-treelist-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-treelist-select-all).dx-command-edit .dx-link.dx-state-disabled.dx-link-icon,
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td:not(.dx-validation-pending):not(.dx-treelist-select-all).dx-command-edit .dx-link.dx-state-disabled.dx-link-icon {
  opacity: .6;
}
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending) .dx-treelist-group-space,
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending).dx-command-expand,
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-treelist-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-treelist-select-all) .dx-treelist-group-space,
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-treelist-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-treelist-select-all).dx-command-expand,
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td:not(.dx-validation-pending):not(.dx-treelist-select-all) .dx-treelist-group-space,
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td:not(.dx-validation-pending):not(.dx-treelist-select-all).dx-command-expand {
  padding: 0 4px 0 8px;
  line-height: 0;
}
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-cell-modified:not(.dx-field-item-content):not(.dx-validation-pending).dx-editor-cell:not(.dx-command-select),
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td.dx-treelist-invalid:not(.dx-field-item-content):not(.dx-validation-pending):not(.dx-treelist-select-all).dx-editor-cell:not(.dx-command-select),
.dx-treelist .dx-treelist-content .dx-treelist-table .dx-row > td:not(.dx-validation-pending):not(.dx-treelist-select-all).dx-editor-cell:not(.dx-command-select) {
  padding-right: 0;
  padding-left: 0;
}
.dx-treelist .dx-treelist-rowsview .dx-virtual-row > td[style*="text-align: right"]:before {
  background-position-y: 49px;
}
.dx-treelist .dx-command-drag {
  width: 56px;
  min-width: 56px;
}
.dx-treelist .dx-command-drag .dx-treelist-drag-icon {
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  font-size: 24px;
  text-align: center;
  line-height: 24px;
}
.dx-treelist-edit-popup .dx-popup-content {
  padding: 0;
}
.dx-treelist-edit-popup .dx-error-message {
  padding: 14px 16px;
}
.dx-treelist-edit-popup-form {
  padding: 24px;
}
.dx-treelist-headers .dx-texteditor-input,
.dx-treelist-rowsview .dx-texteditor-input {
  min-height: 16px;
}
.dx-treelist-headers .dx-lookup,
.dx-treelist-rowsview .dx-lookup {
  height: auto;
}
.dx-treelist-headers .dx-lookup .dx-lookup-field,
.dx-treelist-rowsview .dx-lookup .dx-lookup-field {
  padding-left: 16px;
  padding-top: 14px;
  padding-bottom: 14px;
  font-size: 14px;
}
.dx-treelist-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-invalid .dx-texteditor-input,
.dx-treelist-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-valid .dx-texteditor-input,
.dx-treelist-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-validation-pending .dx-texteditor-input,
.dx-treelist-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-invalid .dx-texteditor-input,
.dx-treelist-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-valid .dx-texteditor-input,
.dx-treelist-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-validation-pending .dx-texteditor-input {
  padding-right: 34px;
}
.dx-treelist-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-invalid.dx-rtl .dx-texteditor-input,
.dx-treelist-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-valid.dx-rtl .dx-texteditor-input,
.dx-treelist-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-validation-pending.dx-rtl .dx-texteditor-input,
.dx-treelist-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-invalid.dx-rtl .dx-texteditor-input,
.dx-treelist-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-valid.dx-rtl .dx-texteditor-input,
.dx-treelist-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-show-clear-button.dx-validation-pending.dx-rtl .dx-texteditor-input {
  padding-right: 0;
  padding-left: 34px;
}
.dx-treelist-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-invalid .dx-texteditor-input,
.dx-treelist-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-valid .dx-texteditor-input,
.dx-treelist-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-validation-pending .dx-texteditor-input,
.dx-treelist-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-invalid .dx-texteditor-input,
.dx-treelist-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-valid .dx-texteditor-input,
.dx-treelist-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-validation-pending .dx-texteditor-input {
  padding-right: 34px;
}
.dx-treelist-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-invalid.dx-rtl .dx-texteditor-input,
.dx-treelist-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-valid.dx-rtl .dx-texteditor-input,
.dx-treelist-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-validation-pending.dx-rtl .dx-texteditor-input,
.dx-treelist-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-invalid.dx-rtl .dx-texteditor-input,
.dx-treelist-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-valid.dx-rtl .dx-texteditor-input,
.dx-treelist-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-validation-pending.dx-rtl .dx-texteditor-input {
  padding-right: 0;
  padding-left: 34px;
}
.dx-treelist-headers .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-rtl .dx-texteditor-input,
.dx-treelist-rowsview .dx-dropdowneditor-button-visible.dx-dropdowneditor.dx-rtl .dx-texteditor-input {
  padding-right: 0;
}
.dx-editor-cell {
  padding-top: 0;
  padding-bottom: 0;
}
.dx-editor-cell .dx-numberbox-spin-button {
  background-color: transparent;
}
.dx-editor-cell .dx-icon-clear {
  left: 0;
}
.dx-editor-cell .dx-texteditor,
.dx-editor-cell .dx-texteditor.dx-state-active,
.dx-editor-cell .dx-texteditor.dx-state-focused,
.dx-editor-cell .dx-texteditor.dx-state-hover {
  background: rgba(255,255,255,0);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-editor-cell .dx-texteditor .dx-texteditor-input {
  background: rgba(255,255,255,0);
  font-size: 14px;
  height: 48px;
  line-height: 48px;
  padding: 0 16px;
  margin-top: 0;
}
.dx-editor-cell .dx-texteditor .dx-placeholder::before {
  padding-right: 16px;
  padding-left: 16px;
}
.dx-editor-cell .dx-texteditor.dx-validation-pending .dx-texteditor-input-container .dx-texteditor-input {
  padding-top: 0;
  padding-bottom: 0;
}
.dx-editor-cell .dx-texteditor .dx-tag-container {
  min-height: 48px;
  padding: 0;
}
.dx-editor-cell .dx-texteditor:not(.dx-editor-filled):not(.dx-editor-outlined) .dx-tag-container,
.dx-editor-cell .dx-texteditor:not(.dx-editor-filled):not(.dx-editor-outlined) .dx-texteditor-input {
  margin-top: 0;
}
.dx-editor-cell .dx-texteditor .dx-texteditor-buttons-container {
  right: 0;
}
.dx-editor-cell .dx-texteditor::after,
.dx-editor-cell .dx-texteditor::before {
  content: none;
}
.dx-editor-cell .dx-texteditor.dx-rtl .dx-texteditor-buttons-container,
.dx-rtl .dx-editor-cell .dx-texteditor .dx-texteditor-buttons-container {
  left: 0;
}
.dx-editor-cell .dx-dropdowneditor {
  background-color: rgba(255,255,255,0);
}
.dx-editor-cell.dx-focused .dx-dropdowneditor-icon {
  border-radius: 0;
}
.dx-editor-cell.dx-editor-inline-block:not(.dx-command-select)::before {
  padding-top: 14px;
  padding-bottom: 14px;
}
.dx-treelist-column-chooser-list .dx-empty-message {
  color: rgba(102,102,102,.87);
  padding: 0 24px;
}
.dx-treelist-column-chooser {
  color: rgba(0,0,0,.87);
  font-weight: 400;
  font-size: 14px;
  font-family: Roboto,RobotoFallback,"Noto Kufi Arabic",Helvetica,Arial,sans-serif;
  line-height: 1.2857;
}
.dx-treelist-column-chooser input,
.dx-treelist-column-chooser textarea {
  font-family: Roboto,RobotoFallback,"Noto Kufi Arabic",Helvetica,Arial,sans-serif;
  line-height: 1.2857;
}
.dx-treelist-column-chooser.dx-treelist-column-chooser-mode-drag .dx-popup-content {
  padding: 16px 24px 9px;
}
.dx-treelist-column-chooser.dx-treelist-column-chooser-mode-drag .dx-popup-content .dx-treeview-search {
  margin-bottom: 10px;
}
.dx-treelist-column-chooser.dx-treelist-column-chooser-mode-drag .dx-popup-content .dx-treeview-node {
  padding-left: 20px;
}
.dx-treelist-column-chooser.dx-treelist-column-chooser-mode-select .dx-popup-content {
  padding: 16px 24px 9px;
}
.dx-treelist-column-chooser .dx-overlay-content {
  background-color: #fff;
}
.dx-treelist-column-chooser .dx-overlay-content .dx-popup-title {
  background-color: transparent;
  border-bottom: 1px solid #e0e0e0;
}
.dx-treelist-column-chooser .dx-overlay-content .dx-popup-title .dx-toolbar-label {
  font-size: 20px;
}
.dx-treelist-column-chooser .dx-overlay-content .dx-popup-content .dx-column-chooser-item {
  margin: 2px 2px 8px;
  background-color: #fff;
  color: rgba(0,0,0,.54);
  font-weight: 500;
  font-size: 14px;
  padding: 14px;
  line-height: 16px;
  -webkit-box-shadow: 0 0 1px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.2);
  box-shadow: 0 0 1px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.2);
}
.dx-treelist-drag-header {
  border-color: rgba(0,150,136,.5);
  -webkit-box-shadow: 0 0 1px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.2);
  box-shadow: 0 0 1px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.2);
  color: rgba(0,0,0,.54);
  font-weight: 500;
  padding: 20px;
  background-color: #fff;
  line-height: 16px;
  font-size: 14px;
}
.dx-treelist-columns-separator {
  background-color: rgba(0,150,136,.5);
}
.dx-treelist-columns-separator-transparent {
  background-color: transparent;
}
.dx-treelist-drop-highlight > td {
  background-color: #009688;
  color: #fff;
}
.dx-treelist-drop-highlight > td .dx-header-filter {
  color: #fff;
}
.dx-treelist-drop-highlight > td .dx-checkbox .dx-checkbox-icon {
  background-color: #fff;
  color: #009688;
}
.dx-treelist-focus-overlay:after {
  content: "";
  position: absolute;
  bottom: 0;
  height: 2px;
  background-color: #33aba0;
  left: 0;
  right: 1px;
}
.dx-data-row.dx-state-hover:not(.dx-selection):not(.dx-row-inserted):not(.dx-row-removed):not(.dx-edit-row):not(.dx-row-focused) > td {
  color: rgba(0,0,0,.87);
}
.dx-data-row.dx-state-hover:not(.dx-selection):not(.dx-row-inserted):not(.dx-row-removed):not(.dx-edit-row):not(.dx-row-focused) > td:not(.dx-focused) {
  background-color: rgba(0,0,0,.04);
}
.dx-data-row.dx-state-hover:not(.dx-selection):not(.dx-row-inserted):not(.dx-row-removed):not(.dx-edit-row):not(.dx-row-focused) > .dx-treelist-readonly .dx-texteditor .dx-texteditor-input {
  background-color: rgba(0,0,0,.04);
  color: rgba(0,0,0,.87);
}
.dx-data-row.dx-state-hover:not(.dx-selection):not(.dx-row-inserted):not(.dx-row-removed):not(.dx-edit-row):not(.dx-row-focused) > td.dx-pointer-events-none {
  background-color: transparent;
}
.dx-treelist-headers {
  color: rgba(0,0,0,.54);
  -ms-touch-action: pinch-zoom;
  touch-action: pinch-zoom;
  border-bottom: 1px solid #e0e0e0;
}
.dx-treelist-headers .dx-treelist-content {
  margin-bottom: -1px;
}
.dx-treelist-borders .dx-treelist-headers .dx-treelist-table {
  border-bottom-width: 1px;
}
.dx-treelist-headers .dx-treelist-table .dx-row > td {
  border-bottom: 1px solid #e0e0e0;
  line-height: 16px;
  font-weight: 500;
  font-size: 14px;
}
.dx-treelist-headers .dx-treelist-table .dx-row>td .dx-sort,
.dx-treelist-headers .dx-treelist-table .dx-row>td .dx-sort-indicator,
.dx-treelist-headers .dx-treelist-table .dx-row>td:hover .dx-treelist-text-content {
  color: rgba(0,0,0,.87);
}
.dx-treelist-headers .dx-treelist-table .dx-row > td:hover .dx-sort {
  color: rgba(0,0,0,.38);
}
.dx-treelist-headers .dx-treelist-table .dx-row > td:hover:not(.dx-command-select):not(.dx-command-expand):not(.dx-editor-cell):not(.dx-command-edit):not(.dx-treelist-group-space) {
  background-color: rgba(0,0,0,.04);
}
.dx-treelist-headers.dx-header-multi-row .dx-treelist-content .dx-treelist-table .dx-row.dx-header-row .dx-command-select {
  padding-bottom: 19px;
}
.dx-treelist-headers.dx-header-multi-row .dx-treelist-content .dx-treelist-table .dx-row.dx-header-row > td {
  padding-top: 12px;
  padding-bottom: 12px;
  vertical-align: bottom;
  border-right: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
}
.dx-treelist-headers.dx-header-multi-row .dx-treelist-content .dx-treelist-table .dx-row.dx-header-row > td:first-child {
  border-left: none;
}
.dx-treelist-headers.dx-header-multi-row .dx-treelist-content .dx-treelist-table .dx-row.dx-header-row > td:last-child {
  border-right: none;
}
.dx-treelist-filter-row {
  background-color: #fafafa;
}
.dx-treelist-filter-row .dx-menu {
  margin-left: 0;
}
.dx-treelist-filter-row .dx-menu .dx-menu-horizontal .dx-menu-items-container {
  height: 100%;
  top: 2px;
  position: absolute;
}
.dx-treelist-filter-row .dx-menu .dx-menu-horizontal .dx-menu-items-container .dx-menu-item-wrapper {
  height: 100%;
}
.dx-treelist-filter-row .dx-menu .dx-overlay-content {
  color: rgba(117,117,117,.87);
}
.dx-treelist-filter-row .dx-filter-modified {
  background-color: rgba(139,195,74,.32);
}
.dx-treelist-filter-row td .dx-editor-container .dx-filter-range-content {
  padding: 14px 16px 14px 40px;
}
.dx-treelist .dx-treelist-table .dx-treelist-filter-row > td {
  padding-top: 0;
  padding-bottom: 0;
}
.dx-treelist-filter-range-overlay .dx-overlay-content {
  overflow: inherit;
  background-color: #fafafa;
  -webkit-box-shadow: 0 0 1px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.2);
  box-shadow: 0 0 1px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.2);
}
.dx-treelist-filter-range-overlay .dx-overlay-content .dx-texteditor.dx-state-focused::after,
.dx-treelist-filter-range-overlay .dx-overlay-content .dx-texteditor.dx-state-hover::after {
  top: auto;
  bottom: 0;
}
.dx-treelist-filter-range-overlay .dx-overlay-content .dx-texteditor .dx-texteditor-input {
  font-size: 14px;
  height: 49px;
  padding-right: 12px;
  padding-left: 12px;
}
.dx-treelist-filter-range-overlay .dx-overlay-content .dx-texteditor .dx-placeholder::before {
  padding-left: 12px;
}
.dx-treelist-filter-range-overlay .dx-overlay-content .dx-invalid-message.dx-overlay-wrapper {
  display: none;
}
.dx-cell-modified,
.dx-treelist-invalid {
  padding: 14px 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dx-treelist-header-panel {
  border-bottom: 1px solid #e0e0e0;
  padding: 0 16px;
  background-color: #fff;
}
.dx-treelist-header-panel .dx-apply-button {
  background-color: transparent;
  color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-treelist-header-panel .dx-apply-button .dx-icon {
  color: #fff;
}
.dx-treelist-header-panel .dx-apply-button.dx-state-focused,
.dx-treelist-header-panel .dx-apply-button.dx-state-hover {
  background-color: rgba(139,195,74,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-treelist-header-panel .dx-apply-button.dx-state-active {
  background-color: rgba(139,195,74,.36);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-treelist-header-panel .dx-apply-button.dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-treelist-header-panel .dx-apply-button.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-treelist-header-panel .dx-apply-button.dx-state-disabled .dx-button-text,
.dx-treelist-header-panel .dx-apply-button.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-treelist-header-panel .dx-apply-button .dx-inkripple-wave {
  background-color: rgba(255,255,255,.2);
}
.dx-treelist-header-panel .dx-toolbar-text-auto-hide .dx-button.dx-button-has-icon {
  border-radius: 50%;
}
.dx-treelist-header-panel .dx-treelist-toolbar-button .dx-icon {
  color: rgba(0,0,0,.87);
}
.dx-icon-column-chooser {
  font: 14px/1 DXIcons;
}
.dx-icon-column-chooser::before {
  content: "\\f04d";
}
.dx-treelist-addrow-button .dx-icon-edit-button-addrow {
  font: 24px/24px DXIcons;
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  text-align: center;
}
.dx-treelist-addrow-button .dx-icon-edit-button-addrow::before {
  content: "\\f00b";
}
.dx-treelist-cancel-button .dx-icon-edit-button-cancel {
  font: 24px/24px DXIcons;
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  text-align: center;
}
.dx-treelist-cancel-button .dx-icon-edit-button-cancel::before {
  content: "\\f04c";
}
.dx-treelist-save-button .dx-icon-edit-button-save {
  font: 24px/24px DXIcons;
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  text-align: center;
}
.dx-treelist-save-button .dx-icon-edit-button-save::before {
  content: "\\f041";
}
.dx-apply-button .dx-icon-apply-filter {
  font: 24px/24px DXIcons;
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  text-align: center;
}
.dx-apply-button .dx-icon-apply-filter::before {
  content: "\\f050";
}
.dx-datagrid-export-menu .dx-menu-item .dx-icon-exportselected,
.dx-datagrid-export-menu .dx-menu-item .dx-icon-xlsxfile {
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  font-size: 24px;
  text-align: center;
  line-height: 24px;
}
.dx-treelist-adaptive-more {
  vertical-align: middle;
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  font-size: 24px;
  text-align: center;
  line-height: 24px;
  color: rgba(0,0,0,.54);
}
.dx-row.dx-row-focused .dx-treelist-adaptive-more {
  color: inherit;
}
.dx-treelist-rowsview {
  border-top: 1px solid #e0e0e0;
}
.dx-treelist-headers + .dx-treelist-rowsview,
.dx-treelist-rowsview.dx-treelist-after-headers {
  border-top: none;
}
.dx-treelist-rowsview .dx-row {
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
}
.dx-treelist-rowsview .dx-row:focus {
  outline: 0;
}
.dx-treelist-rowsview .dx-row.dx-edit-row:first-child > td {
  border-top-width: 0;
  border-bottom: 1px solid #e0e0e0;
}
.dx-treelist-rowsview .dx-row.dx-edit-row > td {
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
}
.dx-treelist-rowsview .dx-master-detail-row > .dx-master-detail-cell {
  padding: 16px;
}
.dx-treelist-rowsview .dx-master-detail-row .dx-master-detail-cell,
.dx-treelist-rowsview .dx-master-detail-row > .dx-treelist-group-space {
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
}
.dx-treelist-rowsview .dx-master-detail-row:not(.dx-treelist-edit-form) .dx-master-detail-cell,
.dx-treelist-rowsview .dx-master-detail-row:not(.dx-treelist-edit-form) > .dx-treelist-group-space {
  background-color: #fafafa;
}
.dx-treelist-rowsview .dx-adaptive-detail-row.dx-selection:hover:not(.dx-edit-row) .dx-cell-modified,
.dx-treelist-rowsview .dx-adaptive-detail-row.dx-selection:not(.dx-edit-row) .dx-cell-modified,
.dx-treelist-rowsview .dx-adaptive-detail-row:not(.dx-edit-row) .dx-cell-modified,
.dx-treelist-rowsview .dx-data-row.dx-selection:hover:not(.dx-edit-row) .dx-cell-modified,
.dx-treelist-rowsview .dx-data-row.dx-selection:not(.dx-edit-row) .dx-cell-modified,
.dx-treelist-rowsview .dx-data-row:not(.dx-edit-row) .dx-cell-modified {
  background-color: rgba(139,195,74,.32);
}
.dx-treelist-rowsview .dx-adaptive-detail-row .dx-validator.dx-invalid,
.dx-treelist-rowsview .dx-adaptive-detail-row .dx-validator.dx-treelist-invalid,
.dx-treelist-rowsview .dx-adaptive-detail-row.dx-selection .dx-validator.dx-invalid,
.dx-treelist-rowsview .dx-adaptive-detail-row.dx-selection .dx-validator.dx-treelist-invalid,
.dx-treelist-rowsview .dx-adaptive-detail-row.dx-selection:hover .dx-validator.dx-invalid,
.dx-treelist-rowsview .dx-adaptive-detail-row.dx-selection:hover .dx-validator.dx-treelist-invalid,
.dx-treelist-rowsview .dx-data-row .dx-validator.dx-invalid,
.dx-treelist-rowsview .dx-data-row .dx-validator.dx-treelist-invalid,
.dx-treelist-rowsview .dx-data-row.dx-selection .dx-validator.dx-invalid,
.dx-treelist-rowsview .dx-data-row.dx-selection .dx-validator.dx-treelist-invalid,
.dx-treelist-rowsview .dx-data-row.dx-selection:hover .dx-validator.dx-invalid,
.dx-treelist-rowsview .dx-data-row.dx-selection:hover .dx-validator.dx-treelist-invalid {
  background-color: rgba(244,67,54,.32);
}
.dx-treelist-rowsview .dx-overlay-wrapper.dx-invalid-message .dx-overlay-content {
  padding: 9px 17px;
  background-color: #f44336;
  color: #fff;
}
.dx-treelist-rowsview .dx-row-removed > td {
  background-color: #e0e0e0;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  color: rgba(0,0,0,.54);
}
.dx-treelist-rowsview .dx-adaptive-detail-row .dx-field-item-label {
  padding-top: 0;
}
.dx-treelist-rowsview .dx-adaptive-detail-row .dx-field-item-content {
  line-height: 40px;
  min-height: 40px;
  font-size: 14px;
}
.dx-treelist-rowsview .dx-adaptive-detail-row .dx-field-item-content.dx-focused {
  padding: 0;
}
.dx-treelist-rowsview .dx-adaptive-detail-row .dx-texteditor-input {
  font-size: 14px;
  height: 40px;
  line-height: 40px;
}
.dx-treelist-rowsview .dx-adaptive-detail-row .dx-texteditor::after,
.dx-treelist-rowsview .dx-adaptive-detail-row .dx-texteditor::before {
  content: none;
}
.dx-treelist-rowsview .dx-adaptive-detail-row .dx-texteditor.dx-editor-outlined {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-treelist-rowsview .dx-item-modified {
  background-color: rgba(139,195,74,.32);
}
.dx-treelist-rowsview .dx-row-focused.dx-data-row .dx-command-edit .dx-link,
.dx-treelist-rowsview .dx-row-focused.dx-data-row > td:not(.dx-focused):not(.dx-cell-modified) {
  background-color: #33aba0;
  color: #fff;
}
.dx-treelist-rowsview .dx-row-focused.dx-data-row .dx-command-edit .dx-link .dx-treelist-group-closed,
.dx-treelist-rowsview .dx-row-focused.dx-data-row .dx-command-edit .dx-link .dx-treelist-group-opened,
.dx-treelist-rowsview .dx-row-focused.dx-data-row > td:not(.dx-focused):not(.dx-cell-modified) .dx-treelist-group-closed,
.dx-treelist-rowsview .dx-row-focused.dx-data-row > td:not(.dx-focused):not(.dx-cell-modified) .dx-treelist-group-opened {
  color: #fff;
}
.dx-treelist-rowsview .dx-row-focused.dx-data-row .dx-command-edit .dx-link:focus {
  background-color: #fff;
  color: #009688;
}
.dx-treelist-rowsview .dx-row-focused.dx-data-row > td,
.dx-treelist-rowsview .dx-row-focused.dx-data-row > tr:last-child > td {
  border-bottom: 2px solid #33aba0;
}
.dx-treelist-rowsview .dx-row-focused.dx-data-row:not(.dx-row-lines) > td,
.dx-treelist-rowsview .dx-row-focused.dx-data-row:not(.dx-row-lines) > tr:first-child > td {
  border-top: 1px solid #33aba0;
  border-bottom: 1px solid #33aba0;
}
.dx-treelist-rowsview .dx-row-focused.dx-data-row.dx-edit-row > td.dx-editor-cell:not(.dx-command-select),
.dx-treelist-rowsview .dx-row-focused.dx-data-row.dx-edit-row > tr > td.dx-editor-cell:not(.dx-command-select) {
  background-color: #fff;
  color: rgba(0,0,0,.87);
}
.dx-treelist-rowsview .dx-row-focused.dx-group-row {
  background-color: #33aba0;
  color: #fff;
}
.dx-treelist-rowsview .dx-row-focused.dx-group-row .dx-treelist-group-closed,
.dx-treelist-rowsview .dx-row-focused.dx-group-row .dx-treelist-group-opened {
  color: #fff;
}
.dx-treelist-rowsview .dx-selection.dx-row:not(.dx-row-focused) > td,
.dx-treelist-rowsview .dx-selection.dx-row:not(.dx-row-focused) > tr > td,
.dx-treelist-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover > td,
.dx-treelist-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover > tr > td {
  background-color: rgba(0,150,136,.04);
  color: rgba(0,0,0,.87);
}
.dx-treelist-rowsview .dx-selection.dx-row:not(.dx-row-focused) > td.dx-treelist-group-space,
.dx-treelist-rowsview .dx-selection.dx-row:not(.dx-row-focused) > tr > td.dx-treelist-group-space,
.dx-treelist-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover > td.dx-treelist-group-space,
.dx-treelist-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover > tr > td.dx-treelist-group-space {
  border-right-color: rgba(0,150,136,.04);
}
.dx-treelist-rowsview .dx-selection.dx-row:not(.dx-row-focused) > td.dx-pointer-events-none,
.dx-treelist-rowsview .dx-selection.dx-row:not(.dx-row-focused) > tr > td.dx-pointer-events-none,
.dx-treelist-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover > td.dx-pointer-events-none,
.dx-treelist-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover > tr > td.dx-pointer-events-none {
  border-left-color: #e0e0e0;
  border-right-color: #e0e0e0;
}
.dx-treelist-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover:not(.dx-row-lines) > td,
.dx-treelist-rowsview .dx-selection.dx-row:not(.dx-row-focused):not(.dx-row-lines) > td {
  border-bottom: 1px solid rgba(0,150,136,.04);
  border-top: 1px solid rgba(0,150,136,.04);
}
.dx-treelist-rowsview .dx-selection.dx-row:not(.dx-row-focused).dx-row-lines > td,
.dx-treelist-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover.dx-row-lines > td {
  border-bottom-color: #e0e0e0;
}
.dx-treelist-rowsview.dx-scrollable-scrollbars-alwaysvisible.dx-scrollable-both .dx-scrollable-wrapper .dx-scrollable-container .dx-scrollable-content {
  padding-right: 0;
}
.dx-treelist-rowsview td.dx-validation-pending {
  position: relative;
  padding: 0;
}
.dx-treelist-rowsview td.dx-validation-pending .dx-treelist-invalid,
.dx-treelist-rowsview td.dx-validation-pending.dx-cell-modified {
  padding: 14px 46px 14px 16px;
}
.dx-rtl .dx-treelist-rowsview td.dx-validation-pending .dx-treelist-invalid,
.dx-rtl .dx-treelist-rowsview td.dx-validation-pending.dx-cell-modified,
.dx-rtl.dx-treelist-rowsview td.dx-validation-pending .dx-treelist-invalid,
.dx-rtl.dx-treelist-rowsview td.dx-validation-pending.dx-cell-modified {
  padding-left: 46px;
  padding-right: 16px;
}
.dx-treelist-rowsview td.dx-validation-pending > .dx-pending-indicator {
  pointer-events: none;
  position: absolute;
  top: 50%;
  margin-top: -11px;
  width: 22px;
  height: 22px;
  right: 22px;
  background-color: transparent;
}
.dx-rtl .dx-treelist-rowsview td.dx-validation-pending > .dx-pending-indicator,
.dx-rtl.dx-treelist-rowsview td.dx-validation-pending > .dx-pending-indicator {
  right: auto;
  left: 22px;
}
.dx-treelist-search-text {
  color: #fff;
  background-color: #009688;
}
.dx-treelist-nodata {
  color: rgba(102,102,102,.87);
  font-size: 17px;
}
.dx-treelist-bottom-load-panel {
  border-top: 1px solid #e0e0e0;
  background-color: #fff;
}
.dx-treelist-summary-item {
  color: rgba(0,0,0,.7);
}
.dx-treelist-total-footer {
  position: relative;
  border-bottom: 1px solid #e0e0e0;
  border-top: 1px solid #e0e0e0;
}
.dx-treelist-total-footer > .dx-treelist-content {
  padding: 0;
}
.dx-treelist-revert-tooltip .dx-overlay-content {
  background-color: transparent;
  min-width: inherit;
}
.dx-treelist-revert-tooltip .dx-revert-button {
  border-radius: 4px;
  background-color: #f44336;
  color: #fff;
  -webkit-box-shadow: none;
  margin: 0 0 0 1px;
  height: 48px;
  box-shadow: none;
  min-width: inherit;
}
.dx-treelist-revert-tooltip .dx-revert-button .dx-button-content {
  padding: 2px;
}
.dx-treelist-revert-tooltip .dx-revert-button .dx-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
  margin-right: 0;
  margin-left: 0;
  color: #fff;
}
.dx-rtl .dx-treelist-revert-tooltip .dx-revert-button .dx-icon,
.dx-rtl.dx-treelist-revert-tooltip .dx-revert-button .dx-icon,
.dx-treelist-revert-tooltip .dx-revert-button .dx-icon.dx-icon-right {
  margin-left: 0;
  margin-right: 0;
}
.dx-rtl .dx-treelist-revert-tooltip .dx-revert-button .dx-icon.dx-icon-right,
.dx-rtl.dx-treelist-revert-tooltip .dx-revert-button .dx-icon.dx-icon-right {
  margin-right: 0;
  margin-left: 0;
}
.dx-treelist-revert-tooltip .dx-revert-button.dx-state-active,
.dx-treelist-revert-tooltip .dx-revert-button.dx-state-focused,
.dx-treelist-revert-tooltip .dx-revert-button.dx-state-hover {
  background-color: #f44336;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-treelist-revert-tooltip .dx-revert-button.dx-state-disabled {
  background: rgba(0,0,0,.1);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-treelist-revert-tooltip .dx-revert-button.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-treelist-revert-tooltip .dx-revert-button.dx-state-disabled .dx-button-text,
.dx-treelist-revert-tooltip .dx-revert-button.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-treelist-revert-tooltip .dx-revert-button .dx-inkripple-wave {
  background-color: rgba(255,255,255,.2);
}
.dx-treelist-revert-tooltip .dx-revert-button.dx-button-has-icon:not(.dx-button-has-text) {
  border-radius: 2px;
}
.dx-treelist-revert-tooltip .dx-revert-button.dx-state-hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-rtl .dx-data-row.dx-state-hover:not(.dx-selection):not(.dx-row-inserted):not(.dx-row-removed):not(.dx-edit-row):not(.dx-row-focused) > td:not(.dx-focused).dx-treelist-group-space {
  border-left-color: rgba(0,0,0,.04);
  border-right-color: transparent;
}
.dx-rtl .dx-treelist .dx-menu .dx-menu-item-has-submenu.dx-menu-item-has-icon .dx-icon,
.dx-rtl .dx-treelist-container .dx-menu .dx-menu-item-has-submenu.dx-menu-item-has-icon .dx-icon {
  margin: 0 3px;
}
.dx-rtl .dx-treelist-rowsview .dx-selection.dx-row > td,
.dx-rtl .dx-treelist-rowsview .dx-selection.dx-row > tr > td,
.dx-rtl .dx-treelist-rowsview .dx-selection.dx-row:hover > td,
.dx-rtl .dx-treelist-rowsview .dx-selection.dx-row:hover > tr > td {
  border-right-color: #e0e0e0;
}
.dx-rtl .dx-treelist-rowsview .dx-selection.dx-row > td:not(.dx-focused).dx-treelist-group-space,
.dx-rtl .dx-treelist-rowsview .dx-selection.dx-row > tr > td:not(.dx-focused).dx-treelist-group-space,
.dx-rtl .dx-treelist-rowsview .dx-selection.dx-row:hover > td:not(.dx-focused).dx-treelist-group-space,
.dx-rtl .dx-treelist-rowsview .dx-selection.dx-row:hover > tr > td:not(.dx-focused).dx-treelist-group-space {
  border-left-color: rgba(0,150,136,.04);
}
.dx-rtl .dx-treelist-rowsview .dx-selection.dx-row > td.dx-pointer-events-none,
.dx-rtl .dx-treelist-rowsview .dx-selection.dx-row > tr > td.dx-pointer-events-none,
.dx-rtl .dx-treelist-rowsview .dx-selection.dx-row:hover > td.dx-pointer-events-none,
.dx-rtl .dx-treelist-rowsview .dx-selection.dx-row:hover > tr > td.dx-pointer-events-none {
  border-left-color: #e0e0e0;
}
.dx-rtl .dx-treelist-rowsview.dx-scrollable-scrollbars-alwaysvisible.dx-scrollable-both .dx-scrollable-wrapper .dx-scrollable-container .dx-scrollable-content {
  padding-left: 0;
}
.dx-header-filter-menu .dx-popup-content {
  padding: 12px 8px 0;
  border-bottom: 1px solid #e0e0e0;
}
.dx-treelist-form-buttons-container .dx-button {
  background-color: transparent;
  color: #009688;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-treelist-form-buttons-container .dx-button .dx-icon {
  color: #009688;
}
.dx-treelist-form-buttons-container .dx-button.dx-state-focused,
.dx-treelist-form-buttons-container .dx-button.dx-state-hover {
  background-color: rgba(0,150,136,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-treelist-form-buttons-container .dx-button.dx-state-active {
  background-color: rgba(0,150,136,.36);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-treelist-form-buttons-container .dx-button.dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-treelist-form-buttons-container .dx-button.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-treelist-form-buttons-container .dx-button.dx-state-disabled .dx-button-text,
.dx-treelist-form-buttons-container .dx-button.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-treelist-form-buttons-container .dx-button .dx-inkripple-wave {
  background-color: rgba(0,150,136,.2);
}
.dx-command-adaptive {
  width: 56px;
  min-width: 56px;
}
.dx-treelist-filter-panel {
  padding: 18px 16px;
}
.dx-treelist-filter-panel .dx-treelist-filter-panel-clear-filter,
.dx-treelist-filter-panel .dx-treelist-filter-panel-text {
  color: #009688;
  font-size: 14px;
  line-height: 18px;
}
.dx-treelist-filter-panel .dx-icon-filter {
  color: #009688;
}
.dx-adaptive-item-text {
  padding-left: 16px;
  padding-right: 16px;
}
.dx-adaptive-item-text.dx-cell-modified,
.dx-adaptive-item-text.dx-treelist-invalid {
  padding-top: 0;
  padding-bottom: 0;
}
.dx-treelist-rowsview .dx-treelist-empty-space {
  position: relative;
  top: -2px;
  display: inline-block;
  font: 14px/1 DXIcons;
  width: 24px;
}
.dx-treelist-rowsview .dx-treelist-empty-space::before {
  content: "\\f014";
  visibility: hidden;
}
.dx-treelist-rowsview tr:not(.dx-row-focused) .dx-treelist-empty-space {
  color: rgba(98,98,98,.54);
}
.dx-treelist-rowsview .dx-treelist-expanded span {
  font: 24px/24px DXIcons;
  text-align: center;
  cursor: pointer;
}
.dx-treelist-rowsview .dx-treelist-expanded span::before {
  content: "\\f016";
  position: absolute;
  display: block;
  width: 24px;
  top: 50%;
  left: 0;
  margin-left: -5px;
  margin-top: -12px;
}
.dx-treelist-rowsview .dx-treelist-collapsed span {
  font: 24px/24px DXIcons;
  text-align: center;
  cursor: pointer;
}
.dx-treelist-rowsview .dx-treelist-collapsed span::before {
  content: "\\f010";
  position: absolute;
  display: block;
  width: 24px;
  top: 50%;
  left: 0;
  margin-left: -6px;
  margin-top: -12px;
}
.dx-treelist-rowsview .dx-header-filter,
.dx-treelist-rowsview .dx-sort-down,
.dx-treelist-rowsview .dx-sort-up {
  vertical-align: middle;
}
.dx-treelist-rowsview tr:not(.dx-row-focused).dx-selection .dx-treelist-empty-space {
  color: rgba(98,98,98,.54);
}
.dx-treelist-rowsview .dx-treelist-cell-expandable {
  white-space: nowrap;
}
.dx-treelist-rowsview .dx-treelist-cell-expandable .dx-treelist-text-content {
  white-space: normal;
}
.dx-treelist-rowsview.dx-treelist-nowrap .dx-treelist-table .dx-treelist-cell-expandable .dx-treelist-text-content {
  white-space: nowrap;
}
.dx-treelist-checkbox-size {
  vertical-align: middle;
  line-height: 0;
}
.dx-treelist-cell-expandable .dx-checkbox,
.dx-treelist-select-all .dx-checkbox {
  position: absolute;
}
.dx-treelist-icon-container {
  max-height: 20px;
}
.dx-treelist-icon-container.dx-editor-inline-block {
  position: relative;
  padding-right: 34px;
}
.dx-treelist-icon-container.dx-editor-inline-block .dx-checkbox {
  top: 50%;
  margin-top: -9px;
}
.dx-treelist-select-all {
  position: relative;
}
.dx-treelist-select-all .dx-checkbox {
  left: 40px;
}
.dx-treelist .dx-treelist-headers .dx-treelist-content .dx-treelist-table .dx-header-row > .dx-treelist-select-all {
  padding-left: 74px;
}
.dx-rtl .dx-treelist-rowsview .dx-treelist-collapsed,
.dx-rtl .dx-treelist-rowsview .dx-treelist-expanded {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
.dx-rtl .dx-treelist-rowsview .dx-treelist-table-fixed .dx-treelist-icon-container {
  float: right;
}
.dx-rtl .dx-treelist-select-all .dx-checkbox {
  left: calc(100% - 58px);
}
.dx-rtl.dx-treelist .dx-treelist-headers .dx-treelist-content .dx-treelist-table .dx-header-row > .dx-treelist-select-all {
  padding-right: 74px;
  padding-left: 16px;
}
.dx-rtl .dx-treelist-icon-container.dx-editor-inline-block {
  padding-left: 34px;
  padding-right: 0;
}
.dx-pivotgrid-fields-container .dx-header-filter,
.dx-pivotgrid-fields-container .dx-sort {
  display: inline-block;
}
.dx-pivotgrid-fields-container.dx-drag .dx-area-field-content {
  display: inline-block;
}
.dx-pivotgrid-fields-container.dx-drag .dx-column-indicators {
  float: none;
  display: inline-block;
}
.dx-pivotgrid-nodata {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  text-align: center;
  -webkit-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
}
.dx-pivotgrid {
  cursor: default;
  width: 100%;
  position: relative;
  background-color: #fff;
}
.dx-pivotgrid.dx-overflow-hidden {
  overflow: hidden;
}
.dx-pivotgrid .dx-area-column-cell,
.dx-pivotgrid .dx-area-data-cell {
  width: 100%;
}
.dx-pivotgrid .dx-area-data-cell {
  position: relative;
}
.dx-pivotgrid table,
.dx-pivotgrid tbody,
.dx-pivotgrid td,
.dx-pivotgrid tfoot,
.dx-pivotgrid th,
.dx-pivotgrid thead,
.dx-pivotgrid tr {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
}
.dx-pivotgrid table {
  border-collapse: collapse;
  table-layout: auto;
  border-spacing: 0;
}
.dx-pivotgrid td {
  vertical-align: top;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
.dx-pivotgrid .dx-area-description-cell {
  position: relative;
  background-clip: padding-box;
  white-space: nowrap;
}
.dx-pivotgrid .dx-area-description-cell .dx-pivotgrid-fields-area {
  position: absolute;
  bottom: 0;
}
.dx-pivotgrid .dx-area-field-content,
.dx-pivotgrid .dx-column-indicators {
  display: inline-block;
}
.dx-pivotgrid .dx-expand-icon-container {
  position: relative;
  display: inline-block;
}
.dx-pivotgrid .dx-incompressible-fields .dx-pivotgrid-fields-area {
  position: static;
}
.dx-pivotgrid .dx-incompressible-fields .dx-pivotgrid-fields-area:not(.dx-hidden) {
  display: table-cell;
}
.dx-pivotgrid .dx-incompressible-fields .dx-column-indicators {
  vertical-align: top;
  float: none!important;
}
.dx-pivotgrid .dx-incompressible-fields .dx-area-field {
  display: inline-block;
  white-space: nowrap;
}
.dx-pivotgrid .dx-area-field,
.dx-pivotgrid .dx-area-field-content {
  white-space: nowrap;
}
.dx-pivotgrid .dx-popup-content .dx-column-indicators {
  float: none!important;
  display: inline-block;
}
.dx-pivotgrid .dx-popup-content .dx-area-field-content {
  display: inline-block;
}
.dx-pivotgrid .dx-pivotgrid-area {
  white-space: nowrap;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
.dx-pivotgrid .dx-pivotgrid-collapsed,
.dx-pivotgrid .dx-pivotgrid-expanded {
  cursor: pointer;
}
.dx-pivotgrid .dx-pivotgrid-collapsed .dx-expand,
.dx-pivotgrid .dx-pivotgrid-expanded .dx-expand {
  display: inline-block;
}
.dx-pivotgrid .dx-word-wrap .dx-pivotgrid-area {
  white-space: normal;
}
.dx-pivotgrid .dx-word-wrap .dx-pivotgrid-collapsed,
.dx-pivotgrid .dx-word-wrap .dx-pivotgrid-expanded,
.dx-pivotgrid .dx-word-wrap .dx-pivotgrid-sorted {
  white-space: nowrap;
}
.dx-pivotgrid .dx-word-wrap .dx-pivotgrid-collapsed > span,
.dx-pivotgrid .dx-word-wrap .dx-pivotgrid-expanded > span,
.dx-pivotgrid .dx-word-wrap .dx-pivotgrid-sorted > span {
  white-space: normal;
}
.dx-pivotgrid .dx-word-wrap .dx-pivotgrid-collapsed > span,
.dx-pivotgrid .dx-word-wrap .dx-pivotgrid-expanded > span {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}
.dx-pivotgridfieldchooser {
  position: relative;
  background-color: #fff;
}
.dx-pivotgridfieldchooser .dx-pivotgridfieldchooser-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  overflow: hidden;
  height: 100%;
}
.dx-pivotgridfieldchooser .dx-pivotgridfieldchooser-container.dx-layout-0,
.dx-pivotgridfieldchooser .dx-pivotgridfieldchooser-container.dx-layout-2 {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.dx-pivotgridfieldchooser .dx-pivotgridfieldchooser-container.dx-layout-2 .dx-row:first-child {
  -webkit-box-flex: 3;
  -ms-flex-positive: 3;
  flex-grow: 3;
}
.dx-pivotgridfieldchooser .dx-pivotgridfieldchooser-container.dx-layout-2 .dx-row:nth-child(2) {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 4;
  -ms-flex-positive: 4;
  flex-grow: 4;
}
.dx-pivotgridfieldchooser .dx-col {
  width: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.dx-pivotgridfieldchooser .dx-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  height: 0;
}
.dx-pivotgridfieldchooser .dx-pivotgridfieldchooser-container .dx-row:first-child {
  -webkit-box-flex: 2;
  -ms-flex-positive: 2;
  flex-grow: 2;
}
.dx-pivotgridfieldchooser .dx-pivotgridfieldchooser-container .dx-row:nth-child(2) {
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
}
.dx-pivotgridfieldchooser .dx-area-caption {
  vertical-align: middle;
}
.dx-pivotgrid-action {
  cursor: pointer;
}
.dx-pivotgrid-drag-action {
  -ms-touch-action: pinch-zoom;
  touch-action: pinch-zoom;
}
.dx-pivotgrid-scrollbar-measure-element {
  position: absolute;
  top: -9999px;
  width: 100px;
  height: 100px;
  overflow: scroll;
}
.dx-pivotgrid-fields-container .dx-position-indicator.dx-position-indicator-vertical {
  margin-top: -4px;
  margin-left: -1px;
  height: 2px;
}
.dx-pivotgrid-fields-container .dx-position-indicator.dx-position-indicator-vertical.dx-position-indicator-last {
  margin-top: -3px;
}
.dx-pivotgrid-fields-container .dx-position-indicator.dx-position-indicator-horizontal {
  margin-left: -3px;
  width: 2px;
}
.dx-pivotgrid-fields-container .dx-position-indicator.dx-position-indicator-horizontal.dx-position-indicator-last {
  margin-left: 3px;
}
.dx-pivotgrid-fields-container .dx-area-fields {
  position: relative;
}
.dx-pivotgrid-fields-container .dx-sort {
  color: rgba(0,0,0,.54);
  font-size: 14px;
  width: 14px;
}
.dx-pivotgrid-fields-container .dx-sort-up {
  font: 14px/1 DXIcons;
}
.dx-pivotgrid-fields-container .dx-sort-up::before {
  content: "\\f051";
}
.dx-pivotgrid-fields-container .dx-sort-down {
  font: 14px/1 DXIcons;
}
.dx-pivotgrid-fields-container .dx-sort-down::before {
  content: "\\f052";
}
.dx-pivotgrid-fields-container .dx-header-filter {
  color: rgba(0,0,0,.54);
  font: 14px/1 DXIcons;
  width: 14px;
}
.dx-pivotgrid-fields-container .dx-header-filter::before {
  content: "\\f050";
}
.dx-pivotgrid-fields-container .dx-header-filter-empty {
  color: rgba(0,0,0,.38);
}
.dx-pivotgrid-fields-container .dx-area-field {
  cursor: pointer;
}
.dx-pivotgrid-fields-container.dx-drag {
  opacity: .8;
}
.dx-pivotgrid-fields-container.dx-drag .dx-area-field.dx-area-box {
  -webkit-box-shadow: 0 0 1px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.2);
  box-shadow: 0 0 1px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.2);
  border: 1px solid rgba(0,150,136,.5);
}
.dx-pivotgrid-fields-container .dx-area-field.dx-area-box {
  margin-bottom: 4px;
  border: 1px solid #e0e0e0;
  padding: 7px 10px;
}
.dx-pivotgrid-fields-container .dx-drag-source {
  opacity: .5;
}
.dx-pivotgrid-fields-container .dx-column-indicators {
  vertical-align: bottom;
  margin-left: 6px;
  line-height: 12px;
}
.dx-pivotgrid-fields-container .dx-area-field-content {
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}
.dx-pivotgrid .dx-column-header .dx-pivotgrid-fields-area,
.dx-pivotgrid .dx-filter-header .dx-pivotgrid-fields-area {
  overflow: hidden;
}
.dx-pivotgrid .dx-column-header .dx-pivotgrid-toolbar,
.dx-pivotgrid .dx-filter-header .dx-pivotgrid-toolbar {
  margin-right: 10px;
  float: right;
  display: inline-block;
}
.dx-pivotgrid .dx-column-header .dx-pivotgrid-toolbar .dx-button,
.dx-pivotgrid .dx-filter-header .dx-pivotgrid-toolbar .dx-button {
  margin-top: 10px;
}
.dx-pivotgrid .dx-column-header .dx-pivotgrid-toolbar .dx-pivotgrid-field-chooser-button,
.dx-pivotgrid .dx-filter-header .dx-pivotgrid-toolbar .dx-pivotgrid-field-chooser-button {
  margin-right: 4px;
}
.dx-pivotgrid .dx-area-description-cell.dx-pivotgrid-background,
.dx-pivotgrid .dx-column-header,
.dx-pivotgrid .dx-data-header {
  background-color: rgba(221,221,221,.2);
}
.dx-pivotgrid .dx-column-header .dx-pivotgrid-fields-area-head tr > td:first-child {
  padding-left: 0;
}
.dx-pivotgrid .dx-filter-header .dx-area-field-container {
  border-spacing: 8px 12px;
  border-collapse: separate;
}
.dx-pivotgrid .dx-filter-header .dx-pivotgrid-fields-area-head td {
  padding: 2px;
}
.dx-pivotgrid .dx-filter-header .dx-pivotgrid-fields-area-head tr > td:first-child {
  padding-left: 2px;
}
.dx-pivotgrid .dx-area-field.dx-area-box {
  margin-bottom: 0;
}
.dx-pivotgrid.dx-row-lines .dx-pivotgrid-area td {
  border-top: 1px solid #e0e0e0;
}
.dx-pivotgrid.dx-row-lines .dx-pivotgrid-area-data tr:first-child > td {
  border-top-width: 0;
}
.dx-pivotgrid .dx-area-description-cell,
.dx-pivotgrid .dx-area-row-cell {
  border-right: 1px solid #e0e0e0;
}
.dx-pivotgrid .dx-area-description-cell .dx-pivotgrid-toolbar .dx-button {
  margin: 1px;
}
.dx-pivotgrid .dx-area-description-cell .dx-pivotgrid-toolbar .dx-button:not(.dx-state-hover):not(.dx-state-active) {
  border-color: transparent;
  background-color: transparent;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-pivotgrid .dx-area-column-cell,
.dx-pivotgrid .dx-area-description-cell,
.dx-pivotgrid .dx-bottom-border {
  border-bottom: 1px solid #e0e0e0;
}
.dx-pivotgrid .dx-pivotgrid-fields-area-head td {
  position: relative;
  border: none;
  padding: 14px 2px;
}
.dx-pivotgrid .dx-pivotgrid-fields-area-head tr > td:first-child {
  padding-left: 10px;
}
.dx-pivotgrid .dx-pivotgrid-fields-area-head tr > td:last-child {
  padding-right: 10px;
}
.dx-pivotgrid .dx-pivotgrid-fields-area-head .dx-empty-area-text {
  white-space: nowrap;
  padding: 5px 0;
  border: 1px solid transparent;
  color: rgba(0,0,0,.3);
}
.dx-pivotgrid .dx-group-connector {
  position: absolute;
  width: 2px;
  top: 50%;
  height: 2px;
  margin-top: -1px;
  background-color: #e0e0e0;
}
.dx-pivotgrid .dx-group-connector.dx-group-connector-prev {
  left: 0;
}
.dx-pivotgrid .dx-group-connector.dx-group-connector-next {
  right: 0;
}
.dx-pivotgrid .dx-virtual-content {
  display: none;
}
.dx-pivotgrid .dx-virtual-mode .dx-virtual-content {
  position: relative;
  overflow: hidden;
  display: block;
}
.dx-pivotgrid .dx-virtual-mode .dx-virtual-content table td {
  color: transparent;
  background-color: transparent!important;
}
.dx-pivotgrid .dx-virtual-mode .dx-virtual-content table td span {
  visibility: hidden;
}
.dx-pivotgrid .dx-virtual-mode table {
  position: absolute;
}
.dx-pivotgrid .dx-pivotgrid-area-data {
  position: relative;
}
.dx-pivotgrid .dx-pivotgrid-area-data tbody td {
  text-align: right;
  color: rgba(0,0,0,.87);
  white-space: nowrap;
  border-left: 1px solid #e0e0e0;
}
.dx-pivotgrid .dx-pivotgrid-area-data tbody td:first-child {
  border-left: 0;
}
.dx-pivotgrid .dx-pivotgrid-area-data tbody tr:first-child .dx-grandtotal,
.dx-pivotgrid .dx-pivotgrid-area-data tbody tr:first-child .dx-total {
  border-top-width: 0;
}
.dx-pivotgrid .dx-pivotgrid-vertical-headers .dx-expand-border {
  border-top: 1px solid #e0e0e0;
}
.dx-pivotgrid .dx-pivotgrid-vertical-headers .dx-last-cell {
  border-right: 0;
}
.dx-pivotgrid .dx-pivotgrid-vertical-headers td {
  min-width: 50px;
  border-right: 1px solid #e0e0e0;
}
.dx-pivotgrid .dx-pivotgrid-vertical-headers tr:first-child td {
  border-top: 0;
}
.dx-pivotgrid .dx-pivotgrid-vertical-headers .dx-pivotgrid-fields-area-head td:last-child {
  border-right: 0;
}
.dx-pivotgrid .dx-pivotgrid-area-data .dx-row-total,
.dx-pivotgrid .dx-pivotgrid-vertical-headers .dx-row-total {
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
}
.dx-pivotgrid .dx-area-tree-view .dx-total {
  border-bottom: none;
}
.dx-pivotgrid .dx-area-tree-view td.dx-white-space-column {
  border-top: 1px solid transparent;
  background-color: rgba(221,221,221,.2);
  padding: 0;
  width: 19px;
  min-width: 19px;
}
.dx-pivotgrid .dx-pivotgrid-horizontal-headers.dx-vertical-scroll {
  border-right: 1px solid #e0e0e0;
}
.dx-pivotgrid .dx-pivotgrid-horizontal-headers td {
  text-align: center;
  border: 1px solid #e0e0e0;
}
.dx-pivotgrid .dx-pivotgrid-horizontal-headers td.dx-pivotgrid-collapsed,
.dx-pivotgrid .dx-pivotgrid-horizontal-headers td.dx-pivotgrid-expanded {
  text-align: left;
}
.dx-pivotgrid .dx-pivotgrid-horizontal-headers td:first-child {
  border-left: 0;
}
.dx-pivotgrid .dx-pivotgrid-horizontal-headers tr:first-child td {
  border-top: 0;
}
.dx-pivotgrid .dx-expand-icon-container {
  width: 14px;
}
.dx-pivotgrid .dx-pivotgrid-horizontal-headers:last-child {
  border-bottom: 0;
}
.dx-pivotgrid .dx-area-description-cell,
.dx-pivotgrid .dx-column-header,
.dx-pivotgrid .dx-data-header,
.dx-pivotgrid .dx-total {
  background-color: rgba(221,221,221,.2);
}
.dx-pivotgrid .dx-grandtotal {
  background-color: rgba(0,0,0,.04);
}
.dx-pivotgrid .dx-pivotgrid-border .dx-area-description-cell,
.dx-pivotgrid .dx-pivotgrid-border .dx-area-row-cell,
.dx-pivotgrid .dx-pivotgrid-border .dx-data-header,
.dx-pivotgrid .dx-pivotgrid-border .dx-filter-header {
  border-left: 1px solid #e0e0e0;
}
.dx-pivotgrid .dx-pivotgrid-border .dx-area-column-cell,
.dx-pivotgrid .dx-pivotgrid-border .dx-area-data-cell,
.dx-pivotgrid .dx-pivotgrid-border .dx-column-header,
.dx-pivotgrid .dx-pivotgrid-border .dx-filter-header {
  border-right: 1px solid #e0e0e0;
}
.dx-pivotgrid .dx-pivotgrid-border .dx-filter-header {
  border-top: 1px solid #e0e0e0;
}
.dx-pivotgrid .dx-pivotgrid-border .dx-filter-header td {
  display: inline-block;
}
.dx-pivotgrid .dx-pivotgrid-border .dx-area-data-cell,
.dx-pivotgrid .dx-pivotgrid-border .dx-area-row-cell {
  border-bottom: 1px solid #e0e0e0;
}
.dx-pivotgrid .dx-icon-sorted {
  display: inline-block;
  margin-left: 5px;
  width: 14px;
}
.dx-pivotgrid .dx-popup-content {
  padding: 10px;
}
.dx-pivotgrid .dx-popup-content .dx-pivotgrid-fields-area-head td {
  padding: 0 2px;
}
.dx-pivotgrid.dx-context-menu .dx-pivotgrid.dx-submenu {
  width: auto;
}
.dx-pivotgridfieldchooser .dx-area-fields {
  overflow: hidden;
}
.dx-pivotgridfieldchooser .dx-treeview-item .dx-icon {
  vertical-align: middle;
  margin: 0 5px 1px 0;
  width: 16px;
  height: 16px;
  background-position: 0 0;
  background-size: 16px 16px;
  padding: 0;
  font-size: 16px;
  text-align: center;
  line-height: 16px;
}
.dx-pivotgridfieldchooser .dx-treeview-search {
  margin: 5px;
}
.dx-pivotgridfieldchooser .dx-area-icon {
  display: inline-block;
  vertical-align: middle;
  width: 16px;
  height: 16px;
}
.dx-pivotgridfieldchooser .dx-area {
  padding: 5px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.dx-pivotgridfieldchooser .dx-area>.dx-scrollable,
.dx-pivotgridfieldchooser .dx-area>.dx-scrollable>.dx-scrollable-wrapper,
.dx-pivotgridfieldchooser .dx-area>.dx-treeview,
.dx-pivotgridfieldchooser .dx-area>.dx-treeview>.dx-scrollable,
.dx-pivotgridfieldchooser .dx-area>.dx-treeview>.dx-scrollable-wrapper,
.dx-pivotgridfieldchooser .dx-area>.dx-treeview>.dx-scrollable>.dx-scrollable-wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 0;
}
.dx-pivotgridfieldchooser .dx-area > .dx-scrollable > .dx-scrollable-wrapper > .dx-scrollable-container,
.dx-pivotgridfieldchooser .dx-area > .dx-treeview > .dx-scrollable > .dx-scrollable-wrapper > .dx-scrollable-container,
.dx-pivotgridfieldchooser .dx-area > .dx-treeview > .dx-scrollable-wrapper > .dx-scrollable-container {
  height: auto;
}
.dx-pivotgridfieldchooser .dx-area .dx-area-fields {
  border: 1px solid #e0e0e0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 0;
  margin-top: 8px;
}
.dx-pivotgridfieldchooser .dx-area-fields-header .dx-area-caption {
  -ms-flex-item-align: center;
  align-self: center;
}
.dx-pivotgridfieldchooser .dx-area-fields[group] {
  padding: 5px;
  background-color: rgba(221,221,221,.2);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.dx-pivotgridfieldchooser .dx-area-fields.dx-drag-target {
  border-color: #009688;
}
.dx-pivotgridfieldchooser .dx-area-icon-all {
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAAJElEQVQoz2P8z4AfsDAwJELVzGfExmIiYAAD5QoYRx1JL0cCAJeiFh8Qq9chAAAAAElFTkSuQmCC") center center no-repeat;
}
.dx-pivotgridfieldchooser .dx-area-icon-filter {
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAAWElEQVQoz83RsQqAMAxF0fepFxzEQRz8e1sah0JTamhXeVtyCCSRaR6ZTGQsSHJgcRyk1YQ7aBcuB+KkDO0D9UDsHcmARiC2BqiVEfg2+jOoF30+YPnNWV4jV/jo04VE6gAAAABJRU5ErkJggg==") center center no-repeat;
}
.dx-pivotgridfieldchooser .dx-area-icon-row {
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAAI0lEQVQoz2P4z4AfAlHCfwjEzqKPAsKObIBA7Cz6KBgGIQkAQ8IdQJKOGQIAAAAASUVORK5CYII=") center center no-repeat;
}
.dx-pivotgridfieldchooser .dx-area-icon-column {
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAAIElEQVQoz2P4z4AfAlHCfwgEshogEFmMPgpGHUkfRwIAQ8IdQALkrHMAAAAASUVORK5CYII=") center center no-repeat;
}
.dx-pivotgridfieldchooser .dx-area-icon-data,
.dx-pivotgridfieldchooser .dx-icon-measure {
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAARElEQVQoz2P4z4AfMhClIOE/NkiSAl+ooG8CQwKIzwChEQpQlGBXgKYEwxeoSrB6k7ACfFYkYPgDXQGKdAItQpKi2AQAaDQFJxj4SdQAAAAASUVORK5CYII=") center center no-repeat;
}
.dx-pivotgridfieldchooser .dx-icon-dimension {
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAAH0lEQVQoz2P4z4AfMlBHQcJ/MESjqasAKxx5bqAosgCZ3QSYpC33dQAAAABJRU5ErkJggg==") center center no-repeat;
}
.dx-pivotgridfieldchooser .dx-icon-hierarchy {
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAAMUlEQVQoz2P4z4AfMlBXQcJ/EKShggQoxKEAojsBwxQqKUjACpEVoOhGNYVKCiiKLAATcARoA49V5wAAAABJRU5ErkJggg==") center center no-repeat;
}
.dx-pivotgridfieldchooser .dx-icon-hierarchy::before {
  content: none;
}
.dx-rtl .dx-pivotgrid-fields-container .dx-position-indicator.dx-position-indicator-horizontal {
  margin-left: -3px;
}
.dx-rtl .dx-pivotgrid-fields-container .dx-position-indicator.dx-position-indicator-horizontal.dx-position-indicator-last {
  margin-left: 1px;
}
.dx-rtl .dx-pivotgrid-fields-container .dx-column-indicators {
  margin-left: 0;
  margin-right: 6px;
}
.dx-rtl.dx-pivotgrid .dx-column-header .dx-pivotgrid-toolbar,
.dx-rtl.dx-pivotgrid .dx-filter-header .dx-pivotgrid-toolbar {
  margin-right: 0;
  margin-left: 10px;
  float: left;
}
.dx-rtl.dx-pivotgrid .dx-column-header .dx-pivotgrid-toolbar .dx-pivotgrid-field-chooser-button,
.dx-rtl.dx-pivotgrid .dx-filter-header .dx-pivotgrid-toolbar .dx-pivotgrid-field-chooser-button {
  margin-right: 0;
  margin-left: 4px;
}
.dx-rtl.dx-pivotgrid .dx-column-header .dx-pivotgrid-fields-area-head tr > td:first-child {
  padding-left: 2px;
  padding-right: 0;
}
.dx-rtl.dx-pivotgrid .dx-pivotgrid-fields-area-head tr > td {
  padding: 10px 2px;
}
.dx-rtl.dx-pivotgrid .dx-pivotgrid-fields-area-head tr > td:first-child {
  padding-right: 10px;
}
.dx-rtl.dx-pivotgrid .dx-pivotgrid-fields-area-head tr > td:last-child {
  padding-left: 10px;
}
.dx-rtl.dx-pivotgrid .dx-group-connector.dx-group-connector-prev {
  left: initial;
  right: 0;
}
.dx-rtl.dx-pivotgrid .dx-group-connector.dx-group-connector-next {
  right: initial;
  left: 0;
}
.dx-rtl.dx-pivotgrid .dx-area-description-cell,
.dx-rtl.dx-pivotgrid .dx-area-row-cell {
  border-left: 1px solid #e0e0e0;
  border-right: 0;
}
.dx-rtl.dx-pivotgrid .dx-pivotgrid-area-data.dx-scrollable-native .dx-scrollable-content {
  float: none;
}
.dx-rtl.dx-pivotgrid .dx-pivotgrid-area-data tbody td {
  border-left: 0;
  border-right: 1px solid #e0e0e0;
}
.dx-rtl.dx-pivotgrid .dx-pivotgrid-area-data tbody td:first-child {
  border-left: 1px solid #e0e0e0;
  border-right: 0;
}
.dx-rtl.dx-pivotgrid .dx-pivotgrid-vertical-headers td {
  border-right: 0;
  border-left: 1px solid #e0e0e0;
}
.dx-rtl.dx-pivotgrid .dx-pivotgrid-vertical-headers .dx-last-cell {
  border-left: 0;
  border-right: 0;
}
.dx-rtl.dx-pivotgrid .dx-pivotgrid-horizontal-headers.dx-vertical-scroll {
  border-right: 0;
  border-left: 1px solid #e0e0e0;
}
.dx-rtl.dx-pivotgrid .dx-pivotgrid-horizontal-headers.dx-pivotgrid-area {
  border-left: 0;
}
.dx-rtl.dx-pivotgrid .dx-pivotgrid-horizontal-headers td:first-child {
  border-left: 1px solid #e0e0e0;
  border-right: 0;
}
.dx-rtl.dx-pivotgrid .dx-pivotgrid-horizontal-headers td.dx-pivotgrid-collapsed,
.dx-rtl.dx-pivotgrid .dx-pivotgrid-horizontal-headers td.dx-pivotgrid-expanded {
  text-align: right;
}
.dx-rtl.dx-pivotgrid .dx-expand-icon-container {
  margin-left: 0;
  margin-right: -5px;
}
.dx-rtl.dx-pivotgrid .dx-pivotgrid-collapsed .dx-expand-icon-container {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
.dx-rtl.dx-pivotgrid .dx-icon-sorted {
  margin-left: 0;
  margin-right: 5px;
}
.dx-rtl.dx-pivotgrid .dx-pivotgridfieldchooser-container .dx-col {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.dx-rtl.dx-pivotgrid .dx-pivotgrid-border .dx-area-description-cell,
.dx-rtl.dx-pivotgrid .dx-pivotgrid-border .dx-area-row-cell,
.dx-rtl.dx-pivotgrid .dx-pivotgrid-border .dx-data-header {
  border-right: 1px solid #e0e0e0;
}
.dx-rtl.dx-pivotgrid .dx-pivotgrid-border .dx-area-column-cell,
.dx-rtl.dx-pivotgrid .dx-pivotgrid-border .dx-area-data-cell,
.dx-rtl.dx-pivotgrid .dx-pivotgrid-border .dx-column-header {
  border-left: 1px solid #e0e0e0;
}
.dx-rtl.dx-pivotgrid .dx-pivotgrid-border .dx-column-header {
  border-right: none;
}
.dx-rtl.dx-pivotgrid .dx-pivotgrid-border .dx-area-row-cell,
.dx-rtl.dx-pivotgrid .dx-pivotgrid-border .dx-data-header {
  border-left: none;
}
.dx-pivotgrid-fields-container.dx-drag .dx-area-field.dx-area-box {
  background-color: rgba(224,224,224,.9);
  border: none;
  -webkit-box-shadow: 0 3px 4px rgba(0,0,0,.15);
  box-shadow: 0 3px 4px rgba(0,0,0,.15);
}
.dx-pivotgrid-fields-container .dx-area-field.dx-area-box {
  color: rgba(0,0,0,.54);
  background-color: #e0e0e0;
  border-radius: 16px;
  border: none;
  font-size: 12px;
  font-weight: 500;
}
.dx-pivotgrid-fields-container .dx-area-field.dx-area-box .dx-header-filter {
  color: #009688;
}
.dx-pivotgrid-fields-container .dx-area-field.dx-area-box .dx-header-filter.dx-header-filter-empty {
  color: rgba(0,0,0,.54);
}
.dx-pivotgrid .dx-pivotgrid-area.dx-pivotgrid-area-data {
  font-size: 13px;
}
.dx-pivotgrid .dx-pivotgrid-area.dx-pivotgrid-horizontal-headers,
.dx-pivotgrid .dx-pivotgrid-area.dx-pivotgrid-vertical-headers {
  font-size: 12px;
}
.dx-pivotgrid .dx-pivotgrid-area.dx-pivotgrid-horizontal-headers td,
.dx-pivotgrid .dx-pivotgrid-area.dx-pivotgrid-vertical-headers td {
  font-weight: 500;
}
.dx-pivotgrid .dx-pivotgrid-area.dx-pivotgrid-horizontal-headers .dx-grandtotal,
.dx-pivotgrid .dx-pivotgrid-area.dx-pivotgrid-horizontal-headers .dx-total,
.dx-pivotgrid .dx-pivotgrid-area.dx-pivotgrid-vertical-headers .dx-grandtotal,
.dx-pivotgrid .dx-pivotgrid-area.dx-pivotgrid-vertical-headers .dx-total {
  color: rgba(0,0,0,.87);
}
.dx-pivotgrid .dx-pivotgrid-area td {
  color: rgba(0,0,0,.54);
  padding: 10px 16px;
}
.dx-pivotgrid .dx-pivotgrid-area td.dx-pivotgrid-collapsed,
.dx-pivotgrid .dx-pivotgrid-area td.dx-pivotgrid-expanded {
  padding: 10px 14px 10px 19px;
}
.dx-pivotgrid .dx-pivotgrid-area td.dx-pivotgrid-collapsed > span,
.dx-pivotgrid .dx-pivotgrid-area td.dx-pivotgrid-expanded > span {
  padding: 0 5px 0 10px;
}
.dx-pivotgrid .dx-area-description-cell .dx-pivotgrid-toolbar {
  padding-left: 8px;
}
.dx-pivotgrid .dx-area-description-cell .dx-pivotgrid-toolbar .dx-button {
  background-color: transparent;
  color: rgba(0,0,0,.87);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-pivotgrid .dx-area-description-cell .dx-pivotgrid-toolbar .dx-button .dx-icon {
  color: rgba(0,0,0,.87);
}
.dx-pivotgrid .dx-area-description-cell .dx-pivotgrid-toolbar .dx-button.dx-state-focused,
.dx-pivotgrid .dx-area-description-cell .dx-pivotgrid-toolbar .dx-button.dx-state-hover {
  background-color: rgba(0,0,0,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-pivotgrid .dx-area-description-cell .dx-pivotgrid-toolbar .dx-button.dx-state-active {
  background-color: rgba(0,0,0,.3);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-pivotgrid .dx-area-description-cell .dx-pivotgrid-toolbar .dx-button.dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-pivotgrid .dx-area-description-cell .dx-pivotgrid-toolbar .dx-button.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-pivotgrid .dx-area-description-cell .dx-pivotgrid-toolbar .dx-button.dx-state-disabled .dx-button-text,
.dx-pivotgrid .dx-area-description-cell .dx-pivotgrid-toolbar .dx-button.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-pivotgrid .dx-area-description-cell .dx-pivotgrid-toolbar .dx-button .dx-inkripple-wave {
  background-color: rgba(0,0,0,.2);
}
.dx-pivotgrid .dx-grandtotal.dx-last-cell,
.dx-pivotgrid .dx-row-total.dx-last-cell {
  padding-left: 22px;
}
.dx-pivotgrid .dx-column-header .dx-pivotgrid-toolbar .dx-button,
.dx-pivotgrid .dx-filter-header .dx-pivotgrid-toolbar .dx-button {
  background-color: transparent;
  color: rgba(0,0,0,.87);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-pivotgrid .dx-column-header .dx-pivotgrid-toolbar .dx-button .dx-icon,
.dx-pivotgrid .dx-filter-header .dx-pivotgrid-toolbar .dx-button .dx-icon {
  color: rgba(0,0,0,.87);
}
.dx-pivotgrid .dx-column-header .dx-pivotgrid-toolbar .dx-button.dx-state-focused,
.dx-pivotgrid .dx-column-header .dx-pivotgrid-toolbar .dx-button.dx-state-hover,
.dx-pivotgrid .dx-filter-header .dx-pivotgrid-toolbar .dx-button.dx-state-focused,
.dx-pivotgrid .dx-filter-header .dx-pivotgrid-toolbar .dx-button.dx-state-hover {
  background-color: rgba(0,0,0,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-pivotgrid .dx-column-header .dx-pivotgrid-toolbar .dx-button.dx-state-active,
.dx-pivotgrid .dx-filter-header .dx-pivotgrid-toolbar .dx-button.dx-state-active {
  background-color: rgba(0,0,0,.3);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-pivotgrid .dx-column-header .dx-pivotgrid-toolbar .dx-button.dx-state-disabled,
.dx-pivotgrid .dx-filter-header .dx-pivotgrid-toolbar .dx-button.dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-pivotgrid .dx-column-header .dx-pivotgrid-toolbar .dx-button.dx-state-disabled .dx-icon,
.dx-pivotgrid .dx-filter-header .dx-pivotgrid-toolbar .dx-button.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-pivotgrid .dx-column-header .dx-pivotgrid-toolbar .dx-button.dx-state-disabled .dx-button-text,
.dx-pivotgrid .dx-column-header .dx-pivotgrid-toolbar .dx-button.dx-state-disabled.dx-button-mode-contained .dx-icon,
.dx-pivotgrid .dx-filter-header .dx-pivotgrid-toolbar .dx-button.dx-state-disabled .dx-button-text,
.dx-pivotgrid .dx-filter-header .dx-pivotgrid-toolbar .dx-button.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-pivotgrid .dx-column-header .dx-pivotgrid-toolbar .dx-button .dx-inkripple-wave,
.dx-pivotgrid .dx-filter-header .dx-pivotgrid-toolbar .dx-button .dx-inkripple-wave {
  background-color: rgba(0,0,0,.2);
}
.dx-pivotgrid .dx-expand-icon-container {
  margin: 0;
  font: 12px/1 DXIcons;
}
.dx-pivotgrid .dx-expand-icon-container::before {
  content: "\\f010";
  visibility: hidden;
}
.dx-pivotgrid .dx-pivotgrid-collapsed .dx-expand {
  font: 20px/20px DXIcons;
  text-align: center;
  color: rgba(0,0,0,.54);
}
.dx-pivotgrid .dx-pivotgrid-collapsed .dx-expand::before {
  content: "\\f010";
  position: absolute;
  display: block;
  width: 20px;
  top: 50%;
  margin-top: -10px;
  left: 50%;
  margin-left: -10px;
}
.dx-pivotgrid .dx-pivotgrid-expanded .dx-expand {
  font: 20px/20px DXIcons;
  text-align: center;
  color: rgba(0,0,0,.54);
}
.dx-pivotgrid .dx-pivotgrid-expanded .dx-expand::before {
  content: "\\f016";
  position: absolute;
  display: block;
  width: 20px;
  top: 50%;
  margin-top: -10px;
  left: 50%;
  margin-left: -10px;
}
.dx-pivotgridfieldchooser .dx-area .dx-area-icon-filter {
  background: 0 0;
  font: 14px/1 DXIcons;
  width: 14px;
  height: 14px;
}
.dx-pivotgridfieldchooser .dx-area .dx-area-icon-filter::before {
  content: "\\f050";
}
.dx-pivotgridfieldchooser .dx-area .dx-area-caption {
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 500;
  color: rgba(0,0,0,.54);
}
.dx-pivotgridfieldchooser .dx-treeview-border-visible .dx-scrollable-content > .dx-treeview-node-container {
  padding-right: 8px;
}
.dx-pivotgridfieldchooser .dx-treeview-item-with-checkbox.dx-treeview-node-is-leaf {
  padding-left: 0;
}
.dx-pivotgridfieldchooser .dx-treeview-item-with-checkbox.dx-treeview-node-is-leaf .dx-checkbox {
  left: 8px;
}
.dx-pivotgridfieldchooser .dx-treeview-node-container-opened .dx-treeview-item-with-checkbox.dx-treeview-node-is-leaf {
  padding-left: 24px;
}
.dx-pivotgridfieldchooser .dx-treeview-node-container-opened .dx-treeview-item-with-checkbox.dx-treeview-node-is-leaf .dx-checkbox {
  left: 35px;
}
.dx-pivotgridfieldchooser .dx-treeview-item {
  min-height: 36px;
  padding: 9px 8px;
  line-height: normal;
}
.dx-pivotgridfieldchooser .dx-treeview-item-with-checkbox .dx-checkbox {
  top: 9px;
}
.dx-pivotgridfieldchooser .dx-treeview-item-with-checkbox .dx-treeview-item {
  padding-left: 40px;
}
.dx-pivotgridfieldchooser .dx-treeview-toggle-item-visibility {
  height: 36px;
}
.dx-pivotgrid-fields-container .dx-position-indicator {
  background-color: gray;
}
.dx-context-menu.dx-overlay-content {
  overflow: inherit;
  position: absolute;
}
.dx-context-menu .dx-menu-item .dx-submenu {
  position: absolute;
  z-index: 1003;
}
.dx-context-menu .dx-menu-item {
  font-size: 14px;
  color: rgba(0,0,0,.87);
}
.dx-context-menu .dx-menu-item .dx-menu-item-content {
  padding: 12px 16px;
}
.dx-context-menu .dx-menu-item .dx-menu-item-content .dx-menu-item-popout-container {
  right: 16px;
  width: 24px;
}
.dx-context-menu .dx-menu-item .dx-menu-item-content .dx-menu-item-popout-container .dx-menu-item-popout {
  color: rgba(0,0,0,.54);
  font: 24px/24px DXIcons;
  text-align: center;
}
.dx-context-menu .dx-menu-item .dx-menu-item-content .dx-menu-item-popout-container .dx-menu-item-popout::before {
  content: "\\f04e";
  position: absolute;
  display: block;
  width: 24px;
  top: 50%;
  margin-top: -12px;
  left: 50%;
  margin-left: -12px;
}
.dx-context-menu .dx-menu-item.dx-menu-item-has-submenu > .dx-menu-item-content {
  padding-right: 64px;
}
.dx-context-menu .dx-menu-item.dx-menu-item-has-text.dx-menu-item-has-icon .dx-icon {
  margin-right: 16px;
}
.dx-context-menu .dx-menu-items-container {
  padding: 8px 0;
}
.dx-context-menu.dx-overlay-content.dx-state-focused {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-context-menu .dx-submenu {
  background-color: #fff;
  border-radius: 4px;
  -webkit-box-shadow: 0 2px 7px rgba(0,0,0,.2);
  box-shadow: 0 2px 7px rgba(0,0,0,.2);
}
.dx-context-menu .dx-menu-separator {
  height: 1px;
  margin: 5px 0;
  background-color: #e0e0e0;
}
.dx-context-menu.dx-rtl .dx-menu-item .dx-menu-item-popout-container {
  left: 16px;
}
.dx-context-menu.dx-rtl .dx-menu-item.dx-menu-item-has-text.dx-menu-item-has-icon .dx-icon {
  margin-left: 24px;
  margin-right: 0;
}
.dx-context-menu.dx-rtl .dx-menu-item.dx-menu-item-has-submenu > .dx-menu-item-content {
  padding-left: 64px;
  padding-right: 16px;
}
.dx-multiview-wrapper {
  overflow: hidden;
  width: 100%;
  height: 100%;
  -ms-touch-action: pinch-zoom pan-y;
  touch-action: pinch-zoom pan-y;
}
.dx-multiview-item-container {
  position: relative;
  overflow: visible;
  width: 100%;
  height: 100%;
}
.dx-multiview-item-container .dx-empty-message {
  text-align: center;
}
.dx-multiview-item {
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.dx-multiview-item.dx-item-selected {
  position: relative;
}
.dx-multiview-item-content {
  width: 100%;
  height: 100%;
}
.dx-multiview-item-hidden {
  top: -9999px;
  left: -9999px;
  visibility: hidden;
}
.dx-multiview-item-hidden .dx-accordion-item-opened .dx-accordion-item-body {
  visibility: hidden;
}
.dx-tabpanel-tabs {
  width: 100%;
}
.dx-tabpanel-tabs .dx-tabs {
  height: 100%;
}
.dx-tabpanel-container {
  width: 100%;
  height: 100%;
}
.dx-tabpanel .dx-tabs {
  display: block;
  border-bottom: 1px solid #e0e0e0;
}
.dx-empty-collection.dx-tabpanel .dx-tabs {
  border-top: none;
}
.dx-tabpanel .dx-tab {
  min-width: 72px;
}
.dx-tabpanel .dx-tabs-wrapper {
  display: block;
}
.dx-tabpanel .dx-tabs-nav-button {
  height: 100%;
}
.dx-fileuploader.dx-state-disabled .dx-fileuploader-input {
  display: none;
}
.dx-fileuploader-wrapper {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.dx-fileuploader-container {
  display: table;
  table-layout: fixed;
  height: 100%;
  width: 100%;
}
.dx-fileuploader-input-wrapper::after,
.dx-fileuploader-input-wrapper::before {
  display: table;
  content: "";
  line-height: 0;
  width: 100%;
}
.dx-fileuploader-input-wrapper::after {
  clear: both;
  padding-bottom: 1em;
  margin-bottom: -1em;
}
.dx-fileuploader-input-wrapper::before {
  padding-top: 1em;
  margin-top: -1em;
}
.dx-fileuploader-input-wrapper .dx-button {
  float: left;
}
.dx-fileuploader-input-wrapper .dx-button + .dx-button {
  margin-left: 12px;
}
.dx-fileuploader-button {
  position: relative;
}
.dx-fileuploader-button .dx-fileuploader-input {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  cursor: pointer;
}
.dx-fileuploader-button .dx-fileuploader-input::-ms-browse,
.dx-fileuploader-button .dx-fileuploader-input::-webkit-file-upload-button {
  cursor: pointer;
}
.dx-fileuploader-content {
  display: table-row-group;
  vertical-align: middle;
}
.dx-fileuploader-content > .dx-fileuploader-upload-button {
  margin-top: 10px;
}
.dx-fileuploader-empty .dx-fileuploader-content > .dx-fileuploader-upload-button {
  display: none;
}
.dx-fileuploader-input-content {
  width: 100%;
  display: table;
}
.dx-fileuploader-files-container {
  padding-top: 0;
  width: 100%;
}
.dx-fileuploader-file-container {
  width: 100%;
  padding: 4px 0;
}
.dx-fileuploader-file-container .dx-button {
  width: 28px;
  height: 28px;
  margin-right: 10px;
}
.dx-fileuploader-file-container .dx-button.dx-state-invisible {
  margin-right: 0;
}
.dx-fileuploader-button-container,
.dx-fileuploader-input-container {
  display: table-cell;
  vertical-align: middle;
}
.dx-fileuploader-input-container {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
}
.dx-fileuploader-input {
  opacity: 0;
  width: 100%;
  margin: 0;
  cursor: default;
}
.dx-fileuploader-input-label {
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  cursor: default;
}
.dx-fileuploader-input-label::before {
  content: "";
  position: absolute;
  top: -50%;
  overflow: hidden;
  cursor: default;
}
.dx-fileuploader-button-container {
  display: table-cell;
  vertical-align: middle;
}
.dx-fileuploader-file-info {
  float: left;
  width: 100%;
}
.dx-fileuploader-file-status-message {
  float: left;
  font-size: 12px;
  height: 16px;
}
.dx-fileuploader .dx-progressbar {
  float: left;
  width: 100%;
  height: 22px;
  margin-top: -6px;
}
.dx-rtl .dx-fileuploader .dx-fileuploader-button,
.dx-rtl.dx-fileuploader .dx-fileuploader-button {
  float: right;
}
.dx-rtl .dx-fileuploader .dx-fileuploader-file-container .dx-fileuploader-button,
.dx-rtl.dx-fileuploader .dx-fileuploader-file-container .dx-fileuploader-button {
  margin-left: 10px;
  margin-right: 0;
}
.dx-rtl .dx-fileuploader .dx-fileuploader-file-name,
.dx-rtl .dx-fileuploader .dx-fileuploader-file-size,
.dx-rtl .dx-fileuploader .dx-fileuploader-file-status-message,
.dx-rtl.dx-fileuploader .dx-fileuploader-file-name,
.dx-rtl.dx-fileuploader .dx-fileuploader-file-size,
.dx-rtl.dx-fileuploader .dx-fileuploader-file-status-message {
  float: right;
}
.dx-rtl .dx-fileuploader .dx-fileuploader-file-size,
.dx-rtl.dx-fileuploader .dx-fileuploader-file-size {
  margin-right: 4px;
}
.dx-fileuploader-invalid .dx-fileuploader-file-status-message {
  height: auto;
  color: #f44336;
}
.dx-fileuploader-invalid .dx-fileuploader-file-status-message span {
  display: block;
  margin-bottom: 2px;
}
.dx-fileuploader-wrapper {
  padding: 7px;
}
.dx-fileuploader-content > .dx-fileuploader-upload-button {
  margin-left: 3px;
  margin-right: 3px;
}
.dx-fileuploader-input-wrapper {
  padding: 7px 0;
  border: 3px dashed transparent;
}
.dx-fileuploader.dx-state-disabled .dx-fileuploader-input-label {
  position: relative;
}
.dx-fileuploader-dragover .dx-fileuploader-input-wrapper {
  border: none;
  padding: 0;
}
.dx-fileuploader-dragover .dx-fileuploader-input-wrapper .dx-fileuploader-button {
  display: none;
}
.dx-fileuploader-dragover .dx-fileuploader-input-container {
  display: block;
  width: 100%;
}
.dx-fileuploader-dragover .dx-fileuploader-input {
  display: block;
  width: 100%;
  padding: 17px 3px 18px;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
.dx-fileuploader-dragover .dx-fileuploader-input-label {
  text-align: center;
  padding: 14px 9px;
  border: 3px dashed #e0e0e0;
}
.dx-fileuploader-file-size,
.dx-fileuploader-file-status-message {
  color: rgba(102,102,102,.87);
}
.dx-fileuploader-input {
  padding: 7px 0;
}
.dx-fileuploader-input-label {
  padding: 8px 9px;
  color: rgba(0,0,0,.87);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dx-fileuploader-show-file-list .dx-fileuploader-files-container {
  padding: 14px 3px 0;
}
.dx-fileuploader-empty .dx-fileuploader-files-container {
  padding: 0;
}
.dx-invalid .dx-fileuploader-files-container {
  padding-top: 50px;
}
.dx-fileuploader-files-container .dx-fileuploader-button .dx-button-content {
  padding: 0;
}
.dx-fileuploader-files-container .dx-fileuploader-file-container {
  -webkit-box-shadow: 0 1px 3px 0 rgba(0,0,0,.1);
  box-shadow: 0 1px 3px 0 rgba(0,0,0,.1);
  padding: 5px 8px;
  margin-bottom: 4px;
}
.dx-fileuploader-files-container .dx-fileuploader-file-container .dx-fileuploader-button-container + .dx-fileuploader-button-container .dx-button {
  margin-right: 15px;
}
.dx-rtl .dx-fileuploader-files-container .dx-fileuploader-file-container .dx-fileuploader-button-container + .dx-fileuploader-button-container .dx-button {
  margin-left: 15px;
  margin-right: 0;
}
.dx-fileuploader-files-container .dx-fileuploader-file-container .dx-button {
  height: 36px;
  width: 36px;
  margin-right: 5px;
}
.dx-rtl .dx-fileuploader-files-container .dx-fileuploader-file-container .dx-button {
  margin-left: 5px;
  margin-right: 0;
}
.dx-fileuploader-file {
  display: table-cell;
  width: 100%;
  white-space: nowrap;
  padding-top: 5px;
  line-height: 13px;
}
.dx-fileuploader-file-name {
  float: left;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-bottom: 3.5px;
  color: rgba(0,0,0,.87);
  font-weight: 500;
}
.dx-fileuploader-file-size {
  margin-left: 4px;
  float: left;
  vertical-align: super;
  font-size: 10px;
  padding-bottom: 3.5px;
}
.dx-fileuploader-invalid .dx-fileuploader-file-status-message span:first-child {
  margin-top: 2px;
}
.dx-fileuploader-invalid .dx-fileuploader-file-status-message span:last-child {
  margin-bottom: 2px;
}
.dx-fileuploader-invalid .dx-fileuploader-button-container {
  vertical-align: middle;
}
.dx-fileuploader-invalid .dx-fileuploader-cancel-button {
  margin-top: 0;
}
.dx-scheduler-appointment-popup .dx-popup-content {
  padding-top: 0;
  padding-bottom: 0;
}
.dx-scheduler-appointment-popup .dx-scrollable-content {
  padding-top: 20px;
}
.dx-scheduler-appointment-popup .dx-form.dx-recurrence-editor-container .dx-scrollable-content {
  padding-top: 0;
}
.dx-scheduler .dx-empty-message {
  line-height: normal;
}
.dx-scheduler-all-day-panel td {
  padding: 0;
}
.dx-scheduler-appointment-collector {
  display: block;
  height: 20px;
  cursor: pointer;
  margin: 3px 0 0 3px;
}
.dx-scheduler-appointment-collector .dx-button-content,
.dx-scheduler-appointment-collector .dx-scheduler-appointment-collector-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 4px;
  padding: 0;
}
.dx-scheduler-appointment-collector .dx-button-content::after,
.dx-scheduler-appointment-collector .dx-scheduler-appointment-collector-content::after {
  display: inline-block;
  position: relative;
  height: 100%;
  content: "";
  vertical-align: middle;
  font-size: 0;
}
.dx-scheduler-appointment-collector.dx-button.dx-button-default {
  padding: 0;
  max-width: none;
  border-radius: 20px;
}
.dx-scheduler-work-space-mouse-selection .dx-scheduler-all-day-appointments,
.dx-scheduler-work-space-mouse-selection .dx-scheduler-fixed-appointments,
.dx-scheduler-work-space-mouse-selection .dx-scheduler-scrollable-appointments {
  pointer-events: none;
}
.dx-rtl .dx-scheduler-appointment-collector {
  margin: 3px 3px 0 0;
}
@media (max-width:450px) {
  .dx-scheduler-adaptive .dx-scheduler-view-switcher-label {
    display: none;
  }
}
.dx-scheduler-adaptive .dx-scheduler-work-space-week .dx-scheduler-header-panel-cell {
  line-height: 1.3;
  white-space: nowrap;
}
.dx-scheduler-adaptive .dx-scheduler-appointment-collector {
  margin: 0;
}
.dx-popup-wrapper.dx-scheduler-appointment-tooltip-wrapper .dx-popup-content,
.dx-scheduler-overlay-panel .dx-popup-content {
  padding: 0;
}
.dx-popup-wrapper.dx-scheduler-appointment-tooltip-wrapper .dx-popup-content .dx-list-item,
.dx-scheduler-overlay-panel .dx-popup-content .dx-list-item {
  width: 360px;
}
.dx-popup-wrapper.dx-scheduler-appointment-tooltip-wrapper .dx-popup-content .dx-list-item .dx-list-item-content,
.dx-scheduler-overlay-panel .dx-popup-content .dx-list-item .dx-list-item-content {
  padding: 5px;
}
.dx-popup-wrapper.dx-scheduler-appointment-tooltip-wrapper .dx-overlay-content,
.dx-scheduler-overlay-panel .dx-overlay-content {
  -webkit-box-shadow: 0 0 15px 0 rgba(0,0,0,.15);
  box-shadow: 0 0 15px 0 rgba(0,0,0,.15);
}
.dx-popup-wrapper.dx-scheduler-appointment-tooltip-wrapper .dx-tooltip-appointment-item,
.dx-scheduler-overlay-panel .dx-tooltip-appointment-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.dx-popup-wrapper.dx-scheduler-appointment-tooltip-wrapper .dx-tooltip-appointment-item .dx-tooltip-appointment-item-marker-body,
.dx-scheduler-overlay-panel .dx-tooltip-appointment-item .dx-tooltip-appointment-item-marker-body {
  margin-top: 7px;
  margin-left: 5px;
  background: #009688;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.dx-popup-wrapper.dx-scheduler-appointment-tooltip-wrapper .dx-tooltip-appointment-item .dx-tooltip-appointment-item-delete-button .dx-icon,
.dx-scheduler-overlay-panel .dx-tooltip-appointment-item .dx-tooltip-appointment-item-delete-button .dx-icon {
  color: rgba(0,0,0,.87);
}
.dx-popup-wrapper.dx-scheduler-appointment-tooltip-wrapper .dx-tooltip-appointment-item .dx-tooltip-appointment-item-content,
.dx-scheduler-overlay-panel .dx-tooltip-appointment-item .dx-tooltip-appointment-item-content {
  -ms-flex-preferred-size: 100%;
  flex-basis: 100%;
  margin: 5px 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: rgba(0,0,0,.87);
}
.dx-popup-wrapper.dx-scheduler-appointment-tooltip-wrapper .dx-tooltip-appointment-item .dx-tooltip-appointment-item-content .dx-tooltip-appointment-item-content-subject,
.dx-scheduler-overlay-panel .dx-tooltip-appointment-item .dx-tooltip-appointment-item-content .dx-tooltip-appointment-item-content-subject {
  text-align: left;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: .01em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dx-popup-wrapper.dx-scheduler-appointment-tooltip-wrapper .dx-tooltip-appointment-item .dx-tooltip-appointment-item-content .dx-tooltip-appointment-item-content-date,
.dx-scheduler-overlay-panel .dx-tooltip-appointment-item .dx-tooltip-appointment-item-content .dx-tooltip-appointment-item-content-date {
  text-align: left;
  font-size: 12px;
  opacity: .8;
  margin-top: 10px;
}
.dx-scheduler-overlay-panel .dx-overlay-content {
  position: relative;
  background: #fff;
}
.dx-scheduler-appointment-content-date {
  opacity: .7;
  display: inline-block;
  white-space: pre-wrap;
}
.dx-scheduler-appointment-content-details {
  margin-top: 2px;
}
.dx-scheduler-appointment-content-allday {
  display: none;
}
.dx-scheduler-appointment {
  border-bottom: 1px solid transparent;
  background-clip: padding-box;
  position: absolute;
  cursor: default;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  background-color: #009688;
  color: #fff;
  -webkit-box-shadow: inset 0 2px 0 0 rgba(0,0,0,.3);
  box-shadow: inset 0 2px 0 0 rgba(0,0,0,.3);
  left: 0;
  min-width: 4px;
  min-height: 4px;
}
.dx-scheduler-appointment.dx-resizable-resizing,
.dx-scheduler-appointment.dx-state-active {
  -webkit-box-shadow: inset 0 -2px 0 0 rgba(0,0,0,.3),inset 0 2px 0 0 rgba(0,0,0,.3);
  box-shadow: inset 0 -2px 0 0 rgba(0,0,0,.3),inset 0 2px 0 0 rgba(0,0,0,.3);
}
.dx-scheduler-appointment .dx-scheduler-appointment,
.dx-scheduler-appointment.dx-state-focused {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-scheduler-appointment .dx-scheduler-appointment:not(.dx-scheduler-appointment-drag-source)::before,
.dx-scheduler-appointment.dx-state-focused:not(.dx-scheduler-appointment-drag-source)::before {
  pointer-events: none;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,.3);
  opacity: .98;
}
.dx-scheduler-appointment.dx-state-hover {
  -webkit-box-shadow: inset 0 5px 0 0 rgba(0,0,0,.3);
  box-shadow: inset 0 5px 0 0 rgba(0,0,0,.3);
}
.dx-scheduler-appointment.dx-state-hover.dx-resizable {
  -webkit-box-shadow: inset 0 5px 0 0 rgba(0,0,0,.3),inset 0 -2px 0 0 rgba(0,0,0,.3);
  box-shadow: inset 0 5px 0 0 rgba(0,0,0,.3),inset 0 -2px 0 0 rgba(0,0,0,.3);
}
.dx-scheduler-appointment.dx-state-hover .dx-resizable-handle-top {
  height: 5px;
}
.dx-scheduler-appointment.dx-state-hover .dx-resizable-handle-left {
  width: 5px;
}
.dx-scheduler-appointment.dx-resizable-resizing {
  z-index: 1000;
  opacity: .7;
}
.dx-scheduler-appointment .dx-resizable-handle-left {
  left: -1px;
}
.dx-scheduler-appointment .dx-scheduler-appointment-reduced-icon {
  position: absolute;
  top: 3px;
  right: 5px;
  font: 14px/1 DXIcons;
}
.dx-scheduler-appointment .dx-scheduler-appointment-reduced-icon::before {
  content: "\\f00e";
}
.dx-rtl .dx-scheduler-appointment .dx-scheduler-appointment-reduced-icon {
  right: auto;
  left: 3px;
  font: 14px/1 DXIcons;
}
.dx-rtl .dx-scheduler-appointment .dx-scheduler-appointment-reduced-icon::before {
  content: "\\f011";
}
.dx-scheduler-appointment.dx-scheduler-appointment-empty .dx-scheduler-appointment-reduced-icon,
.dx-scheduler-appointment.dx-scheduler-appointment-tail .dx-scheduler-appointment-reduced-icon {
  display: none;
}
.dx-scheduler-appointment.dx-state-disabled {
  cursor: default;
  opacity: .6;
  pointer-events: auto;
}
.dx-scheduler-appointment.dx-scheduler-appointment-drag-source {
  opacity: .7;
}
.dx-scheduler-fixed-appointments {
  z-index: 100;
  position: absolute;
}
.dx-scheduler-fixed-appointments .dx-draggable-dragging {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}
.dx-scheduler-fixed-appointments .dx-draggable-dragging .dx-scheduler-appointment,
.dx-scheduler-fixed-appointments .dx-draggable-dragging.dx-state-focused {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-scheduler-fixed-appointments .dx-draggable-dragging .dx-scheduler-appointment:not(.dx-scheduler-appointment-drag-source)::before,
.dx-scheduler-fixed-appointments .dx-draggable-dragging.dx-state-focused:not(.dx-scheduler-appointment-drag-source)::before {
  pointer-events: none;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,.3);
  opacity: .98;
}
.dx-scheduler-fixed-appointments .dx-draggable-dragging .dx-scheduler-appointment {
  -webkit-box-shadow: 7px 7px 15px 0 rgba(50,50,50,.2),inset 0 -2px 0 0 rgba(0,0,0,.3),inset 0 2px 0 0 rgba(0,0,0,.3);
  box-shadow: 7px 7px 15px 0 rgba(50,50,50,.2),inset 0 -2px 0 0 rgba(0,0,0,.3),inset 0 2px 0 0 rgba(0,0,0,.3);
}
.dx-scheduler-agenda .dx-scheduler-appointment {
  background-color: transparent;
  color: rgba(0,0,0,.87);
  padding: 10px;
  border-radius: 5px;
}
.dx-scheduler-agenda .dx-scheduler-appointment.dx-state-hover {
  background-color: rgba(0,0,0,.04);
}
.dx-scheduler-agenda .dx-scheduler-appointment.dx-state-focused {
  color: rgba(0,0,0,.87);
  background-color: rgba(0,0,0,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-scheduler-agenda .dx-scheduler-appointment.dx-state-focused::before {
  background: 0 0;
}
.dx-scheduler-agenda .dx-scheduler-appointment-recurrence-icon {
  position: static;
  color: #fff;
}
.dx-scheduler-agenda .dx-scheduler-agenda-appointment-left-layout {
  overflow: visible;
}
.dx-scheduler-agenda .dx-scheduler-agenda-appointment-right-layout {
  margin-left: 10px;
}
.dx-scheduler-agenda .dx-scheduler-appointment-content,
.dx-scheduler-agenda .dx-scheduler-appointment-recurrence .dx-scheduler-appointment-content {
  padding: 0;
}
.dx-scheduler-agenda .dx-scheduler-appointment-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
}
.dx-scheduler-agenda .dx-scheduler-appointment-content-date {
  opacity: 1;
  white-space: nowrap;
}
.dx-scheduler-agenda .dx-scheduler-appointment-title {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-weight: 700;
  font-size: 14px;
}
.dx-scheduler-agenda .dx-scheduler-appointment-content-details {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 12px;
  opacity: .7;
}
.dx-scheduler-agenda .dx-scheduler-appointment-content-allday {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding-right: 5px;
}
.dx-scheduler-agenda .dx-scheduler-appointment-resource-item,
.dx-scheduler-agenda .dx-scheduler-appointment-resource-list {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.dx-scheduler-agenda .dx-scheduler-appointment-resource-item {
  margin-left: 15px;
}
.dx-scheduler-agenda .dx-scheduler-appointment-resource-item-value {
  margin-left: 3px;
}
.dx-scheduler-agenda .dx-scheduler-agenda-appointment-marker {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: #009688;
}
.dx-scheduler-agenda .dx-rtl .dx-scheduler-agenda-appointment-right-layout {
  margin-left: 0;
  margin-right: 10px;
}
.dx-scheduler-agenda .dx-rtl .dx-scheduler-appointment-content,
.dx-scheduler-agenda .dx-rtl .dx-scheduler-appointment-recurrence .dx-scheduler-appointment-content {
  padding: 0;
}
.dx-scheduler-work-space-day:not(.dx-scheduler-work-space-count):not(.dx-scheduler-work-space-grouped):not(.dx-scheduler-work-space-all-day) .dx-scheduler-header-panel-container {
  display: none;
}
.dx-scheduler-work-space-day:not(.dx-scheduler-work-space-count):not(.dx-scheduler-work-space-grouped) .dx-scheduler-header-panel-empty-cell {
  border: none;
}
.dx-scheduler-work-space-day:not(.dx-scheduler-work-space-count):not(.dx-scheduler-work-space-grouped) .dx-scheduler-date-table-cell {
  border-right: none;
  border-left: none;
}
.dx-scheduler-work-space-day:not(.dx-scheduler-work-space-count):not(.dx-scheduler-work-space-grouped) .dx-scheduler-all-day-table-cell {
  border-top: none;
  border-left: none;
}
.dx-scheduler-work-space-day:not(.dx-scheduler-work-space-count):not(.dx-scheduler-work-space-grouped) .dx-scheduler-time-panel {
  border: none;
}
.dx-scheduler-work-space-day:not(.dx-scheduler-work-space-count).dx-scheduler-work-space-vertical-grouped .dx-scheduler-header-panel-container {
  display: none;
}
.dx-scheduler-work-space-day:not(.dx-scheduler-work-space-count) .dx-scheduler-header-panel-empty-cell {
  margin-top: 0;
}
.dx-scheduler-work-space-day:not(.dx-scheduler-work-space-grouped) .dx-scheduler-header-panel {
  margin-top: 1px;
}
.dx-scheduler-work-space-day .dx-scheduler-all-day-table-cell,
.dx-scheduler-work-space-day .dx-scheduler-date-table-cell,
.dx-scheduler-work-space-day .dx-scheduler-header-panel-cell {
  border-right: none;
}
.dx-rtl .dx-scheduler-work-space-day .dx-scheduler-all-day-table-cell,
.dx-rtl .dx-scheduler-work-space-day .dx-scheduler-date-table-cell,
.dx-rtl .dx-scheduler-work-space-day .dx-scheduler-header-panel-cell {
  border-left: none;
}
.dx-scheduler-work-space-day.dx-scheduler-work-space-both-scrollbar .dx-scheduler-header-panel {
  width: 100%;
}
.dx-scheduler-work-space-day.dx-scheduler-work-space-both-scrollbar:not(.dx-scheduler-work-space-count):not(.dx-scheduler-work-space-grouped) .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-work-space-day.dx-scheduler-work-space-both-scrollbar:not(.dx-scheduler-work-space-count):not(.dx-scheduler-work-space-grouped) .dx-scheduler-time-panel {
  border-right: 1px solid #e0e0e0;
}
.dx-scheduler-work-space-day.dx-scheduler-work-space-vertical-grouped .dx-scheduler-all-day-table-cell {
  border-top: 1px solid #e0e0e0;
}
.dx-scheduler-work-space-day.dx-scheduler-work-space-count:not(.dx-scheduler-work-space-grouped) .dx-scheduler-all-day-table-cell,
.dx-scheduler-work-space-day.dx-scheduler-work-space-count:not(.dx-scheduler-work-space-grouped) .dx-scheduler-date-table-cell,
.dx-scheduler-work-space-day.dx-scheduler-work-space-count:not(.dx-scheduler-work-space-grouped) .dx-scheduler-header-panel-cell {
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
}
.dx-rtl .dx-scheduler-work-space-day:not(.dx-scheduler-work-space-count):not(.dx-scheduler-work-space-grouped) .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-work-space-day.dx-scheduler-work-space-count:not(.dx-scheduler-work-space-grouped) .dx-scheduler-all-day-table-cell:first-child,
.dx-scheduler-work-space-day.dx-scheduler-work-space-count:not(.dx-scheduler-work-space-grouped) .dx-scheduler-date-table-cell:first-child,
.dx-scheduler-work-space-day.dx-scheduler-work-space-count:not(.dx-scheduler-work-space-grouped) .dx-scheduler-header-panel-cell:first-child {
  border-left: none;
}
.dx-rtl .dx-scheduler-work-space-day:not(.dx-scheduler-work-space-count):not(.dx-scheduler-work-space-grouped) .dx-scheduler-time-panel {
  border: none;
}
.dx-rtl .dx-scheduler-work-space-day.dx-scheduler-work-space-count:not(.dx-scheduler-work-space-grouped) .dx-scheduler-all-day-table-cell:first-child,
.dx-rtl .dx-scheduler-work-space-day.dx-scheduler-work-space-count:not(.dx-scheduler-work-space-grouped) .dx-scheduler-date-table-cell:first-child,
.dx-rtl .dx-scheduler-work-space-day.dx-scheduler-work-space-count:not(.dx-scheduler-work-space-grouped) .dx-scheduler-header-panel-cell:first-child,
.dx-rtl .dx-scheduler-work-space-day:not(.dx-scheduler-work-space-count):not(.dx-scheduler-work-space-grouped).dx-scheduler-work-space-both-scrollbar .dx-scheduler-header-panel-empty-cell,
.dx-rtl .dx-scheduler-work-space-day:not(.dx-scheduler-work-space-count):not(.dx-scheduler-work-space-grouped).dx-scheduler-work-space-both-scrollbar .dx-scheduler-time-panel {
  border-left: 1px solid #e0e0e0;
  border-right: none;
}
.dx-scheduler-work-space-month .dx-scheduler-header-panel {
  width: 100%;
}
.dx-scheduler-work-space-month .dx-scheduler-date-table {
  width: 100%;
  height: 100%;
}
.dx-scheduler-work-space-month .dx-scheduler-date-table-cell,
.dx-scheduler-work-space-month .dx-scheduler-header-panel-cell {
  border-right: none;
}
.dx-scheduler-work-space-month .dx-scheduler-date-table-scrollable .dx-scrollable-content {
  min-height: 300px;
}
.dx-scheduler-work-space-month:not(.dx-scheduler-work-space-count):not(.dx-scheduler-work-space-vertical-grouped) .dx-scheduler-date-table-scrollable-content,
.dx-scheduler-work-space-month:not(.dx-scheduler-work-space-count):not(.dx-scheduler-work-space-vertical-grouped) .dx-scrollable-content {
  height: 100%;
}
.dx-scheduler-work-space-month .dx-scheduler-date-table-cell {
  height: 50px;
  vertical-align: top;
  text-align: right;
  font-size: 16px;
  color: rgba(0,0,0,.54);
}
.dx-scheduler-work-space-month .dx-scheduler-date-table-cell .dx-scheduler-date-table-cell-text {
  padding-right: 6px;
}
.dx-scheduler-work-space-month.dx-scheduler-work-space-count .dx-scheduler-date-table-cell {
  height: 75px;
}
.dx-scheduler-work-space-month.dx-scheduler-work-space-count .dx-scheduler-date-table-first-of-month {
  color: #009688;
  background-color: rgba(0,150,136,.15);
  font-weight: 700;
}
.dx-scheduler-work-space-month.dx-scheduler-work-space-both-scrollbar .dx-scheduler-sidebar-scrollable {
  display: none;
}
.dx-scheduler-work-space-month.dx-scheduler-work-space-vertical-grouped .dx-scheduler-sidebar-scrollable {
  display: block;
  float: left;
}
.dx-scheduler-work-space-month.dx-scheduler-work-space-vertical-grouped .dx-scheduler-group-header {
  -webkit-box-shadow: 0 -2px 0 #e0e0e0;
  box-shadow: 0 -2px 0 #e0e0e0;
  border-bottom: none;
}
.dx-scheduler-work-space-month.dx-scheduler-work-space-vertical-grouped .dx-scheduler-date-table-cell {
  height: 75px;
}
.dx-scheduler-timeline-day .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-timeline-month .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-timeline-week .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-timeline-work-week .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-work-space-month.dx-scheduler-work-space-vertical-grouped.dx-scheduler-work-space-both-scrollbar .dx-scheduler-header-panel {
  border-bottom: none;
}
.dx-scheduler-timeline-day.dx-scheduler-group-column-count-two .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-timeline-month.dx-scheduler-group-column-count-two .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-timeline-week.dx-scheduler-group-column-count-two .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-timeline-work-week.dx-scheduler-group-column-count-two .dx-scheduler-header-panel-empty-cell {
  width: 160px;
}
.dx-scheduler-timeline-day.dx-scheduler-group-column-count-two .dx-scheduler-group-flex-container .dx-scheduler-group-header,
.dx-scheduler-timeline-month.dx-scheduler-group-column-count-two .dx-scheduler-group-flex-container .dx-scheduler-group-header,
.dx-scheduler-timeline-week.dx-scheduler-group-column-count-two .dx-scheduler-group-flex-container .dx-scheduler-group-header,
.dx-scheduler-timeline-work-week.dx-scheduler-group-column-count-two .dx-scheduler-group-flex-container .dx-scheduler-group-header {
  width: 80px;
}
.dx-scheduler-timeline-day.dx-scheduler-group-column-count-three .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-timeline-month.dx-scheduler-group-column-count-three .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-timeline-week.dx-scheduler-group-column-count-three .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-timeline-work-week.dx-scheduler-group-column-count-three .dx-scheduler-header-panel-empty-cell {
  width: 240px;
}
.dx-scheduler-timeline-day.dx-scheduler-group-column-count-three .dx-scheduler-group-flex-container .dx-scheduler-group-header,
.dx-scheduler-timeline-month.dx-scheduler-group-column-count-three .dx-scheduler-group-flex-container .dx-scheduler-group-header,
.dx-scheduler-timeline-week.dx-scheduler-group-column-count-three .dx-scheduler-group-flex-container .dx-scheduler-group-header,
.dx-scheduler-timeline-work-week.dx-scheduler-group-column-count-three .dx-scheduler-group-flex-container .dx-scheduler-group-header {
  width: 80px;
}
.dx-scheduler-timeline-day .dx-scheduler-date-table-container,
.dx-scheduler-timeline-day .dx-scheduler-date-table-scrollable-content,
.dx-scheduler-timeline-month .dx-scheduler-date-table-container,
.dx-scheduler-timeline-month .dx-scheduler-date-table-scrollable-content,
.dx-scheduler-timeline-week .dx-scheduler-date-table-container,
.dx-scheduler-timeline-week .dx-scheduler-date-table-scrollable-content,
.dx-scheduler-timeline-work-week .dx-scheduler-date-table-container,
.dx-scheduler-timeline-work-week .dx-scheduler-date-table-scrollable-content {
  min-height: 100%;
  height: 100%;
  width: 100%;
}
.dx-scheduler-timeline-day .dx-scheduler-header-panel,
.dx-scheduler-timeline-month .dx-scheduler-header-panel,
.dx-scheduler-timeline-week .dx-scheduler-header-panel,
.dx-scheduler-timeline-work-week .dx-scheduler-header-panel {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
}
.dx-scheduler-timeline-day .dx-scheduler-header-panel thead,
.dx-scheduler-timeline-month .dx-scheduler-header-panel thead,
.dx-scheduler-timeline-week .dx-scheduler-header-panel thead,
.dx-scheduler-timeline-work-week .dx-scheduler-header-panel thead {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  width: 100%;
}
.dx-scheduler-timeline-day .dx-scheduler-header-row,
.dx-scheduler-timeline-month .dx-scheduler-header-row,
.dx-scheduler-timeline-week .dx-scheduler-header-row,
.dx-scheduler-timeline-work-week .dx-scheduler-header-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
}
.dx-scheduler-timeline-day .dx-scheduler-header-panel-cell,
.dx-scheduler-timeline-month .dx-scheduler-header-panel-cell,
.dx-scheduler-timeline-week .dx-scheduler-header-panel-cell,
.dx-scheduler-timeline-work-week .dx-scheduler-header-panel-cell {
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
}
.dx-scheduler-timeline-day .dx-scheduler-header-panel-cell:not(.dx-scheduler-header-panel-week-cell),
.dx-scheduler-timeline-month .dx-scheduler-header-panel-cell:not(.dx-scheduler-header-panel-week-cell),
.dx-scheduler-timeline-week .dx-scheduler-header-panel-cell:not(.dx-scheduler-header-panel-week-cell),
.dx-scheduler-timeline-work-week .dx-scheduler-header-panel-cell:not(.dx-scheduler-header-panel-week-cell) {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  -ms-flex-flow: row-reverse nowrap;
  flex-flow: row-reverse nowrap;
}
.dx-scheduler-timeline-day .dx-scheduler-header-panel-week-cell,
.dx-scheduler-timeline-month .dx-scheduler-header-panel-week-cell,
.dx-scheduler-timeline-week .dx-scheduler-header-panel-week-cell,
.dx-scheduler-timeline-work-week .dx-scheduler-header-panel-week-cell {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
}
.dx-scheduler-timeline-day .dx-scheduler-header-row .dx-scheduler-header-panel-cell,
.dx-scheduler-timeline-month .dx-scheduler-header-row .dx-scheduler-header-panel-cell,
.dx-scheduler-timeline-week .dx-scheduler-header-row .dx-scheduler-header-panel-cell,
.dx-scheduler-timeline-work-week .dx-scheduler-header-row .dx-scheduler-header-panel-cell {
  border-right: none;
}
.dx-scheduler-timeline .dx-scheduler-date-table-cell,
.dx-scheduler-timeline .dx-scheduler-header-panel-cell:not(.dx-scheduler-header-panel-week-cell) {
  width: 200px;
}
.dx-scheduler-timeline .dx-scheduler-work-space-vertical-group-table {
  display: none;
}
.dx-scheduler-timeline .dx-scheduler-date-table {
  border-spacing: 0;
  border-collapse: separate;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
}
.dx-scheduler-timeline .dx-scheduler-date-table tbody {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  height: 100%;
  min-height: 100px;
}
.dx-scheduler-timeline .dx-scheduler-date-table .dx-scheduler-date-table-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
}
.dx-scheduler-timeline .dx-scheduler-date-table .dx-scheduler-date-table-cell {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  height: inherit;
  min-height: 50px;
}
.dx-scheduler-timeline .dx-scheduler-group-table {
  border-spacing: 0;
  border-collapse: separate;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
}
.dx-scheduler-timeline .dx-scheduler-group-table tbody {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  height: 100%;
}
.dx-scheduler-timeline .dx-scheduler-group-header {
  min-height: 50px;
}
.dx-scheduler-timeline .dx-scheduler-group-header-content {
  overflow: visible;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
}
.dx-scheduler-timeline .dx-scheduler-group-header-content div {
  white-space: normal;
  line-height: normal;
}
.dx-scheduler-timeline.dx-scheduler-work-space-group-by-date .dx-scheduler-group-header {
  width: 200px;
}
.dx-scheduler-timeline .dx-scheduler-date-table,
.dx-scheduler-timeline .dx-scheduler-date-table-scrollable .dx-scrollable-content,
.dx-scheduler-timeline .dx-scheduler-group-table,
.dx-scheduler-timeline .dx-scheduler-sidebar-scrollable .dx-scrollable-content {
  height: 100%;
  min-height: 100px;
}
.dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-table-scrollable .dx-scrollable-content,
.dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-group-table,
.dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-sidebar-scrollable .dx-scrollable-content {
  height: auto;
}
.dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-table .dx-scheduler-date-table-row:first-child .dx-scheduler-date-table-cell {
  border-top-color: transparent;
}
.dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-header-panel,
.dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-header-panel-empty-cell {
  border-bottom: 1px solid #e0e0e0;
}
.dx-scheduler-timeline .dx-scheduler-sidebar-scrollable {
  display: none;
}
.dx-scheduler-timeline.dx-scheduler-work-space-grouped .dx-scheduler-sidebar-scrollable {
  display: block;
}
.dx-scheduler-timeline.dx-scheduler-work-space-grouped .dx-scheduler-group-row .dx-scheduler-group-header {
  border: none;
  border-top: 1px solid #e0e0e0;
}
.dx-scheduler-timeline.dx-scheduler-work-space-grouped.dx-scheduler-work-space-group-by-date .dx-scheduler-group-row .dx-scheduler-group-header,
.dx-scheduler-timeline.dx-scheduler-work-space-grouped.dx-scheduler-work-space-group-by-date .dx-scheduler-group-row .dx-scheduler-last-group-cell {
  border-right: 1px solid #e0e0e0;
}
.dx-scheduler-timeline.dx-scheduler-work-space-grouped .dx-scheduler-date-table-cell:first-child {
  border-left: none;
}
.dx-rtl .dx-scheduler-timeline.dx-scheduler-work-space-grouped .dx-scheduler-date-table-cell:first-child {
  border-left: 1px solid #e0e0e0;
  border-right: none;
}
.dx-scheduler:not(.dx-scheduler-native) .dx-scheduler-timeline .dx-scheduler-date-table .dx-scheduler-date-table-row {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.dx-scheduler-agenda .dx-scheduler-time-panel-cell::after {
  display: none;
}
.dx-scheduler-agenda .dx-scheduler-group-table {
  border-spacing: 0;
  margin-top: 0;
  height: 100%;
  float: left;
}
.dx-scheduler-agenda .dx-scheduler-time-panel {
  margin-top: 0;
  width: 70px;
  border: none;
}
.dx-scheduler-agenda .dx-scheduler-date-table-cell,
.dx-scheduler-agenda .dx-scheduler-time-panel-cell {
  border: none;
}
.dx-scheduler-agenda.dx-scheduler-work-space-grouped .dx-scheduler-date-table {
  float: right;
}
.dx-scheduler-agenda.dx-scheduler-work-space-grouped .dx-scheduler-group-row:first-child .dx-scheduler-group-header-content::before {
  border-bottom: none;
}
.dx-scheduler-agenda.dx-scheduler-work-space-grouped .dx-scheduler-time-panel-cell::after {
  display: none;
}
.dx-scheduler-agenda .dx-scheduler-group-header {
  vertical-align: top;
  border-top: none;
  border-left: none;
  border-right: none;
  font-weight: 700;
  padding: 0;
}
.dx-scheduler-small .dx-scheduler-agenda .dx-scheduler-group-header {
  width: 40px;
  font-size: 14px;
}
.dx-scheduler-agenda .dx-scheduler-group-header-content {
  width: 80px;
  overflow: hidden;
}
.dx-scheduler-agenda .dx-scheduler-group-header-content div {
  white-space: normal;
}
.dx-scheduler-agenda-nodata {
  text-align: center;
  opacity: .5;
  position: absolute;
  top: 45%;
  left: 0;
  right: 0;
}
.dx-rtl .dx-scheduler-agenda .dx-scheduler-time-panel {
  border: none;
}
.dx-scheduler-small .dx-scheduler-agenda .dx-scheduler-time-panel {
  width: 70px;
}
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-table-scrollable .dx-scrollable-content,
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-group-table,
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-sidebar-scrollable .dx-scrollable-content {
  min-height: 100%;
}
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-table-scrollable .dx-scrollable-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-table-container,
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-table-scrollable-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
}
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-table,
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-table > tbody {
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
}
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-table-row {
  height: 50px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
}
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-table-cell {
  height: auto;
}
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar.dx-scheduler-work-space-virtual .dx-scheduler-date-table-row {
  height: 50px;
}
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-table-container,
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-table-scrollable,
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-header-scrollable,
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-header-tables-container {
  width: 100%;
}
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-table-scrollable,
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-header-tables-container {
  -ms-flex-negative: 1;
  flex-shrink: 1;
}
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-table-scrollable .dx-scrollable-content,
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-header-scrollable .dx-scrollable-content {
  min-width: 100%;
}
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-table-cell,
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar .dx-scheduler-header-panel-cell {
  -ms-flex-negative: 0;
  flex-shrink: 0;
}
.dx-scheduler.dx-scheduler-native .dx-scheduler-timeline:not(.dx-scheduler-work-space-both-scrollbar) .dx-scheduler-date-table .dx-scheduler-date-table-row {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.dx-scheduler-header-panel-cell.dx-scheduler-header-panel-current-time-cell {
  color: #009688;
}
.dx-scheduler-header-panel-cell.dx-scheduler-header-panel-current-time-cell::before {
  position: absolute;
  top: 37px;
  right: 0;
  width: 100%;
  height: 2px;
  content: "";
  background-color: #eb5757;
}
.dx-scheduler-group-column-count-one .dx-scheduler-header-panel-empty-cell {
  width: 65px;
}
.dx-scheduler-group-column-count-two .dx-scheduler-header-panel-empty-cell {
  width: 97.5px;
}
.dx-scheduler-group-column-count-two .dx-scheduler-group-flex-container .dx-scheduler-group-header {
  width: 48.75px;
}
.dx-scheduler-group-column-count-three .dx-scheduler-header-panel-empty-cell {
  width: 130px;
}
.dx-scheduler-group-column-count-three .dx-scheduler-group-flex-container .dx-scheduler-group-header {
  width: 43.3333333333px;
}
.dx-scheduler-work-space-day .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-work-space-week .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-work-space-work-week .dx-scheduler-header-panel-empty-cell {
  width: 65px;
}
.dx-scheduler-work-space-day.dx-scheduler-group-column-count-one .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-work-space-week.dx-scheduler-group-column-count-one .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-work-space-work-week.dx-scheduler-group-column-count-one .dx-scheduler-header-panel-empty-cell {
  width: 130px;
}
.dx-scheduler-work-space-day.dx-scheduler-group-column-count-two .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-work-space-week.dx-scheduler-group-column-count-two .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-work-space-work-week.dx-scheduler-group-column-count-two .dx-scheduler-header-panel-empty-cell {
  width: 162.5px;
}
.dx-scheduler-work-space-day.dx-scheduler-group-column-count-three .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-work-space-week.dx-scheduler-group-column-count-three .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-work-space-work-week.dx-scheduler-group-column-count-three .dx-scheduler-header-panel-empty-cell {
  width: 195px;
}
.dx-scheduler-work-space-day.dx-scheduler-work-space-odd-cells .dx-scheduler-date-table-row:nth-child(odd) .dx-scheduler-date-table-cell,
.dx-scheduler-work-space-week.dx-scheduler-work-space-odd-cells .dx-scheduler-date-table-row:nth-child(odd) .dx-scheduler-date-table-cell,
.dx-scheduler-work-space-work-week.dx-scheduler-work-space-odd-cells .dx-scheduler-date-table-row:nth-child(odd) .dx-scheduler-date-table-cell {
  border-top: 1px solid #e0e0e0;
}
.dx-scheduler-work-space-day.dx-scheduler-work-space-odd-cells .dx-scheduler-date-table-row:first-child .dx-scheduler-date-table-cell,
.dx-scheduler-work-space-week.dx-scheduler-work-space-odd-cells .dx-scheduler-date-table-row:first-child .dx-scheduler-date-table-cell,
.dx-scheduler-work-space-work-week.dx-scheduler-work-space-odd-cells .dx-scheduler-date-table-row:first-child .dx-scheduler-date-table-cell {
  border-top: none;
}
.dx-scheduler-work-space-day.dx-scheduler-work-space-odd-cells .dx-scheduler-time-panel-row:nth-child(2n) .dx-scheduler-time-panel-cell::after,
.dx-scheduler-work-space-week.dx-scheduler-work-space-odd-cells .dx-scheduler-time-panel-row:nth-child(2n) .dx-scheduler-time-panel-cell::after,
.dx-scheduler-work-space-work-week.dx-scheduler-work-space-odd-cells .dx-scheduler-time-panel-row:nth-child(2n) .dx-scheduler-time-panel-cell::after {
  background-color: #e0e0e0;
}
.dx-scheduler-work-space {
  border: 1px solid #e0e0e0;
  background-color: #fff;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  width: 100%;
  border-top: none;
  float: left;
}
.dx-scheduler-work-space.dx-scheduler-timeline-month:not(.dx-scheduler-agenda) .dx-scheduler-all-day-title {
  border-top: 1px solid #e0e0e0;
}
.dx-scheduler-work-space.dx-scheduler-timeline-month:not(.dx-scheduler-agenda) .dx-scheduler-date-table-cell {
  border-right: none;
}
.dx-scheduler-work-space.dx-scheduler-work-space-grouped:not(.dx-scheduler-agenda) .dx-scheduler-all-day-panel td {
  border-top: 1px solid #e0e0e0;
}
.dx-scheduler-work-space:not(.dx-scheduler-work-space-all-day):not(.dx-scheduler-work-space-month):not(.dx-scheduler-timeline) .dx-scheduler-header-panel,
.dx-scheduler-work-space:not(.dx-scheduler-work-space-all-day):not(.dx-scheduler-work-space-month):not(.dx-scheduler-timeline) .dx-scheduler-header-panel-empty-cell {
  border-bottom: 1px solid #e0e0e0;
}
.dx-scheduler-work-space:not(.dx-scheduler-work-space-all-day):not(.dx-scheduler-work-space-month):not(.dx-scheduler-timeline).dx-scheduler-work-space-vertical-grouped.dx-scheduler-work-space-both-scrollbar .dx-scheduler-header-panel,
.dx-scheduler-work-space:not(.dx-scheduler-work-space-all-day):not(.dx-scheduler-work-space-month):not(.dx-scheduler-timeline).dx-scheduler-work-space-vertical-grouped.dx-scheduler-work-space-both-scrollbar .dx-scheduler-header-panel-empty-cell {
  border-bottom: none;
}
.dx-scheduler-work-space.dx-scheduler-work-space-month:not(.dx-scheduler-work-space-vertical-grouped) .dx-scheduler-header-panel {
  border-bottom: 1px solid #e0e0e0;
}
.dx-scheduler-header-panel-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}
.dx-scheduler-header-panel-empty-cell {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: end;
  -ms-flex-align: end;
  align-items: flex-end;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  width: 0;
  border-bottom: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
}
.dx-scheduler-header-tables-container {
  overflow: hidden;
  width: 100%;
}
.dx-scheduler-date-table-container {
  position: relative;
}
.dx-scheduler-work-space-month:not(.dx-scheduler-work-space-count) .dx-scheduler-date-table-container {
  height: 100%;
}
.dx-scheduler-date-table-scrollable {
  width: 100%;
  overflow: hidden;
}
.dx-scheduler-date-table-scrollable .dx-scrollable-content {
  overflow: hidden;
}
.dx-scheduler-date-table-scrollable-content,
.dx-scheduler-side-bar-scrollable-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
}
.dx-scheduler-date-table-scrollable-content {
  position: relative;
  float: left;
}
.dx-scheduler-date-table-cell,
.dx-scheduler-group-header,
.dx-scheduler-header-panel-cell,
.dx-scheduler-time-panel-cell {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  cursor: default;
}
.dx-scheduler-date-table-current-date {
  font-weight: 700;
}
.dx-scheduler-date-table-other-month {
  opacity: .5;
}
.dx-scheduler-work-space-flex-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  height: 100%;
  min-height: 0;
}
.dx-scheduler-group-flex-container {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  min-height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.dx-scheduler-group-flex-container .dx-scheduler-group-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  min-width: 0;
}
.dx-scheduler-group-flex-container .dx-scheduler-group-row:last-child .dx-scheduler-group-header {
  border-right: 1px solid #e0e0e0;
}
.dx-scheduler-group-flex-container .dx-scheduler-group-row .dx-scheduler-group-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 100%;
  flex: 1 1 100%;
  padding: 0 5px;
  height: auto;
  width: 65px;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  border: none;
  border-top: 1px solid #e0e0e0;
}
.dx-scheduler-header-scrollable {
  height: auto;
}
.dx-scheduler-work-space-day .dx-scheduler-date-table-row:first-child .dx-scheduler-date-table-cell,
.dx-scheduler-work-space-week .dx-scheduler-date-table .dx-scheduler-date-table-row:first-child .dx-scheduler-date-table-cell,
.dx-scheduler-work-space-work-week .dx-scheduler-date-table-row:first-child .dx-scheduler-date-table-cell {
  border-top: none;
}
.dx-scheduler-all-day-table-cell,
.dx-scheduler-date-table-cell {
  border-top: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
}
.dx-scheduler-all-day-table-cell:first-child,
.dx-scheduler-date-table-cell:first-child {
  border-left: none;
}
.dx-scheduler-date-table-cell,
.dx-scheduler-header-panel-cell {
  border-right: 1px solid #e0e0e0;
}
.dx-scheduler-work-space-day.dx-scheduler-work-space-count .dx-scheduler-all-day-title,
.dx-scheduler-work-space-week .dx-scheduler-all-day-title,
.dx-scheduler-work-space-work-week .dx-scheduler-all-day-title {
  border-top: 1px solid #e0e0e0;
}
.dx-scheduler-timeline .dx-scheduler-all-day-panel,
.dx-scheduler-timeline .dx-scheduler-all-day-title,
.dx-scheduler-timeline .dx-scheduler-time-panel,
.dx-scheduler-work-space-month .dx-scheduler-all-day-panel,
.dx-scheduler-work-space-month .dx-scheduler-all-day-title,
.dx-scheduler-work-space-month .dx-scheduler-time-panel {
  display: none;
}
.dx-scheduler-work-space-month .dx-scheduler-all-day-table-cell:nth-child(7n),
.dx-scheduler-work-space-month .dx-scheduler-date-table-cell:nth-child(7n),
.dx-scheduler-work-space-month .dx-scheduler-header-panel-cell:nth-child(7n),
.dx-scheduler-work-space-week .dx-scheduler-all-day-table-cell:nth-child(7n),
.dx-scheduler-work-space-week .dx-scheduler-date-table-cell:nth-child(7n),
.dx-scheduler-work-space-week .dx-scheduler-header-panel-cell:nth-child(7n) {
  border-right: none;
}
.dx-rtl .dx-scheduler-work-space-month .dx-scheduler-all-day-table-cell:nth-child(7n),
.dx-rtl .dx-scheduler-work-space-month .dx-scheduler-date-table-cell:nth-child(7n),
.dx-rtl .dx-scheduler-work-space-month .dx-scheduler-header-panel-cell:nth-child(7n),
.dx-rtl .dx-scheduler-work-space-week .dx-scheduler-all-day-table-cell:nth-child(7n),
.dx-rtl .dx-scheduler-work-space-week .dx-scheduler-date-table-cell:nth-child(7n),
.dx-rtl .dx-scheduler-work-space-week .dx-scheduler-header-panel-cell:nth-child(7n) {
  border-left: none;
}
.dx-scheduler-work-space-work-week .dx-scheduler-all-day-table-cell:nth-child(5n),
.dx-scheduler-work-space-work-week .dx-scheduler-date-table-cell:nth-child(5n),
.dx-scheduler-work-space-work-week .dx-scheduler-header-panel-cell:nth-child(5n) {
  border-right: none;
}
.dx-rtl .dx-scheduler-work-space-work-week .dx-scheduler-all-day-table-cell:nth-child(5n),
.dx-rtl .dx-scheduler-work-space-work-week .dx-scheduler-date-table-cell:nth-child(5n),
.dx-rtl .dx-scheduler-work-space-work-week .dx-scheduler-header-panel-cell:nth-child(5n) {
  border-left: none;
}
.dx-scheduler-work-space-count.dx-scheduler-work-space-week .dx-scheduler-all-day-table-cell:nth-child(7n),
.dx-scheduler-work-space-count.dx-scheduler-work-space-week .dx-scheduler-date-table-cell:nth-child(7n),
.dx-scheduler-work-space-count.dx-scheduler-work-space-week .dx-scheduler-header-panel-cell:nth-child(7n) {
  border-right: 1px solid #e0e0e0;
}
.dx-rtl .dx-scheduler-work-space-count.dx-scheduler-work-space-week .dx-scheduler-all-day-table-cell:nth-child(7n),
.dx-rtl .dx-scheduler-work-space-count.dx-scheduler-work-space-week .dx-scheduler-date-table-cell:nth-child(7n),
.dx-rtl .dx-scheduler-work-space-count.dx-scheduler-work-space-week .dx-scheduler-header-panel-cell:nth-child(7n) {
  border-left: 1px solid #e0e0e0;
}
.dx-scheduler-work-space-count.dx-scheduler-work-space-work-week .dx-scheduler-all-day-table-cell:nth-child(5n),
.dx-scheduler-work-space-count.dx-scheduler-work-space-work-week .dx-scheduler-date-table-cell:nth-child(5n),
.dx-scheduler-work-space-count.dx-scheduler-work-space-work-week .dx-scheduler-header-panel-cell:nth-child(5n) {
  border-right: 1px solid #e0e0e0;
}
.dx-rtl .dx-scheduler-work-space-count.dx-scheduler-work-space-work-week .dx-scheduler-all-day-table-cell:nth-child(5n),
.dx-rtl .dx-scheduler-work-space-count.dx-scheduler-work-space-work-week .dx-scheduler-date-table-cell:nth-child(5n),
.dx-rtl .dx-scheduler-work-space-count.dx-scheduler-work-space-work-week .dx-scheduler-header-panel-cell:nth-child(5n) {
  border-right: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
}
.dx-scheduler-header-panel {
  border-spacing: 0;
  table-layout: fixed;
  width: 100%;
}
.dx-scheduler-work-space.dx-scheduler-work-space-all-day .dx-scheduler-header-panel-empty-cell {
  border-bottom: none;
}
.dx-scheduler-work-space-both-scrollbar .dx-scheduler-header-panel {
  width: auto;
}
.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-table {
  float: none;
}
.dx-scheduler-work-space-both-scrollbar .dx-scheduler-header-scrollable {
  height: auto;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}
.dx-scheduler-work-space-both-scrollbar .dx-scheduler-all-day-table-row .dx-scheduler-all-day-table-cell:first-child,
.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-table-row .dx-scheduler-date-table-cell:first-child {
  border-left: none;
}
.dx-scheduler-header-panel-cell {
  position: relative;
  color: rgba(0,0,0,.54);
  padding: 0;
  font-weight: 400;
  border-left: 1px solid #e0e0e0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dx-scheduler-header-panel-cell:first-child {
  border-left: 1px solid transparent;
}
.dx-scheduler-all-day-panel {
  width: 100%;
  position: relative;
}
.dx-scheduler-all-day-title {
  color: rgba(0,0,0,.54);
  width: 65px;
  position: relative;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}
.dx-scheduler-small .dx-scheduler-all-day-title {
  width: 32.5px;
}
.dx-scheduler-work-space-vertical-grouped .dx-scheduler-all-day-title {
  height: 50px;
  line-height: 50px;
}
.dx-scheduler-all-day-table {
  border-spacing: 0;
  table-layout: fixed;
  width: 100%;
}
.dx-scheduler-group-header {
  height: 30px;
  text-align: center;
}
.dx-scheduler-time-panel {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 65px;
  border-collapse: collapse;
  border-right: 1px solid #e0e0e0;
}
.dx-scheduler-small .dx-scheduler-time-panel {
  width: 32.5px;
  font-size: 14px;
}
.dx-scheduler-time-panel .dx-scheduler-time-panel-row:first-of-type td > div {
  margin-top: 0;
}
.dx-scheduler-time-panel-cell {
  color: rgba(0,0,0,.54);
  position: relative;
  width: 100%;
  text-align: right;
  vertical-align: top;
  border-bottom: 1px solid transparent;
}
.dx-scheduler-small .dx-scheduler-time-panel-cell {
  padding-left: 0;
}
.dx-scheduler-time-panel-cell::after {
  position: absolute;
  bottom: -1px;
  width: 10%;
  height: 1px;
  right: 0;
  background-color: #e0e0e0;
  content: none;
}
.dx-scheduler-time-panel-cell.dx-scheduler-time-panel-current-time-cell {
  color: #009688;
}
.dx-scheduler-time-panel-cell.dx-scheduler-time-panel-current-time-cell::before {
  position: absolute;
  top: 0;
  right: 0;
  width: 2px;
  height: inherit;
  background-color: #eb5757;
}
.dx-scheduler-time-panel-row:last-child .dx-scheduler-time-panel-cell::after {
  display: none;
}
.dx-scheduler-time-panel-title-cell {
  padding: 0;
}
.dx-scheduler-date-table {
  width: 100%;
  border-spacing: 0;
  table-layout: fixed;
}
.dx-scheduler-all-day-table-cell.dx-state-hover.dx-state-focused,
.dx-scheduler-date-table-cell.dx-state-hover.dx-state-focused {
  background-color: rgba(0,150,136,.12);
}
.dx-scheduler-all-day-table-cell.dx-state-focused,
.dx-scheduler-date-table-cell.dx-state-focused {
  background-color: rgba(0,150,136,.12);
  opacity: 1;
}
.dx-scheduler-all-day-table-cell.dx-scheduler-focused-cell,
.dx-scheduler-date-table-cell.dx-scheduler-focused-cell {
  -webkit-box-shadow: inset 0 0 0 1px #009688;
  box-shadow: inset 0 0 0 1px #009688;
}
.dx-scheduler-all-day-table-cell > div,
.dx-scheduler-date-table-cell > div {
  pointer-events: none;
}
.dx-scheduler-date-table-droppable-cell {
  background-color: #f2f2f2;
}
.dx-scheduler-group-header-content div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dx-scheduler-work-space-horizontal-grouped.dx-scheduler-timeline .dx-scheduler-sidebar-scrollable {
  display: none;
}
.dx-scheduler-work-space-horizontal-grouped.dx-scheduler-timeline .dx-scheduler-group-header-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 40px;
}
.dx-scheduler-work-space-horizontal-grouped.dx-scheduler-timeline .dx-scheduler-group-header-content > div {
  margin: auto;
}
.dx-scheduler-work-space-horizontal-grouped.dx-scheduler-timeline .dx-scheduler-group-row,
.dx-scheduler-work-space-horizontal-grouped.dx-scheduler-timeline .dx-scheduler-header-panel,
.dx-scheduler-work-space-horizontal-grouped.dx-scheduler-timeline .dx-scheduler-header-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
}
.dx-scheduler-work-space-horizontal-grouped.dx-scheduler-timeline.dx-scheduler-work-space-grouped .dx-scheduler-group-header {
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
}
.dx-scheduler-work-space-horizontal-grouped.dx-scheduler-timeline.dx-scheduler-work-space-group-by-date .dx-scheduler-group-header {
  -ms-flex-preferred-size: auto;
  flex-basis: auto;
}
.dx-scheduler-work-space-horizontal-grouped.dx-scheduler-timeline:not(.dx-scheduler-work-space-group-by-date) .dx-scheduler-header-row .dx-scheduler-header-panel-cell {
  border-right: none;
}
.dx-scheduler-work-space-vertical-grouped .dx-scheduler-work-space-vertical-group-table {
  height: 100%;
  min-height: 100px;
  border-top: 1px solid #e0e0e0;
  border-spacing: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
}
.dx-scheduler-work-space-vertical-grouped.dx-scheduler-work-space-day .dx-scheduler-all-day-title,
.dx-scheduler-work-space-vertical-grouped.dx-scheduler-work-space-week .dx-scheduler-all-day-title,
.dx-scheduler-work-space-vertical-grouped.dx-scheduler-work-space-work-week .dx-scheduler-all-day-title {
  top: 0;
  height: 50px!important;
  line-height: 50px!important;
  border-bottom: none;
}
.dx-scheduler-work-space-vertical-grouped .dx-scheduler-all-day-panel {
  display: table-cell;
  position: relative;
}
.dx-scheduler-work-space-vertical-grouped .dx-scheduler-all-day-table-row {
  height: 50px;
}
.dx-scheduler-work-space-vertical-grouped .dx-scheduler-time-panel-cell.dx-scheduler-first-group-cell {
  border-top: 1px solid #e0e0e0;
}
.dx-scheduler-work-space-vertical-grouped .dx-scheduler-time-panel-cell.dx-scheduler-first-group-cell > div {
  margin-top: 0;
}
.dx-scheduler-work-space-vertical-grouped .dx-scheduler-time-panel-cell.dx-scheduler-last-group-cell {
  border-bottom: none;
  -webkit-box-shadow: inset 0 -1px 0 #e0e0e0;
  box-shadow: inset 0 -1px 0 #e0e0e0;
}
.dx-scheduler-work-space-vertical-grouped .dx-scheduler-date-table-cell.dx-scheduler-last-group-cell {
  border-bottom: 2px solid #e0e0e0;
}
.dx-scheduler-work-space-vertical-grouped.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-table-scrollable,
.dx-scheduler-work-space-vertical-grouped.dx-scheduler-work-space-both-scrollbar .dx-scheduler-sidebar-scrollable {
  border-top: 1px solid #e0e0e0;
}
.dx-rtl .dx-scheduler-header-panel-empty-cell {
  border-left: 1px solid #e0e0e0;
  border-right: none;
}
.dx-rtl .dx-scheduler-date-table-scrollable-content,
.dx-rtl .dx-scheduler-side-bar-scrollable-content {
  direction: rtl;
}
.dx-rtl .dx-scheduler-sidebar-scrollable .dx-scheduler-group-row:last-child .dx-scheduler-group-header,
.dx-rtl .dx-scheduler-work-space-vertical-grouped .dx-scheduler-group-row:last-child .dx-scheduler-group-header {
  border-right: none;
  border-left: 1px solid #e0e0e0;
}
.dx-rtl .dx-scheduler-header-panel {
  left: 0;
  right: inherit;
}
.dx-rtl .dx-scheduler-time-panel,
.dx-rtl .dx-scheduler-work-space-vertical-group-table {
  float: right;
}
.dx-scheduler-small .dx-rtl .dx-scheduler-time-panel-cell {
  padding-left: 10px;
}
.dx-rtl .dx-scheduler-time-panel-cell::after {
  right: auto;
  left: 0;
}
.dx-rtl .dx-scheduler-work-space-week .dx-scheduler-all-day-table-cell,
.dx-rtl .dx-scheduler-work-space-work-week .dx-scheduler-all-day-table-cell {
  border-right: 1px solid #e0e0e0;
  border-left: none;
}
.dx-rtl.dx-scheduler-work-space-both-scrollbar .dx-scheduler-time-panel {
  border-left: 1px solid #e0e0e0;
  border-right: none;
}
.dx-rtl.dx-scheduler-work-space-both-scrollbar .dx-scheduler-all-day-table-row .dx-scheduler-all-day-table-cell:first-child,
.dx-rtl.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-table-row .dx-scheduler-date-table-cell:first-child,
.dx-rtl.dx-scheduler-work-space-both-scrollbar .dx-scheduler-header-row .dx-scheduler-header-panel-cell:first-child {
  border-right: none;
  border-left: 1px solid #e0e0e0;
}
.dx-rtl .dx-scheduler-timeline.dx-scheduler-work-space-grouped .dx-scheduler-sidebar-scrollable {
  float: right;
}
.dx-rtl .dx-scheduler-timeline.dx-scheduler-work-space-grouped .dx-scheduler-group-header {
  padding: 0 5px 0 10px;
}
.dx-rtl .dx-scheduler-timeline.dx-scheduler-work-space-grouped.dx-scheduler-group-column-count-three .dx-scheduler-group-header:last-child,
.dx-rtl .dx-scheduler-timeline.dx-scheduler-work-space-grouped.dx-scheduler-group-column-count-two .dx-scheduler-group-header:last-child {
  text-align: right;
}
.dx-rtl .dx-scheduler-all-day-table-cell:first-child,
.dx-rtl .dx-scheduler-date-table-cell:first-child,
.dx-rtl .dx-scheduler-header-panel-cell:first-child {
  border-right: none;
  border-left: 1px solid #e0e0e0;
}
.dx-rtl .dx-scheduler-time-panel {
  border-left: 1px solid #e0e0e0;
  border-right: none;
}
.dx-scheduler-small .dx-scheduler-work-space-day .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-small .dx-scheduler-work-space-week .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-small .dx-scheduler-work-space-work-week .dx-scheduler-header-panel-empty-cell {
  width: 32.5px;
}
.dx-scheduler-small .dx-scheduler-work-space-day.dx-scheduler-group-column-count-one .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-small .dx-scheduler-work-space-week.dx-scheduler-group-column-count-one .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-small .dx-scheduler-work-space-work-week.dx-scheduler-group-column-count-one .dx-scheduler-header-panel-empty-cell {
  width: 97.5px;
}
.dx-scheduler-small .dx-scheduler-work-space-day.dx-scheduler-group-column-count-two .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-small .dx-scheduler-work-space-week.dx-scheduler-group-column-count-two .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-small .dx-scheduler-work-space-work-week.dx-scheduler-group-column-count-two .dx-scheduler-header-panel-empty-cell {
  width: 130px;
}
.dx-scheduler-small .dx-scheduler-work-space-day.dx-scheduler-group-column-count-three .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-small .dx-scheduler-work-space-week.dx-scheduler-group-column-count-three .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-small .dx-scheduler-work-space-work-week.dx-scheduler-group-column-count-three .dx-scheduler-header-panel-empty-cell {
  width: 162.5px;
}
.dx-recurrence-repeat-end-wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.dx-recurrence-numberbox-interval-wrapper .dx-layout-manager .dx-field-item,
.dx-recurrence-repeat-on .dx-layout-manager .dx-field-item {
  padding-right: 0;
  padding-left: 0;
}
.dx-recurrence-numberbox-interval-wrapper .dx-box-item:first-child:not(:only-child),
.dx-recurrence-repeat-on .dx-box-item:first-child:not(:only-child) {
  -webkit-box-flex: 0!important;
  -ms-flex-positive: 0!important;
  flex-grow: 0!important;
  min-width: auto!important;
}
.dx-recurrence-numberbox-interval-wrapper .dx-field-item-label {
  white-space: nowrap;
}
.dx-layout-manager .dx-field-item.dx-recurrence-repeat-on {
  padding-top: 0;
}
.dx-recurrence-repeat-end-label {
  line-height: 36px;
}
.dx-recurrence-radiogroup-repeat-type .dx-item {
  padding-bottom: 10px;
}
.dx-recurrence-button-group {
  width: 100%;
}
.dx-recurrence-button-group .dx-buttongroup-wrapper > div {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  min-width: 0;
}
.dx-recurrence-numberbox-interval {
  margin-right: 11px;
}
.dx-recurrence-numberbox-interval-label {
  font-size: 14px;
  margin-top: 40px;
}
.dx-recurrence-button-group .dx-button-content {
  padding: 6px;
}
.dx-recurrence-radiogroup-repeat-type {
  margin: 15px 0;
}
.dx-recurrence-datebox-until-date {
  margin-left: 23px;
}
.dx-recurrence-numberbox-repeat-count {
  margin: 0 11px;
}
.dx-scheduler-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: #fff;
}
.dx-scheduler-header {
  border: 1px solid #e0e0e0;
  position: relative;
  z-index: 1;
  width: 100%;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}
.dx-scheduler-header .dx-toolbar {
  height: 100%;
  background-color: transparent;
}
.dx-scheduler-header .dx-toolbar .dx-toolbar-items-container {
  height: 100%;
}
.dx-scheduler-header .dx-toolbar .dx-toolbar-menu-container .dx-icon::before {
  content: "\\f016";
}
.dx-scheduler-view-switcher-dropdown-button-content .dx-list-item {
  display: list-item;
}
.dx-scheduler-date-time-shader-all-day {
  width: 100%;
  background-color: rgba(0,0,0,.03);
  position: absolute;
  pointer-events: none;
}
.dx-scheduler-date-time-indicator {
  background-color: #eb5757;
  position: absolute;
  pointer-events: none;
  -webkit-box-shadow: 0 1px 0 0 rgba(255,255,255,.1);
  box-shadow: 0 1px 0 0 rgba(255,255,255,.1);
}
.dx-scheduler-date-time-indicator::before {
  font-size: 30px;
  color: #eb5757;
  position: absolute;
  z-index: 1000;
  margin-top: -14px;
  margin-left: -12px;
  text-shadow: rgba(255,255,255,.1) 1px 0 0;
}
.dx-scheduler-date-time-shader {
  pointer-events: none;
}
.dx-scheduler-work-space-day .dx-scheduler-appointment-reduced .dx-scheduler-appointment-content,
.dx-scheduler-work-space-week .dx-scheduler-appointment-reduced .dx-scheduler-appointment-content,
.dx-scheduler-work-space-work-week .dx-scheduler-appointment-reduced .dx-scheduler-appointment-content {
  padding-right: 40px;
}
.dx-scheduler-work-space-day .dx-scheduler-appointment-reduced:not(.dx-scheduler-all-day-appointment) .dx-scheduler-appointment-recurrence-icon,
.dx-scheduler-work-space-day .dx-scheduler-appointment-reduced:not(.dx-scheduler-all-day-appointment) .dx-scheduler-appointment-reduced-icon,
.dx-scheduler-work-space-week .dx-scheduler-appointment-reduced:not(.dx-scheduler-all-day-appointment) .dx-scheduler-appointment-recurrence-icon,
.dx-scheduler-work-space-week .dx-scheduler-appointment-reduced:not(.dx-scheduler-all-day-appointment) .dx-scheduler-appointment-reduced-icon,
.dx-scheduler-work-space-work-week .dx-scheduler-appointment-reduced:not(.dx-scheduler-all-day-appointment) .dx-scheduler-appointment-recurrence-icon,
.dx-scheduler-work-space-work-week .dx-scheduler-appointment-reduced:not(.dx-scheduler-all-day-appointment) .dx-scheduler-appointment-reduced-icon {
  top: 9px;
}
.dx-scheduler-work-space-day .dx-scheduler-date-time-indicator,
.dx-scheduler-work-space-week .dx-scheduler-date-time-indicator,
.dx-scheduler-work-space-work-week .dx-scheduler-date-time-indicator {
  margin-left: 65px;
  font: 14px/1 DXIcons;
}
.dx-scheduler-work-space-day .dx-scheduler-date-time-indicator::before,
.dx-scheduler-work-space-week .dx-scheduler-date-time-indicator::before,
.dx-scheduler-work-space-work-week .dx-scheduler-date-time-indicator::before {
  content: "\\f04e";
  display: none;
}
.dx-scheduler-small .dx-scheduler-work-space-day .dx-scheduler-date-time-indicator,
.dx-scheduler-small .dx-scheduler-work-space-week .dx-scheduler-date-time-indicator,
.dx-scheduler-small .dx-scheduler-work-space-work-week .dx-scheduler-date-time-indicator {
  margin-left: 32.5px;
}
.dx-scheduler-work-space-day .dx-scheduler-date-time-shader,
.dx-scheduler-work-space-week .dx-scheduler-date-time-shader,
.dx-scheduler-work-space-work-week .dx-scheduler-date-time-shader {
  margin-left: 65px;
}
.dx-scheduler-small .dx-scheduler-work-space-day .dx-scheduler-date-time-shader,
.dx-scheduler-small .dx-scheduler-work-space-week .dx-scheduler-date-time-shader,
.dx-scheduler-small .dx-scheduler-work-space-work-week .dx-scheduler-date-time-shader {
  margin-left: 32.5px;
}
.dx-scheduler-work-space-day .dx-scheduler-date-time-shader-bottom::before,
.dx-scheduler-work-space-day .dx-scheduler-date-time-shader-top::before,
.dx-scheduler-work-space-week .dx-scheduler-date-time-shader-bottom::before,
.dx-scheduler-work-space-week .dx-scheduler-date-time-shader-top::before,
.dx-scheduler-work-space-work-week .dx-scheduler-date-time-shader-bottom::before,
.dx-scheduler-work-space-work-week .dx-scheduler-date-time-shader-top::before {
  width: inherit;
  height: inherit;
  content: "";
  left: inherit;
  position: absolute;
  margin-left: 65px;
  background-color: rgba(0,0,0,.03);
}
.dx-scheduler-small .dx-scheduler-work-space-day .dx-scheduler-date-time-shader-bottom::before,
.dx-scheduler-small .dx-scheduler-work-space-day .dx-scheduler-date-time-shader-top::before,
.dx-scheduler-small .dx-scheduler-work-space-week .dx-scheduler-date-time-shader-bottom::before,
.dx-scheduler-small .dx-scheduler-work-space-week .dx-scheduler-date-time-shader-top::before,
.dx-scheduler-small .dx-scheduler-work-space-work-week .dx-scheduler-date-time-shader-bottom::before,
.dx-scheduler-small .dx-scheduler-work-space-work-week .dx-scheduler-date-time-shader-top::before {
  margin-left: 32.5px;
}
.dx-scheduler-work-space-day.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-time-indicator,
.dx-scheduler-work-space-day.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-time-shader,
.dx-scheduler-work-space-day.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-time-shader-all-day,
.dx-scheduler-work-space-day.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-time-shader-bottom::before,
.dx-scheduler-work-space-day.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-time-shader-top::before,
.dx-scheduler-work-space-week.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-time-indicator,
.dx-scheduler-work-space-week.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-time-shader,
.dx-scheduler-work-space-week.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-time-shader-all-day,
.dx-scheduler-work-space-week.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-time-shader-bottom::before,
.dx-scheduler-work-space-week.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-time-shader-top::before,
.dx-scheduler-work-space-work-week.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-time-indicator,
.dx-scheduler-work-space-work-week.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-time-shader,
.dx-scheduler-work-space-work-week.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-time-shader-all-day,
.dx-scheduler-work-space-work-week.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-time-shader-bottom::before,
.dx-scheduler-work-space-work-week.dx-scheduler-work-space-both-scrollbar .dx-scheduler-date-time-shader-top::before {
  margin-left: 0;
}
.dx-scheduler-work-space-day.dx-rtl .dx-scheduler-date-time-indicator,
.dx-scheduler-work-space-week.dx-rtl .dx-scheduler-date-time-indicator,
.dx-scheduler-work-space-work-week.dx-rtl .dx-scheduler-date-time-indicator {
  margin-left: 0;
  font: 14px/1 DXIcons;
}
.dx-scheduler-work-space-day.dx-rtl .dx-scheduler-date-time-indicator::before,
.dx-scheduler-work-space-week.dx-rtl .dx-scheduler-date-time-indicator::before,
.dx-scheduler-work-space-work-week.dx-rtl .dx-scheduler-date-time-indicator::before {
  content: "\\f04f";
  margin-right: -12px;
}
.dx-scheduler-work-space-day.dx-rtl .dx-scheduler-date-time-shader-bottom::before,
.dx-scheduler-work-space-day.dx-rtl .dx-scheduler-date-time-shader-top::before,
.dx-scheduler-work-space-week.dx-rtl .dx-scheduler-date-time-shader-bottom::before,
.dx-scheduler-work-space-week.dx-rtl .dx-scheduler-date-time-shader-top::before,
.dx-scheduler-work-space-work-week.dx-rtl .dx-scheduler-date-time-shader-bottom::before,
.dx-scheduler-work-space-work-week.dx-rtl .dx-scheduler-date-time-shader-top::before {
  margin-left: 0;
  margin-right: 65px;
}
.dx-scheduler-timeline .dx-scheduler-date-time-indicator {
  width: 1px;
  top: 0;
  font: 14px/1 DXIcons;
}
.dx-scheduler-timeline .dx-scheduler-date-time-indicator::before {
  content: "\\f001";
  margin-left: -14px;
  margin-top: -12px;
}
.dx-scheduler-timeline .dx-scheduler-date-time-shader {
  height: 100%;
  position: absolute;
}
.dx-scheduler-timeline .dx-scheduler-date-time-shader::before {
  width: inherit;
  height: 100%;
  content: "";
  left: 0;
  position: absolute;
  background-color: rgba(0,0,0,.03);
}
.dx-scheduler-timeline .dx-scheduler-header-panel-cell.dx-scheduler-header-panel-current-time-cell {
  border-bottom: 2px solid #eb5757;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-scheduler-timeline .dx-scheduler-header-panel-cell.dx-scheduler-header-panel-current-time-cell::before {
  content: none;
}
.dx-scheduler-timeline .dx-scheduler-appointment-reduced .dx-scheduler-appointment-recurrence-icon {
  top: 0;
}
.dx-scheduler-work-space-month .dx-scheduler-appointment-content {
  padding: 0 7px;
}
.dx-scheduler-work-space-month .dx-scheduler-appointment-recurrence .dx-scheduler-appointment-content {
  padding: 0 25px 0 7px;
}
.dx-rtl .dx-scheduler-work-space-month .dx-scheduler-appointment-recurrence .dx-scheduler-appointment-content {
  padding: 0 7px 0 25px;
}
.dx-scheduler-work-space-month .dx-scheduler-appointment-recurrence-icon {
  top: 0;
}
.dx-scheduler-all-day-appointments,
.dx-scheduler-scrollable-appointments {
  position: absolute;
  top: 0;
}
.dx-scheduler-all-day-appointments.dx-rtl,
.dx-scheduler-scrollable-appointments.dx-rtl {
  left: 0;
}
.dx-scheduler-all-day-appointment,
.dx-scheduler-timeline .dx-scheduler-appointment,
.dx-scheduler-work-space-month .dx-scheduler-appointment {
  -webkit-box-shadow: inset 2px 0 0 0 rgba(0,0,0,.3);
  box-shadow: inset 2px 0 0 0 rgba(0,0,0,.3);
}
.dx-rtl .dx-scheduler-all-day-appointment,
.dx-rtl .dx-scheduler-timeline .dx-scheduler-appointment,
.dx-rtl .dx-scheduler-work-space-month .dx-scheduler-appointment {
  -webkit-box-shadow: inset -2px 0 0 0 rgba(0,0,0,.3);
  box-shadow: inset -2px 0 0 0 rgba(0,0,0,.3);
}
.dx-scheduler-all-day-appointment.dx-resizable-resizing,
.dx-scheduler-all-day-appointment.dx-state-active,
.dx-scheduler-timeline .dx-scheduler-appointment.dx-resizable-resizing,
.dx-scheduler-timeline .dx-scheduler-appointment.dx-state-active,
.dx-scheduler-work-space-month .dx-scheduler-appointment.dx-resizable-resizing,
.dx-scheduler-work-space-month .dx-scheduler-appointment.dx-state-active {
  -webkit-box-shadow: inset -2px 0 0 0 rgba(0,0,0,.3),inset 2px 0 0 0 rgba(0,0,0,.3);
  box-shadow: inset -2px 0 0 0 rgba(0,0,0,.3),inset 2px 0 0 0 rgba(0,0,0,.3);
}
.dx-scheduler-all-day-appointment.dx-state-hover,
.dx-scheduler-timeline .dx-scheduler-appointment.dx-state-hover,
.dx-scheduler-work-space-month .dx-scheduler-appointment.dx-state-hover {
  -webkit-box-shadow: inset 5px 0 0 0 rgba(0,0,0,.3);
  box-shadow: inset 5px 0 0 0 rgba(0,0,0,.3);
}
.dx-scheduler-all-day-appointment.dx-state-hover.dx-resizable,
.dx-scheduler-timeline .dx-scheduler-appointment.dx-state-hover.dx-resizable,
.dx-scheduler-work-space-month .dx-scheduler-appointment.dx-state-hover.dx-resizable {
  -webkit-box-shadow: inset 5px 0 0 0 rgba(0,0,0,.3),inset -2px 0 0 0 rgba(0,0,0,.3);
  box-shadow: inset 5px 0 0 0 rgba(0,0,0,.3),inset -2px 0 0 0 rgba(0,0,0,.3);
}
.dx-rtl .dx-scheduler-all-day-appointment.dx-state-hover,
.dx-rtl .dx-scheduler-timeline .dx-scheduler-appointment.dx-state-hover,
.dx-rtl .dx-scheduler-work-space-month .dx-scheduler-appointment.dx-state-hover {
  -webkit-box-shadow: inset -5px 0 0 0 rgba(0,0,0,.3);
  box-shadow: inset -5px 0 0 0 rgba(0,0,0,.3);
}
.dx-rtl .dx-scheduler-all-day-appointment.dx-state-hover.dx-resizable,
.dx-rtl .dx-scheduler-timeline .dx-scheduler-appointment.dx-state-hover.dx-resizable,
.dx-rtl .dx-scheduler-work-space-month .dx-scheduler-appointment.dx-state-hover.dx-resizable {
  -webkit-box-shadow: inset -5px 0 0 0 rgba(0,0,0,.3),inset 2px 0 0 0 rgba(0,0,0,.3);
  box-shadow: inset -5px 0 0 0 rgba(0,0,0,.3),inset 2px 0 0 0 rgba(0,0,0,.3);
}
.dx-scheduler-fixed-appointments .dx-draggable-dragging .dx-scheduler-all-day-appointment,
.dx-scheduler-timeline .dx-draggable-dragging .dx-scheduler-appointment,
.dx-scheduler-work-space-month .dx-draggable-dragging .dx-scheduler-appointment {
  -webkit-box-shadow: inset -2px 0 0 0 rgba(0,0,0,.3),inset 2px 0 0 0 rgba(0,0,0,.3),7px 7px 15px 0 rgba(50,50,50,.2);
  box-shadow: inset -2px 0 0 0 rgba(0,0,0,.3),inset 2px 0 0 0 rgba(0,0,0,.3),7px 7px 15px 0 rgba(50,50,50,.2);
}
.dx-scheduler-appointment.dx-scheduler-appointment-body,
.dx-scheduler-appointment.dx-scheduler-appointment-tail {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-scheduler-appointment-recurrence-icon {
  position: absolute;
  background-repeat: no-repeat;
  top: 3px;
  right: 5px;
  display: block;
}
.dx-scheduler-appointment-recurrence-icon.dx-icon-repeat {
  font-size: 18px;
}
.dx-scheduler-all-day-appointment .dx-scheduler-appointment-reduced-icon {
  position: absolute;
  top: 15%;
}
.dx-scheduler-appointment-reduced.dx-scheduler-appointment-head .dx-scheduler-appointment-recurrence-icon {
  right: 20px;
}
.dx-scheduler-appointment-recurrence .dx-scheduler-appointment-content {
  padding: 5px 25px 5px 7px;
}
.dx-rtl .dx-scheduler-appointment-recurrence .dx-scheduler-appointment-content {
  padding: 5px 7px 5px 25px;
}
.dx-scheduler-appointment-content {
  cursor: pointer;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  opacity: .99;
}
.dx-scheduler-work-space-grouped.dx-scheduler-work-space-month .dx-scheduler-appointment-content {
  font-size: 12px;
}
.dx-scheduler-appointment-content > * {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dx-scheduler-appointment-empty .dx-scheduler-appointment-content-details,
.dx-scheduler-appointment-empty .dx-scheduler-appointment-recurrence-icon,
.dx-scheduler-appointment-empty .dx-scheduler-appointment-title {
  display: none;
}
.dx-scheduler-all-day-appointment .dx-scheduler-appointment-content-details,
.dx-scheduler-work-space-month .dx-scheduler-appointment-content-details {
  display: none;
}
.dx-scheduler-appointment-popup .dx-form .dx-field-item.dx-appointment-form-switch > div {
  -webkit-box-flex: 0;
  -ms-flex-positive: 0;
  flex-grow: 0;
  width: auto;
}
.dx-scheduler-appointment-popup .dx-layout-manager .dx-label-h-align .dx-field-item-content .dx-checkbox,
.dx-scheduler-appointment-popup .dx-layout-manager .dx-label-h-align .dx-field-item-content .dx-switch {
  margin: 0;
}
.dx-scheduler-appointment-popup .dx-field-item-label-location-left {
  padding-right: 20px;
}
.dx-scheduler-appointment-popup .dx-field {
  min-height: 0;
}
.dx-scheduler-appointment-popup .dx-field-label {
  width: auto;
}
.dx-scheduler-appointment-popup .dx-field-value {
  padding-left: 0;
  padding-right: 0;
}
.dx-scheduler-appointment-popup .dx-field-value:not(.dx-widget) > .dx-checkbox {
  float: left;
}
.dx-scheduler-appointment-popup .dx-field-value:not(.dx-widget) > .dx-checkbox.dx-rtl {
  float: right;
}
.dx-scheduler-appointment-collector.dx-button,
.dx-scheduler-appointment-collector.dx-button.dx-state-active,
.dx-scheduler-appointment-collector.dx-button.dx-state-focused,
.dx-scheduler-appointment-collector.dx-button.dx-state-hover {
  background-color: #009688;
  color: #fff;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-scheduler-appointment-collector.dx-button.dx-state-hover::before {
  pointer-events: none;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,.3);
  opacity: .98;
}
.dx-scheduler-appointment-collector.dx-button.dx-state-hover .dx-button-content,
.dx-scheduler-appointment-collector.dx-button.dx-state-hover .dx-scheduler-appointment-collector-content {
  color: #fff;
  opacity: .99;
}
.dx-scheduler-appointment-collector-compact .dx-button-content span:last-child,
.dx-scheduler-appointment-collector-compact .dx-scheduler-appointment-collector-content span:last-child {
  padding-left: 0;
}
.dx-scheduler-agenda .dx-scheduler-scrollable-appointments {
  width: 100%;
  height: 0;
}
.dx-scheduler-agenda .dx-scheduler-appointment {
  position: relative;
  -webkit-box-shadow: none;
  box-shadow: none;
  margin-top: 5px;
  margin-bottom: 5px;
}
.dx-scheduler-agenda .dx-scheduler-appointment.dx-scheduler-last-in-date-agenda-appointment {
  margin-bottom: 20px;
}
.dx-rtl .dx-scheduler-appointment-recurrence-icon {
  left: 5px;
  right: auto;
}
.dx-rtl .dx-scheduler-appointment-reduced.dx-scheduler-appointment-head .dx-scheduler-appointment-recurrence-icon {
  left: 20px;
  right: auto;
}
.dx-rtl .dx-scheduler-work-space-day .dx-scheduler-appointment-reduced .dx-scheduler-appointment-content,
.dx-rtl .dx-scheduler-work-space-week .dx-scheduler-appointment-reduced .dx-scheduler-appointment-content,
.dx-rtl .dx-scheduler-work-space-work-week .dx-scheduler-appointment-reduced .dx-scheduler-appointment-content {
  padding-right: 5px;
  padding-left: 40px;
}
.dx-rtl .dx-scheduler-all-day-appointments,
.dx-rtl .dx-scheduler-scrollable-appointments {
  left: 0;
}
.dx-scheduler-small.dx-rtl .dx-scheduler-date-time-shader-bottom::before,
.dx-scheduler-small.dx-rtl .dx-scheduler-date-time-shader-top::before {
  margin-right: 32.5px;
}
.dx-scheduler-time-panel-cell {
  height: 38px;
  padding-right: 8px;
}
.dx-scheduler-time-panel-cell > div {
  margin-top: -6px;
  font-size: 12px;
}
.dx-scheduler-small .dx-scheduler-time-panel-cell > div {
  font-size: 11px;
}
.dx-scheduler-small .dx-scheduler-time-panel-cell {
  padding-right: 2px;
}
.dx-rtl .dx-scheduler-time-panel-cell {
  text-align: left;
  padding-left: 8px;
  padding-right: 0;
}
.dx-rtl.dx-scheduler-small .dx-scheduler-time-panel-cell {
  padding-left: 2px;
}
.dx-scheduler-time-panel-cell.dx-scheduler-time-panel-current-time-cell::before {
  content: none;
}
.dx-scheduler-date-table-cell {
  height: 38px;
}
.dx-scheduler-all-day-title {
  height: 57px;
  line-height: 57px;
  font-size: 12px;
  border-bottom: 1px solid #e0e0e0;
}
.dx-scheduler-small .dx-scheduler-all-day-title {
  font-size: 9.6px;
}
.dx-scheduler-work-space-all-day-collapsed .dx-scheduler-all-day-title {
  height: 19px;
  line-height: 19px;
}
.dx-scheduler-all-day-table {
  height: 57px;
}
.dx-scheduler-work-space-all-day-collapsed .dx-scheduler-all-day-table {
  height: 19px;
}
.dx-scheduler-appointment-content {
  padding: 5px 7px;
}
.dx-scheduler-appointment-title {
  font-size: 12px;
}
.dx-scheduler-appointment-content-details {
  white-space: pre;
  overflow: hidden;
  font-size: 10px;
}
.dx-scheduler-work-space-day .dx-scheduler-all-day-appointment .dx-scheduler-appointment-content,
.dx-scheduler-work-space-week .dx-scheduler-all-day-appointment .dx-scheduler-appointment-content,
.dx-scheduler-work-space-work-week .dx-scheduler-all-day-appointment .dx-scheduler-appointment-content {
  padding: 5px 7px;
}
.dx-scheduler-work-space-day .dx-scheduler-date-time-indicator,
.dx-scheduler-work-space-week .dx-scheduler-date-time-indicator,
.dx-scheduler-work-space-work-week .dx-scheduler-date-time-indicator {
  height: 2px;
}
.dx-scheduler-header-panel {
  margin-top: 0;
}
.dx-scheduler-header-panel-cell {
  height: 56px;
  text-align: left;
  vertical-align: bottom;
}
.dx-rtl .dx-scheduler-header-panel-cell {
  text-align: right;
}
.dx-scheduler-work-space.dx-scheduler-work-space-month .dx-scheduler-header-panel-cell {
  height: 22px;
}
.dx-scheduler-work-space.dx-scheduler-timeline.dx-scheduler-timeline-week .dx-scheduler-header-panel-cell:not(.dx-scheduler-header-panel-week-cell),
.dx-scheduler-work-space.dx-scheduler-timeline.dx-scheduler-timeline-work-week .dx-scheduler-header-panel-cell:not(.dx-scheduler-header-panel-week-cell) {
  height: 34px;
  font-size: 12px;
  padding-left: 14px;
  padding-right: 14px;
  padding-top: 11px;
}
.dx-scheduler-work-space.dx-scheduler-timeline.dx-scheduler-timeline-month .dx-scheduler-header-panel-cell,
.dx-scheduler-work-space.dx-scheduler-timeline.dx-scheduler-timeline-week .dx-scheduler-header-panel-cell,
.dx-scheduler-work-space.dx-scheduler-timeline.dx-scheduler-timeline-work-week .dx-scheduler-header-panel-cell {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
}
.dx-scheduler-work-space.dx-scheduler-timeline.dx-scheduler-timeline-day .dx-scheduler-header-panel-cell,
.dx-scheduler-work-space.dx-scheduler-timeline.dx-scheduler-timeline-month .dx-scheduler-header-panel-cell,
.dx-scheduler-work-space.dx-scheduler-timeline.dx-scheduler-timeline-week .dx-scheduler-header-panel-cell,
.dx-scheduler-work-space.dx-scheduler-timeline.dx-scheduler-timeline-work-week .dx-scheduler-header-panel-cell {
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}
.dx-scheduler-work-space.dx-scheduler-timeline.dx-scheduler-timeline-day .dx-scheduler-header-panel-cell {
  -webkit-box-align: end;
  -ms-flex-align: end;
  align-items: flex-end;
}
.dx-scheduler-work-space.dx-scheduler-timeline.dx-scheduler-timeline-day .dx-scheduler-header-panel-cell:not(.dx-scheduler-header-panel-week-cell) {
  height: 34px;
  font-size: 12px;
  padding-left: 14px;
  padding-right: 14px;
}
.dx-scheduler-work-space.dx-scheduler-timeline.dx-scheduler-timeline-day .dx-scheduler-header-panel-cell.dx-scheduler-header-panel-week-cell {
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.dx-scheduler-header-panel-cell.dx-scheduler-header-panel-week-cell {
  border-bottom: 1px solid #e0e0e0;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column;
  flex-flow: column;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}
.dx-scheduler-header-panel-cell.dx-scheduler-header-panel-current-time-cell::before {
  content: none;
}
.dx-scheduler-header-panel-cell .dx-scheduler-header-panel-cell-date {
  display: block;
  margin: 0 14px;
}
.dx-scheduler-small .dx-scheduler-header-panel-cell .dx-scheduler-header-panel-cell-date {
  margin: 0 7px;
}
.dx-scheduler-header-panel-cell .dx-scheduler-header-panel-cell-date:first-child {
  font-size: 12px;
  line-height: 7px;
}
.dx-scheduler-header-panel-cell .dx-scheduler-header-panel-cell-date:last-child {
  font-size: 30px;
  line-height: 35px;
}
.dx-scheduler-timeline .dx-scheduler-date-table-cell {
  border-right: none;
  height: 50px;
}
.dx-scheduler-work-space-day.dx-scheduler-work-space-count .dx-scheduler-header-panel {
  margin-top: 0;
}
.dx-scheduler-work-space-day .dx-scheduler-header-panel .dx-scheduler-group-row:not(:first-child) {
  border-bottom: none;
}
.dx-scheduler-work-space-day:not(.dx-scheduler-work-space-count):not(.dx-scheduler-work-space-grouped) .dx-scheduler-header-panel-empty-cell,
.dx-scheduler-work-space-day:not(.dx-scheduler-work-space-count):not(.dx-scheduler-work-space-grouped) .dx-scheduler-time-panel {
  border-right: 1px solid #e0e0e0;
}
.dx-scheduler-work-space.dx-scheduler-work-space-month .dx-scheduler-appointment-content {
  padding-top: 3px;
  font-size: 12px;
}
.dx-scheduler-work-space.dx-scheduler-work-space-month .dx-scheduler-date-table-first-of-month {
  border-left: 1px solid #e0e0e0;
  border-top: 1px solid #e0e0e0;
}
.dx-scheduler-work-space.dx-scheduler-work-space-month .dx-scheduler-header-panel {
  border-bottom: none;
}
.dx-scheduler-work-space.dx-scheduler-work-space-month .dx-scheduler-date-table-cell {
  font-size: 14px;
  text-align: left;
  height: 100px;
}
.dx-scheduler-work-space.dx-scheduler-work-space-month .dx-scheduler-date-table-cell > div {
  padding: 8px;
}
.dx-rtl .dx-scheduler-work-space.dx-scheduler-work-space-month .dx-scheduler-date-table-cell {
  text-align: right;
}
.dx-scheduler-work-space.dx-scheduler-work-space-month .dx-scheduler-header-panel-cell .dx-scheduler-header-panel-cell-date {
  font-size: 12px;
  margin-left: 8px;
  line-height: 22px;
}
.dx-scheduler-work-space.dx-scheduler-work-space-month .dx-scheduler-appointment-collector {
  margin-top: 7px;
  margin-left: 52px;
}
.dx-scheduler-work-space.dx-scheduler-work-space-month .dx-scheduler-date-table-current-date {
  color: #009688;
}
.dx-scheduler-adaptive .dx-scheduler-work-space.dx-scheduler-work-space-month .dx-scheduler-appointment-collector {
  margin: 0;
}
.dx-scheduler-appointment-collector {
  background-color: #009688;
  color: #fff;
  margin-top: 5px;
  position: absolute;
}
.dx-scheduler-appointment-collector.dx-button {
  border-radius: 12px;
  height: 22px;
  min-width: auto;
  width: auto;
}
.dx-scheduler-appointment-collector.dx-button::before {
  display: none;
}
.dx-scheduler-appointment-collector.dx-button .dx-button-content {
  padding: 4px 0;
  font-size: 12px;
}
.dx-scheduler-header {
  height: 58px;
  background-color: #fff;
}
.dx-scheduler-header .dx-toolbar .dx-toolbar-item-content,
.dx-scheduler-header .dx-toolbar .dx-toolbar-menu-container {
  padding: 0 16px;
}
.dx-scheduler-header .dx-toolbar .dx-scheduler-navigator .dx-scheduler-navigator-caption {
  min-width: 180px;
}
.dx-scheduler-adaptive .dx-scheduler-header .dx-toolbar .dx-scheduler-navigator .dx-scheduler-navigator-caption {
  min-width: 140px;
}
.dx-scheduler-header .dx-toolbar .dx-button.dx-item-selected,
.dx-scheduler-header .dx-toolbar .dx-button.dx-state-focused,
.dx-scheduler-header .dx-toolbar .dx-button.dx-state-hover {
  background-color: rgba(0,150,136,.08);
}
.dx-scheduler-header .dx-toolbar .dx-scheduler-navigator .dx-buttongroup .dx-button.dx-item-selected {
  background-color: #fff;
}
.dx-scheduler-header .dx-toolbar .dx-scheduler-navigator .dx-buttongroup .dx-button.dx-item-selected.dx-state-focused,
.dx-scheduler-header .dx-toolbar .dx-scheduler-navigator .dx-buttongroup .dx-button.dx-item-selected.dx-state-hover {
  background-color: rgba(0,150,136,.08);
}
.dx-scheduler-header .dx-toolbar .dx-button,
.dx-scheduler-header .dx-toolbar .dx-button .dx-icon {
  color: #009688;
}
.dx-scheduler-header .dx-toolbar .dx-scheduler-navigator .dx-buttongroup .dx-button .dx-icon {
  width: 24px;
  height: 24px;
  font-size: 24px;
}
.dx-scheduler-header .dx-toolbar .dx-scheduler-navigator .dx-buttongroup .dx-button.dx-item-selected,
.dx-scheduler-header .dx-toolbar .dx-scheduler-navigator .dx-buttongroup .dx-button.dx-item-selected .dx-icon {
  color: #009688;
}
.dx-scheduler-header .dx-button-text {
  text-transform: none;
}
.dx-scheduler-group-flex-container .dx-scheduler-group-header {
  font-weight: 700;
}
.dx-scheduler-group-table .dx-scheduler-group-row .dx-scheduler-group-header,
.dx-scheduler-header-panel .dx-scheduler-group-row .dx-scheduler-group-header {
  font-weight: 500;
  font-size: 14px;
  color: rgba(0,0,0,.87);
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}
.dx-scheduler-group-table .dx-scheduler-group-row .dx-scheduler-group-header .dx-scheduler-group-header-content,
.dx-scheduler-header-panel .dx-scheduler-group-row .dx-scheduler-group-header .dx-scheduler-group-header-content {
  padding-left: 14px;
}
.dx-scheduler-agenda .dx-scheduler-group-table .dx-scheduler-group-row .dx-scheduler-group-header .dx-scheduler-group-header-content,
.dx-scheduler-agenda .dx-scheduler-header-panel .dx-scheduler-group-row .dx-scheduler-group-header .dx-scheduler-group-header-content,
.dx-scheduler-work-space-month .dx-scheduler-group-table .dx-scheduler-group-row .dx-scheduler-group-header .dx-scheduler-group-header-content,
.dx-scheduler-work-space-month .dx-scheduler-header-panel .dx-scheduler-group-row .dx-scheduler-group-header .dx-scheduler-group-header-content {
  padding-left: 8px;
}
.dx-rtl .dx-scheduler-agenda .dx-scheduler-group-table .dx-scheduler-group-row .dx-scheduler-group-header .dx-scheduler-group-header-content,
.dx-rtl .dx-scheduler-agenda .dx-scheduler-header-panel .dx-scheduler-group-row .dx-scheduler-group-header .dx-scheduler-group-header-content,
.dx-rtl .dx-scheduler-work-space-month .dx-scheduler-group-table .dx-scheduler-group-row .dx-scheduler-group-header .dx-scheduler-group-header-content,
.dx-rtl .dx-scheduler-work-space-month .dx-scheduler-header-panel .dx-scheduler-group-row .dx-scheduler-group-header .dx-scheduler-group-header-content {
  padding-right: 8px;
  padding-left: 0;
}
.dx-scheduler-timeline .dx-scheduler-group-table .dx-scheduler-group-row .dx-scheduler-group-header .dx-scheduler-group-header-content,
.dx-scheduler-timeline .dx-scheduler-header-panel .dx-scheduler-group-row .dx-scheduler-group-header .dx-scheduler-group-header-content {
  padding-left: 0;
}
.dx-scheduler-timeline .dx-scheduler-group-table .dx-scheduler-group-row .dx-scheduler-group-header,
.dx-scheduler-timeline .dx-scheduler-header-panel .dx-scheduler-group-row .dx-scheduler-group-header {
  vertical-align: top;
}
.dx-scheduler-timeline .dx-scheduler-group-table .dx-scheduler-group-row .dx-scheduler-group-header .dx-scheduler-group-header-content div,
.dx-scheduler-timeline .dx-scheduler-header-panel .dx-scheduler-group-row .dx-scheduler-group-header .dx-scheduler-group-header-content div {
  top: 8px;
  -webkit-transform: none;
  transform: none;
}
.dx-rtl .dx-scheduler-group-table .dx-scheduler-group-row .dx-scheduler-group-header,
.dx-rtl .dx-scheduler-header-panel .dx-scheduler-group-row .dx-scheduler-group-header {
  text-align: right;
}
.dx-scheduler-all-day-panel {
  background-color: #fff;
}
.dx-scheduler-all-day-panel .dx-scheduler-all-day-table-cell {
  border-bottom: 1px solid #e0e0e0;
}
.dx-scheduler-work-space.dx-scheduler-work-space-grouped .dx-scheduler-all-day-title {
  border-top: 1px solid #e0e0e0;
}
.dx-scheduler-work-space.dx-scheduler-work-space-grouped.dx-scheduler-work-space-all-day:not(.dx-scheduler-work-space-week):not(.dx-scheduler-work-space-work-week) .dx-scheduler-group-header {
  border-bottom: none;
}
.dx-scheduler-work-space.dx-scheduler-work-space-grouped.dx-scheduler-agenda .dx-scheduler-date-table-cell {
  border: none;
}
.dx-rtl .dx-scheduler-work-space.dx-scheduler-work-space-grouped.dx-scheduler-timeline .dx-scheduler-group-row th {
  border-left: none;
  border-right: none;
}
.dx-scheduler-work-space.dx-scheduler-work-space-grouped.dx-scheduler-work-space-both-scrollbar:not(.dx-scheduler-agenda) .dx-scheduler-all-day-panel .dx-scheduler-first-group-cell {
  border-left: none;
}
.dx-scheduler-work-space-week .dx-scheduler-date-table-row:first-child {
  border-top: none;
}
.dx-scheduler-all-day-table-cell.dx-state-active,
.dx-scheduler-date-table-cell.dx-state-active {
  background-color: rgba(221,221,221,.7);
}
.dx-scheduler-all-day-table-cell.dx-state-hover,
.dx-scheduler-date-table-cell.dx-state-hover {
  background-color: rgba(0,0,0,.04);
  color: rgba(0,0,0,.54);
}
.dx-scheduler-all-day-table-cell.dx-scheduler-focused-cell,
.dx-scheduler-date-table-cell.dx-scheduler-focused-cell {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-scheduler-appointment-popup .dx-form {
  padding: 0 10px;
}
.dx-scheduler-appointment-popup .dx-popup-title {
  background-color: #fff;
  border-bottom: none;
}
.dx-scheduler-appointment-popup .dx-popup-title .dx-closebutton,
.dx-scheduler-appointment-popup .dx-popup-title .dx-closebutton.dx-rtl {
  margin: 0;
}
.dx-scheduler-appointment-popup .dx-toolbar-after {
  margin-right: 4px;
}
.dx-rtl .dx-scheduler-appointment-popup .dx-toolbar-after {
  margin-left: 4px;
  margin-right: 0;
}
.dx-scheduler-appointment-popup .dx-form-validation-summary {
  padding: 10px 20px;
}
.dx-scheduler-header-panel,
.dx-scheduler-time-panel {
  font-size: 16px;
}
.dx-scheduler-work-space-grouped:not(.dx-scheduler-agenda) .dx-scheduler-group-row th,
.dx-scheduler-work-space.dx-scheduler-work-space-grouped:not(.dx-scheduler-work-space-vertical-grouped):not(.dx-scheduler-timeline) .dx-scheduler-last-group-cell {
  border-right: 1px solid #bfbfbf;
}
.dx-scheduler-work-space-grouped:not(.dx-scheduler-agenda) .dx-scheduler-group-row th:last-child,
.dx-scheduler-work-space.dx-scheduler-work-space-grouped:not(.dx-scheduler-work-space-vertical-grouped):not(.dx-scheduler-timeline) .dx-scheduler-last-group-cell:last-child {
  border-right: none;
}
.dx-rtl .dx-scheduler-work-space-grouped:not(.dx-scheduler-agenda) .dx-scheduler-group-row th,
.dx-rtl .dx-scheduler-work-space.dx-scheduler-work-space-grouped:not(.dx-scheduler-work-space-vertical-grouped):not(.dx-scheduler-timeline) .dx-scheduler-last-group-cell {
  border-left: 1px solid #bfbfbf;
  border-right: 1px solid #e0e0e0;
}
.dx-rtl .dx-scheduler-work-space-grouped:not(.dx-scheduler-agenda) .dx-scheduler-group-row th:last-child,
.dx-rtl .dx-scheduler-work-space.dx-scheduler-work-space-grouped:not(.dx-scheduler-work-space-vertical-grouped):not(.dx-scheduler-timeline) .dx-scheduler-last-group-cell:last-child {
  border-left: none;
}
.dx-rtl .dx-scheduler-appointment,
.dx-rtl .dx-scheduler-timeline .dx-scheduler-appointment,
.dx-scheduler-appointment,
.dx-scheduler-timeline .dx-scheduler-appointment,
.dx-scheduler-work-space-month .dx-scheduler-appointment {
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  -webkit-box-shadow: none;
  box-shadow: none;
  border-radius: 2px;
}
.dx-rtl .dx-scheduler-appointment.dx-state-focused,
.dx-rtl .dx-scheduler-timeline .dx-scheduler-appointment.dx-state-focused,
.dx-scheduler-appointment.dx-state-focused,
.dx-scheduler-timeline .dx-scheduler-appointment.dx-state-focused,
.dx-scheduler-work-space-month .dx-scheduler-appointment.dx-state-focused {
  color: #fff;
}
.dx-rtl .dx-scheduler-appointment.dx-resizable-resizing,
.dx-rtl .dx-scheduler-appointment.dx-state-active,
.dx-rtl .dx-scheduler-appointment.dx-state-hover,
.dx-rtl .dx-scheduler-appointment.dx-state-hover.dx-resizable,
.dx-rtl .dx-scheduler-timeline .dx-scheduler-appointment.dx-resizable-resizing,
.dx-rtl .dx-scheduler-timeline .dx-scheduler-appointment.dx-state-active,
.dx-rtl .dx-scheduler-timeline .dx-scheduler-appointment.dx-state-hover,
.dx-rtl .dx-scheduler-timeline .dx-scheduler-appointment.dx-state-hover.dx-resizable,
.dx-scheduler-appointment.dx-resizable-resizing,
.dx-scheduler-appointment.dx-state-active,
.dx-scheduler-appointment.dx-state-hover,
.dx-scheduler-appointment.dx-state-hover.dx-resizable,
.dx-scheduler-fixed-appointments .dx-draggable-dragging .dx-scheduler-appointment,
.dx-scheduler-timeline .dx-scheduler-appointment.dx-resizable-resizing,
.dx-scheduler-timeline .dx-scheduler-appointment.dx-state-active,
.dx-scheduler-timeline .dx-scheduler-appointment.dx-state-hover,
.dx-scheduler-timeline .dx-scheduler-appointment.dx-state-hover.dx-resizable,
.dx-scheduler-work-space-month .dx-scheduler-appointment.dx-resizable-resizing,
.dx-scheduler-work-space-month .dx-scheduler-appointment.dx-state-active,
.dx-scheduler-work-space-month .dx-scheduler-appointment.dx-state-hover,
.dx-scheduler-work-space-month .dx-scheduler-appointment.dx-state-hover.dx-resizable {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-scheduler-dropdown-appointment-date {
  color: rgba(0,0,0,.54);
}
.dx-scheduler-work-space-vertical-grouped.dx-scheduler-work-space-month .dx-scheduler-date-table-scrollable {
  border-top: 1px solid #e0e0e0;
}
.dx-scheduler-work-space-both-scrollbar .dx-scheduler-all-day-title {
  background-color: #fff;
}
.dx-scheduler-work-space-both-scrollbar .dx-scheduler-header-panel .dx-scheduler-group-header:first-child {
  border-left: none;
}
.dx-scheduler-agenda .dx-scheduler-group-header {
  font-size: 14px;
  width: 100px;
}
.dx-scheduler-agenda .dx-scheduler-group-header .dx-scheduler-group-header-content {
  padding-top: 2px;
  width: 100px;
}
.dx-scheduler-agenda .dx-scheduler-group-header .dx-scheduler-group-header-content::before {
  display: none;
}
.dx-scheduler-agenda .dx-scheduler-date-table-row,
.dx-scheduler-agenda .dx-scheduler-time-panel-row {
  -webkit-box-shadow: inset 0 -1px 0 0 #e0e0e0;
  box-shadow: inset 0 -1px 0 0 #e0e0e0;
}
.dx-scheduler-agenda .dx-scheduler-time-panel-cell {
  vertical-align: top;
  text-align: left;
  padding-left: 8px;
  padding-right: 0;
}
.dx-rtl .dx-scheduler-agenda .dx-scheduler-time-panel-cell {
  text-align: right;
  padding-right: 8px;
  padding-left: 0;
}
.dx-scheduler-agenda .dx-scheduler-time-panel-cell > span {
  font-size: 12px;
}
.dx-scheduler-agenda .dx-scheduler-date-table-scrollable {
  padding-top: 0;
}
.dx-scheduler-agenda.dx-scheduler-work-space-grouped .dx-scheduler-date-table-row.dx-scheduler-date-table-last-row,
.dx-scheduler-agenda.dx-scheduler-work-space-grouped .dx-scheduler-group-header,
.dx-scheduler-agenda.dx-scheduler-work-space-grouped .dx-scheduler-group-table .dx-scheduler-group-row,
.dx-scheduler-agenda.dx-scheduler-work-space-grouped .dx-scheduler-time-panel-row.dx-scheduler-date-table-last-row {
  border-bottom: none;
}
.dx-scheduler-agenda.dx-scheduler-work-space-grouped .dx-scheduler-date-table-row.dx-scheduler-date-table-last-row:not(:last-child),
.dx-scheduler-agenda.dx-scheduler-work-space-grouped .dx-scheduler-group-table .dx-scheduler-group-row:not(:last-child),
.dx-scheduler-agenda.dx-scheduler-work-space-grouped .dx-scheduler-time-panel-row.dx-scheduler-date-table-last-row:not(:last-child) {
  -webkit-box-shadow: inset 0 -1px 0 0 #bfbfbf;
  box-shadow: inset 0 -1px 0 0 #bfbfbf;
}
.dx-scheduler-agenda-nodata {
  font-size: 16px;
}
.dx-popup-content .dx-scheduler-dropdown-appointment-buttons-block .dx-button {
  min-width: auto;
  padding: 0;
  background-color: transparent;
  color: #009688;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-popup-content .dx-scheduler-dropdown-appointment-buttons-block .dx-button.dx-state-focused,
.dx-popup-content .dx-scheduler-dropdown-appointment-buttons-block .dx-button.dx-state-hover {
  background-color: rgba(0,150,136,.08);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-popup-content .dx-scheduler-dropdown-appointment-buttons-block .dx-button.dx-state-active {
  background-color: rgba(0,150,136,.36);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-popup-content .dx-scheduler-dropdown-appointment-buttons-block .dx-button.dx-state-disabled {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-popup-content .dx-scheduler-dropdown-appointment-buttons-block .dx-button.dx-state-disabled .dx-icon {
  opacity: .6;
}
.dx-popup-content .dx-scheduler-dropdown-appointment-buttons-block .dx-button.dx-state-disabled .dx-button-text,
.dx-popup-content .dx-scheduler-dropdown-appointment-buttons-block .dx-button.dx-state-disabled.dx-button-mode-contained .dx-icon {
  color: rgba(0,0,0,.35);
}
.dx-popup-content .dx-scheduler-dropdown-appointment-buttons-block .dx-button .dx-inkripple-wave {
  background-color: rgba(0,150,136,.2);
}
.dx-popup-content .dx-scheduler-dropdown-appointment-buttons-block .dx-button .dx-icon {
  color: #009688;
  width: 24px;
  height: 24px;
  background-position: 0 0;
  background-size: 24px 24px;
  padding: 0;
  font-size: 24px;
  text-align: center;
  line-height: 24px;
}
.dx-rtl .dx-scheduler-work-space-both-scrollbar .dx-scheduler-header-panel .dx-scheduler-group-header:first-child {
  border-right: none;
}
.dx-rtl.dx-scheduler-work-space-day:not(.dx-scheduler-work-space-count):not(.dx-scheduler-work-space-grouped) .dx-scheduler-header-panel-empty-cell,
.dx-rtl.dx-scheduler-work-space-day:not(.dx-scheduler-work-space-count):not(.dx-scheduler-work-space-grouped) .dx-scheduler-time-panel {
  border-left: 1px solid #e0e0e0;
  border-right: none;
}
.dx-scheduler-appointment-tooltip-wrapper .dx-overlay-content,
.dx-scheduler-overlay-panel .dx-overlay-content {
  background-color: #fff;
}
.dx-scheduler-appointment-tooltip-wrapper .dx-overlay-content .dx-popup-content,
.dx-scheduler-overlay-panel .dx-overlay-content .dx-popup-content {
  padding: 0;
}
.dx-scheduler-appointment-tooltip-wrapper .dx-overlay-content .dx-list .dx-list-item,
.dx-scheduler-overlay-panel .dx-overlay-content .dx-list .dx-list-item {
  margin-bottom: 0;
  margin-top: 0;
  border-bottom: 1px solid #e0e0e0;
}
.dx-scheduler-appointment-tooltip-wrapper .dx-overlay-content .dx-list .dx-list-item:last-of-type,
.dx-scheduler-overlay-panel .dx-overlay-content .dx-list .dx-list-item:last-of-type {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom: none;
}
.dx-scheduler-appointment-tooltip-wrapper .dx-overlay-content .dx-list .dx-list-item:first-of-type,
.dx-scheduler-overlay-panel .dx-overlay-content .dx-list .dx-list-item:first-of-type {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.dx-scheduler-appointment-tooltip-wrapper .dx-overlay-content .dx-list .dx-list-item .dx-tooltip-appointment-item,
.dx-scheduler-overlay-panel .dx-overlay-content .dx-list .dx-list-item .dx-tooltip-appointment-item {
  margin-left: 10px;
}
.dx-scheduler-appointment-tooltip-wrapper .dx-overlay-content .dx-list .dx-list-item .dx-tooltip-appointment-item .dx-tooltip-appointment-item-marker-body,
.dx-scheduler-overlay-panel .dx-overlay-content .dx-list .dx-list-item .dx-tooltip-appointment-item .dx-tooltip-appointment-item-marker-body {
  width: 24px;
  height: 24px;
}
.dx-scheduler-appointment-tooltip-wrapper .dx-overlay-content .dx-list .dx-list-item .dx-tooltip-appointment-item .dx-tooltip-appointment-item-content .dx-tooltip-appointment-item-content-subject,
.dx-scheduler-overlay-panel .dx-overlay-content .dx-list .dx-list-item .dx-tooltip-appointment-item .dx-tooltip-appointment-item-content .dx-tooltip-appointment-item-content-subject {
  margin-top: 4px;
  font-size: 18px;
}
.dx-scheduler-appointment-tooltip-wrapper .dx-overlay-content .dx-list .dx-list-item .dx-tooltip-appointment-item .dx-tooltip-appointment-item-content .dx-tooltip-appointment-item-content-date,
.dx-scheduler-overlay-panel .dx-overlay-content .dx-list .dx-list-item .dx-tooltip-appointment-item .dx-tooltip-appointment-item-content .dx-tooltip-appointment-item-content-date {
  font-size: 14px;
  opacity: 1;
  margin-top: 4px;
}
.dx-scheduler-appointment-tooltip-wrapper .dx-overlay-content .dx-list .dx-list-item .dx-tooltip-appointment-item .dx-tooltip-appointment-item-delete-button-container,
.dx-scheduler-overlay-panel .dx-overlay-content .dx-list .dx-list-item .dx-tooltip-appointment-item .dx-tooltip-appointment-item-delete-button-container {
  padding-top: 1px;
}
.dx-scheduler-timeline .dx-scheduler-group-flex-container .dx-scheduler-group-header {
  width: 100px;
}
.dx-scheduler-header-panel-empty-cell {
  margin-top: 0;
}
.dx-layout-manager .dx-field-item:not(.dx-first-row) {
  padding-top: 10px;
}
.dx-layout-manager .dx-field-empty-item {
  width: 100%;
}
.dx-layout-manager.dx-layout-manager-one-col .dx-single-column-item-content > .dx-field-item {
  padding-left: 0;
  padding-right: 0;
}
.dx-layout-manager.dx-layout-manager-one-col .dx-form-group .dx-single-column-item-content > .dx-first-row.dx-col-0.dx-field-item {
  padding-top: 0;
}
.dx-layout-manager.dx-layout-manager-one-col .dx-box-item:not(:first-child) .dx-single-column-item-content > .dx-field-item {
  padding-top: 10px;
}
.dx-layout-manager .dx-label-h-align.dx-flex-layout {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.dx-layout-manager .dx-label-h-align.dx-flex-layout .dx-field-item-label {
  display: block;
}
.dx-layout-manager .dx-label-h-align.dx-flex-layout .dx-field-item-content,
.dx-layout-manager .dx-label-h-align.dx-flex-layout .dx-field-item-content-wrapper {
  -ms-flex-negative: 1;
  flex-shrink: 1;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -ms-flex-preferred-size: auto;
  flex-basis: auto;
  display: block;
}
.dx-layout-manager .dx-label-h-align.dx-flex-layout:not(.dx-field-item-label-align) {
  -webkit-box-align: baseline;
  -ms-flex-align: baseline;
  align-items: baseline;
}
.dx-layout-manager .dx-label-h-align.dx-field-item-label-align:not(.dx-flex-layout) .dx-field-item-label {
  vertical-align: baseline;
}
.dx-layout-manager .dx-label-h-align .dx-field-item-content,
.dx-layout-manager .dx-label-h-align .dx-field-item-content-wrapper,
.dx-layout-manager .dx-label-h-align .dx-field-item-label {
  display: table-cell;
}
.dx-layout-manager .dx-label-h-align .dx-field-item-content-wrapper .dx-field-item-content {
  display: block;
}
.dx-layout-manager .dx-label-h-align .dx-field-item-label {
  white-space: nowrap;
  vertical-align: middle;
}
.dx-layout-manager .dx-label-h-align .dx-field-item-label .dx-field-item-label-content {
  display: block;
}
.dx-layout-manager .dx-label-h-align .dx-field-item-label .dx-field-item-custom-label-content {
  display: inline-block;
}
.dx-layout-manager .dx-label-h-align .dx-field-item-content,
.dx-layout-manager .dx-label-h-align .dx-field-item-label .dx-field-item-custom-label-content .dx-icon {
  vertical-align: top;
}
.dx-layout-manager .dx-label-h-align .dx-field-item-content .dx-checkbox,
.dx-layout-manager .dx-label-h-align .dx-field-item-content .dx-switch {
  margin-top: 7px;
  margin-bottom: 4px;
}
.dx-layout-manager .dx-label-h-align .dx-field-item-content,
.dx-layout-manager .dx-label-h-align .dx-field-item-content-wrapper {
  width: 100%;
}
.dx-layout-manager .dx-tabpanel .dx-multiview-item-content {
  padding: 20px;
}
.dx-field-item-label-location-top .dx-field-item-custom-label-content {
  display: inline-block;
}
.dx-field-item-label-location-top .dx-field-item-custom-label-content .dx-icon {
  vertical-align: top;
}
.dx-form-group-content {
  border-width: 0;
  padding: 0;
  margin: 0;
}
.dx-form-group-with-caption .dx-form-group.dx-form-group-with-caption {
  padding-left: 20px;
}
.dx-layout-manager-hidden-label {
  position: absolute;
  display: block;
  visibility: hidden;
}
.dx-field-item-label-location-left {
  padding-right: 10px;
}
.dx-field-item-label-location-right {
  padding-left: 10px;
}
.dx-field-item-optional .dx-label > span::after,
.dx-field-item-required .dx-label > span::after {
  content: attr(data-mark);
}
.dx-rtl .dx-field-item-optional-mark,
.dx-rtl .dx-field-item-required-mark {
  unicode-bidi: embed;
}
.dx-rtl .dx-field-item:not(.dx-first-col) {
  padding-left: 0;
  padding-right: 15px;
}
.dx-rtl .dx-field-item:not(.dx-last-col) {
  padding-left: 15px;
  padding-right: 0;
}
.dx-rtl .dx-field-item-label-location-left {
  padding-right: 0;
  padding-left: 10px;
}
.dx-rtl .dx-field-item-label-location-right {
  padding-left: 0;
  padding-right: 10px;
}
.dx-rtl .dx-layout-manager-one-col .dx-single-column-item-content > .dx-field-item {
  padding-right: 0;
  padding-left: 0;
}
.dx-rtl .dx-form-group-with-caption .dx-form-group.dx-form-group-with-caption {
  padding-left: 0;
  padding-right: 20px;
}
.dx-form-group-caption {
  font-size: 20px;
}
.dx-form-group-with-caption > .dx-form-group-content {
  border-top: 1px solid #e0e0e0;
  padding-bottom: 20px;
  padding-top: 19px;
  margin-top: 6px;
}
.dx-form > .dx-scrollable-wrapper > .dx-scrollable-container {
  margin-left: -10px;
  padding-left: 10px;
}
.dx-scrollable-content > .dx-layout-manager {
  padding-right: 5px;
}
.dx-layout-manager .dx-field-item {
  padding-bottom: 10px;
  font-size: 12px;
}
.dx-layout-manager .dx-field-item:not(.dx-last-col) {
  padding-right: 20px;
}
.dx-layout-manager .dx-field-item:not(.dx-first-col) {
  padding-left: 20px;
}
.dx-layout-manager .dx-field-item .dx-field-item.dx-last-row {
  padding-bottom: 0;
}
.dx-form > .dx-layout-manager.dx-layout-manager-one-col .dx-field-item .dx-field-item.dx-last-row:not(.dx-last-col) {
  padding-bottom: 10px;
}
.dx-field-item:not(.dx-field-item-has-group):not(.dx-field-item-has-tabs):not(.dx-first-row):not(.dx-label-v-align) {
  padding-top: 26px;
}
.dx-field-item .dx-switch {
  vertical-align: middle;
}
.dx-field-item.dx-label-v-align .dx-invalid-message > .dx-overlay-content,
.dx-field-item.dx-label-v-align .dx-invalid-message > .dx-overlay-wrapper {
  -webkit-transform: translate(0,0)!important;
  transform: translate(0,0)!important;
}
.dx-field-item .dx-toggle-controls-paddings {
  padding-left: 16px;
}
.dx-field-item-content-wrapper.dx-invalid .dx-field-item-help-text {
  color: transparent;
}
.dx-field-item-label-location-top {
  display: block;
  padding: 16px 16px 3px;
}
.dx-form-styling-mode-underlined .dx-field-item-label-location-top {
  padding-left: 0;
  padding-right: 0;
}
.dx-field-item-label-text {
  color: rgba(0,0,0,.6);
}
.dx-field-item-help-text {
  white-space: normal;
  color: rgba(0,0,0,.6);
  padding: 6px 16px 2px;
  font-style: normal;
}
.dx-form-styling-mode-underlined .dx-field-item-help-text {
  padding-left: 0;
  padding-right: 0;
}
.dx-field-item-optional .dx-label>span::after,
.dx-field-item-optional-mark,
.dx-field-item-required .dx-label>span::after,
.dx-field-item-required-mark {
  color: rgba(0,0,0,.6);
}
.dx-field-item-custom-label-content .dx-icon {
  width: 14px;
  height: 14px;
  background-position: 0 0;
  background-size: 14px 14px;
  padding: 0;
  font-size: 14px;
  text-align: center;
  line-height: 14px;
  margin-right: 8px;
  margin-left: 0;
}
.dx-field-item-custom-label-content .dx-icon.dx-icon-right,
.dx-rtl .dx-field-item-custom-label-content .dx-icon,
.dx-rtl.dx-field-item-custom-label-content .dx-icon {
  margin-left: 8px;
  margin-right: 0;
}
.dx-rtl .dx-field-item-custom-label-content .dx-icon.dx-icon-right,
.dx-rtl.dx-field-item-custom-label-content .dx-icon.dx-icon-right {
  margin-right: 8px;
  margin-left: 0;
}
.dx-filterbuilder.dx-rtl .dx-filterbuilder-action-icon,
.dx-filterbuilder.dx-rtl .dx-filterbuilder-text {
  margin-left: 5px;
  margin-right: 0;
}
.dx-filterbuilder.dx-rtl .dx-filterbuilder-group .dx-filterbuilder-group-content .dx-filterbuilder-group-content {
  padding-left: 0;
  padding-right: 26px;
}
.dx-filterbuilder .dx-filterbuilder-action-icon,
.dx-filterbuilder .dx-filterbuilder-text {
  margin-left: 0;
  margin-right: 5px;
}
.dx-filterbuilder .dx-filterbuilder-action-icon:focus,
.dx-filterbuilder .dx-filterbuilder-item-value-text:focus,
.dx-filterbuilder .dx-filterbuilder-text:focus {
  outline: 0;
}
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-group-item {
  display: inline-block;
  white-space: nowrap;
}
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-group-item .dx-filterbuilder-text {
  display: inline-block;
  cursor: pointer;
  white-space: pre;
}
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-group-item .dx-filterbuilder-text .dx-filterbuilder-range {
  white-space: nowrap;
}
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-group-item .dx-filterbuilder-text .dx-filterbuilder-range-separator,
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-group-item .dx-filterbuilder-text .dx-filterbuilder-text-separator {
  margin: 0 7px;
  opacity: .3;
}
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-group-item .dx-filterbuilder-text .dx-filterbuilder-item-value-text,
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-group-item .dx-filterbuilder-text.dx-filterbuilder-group-operation,
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-group-item .dx-filterbuilder-text.dx-filterbuilder-item-field,
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-group-item .dx-filterbuilder-text.dx-filterbuilder-item-operation {
  min-width: 20px;
  padding: 2px 7px 3px;
}
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-group-item .dx-filterbuilder-text .dx-texteditor {
  vertical-align: middle;
  margin-top: -7px;
  margin-bottom: -4px;
  display: inline-block;
}
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-group-item .dx-filterbuilder-action {
  display: inline-block;
  cursor: pointer;
  position: relative;
}
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-group-content .dx-filterbuilder-group-content {
  padding-left: 26px;
}
.dx-filterbuilder-operations .dx-treeview-item {
  padding-left: 5px;
}
.dx-filterbuilder-operations .dx-rtl .dx-treeview-item {
  padding-right: 5px;
}
.dx-filterbuilder-overlay {
  white-space: nowrap;
}
.dx-filterbuilder-overlay .dx-treeview .dx-treeview-node {
  padding-left: 0;
}
.dx-filterbuilder-overlay .dx-treeview .dx-treeview-node .dx-treeview-node-container-opened {
  margin-left: 15px;
}
.dx-filterbuilder-overlay .dx-treeview.dx-rtl .dx-treeview-node {
  padding-right: 0;
}
.dx-filterbuilder-overlay .dx-treeview.dx-rtl .dx-treeview-node .dx-treeview-node-container-opened {
  margin-right: 15px;
}
.dx-filterbuilder-overlay .dx-overlay-content.dx-popup-normal {
  border-radius: 0;
}
.dx-filterbuilder-overlay .dx-overlay-content.dx-popup-normal > .dx-popup-content {
  padding: 0;
}
.dx-filterbuilder-overlay .dx-scrollable-container {
  max-height: 360px;
}
.dx-filterbuilder-overlay .dx-menu-items-container {
  padding: 0;
}
.dx-filterbuilder {
  background-color: #fff;
}
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-text {
  color: rgba(0,0,0,.87);
}
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-text.dx-filterbuilder-group-operation {
  background-color: rgba(244,67,54,.3);
}
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-text.dx-filterbuilder-group-operation:hover {
  background-color: rgba(244,67,54,.5);
}
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-text.dx-filterbuilder-group-operation.dx-state-active,
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-text.dx-filterbuilder-group-operation:focus {
  background-color: #f44336;
  color: #fff;
}
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-text.dx-filterbuilder-item-field {
  background-color: rgba(0,150,136,.3);
}
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-text.dx-filterbuilder-item-field:hover {
  background-color: rgba(0,150,136,.5);
}
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-text.dx-filterbuilder-item-field.dx-state-active,
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-text.dx-filterbuilder-item-field:focus {
  background-color: #009688;
  color: #fff;
}
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-text.dx-filterbuilder-item-operation {
  background-color: rgba(139,195,74,.3);
}
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-text.dx-filterbuilder-item-operation:hover {
  background-color: rgba(139,195,74,.5);
}
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-text.dx-filterbuilder-item-operation.dx-state-active,
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-text.dx-filterbuilder-item-operation:focus {
  background-color: #8bc34a;
  color: #fff;
}
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-text .dx-filterbuilder-item-value-text,
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-text .dx-filterbuilder-item-value-text:hover {
  background-color: rgba(224,224,224,.5);
}
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-text .dx-filterbuilder-item-value-text.dx-state-active,
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-text .dx-filterbuilder-item-value-text:focus {
  background-color: #e0e0e0;
  color: #fff;
}
.dx-filterbuilder .dx-filterbuilder-group .dx-icon-plus {
  color: rgba(139,195,74,.7);
}
.dx-filterbuilder .dx-filterbuilder-group .dx-icon-plus.dx-state-active,
.dx-filterbuilder .dx-filterbuilder-group .dx-icon-plus:focus,
.dx-filterbuilder .dx-filterbuilder-group .dx-icon-plus:hover {
  color: #8bc34a;
}
.dx-filterbuilder .dx-filterbuilder-group .dx-icon-remove {
  color: rgba(244,67,54,.7);
}
.dx-filterbuilder .dx-filterbuilder-group .dx-icon-remove:focus,
.dx-filterbuilder .dx-filterbuilder-group .dx-icon-remove:hover {
  color: #f44336;
}
.dx-filterbuilder-overlay.dx-filterbuilder-operations .dx-treeview-item .dx-icon {
  color: rgba(86,86,86,.54);
  width: 14px;
  height: 14px;
  background-position: 0 0;
  background-size: 14px 14px;
  padding: 0;
  font-size: 14px;
  text-align: center;
  line-height: 14px;
}
.dx-filterbuilder .dx-filterbuilder-action-icon {
  font-size: 21px;
}
.dx-filterbuilder .dx-filterbuilder-group .dx-filterbuilder-group-item .dx-filterbuilder-action.dx-filterbuilder-action-icon {
  padding: 8px;
  vertical-align: middle;
}
.dx-filterbuilder .dx-filterbuilder-item-value .dx-editor-filled .dx-texteditor-input,
.dx-filterbuilder .dx-filterbuilder-item-value .dx-editor-outlined .dx-texteditor-input {
  padding: 13px 12px;
}
.dx-filterbuilder .dx-filterbuilder-item-value-text,
.dx-filterbuilder .dx-filterbuilder-text {
  border-radius: 5px;
}
.dx-filterbuilder-range-separator {
  color: rgba(0,0,0,.87);
}
.dx-filterbuilder-overlay.dx-popup-wrapper > .dx-overlay-content {
  -webkit-box-shadow: 0 2px 7px rgba(0,0,0,.2);
  box-shadow: 0 2px 7px rgba(0,0,0,.2);
}
.dx-filterbuilder-overlay.dx-filterbuilder-operations .dx-treeview-item {
  padding-left: 24px;
}
.dx-filterbuilder-overlay.dx-filterbuilder-operations .dx-rtl .dx-treeview-item {
  padding-right: 24px;
}
.dx-filterbuilder-overlay .dx-treeview-node > .dx-treeview-item {
  padding-left: 48px;
}
.dx-filterbuilder-overlay .dx-treeview-node.dx-treeview-node-is-leaf > .dx-treeview-item {
  padding-left: 24px;
}
.dx-filterbuilder-overlay .dx-treeview-node .dx-treeview-node-container-opened {
  margin-left: 24px;
}
.dx-filterbuilder-overlay .dx-treeview-item {
  padding: 8px 24px 10px;
  min-height: 36px;
}
.dx-filterbuilder-overlay .dx-treeview-item .dx-icon {
  margin-right: 10px;
}
.dx-filterbuilder-overlay .dx-treeview-toggle-item-visibility {
  height: 36px;
  left: 16px;
}
.dx-filterbuilder-overlay .dx-rtl .dx-treeview-node > .dx-treeview-item {
  padding-right: 48px;
}
.dx-filterbuilder-overlay .dx-rtl .dx-treeview-node.dx-treeview-node-is-leaf > .dx-treeview-item {
  padding-right: 24px;
}
.dx-filterbuilder-overlay .dx-rtl .dx-treeview-node .dx-treeview-node-container-opened {
  margin-right: 24px;
  margin-left: 0;
}
.dx-filterbuilder-overlay .dx-rtl .dx-treeview-item .dx-icon {
  margin-left: 10px;
}
.dx-filterbuilder-overlay .dx-rtl .dx-treeview-toggle-item-visibility {
  right: 16px;
}
.dx-drawer {
  height: 100%;
  width: 100%;
}
.dx-drawer-wrapper {
  position: relative;
  overflow: hidden;
  height: 100%;
}
.dx-drawer-panel-content {
  position: absolute;
  top: 0;
  bottom: 0;
}
.dx-drawer-right .dx-drawer-panel-content {
  right: 0;
}
.dx-drawer-left .dx-drawer-panel-content {
  left: 0;
}
.dx-drawer-panel-content-push-top-or-bottom {
  width: 100%;
}
.dx-drawer-content {
  overflow: hidden;
  width: 100%;
  height: 100%;
  top: 0;
}
.dx-drawer-shader {
  z-index: 1000;
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0,0,0,.5);
}
.dx-drawer-push.dx-drawer-bottom .dx-drawer-panel-content {
  top: auto;
}
.dx-drawer-shrink .dx-drawer-panel-content {
  position: relative;
  overflow: hidden;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  height: 100%;
}
.dx-drawer-shrink .dx-drawer-wrapper {
  -webkit-box-flex: 1;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
}
.dx-drawer-shrink .dx-drawer-content {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.dx-drawer-shrink.dx-drawer-bottom .dx-drawer-wrapper,
.dx-drawer-shrink.dx-drawer-top .dx-drawer-wrapper {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.dx-drawer-overlap .dx-drawer-panel-content {
  overflow: visible;
}
.dx-drawer-overlap .dx-drawer-panel-content.dx-overlay-wrapper {
  right: auto;
  left: auto;
}
.dx-drawer-overlap.dx-drawer-left .dx-drawer-wrapper,
.dx-drawer-overlap.dx-drawer-right .dx-drawer-wrapper {
  overflow-y: visible;
}
.dx-drawer-overlap.dx-drawer-bottom .dx-drawer-wrapper,
.dx-drawer-overlap.dx-drawer-top .dx-drawer-wrapper {
  overflow-x: visible;
}
.dx-drawer-overlap.dx-drawer-right.dx-drawer-expand>.dx-drawer-wrapper>.dx-overlay>.dx-overlay-wrapper>.dx-overlay-content,
.dx-drawer-overlap.dx-drawer-right.dx-drawer-slide>.dx-drawer-wrapper>.dx-overlay>.dx-overlay-wrapper>.dx-overlay-content {
  right: 0;
}
.dx-htmleditor {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  border: 1px solid transparent;
}
.dx-htmleditor:not(.dx-state-disabled) li[data-list=checked],
.dx-htmleditor:not(.dx-state-disabled) li[data-list=unchecked] {
  cursor: pointer;
}
.dx-htmleditor-add-image-popup-with-tabs > .dx-overlay-content > .dx-popup-content {
  padding: 0;
}
.dx-htmleditor-hidden-content {
  display: none;
}
.dx-htmleditor-add-image-popup > .dx-overlay-content > .dx-popup-content .dx-multiview-wrapper {
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
}
.dx-htmleditor-add-image-popup > .dx-overlay-content > .dx-popup-content .dx-fix-ratio-container .dx-textbox {
  display: inline-block;
  width: calc(100% - 36px - 5px);
}
.dx-htmleditor-add-image-popup > .dx-overlay-content > .dx-popup-content .dx-fileuploader-wrapper {
  padding: 0;
}
.dx-htmleditor-add-image-popup > .dx-overlay-content > .dx-popup-content .dx-fileuploader-upload-button {
  display: none;
}
.dx-htmleditor-add-image-popup > .dx-overlay-content .dx-popup-title {
  border-bottom: 0;
}
.dx-quill-container {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -ms-flex-preferred-size: auto;
  flex-basis: auto;
  min-height: 1px;
  margin: 0;
  position: relative;
  overflow: hidden;
}
.ql-clipboard {
  left: -100000px;
  height: 1px;
  overflow-y: hidden;
  position: absolute;
  top: 50%;
}
.ql-clipboard p {
  margin: 0;
  padding: 0;
}
.dx-htmleditor-content {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 1.42;
  width: 100%;
  outline: 0;
  overflow-y: auto;
  padding: 12px 15px;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.dx-htmleditor-content .dx-variable > span {
  padding: 3px 6px;
  border-radius: 8px;
  background: rgba(0,150,136,.15);
}
.dx-htmleditor-content > * {
  cursor: text;
}
.dx-htmleditor-content blockquote,
.dx-htmleditor-content h1,
.dx-htmleditor-content h2,
.dx-htmleditor-content h3,
.dx-htmleditor-content h4,
.dx-htmleditor-content h5,
.dx-htmleditor-content h6,
.dx-htmleditor-content ol,
.dx-htmleditor-content p,
.dx-htmleditor-content pre,
.dx-htmleditor-content ul {
  margin: 0;
  padding: 0;
}
.dx-htmleditor-content h1,
.dx-htmleditor-content h2,
.dx-htmleditor-content h3,
.dx-htmleditor-content h4,
.dx-htmleditor-content h5,
.dx-htmleditor-content h6,
.dx-htmleditor-content ol,
.dx-htmleditor-content p,
.dx-htmleditor-content ul {
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.dx-htmleditor-content table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
}
.dx-htmleditor-content td,
.dx-htmleditor-content th {
  border: 1px solid #000;
  padding: 2px 5px;
}
.dx-htmleditor-content ol,
.dx-htmleditor-content ul {
  padding-left: 1.5em;
}
.dx-rtl .dx-htmleditor-content ol,
.dx-rtl .dx-htmleditor-content ul {
  padding-left: 0;
  padding-right: 1.5em;
}
.dx-htmleditor-content li {
  list-style-type: none;
  padding-left: 1.5em;
  position: relative;
}
.dx-htmleditor-content li[data-list=bullet]::before {
  content: "•";
}
.dx-htmleditor-content li[data-list=checked]::before {
  content: "☑";
}
.dx-htmleditor-content li[data-list=unchecked]::before {
  content: "☐";
}
.dx-htmleditor-content li::before {
  display: inline-block;
  margin-left: -1.5em;
  margin-right: .3em;
  text-align: right;
  white-space: nowrap;
  width: 1.2em;
}
.dx-htmleditor-content li > .ql-ui {
  visibility: hidden;
}
.dx-htmleditor-content li[data-list=checked] > .ql-ui,
.dx-htmleditor-content li[data-list=unchecked] > .ql-ui {
  visibility: visible;
}
.dx-rtl .dx-htmleditor-content li {
  padding-left: 0;
  padding-right: 1.5em;
}
.dx-htmleditor-content li[data-list=ordered] {
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  counter-increment: list-0;
}
.dx-htmleditor-content li[data-list=ordered]::before {
  content: counter(list-0,decimal) ". ";
}
.dx-htmleditor-content ol li[data-list=ordered].ql-indent-1 {
  counter-increment: list-1;
}
.dx-htmleditor-content ol li[data-list=ordered].ql-indent-1::before {
  content: counter(list-1,lower-alpha) ". ";
}
.dx-htmleditor-content li.ql-indent-1 {
  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  padding-left: 4.5em;
}
.dx-htmleditor-content ol li[data-list=ordered].ql-indent-2 {
  counter-increment: list-2;
}
.dx-htmleditor-content ol li[data-list=ordered].ql-indent-2::before {
  content: counter(list-2,lower-roman) ". ";
}
.dx-htmleditor-content li.ql-indent-2 {
  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  padding-left: 7.5em;
}
.dx-htmleditor-content ol li[data-list=ordered].ql-indent-3 {
  counter-increment: list-3;
}
.dx-htmleditor-content ol li[data-list=ordered].ql-indent-3::before {
  content: counter(list-3,decimal) ". ";
}
.dx-htmleditor-content li.ql-indent-3 {
  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
  padding-left: 10.5em;
}
.dx-htmleditor-content ol li[data-list=ordered].ql-indent-4 {
  counter-increment: list-4;
}
.dx-htmleditor-content ol li[data-list=ordered].ql-indent-4::before {
  content: counter(list-4,lower-alpha) ". ";
}
.dx-htmleditor-content li.ql-indent-4 {
  counter-reset: list-5 list-6 list-7 list-8 list-9;
  padding-left: 13.5em;
}
.dx-htmleditor-content ol li[data-list=ordered].ql-indent-5 {
  counter-increment: list-5;
}
.dx-htmleditor-content ol li[data-list=ordered].ql-indent-5::before {
  content: counter(list-5,lower-roman) ". ";
}
.dx-htmleditor-content li.ql-indent-5 {
  counter-reset: list-6 list-7 list-8 list-9;
  padding-left: 16.5em;
}
.dx-htmleditor-content ol li[data-list=ordered].ql-indent-6 {
  counter-increment: list-6;
}
.dx-htmleditor-content ol li[data-list=ordered].ql-indent-6::before {
  content: counter(list-6,decimal) ". ";
}
.dx-htmleditor-content li.ql-indent-6 {
  counter-reset: list-7 list-8 list-9;
  padding-left: 19.5em;
}
.dx-htmleditor-content ol li[data-list=ordered].ql-indent-7 {
  counter-increment: list-7;
}
.dx-htmleditor-content ol li[data-list=ordered].ql-indent-7::before {
  content: counter(list-7,lower-alpha) ". ";
}
.dx-htmleditor-content li.ql-indent-7 {
  counter-reset: list-8 list-9;
  padding-left: 22.5em;
}
.dx-htmleditor-content ol li[data-list=ordered].ql-indent-8 {
  counter-increment: list-8;
}
.dx-htmleditor-content ol li[data-list=ordered].ql-indent-8::before {
  content: counter(list-8,lower-roman) ". ";
}
.dx-htmleditor-content li.ql-indent-8 {
  counter-reset: list-9;
  padding-left: 25.5em;
}
.dx-htmleditor-content ol li[data-list=ordered].ql-indent-9 {
  counter-increment: list-9;
}
.dx-htmleditor-content ol li[data-list=ordered].ql-indent-9::before {
  content: counter(list-9,decimal) ". ";
}
.dx-htmleditor-content .ql-indent-1 {
  padding-left: 3em;
}
.dx-rtl .dx-htmleditor-content .ql-indent-1 {
  padding-left: 0;
  padding-right: 3em;
}
.dx-rtl .dx-htmleditor-content li.ql-indent-1 {
  padding-left: 0;
  padding-right: 4.5em;
}
.dx-htmleditor-content .ql-indent-2 {
  padding-left: 6em;
}
.dx-rtl .dx-htmleditor-content .ql-indent-2 {
  padding-left: 0;
  padding-right: 6em;
}
.dx-rtl .dx-htmleditor-content li.ql-indent-2 {
  padding-left: 0;
  padding-right: 7.5em;
}
.dx-htmleditor-content .ql-indent-3 {
  padding-left: 9em;
}
.dx-rtl .dx-htmleditor-content .ql-indent-3 {
  padding-left: 0;
  padding-right: 9em;
}
.dx-rtl .dx-htmleditor-content li.ql-indent-3 {
  padding-left: 0;
  padding-right: 10.5em;
}
.dx-htmleditor-content .ql-indent-4 {
  padding-left: 12em;
}
.dx-rtl .dx-htmleditor-content .ql-indent-4 {
  padding-left: 0;
  padding-right: 12em;
}
.dx-rtl .dx-htmleditor-content li.ql-indent-4 {
  padding-left: 0;
  padding-right: 13.5em;
}
.dx-htmleditor-content .ql-indent-5 {
  padding-left: 15em;
}
.dx-rtl .dx-htmleditor-content .ql-indent-5 {
  padding-left: 0;
  padding-right: 15em;
}
.dx-rtl .dx-htmleditor-content li.ql-indent-5 {
  padding-left: 0;
  padding-right: 16.5em;
}
.dx-htmleditor-content .ql-indent-6 {
  padding-left: 18em;
}
.dx-rtl .dx-htmleditor-content .ql-indent-6 {
  padding-left: 0;
  padding-right: 18em;
}
.dx-rtl .dx-htmleditor-content li.ql-indent-6 {
  padding-left: 0;
  padding-right: 19.5em;
}
.dx-htmleditor-content .ql-indent-7 {
  padding-left: 21em;
}
.dx-rtl .dx-htmleditor-content .ql-indent-7 {
  padding-left: 0;
  padding-right: 21em;
}
.dx-rtl .dx-htmleditor-content li.ql-indent-7 {
  padding-left: 0;
  padding-right: 22.5em;
}
.dx-htmleditor-content .ql-indent-8 {
  padding-left: 24em;
}
.dx-rtl .dx-htmleditor-content .ql-indent-8 {
  padding-left: 0;
  padding-right: 24em;
}
.dx-rtl .dx-htmleditor-content li.ql-indent-8 {
  padding-left: 0;
  padding-right: 25.5em;
}
.dx-htmleditor-content .ql-indent-9 {
  padding-left: 27em;
}
.dx-rtl .dx-htmleditor-content .ql-indent-9 {
  padding-left: 0;
  padding-right: 27em;
}
.dx-htmleditor-content li.ql-indent-9 {
  padding-left: 28.5em;
}
.dx-rtl .dx-htmleditor-content li.ql-indent-9 {
  padding-left: 0;
  padding-right: 28.5em;
}
.dx-rtl .dx-htmleditor-content li::before {
  margin-left: .3em;
  margin-right: -1.5em;
  text-align: left;
}
.dx-htmleditor-content table td,
.dx-htmleditor-content table th {
  outline: 0;
}
.dx-htmleditor-content .ql-code-block-container {
  font-family: monospace;
}
.dx-htmleditor-content .ql-code-block-container,
.dx-htmleditor-content code {
  background-color: rgba(191,191,191,.15);
  color: rgba(0,0,0,.8);
}
.dx-htmleditor-content .ql-video {
  display: block;
  max-width: 100%;
}
.dx-htmleditor-content .ql-video.ql-align-center {
  margin: 0 auto;
}
.dx-htmleditor-content .ql-video.ql-align-right {
  margin: 0 0 0 auto;
}
.dx-htmleditor-content .ql-font-serif {
  font-family: Georgia,"Times New Roman",serif;
}
.dx-htmleditor-content .ql-font-monospace {
  font-family: Monaco,"Courier New",monospace;
}
.dx-htmleditor-content .ql-direction-rtl {
  direction: rtl;
  text-align: inherit;
}
.dx-htmleditor-content.ql-blank::before {
  content: attr(data-placeholder);
  font-style: italic;
  left: 15px;
  pointer-events: none;
  position: absolute;
  right: 15px;
  color: rgba(148,148,148,.87);
}
.dx-htmleditor-content.ql-blank::after {
  content: attr(data-placeholder);
  z-index: -1;
  visibility: hidden;
}
.dx-htmleditor-content.ql-blank[data-placeholder] > p {
  height: .1px;
}
.dx-htmleditor-content blockquote {
  padding-left: 12px;
  border-left: 4px solid;
}
.dx-rtl .dx-htmleditor-content blockquote {
  padding-left: 0;
  padding-right: 12px;
  border-left: none;
  border-right: 4px solid;
}
.dx-suggestion-list-wrapper .dx-list .dx-scrollable-content {
  margin: 0;
}
.dx-suggestion-list {
  min-width: 50px;
}
.dx-suggestion-list .dx-list-item {
  display: block;
}
.dx-suggestion-list .dx-list-item-icon {
  border-radius: 50%;
  vertical-align: text-bottom;
}
.dx-formdialog-form {
  min-width: 360px;
}
.dx-overlay-content.dx-popup-fullscreen .dx-formdialog-form {
  min-width: 240px;
}
.dx-formdialog-field-target .dx-field-item-content {
  text-align: right;
}
.dx-rtl .dx-formdialog-field-target .dx-field-item-content {
  text-align: left;
}
.dx-background-format .dx-icon-background,
.dx-background-format .dx-icon-color,
.dx-color-format .dx-icon-background,
.dx-color-format .dx-icon-color {
  border-bottom: 3px solid transparent;
}
.dx-htmleditor-toolbar-separator {
  border-left: 1px solid transparent;
}
.dx-htmleditor-toolbar-menu-separator {
  width: 100%;
  border-top: 1px solid transparent;
}
.dx-htmleditor-toolbar-menu-separator::before {
  content: none;
}
.dx-resize-frame {
  position: absolute;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  border: 1px dashed #778899;
  pointer-events: none;
}
.dx-resize-frame .dx-resizable-handle {
  pointer-events: auto;
}
.dx-resize-frame .dx-resizable-handle-corner-bottom-left,
.dx-resize-frame .dx-resizable-handle-corner-bottom-right,
.dx-resize-frame .dx-resizable-handle-corner-top-left,
.dx-resize-frame .dx-resizable-handle-corner-top-right {
  border: 1px solid #fff;
  width: 11px;
  height: 11px;
  border-radius: 0;
}
.dx-touch-device.dx-resize-frame .dx-resizable-handle-corner-bottom-left,
.dx-touch-device.dx-resize-frame .dx-resizable-handle-corner-bottom-right,
.dx-touch-device.dx-resize-frame .dx-resizable-handle-corner-top-left,
.dx-touch-device.dx-resize-frame .dx-resizable-handle-corner-top-right {
  width: 15px;
  height: 15px;
}
.dx-resize-frame .dx-resizable-handle-corner-bottom-right,
.dx-resize-frame .dx-resizable-handle-corner-top-right {
  right: -5.5px;
}
.dx-touch-device.dx-resize-frame .dx-resizable-handle-corner-bottom-right,
.dx-touch-device.dx-resize-frame .dx-resizable-handle-corner-top-right {
  right: -7.5px;
}
.dx-resize-frame .dx-resizable-handle-corner-bottom-left,
.dx-resize-frame .dx-resizable-handle-corner-top-left {
  left: -5.5px;
}
.dx-touch-device.dx-resize-frame .dx-resizable-handle-corner-bottom-left,
.dx-touch-device.dx-resize-frame .dx-resizable-handle-corner-top-left {
  left: -7.5px;
}
.dx-resize-frame .dx-resizable-handle-corner-top-left,
.dx-resize-frame .dx-resizable-handle-corner-top-right {
  top: -5.5px;
}
.dx-touch-device.dx-resize-frame .dx-resizable-handle-corner-top-left,
.dx-touch-device.dx-resize-frame .dx-resizable-handle-corner-top-right {
  top: -7.5px;
}
.dx-resize-frame .dx-resizable-handle-corner-bottom-left,
.dx-resize-frame .dx-resizable-handle-corner-bottom-right {
  bottom: -5.5px;
}
.dx-touch-device.dx-resize-frame .dx-resizable-handle-corner-bottom-left,
.dx-touch-device.dx-resize-frame .dx-resizable-handle-corner-bottom-right {
  bottom: -7.5px;
}
.dx-resize-frame .dx-resizable-handle-bottom::after,
.dx-resize-frame .dx-resizable-handle-left::after,
.dx-resize-frame .dx-resizable-handle-right::after,
.dx-resize-frame .dx-resizable-handle-top::after {
  content: "";
  position: absolute;
  width: 11px;
  height: 11px;
  border: 1px solid #fff;
}
.dx-touch-device.dx-resize-frame .dx-resizable-handle-bottom::after,
.dx-touch-device.dx-resize-frame .dx-resizable-handle-left::after,
.dx-touch-device.dx-resize-frame .dx-resizable-handle-right::after,
.dx-touch-device.dx-resize-frame .dx-resizable-handle-top::after {
  width: 15px;
  height: 15px;
}
.dx-resize-frame .dx-resizable-handle-left::after,
.dx-resize-frame .dx-resizable-handle-right::after {
  top: calc(50% - 5.5px);
}
.dx-touch-device.dx-resize-frame .dx-resizable-handle-left::after,
.dx-touch-device.dx-resize-frame .dx-resizable-handle-right::after {
  top: calc(50% - 7.5px);
}
.dx-resize-frame .dx-resizable-handle-bottom::after,
.dx-resize-frame .dx-resizable-handle-top::after {
  left: calc(50% - 5.5px);
}
.dx-touch-device.dx-resize-frame .dx-resizable-handle-bottom::after,
.dx-touch-device.dx-resize-frame .dx-resizable-handle-top::after {
  left: calc(50% - 7.5px);
}
.dx-resize-frame .dx-resizable-handle-right::after {
  right: -5.5px;
}
.dx-touch-device.dx-resize-frame .dx-resizable-handle-right::after {
  right: -7.5px;
}
.dx-resize-frame .dx-resizable-handle-left::after {
  left: -5.5px;
}
.dx-touch-device.dx-resize-frame .dx-resizable-handle-left::after {
  left: -7.5px;
}
.dx-resize-frame .dx-resizable-handle-top::after {
  top: -5.5px;
}
.dx-touch-device.dx-resize-frame .dx-resizable-handle-top::after {
  top: -7.5px;
}
.dx-resize-frame .dx-resizable-handle-bottom::after {
  bottom: -5.5px;
}
.dx-touch-device.dx-resize-frame .dx-resizable-handle-bottom::after {
  bottom: -7.5px;
}
.dx-mention {
  padding: 1px 0;
  border-radius: 2px;
}
.dx-mention .dx-template-wrapper {
  white-space: nowrap;
  display: inline-block;
}
.dx-mention > span {
  margin: 0 2px;
}
.dx-table-resize-frame {
  position: absolute;
  pointer-events: none;
}
.dx-table-resize-frame > div {
  position: absolute;
  pointer-events: auto;
  background-color: transparent;
}
.dx-table-resize-frame .dx-htmleditor-column-resizer {
  width: 5px;
  top: 0;
  height: 100%;
  cursor: col-resize;
}
.dx-table-resize-frame .dx-htmleditor-highlighted-column {
  width: 3px;
  top: 0;
  height: 100%;
}
.dx-table-resize-frame .dx-htmleditor-row-resizer {
  height: 5px;
  left: 0;
  width: 100%;
  cursor: row-resize;
}
.dx-table-resize-frame .dx-htmleditor-highlighted-row {
  height: 3px;
  left: 0;
  width: 100%;
}
.dx-htmleditor {
  border-color: transparent;
  position: relative;
}
.dx-htmleditor .dx-htmleditor-toolbar-wrapper {
  padding: 0 16px;
  position: relative;
}
.dx-htmleditor .dx-htmleditor-toolbar-wrapper:first-child {
  border-bottom: 1px solid rgba(0,0,0,.42);
}
.dx-htmleditor.dx-state-readonly .dx-htmleditor-toolbar-wrapper::before {
  position: absolute;
  top: 1px;
  bottom: 1px;
  left: 1px;
  right: 1px;
  z-index: 2;
  background-color: rgba(255,255,255,.4);
  content: "";
  pointer-events: none;
}
.dx-htmleditor.dx-state-readonly .dx-toolbar-button .dx-button.dx-state-disabled {
  opacity: .38;
}
.dx-htmleditor.dx-invalid {
  border: 1px solid rgba(244,67,54,.4);
}
.dx-htmleditor.dx-invalid.dx-state-focused {
  border-color: #f44336;
}
.dx-htmleditor.dx-htmleditor-outlined {
  -webkit-box-shadow: inset 0 0 0 1px rgba(0,0,0,.42);
  box-shadow: inset 0 0 0 1px rgba(0,0,0,.42);
  border-color: transparent;
  border-radius: 4px;
}
.dx-htmleditor.dx-htmleditor-outlined .dx-htmleditor-content {
  margin: 1px 1px 1px 0;
}
.dx-htmleditor.dx-htmleditor-outlined.dx-rtl .dx-htmleditor-content,
.dx-rtl .dx-htmleditor.dx-htmleditor-outlined .dx-htmleditor-content {
  margin-right: 0;
  margin-left: 1px;
}
.dx-htmleditor.dx-htmleditor-outlined .dx-htmleditor-toolbar-wrapper + .dx-quill-container .dx-htmleditor-content {
  margin-top: 0;
}
.dx-htmleditor.dx-htmleditor-outlined.dx-state-disabled,
.dx-htmleditor.dx-htmleditor-outlined.dx-state-readonly,
.dx-htmleditor.dx-htmleditor-outlined.dx-state-readonly.dx-state-hover {
  -webkit-box-shadow: inset 0 0 0 1px rgba(0,0,0,.5);
  box-shadow: inset 0 0 0 1px rgba(0,0,0,.5);
}
.dx-htmleditor.dx-htmleditor-outlined.dx-state-hover {
  -webkit-box-shadow: inset 0 0 0 1px rgba(0,0,0,.87);
  box-shadow: inset 0 0 0 1px rgba(0,0,0,.87);
}
.dx-htmleditor.dx-htmleditor-outlined.dx-state-active,
.dx-htmleditor.dx-htmleditor-outlined.dx-state-focused {
  -webkit-box-shadow: inset 0 0 0 1px #009688;
  box-shadow: inset 0 0 0 1px #009688;
  border-color: #009688;
}
.dx-htmleditor.dx-htmleditor-outlined.dx-invalid {
  border-color: transparent;
  -webkit-box-shadow: inset 0 0 0 1px rgba(244,67,54,.4);
  box-shadow: inset 0 0 0 1px rgba(244,67,54,.4);
}
.dx-htmleditor.dx-htmleditor-outlined.dx-invalid.dx-state-active,
.dx-htmleditor.dx-htmleditor-outlined.dx-invalid.dx-state-focused {
  -webkit-box-shadow: inset 0 0 0 1px #f44336;
  box-shadow: inset 0 0 0 1px #f44336;
  border-color: #f44336;
}
.dx-htmleditor.dx-htmleditor-filled {
  background: rgba(0,0,0,.04);
  border-radius: 4px;
}
.dx-htmleditor.dx-htmleditor-filled.dx-state-hover {
  background-color: rgba(0,0,0,.07);
}
.dx-htmleditor.dx-htmleditor-filled.dx-state-hover:not(.dx-invalid) {
  border-bottom: 1px solid rgba(0,0,0,.87);
}
.dx-htmleditor.dx-htmleditor-filled.dx-state-disabled,
.dx-htmleditor.dx-htmleditor-filled.dx-state-readonly,
.dx-htmleditor.dx-htmleditor-filled.dx-state-readonly.dx-state-hover {
  background-color: rgba(0,0,0,.12);
}
.dx-htmleditor.dx-htmleditor-underlined {
  border-color: transparent transparent rgba(0,0,0,.42);
}
.dx-htmleditor.dx-htmleditor-underlined .dx-htmleditor-content {
  padding-left: 0;
}
.dx-htmleditor.dx-htmleditor-underlined.dx-rtl .dx-htmleditor-content {
  padding-left: 15px;
  padding-right: 0;
}
.dx-htmleditor.dx-htmleditor-underlined.dx-state-hover:not(.dx-state-focused) {
  border-bottom: 2px solid rgba(0,0,0,.87);
}
.dx-htmleditor.dx-htmleditor-underlined.dx-state-disabled,
.dx-htmleditor.dx-htmleditor-underlined.dx-state-readonly,
.dx-htmleditor.dx-htmleditor-underlined.dx-state-readonly.dx-state-hover {
  border-bottom-style: dotted;
  border-bottom-width: 1px;
}
.dx-htmleditor.dx-htmleditor-underlined.dx-invalid {
  border-bottom-color: rgba(244,67,54,.4);
}
.dx-htmleditor.dx-htmleditor-underlined.dx-invalid.dx-state-active,
.dx-htmleditor.dx-htmleditor-underlined.dx-invalid.dx-state-focused {
  border-color: transparent transparent #f44336;
}
.dx-htmleditor.dx-htmleditor-underlined.dx-invalid.dx-state-hover:not(.dx-state-focused) {
  border-bottom-color: rgba(244,67,54,.4);
}
.dx-htmleditor.dx-htmleditor-filled::before,
.dx-htmleditor.dx-htmleditor-underlined::before {
  left: 0;
  right: 0;
  bottom: -1px;
  height: 0;
  width: 100%;
  content: "";
  position: absolute;
  z-index: 2;
  -webkit-transform: scale(0);
  transform: scale(0);
}
.dx-htmleditor.dx-htmleditor-filled.dx-state-active::before,
.dx-htmleditor.dx-htmleditor-filled.dx-state-focused::before,
.dx-htmleditor.dx-htmleditor-underlined.dx-state-active::before,
.dx-htmleditor.dx-htmleditor-underlined.dx-state-focused::before {
  border-bottom: 2px solid #009688;
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: -webkit-transform .6s cubic-bezier(.4, 0, .02, 1);
  transition: transform .6s cubic-bezier(.4, 0, .02, 1);
  transition: transform .6s cubic-bezier(.4, 0, .02, 1),-webkit-transform .6s cubic-bezier(.4, 0, .02, 1);
}
.dx-htmleditor.dx-htmleditor-filled.dx-state-active.dx-invalid::before,
.dx-htmleditor.dx-htmleditor-filled.dx-state-focused.dx-invalid::before,
.dx-htmleditor.dx-htmleditor-underlined.dx-state-active.dx-invalid::before,
.dx-htmleditor.dx-htmleditor-underlined.dx-state-focused.dx-invalid::before {
  border-bottom-color: #f44336;
}
.dx-htmleditor-content blockquote {
  color: rgba(0,0,0,.8);
  border-left-color: #e0e0e0;
}
.dx-rtl .dx-htmleditor-content blockquote {
  border-right-color: #e0e0e0;
}
.dx-htmleditor-content td,
.dx-htmleditor-content th {
  border-color: #e0e0e0;
}
.dx-htmleditor-toolbar {
  background-color: transparent;
}
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-outlined,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-text {
  background-color: rgba(0,0,0,.18);
}
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-outlined.dx-state-focused,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-outlined.dx-state-hover,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-text.dx-state-focused,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-text.dx-state-hover {
  background-color: rgba(0,0,0,.12);
}
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-outlined.dx-button-success,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-text.dx-button-success {
  background-color: rgba(139,195,74,.22);
}
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-outlined.dx-button-success.dx-state-focused,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-outlined.dx-button-success.dx-state-hover,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-text.dx-button-success.dx-state-focused,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-text.dx-button-success.dx-state-hover {
  background-color: rgba(139,195,74,.14);
}
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-outlined.dx-button-default,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-text.dx-button-default {
  background-color: rgba(0,150,136,.22);
}
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-outlined.dx-button-default.dx-state-focused,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-outlined.dx-button-default.dx-state-hover,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-text.dx-button-default.dx-state-focused,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-text.dx-button-default.dx-state-hover {
  background-color: rgba(0,150,136,.14);
}
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-outlined.dx-button-danger,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-text.dx-button-danger {
  background-color: rgba(244,67,54,.22);
}
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-outlined.dx-button-danger.dx-state-focused,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-outlined.dx-button-danger.dx-state-hover,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-text.dx-button-danger.dx-state-focused,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-text.dx-button-danger.dx-state-hover {
  background-color: rgba(244,67,54,.14);
}
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-outlined.dx-button-normal,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-outlined.dx-button-normal .dx-icon,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-text.dx-button-normal,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-text.dx-button-normal .dx-icon {
  color: rgba(0,0,0,.87);
}
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-outlined.dx-button-success,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-outlined.dx-button-success .dx-icon,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-text.dx-button-success,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-text.dx-button-success .dx-icon {
  color: #8bc34a;
}
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-outlined.dx-button-default,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-outlined.dx-button-default .dx-icon,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-text.dx-button-default,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-text.dx-button-default .dx-icon {
  color: #009688;
}
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-outlined.dx-button-danger,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-outlined.dx-button-danger .dx-icon,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-text.dx-button-danger,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-text.dx-button-danger .dx-icon {
  color: #f44336;
}
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-contained {
  background-color: #fff;
}
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-contained.dx-state-focused,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-contained.dx-state-hover {
  background-color: #ebebeb;
}
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-contained.dx-button-success {
  background-color: #8bc34a;
}
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-contained.dx-button-success.dx-state-focused,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-contained.dx-button-success.dx-state-hover {
  background-color: #75a938;
}
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-contained.dx-button-default {
  background-color: #009688;
}
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-contained.dx-button-default.dx-state-focused,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-contained.dx-button-default.dx-state-hover {
  background-color: #006b61;
}
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-contained.dx-button-danger {
  background-color: #f44336;
}
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-contained.dx-button-danger.dx-state-focused,
.dx-htmleditor-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-mode-contained.dx-button-danger.dx-state-hover {
  background-color: #f11d0d;
}
.dx-htmleditor-toolbar-format.dx-dropdowneditor.dx-editor-filled {
  background-color: transparent;
}
.dx-htmleditor-toolbar-format.dx-dropdowneditor.dx-editor-filled::after {
  border-bottom-color: transparent;
}
.dx-htmleditor-toolbar-format.dx-background-format .dx-button-content,
.dx-htmleditor-toolbar-format.dx-color-format .dx-button-content {
  padding-bottom: 3px;
}
.dx-htmleditor-toolbar-format.dx-size-format {
  width: 120px;
}
.dx-htmleditor-toolbar-separator {
  height: 50%;
  border-left-color: #e0e0e0;
}
.dx-toolbar-multiline .dx-htmleditor-toolbar-separator {
  height: 28px;
}
.dx-htmleditor-toolbar-menu-separator {
  border-top-color: #e0e0e0;
}
.dx-resize-frame {
  border-color: #009688;
}
.dx-resize-frame .dx-resizable-handle-bottom::after,
.dx-resize-frame .dx-resizable-handle-corner-bottom-left,
.dx-resize-frame .dx-resizable-handle-corner-bottom-right,
.dx-resize-frame .dx-resizable-handle-corner-top-left,
.dx-resize-frame .dx-resizable-handle-corner-top-right,
.dx-resize-frame .dx-resizable-handle-left::after,
.dx-resize-frame .dx-resizable-handle-right::after,
.dx-resize-frame .dx-resizable-handle-top::after {
  background-color: #009688;
}
.dx-htmleditor-add-image-popup > .dx-overlay-content > .dx-popup-content .dx-collection .dx-field-item:not(.dx-last-col) {
  padding-right: 5px;
}
.dx-htmleditor-add-image-popup > .dx-overlay-content > .dx-popup-content .dx-fix-ratio-container .dx-buttongroup {
  vertical-align: top;
  margin-left: 5px;
  width: 36px;
  margin-top: 6px;
}
.dx-htmleditor-add-image-popup > .dx-overlay-content > .dx-popup-content .dx-collection .dx-field-item:not(.dx-first-col) {
  padding-left: 0;
}
.dx-htmleditor-add-image-popup > .dx-overlay-content > .dx-popup-content .dx-fileuploader-input-wrapper {
  padding: 50px 40px;
  border: 3px dashed #e0e0e0;
}
.dx-htmleditor-add-image-popup > .dx-overlay-content > .dx-popup-content .dx-fileuploader-input-wrapper .dx-fileuploader-input-label {
  border-width: 0;
}
.dx-htmleditor-add-image-popup .dx-fileuploader-dragover .dx-fileuploader-input {
  padding-top: 7px;
  padding-bottom: 8px;
}
.dx-htmleditor-add-image-popup .dx-fileuploader-dragover .dx-fileuploader-content {
  background-color: rgba(224,224,224,.8);
}
.dx-mention {
  background-color: #e0e0e0;
}
.dx-suggestion-list-wrapper {
  height: 100%;
}
.dx-suggestion-list-wrapper.dx-popup-wrapper .dx-overlay-content {
  -webkit-box-shadow: 0 2px 7px rgba(0,0,0,.2);
  box-shadow: 0 2px 7px rgba(0,0,0,.2);
  border-top-width: 0;
  border-bottom-width: 1px;
}
.dx-suggestion-list-wrapper.dx-popup-wrapper .dx-overlay-content.dx-dropdowneditor-overlay-flipped {
  border-top-width: 1px;
  border-bottom-width: 0;
}
.dx-suggestion-list-wrapper .dx-popup-content {
  height: 100%;
  padding: 1px;
}
.dx-suggestion-list-wrapper .dx-list {
  height: 100%;
  min-height: 48px;
}
.dx-suggestion-list-wrapper .dx-list-select-all {
  padding: 16px 0 12px;
}
.dx-suggestion-list-wrapper .dx-empty-message,
.dx-suggestion-list-wrapper .dx-list-item {
  border-top: 0;
}
.dx-suggestion-list-wrapper .dx-empty-message:last-of-type,
.dx-suggestion-list-wrapper .dx-list-item:last-of-type {
  border-bottom: none;
}
.dx-table-resize-frame > .dx-draggable-dragging + .dx-htmleditor-highlighted-column,
.dx-table-resize-frame > .dx-draggable-dragging + .dx-htmleditor-highlighted-row {
  background-color: rgba(0,150,136,.5);
}
.dx-fa-button.dx-fa-button-main .dx-overlay-shader {
  background-color: rgba(0,0,0,.32);
}
.dx-fa-button.dx-fa-button-main .dx-overlay-content {
  min-width: 56px;
  max-height: 56px;
  background-color: #009688;
  color: #fff;
  overflow: visible;
  border-radius: 28px;
  -webkit-box-shadow: 0 2px 6px 0 rgba(0,0,0,.2);
  box-shadow: 0 2px 6px 0 rgba(0,0,0,.2);
}
.dx-fa-button.dx-fa-button-main .dx-overlay-content.dx-state-hover {
  background-color: #00635a;
}
.dx-fa-button.dx-fa-button-main .dx-overlay-content.dx-state-hover .dx-fa-button-icon {
  background-color: transparent;
}
.dx-fa-button.dx-fa-button-main .dx-overlay-content.dx-state-active {
  background-color: #004a43;
}
.dx-fa-button.dx-fa-button-main .dx-overlay-content.dx-state-active .dx-fa-button-icon {
  background-color: transparent;
}
.dx-fa-button.dx-fa-button-main .dx-overlay-content .dx-fa-button-icon,
.dx-fa-button.dx-fa-button-main .dx-overlay-content .dx-fa-button-icon-close {
  padding: 16px;
  -webkit-box-shadow: none;
  box-shadow: none;
  background-color: transparent;
}
.dx-fa-button.dx-fa-button-main .dx-overlay-content .dx-fa-button-label-wrapper {
  position: static;
}
.dx-fa-button.dx-fa-button-main .dx-overlay-content .dx-fa-button-label-wrapper .dx-fa-button-label {
  background: 0 0;
  color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
  border-radius: 0;
  margin-right: 0;
}
.dx-fa-button.dx-fa-button-main .dx-overlay-content .dx-inkripple {
  border-radius: 28px;
}
.dx-fa-button.dx-fa-button-main.dx-fa-button-with-label .dx-overlay-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  -ms-flex-direction: row-reverse;
  flex-direction: row-reverse;
}
.dx-fa-button.dx-fa-button-main.dx-fa-button-with-label .dx-overlay-content .dx-fa-button-icon,
.dx-fa-button.dx-fa-button-main.dx-fa-button-with-label .dx-overlay-content .dx-fa-button-icon-close {
  padding: 16px 0 16px 16px;
}
.dx-fa-button.dx-fa-button-main.dx-fa-button-without-icon .dx-fa-button-icon {
  width: 0;
}
.dx-fa-button .dx-fa-button-icon,
.dx-fa-button .dx-fa-button-icon-close {
  padding: 8px;
  width: 24px;
  height: 24px;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
.dx-fa-button .dx-fa-button-icon .dx-icon,
.dx-fa-button .dx-fa-button-icon-close .dx-icon {
  font-size: 24px;
}
.dx-fa-button .dx-fa-button-icon img,
.dx-fa-button .dx-fa-button-icon-close img {
  width: 100%;
  height: 100%;
}
.dx-fa-button .dx-overlay-content {
  border-radius: 50%;
  cursor: pointer;
  min-width: 40px;
  max-height: 40px;
  background-color: transparent;
  color: rgba(0,0,0,.87);
  overflow: visible;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.dx-fa-button .dx-overlay-content.dx-fa-button-content-reverse {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  -ms-flex-direction: row-reverse;
  flex-direction: row-reverse;
}
.dx-fa-button .dx-overlay-content.dx-fa-button-content-reverse .dx-fa-button-label-wrapper {
  right: auto;
  left: 40px;
}
.dx-fa-button .dx-overlay-content.dx-fa-button-content-reverse .dx-fa-button-label-wrapper .dx-fa-button-label {
  margin-left: 16px;
  margin-right: auto;
}
.dx-fa-button .dx-overlay-content.dx-state-hover .dx-fa-button-icon {
  background-color: #ebebeb;
}
.dx-fa-button .dx-overlay-content.dx-state-active .dx-fa-button-icon {
  background-color: #a3a3a3;
}
.dx-fa-button .dx-overlay-content .dx-fa-button-label-wrapper {
  position: absolute;
  right: 40px;
}
.dx-fa-button .dx-overlay-content .dx-fa-button-label-wrapper .dx-fa-button-label {
  background-color: #fff;
  color: rgba(0,0,0,.87);
  white-space: nowrap;
  border-radius: 4px;
  padding: 4px 8px;
  margin-right: 16px;
  -webkit-box-shadow: 0 2px 6px rgba(0,0,0,.16);
  box-shadow: 0 2px 6px rgba(0,0,0,.16);
  font-size: 14px;
}
.dx-fa-button .dx-overlay-content .dx-fa-button-icon {
  -webkit-box-shadow: 0 2px 6px 0 rgba(0,0,0,.2);
  box-shadow: 0 2px 6px 0 rgba(0,0,0,.2);
  background-color: #fff;
  border-radius: 50%;
  position: relative;
}
.dx-fa-button .dx-overlay-content .dx-inkripple {
  overflow: hidden;
  border-radius: 20px;
}
.dx-fa-button.dx-fa-button-main .dx-overlay-content .dx-fa-button-label {
  padding: 0 24px 0 8px;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1.25px;
  font-weight: 500;
}
.dx-filemanager {
  height: 500px;
  border: 1px solid;
}
.dx-filemanager .dx-filemanager-wrapper {
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.dx-filemanager .dx-filemanager-notification-drawer,
.dx-filemanager .dx-filemanager-notification-drawer-panel {
  height: 100%;
}
.dx-filemanager .dx-filemanager-notification-popup .dx-overlay-content {
  min-width: 240px;
  max-width: 93vw;
}
@media (min-width:431px) {
  .dx-filemanager .dx-filemanager-notification-popup .dx-overlay-content {
    max-width: 400px;
  }
}
.dx-filemanager .dx-filemanager-notification-popup .dx-popup-content {
  padding: 15px;
}
.dx-filemanager .dx-filemanager-notification-popup .dx-popup-content .dx-filemanager-progress-box {
  padding: 5px 0 0;
}
.dx-filemanager .dx-filemanager-notification-popup .dx-filemanager-notification-common {
  padding-bottom: 10px;
  border-bottom-width: 1px;
  border-bottom-style: solid;
}
.dx-filemanager .dx-filemanager-notification-popup .dx-filemanager-notification-common-no-item {
  border-style: none;
}
.dx-filemanager .dx-drawer-shrink .dx-filemanager-progress-panel {
  border-left-width: 1px;
  border-left-style: solid;
}
.dx-filemanager .dx-filemanager-progress-panel {
  width: 340px;
  height: 100%;
}
.dx-filemanager .dx-filemanager-progress-panel .dx-filemanager-progress-panel-container {
  padding: 10px 20px 20px;
}
.dx-filemanager .dx-filemanager-progress-panel .dx-filemanager-progress-panel-title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  padding: 0 0 5px 10px;
}
.dx-filemanager .dx-filemanager-progress-panel .dx-filemanager-progress-panel-title .dx-filemanager-progress-panel-title-text {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  -ms-flex-item-align: center;
  align-self: center;
  font-size: 18px;
  font-weight: 600;
}
.dx-filemanager .dx-filemanager-progress-panel .dx-filemanager-progress-panel-common .dx-filemanager-progress-box-common {
  font-weight: 600;
}
.dx-filemanager .dx-filemanager-progress-panel .dx-filemanager-progress-panel-separator {
  height: 20px;
}
.dx-filemanager .dx-filemanager-progress-panel .dx-filemanager-i.dx-filemanager-i-cancel {
  width: 16px;
  height: 16px;
}
.dx-filemanager .dx-filemanager-progress-panel .dx-filemanager-progress-panel-details > .dx-filemanager-progress-box {
  margin-bottom: 8px;
  border-radius: 2px;
}
.dx-filemanager .dx-filemanager-progress-box {
  padding: 10px 0 10px 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.dx-filemanager .dx-filemanager-progress-box.dx-filemanager-progress-box-without-close-button {
  padding-right: 10px;
}
.dx-filemanager .dx-filemanager-progress-box .dx-filemanager-progress-box-image {
  margin-right: 10px;
}
.dx-filemanager .dx-filemanager-progress-box .dx-filemanager-progress-box-wrapper {
  -webkit-box-flex: 1;
  -ms-flex: 1 auto;
  flex: 1 auto;
  overflow: hidden;
}
.dx-filemanager .dx-filemanager-progress-box .dx-filemanager-progress-box-common {
  padding: 5px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dx-filemanager .dx-filemanager-progress-box .dx-filemanager-progress-box-progress-bar,
.dx-filemanager .dx-filemanager-progress-box .dx-filemanager-progress-box-status {
  padding: 5px 0;
}
.dx-filemanager .dx-filemanager-progress-box .dx-filemanager-progress-box-close-button {
  margin-left: 5px;
}
.dx-filemanager .dx-filemanager-progress-box-error {
  border-radius: 2px;
  display: inline-block;
  border-width: 0;
  padding: 2px 8px 3px;
  font-size: .85em;
  line-height: normal;
  word-wrap: break-word;
  overflow-y: auto;
  max-height: 150px;
}
.dx-filemanager .dx-filemanager-toolbar .dx-filemanager-toolbar-separator-item {
  width: 1px;
  margin-right: 5px;
}
.dx-filemanager .dx-splitter-wrapper.dx-splitter-inactive,
.dx-filemanager .dx-splitter-wrapper.dx-splitter-initial {
  right: 3px;
}
.dx-filemanager .dx-filemanager-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 100%;
  border-top: 1px solid;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
}
.dx-filemanager .dx-filemanager-container .dx-filemanager-adaptivity-drawer-panel {
  height: 100%;
}
.dx-filemanager .dx-filemanager-container .dx-filemanager-dirs-panel {
  padding: 5px 10px;
  height: 100%;
  width: 100%;
  display: block;
}
.dx-filemanager .dx-filemanager-container .dx-drawer-opened .dx-splitter.dx-state-disabled {
  width: 1px;
}
.dx-filemanager .dx-filemanager-container .dx-drawer-shrink .dx-drawer-panel-content {
  overflow: visible;
}
.dx-filemanager .dx-filemanager-container .dx-drawer-panel-content {
  display: block;
  width: 30%;
}
.dx-filemanager .dx-filemanager-container .dx-drawer-panel-content.dx-drawer-panel-content-initial {
  min-width: 250px;
  max-width: 300px;
}
.dx-filemanager .dx-filemanager-container .dx-drawer-panel-content.dx-drawer-panel-content-adaptive {
  max-width: 100%;
}
.dx-filemanager .dx-filemanager-dirs-panel {
  height: 100%;
}
.dx-filemanager .dx-filemanager-breadcrumbs {
  padding: 2px 11px;
  border-bottom: 1px solid;
}
.dx-filemanager .dx-filemanager-breadcrumbs .dx-menu-item-content {
  padding-left: 0;
  padding-right: 0;
}
.dx-filemanager .dx-filemanager-breadcrumbs .dx-filemanager-breadcrumbs-parent-folder-item .dx-menu-item-content {
  padding-left: 2px;
  padding-right: 2px;
}
.dx-filemanager .dx-filemanager-breadcrumbs .dx-filemanager-breadcrumbs-separator-item .dx-menu-item-content {
  width: 1px;
  padding-left: 0;
  padding-right: 0;
  margin: 0 10px;
}
.dx-filemanager .dx-filemanager-breadcrumbs .dx-filemanager-breadcrumbs-path-separator-item .dx-menu-item-content {
  padding-left: 1px;
  padding-right: 1px;
}
.dx-filemanager .dx-filemanager-breadcrumbs .dx-filemanager-breadcrumbs-path-separator-item.dx-state-hover,
.dx-filemanager .dx-filemanager-breadcrumbs .dx-filemanager-breadcrumbs-separator-item.dx-state-hover {
  cursor: default;
}
.dx-filemanager .dx-filemanager-editing-container,
.dx-filemanager .dx-filemanager-notification-container {
  position: absolute;
  top: -5000px;
  left: -5000px;
}
.dx-filemanager .dx-row .dx-filemanager-file-actions-button {
  float: right;
}
.dx-filemanager .dx-row .dx-filemanager-file-actions-button .dx-button-content {
  padding: 0;
}
.dx-filemanager .dx-row.dx-row-focused .dx-filemanager-file-actions-button,
.dx-filemanager .dx-row.dx-selection .dx-filemanager-file-actions-button,
.dx-filemanager .dx-row.dx-state-hover .dx-filemanager-file-actions-button {
  visibility: visible;
}
.dx-filemanager .dx-filemanager-items-panel {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.dx-filemanager .dx-filemanager-fileuploader-dropzone-placeholder {
  position: relative;
  top: 0;
  left: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  pointer-events: none;
  z-index: 1000;
}
.dx-filemanager .dx-filemanager-thumbnails {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.dx-filemanager .dx-filemanager-thumbnails .dx-filemanager-thumbnails-view-port {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 5px;
}
.dx-filemanager .dx-filemanager-thumbnails .dx-filemanager-thumbnails-view-port .dx-filemanager-thumbnails-container {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.dx-filemanager .dx-filemanager-thumbnails .dx-filemanager-thumbnails-view-port .dx-filemanager-thumbnails-item {
  float: left;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  width: 100px;
  height: 100px;
  border: 1px dashed transparent;
  margin: 5px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.dx-filemanager .dx-filemanager-thumbnails .dx-filemanager-thumbnails-view-port .dx-filemanager-thumbnails-item .dx-filemanager-thumbnails-item-content {
  overflow: hidden;
  padding: 13px 0 10px;
}
.dx-filemanager .dx-filemanager-thumbnails .dx-filemanager-thumbnails-view-port .dx-filemanager-thumbnails-item .dx-filemanager-thumbnails-item-content .dx-filemanager-thumbnails-item-thumbnail {
  border: 0;
}
.dx-filemanager .dx-filemanager-thumbnails .dx-filemanager-thumbnails-view-port .dx-filemanager-thumbnails-item .dx-filemanager-thumbnails-item-content .dx-filemanager-thumbnails-item-spacer {
  border: 0;
  padding: 0;
  margin: 0;
  height: 10px;
  visibility: hidden;
}
.dx-filemanager .dx-filemanager-thumbnails .dx-filemanager-thumbnails-view-port .dx-filemanager-thumbnails-item .dx-filemanager-thumbnails-item-content .dx-filemanager-thumbnails-item-name {
  overflow: hidden;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.dx-filemanager .dx-filemanager-details {
  height: 100%;
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.dx-filemanager .dx-filemanager-details > div {
  height: 100%;
}
.dx-filemanager .dx-filemanager-details .dx-datagrid-rowsview .dx-datagrid-table > tbody > tr.dx-filemanager-parent-directory-item > td > .dx-select-checkbox {
  display: none;
}
.dx-filemanager .dx-filemanager-details .dx-filemanager-details-item-name-wrapper {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  width: 100%;
}
.dx-filemanager .dx-filemanager-details .dx-filemanager-details-item-name-wrapper .dx-filemanager-details-item-name {
  -webkit-box-flex: 1;
  -ms-flex: 1 auto;
  flex: 1 auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dx-filemanager .dx-filemanager-i.dx-filemanager-i-progress,
.dx-filemanager .dx-filemanager-i.dx-icon.dx-filemanager-i-progress {
  -webkit-animation: 1.5s linear infinite dx-filemanager-icon-rotate;
  animation: 1.5s linear infinite dx-filemanager-icon-rotate;
}
@-webkit-keyframes dx-filemanager-icon-rotate {
  from {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes dx-filemanager-icon-rotate {
  from {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.dx-filemanager-file-actions-button {
  visibility: hidden;
  text-align: center;
}
.dx-filemanager-file-actions-button.dx-widget {
  line-height: 100%;
}
.dx-filemanager-file-actions-button .dx-button {
  border: none;
  background-color: transparent;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-filemanager-file-actions-button .dx-button i {
  font-style: normal;
}
.dx-filemanager-file-actions-button.dx-filemanager-file-actions-button-activated,
.dx-filemanager-file-actions-button:hover {
  visibility: visible;
}
.dx-filemanager-dirs-tree {
  width: 100%;
}
.dx-filemanager-dirs-tree .dx-treeview-item-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: end;
  -ms-flex-align: end;
  align-items: flex-end;
}
.dx-filemanager-dirs-tree .dx-treeview-item-content > .dx-icon {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
}
.dx-filemanager-dirs-tree .dx-treeview-item-content .dx-filemanager-dirs-tree-item-text {
  -webkit-box-flex: 1;
  -ms-flex: 1 auto;
  flex: 1 auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dx-filemanager-dirs-tree .dx-filemanager-focused-item .dx-filemanager-file-actions-button,
.dx-filemanager-dirs-tree .dx-treeview-item.dx-state-hover .dx-filemanager-file-actions-button {
  visibility: visible;
}
.dx-filemanager-dialog.dx-filemanager-dialog-folder-chooser,
.dx-filemanager-progresspanel {
  height: 100%;
  overflow: auto;
}
.dx-filemanager-dialog-folder-chooser > div {
  height: 100%;
}
.dx-filemanager-dialog-popup > .dx-overlay-content {
  min-width: 300px;
  max-width: 400px;
  min-height: 300px;
  max-height: 400px;
}
.dx-filemanager-dialog-name-editor-popup > .dx-overlay-content {
  max-width: 340px;
  min-height: 180px;
  max-height: 180px;
}
.dx-filemanager-dialog-delete-item-popup > .dx-overlay-content {
  max-width: 340px;
  min-height: 180px;
}
.dx-filemanager-dialog-delete-item-popup > .dx-overlay-content .dx-popup-content .dx-filemanager-dialog-delete-item {
  overflow-wrap: break-word;
}
.dx-filemanager-progresspanel {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 5px;
}
.dx-filemanager-progresspanel .dx-filemanager-progressbox {
  float: left;
  width: 100%;
  padding-bottom: 10px;
}
.dx-filemanager-progresspanel .dx-filemanager-progressbox-cancel-button {
  margin-top: 5px;
  float: right;
}
.dx-splitter-wrapper {
  height: 100%;
  width: 0;
  position: absolute;
  z-index: 998;
  top: 0;
}
.dx-splitter-wrapper .dx-splitter-border {
  z-index: 997;
  height: 100%;
  width: 7px;
  cursor: col-resize;
}
.dx-splitter-wrapper .dx-splitter-border .dx-splitter {
  height: 100%;
  width: 1px;
  display: block;
  cursor: col-resize;
  z-index: 999;
  margin: auto;
}
.dx-splitter-wrapper .dx-splitter-border .dx-splitter.dx-splitter-inactive {
  z-index: 998;
}
.dx-splitter-wrapper .dx-splitter-border .dx-splitter.dx-state-disabled {
  width: 0;
  cursor: default;
}
.dx-splitter {
  background-color: rgba(0,150,136,.5);
}
.dx-splitter.dx-splitter-inactive {
  background-color: #e0e0e0;
}
.dx-splitter-border {
  background-color: transparent;
}
.dx-filemanager {
  border-color: #e0e0e0;
}
.dx-filemanager .dx-filemanager-notification-common {
  border-color: #e0e0e0;
  color: #f44336;
}
.dx-filemanager .dx-drawer-shrink .dx-filemanager-progress-panel {
  border-left-color: #e0e0e0;
}
.dx-filemanager .dx-filemanager-progress-panel {
  background-color: #fff;
}
.dx-filemanager .dx-filemanager-progress-panel .dx-filemanager-progress-panel-title {
  padding-top: 16px;
  padding-bottom: 16px;
}
.dx-filemanager .dx-filemanager-progress-box-image {
  width: 48px;
  height: 48px;
  font-size: 48px;
}
.dx-filemanager .dx-filemanager-progress-box-error {
  color: #fff;
  background: #f44336;
}
.dx-filemanager .dx-filemanager-progress-box .dx-filemanager-progress-box-close-button {
  margin-top: 6px;
}
.dx-filemanager .dx-filemanager-toolbar {
  padding: 0 10px;
  background: #fff;
  min-height: 56px;
}
.dx-filemanager .dx-filemanager-toolbar.dx-filemanager-file-toolbar,
.dx-filemanager .dx-filemanager-toolbar.dx-filemanager-file-toolbar .dx-toolbar {
  background: #f7f7f7;
}
.dx-filemanager .dx-filemanager-toolbar .dx-filemanager-toolbar-separator-item {
  height: 36px;
  background: #e0e0e0;
}
.dx-filemanager .dx-filemanager-toolbar .dx-filemanager-toolbar-viewmode-item .dx-texteditor {
  width: 190px;
}
.dx-filemanager .dx-filemanager-toolbar .dx-texteditor.dx-editor-filled {
  background: 0 0;
}
.dx-filemanager .dx-filemanager-toolbar .dx-texteditor.dx-editor-filled.dx-state-active,
.dx-filemanager .dx-filemanager-toolbar .dx-texteditor.dx-editor-filled.dx-state-focused,
.dx-filemanager .dx-filemanager-toolbar .dx-texteditor.dx-editor-filled.dx-state-hover {
  background: rgba(0,0,0,.1);
}
.dx-filemanager .dx-filemanager-toolbar .dx-texteditor.dx-editor-filled.dx-dropdowneditor {
  border-color: transparent;
}
.dx-filemanager .dx-filemanager-toolbar .dx-texteditor.dx-editor-filled.dx-dropdowneditor .dx-dropdowneditor-icon {
  background: 0 0;
}
.dx-filemanager .dx-filemanager-toolbar .dx-texteditor.dx-editor-filled.dx-dropdowneditor.dx-state-active .dx-dropdowneditor-icon,
.dx-filemanager .dx-filemanager-toolbar .dx-texteditor.dx-editor-filled.dx-dropdowneditor.dx-state-hover .dx-dropdowneditor-icon {
  background: 0 0;
  border-color: transparent;
}
.dx-filemanager .dx-filemanager-toolbar .dx-toolbar .dx-filemanager-toolbar-viewmode-item .dx-button-content {
  padding-left: 6px;
  padding-right: 6px;
}
.dx-filemanager .dx-filemanager-fileuploader-dropzone-placeholder {
  border: 2px solid #009688;
}
.dx-filemanager .dx-filemanager-container {
  border-top-color: #e0e0e0;
}
.dx-filemanager .dx-filemanager-dirs-panel {
  border-right-color: #e0e0e0;
}
.dx-filemanager .dx-filemanager-breadcrumbs {
  border-bottom-color: #e0e0e0;
}
.dx-filemanager .dx-filemanager-breadcrumbs .dx-menu-item.dx-state-focused {
  background: #e0e0e0;
  color: rgba(0,0,0,.87);
}
.dx-filemanager .dx-filemanager-breadcrumbs .dx-menu-item-content {
  padding-top: 7px;
  padding-bottom: 8px;
}
.dx-filemanager .dx-filemanager-breadcrumbs .dx-filemanager-breadcrumbs-separator-item .dx-menu-item-content {
  background: #e0e0e0;
}
.dx-filemanager .dx-filemanager-breadcrumbs .dx-filemanager-breadcrumbs-path-separator-item.dx-state-hover,
.dx-filemanager .dx-filemanager-breadcrumbs .dx-filemanager-breadcrumbs-separator-item.dx-state-hover {
  background: 0 0;
}
.dx-filemanager .dx-filemanager-thumbnails .dx-filemanager-thumbnails-item.dx-item-selected {
  color: #fff;
  background: rgba(0,150,136,.8);
}
.dx-filemanager .dx-filemanager-thumbnails .dx-filemanager-thumbnails-item.dx-state-hover:not(.dx-state-focused):not(.dx-item-selected) {
  background: rgba(0,0,0,.04);
}
.dx-filemanager .dx-filemanager-thumbnails .dx-filemanager-thumbnails-item.dx-state-focused {
  border: 1px solid #009688;
}
.dx-filemanager .dx-filemanager-thumbnails .dx-filemanager-thumbnails-item.dx-item-selected.dx-state-focused {
  color: #fff;
  background: rgba(0,150,136,.7);
}
.dx-filemanager .dx-filemanager-thumbnails .dx-filemanager-thumbnails-item .dx-filemanager-thumbnails-item-thumbnail {
  width: 48px;
  height: 48px;
  font-size: 48px;
}
.dx-filemanager .dx-filemanager-thumbnails .dx-filemanager-thumbnails-item .dx-filemanager-item-custom-thumbnail {
  color: #e0e0e0;
}
.dx-filemanager .dx-filemanager-files-view {
  background: #fff;
}
.dx-filemanager .dx-filemanager-files-view.dx-filemanager-details .dx-filemanager-details-item-thumbnail {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.dx-filemanager .dx-filemanager-files-view.dx-filemanager-details .dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-command-select {
  padding: 0;
  width: 49px;
  min-width: 49px;
  max-width: 49px;
}
.dx-filemanager .dx-filemanager-files-view.dx-filemanager-details .dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-filemanager-details-item-is-directory {
  padding-right: 0!important;
  padding-left: 0!important;
}
.dx-filemanager .dx-filemanager-files-view.dx-filemanager-details .dx-row-focused .dx-filemanager-file-actions-button .dx-button .dx-icon {
  color: #fff;
}
.dx-filemanager .dx-filemanager-details .dx-filemanager-details-item-name-wrapper {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.dx-filemanager-dirs-tree.dx-treeview .dx-treeview-item {
  padding-top: 11px;
  padding-bottom: 11px;
}
.dx-filemanager-dirs-tree.dx-treeview .dx-state-focused > .dx-treeview-item {
  background: 0 0;
}
.dx-filemanager-dirs-tree.dx-treeview .dx-state-focused > .dx-treeview-item.dx-state-hover {
  background: #ebebeb;
}
.dx-filemanager-dirs-tree.dx-treeview .dx-state-focused > .dx-treeview-item * {
  color: rgba(0,0,0,.87);
}
.dx-filemanager-dirs-tree.dx-treeview .dx-treeview-item-without-checkbox > .dx-treeview-item.dx-filemanager-focused-item {
  background: #ebebeb;
}
.dx-filemanager-dirs-tree.dx-treeview .dx-treeview-item-without-checkbox > .dx-treeview-item.dx-filemanager-focused-item * {
  color: rgba(0,0,0,.87);
}
.dx-filemanager-view-switcher-popup {
  width: 36px;
}
.dx-filemanager-view-switcher-popup .dx-dropdownbutton-popup-wrapper.dx-dropdownbutton-popup-wrapper .dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item-content {
  padding-left: 5px;
  padding-right: 6px;
  text-overflow: clip;
}
.dx-filemanager-dirs-tree.dx-treeview .dx-filemanager-file-actions-button .dx-button .dx-button-content {
  padding: 0;
}
.dx-filemanager-file-actions-button .dx-button {
  min-width: 28px;
  height: 28px;
}
.dx-filemanager-file-actions-button .dx-button .dx-button-content {
  padding: 2px 6px;
}
.dx-filemanager-context-menu .dx-menu-item-has-text:not(.dx-menu-item-has-icon) .dx-menu-item-text {
  margin-left: 48px;
}
.dx-filemanager-i.dx-filemanager-i-progress,
.dx-filemanager-i.dx-filemanager-i-refresh,
.dx-filemanager-i.dx-icon.dx-filemanager-i-progress,
.dx-filemanager-i.dx-icon.dx-filemanager-i-refresh {
  background: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x30_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2022%2022%22%20style%3D%22enable-background%3Anew%200%200%2022%2022%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3Argba%280,%200,%200,%200.87%29%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%20id%3D%22_x31_%22%3E%0A%09%3Cpath%20id%3D%22_x33_%22%20class%3D%22st0%22%20d%3D%22M11%2C4c2.45%2C0%2C4.59%2C1.26%2C5.84%2C3.16L15%2C9l6%2C1l-1-6l-1.73%2C1.73C16.64%2C3.47%2C14%2C2%2C11%2C2%0A%09%09c-4.97%2C0-9%2C4.03-9%2C9h2C4%2C7.13%2C7.13%2C4%2C11%2C4z%22%2F%3E%0A%09%3Cpath%20id%3D%22_x32_%22%20class%3D%22st0%22%20d%3D%22M17.92%2C12c-0.49%2C3.39-3.39%2C6-6.92%2C6c-2.19%2C0-4.13-1.01-5.41-2.59L7%2C14l-6-1l1%2C6l2.17-2.17%0A%09%09C5.82%2C18.76%2C8.26%2C20%2C11%2C20c4.63%2C0%2C8.44-3.5%2C8.94-8H17.92z%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A");
  width: 22px;
  height: 22px;
}
.dx-filemanager-i.dx-filemanager-i-done,
.dx-filemanager-i.dx-icon.dx-filemanager-i-done {
  background: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x30_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2022%2022%22%20style%3D%22enable-background%3Anew%200%200%2022%2022%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3Bfill%3Argba%280,%200,%200,%200.87%29%3B%7D%0A%09.st1%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3Bfill%3A%238bc34a%3B%7D%0A%09.st2%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3Bfill%3A%23fff%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x33_%22%20class%3D%22st0%22%20d%3D%22M21%2C10l-6-1l1.87-1.87C15.6%2C5.24%2C13.44%2C4%2C11%2C4c-3.87%2C0-7%2C3.13-7%2C7H2c0-4.97%2C4.03-9%2C9-9%0A%09c3.02%2C0%2C5.7%2C1.42%2C7.35%2C3.65L20%2C4L21%2C10z%20M5.6%2C15.4C6.88%2C16.98%2C8.81%2C18%2C11%2C18c0.4%2C0%2C0.78-0.05%2C1.15-0.12%0A%09c0.15%2C0.69%2C0.42%2C1.32%2C0.77%2C1.91C12.3%2C19.92%2C11.66%2C20%2C11%2C20c-2.74%2C0-5.17-1.24-6.82-3.18L2%2C19l-1-6l6%2C1L5.6%2C15.4z%22%2F%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st1%22%20d%3D%22M17.5%2C12c2.49%2C0%2C4.5%2C2.01%2C4.5%2C4.5S19.99%2C21%2C17.5%2C21S13%2C18.99%2C13%2C16.5S15.01%2C12%2C17.5%2C12z%22%2F%3E%0A%3Cpath%20id%3D%22_x31_%22%20class%3D%22st2%22%20d%3D%22M21.35%2C14.35l-4.71%2C5l-3-3l0.71-0.71l2.15%2C2.15l4.15-4.15L21.35%2C14.35z%22%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 22px;
  height: 22px;
}
.dx-filemanager-i.dx-filemanager-i-danger,
.dx-filemanager-i.dx-icon.dx-filemanager-i-danger {
  background: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x30_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2022%2022%22%20style%3D%22enable-background%3Anew%200%200%2022%2022%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3Bfill%3Argba%280,%200,%200,%200.87%29%3B%7D%0A%09.st1%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3Bfill%3A%23f44336%3B%7D%0A%09.st2%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3Bfill%3A%23fff%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x33_%22%20class%3D%22st0%22%20d%3D%22M21%2C10l-6-1l1.87-1.87C15.6%2C5.24%2C13.44%2C4%2C11%2C4c-3.87%2C0-7%2C3.13-7%2C7H2c0-4.97%2C4.03-9%2C9-9%0A%09c3.02%2C0%2C5.7%2C1.42%2C7.35%2C3.65L20%2C4L21%2C10z%20M5.6%2C15.4C6.88%2C16.98%2C8.81%2C18%2C11%2C18c0.4%2C0%2C0.78-0.05%2C1.15-0.12%0A%09c0.15%2C0.69%2C0.42%2C1.32%2C0.77%2C1.91C12.3%2C19.92%2C11.66%2C20%2C11%2C20c-2.74%2C0-5.17-1.24-6.82-3.18L2%2C19l-1-6l6%2C1L5.6%2C15.4z%22%2F%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st1%22%20d%3D%22M17.5%2C12c2.49%2C0%2C4.5%2C2.01%2C4.5%2C4.5S19.99%2C21%2C17.5%2C21S13%2C18.99%2C13%2C16.5S15.01%2C12%2C17.5%2C12z%22%2F%3E%0A%3Cpath%20id%3D%22_x31_%22%20class%3D%22st2%22%20d%3D%22M17%2C20v-1h1v1H17z%20M17%2C13h1v5h-1V13z%22%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 22px;
  height: 22px;
}
.dx-filemanager-i.dx-filemanager-i-cancel,
.dx-filemanager-i.dx-icon.dx-filemanager-i-cancel {
  background: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2016%2016%22%20style%3D%22enable-background%3Anew%200%200%2016%2016%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cpath%20id%3D%22_x32_%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20d%3D%22M8%2C0c4.42%2C0%2C8%2C3.58%2C8%2C8s-3.58%2C8-8%2C8c-4.42%2C0-8-3.58-8-8S3.58%2C0%2C8%2C0%20M10.87%2C4L8%2C6.87L5.13%2C4L4%2C5.13L6.87%2C8%0A%09L4%2C10.87L5.13%2C12L8%2C9.13L10.87%2C12L12%2C10.87L9.13%2C8L12%2C5.13L10.87%2C4z%22%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 22px;
  height: 22px;
}
.dx-diagram {
  border: 1px solid transparent;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column;
  flex-flow: column;
  height: 600px;
  min-height: 350px;
}
.dx-diagram .dx-diagram-toolbar-wrapper {
  padding: 5px;
  -webkit-box-flex: 0;
  -ms-flex-positive: 0;
  flex-grow: 0;
}
.dx-diagram .dx-diagram-toolbar-wrapper .dx-diagram-toolbar {
  background-color: transparent;
}
.dx-diagram .dx-diagram-content-wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  overflow: hidden;
}
.dx-diagram .dx-diagram-content,
.dx-diagram .dx-diagram-scroll-view {
  height: 100%;
  width: 100%;
}
.dx-diagram.dx-diagram-fullscreen {
  left: 0;
  top: 0;
  width: 100%!important;
  height: 100%!important;
  position: fixed;
  z-index: 2;
}
.dx-diagram .dxdi-control {
  width: auto;
  height: auto;
  overflow: visible;
}
.dx-diagram .dxdi-canvas {
  overflow: hidden;
}
.dx-diagram-toolbox-popup.dx-popup-wrapper .dx-overlay-content {
  border-radius: 0;
}
.dx-diagram-toolbox-popup .dx-popup-title.dx-toolbar {
  padding: 0;
  background-color: rgba(0,0,0,.05);
}
.dx-diagram-toolbox-popup .dx-popup-title .dx-button-content,
.dx-diagram-toolbox-popup .dx-popup-title .dx-button.dx-button-has-icon:not(.dx-button-has-text) {
  background-color: transparent;
  border: 0;
  border-radius: 0;
  padding: 0;
  min-width: 0;
}
.dx-diagram-toolbox-popup .dx-popup-title .dx-button:not(.dx-closebutton) {
  cursor: inherit;
  pointer-events: none;
}
.dx-diagram-toolbox-popup .dx-popup-content {
  padding: 0;
}
.dx-diagram-toolbox-popup .dx-popup-content .dx-diagram-toolbox-input {
  border-color: transparent;
}
.dx-diagram-toolbox-popup .dx-popup-content .dx-diagram-toolbox-input .dx-placeholder::before,
.dx-diagram-toolbox-popup .dx-popup-content .dx-diagram-toolbox-input input {
  min-height: 0;
  font-size: .9em;
}
.dx-diagram-toolbox-popup .dx-popup-content .dx-diagram-toolbox-input .dx-button {
  border: 0;
  border-radius: 0;
  min-height: 14px;
}
.dx-diagram-toolbox-popup .dx-popup-content .dx-diagram-toolbox-panel {
  position: relative;
  height: 100%;
  overflow-y: auto;
}
.dx-diagram-toolbox-popup .dx-popup-content .dx-diagram-toolbox-panel > * {
  position: absolute;
}
.dx-diagram-properties-popup .dx-scrollview,
.dx-diagram-toolbox-popup .dx-popup-content .dx-diagram-toolbox-panel>.dx-scrollview {
  width: 100%;
}
.dx-diagram-properties-popup .dx-popup-content {
  padding: 0;
}
.dx-diagram-properties-popup .dx-tabs {
  border: 0;
}
.dx-diagram-properties-popup .dx-tabpanel .dx-multiview-wrapper {
  border-left: 0;
  border-right: 0;
}
.dx-diagram-properties-popup .dx-diagram-properties-panel-group-toolbar .dx-toolbar-items-container {
  display: block;
  height: auto;
}
.dx-diagram-properties-popup .dx-diagram-properties-panel-group-toolbar .dx-toolbar-items-container > div {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  position: inherit;
}
.dx-diagram-properties-popup .dx-diagram-properties-panel-group-toolbar .dx-toolbar-items-container .dx-toolbar-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.dx-diagram-properties-popup:not(.dx-diagram-mobile-popup) .dx-tabpanel .dx-multiview-wrapper {
  border-bottom: 0;
}
.dx-diagram-properties-popup.dx-diagram-mobile-popup {
  width: calc(100% - 2px)!important;
}
.dx-diagram-properties-popup.dx-diagram-mobile-popup .dx-popup-title {
  border: 0;
  min-height: 0;
  position: relative;
  z-index: 1;
}
.dx-diagram-properties-popup.dx-diagram-mobile-popup .dx-toolbar .dx-toolbar-items-container {
  height: auto;
}
.dx-diagram-properties-popup.dx-diagram-mobile-popup .dx-toolbar .dx-toolbar-items-container .dx-toolbar-item {
  padding-top: 0;
  padding-bottom: 0;
}
.dx-diagram-properties-popup.dx-diagram-mobile-popup .dx-tabpanel {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: reverse;
  -ms-flex-direction: column-reverse;
  flex-direction: column-reverse;
}
.dx-diagram-properties-popup.dx-diagram-mobile-popup .dx-tabpanel .dx-multiview-wrapper {
  border-top: 0;
}
.dx-diagram-floating-toolbar-container {
  position: absolute;
  z-index: 1001;
  width: 100%;
  -webkit-transition: opacity .4s;
  transition: opacity .4s;
}
.dx-diagram-floating-toolbar-container.dx-diagram-properties-panel-toolbar-container {
  background: 0 0;
  border-radius: 50%;
  border: 0;
  padding: 0;
}
.dx-diagram-floating-toolbar-container.dx-diagram-properties-panel-toolbar-container .dx-toolbar {
  background: 0 0;
}
.dx-diagram-floating-toolbar-container.dx-diagram-properties-panel-toolbar-container div {
  border-radius: 50%;
}
.dx-diagram-floating-toolbar-container .dx-diagram-toolbar .dx-toolbar-items-container > * {
  padding-left: 0;
  padding-right: 0;
}
.dx-diagram-toolbar .dx-diagram-toolbar-separator {
  display: table;
  border-left: 1px solid transparent;
}
.dx-diagram-toolbar .dx-diagram-toolbar-menu-separator {
  width: 100%;
  border-top: 1px solid transparent;
}
.dx-diagram-toolbar .dx-diagram-toolbar-menu-separator::before {
  content: none;
}
.dx-diagram-toolbar .dx-diagram-color-edit-item .dx-texteditor,
.dx-diagram-toolbar .dx-diagram-image-dropdown-item .dx-texteditor,
.dx-dropdownmenu-popup .dx-diagram-color-edit-item .dx-texteditor,
.dx-dropdownmenu-popup .dx-diagram-image-dropdown-item .dx-texteditor {
  width: auto;
}
.dx-diagram-toolbar .dx-diagram-color-edit-item .dx-dropdowneditor-field-template-wrapper,
.dx-diagram-toolbar .dx-diagram-image-dropdown-item .dx-dropdowneditor-field-template-wrapper,
.dx-dropdownmenu-popup .dx-diagram-color-edit-item .dx-dropdowneditor-field-template-wrapper,
.dx-dropdownmenu-popup .dx-diagram-image-dropdown-item .dx-dropdowneditor-field-template-wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.dx-diagram-toolbar .dx-diagram-color-edit-item .dx-dropdowneditor-field-template-wrapper .dx-diagram-i,
.dx-diagram-toolbar .dx-diagram-image-dropdown-item .dx-dropdowneditor-field-template-wrapper .dx-diagram-i,
.dx-dropdownmenu-popup .dx-diagram-color-edit-item .dx-dropdowneditor-field-template-wrapper .dx-diagram-i,
.dx-dropdownmenu-popup .dx-diagram-image-dropdown-item .dx-dropdowneditor-field-template-wrapper .dx-diagram-i {
  display: block;
}
.dx-diagram-toolbar .dx-diagram-color-edit-item .dx-dropdowneditor-field-template-wrapper .dx-textbox,
.dx-diagram-toolbar .dx-diagram-image-dropdown-item .dx-dropdowneditor-field-template-wrapper .dx-textbox,
.dx-dropdownmenu-popup .dx-diagram-color-edit-item .dx-dropdowneditor-field-template-wrapper .dx-textbox,
.dx-dropdownmenu-popup .dx-diagram-image-dropdown-item .dx-dropdowneditor-field-template-wrapper .dx-textbox {
  width: 0;
  max-width: 0;
}
.dx-diagram-toolbar .dx-diagram-color-edit-item .dx-dropdowneditor-field-template-wrapper .dx-textbox .dx-texteditor-input,
.dx-diagram-toolbar .dx-diagram-image-dropdown-item .dx-dropdowneditor-field-template-wrapper .dx-textbox .dx-texteditor-input,
.dx-dropdownmenu-popup .dx-diagram-color-edit-item .dx-dropdowneditor-field-template-wrapper .dx-textbox .dx-texteditor-input,
.dx-dropdownmenu-popup .dx-diagram-image-dropdown-item .dx-dropdowneditor-field-template-wrapper .dx-textbox .dx-texteditor-input {
  width: 0;
  padding-left: 0;
}
.dx-diagram-mobile-toolbar-color-box-opened .dx-dropdowneditor-overlay {
  -webkit-transform: none!important;
  transform: none!important;
  width: 100%!important;
  height: 100%!important;
}
.dx-diagram-mobile-toolbar-color-box-opened .dx-dropdowneditor-overlay .dx-overlay-content {
  -webkit-transform: none!important;
  transform: none!important;
  width: 100%!important;
  top: initial!important;
  bottom: 0!important;
}
.dx-diagram-mobile-toolbar-color-box-opened .dx-dropdowneditor-overlay .dx-overlay-content .dx-popup-content {
  padding: 8px;
}
.dx-diagram-mobile-toolbar-color-box-opened .dx-dropdowneditor-overlay .dx-overlay-content .dx-colorview-container {
  width: 100%;
}
.dx-diagram-mobile-toolbar-color-box-opened .dx-dropdowneditor-overlay .dx-overlay-content .dx-colorview-container .dx-colorview-container-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.dx-diagram-mobile-toolbar-color-box-opened .dx-dropdowneditor-overlay .dx-overlay-content .dx-colorview-container .dx-colorview-container-row .dx-colorview-palette-cell {
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
}
.dx-diagram-mobile-toolbar-color-box-opened .dx-dropdowneditor-overlay .dx-overlay-content .dx-colorview-container .dx-colorview-container-row .dx-colorview-palette-cell .dx-colorview-palette {
  width: 100%;
  min-width: 300px;
}
.dx-diagram-mobile-toolbar-color-box-opened .dx-dropdowneditor-overlay .dx-overlay-content .dx-colorview-container .dx-colorview-container-row .dx-colorview-controls-container,
.dx-diagram-mobile-toolbar-color-box-opened .dx-dropdowneditor-overlay .dx-overlay-content .dx-colorview-container .dx-colorview-container-row .dx-colorview-hue-scale-cell {
  margin-left: 12px;
}
.dx-diagram-i {
  background-repeat: no-repeat;
  background-position: 0 0;
  display: inline-block;
}
.dx-diagram-loading-indicator {
  position: absolute;
  top: calc(50% - 32px);
  left: calc(50% - 32px);
  width: 64px;
  height: 64px;
}
.dx-diagram-touch-context-toolbox .dx-popover-wrapper,
.dx-diagram-touchbar-overlay {
  z-index: 1!important;
}
.dx-diagram-touchbar.dx-context-menu .dx-menu-items-container {
  display: block;
  height: 100%;
  padding: 0;
}
.dx-diagram-touchbar.dx-context-menu .dx-menu-items-container::after {
  display: block;
  content: "";
  clear: both;
}
.dx-diagram-touchbar.dx-context-menu .dx-menu-items-container > li {
  display: block;
  float: left;
}
.dx-diagram-touchbar.dx-context-menu .dx-menu-item.dx-menu-item-has-text.dx-menu-item-has-icon .dx-menu-item-content .dx-icon {
  margin: 0;
}
.dx-diagram-touchbar.dx-context-menu .dx-menu-item .dx-menu-item-content .dx-menu-item-text {
  display: none;
}
.dx-diagram-context-toolbox-target,
.dx-diagram-touchbar-target {
  position: absolute;
  background-color: transparent;
  pointer-events: none;
}
.dx-diagram-context-toolbox-target {
  width: 1px;
  height: 1px;
}
.dx-diagram-context-toolbox .dx-popup-content {
  padding: 8px;
}
.dx-diagram {
  border-color: #e0e0e0;
}
.dx-diagram .dxdi-control .dxdi-canvas {
  background-color: #d9d9d9;
}
.dx-diagram .dxdi-control .dxdi-canvas .connector-multi-selection,
.dx-diagram .dxdi-control .dxdi-canvas .connector-point-mark,
.dx-diagram .dxdi-control .dxdi-canvas .connector-selection,
.dx-diagram .dxdi-control .dxdi-canvas .connector-side-mark,
.dx-diagram .dxdi-control .dxdi-canvas .extension-line path,
.dx-diagram .dxdi-control .dxdi-canvas .item-multi-selection-rect,
.dx-diagram .dxdi-control .dxdi-canvas .item-selection-rect,
.dx-diagram .dxdi-control .dxdi-canvas .items-selection-rect,
.dx-diagram .dxdi-control .dxdi-canvas .selection-mark {
  stroke: #009688;
}
.dx-diagram .dxdi-control .dxdi-canvas .connector-side-mark,
.dx-diagram .dxdi-control .dxdi-canvas .extension-line text {
  fill: #009688;
}
.dx-diagram .dxdi-control .dxdi-canvas .connection-mark:not(.selector),
.dx-diagram .dxdi-control .dxdi-canvas .connection-point:not(.selector),
.dx-diagram .dxdi-control .dxdi-canvas .connection-target,
.dx-diagram .dxdi-control .dxdi-canvas .container-target {
  stroke: #8bc34a;
}
.dx-diagram .dxdi-control .dxdi-canvas .connection-mark:not(.selector).active,
.dx-diagram .dxdi-control .dxdi-canvas .connection-point:not(.selector).active {
  fill: #8bc34a;
}
.dx-diagram .dxdi-control .dxdi-canvas .geometry-mark {
  stroke: #f44336;
}
.dx-diagram .dxdi-control .dxdi-canvas .dxdi-main .dxdi-image .dxdi-spinner path {
  stroke: #009688;
  stroke-opacity: 1;
}
.dx-diagram .dxdi-control .dxdi-canvas .dxdi-main .dxdi-image .dxdi-spinner ellipse {
  stroke: rgba(0,0,0,0.54);
  stroke-opacity: 0.5;
}
.dx-diagram .dxdi-control .dxdi-canvas .dxdi-main .dxdi-image .dxdi-user .dxdi-background {
  fill: rgba(0,0,0,0.54);
  opacity: .5;
}
.dx-diagram .dxdi-control .dxdi-canvas .dxdi-main .dxdi-image .dxdi-warning ellipse {
  fill: #f44336;
}
.dx-diagram .dxdi-control:not(.focused) .dxdi-canvas .geometry-mark,
.dx-diagram .dxdi-control:not(.focused) .dxdi-canvas .selection-mark {
  stroke: #666;
}
.dx-diagram .dxdi-control:not(.focused) .dxdi-canvas .item-selection-rect,
.dx-diagram .dxdi-control:not(.focused) .dxdi-canvas .items-selection-rect {
  fill: transparent;
  stroke: #666;
}
.dx-diagram .dxdi-control:not(.focused) .dxdi-canvas .items-selection-rect {
  fill: rgba(144,144,144,0.02);
}
.dx-diagram .dxdi-control:not(.focused) .dxdi-canvas .item-multi-selection-rect {
  fill: rgba(144,144,144,0.02);
  stroke: #666;
}
.dx-diagram .dxdi-control:not(.focused) .dxdi-canvas .connector-multi-selection,
.dx-diagram .dxdi-control:not(.focused) .dxdi-canvas .connector-point-mark,
.dx-diagram .dxdi-control:not(.focused) .dxdi-canvas .connector-selection,
.dx-diagram .dxdi-control:not(.focused) .dxdi-canvas .connector-side-mark {
  stroke: #666;
}
.dx-diagram .dxdi-control:not(.focused) .dxdi-canvas .connector-side-mark {
  fill: #666;
}
.dx-diagram .dxdi-text-input-container.connector-text .dxdi-text-input {
  border-color: #009688;
}
.dx-diagram .dx-diagram-toolbar-wrapper {
  border-bottom: 1px solid #e0e0e0;
}
.dx-diagram.dx-diagram-fullscreen {
  background-color: #fff;
}
.dx-diagram-properties-panel,
.dx-diagram-toolbox-panel {
  background: #fff;
}
.dx-diagram-floating-toolbar-container {
  background: #fff;
  -webkit-box-shadow: 0 1px 8px rgba(0,0,0,.175);
  box-shadow: 0 1px 8px rgba(0,0,0,.175);
  border-radius: 4px;
  padding: 4px;
}
.dx-diagram-floating-toolbar-container .dx-toolbar .dx-toolbar-items-container {
  height: 36px;
}
.dx-diagram-floating-toolbar-container .dx-toolbar .dx-toolbar-items-container .dx-texteditor .dx-placeholder::before,
.dx-diagram-floating-toolbar-container .dx-toolbar .dx-toolbar-items-container .dx-texteditor .dx-texteditor-input {
  color: inherit;
  padding: 8px 6px;
}
.dx-diagram-floating-toolbar-container .dx-toolbar .dx-toolbar-items-container .dx-texteditor .dx-button {
  width: auto;
  height: auto;
  min-width: 24px;
  min-height: 24px;
  margin: 2px;
}
.dx-diagram-floating-toolbar-container .dx-toolbar .dx-toolbar-items-container .dx-texteditor .dx-button .dx-button-content {
  padding: 4px;
}
.dx-diagram-floating-toolbar-container.dx-diagram-properties-panel-toolbar-container,
.dx-diagram-floating-toolbar-container.dx-diagram-properties-panel-toolbar-container .dx-button,
.dx-diagram-floating-toolbar-container.dx-diagram-properties-panel-toolbar-container .dx-toolbar,
.dx-diagram-floating-toolbar-container.dx-diagram-properties-panel-toolbar-container .dx-toolbar-item,
.dx-diagram-floating-toolbar-container.dx-diagram-properties-panel-toolbar-container .dx-toolbar-items-container {
  width: 56px;
  height: 56px;
}
.dx-diagram-floating-toolbar-container.dx-diagram-properties-panel-toolbar-container .dx-button .dx-button-content,
.dx-diagram-floating-toolbar-container.dx-diagram-properties-panel-toolbar-container .dx-button-content,
.dx-diagram-floating-toolbar-container.dx-diagram-properties-panel-toolbar-container .dx-toolbar .dx-button-content,
.dx-diagram-floating-toolbar-container.dx-diagram-properties-panel-toolbar-container .dx-toolbar-item .dx-button-content,
.dx-diagram-floating-toolbar-container.dx-diagram-properties-panel-toolbar-container .dx-toolbar-items-container .dx-button-content {
  padding-top: 0;
  padding-bottom: 0;
  line-height: 56px;
}
.dx-diagram-floating-toolbar-container .dx-toolbar-item {
  padding: 0 4px 0 0;
}
.dx-diagram-toolbox-popup > .dx-overlay-content {
  -webkit-box-shadow: 0 1px 8px rgba(0,0,0,.175);
  box-shadow: 0 1px 8px rgba(0,0,0,.175);
}
.dx-diagram-toolbox-popup .dx-popup-title {
  margin-bottom: 0;
}
.dx-diagram-toolbox-popup .dx-popup-title.dx-toolbar {
  font-size: .8em;
  min-height: 18px;
}
.dx-diagram-toolbox-popup .dx-popup-title.dx-toolbar .dx-toolbar-items-container {
  height: 18px;
}
.dx-diagram-toolbox-popup .dx-popup-title .dx-button-content,
.dx-diagram-toolbox-popup .dx-popup-title .dx-button.dx-button-has-icon:not(.dx-button-has-text) {
  width: 18px;
  height: 18px;
}
.dx-diagram-toolbox-popup .dx-popup-content .dx-diagram-toolbox-input-container,
.dx-diagram-toolbox-popup .dx-popup-content .dx-diagram-toolbox-panel,
.dx-diagram-toolbox-popup .dx-popup-content .dx-diagram-toolbox-panel .dx-accordion {
  width: 156px;
}
.dx-diagram-toolbox-popup .dx-diagram-toolbox-input-container {
  border-bottom: 1px solid #e0e0e0;
}
.dx-diagram-toolbox-popup .dx-diagram-toolbox-input {
  margin: 2px;
}
.dx-diagram-toolbox-popup .dx-diagram-toolbox-input .dx-placeholder::before,
.dx-diagram-toolbox-popup .dx-diagram-toolbox-input .dx-texteditor-input {
  padding: 12px 9px;
}
.dx-diagram-toolbox-popup .dx-diagram-toolbox-input.dx-editor-outlined:not(.dx-state-focused) {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-diagram-toolbox-popup .dx-diagram-toolbox-input.dx-editor-outlined .dx-texteditor-buttons-container:last-child > .dx-button:last-child {
  margin-right: 0;
}
.dx-diagram-toolbox-popup .dx-diagram-toolbox-input .dx-button .dx-button-content {
  padding: 6px 4px;
}
.dx-diagram-toolbox-popup .dx-diagram-toolbox-input .dx-button .dx-icon {
  font-size: 18px;
}
.dx-diagram-toolbox-popup .dx-popup-title .dx-closebutton {
  width: 18px;
  height: 18px;
  margin: 1px 0 0;
}
.dx-diagram-toolbox-popup .dx-popup-title .dx-closebutton .dx-icon {
  width: 14px;
  height: 14px;
  padding: 2px;
  font-size: 12px;
  line-height: 12px;
  background-position: 2px 2px;
  background-size: 12px 12px;
}
.dx-diagram-toolbox-popup.dx-diagram-mobile-popup .dx-popup-content {
  padding-top: 68px;
}
.dx-diagram-toolbox-popup.dx-diagram-mobile-popup .dx-popup-content .dx-diagram-toolbox-input-container {
  border-top: 1px solid #e0e0e0;
}
.dx-diagram-toolbox-panel .dx-accordion {
  margin: 0;
}
.dx-diagram-toolbox-panel .dx-accordion .dx-accordion-item {
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #e0e0e0;
  border-top: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.dx-diagram-toolbox-panel .dx-accordion .dx-accordion-item-opened {
  margin: 0;
}
.dx-diagram-toolbox-panel .dx-accordion .dx-item-content.dx-accordion-item-title {
  height: 32px;
}
.dx-diagram-toolbox-panel .dx-accordion .dx-item-content.dx-accordion-item-title .dx-accordion-item-title-caption {
  font-size: .8em;
  text-transform: uppercase;
  left: 12px;
  top: 8px;
  right: 32px;
}
.dx-diagram-toolbox-panel .dx-accordion .dx-item-content.dx-accordion-item-title::before {
  font-size: 1em;
  line-height: .8em;
  right: 0;
  top: 8px;
}
.dx-diagram-toolbox-panel .dx-accordion .dx-item-content.dx-accordion-item-body {
  padding: 8px 12px;
}
.dx-diagram-toolbox-panel .dxdi-toolbox .dxdi-canvas .dxdi-shape-text {
  opacity: .25;
}
.dx-diagram-properties-popup .dx-multiview-item,
.dx-diagram-properties-popup.dx-diagram-properties-popup-notabs .dx-popup-content {
  padding: 0;
}
.dx-diagram-properties-popup .dx-diagram-properties-panel-group-title {
  text-transform: uppercase;
  padding: 16px;
}
.dx-diagram-properties-popup .dx-diagram-properties-panel-group-toolbar {
  padding: 0 16px 16px;
}
.dx-diagram-properties-popup .dx-diagram-properties-panel-group-toolbar .dx-toolbar-item {
  margin-bottom: 8px;
}
.dx-diagram-properties-popup .dx-diagram-properties-panel-group-toolbar .dx-toolbar-item .dx-button {
  height: auto;
}
.dx-diagram-properties-popup .dx-diagram-properties-panel-group-toolbar .dx-toolbar-item.dx-diagram-lg-icon-item .dx-diagram-i {
  background-size: 64px 64px;
  width: 64px;
  height: 64px;
}
.dx-diagram-properties-popup .dx-diagram-properties-panel-group-toolbar:first-child {
  padding-top: 16px;
}
.dx-diagram-properties-popup.dx-diagram-mobile-popup .dx-popup-title {
  padding: 8px 8px 0 0;
}
.dx-diagram-properties-popup.dx-diagram-mobile-popup .dx-tabpanel .dx-tab-selected::before {
  top: 0;
  bottom: initial;
}
.dx-diagram-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format) {
  background-color: #e6e6e6;
}
.dx-diagram-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-success {
  background-color: #71a436;
}
.dx-diagram-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-default {
  background-color: #00635a;
}
.dx-diagram-toolbar .dx-format-active:not(.dx-color-format):not(.dx-background-format).dx-button-danger {
  background-color: #ea1c0d;
}
.dx-diagram-toolbar .dx-dropdowneditor.dx-editor-filled,
.dx-diagram-toolbar .dx-texteditor.dx-editor-filled {
  background-color: transparent;
}
.dx-diagram-toolbar .dx-dropdowneditor.dx-editor-filled::after,
.dx-diagram-toolbar .dx-texteditor.dx-editor-filled::after {
  border-bottom-color: transparent;
}
.dx-diagram-toolbar .dx-diagram-toolbar-separator {
  height: 50%;
  border-left-color: #e0e0e0;
}
.dx-diagram-toolbar .dx-diagram-toolbar-menu-separator {
  border-top-color: #e0e0e0;
}
.dx-diagram-toolbar .dx-diagram-toolbar-text {
  padding: 21px 0 20px 15px;
}
.dx-diagram-toolbar .dx-diagram-lg-edit-item .dx-texteditor {
  width: 280px;
}
.dx-diagram-toolbar .dx-diagram-md-edit-item .dx-texteditor {
  width: 180px;
}
.dx-diagram-toolbar .dx-diagram-sm-edit-item .dx-texteditor {
  width: 100px;
}
.dx-diagram-toolbar .dx-diagram-color-edit-item .dx-dropdowneditor-field-template-wrapper .dx-diagram-i,
.dx-diagram-toolbar .dx-diagram-color-edit-item .dx-dropdowneditor-field-template-wrapper .dx-icon {
  border-bottom-width: 3px;
  border-bottom-style: solid;
}
.dx-diagram-toolbar .dx-diagram-color-edit-item .dx-dropdowneditor-field-template-wrapper .dx-diagram-i,
.dx-diagram-toolbar .dx-diagram-color-edit-item .dx-dropdowneditor-field-template-wrapper .dx-icon,
.dx-diagram-toolbar .dx-diagram-image-dropdown-item .dx-dropdowneditor-field-template-wrapper .dx-diagram-i,
.dx-diagram-toolbar .dx-diagram-image-dropdown-item .dx-dropdowneditor-field-template-wrapper .dx-icon,
.dx-dropdownmenu-popup .dx-diagram-color-edit-item .dx-dropdowneditor-field-template-wrapper .dx-diagram-i,
.dx-dropdownmenu-popup .dx-diagram-color-edit-item .dx-dropdowneditor-field-template-wrapper .dx-icon,
.dx-dropdownmenu-popup .dx-diagram-image-dropdown-item .dx-dropdowneditor-field-template-wrapper .dx-diagram-i,
.dx-dropdownmenu-popup .dx-diagram-image-dropdown-item .dx-dropdowneditor-field-template-wrapper .dx-icon {
  margin-left: 12px;
  margin-right: 12px;
}
.dx-diagram-toolbar .dx-diagram-color-edit-item .dx-dropdowneditor-field-template-wrapper .dx-icon,
.dx-diagram-toolbar .dx-diagram-image-dropdown-item .dx-dropdowneditor-field-template-wrapper .dx-icon,
.dx-dropdownmenu-popup .dx-diagram-color-edit-item .dx-dropdowneditor-field-template-wrapper .dx-icon,
.dx-dropdownmenu-popup .dx-diagram-image-dropdown-item .dx-dropdowneditor-field-template-wrapper .dx-icon {
  font-size: 24px;
  color: rgba(0,0,0,.87);
}
.dx-diagram-contextmenu.dx-context-menu .dx-menu-item .dx-menu-item-content .dx-menu-item-popout-container {
  right: 0;
}
.dx-diagram-contextmenu.dx-context-menu .dx-menu-no-icons > .dx-menu-item-wrapper > .dx-menu-item > .dx-menu-item-content .dx-menu-item-text {
  padding-left: 4px;
}
.dx-diagram-touchbar .dx-menu-item .dx-menu-item-content {
  padding: 10px;
}
.dx-diagram-touchbar .dx-menu-separator {
  width: 1px;
  height: 46px;
  margin: 0;
}
.dx-diagram-i-selectbox-null-icon {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2028%2018%22%20style%3D%22enable-background%3Anew%200%200%2028%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3C%2Fsvg%3E%0A");
  width: 37.44px;
  height: 24px;
}
.dx-diagram-i-connector-begin-none {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2028%2018%22%20style%3D%22enable-background%3Anew%200%200%2028%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3Bfill%3A%23FF0000%3B%7D%0A%09.st1%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20class%3D%22st0%22%20d%3D%22M1%2C13l9-9l1%2C1l-9%2C9L1%2C13z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%2F%3E%0A%3Cpath%20class%3D%22st1%22%20d%3D%22M12%2C8V3H0v12h12v-5h16V8H12z%20M10%2C13H2V5h8V13z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 37.44px;
  height: 24px;
}
.dx-diagram-i-connector-begin-arrow {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2028%2016%22%20style%3D%22enable-background%3Anew%200%200%2028%2016%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st0%22%20d%3D%22M8%2C9l4%2C3l1%2C2L0%2C8l13-6l-1%2C2L8%2C7h20v2H8z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 37.44px;
  height: 24px;
}
.dx-diagram-i-connector-begin-outlined-triangle {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2028%2018%22%20style%3D%22enable-background%3Anew%200%200%2028%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st0%22%20d%3D%22M0%2C9l13%2C6v-5h15V8H13V3L0%2C9z%20M11%2C12L3.9%2C9L11%2C6V12z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 37.44px;
  height: 24px;
}
.dx-diagram-i-connector-begin-filled-triangle {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2028%2018%22%20style%3D%22enable-background%3Anew%200%200%2028%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20class%3D%22st0%22%20d%3D%22M13%2C10v5L0%2C9l13-6v5h15v2H13z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 37.44px;
  height: 24px;
}
.dx-diagram-i-connector-end-none {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2028%2018%22%20style%3D%22enable-background%3Anew%200%200%2028%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3Bfill%3A%23FF0000%3B%7D%0A%09.st1%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20class%3D%22st0%22%20d%3D%22M17%2C13l9-9l1%2C1l-9%2C9L17%2C13z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3Cpath%20class%3D%22st1%22%20d%3D%22M0%2C8v2h16v5h12V3H16v5H0z%20M18%2C5h8v8h-8V5z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 37.44px;
  height: 24px;
}
.dx-diagram-i-connector-end-arrow {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2028%2018%22%20style%3D%22enable-background%3Anew%200%200%2028%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st0%22%20d%3D%22M0%2C10l0-2h20l-4-3l-1-2l13%2C6l-13%2C6l1-2l4-3H0z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 37.44px;
  height: 24px;
}
.dx-diagram-i-connector-end-outlined-triangle {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2028%2016%22%20style%3D%22enable-background%3Anew%200%200%2028%2016%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st0%22%20d%3D%22M28%2C8L15%2C2v5H0v2h15v5L28%2C8z%20M17%2C5l7.1%2C3L17%2C11V5z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 37.44px;
  height: 24px;
}
.dx-diagram-i-connector-end-filled-triangle {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2028%2018%22%20style%3D%22enable-background%3Anew%200%200%2028%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st0%22%20d%3D%22M0%2C10V8h15V3l13%2C6l-13%2C6v-5H0z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 37.44px;
  height: 24px;
}
.dx-diagram-i-connector-orthogonal {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2028%2018%22%20style%3D%22enable-background%3Anew%200%200%2028%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20class%3D%22st0%22%20d%3D%22M20%2C18v-8h3V5H8v3H0V0h8v3h15h2v2v5h3v8H20z%20M6%2C2H2v4h4V2z%20M26%2C12h-4v4h4V12z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 37.44px;
  height: 24px;
}
.dx-diagram-i-connector-straight {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2028%2018%22%20style%3D%22enable-background%3Anew%200%200%2028%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cpath%20d%3D%22M20%2C10v2.2L8%2C2.8V0H0v8h8V5.8l12%2C9.3V18h8v-8H20z%20M6%2C6H2V2h4V6z%20M26%2C16h-4v-4h4V16z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 37.44px;
  height: 24px;
}
.dx-diagram-i-line-solid {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2028%2018%22%20style%3D%22enable-background%3Anew%200%200%2028%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Crect%20id%3D%22_x32__2_%22%20x%3D%223%22%20y%3D%228%22%20class%3D%22st0%22%20width%3D%2222%22%20height%3D%222%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 37.44px;
  height: 24px;
}
.dx-diagram-i-line-dotted {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2028%2018%22%20style%3D%22enable-background%3Anew%200%200%2028%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Crect%20id%3D%22_x32__2_%22%20x%3D%223%22%20y%3D%228%22%20class%3D%22st0%22%20width%3D%222%22%20height%3D%222%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3Crect%20id%3D%22_x32__1_%22%20x%3D%227%22%20y%3D%228%22%20class%3D%22st0%22%20width%3D%222%22%20height%3D%222%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3Crect%20id%3D%22_x32__3_%22%20x%3D%2211%22%20y%3D%228%22%20class%3D%22st0%22%20width%3D%222%22%20height%3D%222%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3Crect%20id%3D%22_x32__4_%22%20x%3D%2215%22%20y%3D%228%22%20class%3D%22st0%22%20width%3D%222%22%20height%3D%222%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3Crect%20id%3D%22_x32__5_%22%20x%3D%2219%22%20y%3D%228%22%20class%3D%22st0%22%20width%3D%222%22%20height%3D%222%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3Crect%20id%3D%22_x32__6_%22%20x%3D%2223%22%20y%3D%228%22%20class%3D%22st0%22%20width%3D%222%22%20height%3D%222%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 37.44px;
  height: 24px;
}
.dx-diagram-i-line-dashed {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2028%2018%22%20style%3D%22enable-background%3Anew%200%200%2028%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Crect%20id%3D%22_x32__1_%22%20x%3D%223%22%20y%3D%228%22%20class%3D%22st0%22%20width%3D%226%22%20height%3D%222%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3Crect%20id%3D%22_x32__4_%22%20x%3D%2211%22%20y%3D%228%22%20class%3D%22st0%22%20width%3D%226%22%20height%3D%222%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3Crect%20id%3D%22_x32__5_%22%20x%3D%2219%22%20y%3D%228%22%20class%3D%22st0%22%20width%3D%226%22%20height%3D%222%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 37.44px;
  height: 24px;
}
.dx-diagram-i-button-fill,
.dx-diagram-i-menu-fill {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cpath%20id%3D%22_x32_%22%20d%3D%22M7.6%2C1L6.7%2C1.9l1.9%2C1.9L3%2C9.4L9.5%2C16L16%2C9.4L7.6%2C1z%20M5%2C9l4.5-4.5L14%2C9H5z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fsvg%3E%0A%0A");
  width: 24px;
  height: 27px;
}
.dx-diagram-i-button-fullscreen,
.dx-diagram-i-menu-fullscreen {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cpolygon%20points%3D%220%2C6%202%2C6%202%2C2%206%2C2%206%2C0%200%2C0%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%2F%3E%0A%3Cpolygon%20points%3D%222%2C12%200%2C12%200%2C18%206%2C18%206%2C16%202%2C16%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%2F%3E%0A%3Cpolygon%20points%3D%2212%2C0%2012%2C2%2016%2C2%2016%2C6%2018%2C6%2018%2C0%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%2F%3E%0A%3Cpolygon%20points%3D%2216%2C16%2012%2C16%2012%2C18%2018%2C18%2018%2C12%2016%2C12%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 24px;
  height: 24px;
}
.dx-diagram-i-button-lock,
.dx-diagram-i-menu-lock {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x32_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cpath%20id%3D%22_x31_%22%20d%3D%22M14%2C5c0-2.8-2.2-5-5-5C6.2%2C0%2C4%2C2.2%2C4%2C5C2.9%2C5%2C2%2C5.9%2C2%2C7v8c0%2C1.1%2C0.9%2C2%2C2%2C2h10c1.1%2C0%2C2-0.9%2C2-2V7%0A%09C16%2C5.9%2C15.1%2C5%2C14%2C5z%20M9%2C13c-1.1%2C0-2-0.9-2-2s0.9-2%2C2-2c1.1%2C0%2C2%2C0.9%2C2%2C2C11%2C12.1%2C10.1%2C13%2C9%2C13z%20M6%2C5c0-1.7%2C1.3-3%2C3-3%0A%09c1.7%2C0%2C3%2C1.3%2C3%2C3H6z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 24px;
  height: 24px;
}
.dx-diagram-i-button-unlock,
.dx-diagram-i-menu-unlock {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x32_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x31_%22%20class%3D%22st0%22%20d%3D%22M14%2C17H4c-1.1%2C0-2-0.9-2-2V7c0-1.1%2C0.9-2%2C2-2h2h2h4c0-1.7-1.3-3-3-3C8.1%2C2%2C7.3%2C2.4%2C6.8%2C3H4.4%0A%09C5.2%2C1.2%2C7%2C0%2C9%2C0c2.8%2C0%2C5%2C2.2%2C5%2C5c1.1%2C0%2C2%2C0.9%2C2%2C2v8C16%2C16.1%2C15.1%2C17%2C14%2C17z%20M9%2C9c-1.1%2C0-2%2C0.9-2%2C2s0.9%2C2%2C2%2C2s2-0.9%2C2-2%0A%09C11%2C9.9%2C10.1%2C9%2C9%2C9z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 24px;
  height: 24px;
}
.dx-diagram-i-button-send-to-back,
.dx-diagram-i-menu-send-to-back {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x32_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bopacity%3A0.35%3Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%09.st1%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x30__1_%22%20class%3D%22st0%22%20d%3D%22M8%2C0h8c1.1%2C0%2C2%2C0.9%2C2%2C2v8c0%2C1.1-0.9%2C2-2%2C2H8c-1.1%2C0-2-0.9-2-2V2C6%2C0.9%2C6.9%2C0%2C8%2C0z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3Cpath%20id%3D%22_x31_%22%20class%3D%22st1%22%20d%3D%22M8%2C12c-1.1%2C0-2-0.9-2-2V4H4C2.9%2C4%2C2%2C4.9%2C2%2C6v8c0%2C1.1%2C0.9%2C2%2C2%2C2h8c1.1%2C0%2C2-0.9%2C2-2v-2H8z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 24px;
  height: 24px;
}
.dx-diagram-i-button-bring-to-front,
.dx-diagram-i-menu-bring-to-front {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x32_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bopacity%3A0.35%3Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%09.st1%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x30__1_%22%20class%3D%22st0%22%20d%3D%22M8%2C0h8c1.1%2C0%2C2%2C0.9%2C2%2C2v8c0%2C1.1-0.9%2C2-2%2C2H8c-1.1%2C0-2-0.9-2-2V2C6%2C0.9%2C6.9%2C0%2C8%2C0z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3Cpath%20id%3D%22_x30_%22%20class%3D%22st1%22%20d%3D%22M4%2C4h8c1.1%2C0%2C2%2C0.9%2C2%2C2v8c0%2C1.1-0.9%2C2-2%2C2H4c-1.1%2C0-2-0.9-2-2V6C2%2C4.9%2C2.9%2C4%2C4%2C4z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 24px;
  height: 24px;
}
.dx-diagram-i-button-select-all,
.dx-diagram-i-menu-select-all {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x32_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%09.st1%7Bopacity%3A0.75%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x31_%22%20class%3D%22st0%22%20d%3D%22M8.5%2C6c0.1%2C0%2C0.3%2C0%2C0.4%2C0.1l0%2C0l6.8%2C5.3c0.3%2C0.2%2C0.3%2C0.5%2C0.1%2C0.8c-0.1%2C0.1-0.1%2C0.2-0.3%2C0.2l-1.9%2C0.3%0A%09l1.3%2C2.6c0.2%2C0.3%2C0%2C0.6-0.3%2C0.7l-2.1%2C0.9c-0.1%2C0-0.2%2C0.1-0.3%2C0.1c-0.2%2C0-0.4-0.1-0.5-0.3l-1.3-2.6l-1.5%2C1.1%0A%09c-0.1%2C0.1-0.2%2C0.1-0.4%2C0.1c-0.3%2C0-0.6-0.2-0.6-0.5V6.6C7.9%2C6.3%2C8.2%2C6%2C8.5%2C6z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%2F%3E%0A%3Cg%20id%3D%22_x33_%22%20class%3D%22st1%22%3E%0A%09%3Cpolygon%20id%3D%22_x31__1_%22%20class%3D%22st0%22%20points%3D%2212%2C6%2014%2C8%2016%2C8%2016%2C6%20%09%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%09%3Crect%20id%3D%22_x32__1_%22%20x%3D%2211.6%22%20y%3D%222%22%20transform%3D%22matrix(0.7071%20-0.7071%200.7071%200.7071%201.6862%2010.071)%22%20class%3D%22st0%22%20width%3D%222.8%22%20height%3D%222%22%20%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%2F%3E%0A%09%3Crect%20id%3D%22_x33__1_%22%20x%3D%228%22%20y%3D%221%22%20class%3D%22st0%22%20width%3D%222%22%20height%3D%224%22%20%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%2F%3E%0A%09%3Crect%20id%3D%22_x34_%22%20x%3D%223.6%22%20y%3D%2210%22%20transform%3D%22matrix(0.7071%20-0.7071%200.7071%200.7071%20-6.3137%206.7573)%22%20class%3D%22st0%22%20width%3D%222.8%22%20height%3D%222%22%20%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%2F%3E%0A%09%3Crect%20id%3D%22_x35_%22%20x%3D%224%22%20y%3D%221.6%22%20transform%3D%22matrix(0.7071%20-0.7071%200.7071%200.7071%20-0.6569%204.4142)%22%20class%3D%22st0%22%20width%3D%222%22%20height%3D%222.8%22%20%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%2F%3E%0A%09%3Crect%20id%3D%22_x36_%22%20x%3D%222%22%20y%3D%226%22%20class%3D%22st0%22%20width%3D%224%22%20height%3D%222%22%20%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A");
  width: 24px;
  height: 24px;
}
.dx-diagram-i-button-image-delete,
.dx-diagram-i-menu-image-delete {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x32_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x31_%22%20class%3D%22st0%22%20d%3D%22M17%2C15.4L15.5%2C17l-2-2l-2%2C2L10%2C15.4l2-2l-2-2l1.5-1.4l2%2C2l2-2l1.5%2C1.5l-2%2C2L17%2C15.4z%20M12%2C6l-4%2C6%0A%09l-2-2l-3%2C5h5v2H3c-1.1%2C0-2-0.9-2-2V3c0-1.1%2C0.9-2%2C2-2h12c1.1%2C0%2C2%2C0.9%2C2%2C2v4l-2%2C2L12%2C6z%20M5.5%2C5C4.7%2C5%2C4%2C5.6%2C4%2C6.5S4.7%2C8%2C5.5%2C8%0A%09S7%2C7.3%2C7%2C6.5S6.3%2C5%2C5.5%2C5z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 24px;
  height: 24px;
}
.dx-diagram-i-button-image-edit,
.dx-diagram-i-menu-image-edit {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x32_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x31_%22%20class%3D%22st0%22%20d%3D%22M15%2C9l-3-3l-4%2C6l-2-2l-3%2C5h6v2H3c-1.1%2C0-2-0.9-2-2V3c0-1.1%2C0.9-2%2C2-2h12c1.1%2C0%2C2%2C0.9%2C2%2C2v4L15%2C9z%0A%09%20M5.5%2C5C4.7%2C5%2C4%2C5.7%2C4%2C6.5S4.7%2C8%2C5.5%2C8S7%2C7.3%2C7%2C6.5S6.3%2C5%2C5.5%2C5z%20M17%2C12.5L12.5%2C17H11v-1.5l4.5-4.5L17%2C12.5z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 24px;
  height: 24px;
}
.dx-diagram-i-button-image-insert,
.dx-diagram-i-menu-image-insert {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x32_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x31_%22%20class%3D%22st0%22%20d%3D%22M15%2C9l-3-3l-4%2C7l-2-3l-3%2C5h6v2H3c-1.1%2C0-2-0.9-2-2V3c0-1.1%2C0.9-2%2C2-2h12c1.1%2C0%2C2%2C0.9%2C2%2C2v4L15%2C9z%0A%09%20M5.5%2C5C4.7%2C5%2C4%2C5.7%2C4%2C6.5S4.7%2C8%2C5.5%2C8S7%2C7.3%2C7%2C6.5S6.3%2C5%2C5.5%2C5z%20M13%2C11h2v2h2v2h-2v2h-2v-2h-2v-2h2V11z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 24px;
  height: 24px;
}
.dx-diagram-i-button-layout-layered-bt {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2064%2064%22%20style%3D%22enable-background%3Anew%200%200%2064%2064%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%09.st1%7Bopacity%3A0.5%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%20id%3D%22_x34_%22%3E%0A%09%3Cpath%20id%3D%22_x35_%22%20class%3D%22st0%22%20d%3D%22M60%2C20v8c0%2C1.1-0.9%2C2-2%2C2h-8c-1.1%2C0-2-0.9-2-2v-8c0-1.1%2C0.9-2%2C2-2h8C59.1%2C18%2C60%2C18.9%2C60%2C20z%20M58%2C20%0A%09%09h-8v8h8V20z%20M46%2C6v8c0%2C1.1-0.9%2C2-2%2C2h-8c-1.1%2C0-2-0.9-2-2V6c0-1.1%2C0.9-2%2C2-2h8C45.1%2C4%2C46%2C4.9%2C46%2C6z%20M44%2C6h-8v8h8V6z%20M46%2C34v8%0A%09%09c0%2C1.1-0.9%2C2-2%2C2h-8c-1.1%2C0-2-0.9-2-2v-8c0-1.1%2C0.9-2%2C2-2h8C45.1%2C32%2C46%2C32.9%2C46%2C34z%20M44%2C34h-8v8h8V34z%20M46%2C50v8c0%2C1.1-0.9%2C2-2%2C2h-8%0A%09%09c-1.1%2C0-2-0.9-2-2v-8c0-1.1%2C0.9-2%2C2-2h8C45.1%2C48%2C46%2C48.9%2C46%2C50z%20M44%2C50h-8v8h8V50z%20M32%2C20v8c0%2C1.1-0.9%2C2-2%2C2h-8c-1.1%2C0-2-0.9-2-2%0A%09%09v-8c0-1.1%2C0.9-2%2C2-2h8C31.1%2C18%2C32%2C18.9%2C32%2C20z%20M30%2C20h-8v8h8V20z%20M12%2C4l6%2C6h-5v50h-2V10H6L12%2C4z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fg%3E%0A%3Cg%20id%3D%22_x32_%22%20class%3D%22st1%22%3E%0A%09%3Cpath%20id%3D%22_x33_%22%20class%3D%22st0%22%20d%3D%22M55%2C9v2v7h-2v-7h-7V9h7H55z%20M53%2C30h2v7v2h-2h-7v-2h7V30z%20M39%2C44h2v4h-2V44z%20M27%2C9h7v2h-7v7h-2v-7V9%0A%09%09H27z%20M27%2C37h7v2h-7h-2v-2v-7h2V37z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A");
  width: 24px;
  height: 24px;
}
.dx-diagram-i-button-layout-layered-lr {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2064%2064%22%20style%3D%22enable-background%3Anew%200%200%2064%2064%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%09.st1%7Bopacity%3A0.5%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%20id%3D%22_x34_%22%3E%0A%09%3Cpath%20id%3D%22_x35_%22%20class%3D%22st0%22%20d%3D%22M45%2C59h-8c-1.1%2C0-2-0.9-2-2v-8c0-1.1%2C0.9-2%2C2-2h8c1.1%2C0%2C2%2C0.9%2C2%2C2v8C47%2C58.1%2C46.1%2C59%2C45%2C59z%20M45%2C57%0A%09%09v-8h-8v8H45z%20M59%2C45h-8c-1.1%2C0-2-0.9-2-2v-8c0-1.1%2C0.9-2%2C2-2h8c1.1%2C0%2C2%2C0.9%2C2%2C2v8C61%2C44.1%2C60.1%2C45%2C59%2C45z%20M59%2C43v-8h-8v8H59z%0A%09%09%20M31%2C45h-8c-1.1%2C0-2-0.9-2-2v-8c0-1.1%2C0.9-2%2C2-2h8c1.1%2C0%2C2%2C0.9%2C2%2C2v8C33%2C44.1%2C32.1%2C45%2C31%2C45z%20M31%2C43v-8h-8v8H31z%20M15%2C45H7%0A%09%09c-1.1%2C0-2-0.9-2-2v-8c0-1.1%2C0.9-2%2C2-2h8c1.1%2C0%2C2%2C0.9%2C2%2C2v8C17%2C44.1%2C16.1%2C45%2C15%2C45z%20M15%2C43v-8H7v8H15z%20M45%2C31h-8c-1.1%2C0-2-0.9-2-2%0A%09%09v-8c0-1.1%2C0.9-2%2C2-2h8c1.1%2C0%2C2%2C0.9%2C2%2C2v8C47%2C30.1%2C46.1%2C31%2C45%2C31z%20M45%2C29v-8h-8v8H45z%20M61%2C11l-6%2C6v-5H5v-2h50V5L61%2C11z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fg%3E%0A%3Cg%20id%3D%22_x32_%22%20class%3D%22st1%22%3E%0A%09%3Cpath%20id%3D%22_x33_%22%20class%3D%22st0%22%20d%3D%22M56%2C54h-2h-7v-2h7v-7h2v7V54z%20M35%2C52v2h-7h-2v-2v-7h2v7H35z%20M21%2C38v2h-4v-2H21z%20M56%2C26v7h-2v-7h-7%0A%09%09v-2h7h2V26z%20M28%2C26v7h-2v-7v-2h2h7v2H28z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A");
  width: 24px;
  height: 24px;
}
.dx-diagram-i-button-layout-layered-rl {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2064%2064%22%20style%3D%22enable-background%3Anew%200%200%2064%2064%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%09.st1%7Bopacity%3A0.5%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%20id%3D%22_x34_%22%3E%0A%09%3Cpath%20id%3D%22_x35_%22%20class%3D%22st0%22%20d%3D%22M19%2C57v-8c0-1.1%2C0.9-2%2C2-2h8c1.1%2C0%2C2%2C0.9%2C2%2C2v8c0%2C1.1-0.9%2C2-2%2C2h-8C19.9%2C59%2C19%2C58.1%2C19%2C57z%20M29%2C57%0A%09%09v-8h-8v8H29z%20M5%2C43v-8c0-1.1%2C0.9-2%2C2-2h8c1.1%2C0%2C2%2C0.9%2C2%2C2v8c0%2C1.1-0.9%2C2-2%2C2H7C5.9%2C45%2C5%2C44.1%2C5%2C43z%20M15%2C43v-8H7v8H15z%20M33%2C43v-8%0A%09%09c0-1.1%2C0.9-2%2C2-2h8c1.1%2C0%2C2%2C0.9%2C2%2C2v8c0%2C1.1-0.9%2C2-2%2C2h-8C33.9%2C45%2C33%2C44.1%2C33%2C43z%20M43%2C43v-8h-8v8H43z%20M49%2C43v-8c0-1.1%2C0.9-2%2C2-2h8%0A%09%09c1.1%2C0%2C2%2C0.9%2C2%2C2v8c0%2C1.1-0.9%2C2-2%2C2h-8C49.9%2C45%2C49%2C44.1%2C49%2C43z%20M59%2C43v-8h-8v8H59z%20M19%2C29v-8c0-1.1%2C0.9-2%2C2-2h8c1.1%2C0%2C2%2C0.9%2C2%2C2v8%0A%09%09c0%2C1.1-0.9%2C2-2%2C2h-8C19.9%2C31%2C19%2C30.1%2C19%2C29z%20M29%2C29v-8h-8v8H29z%20M11%2C5v5h50v2H11v5l-6-6L11%2C5z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fg%3E%0A%3Cg%20id%3D%22_x32_%22%20class%3D%22st1%22%3E%0A%09%3Cpath%20id%3D%22_x33_%22%20class%3D%22st0%22%20d%3D%22M10%2C52v-7h2v7h7v2h-7h-2V52z%20M38%2C52v-7h2v7v2h-2h-7v-2H38z%20M49%2C38v2h-4v-2H49z%20M10%2C24h2h7v2h-7v7%0A%09%09h-2v-7V24z%20M31%2C26v-2h7h2v2v7h-2v-7H31z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A");
  width: 24px;
  height: 24px;
}
.dx-diagram-i-button-layout-layered-tb {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2064%2064%22%20style%3D%22enable-background%3Anew%200%200%2064%2064%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%09.st1%7Bopacity%3A0.5%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%20id%3D%22_x34_%22%3E%0A%09%3Cpath%20id%3D%22_x35_%22%20class%3D%22st0%22%20d%3D%22M58%2C46h-8c-1.1%2C0-2-0.9-2-2v-8c0-1.1%2C0.9-2%2C2-2h8c1.1%2C0%2C2%2C0.9%2C2%2C2v8C60%2C45.1%2C59.1%2C46%2C58%2C46z%20M58%2C36%0A%09%09h-8v8h8V36z%20M44%2C60h-8c-1.1%2C0-2-0.9-2-2v-8c0-1.1%2C0.9-2%2C2-2h8c1.1%2C0%2C2%2C0.9%2C2%2C2v8C46%2C59.1%2C45.1%2C60%2C44%2C60z%20M44%2C50h-8v8h8V50z%20M44%2C32%0A%09%09h-8c-1.1%2C0-2-0.9-2-2v-8c0-1.1%2C0.9-2%2C2-2h8c1.1%2C0%2C2%2C0.9%2C2%2C2v8C46%2C31.1%2C45.1%2C32%2C44%2C32z%20M44%2C22h-8v8h8V22z%20M44%2C16h-8%0A%09%09c-1.1%2C0-2-0.9-2-2V6c0-1.1%2C0.9-2%2C2-2h8c1.1%2C0%2C2%2C0.9%2C2%2C2v8C46%2C15.1%2C45.1%2C16%2C44%2C16z%20M44%2C6h-8v8h8V6z%20M30%2C46h-8c-1.1%2C0-2-0.9-2-2v-8%0A%09%09c0-1.1%2C0.9-2%2C2-2h8c1.1%2C0%2C2%2C0.9%2C2%2C2v8C32%2C45.1%2C31.1%2C46%2C30%2C46z%20M30%2C36h-8v8h8V36z%20M6%2C54h5V4h2v50h5l-6%2C6L6%2C54z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fg%3E%0A%3Cg%20id%3D%22_x32_%22%20class%3D%22st1%22%3E%0A%09%3Cpath%20id%3D%22_x33_%22%20class%3D%22st0%22%20d%3D%22M53%2C55h-7v-2h7v-7h2v7v2H53z%20M53%2C27h-7v-2h7h2v2v7h-2V27z%20M39%2C16h2v4h-2V16z%20M25%2C55v-2v-7h2v7h7v2%0A%09%09h-7H25z%20M27%2C34h-2v-7v-2h2h7v2h-7V34z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A");
  width: 24px;
  height: 24px;
}
.dx-diagram-i-button-layout-tree-bt {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2064%2064%22%20style%3D%22enable-background%3Anew%200%200%2064%2064%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%09.st1%7Bopacity%3A0.5%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%20id%3D%22_x34_%22%3E%0A%09%3Cpath%20id%3D%22_x35_%22%20class%3D%22st0%22%20d%3D%22M59%2C6v6c0%2C1.1-0.9%2C2-2%2C2h-6c-1.1%2C0-2-0.9-2-2V6c0-1.1%2C0.9-2%2C2-2h6C58.1%2C4%2C59%2C4.9%2C59%2C6z%20M57%2C6h-6v6%0A%09%09h6V6z%20M59%2C26v6c0%2C1.1-0.9%2C2-2%2C2h-6c-1.1%2C0-2-0.9-2-2v-6c0-1.1%2C0.9-2%2C2-2h6C58.1%2C24%2C59%2C24.9%2C59%2C26z%20M57%2C26h-6v6h6V26z%20M49%2C38v6%0A%09%09c0%2C1.1-0.9%2C2-2%2C2h-6c-1.1%2C0-2-0.9-2-2v-6c0-1.1%2C0.9-2%2C2-2h6C48.1%2C36%2C49%2C36.9%2C49%2C38z%20M47%2C38h-6v6h6V38z%20M49%2C52v6c0%2C1.1-0.9%2C2-2%2C2h-6%0A%09%09c-1.1%2C0-2-0.9-2-2v-6c0-1.1%2C0.9-2%2C2-2h6C48.1%2C50%2C49%2C50.9%2C49%2C52z%20M47%2C52h-6v6h6V52z%20M39%2C32c0%2C1.1-0.9%2C2-2%2C2h-6c-1.1%2C0-2-0.9-2-2v-6%0A%09%09c0-1.1%2C0.9-2%2C2-2h6c1.1%2C0%2C2%2C0.9%2C2%2C2V32z%20M37%2C26h-6v6h6V26z%20M30%2C14h-6c-1.1%2C0-2-0.9-2-2V6c0-1.1%2C0.9-2%2C2-2h6c1.1%2C0%2C2%2C0.9%2C2%2C2v6%0A%09%09C32%2C13.1%2C31.1%2C14%2C30%2C14z%20M24%2C12h6V6h-6V12z%20M17%2C10h-5v50h-2V10H5l6-6L17%2C10z%20M36%2C12V6c0-1.1%2C0.9-2%2C2-2h6c1.1%2C0%2C2%2C0.9%2C2%2C2v6%0A%09%09c0%2C1.1-0.9%2C2-2%2C2h-6C36.9%2C14%2C36%2C13.1%2C36%2C12z%20M38%2C12h6V6h-6V12z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fg%3E%0A%3Cg%20id%3D%22_x32_%22%20class%3D%22st1%22%3E%0A%09%3Cpath%20id%3D%22_x33_%22%20class%3D%22st0%22%20d%3D%22M55%2C14v10h-2V14H55z%20M53%2C34h2v6v2h-2h-4v-2h4V34z%20M43%2C46h2v4h-2V46z%20M40%2C14h2v6h-7v4h-2v-4h-7v-6h2%0A%09%09v4h5h2h4.9L40%2C14z%20M35%2C40h4v2h-4h-2v-2v-6h2V40z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A");
  width: 24px;
  height: 24px;
}
.dx-diagram-i-button-layout-tree-lr {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2064%2064%22%20style%3D%22enable-background%3Anew%200%200%2064%2064%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%09.st1%7Bopacity%3A0.5%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%20id%3D%22_x34_%22%3E%0A%09%3Cpath%20id%3D%22_x35_%22%20class%3D%22st0%22%20d%3D%22M58%2C59h-6c-1.1%2C0-2-0.9-2-2v-6c0-1.1%2C0.9-2%2C2-2h6c1.1%2C0%2C2%2C0.9%2C2%2C2v6C60%2C58.1%2C59.1%2C59%2C58%2C59z%20M58%2C57%0A%09%09v-6h-6v6H58z%20M38%2C59h-6c-1.1%2C0-2-0.9-2-2v-6c0-1.1%2C0.9-2%2C2-2h6c1.1%2C0%2C2%2C0.9%2C2%2C2v6C40%2C58.1%2C39.1%2C59%2C38%2C59z%20M38%2C57v-6h-6v6H38z%0A%09%09%20M26%2C49h-6c-1.1%2C0-2-0.9-2-2v-6c0-1.1%2C0.9-2%2C2-2h6c1.1%2C0%2C2%2C0.9%2C2%2C2v6C28%2C48.1%2C27.1%2C49%2C26%2C49z%20M26%2C47v-6h-6v6H26z%20M12%2C49H6%0A%09%09c-1.1%2C0-2-0.9-2-2v-6c0-1.1%2C0.9-2%2C2-2h6c1.1%2C0%2C2%2C0.9%2C2%2C2v6C14%2C48.1%2C13.1%2C49%2C12%2C49z%20M12%2C47v-6H6v6H12z%20M32%2C39c-1.1%2C0-2-0.9-2-2v-6%0A%09%09c0-1.1%2C0.9-2%2C2-2h6c1.1%2C0%2C2%2C0.9%2C2%2C2v6c0%2C1.1-0.9%2C2-2%2C2H32z%20M38%2C37v-6h-6v6H38z%20M50%2C30v-6c0-1.1%2C0.9-2%2C2-2h6c1.1%2C0%2C2%2C0.9%2C2%2C2v6%0A%09%09c0%2C1.1-0.9%2C2-2%2C2h-6C50.9%2C32%2C50%2C31.1%2C50%2C30z%20M52%2C24v6h6v-6H52z%20M54%2C17v-5H4v-2h50V5l6%2C6L54%2C17z%20M52%2C36h6c1.1%2C0%2C2%2C0.9%2C2%2C2v6%0A%09%09c0%2C1.1-0.9%2C2-2%2C2h-6c-1.1%2C0-2-0.9-2-2v-6C50%2C36.9%2C50.9%2C36%2C52%2C36z%20M52%2C38v6h6v-6H52z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fg%3E%0A%3Cg%20id%3D%22_x32_%22%20class%3D%22st1%22%3E%0A%09%3Cpath%20id%3D%22_x33_%22%20class%3D%22st0%22%20d%3D%22M50%2C55H40v-2h10V55z%20M30%2C53v2h-6h-2v-2v-4h2v4H30z%20M18%2C43v2h-4v-2H18z%20M50%2C40v2h-6v-7h-4v-2h4v-7h6%0A%09%09v2h-4v5v2v4.9L50%2C40z%20M24%2C35v4h-2v-4v-2h2h6v2H24z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A");
  width: 24px;
  height: 24px;
}
.dx-diagram-i-button-layout-tree-rl {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2064%2064%22%20style%3D%22enable-background%3Anew%200%200%2064%2064%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%09.st1%7Bopacity%3A0.5%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%20id%3D%22_x34_%22%3E%0A%09%3Cpath%20id%3D%22_x35_%22%20class%3D%22st0%22%20d%3D%22M4%2C57v-6c0-1.1%2C0.9-2%2C2-2h6c1.1%2C0%2C2%2C0.9%2C2%2C2v6c0%2C1.1-0.9%2C2-2%2C2H6C4.9%2C59%2C4%2C58.1%2C4%2C57z%20M12%2C57v-6H6%0A%09%09v6H12z%20M24%2C57v-6c0-1.1%2C0.9-2%2C2-2h6c1.1%2C0%2C2%2C0.9%2C2%2C2v6c0%2C1.1-0.9%2C2-2%2C2h-6C24.9%2C59%2C24%2C58.1%2C24%2C57z%20M32%2C57v-6h-6v6H32z%20M36%2C47v-6%0A%09%09c0-1.1%2C0.9-2%2C2-2h6c1.1%2C0%2C2%2C0.9%2C2%2C2v6c0%2C1.1-0.9%2C2-2%2C2h-6C36.9%2C49%2C36%2C48.1%2C36%2C47z%20M44%2C47v-6h-6v6H44z%20M50%2C47v-6c0-1.1%2C0.9-2%2C2-2h6%0A%09%09c1.1%2C0%2C2%2C0.9%2C2%2C2v6c0%2C1.1-0.9%2C2-2%2C2h-6C50.9%2C49%2C50%2C48.1%2C50%2C47z%20M58%2C47v-6h-6v6H58z%20M26%2C39c-1.1%2C0-2-0.9-2-2v-6c0-1.1%2C0.9-2%2C2-2h6%0A%09%09c1.1%2C0%2C2%2C0.9%2C2%2C2v6c0%2C1.1-0.9%2C2-2%2C2H26z%20M32%2C37v-6h-6v6H32z%20M12%2C32H6c-1.1%2C0-2-0.9-2-2v-6c0-1.1%2C0.9-2%2C2-2h6c1.1%2C0%2C2%2C0.9%2C2%2C2v6%0A%09%09C14%2C31.1%2C13.1%2C32%2C12%2C32z%20M6%2C24v6h6v-6H6z%20M4%2C11l6-6v5h50v2H10v5L4%2C11z%20M14%2C38v6c0%2C1.1-0.9%2C2-2%2C2H6c-1.1%2C0-2-0.9-2-2v-6%0A%09%09c0-1.1%2C0.9-2%2C2-2h6C13.1%2C36%2C14%2C36.9%2C14%2C38z%20M6%2C38v6h6v-6H6z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fg%3E%0A%3Cg%20id%3D%22_x32_%22%20class%3D%22st1%22%3E%0A%09%3Cpath%20id%3D%22_x33_%22%20class%3D%22st0%22%20d%3D%22M14%2C53h10v2H14V53z%20M40%2C53v-4h2v4v2h-2h-6v-2H40z%20M50%2C43v2h-4v-2H50z%20M18%2C39.9V35v-2v-5h-4v-2h6v7%0A%09%09h4v2h-4v7h-6v-2L18%2C39.9z%20M34%2C35v-2h6h2v2v4h-2v-4H34z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A");
  width: 24px;
  height: 24px;
}
.dx-diagram-i-button-toolbox-open {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st0%22%20d%3D%22M13.5%2C17c-1.9%2C0-3.5-1.6-3.5-3.5s1.6-3.5%2C3.5-3.5s3.5%2C1.6%2C3.5%2C3.5S15.4%2C17%2C13.5%2C17z%20M9%2C1l5%2C7H4L9%2C1z%0A%09%20M8%2C17H1v-7h7V17z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 24px;
  height: 24px;
}
.dx-diagram-i-button-toolbox-close {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%20id%3D%22_x32_%22%3E%0A%09%3Cpath%20id%3D%22_x33_%22%20class%3D%22st0%22%20d%3D%22M8%2C14v-2h8v2H8z%20M6.7%2C12.3l-1.4%2C1.4L1%2C9l4.3-4.7l1.4%2C1.4L4.4%2C8H16v2H4.4L6.7%2C12.3z%20M8%2C4h8v2H8V4z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A");
  width: 24px;
  height: 24px;
}
.dx-diagram-i-button-layout-tree-tb {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2064%2064%22%20style%3D%22enable-background%3Anew%200%200%2064%2064%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%09.st1%7Bopacity%3A0.5%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%20id%3D%22_x34_%22%3E%0A%09%3Cpath%20id%3D%22_x35_%22%20class%3D%22st0%22%20d%3D%22M57%2C60h-6c-1.1%2C0-2-0.9-2-2v-6c0-1.1%2C0.9-2%2C2-2h6c1.1%2C0%2C2%2C0.9%2C2%2C2v6C59%2C59.1%2C58.1%2C60%2C57%2C60z%20M57%2C52%0A%09%09h-6v6h6V52z%20M57%2C40h-6c-1.1%2C0-2-0.9-2-2v-6c0-1.1%2C0.9-2%2C2-2h6c1.1%2C0%2C2%2C0.9%2C2%2C2v6C59%2C39.1%2C58.1%2C40%2C57%2C40z%20M57%2C32h-6v6h6V32z%20M47%2C28%0A%09%09h-6c-1.1%2C0-2-0.9-2-2v-6c0-1.1%2C0.9-2%2C2-2h6c1.1%2C0%2C2%2C0.9%2C2%2C2v6C49%2C27.1%2C48.1%2C28%2C47%2C28z%20M47%2C20h-6v6h6V20z%20M47%2C14h-6%0A%09%09c-1.1%2C0-2-0.9-2-2V6c0-1.1%2C0.9-2%2C2-2h6c1.1%2C0%2C2%2C0.9%2C2%2C2v6C49%2C13.1%2C48.1%2C14%2C47%2C14z%20M47%2C6h-6v6h6V6z%20M39%2C38c0%2C1.1-0.9%2C2-2%2C2h-6%0A%09%09c-1.1%2C0-2-0.9-2-2v-6c0-1.1%2C0.9-2%2C2-2h6c1.1%2C0%2C2%2C0.9%2C2%2C2V38z%20M37%2C32h-6v6h6V32z%20M32%2C52v6c0%2C1.1-0.9%2C2-2%2C2h-6c-1.1%2C0-2-0.9-2-2v-6%0A%09%09c0-1.1%2C0.9-2%2C2-2h6C31.1%2C50%2C32%2C50.9%2C32%2C52z%20M24%2C58h6v-6h-6V58z%20M11%2C60l-6-6h5V4h2v50h5L11%2C60z%20M38%2C50h6c1.1%2C0%2C2%2C0.9%2C2%2C2v6%0A%09%09c0%2C1.1-0.9%2C2-2%2C2h-6c-1.1%2C0-2-0.9-2-2v-6C36%2C50.9%2C36.9%2C50%2C38%2C50z%20M38%2C58h6v-6h-6V58z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fg%3E%0A%3Cg%20id%3D%22_x32_%22%20class%3D%22st1%22%3E%0A%09%3Cpath%20id%3D%22_x33_%22%20class%3D%22st0%22%20d%3D%22M53%2C50V40h2v10H53z%20M53%2C24h-4v-2h4h2v2v6h-2V24z%20M43%2C14h2v4h-2V14z%20M39.9%2C46H35h-2h-5v4h-2v-6h7v-4%0A%09%09h2v4h7v6h-2L39.9%2C46z%20M35%2C30h-2v-6v-2h2h4v2h-4V30z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A");
  width: 24px;
  height: 24px;
}
.dx-diagram-toolbox-popup .dx-button-has-icon .dx-icon.dx-icon-diagram-toolbox-drag {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2012%2012%22%20style%3D%22enable-background%3Anew%200%200%2012%2012%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%20%7D%0A%3C%2Fstyle%3E%0A%3Cg%20id%3D%22_x32_%22%3E%0A%09%3Cg%3E%0A%09%09%3Cpath%20class%3D%22st0%22%20d%3D%22M0%2C8h1V3H0V8z%20M2%2C8h1V3H2V8z%20M4%2C8h1V3H4V8z%20M6%2C8h1V3H6V8z%20M8%2C8h1V3H8V8z%20M10%2C3v5h1V3H10z%22%20fill%3D%22rgba%280,%200,%200,%200.87%29%22%20%2F%3E%0A%09%3C%2Fg%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A");
  width: 18px;
  height: 18px;
  line-height: 18px;
  background-size: 18px 18px;
}
.dx-diagram-i-button-properties-panel-open {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%09.st1%7Bopacity%3A0.35%3Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3Benable-background%3Anew%20%20%20%20%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x33_%22%20class%3D%22st0%22%20d%3D%22M17.8%2C10.3l-1%2C1l-2.1-2.1l1-1C15.8%2C8.1%2C15.9%2C8%2C16.1%2C8c0.1%2C0%2C0.3%2C0.1%2C0.4%2C0.2l1.3%2C1.3%0A%09C18%2C9.7%2C18%2C10.1%2C17.8%2C10.3z%20M14%2C2H4v13h2v2H4c-1.1%2C0-2-0.9-2-2V2c0-1.1%2C0.9-2%2C2-2h10c1.1%2C0%2C2%2C0.9%2C2%2C2v3l-2%2C2V2z%20M16.1%2C11.9l-6%2C6.1H8%0A%09v-2.1l6.1-6.1L16.1%2C11.9z%22%20fill%3D%22%23fff%22%2F%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st1%22%20d%3D%22M5%2C3h8v5l-6%2C6H5V3z%22%20fill%3D%22%23fff%22%2F%3E%0A%3C%2Fsvg%3E%0A");
  width: 24px;
  height: 24px;
}
.dx-gantt {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
  width: 100%;
  overflow: hidden;
}
.dx-gantt .dx-gantt-main-wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  height: 100%;
}
.dx-gantt .dx-toolbar .dx-toolbar-items-container {
  height: auto;
}
.dx-gantt .dx-gantt-toolbar-separator {
  display: table;
  height: 100%;
  border-left: 1px solid transparent;
}
.dx-gantt .dx-gantt-treelist-wrapper {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}
.dx-gantt .dx-gantt-treelist-wrapper .dx-treelist .dx-scrollbar-vertical {
  display: none;
}
.dx-gantt .dx-gantt-treelist-wrapper .dx-treelist .dx-treelist-headers + .dx-treelist-rowsview {
  border-top: none;
}
.dx-gantt .dx-splitter-wrapper .dx-splitter-border .dx-splitter {
  width: 2px;
}
.dx-gantt .dx-gantt-view {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 100%;
  min-width: 1px;
  background-color: #fff;
}
.dx-gantt .dx-gantt-view .dx-gantt-tac-hb {
  margin-top: -1px;
}
.dx-gantt .dx-gantt-view .dx-scrollable-scrollbar {
  z-index: 100;
}
.dx-gantt .dx-gantt-view .dx-gantt-parent::before {
  border-left-color: inherit;
  border-top-color: inherit;
}
.dx-gantt .dx-gantt-view .dx-gantt-parent::after {
  border-right-color: inherit;
  border-top-color: inherit;
}
.dx-gantt {
  border: 1px solid #e0e0e0;
}
.dx-gantt .dx-gantt-toolbar-wrapper {
  padding: 5px;
  border-bottom: 1px solid #e0e0e0;
}
.dx-gantt .dx-gantt-toolbar-wrapper .dx-gantt-toolbar-separator {
  border-left-color: #e0e0e0;
}
.dx-gantt .dx-gantt-toolbar-wrapper .dx-toolbar .dx-toolbar-items-container {
  min-height: 42px;
}
.dx-gantt .dx-header-row {
  height: 57px;
}
.dx-gantt .dx-gantt-header {
  color: rgba(0,0,0,.54);
  font-size: 12px;
}
.dx-gantt .dx-gantt-header .dx-gantt-hb,
.dx-gantt .dx-gantt-header .dx-gantt-tsa,
.dx-gantt .dx-gantt-header .dx-gantt-tsac,
.dx-gantt .dx-gantt-header .dx-gantt-vb {
  border-color: #e0e0e0;
  background-color: #fff;
}
.dx-gantt .dx-gantt-si {
  text-align: center;
  vertical-align: middle;
  padding-left: 16px;
  padding-right: 16px;
}
.dx-gantt .dx-gantt-tsa,
.dx-gantt .dx-gantt-tsac {
  border-bottom: 1px solid #e0e0e0;
}
.dx-gantt .dx-gantt-hb {
  border-top: 1px solid #e0e0e0;
}
.dx-gantt .dx-gantt-vb {
  border-left: 1px solid #e0e0e0;
}
.dx-gantt .dx-gantt-taskWrapper {
  padding-top: 0;
}
.dx-gantt .dx-gantt-taskWrapper .dx-gantt-task,
.dx-gantt .dx-gantt-taskWrapper .dx-gantt-titleOut {
  height: 27px;
  line-height: 27px;
}
.dx-gantt .dx-gantt-taskWrapper .dx-gantt-task {
  background-color: #009688;
  border-radius: 4px;
}
.dx-gantt .dx-gantt-taskWrapper .dx-gantt-task .dx-gantt-tPrg {
  border-radius: 4px;
  background-color: rgba(0,0,0,.2);
}
.dx-gantt .dx-gantt-taskWrapper .dx-gantt-task.dx-gantt-smallTask {
  border-radius: 4px;
}
.dx-gantt .dx-gantt-taskWrapper .dx-gantt-task.dx-gantt-smallTask .dx-gantt-titleIn {
  padding: 0 2px;
}
.dx-gantt .dx-gantt-taskWrapper .dx-gantt-task.dx-gantt-parent {
  height: 25px;
  line-height: 25px;
  background-color: #8bc34a;
  border-left-color: #8bc34a;
  border-right-color: #8bc34a;
  border-top-color: #8bc34a;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.dx-gantt .dx-gantt-taskWrapper .dx-gantt-task.dx-gantt-parent:not(.dx-gantt-noPrg) .dx-gantt-tPrg {
  background-color: rgba(255,255,255,.2);
}
.dx-gantt .dx-gantt-taskWrapper .dx-gantt-task.dx-gantt-parent:not(.dx-gantt-smallTask).dx-gantt-cmpl .dx-gantt-tPrg::after,
.dx-gantt .dx-gantt-taskWrapper .dx-gantt-task.dx-gantt-parent:not(.dx-gantt-smallTask)::after,
.dx-gantt .dx-gantt-taskWrapper .dx-gantt-task.dx-gantt-parent:not(.dx-gantt-smallTask)::before,
.dx-gantt .dx-gantt-taskWrapper .dx-gantt-task.dx-gantt-parent:not(.dx-gantt-smallTask):not(.dx-gantt-noPrg) .dx-gantt-tPrg::before {
  content: "";
  position: absolute;
  bottom: -8px;
  border-width: 4px;
  border-style: solid;
}
.dx-gantt .dx-gantt-taskWrapper .dx-gantt-task.dx-gantt-parent::before,
.dx-gantt .dx-gantt-taskWrapper .dx-gantt-task.dx-gantt-parent:not(.dx-gantt-noPrg) .dx-gantt-tPrg::before {
  left: 0;
  border-right-color: transparent;
  border-bottom-color: transparent;
}
.dx-gantt .dx-gantt-taskWrapper .dx-gantt-task.dx-gantt-parent:not(.dx-gantt-noPrg) .dx-gantt-tPrg::before {
  border-left-color: rgba(255,255,255,.2);
  border-top-color: rgba(255,255,255,.2);
}
.dx-gantt .dx-gantt-taskWrapper .dx-gantt-task.dx-gantt-parent.dx-gantt-cmpl .dx-gantt-tPrg::after,
.dx-gantt .dx-gantt-taskWrapper .dx-gantt-task.dx-gantt-parent::after {
  right: 0;
  border-left-color: transparent;
  border-bottom-color: transparent;
}
.dx-gantt .dx-gantt-taskWrapper .dx-gantt-task.dx-gantt-parent.dx-gantt-cmpl::after {
  border-right-color: rgba(255,255,255,.2);
  border-top-color: rgba(255,255,255,.2);
}
.dx-gantt .dx-gantt-taskWrapper .dx-gantt-task.dx-gantt-parent.dx-gantt-cmpl .dx-gantt-tPrg::after {
  border-right-color: #8bc34a;
  border-top-color: #8bc34a;
}
.dx-gantt .dx-gantt-taskWrapper .dx-gantt-task.dx-gantt-parent .dx-gantt-task-edit-frame {
  height: 25px;
}
.dx-gantt .dx-gantt-taskWrapper .dx-gantt-titleIn {
  color: #fff;
  padding: 0 11px;
}
.dx-gantt .dx-gantt-taskRes {
  height: 27px;
  line-height: 27px;
  color: #fff;
  background-color: #999;
  border-radius: 4px;
  margin-left: 21px;
  padding-left: 4px;
  padding-right: 4px;
}
.dx-gantt .dx-gantt-titleOut {
  padding-right: 20px;
}
.dx-gantt .dx-gantt-milestone {
  background-color: rgba(0,0,0,.87);
  width: 17px;
  height: 17px;
}
.dx-gantt .dx-gantt-task-edit-wrapper {
  padding-top: 0;
  padding-left: 1px;
}
.dx-gantt .dx-gantt-task-edit-wrapper .dx-gantt-task-edit-frame {
  height: 100%;
  border: 1px solid #00635a;
  border-radius: 4px;
}
.dx-gantt .dx-gantt-task-edit-wrapper .dx-gantt-task-edit-frame .dx-gantt-task-edit-progress {
  border-color: transparent transparent #00635a;
}
.dx-gantt .dx-gantt-task-edit-wrapper .dx-gantt-task-edit-frame .dx-gantt-task-edit-progress::before {
  width: 12px;
  height: 6px;
  bottom: -14px;
  border: 1px solid #00635a;
}
.dx-gantt .dx-gantt-task-edit-wrapper .dx-gantt-task-edit-frame .dx-gantt-task-edit-progress-status {
  border-radius: 4px;
}
.dx-gantt .dx-gantt-task-edit-wrapper-successor {
  padding-top: 0;
}
.dx-gantt .dx-gantt-task-edit-wrapper-successor .dx-gantt-task-edit-frame-successor {
  height: 27px;
}
.dx-gantt .dx-gantt-task-edit-dependency-l,
.dx-gantt .dx-gantt-task-edit-dependency-r,
.dx-gantt .dx-gantt-task-edit-successor-dependency-l,
.dx-gantt .dx-gantt-task-edit-successor-dependency-r {
  background: #fff;
  border: 1px solid #00635a;
  width: 12px;
  height: 12px;
  margin: auto;
  top: 0;
  bottom: 0;
}
.dx-gantt .dx-gantt-task-edit-dependency-r,
.dx-gantt .dx-gantt-task-edit-successor-dependency-r {
  left: -13px;
}
.dx-gantt .dx-gantt-task-edit-dependency-l,
.dx-gantt .dx-gantt-task-edit-successor-dependency-l {
  right: -13px;
}
.dx-gantt .dx-gantt-task-edit-dependency-line {
  background-color: rgba(0,0,0,.87);
}
.dx-gantt .dx-gantt-sel {
  background-color: rgba(0,150,136,.04);
}
.dx-gantt .dx-gantt-conn-v {
  border-left-color: rgba(0,0,0,.87);
}
.dx-gantt .dx-gantt-conn-h {
  border-top-color: rgba(0,0,0,.87);
}
.dx-gantt .dx-gantt-arrow {
  border: 5px solid rgba(0,0,0,.87);
}
.dx-gantt .dx-gantt-tm {
  border-left: 1px dashed #009688;
}
.dx-gantt .dx-gantt-ti {
  border-left: 1px dashed #009688;
  border-right: 1px dashed #009688;
  background-color: rgba(0,150,136,.15);
}
.dx-gantt .dx-gantt-altRow,
.dx-gantt .dx-gantt-collapsable-row {
  background-color: #f2f2f2;
}
.dx-gantt-i.dx-gantt-i-add {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st0%22%20d%3D%22M17%2C15h-3v3h-2v-3H9v-2h3v-3h2v3h3V15z%20M12%2C4l-2-2H3v12h4v2H1V0h10l3%2C3v5h-2V4z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3C%2Fsvg%3E%0A");
}
.dx-gantt-i.dx-gantt-i-add-sub-task {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st0%22%20d%3D%22M14%2C6H6v3h2.3c0.3-0.6%2C1-1%2C1.7-1h5c1.1%2C0%2C2%2C0.9%2C2%2C2s-0.9%2C2-2%2C2h-5c-0.7%2C0-1.4-0.4-1.7-1H6v4h2.3%0A%09c0.3-0.6%2C1-1%2C1.7-1h5c1.1%2C0%2C2%2C0.9%2C2%2C2s-0.9%2C2-2%2C2h-5c-0.7%2C0-1.4-0.4-1.7-1H4v-2v-4V9V6l0%2C0C2.3%2C6%2C1%2C4.7%2C1%2C3s1.3-3%2C3-3h10%0A%09c1.7%2C0%2C3%2C1.3%2C3%2C3S15.7%2C6%2C14%2C6z%20M14%2C2H4C3.4%2C2%2C3%2C2.4%2C3%2C3s0.4%2C1%2C1%2C1h10c0.6%2C0%2C1-0.4%2C1-1S14.6%2C2%2C14%2C2z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3C%2Fsvg%3E%0A");
}
.dx-gantt-i.dx-gantt-i-add-task {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20class%3D%22st0%22%20d%3D%22M10%2C13H8v-3H5V8h3V5h2v3h3v2h-3V13z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3Cpath%20class%3D%22st0%22%20d%3D%22M9%2C1.1c-4.4%2C0-8%2C3.6-8%2C8c0%2C4.4%2C3.6%2C8%2C8%2C8s8-3.6%2C8-8C17%2C4.6%2C13.4%2C1.1%2C9%2C1.1z%20M9%2C15c-3.3%2C0-6-2.7-6-6s2.7-6%2C6-6%0A%09s6%2C2.7%2C6%2C6S12.3%2C15%2C9%2C15z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3C%2Fsvg%3E%0A");
}
.dx-gantt-i.dx-gantt-i-collapse {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st0%22%20d%3D%22M9%2C7l7%2C6.8L14.8%2C15L9%2C9.3L3.2%2C15L2%2C13.8L9%2C7z%20M3.2%2C10L2%2C8.8L9%2C2l7%2C6.8L14.8%2C10L9%2C4.3L3.2%2C10z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3C%2Fsvg%3E%0A");
}
.dx-gantt-i.dx-gantt-i-delete {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st0%22%20d%3D%22M17%2C10H9c-0.6%2C0-1-0.4-1-1s0.4-1%2C1-1h2c0-0.6%2C0.4-1%2C1-1h2c0.6%2C0%2C1%2C0.4%2C1%2C1h2c0.6%2C0%2C1%2C0.4%2C1%2C1%0A%09S17.6%2C10%2C17%2C10z%20M12%2C4l-2-2H3v12h4v2H1V0h10l3%2C3v3h-2V4z%20M17%2C16c0%2C1.1-0.9%2C2-2%2C2h-4c-1.1%2C0-2-0.9-2-2v-5h8V16z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3C%2Fsvg%3E%0A");
}
.dx-gantt-i.dx-gantt-i-delete-dependency {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st0%22%20d%3D%22M17%2C10H9c-0.6%2C0-1-0.4-1-1c0-0.6%2C0.4-1%2C1-1h2c0-0.6%2C0.4-1%2C1-1h2c0.6%2C0%2C1%2C0.4%2C1%2C1h2c0.6%2C0%2C1%2C0.4%2C1%2C1%0A%09C18%2C9.6%2C17.6%2C10%2C17%2C10z%20M8%2C13H5V5H3.7C3.4%2C5.6%2C2.7%2C6%2C2%2C6C0.9%2C6%2C0%2C5.1%2C0%2C4s0.9-2%2C2-2c0.7%2C0%2C1.4%2C0.4%2C1.7%2C1H7v8h1V13z%20M17%2C16%0A%09c0%2C1.1-0.9%2C2-2%2C2h-4c-1.1%2C0-2-0.9-2-2v-5h8V16z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3C%2Fsvg%3E%0A");
}
.dx-gantt-i.dx-gantt-i-expand {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st0%22%20d%3D%22M2%2C3.2L3.2%2C2L9%2C7.7L14.8%2C2L16%2C3.2L9%2C10L2%2C3.2z%20M9%2C12.7L14.8%2C7L16%2C8.2L9%2C15L2%2C8.2L3.2%2C7L9%2C12.7z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3C%2Fsvg%3E%0A");
}
.dx-gantt-i.dx-gantt-i-full-screen {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7B%7D%0A%3C%2Fstyle%3E%0A%3Cpolygon%20id%3D%22_x34_%22%20class%3D%22st0%22%20points%3D%221%2C7%203%2C7%203%2C3%207%2C3%207%2C1%201%2C1%20%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3Cpolygon%20id%3D%22_x33_%22%20class%3D%22st0%22%20points%3D%223%2C11%201%2C11%201%2C17%207%2C17%207%2C15%203%2C15%20%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3Cpolygon%20id%3D%22_x32_%22%20class%3D%22st0%22%20points%3D%2211%2C1%2011%2C3%2015%2C3%2015%2C7%2017%2C7%2017%2C1%20%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3Cpolygon%20id%3D%22_x31_%22%20class%3D%22st0%22%20points%3D%2215%2C15%2011%2C15%2011%2C17%2017%2C17%2017%2C11%2015%2C11%20%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3C%2Fsvg%3E%0A");
}
.dx-gantt-i.dx-gantt-i-redo {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st0%22%20d%3D%22M1%2C9c0-4.4%2C3.6-8%2C8-8c2.2%2C0%2C4.2%2C0.9%2C5.6%2C2.4L17%2C1v6h-6l2.2-2.2C12.1%2C3.7%2C10.7%2C3%2C9%2C3C5.7%2C3%2C3%2C5.7%2C3%2C9%0A%09s2.7%2C6%2C6%2C6v2C4.6%2C17%2C1%2C13.4%2C1%2C9z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3C%2Fsvg%3E%0A");
}
.dx-gantt-i.dx-gantt-i-task-details {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st0%22%20d%3D%22M12.5%2C18C10%2C18%2C7.9%2C15.5%2C7%2C13.5c0.9-2%2C3-4.5%2C5.5-4.5s4.6%2C2.5%2C5.5%2C4.5C17.1%2C15.5%2C15%2C18%2C12.5%2C18z%0A%09%20M12.5%2C11c-1.4%2C0-2.5%2C1.1-2.5%2C2.5s1.1%2C2.5%2C2.5%2C2.5s2.5-1.1%2C2.5-2.5S13.9%2C11%2C12.5%2C11z%20M12.5%2C15c-0.8%2C0-1.5-0.7-1.5-1.5%0A%09s0.7-1.5%2C1.5-1.5s1.5%2C0.7%2C1.5%2C1.5S13.3%2C15%2C12.5%2C15z%20M12%2C4l-2-2H3v12h2l1%2C2H1V0h10l3%2C3v4h-2V4z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3C%2Fsvg%3E%0A");
}
.dx-gantt-i.dx-gantt-i-undo {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st0%22%20d%3D%22M9%2C17v-2c3.3%2C0%2C6-2.7%2C6-6s-2.7-6-6-6C7.3%2C3%2C5.9%2C3.7%2C4.8%2C4.8L7%2C7H1V1l2.4%2C2.4C4.8%2C1.9%2C6.8%2C1%2C9%2C1%0A%09c4.4%2C0%2C8%2C3.6%2C8%2C8S13.4%2C17%2C9%2C17z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3C%2Fsvg%3E%0A");
}
.dx-gantt-i.dx-gantt-i-zoom-in {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st0%22%20d%3D%22M17.7%2C16.3l-1.4%2C1.4l-4.1-4.1C11%2C14.5%2C9.6%2C15%2C8%2C15c-3.9%2C0-7-3.1-7-7s3.1-7%2C7-7s7%2C3.1%2C7%2C7%0A%09c0%2C1.6-0.5%2C3-1.4%2C4.2L17.7%2C16.3z%20M8%2C3C5.2%2C3%2C3%2C5.2%2C3%2C8s2.2%2C5%2C5%2C5s5-2.2%2C5-5S10.8%2C3%2C8%2C3z%20M9%2C11H7V9H5V7h2V5h2v2h2v2H9V11z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3C%2Fsvg%3E%0A");
}
.dx-gantt-i.dx-gantt-i-zoom-out {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st0%22%20d%3D%22M17.7%2C16.3l-1.4%2C1.4l-4.1-4.1C11%2C14.5%2C9.6%2C15%2C8%2C15c-3.9%2C0-7-3.1-7-7s3.1-7%2C7-7s7%2C3.1%2C7%2C7%0A%09c0%2C1.6-0.5%2C3-1.4%2C4.2L17.7%2C16.3z%20M8%2C3C5.2%2C3%2C3%2C5.2%2C3%2C8s2.2%2C5%2C5%2C5s5-2.2%2C5-5S10.8%2C3%2C8%2C3z%20M5%2C9V7h6v2H5z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3C%2Fsvg%3E%0A");
}
.dx-gantt-i.dx-gantt-i-resource-manager {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2016%2016%22%20style%3D%22enable-background%3Anew%200%200%2016%2016%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st0%22%20d%3D%22M12%2C9h4v4h-4%20M8%2C5H0v2h8%20M12%2C5h4V1h-4%20M0%2C1v2h10V1%20M0%2C15h8v-2H0%20M0%2C11h10V9H0%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3C%2Fsvg%3E%0A");
}
.dx-gantt-i.dx-gantt-i-toggle-resources {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C!--%20Generator%3A%20Adobe%20Illustrator%2024.2.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200)%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x35_%22%20class%3D%22st0%22%20d%3D%22M14%2C15H2c-1.1%2C0-2-0.9-2-2v-2c0-1.1%2C0.9-2%2C2-2h12c1.1%2C0%2C2%2C0.9%2C2%2C2v2C16%2C14.1%2C15.1%2C15%2C14%2C15z%20M9%2C11H2%0A%09v2h7V11z%20M14%2C7H2C0.9%2C7%2C0%2C6.1%2C0%2C5V3c0-1.1%2C0.9-2%2C2-2h12c1.1%2C0%2C2%2C0.9%2C2%2C2v2C16%2C6.1%2C15.1%2C7%2C14%2C7z%20M12%2C3H2v2h10V3z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3C%2Fsvg%3E%0A%0A%0A%0A");
}
.dx-gantt-i.dx-gantt-i-toggle-dependencies {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C!--%20Generator%3A%20Adobe%20Illustrator%2024.2.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200)%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22_x31_%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2018%2018%22%20style%3D%22enable-background%3Anew%200%200%2018%2018%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3B%7D%0A%09.st1%7Bopacity%3A0.5%3B%7D%0A%09.st2%7B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20id%3D%22_x32_%22%20class%3D%22st0%22%20d%3D%22M7%2C11c-2.3%2C0-4.2-1.7-5-4c0.8-2.3%2C2.7-4%2C5-4s4.2%2C1.7%2C5%2C4C11.2%2C9.3%2C9.3%2C11%2C7%2C11z%20M7%2C5%0A%09C5.9%2C5%2C5%2C5.9%2C5%2C7s0.9%2C2%2C2%2C2s2-0.9%2C2-2S8.1%2C5%2C7%2C5z%20M7%2C8C6.4%2C8%2C6%2C7.6%2C6%2C7s0.4-1%2C1-1s1%2C0.4%2C1%2C1S7.6%2C8%2C7%2C8z%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3Cpolygon%20class%3D%22st1%22%20points%3D%226%2C10%206%2C14%2013%2C14%2013%2C16%2016%2C13%2013%2C10%2013%2C12%208%2C12%208%2C10%20%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3Cpolygon%20class%3D%22st1%22%20points%3D%226%2C4%206%2C2%200%2C2%200%2C0%208%2C0%208%2C4%20%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3Crect%20x%3D%229.4%22%20y%3D%222.1%22%20transform%3D%22matrix(0.7071%20-0.7071%200.7071%200.7071%200.8934%209.1569)%22%20class%3D%22st2%22%20width%3D%224.2%22%20height%3D%222.8%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3Crect%20x%3D%221.2%22%20y%3D%229.6%22%20transform%3D%22matrix(0.7071%20-0.7071%200.7071%200.7071%20-6.6066%206.0503)%22%20class%3D%22st2%22%20width%3D%225.7%22%20height%3D%222.8%22%20fill%3D%22rgba%280,%200,%200,%200.54%29%22%2F%3E%0A%3C%2Fsvg%3E%0A%0A");
}
.dx-sortable {
  overflow: hidden;
}
.dx-sortable-dragging.dx-sortable-clone {
  position: absolute;
  top: 0;
  left: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  opacity: .9;
  z-index: 2147483647;
}
.dx-sortable-dragging.dx-sortable-clone .dx-inkripple {
  overflow: hidden;
}
.dx-sortable-dragging.dx-sortable-clone * {
  cursor: pointer;
  cursor: -webkit-grabbing;
  cursor: grabbing;
}
.dx-sortable-source {
  opacity: .5;
}
.dx-sortable-source-hidden {
  opacity: 0;
}
.dx-sortable-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  border: 1px solid #009688;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  z-index: 2147483647;
}
.dx-sortable-placeholder-inside {
  border-width: 2px;
}
.dx-sortable-dragging > * {
  border-color: rgba(0,150,136,.5);
  -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.1),0 6px 8px rgba(0,0,0,.2);
  box-shadow: 0 1px 3px rgba(0,0,0,.1),0 6px 8px rgba(0,0,0,.2);
}
.dx-deferrendering .dx-deferrendering-loadindicator-container {
  width: 100%;
  height: 100%;
  position: relative;
}
.dx-deferrendering.dx-pending-rendering .dx-invisible-while-pending-rendering,
.dx-deferrendering:not(.dx-pending-rendering) .dx-visible-while-pending-rendering {
  display: none!important;
}
.dx-map-container,
.dx-map-shield {
  position: relative;
  width: 100%;
  height: 100%;
  color: #000;
}
.dx-map-shield {
  top: -100%;
  left: 0;
  background: rgba(0,0,0,.01);
  opacity: .01;
}
    `
